webpackJsonp([5],{

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _isPlaceholder = __webpack_require__(70);


/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
module.exports = function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder(a) ? f2
             : _curry1(function(_b) { return fn(a, _b); });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f2
             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b); })
             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b); })
             : fn(a, b);
    }
  };
};


/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 */
module.exports = _curry1(function type(val) {
  return val === null      ? 'Null'      :
         val === undefined ? 'Undefined' :
         Object.prototype.toString.call(val).slice(8, -1);
});


/***/ }),

/***/ 1001:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * Bowser - a browser detector
  * https://github.com/ded/bowser
  * MIT License | (c) Dustin Diaz 2014
  */

!function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports['browser'] = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
}('bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , edgeVersion = getFirstMatch(/edge\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , result

    if (/opera|opr/i.test(ua)) {
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/windows phone/i.test(ua)) {
      result = {
        name: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    }
    else if (/chrome.+? edge/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (/sailfish/i.test(ua)) {
      result = {
        name: 'Sailfish'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
      }
    }
    else if (/silk/i.test(ua)) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
      , version: versionIdentifier
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/(web|hpw)os/i.test(ua)) {
      result = {
        name: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (/tizen/i.test(ua)) {
      result = {
        name: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/safari/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      , version: versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      result.name = result.name || "Webkit"
      result.webkit = t
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.msedge && (android || result.silk)) {
      result.android = t
    } else if (iosdevice) {
      result[iosdevice] = t
      result.ios = t
    }

    // OS version extraction
    var osVersion = '';
    if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = osVersion.split('.')[0];
    if (tablet || iosdevice == 'ipad' || (android && (osMajorVersion == 3 || (osMajorVersion == 4 && !mobile))) || result.silk) {
      result.tablet = t
    } else if (mobile || iosdevice == 'iphone' || iosdevice == 'ipod' || android || result.blackberry || result.webos || result.bada) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.chrome && result.version >= 20) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  return bowser
});


/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

var pipe = __webpack_require__(163);
var reverse = __webpack_require__(80);


/**
 * Performs right-to-left function composition. The rightmost function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of compose is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.pipe
 * @example
 *
 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
 *
 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
 */
module.exports = function compose() {
  if (arguments.length === 0) {
    throw new Error('compose requires at least one argument');
  }
  return pipe.apply(this, reverse(arguments));
};


/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

var _checkForMethod = __webpack_require__(59);
var _curry1 = __webpack_require__(4);
var slice = __webpack_require__(45);


/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */
module.exports = _curry1(_checkForMethod('tail', slice(1, Infinity)));


/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _isArray = __webpack_require__(41);
var _isFunction = __webpack_require__(77);
var _isString = __webpack_require__(58);
var toString = __webpack_require__(60);


/**
 * Returns the result of concatenating the given lists or strings.
 *
 * Note: `R.concat` expects both arguments to be of the same type,
 * unlike the native `Array.prototype.concat` method. It will throw
 * an error if you `concat` an Array with a non-Array value.
 *
 * Dispatches to the `concat` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @sig String -> String -> String
 * @param {Array|String} firstList The first list
 * @param {Array|String} secondList The second list
 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
 * `secondList`.
 *
 * @example
 *
 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 *      R.concat([], []); //=> []
 */
module.exports = _curry2(function concat(a, b) {
  if (_isArray(a)) {
    if (_isArray(b)) {
      return a.concat(b);
    }
    throw new TypeError(toString(b) + ' is not an array');
  }
  if (_isString(a)) {
    if (_isString(b)) {
      return a + b;
    }
    throw new TypeError(toString(b) + ' is not a string');
  }
  if (a != null && _isFunction(a['fantasy-land/concat'])) {
    return a['fantasy-land/concat'](b);
  }
  if (a != null && _isFunction(a.concat)) {
    return a.concat(b);
  }
  throw new TypeError(toString(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
});


/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _filter = __webpack_require__(105);
var _isObject = __webpack_require__(106);
var _reduce = __webpack_require__(18);
var _xfilter = __webpack_require__(300);
var keys = __webpack_require__(32);


/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      var isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */
module.exports = _curry2(_dispatchable(['filter'], _xfilter, function(pred, filterable) {
  return (
    _isObject(filterable) ?
      _reduce(function(acc, key) {
        if (pred(filterable[key])) {
          acc[key] = filterable[key];
        }
        return acc;
      }, {}, keys(filterable)) :
    // else
      _filter(pred, filterable)
  );
}));


/***/ }),

/***/ 105:
/***/ (function(module, exports) {

module.exports = function _filter(fn, list) {
  var idx = 0;
  var len = list.length;
  var result = [];

  while (idx < len) {
    if (fn(list[idx])) {
      result[result.length] = list[idx];
    }
    idx += 1;
  }
  return result;
};


/***/ }),

/***/ 106:
/***/ (function(module, exports) {

module.exports = function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
};


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var adjust = __webpack_require__(147);
var always = __webpack_require__(49);


/**
 * Returns a new copy of the array with the element at the provided index
 * replaced with the given value.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} idx The index to update.
 * @param {*} x The value to exist at the given index of the returned array.
 * @param {Array|Arguments} list The source array-like object to be updated.
 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
 * @see R.adjust
 * @example
 *
 *      R.update(1, 11, [0, 1, 2]);     //=> [0, 11, 2]
 *      R.update(1)(11)([0, 1, 2]);     //=> [0, 11, 2]
 * @symb R.update(-1, a, [b, c]) = [b, a]
 * @symb R.update(0, a, [b, c]) = [a, c]
 * @symb R.update(1, a, [b, c]) = [b, a]
 */
module.exports = _curry3(function update(idx, x, list) {
  return adjust(always(x), idx, list);
});


/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xtake = __webpack_require__(313);
var slice = __webpack_require__(45);


/**
 * Returns the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `take` method).
 *
 * Dispatches to the `take` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*}
 * @see R.drop
 * @example
 *
 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(3, 'ramda');               //=> 'ram'
 *
 *      var personnel = [
 *        'Dave Brubeck',
 *        'Paul Desmond',
 *        'Eugene Wright',
 *        'Joe Morello',
 *        'Gerry Mulligan',
 *        'Bob Bates',
 *        'Joe Dodge',
 *        'Ron Crotty'
 *      ];
 *
 *      var takeFive = R.take(5);
 *      takeFive(personnel);
 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
 * @symb R.take(-1, [a, b]) = [a, b]
 * @symb R.take(0, [a, b]) = []
 * @symb R.take(1, [a, b]) = [a]
 * @symb R.take(2, [a, b]) = [a, b]
 */
module.exports = _curry2(_dispatchable(['take'], _xtake, function take(n, xs) {
  return slice(0, n < 0 ? Infinity : n, xs);
}));


/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _identity = __webpack_require__(110);


/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      var obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */
module.exports = _curry1(_identity);


/***/ }),

/***/ 110:
/***/ (function(module, exports) {

module.exports = function _identity(x) { return x; };


/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(109);
var uniqBy = __webpack_require__(183);


/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */
module.exports = uniqBy(identity);


/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

var _containsWith = __webpack_require__(83);
var _curry2 = __webpack_require__(1);


/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied predicate to
 * two list elements. Prefers the first item if two items compare equal based
 * on the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category List
 * @sig (a, a -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      var strEq = R.eqBy(String);
 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
 */
module.exports = _curry2(function uniqWith(pred, list) {
  var idx = 0;
  var len = list.length;
  var result = [];
  var item;
  while (idx < len) {
    item = list[idx];
    if (!_containsWith(pred, item, result)) {
      result[result.length] = item;
    }
    idx += 1;
  }
  return result;
});


/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

var _objectAssign = __webpack_require__(359);

module.exports =
  typeof Object.assign === 'function' ? Object.assign : _objectAssign;


/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var _has = __webpack_require__(14);


/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig (String -> a -> a -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */
module.exports = _curry3(function mergeWithKey(fn, l, r) {
  var result = {};
  var k;

  for (k in l) {
    if (_has(k, l)) {
      result[k] = _has(k, r) ? fn(k, l[k], r[k]) : l[k];
    }
  }

  for (k in r) {
    if (_has(k, r) && !(_has(k, result))) {
      result[k] = r[k];
    }
  }

  return result;
});


/***/ }),

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return detach; });
/* harmony export (immutable) */ __webpack_exports__["s"] = take;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return takem; });
/* harmony export (immutable) */ __webpack_exports__["n"] = put;
/* harmony export (immutable) */ __webpack_exports__["b"] = all;
/* harmony export (immutable) */ __webpack_exports__["o"] = race;
/* harmony export (immutable) */ __webpack_exports__["e"] = call;
/* harmony export (immutable) */ __webpack_exports__["c"] = apply;
/* harmony export (immutable) */ __webpack_exports__["h"] = cps;
/* harmony export (immutable) */ __webpack_exports__["k"] = fork;
/* harmony export (immutable) */ __webpack_exports__["r"] = spawn;
/* harmony export (immutable) */ __webpack_exports__["m"] = join;
/* harmony export (immutable) */ __webpack_exports__["f"] = cancel;
/* harmony export (immutable) */ __webpack_exports__["p"] = select;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionChannel;
/* harmony export (immutable) */ __webpack_exports__["g"] = cancelled;
/* harmony export (immutable) */ __webpack_exports__["j"] = flush;
/* harmony export (immutable) */ __webpack_exports__["l"] = getContext;
/* harmony export (immutable) */ __webpack_exports__["q"] = setContext;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return asEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(64);


var IO = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["x" /* sym */])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

var detach = function detach(eff) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(asEffect.fork(eff), __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].object, 'detach(eff): argument must be a fork effect');
  eff[FORK].detached = true;
  return eff;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(arguments[0], __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* deprecate */])(take.maybe, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* updateIncentive */])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'put(channel, action): argument channel is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(action, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* deprecate */])(put.resolve, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* updateIncentive */])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(context[fn])) {
    fn = context[fn];
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(undefined, [fn].concat(args)));
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'join(task): argument task is undefined');
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'cancel(task): argument task is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* ident */];
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'select(selector,[...]): argument selector is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(pattern, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(prop, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* createSetContextWarning */])(null, props));
  return effect(SET_CONTEXT, props);
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: /*#__PURE__*/createAsEffectType(TAKE),
  put: /*#__PURE__*/createAsEffectType(PUT),
  all: /*#__PURE__*/createAsEffectType(ALL),
  race: /*#__PURE__*/createAsEffectType(RACE),
  call: /*#__PURE__*/createAsEffectType(CALL),
  cps: /*#__PURE__*/createAsEffectType(CPS),
  fork: /*#__PURE__*/createAsEffectType(FORK),
  join: /*#__PURE__*/createAsEffectType(JOIN),
  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
  select: /*#__PURE__*/createAsEffectType(SELECT),
  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
  flush: /*#__PURE__*/createAsEffectType(FLUSH),
  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
};

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

exports.base64 = true;
exports.array = true;
exports.string = true;
exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
exports.nodebuffer = typeof Buffer !== "undefined";
// contains true if JSZip can read/generate Uint8Array, false otherwise.
exports.uint8array = typeof Uint8Array !== "undefined";

if (typeof ArrayBuffer === "undefined") {
    exports.blob = false;
}
else {
    var buffer = new ArrayBuffer(0);
    try {
        exports.blob = new Blob([buffer], {
            type: "application/zip"
        }).size === 0;
    }
    catch (e) {
        try {
            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
            var builder = new Builder();
            builder.append(buffer);
            exports.blob = builder.getBlob('application/zip').size === 0;
        }
        catch (e) {
            exports.blob = false;
        }
    }
}

try {
    exports.nodestream = !!__webpack_require__(588).Readable;
} catch(e) {
    exports.nodestream = false;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var request = function request(method, url) {
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var opts = {
    method: method,
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    cache: 'no-store'
  };

  if (body) {
    opts.body = JSON.stringify(body);
  }
  return fetch(url, opts);
};

var get = exports.get = function get(url) {
  return request('GET', url);
};

var post = exports.post = function post(url, body) {
  return request('POST', url, body);
};

var put = exports.put = function put(url, body) {
  return request('PUT', url, body);
};

var del = exports.del = function del(url, body) {
  return request('DELETE', url, body);
};

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = __webpack_require__(10).Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > 65536) throw new Error('requested too many random bytes')
  // in case browserify  isn't using the Uint8Array version
  var rawBytes = new global.Uint8Array(size)

  // This will not work in older browsers.
  // See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
  if (size > 0) {  // getRandomValues fails on IE if size == 0
    crypto.getRandomValues(rawBytes)
  }

  // XXX: phantomjs doesn't like a buffer being passed here
  var bytes = Buffer.from(rawBytes.buffer)

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51), __webpack_require__(93)))

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(1027);
var objectAssign = __webpack_require__(127);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _curry1 = __webpack_require__(4);
var _curry2 = __webpack_require__(1);
var _curryN = __webpack_require__(72);


/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      var sumArgs = (...args) => R.sum(args);
 *
 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */
module.exports = _curry2(function curryN(length, fn) {
  if (length === 1) {
    return _curry1(fn);
  }
  return _arity(length, _curryN(length, [], fn));
});


/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RaisedButtonWithLoader = function (_Component) {
  _inherits(RaisedButtonWithLoader, _Component);

  function RaisedButtonWithLoader() {
    _classCallCheck(this, RaisedButtonWithLoader);

    return _possibleConstructorReturn(this, (RaisedButtonWithLoader.__proto__ || Object.getPrototypeOf(RaisedButtonWithLoader)).apply(this, arguments));
  }

  _createClass(RaisedButtonWithLoader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          loader = _props.loader,
          extraProps = _objectWithoutProperties(_props, ['loader']);

      if (loader) return _react2.default.createElement(_materialUi.RaisedButton, _extends({ className: 'loader', label: ' ' }, extraProps, { disabled: true }));
      return _react2.default.createElement(_materialUi.RaisedButton, extraProps);
    }
  }]);

  return RaisedButtonWithLoader;
}(_react.Component);

RaisedButtonWithLoader.propTypes = {
  loader: _react.PropTypes.any
};

exports.default = RaisedButtonWithLoader;

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(8)
var MD5 = __webpack_require__(240)
var RIPEMD160 = __webpack_require__(241)
var sha = __webpack_require__(242)
var Base = __webpack_require__(87)

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}


/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var assert = __webpack_require__(48);

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

var asn1 = exports;

asn1.bignum = __webpack_require__(22);

asn1.define = __webpack_require__(713).define;
asn1.base = __webpack_require__(139);
asn1.constants = __webpack_require__(530);
asn1.decoders = __webpack_require__(719);
asn1.encoders = __webpack_require__(721);


/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

var base = exports;

base.Reporter = __webpack_require__(716).Reporter;
base.DecoderBuffer = __webpack_require__(529).DecoderBuffer;
base.EncoderBuffer = __webpack_require__(529).EncoderBuffer;
base.Node = __webpack_require__(717);


/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};


/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(565);

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Native method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeNow = getNative(Date, 'now');

/**
 * Gets the number of milliseconds that have elapsed since the Unix epoch
 * (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @category Date
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => logs the number of milliseconds it took for the deferred function to be invoked
 */
var now = nativeNow || function() {
  return new Date().getTime();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed invocations. Provide an options object to indicate that `func`
 * should be invoked on the leading and/or trailing edge of the `wait` timeout.
 * Subsequent calls to the debounced function return the result of the last
 * `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
 * on the trailing edge of the timeout only if the the debounced function is
 * invoked more than once during the `wait` timeout.
 *
 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.leading=false] Specify invoking on the leading
 *  edge of the timeout.
 * @param {number} [options.maxWait] The maximum time `func` is allowed to be
 *  delayed before it is invoked.
 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
 *  edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // avoid costly calculations while the window size is in flux
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
 * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // ensure `batchLog` is invoked once after 1 second of debounced calls
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', _.debounce(batchLog, 250, {
 *   'maxWait': 1000
 * }));
 *
 * // cancel a debounced call
 * var todoChanges = _.debounce(batchLog, 1000);
 * Object.observe(models.todo, todoChanges);
 *
 * Object.observe(models, function(changes) {
 *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
 *     todoChanges.cancel();
 *   }
 * }, ['delete']);
 *
 * // ...at some point `models.todo` is changed
 * models.todo.completed = true;
 *
 * // ...before 1 second has passed `models.todo` is deleted
 * // which cancels the debounced `todoChanges` call
 * delete models.todo;
 */
function debounce(func, wait, options) {
  var args,
      maxTimeoutId,
      result,
      stamp,
      thisArg,
      timeoutId,
      trailingCall,
      lastCalled = 0,
      maxWait = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = wait < 0 ? 0 : (+wait || 0);
  if (options === true) {
    var leading = true;
    trailing = false;
  } else if (isObject(options)) {
    leading = !!options.leading;
    maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    if (maxTimeoutId) {
      clearTimeout(maxTimeoutId);
    }
    lastCalled = 0;
    maxTimeoutId = timeoutId = trailingCall = undefined;
  }

  function complete(isCalled, id) {
    if (id) {
      clearTimeout(id);
    }
    maxTimeoutId = timeoutId = trailingCall = undefined;
    if (isCalled) {
      lastCalled = now();
      result = func.apply(thisArg, args);
      if (!timeoutId && !maxTimeoutId) {
        args = thisArg = undefined;
      }
    }
  }

  function delayed() {
    var remaining = wait - (now() - stamp);
    if (remaining <= 0 || remaining > wait) {
      complete(trailingCall, maxTimeoutId);
    } else {
      timeoutId = setTimeout(delayed, remaining);
    }
  }

  function maxDelayed() {
    complete(trailing, timeoutId);
  }

  function debounced() {
    args = arguments;
    stamp = now();
    thisArg = this;
    trailingCall = trailing && (timeoutId || !leading);

    if (maxWait === false) {
      var leadingCall = leading && !timeoutId;
    } else {
      if (!maxTimeoutId && !leading) {
        lastCalled = stamp;
      }
      var remaining = maxWait - (stamp - lastCalled),
          isCalled = remaining <= 0 || remaining > maxWait;

      if (isCalled) {
        if (maxTimeoutId) {
          maxTimeoutId = clearTimeout(maxTimeoutId);
        }
        lastCalled = stamp;
        result = func.apply(thisArg, args);
      }
      else if (!maxTimeoutId) {
        maxTimeoutId = setTimeout(maxDelayed, remaining);
      }
    }
    if (isCalled && timeoutId) {
      timeoutId = clearTimeout(timeoutId);
    }
    else if (!timeoutId && wait !== maxWait) {
      timeoutId = setTimeout(delayed, wait);
    }
    if (leadingCall) {
      isCalled = true;
      result = func.apply(thisArg, args);
    }
    if (isCalled && !timeoutId && !maxTimeoutId) {
      args = thisArg = undefined;
    }
    return result;
  }
  debounced.cancel = cancel;
  return debounced;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = debounce;


/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* \
|*|
|*|  :: cookies.js ::
|*|
|*|  A complete cookies reader/writer framework with full unicode support.
|*|
|*|  Revision #1 - September 4, 2014
|*|
|*|  https://developer.mozilla.org/en-US/docs/Web/API/document.cookie
|*|  https://developer.mozilla.org/User:fusionchess
|*|
|*|  This framework is released under the GNU Public License, version 3 or later.
|*|  http://www.gnu.org/licenses/gpl-3.0-standalone.html
|*|
|*|  Syntaxes:
|*|
|*|  * docCookies.setItem(name, value[, end[, path[, domain[, secure]]]])
|*|  * docCookies.getItem(name)
|*|  * docCookies.removeItem(name[, path[, domain]])
|*|  * docCookies.hasItem(name)
|*|  * docCookies.keys()
|*|
\*/

exports.default = {
  getItem: function getItem(sKey) {
    if (!sKey) {
      return null;
    }
    return decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null;
  },
  setItem: function setItem(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
      return false;
    }
    var sExpires = '';
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + vEnd;
          break;
        case String:
          sExpires = '; expires=' + vEnd;
          break;
        case Date:
          sExpires = '; expires=' + vEnd.toUTCString();
          break;
        default:
          break;
      }
    }
    document.cookie = encodeURIComponent(sKey) + '=' + (encodeURIComponent(sValue) + sExpires + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '') + (bSecure ? '; secure' : ''));
    return true;
  },
  removeItem: function removeItem(sKey, sPath, sDomain) {
    if (!this.hasItem(sKey)) {
      return false;
    }
    document.cookie = encodeURIComponent(sKey) + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' + ((sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : ''));
    return true;
  },
  hasItem: function hasItem(sKey) {
    if (!sKey) {
      return false;
    }
    return new RegExp('(?:^|;\\s*)' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=').test(document.cookie);
  },
  keys: function keys() {
    var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:\=[^;]*)?;\s*/);
    for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
      aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
    }
    return aKeys;
  }
};

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = emitter;
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* harmony export (immutable) */ __webpack_exports__["b"] = channel;
/* harmony export (immutable) */ __webpack_exports__["d"] = eventChannel;
/* harmony export (immutable) */ __webpack_exports__["f"] = stdChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffers__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(583);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* remove */])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {
  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].fixed();

  var closed = false;
  var takers = [];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["p" /* internalErr */])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["p" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(input, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] || cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, "channel.take's callback must be a function");

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, "channel.flush' callback must be a function");
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* SAGA_ACTION */]]) {
        cb(input);
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, "channel.take's matcher argument must be a function");
        cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var support = __webpack_require__(117);
var nodejsUtils = __webpack_require__(238);
var GenericWorker = __webpack_require__(65);

/**
 * The following functions come from pako, from pako/lib/utils/strings
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */

// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new Array(256);
for (var i=0; i<256; i++) {
  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
}
_utf8len[254]=_utf8len[254]=1; // Invalid sequence start

// convert string to array (typed, when possible)
var string2buf = function (str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

    // count binary size
    for (m_pos = 0; m_pos < str_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }

    // allocate buffer
    if (support.uint8array) {
        buf = new Uint8Array(buf_len);
    } else {
        buf = new Array(buf_len);
    }

    // convert
    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) {
            /* one byte */
            buf[i++] = c;
        } else if (c < 0x800) {
            /* two bytes */
            buf[i++] = 0xC0 | (c >>> 6);
            buf[i++] = 0x80 | (c & 0x3f);
        } else if (c < 0x10000) {
            /* three bytes */
            buf[i++] = 0xE0 | (c >>> 12);
            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        } else {
            /* four bytes */
            buf[i++] = 0xf0 | (c >>> 18);
            buf[i++] = 0x80 | (c >>> 12 & 0x3f);
            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        }
    }

    return buf;
};

// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var utf8border = function(buf, max) {
    var pos;

    max = max || buf.length;
    if (max > buf.length) { max = buf.length; }

    // go back from last position, until start of sequence found
    pos = max-1;
    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

    // Fuckup - very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) { return max; }

    // If we came to start of buffer - that means vuffer is too small,
    // return max too.
    if (pos === 0) { return max; }

    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

// convert array to string
var buf2string = function (buf) {
    var str, i, out, c, c_len;
    var len = buf.length;

    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len*2);

    for (out=0, i=0; i<len;) {
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) { utf16buf[out++] = c; continue; }

        c_len = _utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }

        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while (c_len > 1 && i < len) {
            c = (c << 6) | (buf[i++] & 0x3f);
            c_len--;
        }

        // terminated by end of string?
        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

        if (c < 0x10000) {
            utf16buf[out++] = c;
        } else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
        }
    }

    // shrinkBuf(utf16buf, out)
    if (utf16buf.length !== out) {
        if(utf16buf.subarray) {
            utf16buf = utf16buf.subarray(0, out);
        } else {
            utf16buf.length = out;
        }
    }

    // return String.fromCharCode.apply(null, utf16buf);
    return utils.applyFromCharCode(utf16buf);
};


// That's all for the pako functions.


/**
 * Transform a javascript string into an array (typed if possible) of bytes,
 * UTF-8 encoded.
 * @param {String} str the string to encode
 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
 */
exports.utf8encode = function utf8encode(str) {
    if (support.nodebuffer) {
        return nodejsUtils.newBuffer(str, "utf-8");
    }

    return string2buf(str);
};


/**
 * Transform a bytes array (or a representation) representing an UTF-8 encoded
 * string into a javascript string.
 * @param {Array|Uint8Array|Buffer} buf the data de decode
 * @return {String} the decoded string.
 */
exports.utf8decode = function utf8decode(buf) {
    if (support.nodebuffer) {
        return utils.transformTo("nodebuffer", buf).toString("utf-8");
    }

    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);

    return buf2string(buf);
};

/**
 * A worker to decode utf8 encoded binary chunks into string chunks.
 * @constructor
 */
function Utf8DecodeWorker() {
    GenericWorker.call(this, "utf-8 decode");
    // the last bytes if a chunk didn't end with a complete codepoint.
    this.leftOver = null;
}
utils.inherits(Utf8DecodeWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Utf8DecodeWorker.prototype.processChunk = function (chunk) {

    var data = utils.transformTo(support.uint8array ? "uint8array" : "array", chunk.data);

    // 1st step, re-use what's left of the previous chunk
    if (this.leftOver && this.leftOver.length) {
        if(support.uint8array) {
            var previousData = data;
            data = new Uint8Array(previousData.length + this.leftOver.length);
            data.set(this.leftOver, 0);
            data.set(previousData, this.leftOver.length);
        } else {
            data = this.leftOver.concat(data);
        }
        this.leftOver = null;
    }

    var nextBoundary = utf8border(data);
    var usableData = data;
    if (nextBoundary !== data.length) {
        if (support.uint8array) {
            usableData = data.subarray(0, nextBoundary);
            this.leftOver = data.subarray(nextBoundary, data.length);
        } else {
            usableData = data.slice(0, nextBoundary);
            this.leftOver = data.slice(nextBoundary, data.length);
        }
    }

    this.push({
        data : exports.utf8decode(usableData),
        meta : chunk.meta
    });
};

/**
 * @see GenericWorker.flush
 */
Utf8DecodeWorker.prototype.flush = function () {
    if(this.leftOver && this.leftOver.length) {
        this.push({
            data : exports.utf8decode(this.leftOver),
            meta : {}
        });
        this.leftOver = null;
    }
};
exports.Utf8DecodeWorker = Utf8DecodeWorker;

/**
 * A worker to endcode string chunks into utf8 encoded binary chunks.
 * @constructor
 */
function Utf8EncodeWorker() {
    GenericWorker.call(this, "utf-8 encode");
}
utils.inherits(Utf8EncodeWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Utf8EncodeWorker.prototype.processChunk = function (chunk) {
    this.push({
        data : exports.utf8encode(chunk.data),
        meta : chunk.meta
    });
};
exports.Utf8EncodeWorker = Utf8EncodeWorker;


/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _curry3 = __webpack_require__(5);


/**
 * Applies a function to the value at the given index of an array, returning a
 * new copy of the array with the element at the given index replaced with the
 * result of the function application.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig (a -> a) -> Number -> [a] -> [a]
 * @param {Function} fn The function to apply.
 * @param {Number} idx The index.
 * @param {Array|Arguments} list An array-like object whose value
 *        at the supplied index will be replaced.
 * @return {Array} A copy of the supplied array-like object with
 *         the element at index `idx` replaced with the value
 *         returned by applying `fn` to the existing element.
 * @see R.update
 * @example
 *
 *      R.adjust(R.add(10), 1, [1, 2, 3]);     //=> [1, 12, 3]
 *      R.adjust(R.add(10))(1)([1, 2, 3]);     //=> [1, 12, 3]
 * @symb R.adjust(f, -1, [a, b]) = [a, f(b)]
 * @symb R.adjust(f, 0, [a, b]) = [f(a), b]
 */
module.exports = _curry3(function adjust(fn, idx, list) {
  if (idx >= list.length || idx < -list.length) {
    return list;
  }
  var start = idx < 0 ? list.length : 0;
  var _idx = start + idx;
  var _list = _concat(list);
  _list[_idx] = fn(list[_idx]);
  return _list;
});


/***/ }),

/***/ 148:
/***/ (function(module, exports) {

module.exports = (function() {
  function XWrap(fn) {
    this.f = fn;
  }
  XWrap.prototype['@@transducer/init'] = function() {
    throw new Error('init not implemented on XWrap');
  };
  XWrap.prototype['@@transducer/result'] = function(acc) { return acc; };
  XWrap.prototype['@@transducer/step'] = function(acc, x) {
    return this.f(acc, x);
  };

  return function _xwrap(fn) { return new XWrap(fn); };
}());


/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _curry2 = __webpack_require__(1);


/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      var log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */
module.exports = _curry2(function bind(fn, thisObj) {
  return _arity(fn.length, function() {
    return fn.apply(thisObj, arguments);
  });
});


/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

var _has = __webpack_require__(14);


module.exports = (function() {
  var toString = Object.prototype.toString;
  return toString.call(arguments) === '[object Arguments]' ?
    function _isArguments(x) { return toString.call(x) === '[object Arguments]'; } :
    function _isArguments(x) { return _has('callee', x); };
}());


/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns `true` if both arguments are `true`; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if it is falsy, otherwise the second argument.
 * @see R.both
 * @example
 *
 *      R.and(true, true); //=> true
 *      R.and(true, false); //=> false
 *      R.and(false, true); //=> false
 *      R.and(false, false); //=> false
 */
module.exports = _curry2(function and(a, b) {
  return a && b;
});


/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xany = __webpack_require__(153);


/**
 * Returns `true` if at least one of elements of the list match the predicate,
 * `false` otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
 *         otherwise.
 * @see R.all, R.none, R.transduce
 * @example
 *
 *      var lessThan0 = R.flip(R.lt)(0);
 *      var lessThan2 = R.flip(R.lt)(2);
 *      R.any(lessThan0)([1, 2]); //=> false
 *      R.any(lessThan2)([1, 2]); //=> true
 */
module.exports = _curry2(_dispatchable(['any'], _xany, function any(fn, list) {
  var idx = 0;
  while (idx < list.length) {
    if (fn(list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}));


/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _reduced = __webpack_require__(42);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XAny(f, xf) {
    this.xf = xf;
    this.f = f;
    this.any = false;
  }
  XAny.prototype['@@transducer/init'] = _xfBase.init;
  XAny.prototype['@@transducer/result'] = function(result) {
    if (!this.any) {
      result = this.xf['@@transducer/step'](result, false);
    }
    return this.xf['@@transducer/result'](result);
  };
  XAny.prototype['@@transducer/step'] = function(result, input) {
    if (this.f(input)) {
      this.any = true;
      result = _reduced(this.xf['@@transducer/step'](result, true));
    }
    return result;
  };

  return _curry2(function _xany(f, xf) { return new XAny(f, xf); });
}());


/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Applies function `fn` to the argument list `args`. This is useful for
 * creating a fixed-arity function from a variadic function. `fn` should be a
 * bound function if context is significant.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> a) -> [*] -> a
 * @param {Function} fn The function which will be called with `args`
 * @param {Array} args The arguments to call `fn` with
 * @return {*} result The result, equivalent to `fn(...args)`
 * @see R.call, R.unapply
 * @example
 *
 *      var nums = [1, 2, 3, -99, 42, 6, 7];
 *      R.apply(Math.max, nums); //=> 42
 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
 */
module.exports = _curry2(function apply(fn, args) {
  return fn.apply(this, args);
});


/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var keys = __webpack_require__(32);


/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */
module.exports = _curry1(function values(obj) {
  var props = keys(obj);
  var len = props.length;
  var vals = [];
  var idx = 0;
  while (idx < len) {
    vals[idx] = obj[props[idx]];
    idx += 1;
  }
  return vals;
});


/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var _has = __webpack_require__(14);
var _isArray = __webpack_require__(41);
var _isInteger = __webpack_require__(98);
var assoc = __webpack_require__(75);
var isNil = __webpack_require__(157);


/**
 * Makes a shallow clone of an object, setting or overriding the nodes required
 * to create the given path, and placing the specific value at the tail end of
 * that path. Note that this copies and flattens prototype properties onto the
 * new object as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> {a}
 * @param {Array} path the path to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except along the specified path.
 * @see R.dissocPath
 * @example
 *
 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
 *
 *      // Any missing or non-object keys in path will be overridden
 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
 */
module.exports = _curry3(function assocPath(path, val, obj) {
  if (path.length === 0) {
    return val;
  }
  var idx = path[0];
  if (path.length > 1) {
    var nextObj = (!isNil(obj) && _has(idx, obj)) ? obj[idx] : _isInteger(path[1]) ? [] : {};
    val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
  }
  if (_isInteger(idx) && _isArray(obj)) {
    var arr = [].concat(obj);
    arr[idx] = val;
    return arr;
  } else {
    return assoc(idx, val, obj);
  }
});


/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */
module.exports = _curry1(function isNil(x) { return x == null; });


/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _reduce = __webpack_require__(18);
var ap = __webpack_require__(97);
var curryN = __webpack_require__(13);
var map = __webpack_require__(16);


/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      var madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */
module.exports = _curry2(function liftN(arity, fn) {
  var lifted = curryN(arity, fn);
  return curryN(arity, function() {
    return _reduce(ap, map(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
  });
});


/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

var _isArrayLike = __webpack_require__(74);


/**
 * `_makeFlat` is a helper function that returns a one-level or fully recursive
 * function based on the flag passed in.
 *
 * @private
 */
module.exports = function _makeFlat(recursive) {
  return function flatt(list) {
    var value, jlen, j;
    var result = [];
    var idx = 0;
    var ilen = list.length;

    while (idx < ilen) {
      if (_isArrayLike(list[idx])) {
        value = recursive ? flatt(list[idx]) : list[idx];
        j = 0;
        jlen = value.length;
        while (j < jlen) {
          result[result.length] = value[j];
          j += 1;
        }
      } else {
        result[result.length] = list[idx];
      }
      idx += 1;
    }
    return result;
  };
};


/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _map = __webpack_require__(73);
var _reduce = __webpack_require__(18);
var _xmap = __webpack_require__(273);
var curryN = __webpack_require__(13);
var keys = __webpack_require__(32);


/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      var double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */
module.exports = _curry2(_dispatchable(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
  switch (Object.prototype.toString.call(functor)) {
    case '[object Function]':
      return curryN(functor.length, function() {
        return fn.call(this, functor.apply(this, arguments));
      });
    case '[object Object]':
      return _reduce(function(acc, key) {
        acc[key] = fn(functor[key]);
        return acc;
      }, {}, keys(functor));
    default:
      return _map(fn, functor);
  }
}));


/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

var _cloneRegExp = __webpack_require__(161);
var type = __webpack_require__(100);


/**
 * Copies an object.
 *
 * @private
 * @param {*} value The value to be copied
 * @param {Array} refFrom Array containing the source references
 * @param {Array} refTo Array containing the copied source references
 * @param {Boolean} deep Whether or not to perform deep cloning.
 * @return {*} The copied value.
 */
module.exports = function _clone(value, refFrom, refTo, deep) {
  var copy = function copy(copiedValue) {
    var len = refFrom.length;
    var idx = 0;
    while (idx < len) {
      if (value === refFrom[idx]) {
        return refTo[idx];
      }
      idx += 1;
    }
    refFrom[idx + 1] = value;
    refTo[idx + 1] = copiedValue;
    for (var key in value) {
      copiedValue[key] = deep ?
        _clone(value[key], refFrom, refTo, true) : value[key];
    }
    return copiedValue;
  };
  switch (type(value)) {
    case 'Object':  return copy({});
    case 'Array':   return copy([]);
    case 'Date':    return new Date(value.valueOf());
    case 'RegExp':  return _cloneRegExp(value);
    default:        return value;
  }
};


/***/ }),

/***/ 161:
/***/ (function(module, exports) {

module.exports = function _cloneRegExp(pattern) {
  return new RegExp(pattern.source, (pattern.global     ? 'g' : '') +
                                    (pattern.ignoreCase ? 'i' : '') +
                                    (pattern.multiline  ? 'm' : '') +
                                    (pattern.sticky     ? 'y' : '') +
                                    (pattern.unicode    ? 'u' : ''));
};


/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */
module.exports = _curry1(function not(a) {
  return !a;
});


/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _pipe = __webpack_require__(291);
var reduce = __webpack_require__(33);
var tail = __webpack_require__(102);


/**
 * Performs left-to-right function composition. The leftmost function may have
 * any arity; the remaining functions must be unary.
 *
 * In some libraries this function is named `sequence`.
 *
 * **Note:** The result of pipe is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.compose
 * @example
 *
 *      var f = R.pipe(Math.pow, R.negate, R.inc);
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
 */
module.exports = function pipe() {
  if (arguments.length === 0) {
    throw new Error('pipe requires at least one argument');
  }
  return _arity(arguments[0].length,
                reduce(_pipe, arguments[0], tail(arguments)));
};


/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

var chain = __webpack_require__(99);
var compose = __webpack_require__(101);
var map = __webpack_require__(16);


/**
 * Returns the right-to-left Kleisli composition of the provided functions,
 * each of which must return a value of a type supported by [`chain`](#chain).
 *
 * `R.composeK(h, g, f)` is equivalent to `R.compose(R.chain(h), R.chain(g), R.chain(f))`.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Function
 * @sig Chain m => ((y -> m z), (x -> m y), ..., (a -> m b)) -> (a -> m z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.pipeK
 * @example
 *
 *       //  get :: String -> Object -> Maybe *
 *       var get = R.curry((propName, obj) => Maybe(obj[propName]))
 *
 *       //  getStateCode :: Maybe String -> Maybe String
 *       var getStateCode = R.composeK(
 *         R.compose(Maybe.of, R.toUpper),
 *         get('state'),
 *         get('address'),
 *         get('user'),
 *       );
 *       getStateCode({"user":{"address":{"state":"ny"}}}); //=> Maybe.Just("NY")
 *       getStateCode({}); //=> Maybe.Nothing()
 * @symb R.composeK(f, g, h)(a) = R.chain(f, R.chain(g, h(a)))
 */
module.exports = function composeK() {
  if (arguments.length === 0) {
    throw new Error('composeK requires at least one argument');
  }
  var init = Array.prototype.slice.call(arguments);
  var last = init.pop();
  return compose(compose.apply(this, map(chain, init)), last);
};


/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _pipeP = __webpack_require__(293);
var reduce = __webpack_require__(33);
var tail = __webpack_require__(102);


/**
 * Performs left-to-right composition of one or more Promise-returning
 * functions. The leftmost function may have any arity; the remaining functions
 * must be unary.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a -> Promise b), (b -> Promise c), ..., (y -> Promise z)) -> (a -> Promise z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.composeP
 * @example
 *
 *      //  followersForUser :: String -> Promise [User]
 *      var followersForUser = R.pipeP(db.getUserById, db.getFollowers);
 */
module.exports = function pipeP() {
  if (arguments.length === 0) {
    throw new Error('pipeP requires at least one argument');
  }
  return _arity(arguments[0].length,
                reduce(_pipeP, arguments[0], tail(arguments)));
};


/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

var equals = __webpack_require__(19);


module.exports = function _indexOf(list, a, idx) {
  var inf, item;
  // Array.prototype.indexOf doesn't exist below IE9
  if (typeof list.indexOf === 'function') {
    switch (typeof a) {
      case 'number':
        if (a === 0) {
          // manually crawl the list to distinguish between +0 and -0
          inf = 1 / a;
          while (idx < list.length) {
            item = list[idx];
            if (item === 0 && 1 / item === inf) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        } else if (a !== a) {
          // NaN
          while (idx < list.length) {
            item = list[idx];
            if (typeof item === 'number' && item !== item) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        }
        // non-zero numbers can utilise Set
        return list.indexOf(a, idx);

      // all these types can utilise Set
      case 'string':
      case 'boolean':
      case 'function':
      case 'undefined':
        return list.indexOf(a, idx);

      case 'object':
        if (a === null) {
          // null can utilise Set
          return list.indexOf(a, idx);
        }
    }
  }
  // anything else not covered above, defer to R.equals
  while (idx < list.length) {
    if (equals(list[idx], a)) {
      return idx;
    }
    idx += 1;
  }
  return -1;
};


/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      var o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */
module.exports = _curry2(function identical(a, b) {
  // SameValue algorithm
  if (a === b) { // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
  } else {
    // Step 6.a: NaN == NaN
    return a !== a && b !== b;
  }
});


/***/ }),

/***/ 168:
/***/ (function(module, exports) {

module.exports = function _complement(f) {
  return function() {
    return !f.apply(this, arguments);
  };
};


/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var curry = __webpack_require__(79);
var nAry = __webpack_require__(76);


/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type. The arity of the function
 * returned is specified to allow using variadic constructor functions.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Function
 * @sig Number -> (* -> {*}) -> (* -> {*})
 * @param {Number} n The arity of the constructor function.
 * @param {Function} Fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @example
 *
 *      // Variadic Constructor function
 *      function Salad() {
 *        this.ingredients = arguments;
 *      };
 *      Salad.prototype.recipe = function() {
 *        var instructions = R.map((ingredient) => (
 *          'Add a whollop of ' + ingredient, this.ingredients)
 *        )
 *        return R.join('\n', instructions)
 *      }
 *
 *      var ThreeLayerSalad = R.constructN(3, Salad)
 *
 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
 *      var salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup')
 *      console.log(salad.recipe());
 *      // Add a whollop of Mayonnaise
 *      // Add a whollop of Potato Chips
 *      // Add a whollop of Potato Ketchup
 */
module.exports = _curry2(function constructN(n, Fn) {
  if (n > 10) {
    throw new Error('Constructor with greater than ten arguments');
  }
  if (n === 0) {
    return function() { return new Fn(); };
  }
  return curry(nAry(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
    switch (arguments.length) {
      case  1: return new Fn($0);
      case  2: return new Fn($0, $1);
      case  3: return new Fn($0, $1, $2);
      case  4: return new Fn($0, $1, $2, $3);
      case  5: return new Fn($0, $1, $2, $3, $4);
      case  6: return new Fn($0, $1, $2, $3, $4, $5);
      case  7: return new Fn($0, $1, $2, $3, $4, $5, $6);
      case  8: return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
      case  9: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
      case 10: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
    }
  }));
});


/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _map = __webpack_require__(73);
var curryN = __webpack_require__(13);
var max = __webpack_require__(50);
var pluck = __webpack_require__(57);
var reduce = __webpack_require__(33);


/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. When invoked, this new function is applied to some
 * arguments, each branching function is applied to those same arguments. The
 * results of each branching function are passed as arguments to the converging
 * function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig (x1 -> x2 -> ... -> z) -> [(a -> b -> ... -> x1), (a -> b -> ... -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      var average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      var strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */
module.exports = _curry2(function converge(after, fns) {
  return curryN(reduce(max, 0, pluck('length', fns)), function() {
    var args = arguments;
    var context = this;
    return after.apply(context, _map(function(fn) {
      return fn.apply(context, args);
    }, fns));
  });
});


/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
 * otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {a} default The default value.
 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
 * @example
 *
 *      var defaultTo42 = R.defaultTo(42);
 *
 *      defaultTo42(null);  //=> 42
 *      defaultTo42(undefined);  //=> 42
 *      defaultTo42('Ramda');  //=> 'Ramda'
 *      // parseInt('string') results in NaN
 *      defaultTo42(parseInt('string')); //=> 42
 */
module.exports = _curry2(function defaultTo(d, v) {
  return v == null || v !== v ? d : v;
});


/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(46);
var _curry2 = __webpack_require__(1);


/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Objects and Arrays are compared in terms of
 * value equality, not reference equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
 * @example
 *
 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
 */
module.exports = _curry2(function difference(first, second) {
  var out = [];
  var idx = 0;
  var firstLen = first.length;
  while (idx < firstLen) {
    if (!_contains(first[idx], second) && !_contains(first[idx], out)) {
      out[out.length] = first[idx];
    }
    idx += 1;
  }
  return out;
});


/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

var _containsWith = __webpack_require__(83);
var _curry3 = __webpack_require__(5);


/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Duplication is determined according to the
 * value returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
 * @example
 *
 *      var cmp = (x, y) => x.a === y.a;
 *      var l1 = [{a: 1}, {a: 2}, {a: 3}];
 *      var l2 = [{a: 3}, {a: 4}];
 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
 */
module.exports = _curry3(function differenceWith(pred, first, second) {
  var out = [];
  var idx = 0;
  var firstLen = first.length;
  while (idx < firstLen) {
    if (!_containsWith(pred, first[idx], second) &&
        !_containsWith(pred, first[idx], out)) {
      out.push(first[idx]);
    }
    idx += 1;
  }
  return out;
});


/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns a new object that does not contain a `prop` property.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Object
 * @sig String -> {k: v} -> {k: v}
 * @param {String} prop The name of the property to dissociate
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original but without the specified property
 * @see R.assoc
 * @example
 *
 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
 */
module.exports = _curry2(function dissoc(prop, obj) {
  var result = {};
  for (var p in obj) {
    result[p] = obj[p];
  }
  delete result[prop];
  return result;
});


/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Removes the sub-list of `list` starting at index `start` and containing
 * `count` elements. _Note that this is not destructive_: it returns a copy of
 * the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} start The position to start removing elements
 * @param {Number} count The number of elements to remove
 * @param {Array} list The list to remove from
 * @return {Array} A new Array with `count` elements from `start` removed.
 * @example
 *
 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
 */
module.exports = _curry3(function remove(start, count, list) {
  var result = Array.prototype.slice.call(list, 0);
  result.splice(start, count);
  return result;
});


/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xdrop = __webpack_require__(310);
var slice = __webpack_require__(45);


/**
 * Returns all but the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `drop` method).
 *
 * Dispatches to the `drop` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*} A copy of list without the first `n` elements
 * @see R.take, R.transduce, R.dropLast, R.dropWhile
 * @example
 *
 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(3, 'ramda');               //=> 'da'
 */
module.exports = _curry2(_dispatchable(['drop'], _xdrop, function drop(n, xs) {
  return slice(Math.max(0, n), Infinity, xs);
}));


/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XDropRepeatsWith(pred, xf) {
    this.xf = xf;
    this.pred = pred;
    this.lastValue = undefined;
    this.seenFirstValue = false;
  }

  XDropRepeatsWith.prototype['@@transducer/init'] = _xfBase.init;
  XDropRepeatsWith.prototype['@@transducer/result'] = _xfBase.result;
  XDropRepeatsWith.prototype['@@transducer/step'] = function(result, input) {
    var sameAsLast = false;
    if (!this.seenFirstValue) {
      this.seenFirstValue = true;
    } else if (this.pred(this.lastValue, input)) {
      sameAsLast = true;
    }
    this.lastValue = input;
    return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
  };

  return _curry2(function _xdropRepeatsWith(pred, xf) { return new XDropRepeatsWith(pred, xf); });
}());


/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xdropRepeatsWith = __webpack_require__(177);
var last = __webpack_require__(179);


/**
 * Returns a new list without any consecutively repeating elements. Equality is
 * determined by applying the supplied predicate to each pair of consecutive elements. The
 * first element in a series of equal elements will be preserved.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig (a, a -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *      var l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
 */
module.exports = _curry2(_dispatchable([], _xdropRepeatsWith, function dropRepeatsWith(pred, list) {
  var result = [];
  var idx = 1;
  var len = list.length;
  if (len !== 0) {
    result[0] = list[0];
    while (idx < len) {
      if (!pred(last(result), list[idx])) {
        result[result.length] = list[idx];
      }
      idx += 1;
    }
  }
  return result;
}));



/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

var nth = __webpack_require__(61);


/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */
module.exports = nth(-1);


/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

var _isArrayLike = __webpack_require__(74);
var _xwrap = __webpack_require__(148);
var bind = __webpack_require__(149);


module.exports = (function() {
  function _arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while (idx < len) {
      acc = xf['@@transducer/step'](acc, list[idx]);
      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }
      idx += 1;
    }
    return xf['@@transducer/result'](acc);
  }

  function _iterableReduce(xf, acc, iter) {
    var step = iter.next();
    while (!step.done) {
      acc = xf['@@transducer/step'](acc, step.value);
      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }
      step = iter.next();
    }
    return xf['@@transducer/result'](acc);
  }

  function _methodReduce(xf, acc, obj, methodName) {
    return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
  }

  var symIterator = (typeof Symbol !== 'undefined') ? Symbol.iterator : '@@iterator';
  return function _reduce(fn, acc, list) {
    if (typeof fn === 'function') {
      fn = _xwrap(fn);
    }
    if (_isArrayLike(list)) {
      return _arrayReduce(fn, acc, list);
    }
    if (typeof list['fantasy-land/reduce'] === 'function') {
      return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
    }
    if (list[symIterator] != null) {
      return _iterableReduce(fn, acc, list[symIterator]());
    }
    if (typeof list.next === 'function') {
      return _iterableReduce(fn, acc, list);
    }
    if (typeof list.reduce === 'function') {
      return _methodReduce(fn, acc, list, 'reduce');
    }

    throw new TypeError('reduce: list must be array or iterable');
  };
}());


/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns `true` if one or both of its arguments are `true`. Returns `false`
 * if both arguments are `false`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if truthy, otherwise the second argument.
 * @see R.either
 * @example
 *
 *      R.or(true, true); //=> true
 *      R.or(true, false); //=> true
 *      R.or(false, true); //=> true
 *      R.or(false, false); //=> false
 */
module.exports = _curry2(function or(a, b) {
  return a || b;
});


/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _isArguments = __webpack_require__(150);
var _isArray = __webpack_require__(41);
var _isObject = __webpack_require__(106);
var _isString = __webpack_require__(58);


/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
 * types are supported if they define `<Type>.empty` and/or
 * `<Type>.prototype.empty`.
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));      //=> Nothing()
 *      R.empty([1, 2, 3]);     //=> []
 *      R.empty('unicorns');    //=> ''
 *      R.empty({x: 1, y: 2});  //=> {}
 */
module.exports = _curry1(function empty(x) {
  return (
    (x != null && typeof x['fantasy-land/empty'] === 'function') ?
      x['fantasy-land/empty']() :
    (x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function') ?
      x.constructor['fantasy-land/empty']() :
    (x != null && typeof x.empty === 'function') ?
      x.empty() :
    (x != null && x.constructor != null && typeof x.constructor.empty === 'function') ?
      x.constructor.empty() :
    _isArray(x) ?
      [] :
    _isString(x) ?
      '' :
    _isObject(x) ?
      {} :
    _isArguments(x) ?
      (function() { return arguments; }()) :
    // else
      void 0
  );
});


/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var drop = __webpack_require__(176);


/**
 * Returns a new list containing the last `n` elements of the given list.
 * If `n > list.length`, returns a list of `list.length` elements.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements to return.
 * @param {Array} xs The collection to consider.
 * @return {Array}
 * @see R.dropLast
 * @example
 *
 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(3, 'ramda');               //=> 'mda'
 */
module.exports = _curry2(function takeLast(n, xs) {
  return drop(n >= 0 ? xs.length - n : 0, xs);
});


/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

var _Set = __webpack_require__(354);
var _curry2 = __webpack_require__(1);


/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */
module.exports = _curry2(function uniqBy(fn, list) {
  var set = new _Set();
  var result = [];
  var idx = 0;
  var appliedItem, item;

  while (idx < list.length) {
    item = list[idx];
    appliedItem = fn(item);
    if (set.add(appliedItem)) {
      result.push(item);
    }
    idx += 1;
  }
  return result;
});


/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Creates an object containing a single key:value pair.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @sig String -> a -> {String:a}
 * @param {String} key
 * @param {*} val
 * @return {Object}
 * @see R.pair
 * @example
 *
 *      var matchPhrases = R.compose(
 *        R.objOf('must'),
 *        R.map(R.objOf('match_phrase'))
 *      );
 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
 */
module.exports = _curry2(function objOf(key, val) {
  var obj = {};
  obj[key] = val;
  return obj;
});


/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * See if an object (`val`) is an instance of the supplied constructor. This
 * function will check up the inheritance chain, if any.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Type
 * @sig (* -> {*}) -> a -> Boolean
 * @param {Object} ctor A constructor
 * @param {*} val The value to test
 * @return {Boolean}
 * @example
 *
 *      R.is(Object, {}); //=> true
 *      R.is(Number, 1); //=> true
 *      R.is(Object, 1); //=> false
 *      R.is(String, 's'); //=> true
 *      R.is(String, new String('')); //=> true
 *      R.is(Object, new String('')); //=> true
 *      R.is(Object, 's'); //=> false
 *      R.is(Number, {}); //=> false
 */
module.exports = _curry2(function is(Ctor, val) {
  return val != null && val.constructor === Ctor || val instanceof Ctor;
});


/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var converge = __webpack_require__(170);


/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      var getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */
module.exports = _curry1(function juxt(fns) {
  return converge(function() { return Array.prototype.slice.call(arguments, 0); }, fns);
});


/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _isNumber = __webpack_require__(188);


/**
 * Returns the number of elements in the array by returning `list.length`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [a] -> Number
 * @param {Array} list The array to inspect.
 * @return {Number} The length of the array.
 * @example
 *
 *      R.length([]); //=> 0
 *      R.length([1, 2, 3]); //=> 3
 */
module.exports = _curry1(function length(list) {
  return list != null && _isNumber(list.length) ? list.length : NaN;
});


/***/ }),

/***/ 188:
/***/ (function(module, exports) {

module.exports = function _isNumber(x) {
  return Object.prototype.toString.call(x) === '[object Number]';
};


/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var sum = __webpack_require__(190);


/**
 * Returns the mean of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.median
 * @example
 *
 *      R.mean([2, 7, 9]); //=> 6
 *      R.mean([]); //=> NaN
 */
module.exports = _curry1(function mean(list) {
  return sum(list) / list.length;
});


/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _equals = __webpack_require__(295);


/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      var a = {}; a.v = a;
 *      var b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */
module.exports = _curry2(function equals(a, b) {
  return _equals(a, b, [], []);
});


/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

var add = __webpack_require__(71);
var reduce = __webpack_require__(33);


/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */
module.exports = reduce(add, 0);


/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _curry2 = __webpack_require__(1);
var _has = __webpack_require__(14);


/**
 * A customisable version of [`R.memoize`](#memoize). `memoizeWith` takes an
 * additional function that will be applied to a given argument set and used to
 * create the cache key under which the results of the function to be memoized
 * will be stored. Care must be taken when implementing key generation to avoid
 * clashes that may overwrite previous entries erroneously.
 *
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to generate the cache key.
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @see R.memoize
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoizeWith(R.identity, n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */
module.exports = _curry2(function memoizeWith(mFn, fn) {
  var cache = {};
  return _arity(fn.length, function() {
    var key = mFn.apply(this, arguments);
    if (!_has(key, cache)) {
      cache[key] = fn.apply(this, arguments);
    }
    return cache[key];
  });
});


/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      var double = R.multiply(2);
 *      var triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */
module.exports = _curry2(function multiply(a, b) { return a * b; });


/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the result of applying the given function to
 * the focused value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> (a -> a) -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      var headLens = R.lensIndex(0);
 *
 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
 */
module.exports = (function() {
  // `Identity` is a functor that holds a single value, where `map` simply
  // transforms the held value with the provided function.
  var Identity = function(x) {
    return {value: x, map: function(f) { return Identity(f(x)); }};
  };

  return _curry3(function over(lens, f, x) {
    // The value returned by the getter function is first transformed with `f`,
    // then set as the value of an `Identity`. This is then mapped over with the
    // setter function of the lens.
    return lens(function(y) { return Identity(f(y)); })(x).value;
  });
}());


/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _curry2 = __webpack_require__(1);


module.exports = function _createPartialApplicator(concat) {
  return _curry2(function(fn, args) {
    return _arity(Math.max(0, fn.length - args.length), function() {
      return fn.apply(this, concat(args, arguments));
    });
  });
};


/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Similar to `pick` except that this one includes a `key: undefined` pair for
 * properties that don't exist.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.pick
 * @example
 *
 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
 */
module.exports = _curry2(function pickAll(names, obj) {
  var result = {};
  var idx = 0;
  var len = names.length;
  while (idx < len) {
    var name = names[idx];
    result[name] = obj[name];
    idx += 1;
  }
  return result;
});


/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _curry2 = __webpack_require__(1);


/**
 * Returns a new list with the given element at the front, followed by the
 * contents of the list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The item to add to the head of the output list.
 * @param {Array} list The array to add to the tail of the output list.
 * @return {Array} A new array.
 * @see R.append
 * @example
 *
 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
 */
module.exports = _curry2(function prepend(el, list) {
  return _concat([el], list);
});


/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var curryN = __webpack_require__(13);


/**
 * Accepts a function `fn` and a list of transformer functions and returns a
 * new curried function. When the new function is invoked, it calls the
 * function `fn` with parameters consisting of the result of calling each
 * supplied handler on successive arguments to the new function.
 *
 * If more arguments are passed to the returned function than transformer
 * functions, those arguments are passed directly to `fn` as additional
 * parameters. If you expect additional arguments that don't need to be
 * transformed, although you can ignore them, it's best to pass an identity
 * function so that the new function reports the correct arity.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (x1 -> x2 -> ... -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} fn The function to wrap.
 * @param {Array} transformers A list of transformer functions
 * @return {Function} The wrapped function.
 * @see R.converge
 * @example
 *
 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
 */
module.exports = _curry2(function useWith(fn, transformers) {
  return curryN(transformers.length, function() {
    var args = [];
    var idx = 0;
    while (idx < transformers.length) {
      args.push(transformers[idx].call(this, arguments[idx]));
      idx += 1;
    }
    return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
  });
});


/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * Similar to [`reduce`](#reduce), except moves through the input list from the
 * right to the left.
 *
 * The iterator function receives two values: *(value, acc)*, while the arguments'
 * order of `reduce`'s iterator function is *(acc, value)*.
 *
 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduceRight` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a, b -> b) -> b -> [a] -> b
 * @param {Function} fn The iterator function. Receives two values, the current element from the array
 *        and the accumulator.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.addIndex
 * @example
 *
 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
 *          -               -2
 *         / \              / \
 *        1   -            1   3
 *           / \              / \
 *          2   -     ==>    2  -1
 *             / \              / \
 *            3   -            3   4
 *               / \              / \
 *              4   0            4   0
 *
 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
 */
module.exports = _curry3(function reduceRight(fn, acc, list) {
  var idx = list.length - 1;
  while (idx >= 0) {
    acc = fn(list[idx], acc);
    idx -= 1;
  }
  return acc;
});


/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Calls an input function `n` times, returning an array containing the results
 * of those function calls.
 *
 * `fn` is passed one argument: The current value of `n`, which begins at `0`
 * and is gradually incremented to `n - 1`.
 *
 * @func
 * @memberOf R
 * @since v0.2.3
 * @category List
 * @sig (Number -> a) -> Number -> [a]
 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
 * @return {Array} An array containing the return values of all calls to `fn`.
 * @see R.repeat
 * @example
 *
 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
 * @symb R.times(f, 0) = []
 * @symb R.times(f, 1) = [f(0)]
 * @symb R.times(f, 2) = [f(0), f(1)]
 */
module.exports = _curry2(function times(fn, n) {
  var len = Number(n);
  var idx = 0;
  var list;

  if (len < 0 || isNaN(len)) {
    throw new RangeError('n must be a non-negative number');
  }
  list = new Array(len);
  while (idx < len) {
    list[idx] = fn(idx);
    idx += 1;
  }
  return list;
});


/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  F: __webpack_require__(266),
  T: __webpack_require__(267),
  __: __webpack_require__(268),
  add: __webpack_require__(71),
  addIndex: __webpack_require__(269),
  adjust: __webpack_require__(147),
  all: __webpack_require__(270),
  allPass: __webpack_require__(272),
  always: __webpack_require__(49),
  and: __webpack_require__(151),
  any: __webpack_require__(152),
  anyPass: __webpack_require__(274),
  ap: __webpack_require__(97),
  aperture: __webpack_require__(275),
  append: __webpack_require__(278),
  apply: __webpack_require__(154),
  applySpec: __webpack_require__(279),
  ascend: __webpack_require__(280),
  assoc: __webpack_require__(75),
  assocPath: __webpack_require__(156),
  binary: __webpack_require__(281),
  bind: __webpack_require__(149),
  both: __webpack_require__(282),
  call: __webpack_require__(283),
  chain: __webpack_require__(99),
  clamp: __webpack_require__(287),
  clone: __webpack_require__(288),
  comparator: __webpack_require__(289),
  complement: __webpack_require__(290),
  compose: __webpack_require__(101),
  composeK: __webpack_require__(164),
  composeP: __webpack_require__(292),
  concat: __webpack_require__(103),
  cond: __webpack_require__(301),
  construct: __webpack_require__(302),
  constructN: __webpack_require__(169),
  contains: __webpack_require__(303),
  converge: __webpack_require__(170),
  countBy: __webpack_require__(304),
  curry: __webpack_require__(79),
  curryN: __webpack_require__(13),
  dec: __webpack_require__(306),
  defaultTo: __webpack_require__(171),
  descend: __webpack_require__(307),
  difference: __webpack_require__(172),
  differenceWith: __webpack_require__(173),
  dissoc: __webpack_require__(174),
  dissocPath: __webpack_require__(308),
  divide: __webpack_require__(309),
  drop: __webpack_require__(176),
  dropLast: __webpack_require__(311),
  dropLastWhile: __webpack_require__(315),
  dropRepeats: __webpack_require__(318),
  dropRepeatsWith: __webpack_require__(178),
  dropWhile: __webpack_require__(319),
  either: __webpack_require__(321),
  empty: __webpack_require__(181),
  endsWith: __webpack_require__(322),
  eqBy: __webpack_require__(323),
  eqProps: __webpack_require__(324),
  equals: __webpack_require__(19),
  evolve: __webpack_require__(325),
  filter: __webpack_require__(104),
  find: __webpack_require__(326),
  findIndex: __webpack_require__(328),
  findLast: __webpack_require__(330),
  findLastIndex: __webpack_require__(332),
  flatten: __webpack_require__(334),
  flip: __webpack_require__(84),
  forEach: __webpack_require__(335),
  forEachObjIndexed: __webpack_require__(336),
  fromPairs: __webpack_require__(337),
  groupBy: __webpack_require__(338),
  groupWith: __webpack_require__(339),
  gt: __webpack_require__(340),
  gte: __webpack_require__(341),
  has: __webpack_require__(342),
  hasIn: __webpack_require__(343),
  head: __webpack_require__(344),
  identical: __webpack_require__(167),
  identity: __webpack_require__(109),
  ifElse: __webpack_require__(345),
  inc: __webpack_require__(346),
  indexBy: __webpack_require__(347),
  indexOf: __webpack_require__(348),
  init: __webpack_require__(349),
  innerJoin: __webpack_require__(350),
  insert: __webpack_require__(351),
  insertAll: __webpack_require__(352),
  intersection: __webpack_require__(353),
  intersectionWith: __webpack_require__(355),
  intersperse: __webpack_require__(356),
  into: __webpack_require__(357),
  invert: __webpack_require__(360),
  invertObj: __webpack_require__(361),
  invoker: __webpack_require__(62),
  is: __webpack_require__(185),
  isEmpty: __webpack_require__(362),
  isNil: __webpack_require__(157),
  join: __webpack_require__(363),
  juxt: __webpack_require__(186),
  keys: __webpack_require__(32),
  keysIn: __webpack_require__(364),
  last: __webpack_require__(179),
  lastIndexOf: __webpack_require__(365),
  length: __webpack_require__(187),
  lens: __webpack_require__(85),
  lensIndex: __webpack_require__(366),
  lensPath: __webpack_require__(367),
  lensProp: __webpack_require__(368),
  lift: __webpack_require__(78),
  liftN: __webpack_require__(158),
  lt: __webpack_require__(369),
  lte: __webpack_require__(370),
  map: __webpack_require__(16),
  mapAccum: __webpack_require__(371),
  mapAccumRight: __webpack_require__(372),
  mapObjIndexed: __webpack_require__(373),
  match: __webpack_require__(374),
  mathMod: __webpack_require__(375),
  max: __webpack_require__(50),
  maxBy: __webpack_require__(376),
  mean: __webpack_require__(189),
  median: __webpack_require__(377),
  memoize: __webpack_require__(378),
  memoizeWith: __webpack_require__(191),
  merge: __webpack_require__(379),
  mergeAll: __webpack_require__(380),
  mergeDeepLeft: __webpack_require__(381),
  mergeDeepRight: __webpack_require__(382),
  mergeDeepWith: __webpack_require__(383),
  mergeDeepWithKey: __webpack_require__(86),
  mergeWith: __webpack_require__(384),
  mergeWithKey: __webpack_require__(114),
  min: __webpack_require__(385),
  minBy: __webpack_require__(386),
  modulo: __webpack_require__(387),
  multiply: __webpack_require__(192),
  nAry: __webpack_require__(76),
  negate: __webpack_require__(388),
  none: __webpack_require__(389),
  not: __webpack_require__(162),
  nth: __webpack_require__(61),
  nthArg: __webpack_require__(390),
  o: __webpack_require__(391),
  objOf: __webpack_require__(184),
  of: __webpack_require__(392),
  omit: __webpack_require__(394),
  once: __webpack_require__(395),
  or: __webpack_require__(180),
  over: __webpack_require__(193),
  pair: __webpack_require__(396),
  partial: __webpack_require__(397),
  partialRight: __webpack_require__(398),
  partition: __webpack_require__(399),
  path: __webpack_require__(63),
  pathEq: __webpack_require__(400),
  pathOr: __webpack_require__(401),
  pathSatisfies: __webpack_require__(402),
  pick: __webpack_require__(403),
  pickAll: __webpack_require__(195),
  pickBy: __webpack_require__(404),
  pipe: __webpack_require__(163),
  pipeK: __webpack_require__(405),
  pipeP: __webpack_require__(165),
  pluck: __webpack_require__(57),
  prepend: __webpack_require__(196),
  product: __webpack_require__(406),
  project: __webpack_require__(407),
  prop: __webpack_require__(96),
  propEq: __webpack_require__(408),
  propIs: __webpack_require__(409),
  propOr: __webpack_require__(410),
  propSatisfies: __webpack_require__(411),
  props: __webpack_require__(412),
  range: __webpack_require__(413),
  reduce: __webpack_require__(33),
  reduceBy: __webpack_require__(82),
  reduceRight: __webpack_require__(198),
  reduceWhile: __webpack_require__(414),
  reduced: __webpack_require__(415),
  reject: __webpack_require__(81),
  remove: __webpack_require__(175),
  repeat: __webpack_require__(416),
  replace: __webpack_require__(417),
  reverse: __webpack_require__(80),
  scan: __webpack_require__(418),
  sequence: __webpack_require__(200),
  set: __webpack_require__(419),
  slice: __webpack_require__(45),
  sort: __webpack_require__(420),
  sortBy: __webpack_require__(421),
  sortWith: __webpack_require__(422),
  split: __webpack_require__(423),
  splitAt: __webpack_require__(424),
  splitEvery: __webpack_require__(425),
  splitWhen: __webpack_require__(426),
  startsWith: __webpack_require__(427),
  subtract: __webpack_require__(428),
  sum: __webpack_require__(190),
  symmetricDifference: __webpack_require__(429),
  symmetricDifferenceWith: __webpack_require__(430),
  tail: __webpack_require__(102),
  take: __webpack_require__(108),
  takeLast: __webpack_require__(182),
  takeLastWhile: __webpack_require__(431),
  takeWhile: __webpack_require__(432),
  tap: __webpack_require__(434),
  test: __webpack_require__(435),
  times: __webpack_require__(199),
  toLower: __webpack_require__(437),
  toPairs: __webpack_require__(438),
  toPairsIn: __webpack_require__(439),
  toString: __webpack_require__(60),
  toUpper: __webpack_require__(440),
  transduce: __webpack_require__(441),
  transpose: __webpack_require__(442),
  traverse: __webpack_require__(443),
  trim: __webpack_require__(444),
  tryCatch: __webpack_require__(445),
  type: __webpack_require__(100),
  unapply: __webpack_require__(446),
  unary: __webpack_require__(447),
  uncurryN: __webpack_require__(448),
  unfold: __webpack_require__(449),
  union: __webpack_require__(450),
  unionWith: __webpack_require__(451),
  uniq: __webpack_require__(111),
  uniqBy: __webpack_require__(183),
  uniqWith: __webpack_require__(112),
  unless: __webpack_require__(452),
  unnest: __webpack_require__(453),
  until: __webpack_require__(454),
  update: __webpack_require__(107),
  useWith: __webpack_require__(197),
  values: __webpack_require__(155),
  valuesIn: __webpack_require__(455),
  view: __webpack_require__(456),
  when: __webpack_require__(457),
  where: __webpack_require__(201),
  whereEq: __webpack_require__(458),
  without: __webpack_require__(459),
  xprod: __webpack_require__(460),
  zip: __webpack_require__(461),
  zipObj: __webpack_require__(462),
  zipWith: __webpack_require__(463)
};


/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var ap = __webpack_require__(97);
var map = __webpack_require__(16);
var prepend = __webpack_require__(196);
var reduceRight = __webpack_require__(198);


/**
 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
 * Applicative of Traversable.
 *
 * Dispatches to the `sequence` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
 * @param {Function} of
 * @param {*} traversable
 * @return {*}
 * @see R.traverse
 * @example
 *
 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
 *
 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
 */
module.exports = _curry2(function sequence(of, traversable) {
  return typeof traversable.sequence === 'function' ?
    traversable.sequence(of) :
    reduceRight(function(x, acc) { return ap(map(prepend, x), acc); },
                of([]),
                traversable);
});


/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _has = __webpack_require__(14);


/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec. Each of the spec's own properties must be a predicate function.
 * Each predicate is applied to the value of the corresponding property of the
 * test object. `where` returns true if all the predicates return true, false
 * otherwise.
 *
 * `where` is well suited to declaratively expressing constraints for other
 * functions such as [`filter`](#filter) and [`find`](#find).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Object
 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @example
 *
 *      // pred :: Object -> Boolean
 *      var pred = R.where({
 *        a: R.equals('foo'),
 *        b: R.complement(R.equals('bar')),
 *        x: R.gt(R.__, 10),
 *        y: R.lt(R.__, 20)
 *      });
 *
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
 */
module.exports = _curry2(function where(spec, testObj) {
  for (var prop in spec) {
    if (_has(prop, spec) && !spec[prop](testObj[prop])) {
      return false;
    }
  }
  return true;
});


/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(466)();
}


/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(203);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          if (this.subscription) this.subscription.tryUnsubscribe();
          this.initSubscription();
          if (shouldHandleStateChanges) this.subscription.trySubscribe();
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),

/***/ 2048:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendCredentials = sendCredentials;
exports.updateInfoBox = updateInfoBox;
exports.clearInfoBoxMessage = clearInfoBoxMessage;
exports.authReceived = authReceived;
exports.forgotPassword = forgotPassword;
exports.sendConfirmationLink = sendConfirmationLink;
exports.confirmSigninEmail = confirmSigninEmail;
exports.resetPasswordWithToken = resetPasswordWithToken;
exports.sendSecondaryEmailConfirmation = sendSecondaryEmailConfirmation;
exports.confirmSecondaryEmail = confirmSecondaryEmail;
exports.disassociateSecondaryEmail = disassociateSecondaryEmail;
exports.confirmDisassociateSecondary = confirmDisassociateSecondary;

var _soFetch = __webpack_require__(254);

var _signInConstants = __webpack_require__(3618);

var constants = _interopRequireWildcard(_signInConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function sendCredentials() {
  var credentials = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (dispatch) {
    return fetch('/signin', {
      method: 'post',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(credentials)
    }).then(function (response) {
      return response.json();
    }).then(function (res) {
      if (res.message) throw new Error(res.message);
      return res;
    });
  };
}

function updateInfoBox(messages) {
  return {
    type: constants.UPDATE_INFO_BOX,
    messages: messages
  };
}

function clearInfoBoxMessage() {
  return { type: constants.CLEAR_INFO_BOX_MESSAGE };
}

function authReceived(authToken) {
  return {
    type: constants.AUTH_RECEIVED,
    payload: {
      authToken: authToken
    }
  };
}

function forgotPassword(email) {
  return (0, _soFetch.soFetch)('/proxy/forgot-password', {
    method: 'put',
    body: { email: email },
    actionType: constants.FORGOT_PASSWORD
  });
}

function sendConfirmationLink(email) {
  return function (dispatch) {
    return fetch('/proxy/send-confirmation-link', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email })
    }).then(function (res) {
      if (res.status !== 200) throw new Error(res.status);else dispatch({ type: constants.SEND_CONFIRMATION_LINK });
    });
  };
}

function confirmSigninEmail(token) {
  return { type: 'CONFIRM_SIGNIN_EMAIL', payload: { token: token } };
}

function resetPasswordWithToken(newPassword, token) {
  return (0, _soFetch.soFetch)('/proxy/reset-password-with-token', {
    method: 'put',
    body: {
      newPassword: newPassword,
      token: token
    },
    actionType: constants.RESET_PASSWORD_WITH_TOKEN
  });
}

function sendSecondaryEmailConfirmation(email) {
  return (0, _soFetch.soFetch)('/proxy/secondary-email/send-secondary-email-confirmation', {
    method: 'put',
    body: { email: email, type: 'signin' },
    actionType: constants.SEND_SECONDARY_EMAIL_CONFIRMATION
  });
}

function confirmSecondaryEmail(token) {
  return function (dispatch) {
    return (0, _soFetch.soFetch)('/proxy/secondary-email/confirm-secondary-email', {
      method: 'put',
      body: { token: token, type: 'signin' },
      actionType: constants.CONFIRM_SECONDARY_EMAIL
    })(dispatch);
  };
}

function disassociateSecondaryEmail(email) {
  return (0, _soFetch.soFetch)('/proxy/secondary-email/disassociate-secondary-email', {
    method: 'put',
    body: { email: email, type: 'signin' },
    actionType: constants.DISASSOCIATE_SECONDARY_EMAIL
  });
}

function confirmDisassociateSecondary(id) {
  return function (dispatch) {
    return (0, _soFetch.soFetch)('/proxy/secondary-email/confirmed-disassociate-secondary-email', {
      method: 'put',
      body: { id: id, type: 'signin' },
      actionType: constants.CONFIRM_DISASSOCIATE_SECONDARY
    })(dispatch);
  };
}

/***/ }),

/***/ 2049:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Dependencies


var SignInError = function (_Component) {
  _inherits(SignInError, _Component);

  function SignInError() {
    _classCallCheck(this, SignInError);

    return _possibleConstructorReturn(this, (SignInError.__proto__ || Object.getPrototypeOf(SignInError)).apply(this, arguments));
  }

  _createClass(SignInError, [{
    key: 'render',
    value: function render() {
      var signinErrorClasses = 'inline-error opacity signin-alert';
      var style = void 0;
      if (this.props.signinInfo) {
        style = {
          backgroundColor: 'aliceblue',
          color: '#00BCD3'
        };
      }
      if (!this.props.signinError && !this.props.signinInfo) return false;
      return _react2.default.createElement(
        'div',
        { style: { marginTop: '8px' } },
        _react2.default.createElement(
          'p',
          { className: signinErrorClasses, style: style },
          this.props.signinError || this.props.signinInfo
        )
      );
    }
  }]);

  return SignInError;
}(_react.Component);

SignInError.propTypes = {
  signinInfo: _react.PropTypes.string,
  signinError: _react.PropTypes.string
};

exports.default = SignInError;

/* jshint ignore:end */

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(206);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),

/***/ 2050:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function getEnv() {
  var url = window.location.hostname;
  switch (url) {
    case 'dev.tourconnect.com':
      return 'test';
    case 'staging.tourconnect.com':
      return 'staging';
    case 'contracting.tourconnect.com':
    default:
      return 'prod';
  }
}

exports.default = getEnv();

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(115);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7392f206d905d9f0514a5acc03261bd0.eot";

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var neither = (0, _ramda.complement)(_ramda.and);
var sortByDateAsc = (0, _ramda.sort)((0, _ramda.cond)([[_ramda.lt, (0, _ramda.always)(-1)], [_ramda.gt, (0, _ramda.always)(1)], [_ramda.T, (0, _ramda.always)(0)]]));
var NewDate = function NewDate(date) {
  return new Date(date);
};
var getStartDate = function getStartDate(obj) {
  var start = obj.startDate || obj.seasonStartDate || obj.fromDate;
  if (start) return new Date(start);
  // below block is legacy, might not get to be called
  // but not 100% sure
  return (0, _ramda.call)((0, _ramda.compose)((0, _ramda.ifElse)(_ramda.identity, (0, _ramda.construct)(NewDate), (0, _ramda.always)(null)), (0, _ramda.ifElse)((0, _ramda.compose)((0, _ramda.equals)(2), _ramda.length), (0, _ramda.apply)(_ramda.min), (0, _ramda.prop)(0)), _ramda.values, (0, _ramda.omit)(['_id', 'eventName'])), obj);
};
var getEndDate = function getEndDate(obj) {
  var end = obj.endDate || obj.seasonEndDate || obj.toDate || obj.startDate;
  if (end) return new Date(end);
  return (0, _ramda.call)((0, _ramda.compose)((0, _ramda.ifElse)(_ramda.identity, (0, _ramda.construct)(NewDate), (0, _ramda.always)(null)), (0, _ramda.ifElse)((0, _ramda.compose)((0, _ramda.equals)(2), _ramda.length), (0, _ramda.apply)(_ramda.max), (0, _ramda.prop)(0)), _ramda.values, (0, _ramda.omit)(['_id', 'eventName'])), obj);
};

var getFirstDayFromAnArrayOfRanges = (0, _ramda.compose)(_ramda.head, sortByDateAsc, (0, _ramda.map)(getStartDate));

var getLastDayFromAnArrayOfRanges = (0, _ramda.compose)(_ramda.last, sortByDateAsc, (0, _ramda.map)(getEndDate));

var sortDateRangeAsc = (0, _ramda.sort)((0, _ramda.cond)([[(0, _ramda.useWith)(_ramda.lt, [getStartDate, getStartDate]), (0, _ramda.always)(-1)], [(0, _ramda.useWith)(_ramda.gt, [getStartDate, getStartDate]), (0, _ramda.always)(1)], [_ramda.T, (0, _ramda.always)(0)]]));
var notEqual = (0, _ramda.complement)(_ramda.equals);

var getMissingRangesReducerFn = function getMissingRangesReducerFn(missingRanges, currentRange, index, ranges) {
  if (!index) return missingRanges;
  var currentStartDate = getStartDate(currentRange);
  var yesterday = _moment2.default.utc(currentStartDate).subtract(1, 'days');
  var lastEndDate = getEndDate(ranges[index - 1]);
  var tomorrow = _moment2.default.utc(lastEndDate).add(1, 'days');
  return (0, _ramda.call)((0, _ramda.ifElse)(function () {
    return _moment2.default.utc(lastEndDate).isBefore(yesterday, 'day');
  }, (0, _ramda.append)({ from: tomorrow, to: yesterday }), _ramda.identity), missingRanges);
};

var getMissingRanges = function getMissingRanges(allRanges, contractingPeriod) {
  return (0, _ramda.call)((0, _ramda.compose)((0, _ramda.addIndex)(_ramda.reduce)(getMissingRangesReducerFn, []), sortDateRangeAsc, function () {
    return addContractingPeriodToDateRanges(allRanges, contractingPeriod);
  }));
};
var dateToString = function dateToString(date) {
  return _moment2.default.utc(date).format('DD MMM YYYY');
};

var notInContractingPeriod = function notInContractingPeriod(seasons, start, end) {
  var seasonFirst = getFirstDayFromAnArrayOfRanges(seasons);
  var seasonLast = getLastDayFromAnArrayOfRanges(seasons);
  if (neither(_moment2.default.utc(seasonFirst).isBetween(start, end, 'day', '[]'), _moment2.default.utc(seasonLast).isBetween(start, end, 'day', '[]'))) {
    return 'Your seasons, which start from ' + dateToString(seasonFirst) + ' - ' + dateToString(seasonLast) + ',\n    are not within your contract validity period.';
  }
  return '';
};

var _getDateFromUTC = function _getDateFromUTC(date) {
  var dateObject = new Date(date);
  return new Date(dateObject.getUTCFullYear(), dateObject.getUTCMonth(), dateObject.getUTCDate());
};
var transformDateRanges = function transformDateRanges(dateRanges) {
  return dateRanges.map(function (dateRange) {
    return Object.keys(dateRange).reduce(function (result, key) {
      if (key.indexOf('tartDate') > 0) result.from = _getDateFromUTC(dateRange[key]);
      if (key.indexOf('ndDate') > 0) result.to = _getDateFromUTC(dateRange[key]);
      return result;
    }, {});
  });
};
var sameDay = function sameDay(d1, d2) {
  return (0, _moment2.default)(d1).isSame(d2, 'day');
};
var datesMatch = (0, _ramda.curry)(function (range1, range2) {
  return sameDay(getStartDate(range1), getStartDate(range2)) && sameDay(getEndDate(range1), getEndDate(range2));
});
var existsIn = (0, _ramda.curry)(function (rangesFromSeason, range) {
  return (0, _ramda.any)(datesMatch(range), rangesFromSeason);
});
var checkIfSameSeason = (0, _ramda.curry)(function (ranges, rangesFromSeason) {
  return (0, _ramda.and)((0, _ramda.all)(existsIn(rangesFromSeason), ranges), (0, _ramda.all)(existsIn(ranges), rangesFromSeason));
});
var getSeasonNameIfMatch = (0, _ramda.curry)(function (seasons, ranges) {
  return (0, _ramda.call)((0, _ramda.compose)((0, _ramda.propOr)('', 'seasonName'), (0, _ramda.find)((0, _ramda.compose)(checkIfSameSeason(ranges), (0, _ramda.propOr)([], 'dateRanges')))), seasons);
});
var displayRange = function displayRange(range) {
  var classes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var start = getStartDate(range);
  var end = getEndDate(range);
  return sameDay(start, end) ? _react2.default.createElement(
    'span',
    { className: classes.start },
    dateToString(start)
  ) : _react2.default.createElement(
    'span',
    null,
    _react2.default.createElement(
      'span',
      { className: classes.start },
      dateToString(start)
    ),
    ' - ',
    _react2.default.createElement(
      'span',
      { className: classes.end },
      dateToString(end)
    )
  );
};
var displayDateRanges = function displayDateRanges(dateRanges) {
  return dateRanges.map(function (range, index) {
    return _react2.default.createElement(
      'div',
      { key: index },
      displayRange(range)
    );
  });
};

var addContractingPeriodToDateRanges = function addContractingPeriodToDateRanges(dateRanges, contractingPeriod) {
  return (0, _ramda.concat)(dateRanges, [{
    seasonStartDate: _moment2.default.utc(contractingPeriod.startDate).subtract(1, 'days'),
    seasonEndDate: _moment2.default.utc(contractingPeriod.startDate).subtract(1, 'days')
  }, {
    seasonStartDate: _moment2.default.utc(contractingPeriod.endDate).add(1, 'days')
  }]);
};
var seasonCovered = function seasonCovered(dateRanges, contractingPeriod) {
  var dateRangesWithStartAndEnd = addContractingPeriodToDateRanges(dateRanges, contractingPeriod);
  return !notInContractingPeriod(dateRanges, getStartDate(contractingPeriod), getEndDate(contractingPeriod)) && (0, _ramda.isEmpty)(getMissingRanges(dateRangesWithStartAndEnd, contractingPeriod));
};
var isSeasonSameWithContractingPeriod = function isSeasonSameWithContractingPeriod(dateRanges, contractingPeriod) {
  return datesMatch(contractingPeriod, (0, _ramda.pathOr)({}, [0, 0], dateRanges));
};

// const matchAllocationOrPolicyWithSeasons = (seasons, contents) => addIndex(map)(ifElse(
//   (season, index) => checkIfSameSeason(prop('dateRanges', season), pathOr([{}], [index, 'dateRanges'], contents)),
//     compose(propOr({}, __, contents), nthArg(1)),
//   (season, index) => {
//     if (index < contents.length) return merge({ correctDateRanges: prop('dateRanges', season), correctSeasonName: prop('seasonName', season) }, contents[index]);
//     return omit(['_id', 'seasonName'], season);
//   }
// ), seasons);
var matchAllocationOrPolicyWithSeasons = function matchAllocationOrPolicyWithSeasons(seasons, contents) {
  return seasons.map(function (season, i) {
    // for allocation, product cancellation, pickup, dropoff
    if (contents[i]) return (0, _ramda.merge)(contents[i], { dateRanges: season.dateRanges });
    return { dateRanges: season.dateRanges };
  });
};

var dayInRange = (0, _ramda.curry)(function (day, _ref) {
  var seasonStartDate = _ref.seasonStartDate,
      seasonEndDate = _ref.seasonEndDate;
  return seasonStartDate && _moment2.default.utc(day).isBetween(seasonStartDate, seasonEndDate || seasonStartDate, 'day', []);
});
var dayInDateRanges = (0, _ramda.curry)(function (day, dateRanges) {
  return dateRanges.some(dayInRange(day));
});
var dayInSeason = (0, _ramda.curry)(function (day, seasons) {
  return seasons.some(function (_ref2) {
    var dateRanges = _ref2.dateRanges;
    return dayInDateRanges(day, dateRanges);
  });
});

exports.default = {
  sortDateRangeAsc: sortDateRangeAsc,
  getMissingRanges: getMissingRanges,
  notInContractingPeriod: notInContractingPeriod,
  dateToString: dateToString,
  transformDateRanges: transformDateRanges,
  datesMatch: datesMatch,
  checkIfSameSeason: checkIfSameSeason,
  getSeasonNameIfMatch: getSeasonNameIfMatch,
  displayDateRanges: displayDateRanges,
  addContractingPeriodToDateRanges: addContractingPeriodToDateRanges,
  seasonCovered: seasonCovered,
  isSeasonSameWithContractingPeriod: isSeasonSameWithContractingPeriod,
  isDateRangesWithEmptyDates: function isDateRangesWithEmptyDates(dateRanges) {
    return !(dateRanges && dateRanges.length && dateRanges.some(function (range) {
      return range.seasonStartDate;
    }));
  },
  getFlattenedUnEmptyDates: (0, _ramda.compose)((0, _ramda.reject)(_ramda.isEmpty), (0, _ramda.chain)((0, _ramda.propOr)([], 'dateRanges'))),
  matchAllocationOrPolicyWithSeasons: matchAllocationOrPolicyWithSeasons,
  checkIfFullSeasonCoveredForAProduct: function checkIfFullSeasonCoveredForAProduct(start, end, arrayOfDates) {
    if (!arrayOfDates.length) return 1;
    var daysInSeason = Math.abs((0, _moment2.default)(start).diff((0, _moment2.default)(end), 'days')) + 1;
    var numOfDays = arrayOfDates.map(function (obj) {
      if (!(getStartDate(obj) && getEndDate(obj))) return 0;
      var rangeStart = (0, _moment2.default)(getStartDate(obj)).add(1, 'd');
      var rangeEnd = (0, _moment2.default)(getEndDate(obj)).add(1, 'd');
      return Math.round((0, _moment2.default)(rangeEnd).diff((0, _moment2.default)(rangeStart), 'days', true) + 1);
    });
    var totalNumOfDaysCovered = numOfDays.reduce(function (a, b) {
      return a + b;
    });
    return daysInSeason - totalNumOfDaysCovered;
  },
  _getDateFromUTC: function _getDateFromUTC(date) {
    if (!date) return date;
    var dateObject = new Date(date);
    return new Date(dateObject.getUTCFullYear(), dateObject.getUTCMonth(), dateObject.getUTCDate());
  },
  dayInDateRanges: dayInDateRanges,
  dayInSeason: dayInSeason,
  getFirstDayFromAnArrayOfRanges: getFirstDayFromAnArrayOfRanges,
  displayRange: displayRange,
  overlapExisting: function overlapExisting(_ref3, existingSeasons) {
    var from = _ref3.from,
        to = _ref3.to;

    if (!(from && to)) return false;
    return existingSeasons.some(function (_ref4) {
      var dateRanges = _ref4.dateRanges;
      return dateRanges.some(function (range) {
        return range.seasonStartDate && (dayInRange(range.seasonStartDate, { seasonStartDate: from, seasonEndDate: to }) || dayInRange(range.seasonEndDate, { seasonStartDate: from, seasonEndDate: to }) || dayInRange(from, range) || dayInRange(to, range));
      });
    });
    // return (dayInSeason(from, existingSeasons) || dayInSeason(to, existingSeasons));
  },
  removeOverlapDates: function removeOverlapDates(_ref5, existingSeasons) {
    var from = _ref5.from,
        to = _ref5.to;

    var removeOneRangeAFromRangeB = _ramda2.default.curry(function (rangeA, rangeB) {
      var startDate = rangeB.seasonStartDate;
      var endDate = rangeB.seasonEndDate;
      if (!rangeA || !startDate) return [rangeB];
      var rangeAStart = _moment2.default.utc(rangeA.from).format();
      var rangeAEnd = _moment2.default.utc(rangeA.to || rangeA.from).format();
      var dateRangesToReturn = [];
      if (_moment2.default.utc(rangeAEnd).isBefore(startDate, 'day') || _moment2.default.utc(rangeAStart).isAfter(endDate, 'day')) {
        dateRangesToReturn = [rangeB];
      } else if (_moment2.default.utc(rangeAStart).isSameOrAfter(startDate, 'day')) {
        if (_moment2.default.utc(rangeAEnd).isBefore(endDate, 'day')) {
          dateRangesToReturn = [{
            seasonStartDate: startDate,
            seasonEndDate: _moment2.default.utc(rangeAStart).subtract(1, 'days').format()
          }, {
            seasonStartDate: _moment2.default.utc(rangeAEnd).add(1, 'days').format(),
            seasonEndDate: endDate
          }];
        } else {
          dateRangesToReturn = [{
            seasonStartDate: startDate,
            seasonEndDate: _moment2.default.utc(rangeAStart).subtract(1, 'days').format()
          }];
        }
      } else {
        if (_moment2.default.utc(rangeAEnd).isBetween(startDate, endDate, 'day', '[)')) {
          dateRangesToReturn = [{
            seasonStartDate: _moment2.default.utc(rangeAEnd).add(1, 'days').format(),
            seasonEndDate: endDate
          }];
        } else {
          dateRangesToReturn = [];
        }
      }
      return dateRangesToReturn.filter(function (dateRangeToFilter) {
        return _moment2.default.utc(dateRangeToFilter.seasonEndDate).isSameOrAfter(dateRangeToFilter.seasonStartDate, 'day');
      });
    });
    return existingSeasons.map(function (season) {
      var dateRanges = _ramda2.default.chain(removeOneRangeAFromRangeB({ from: from, to: to }), season.dateRanges);
      return (0, _ramda.merge)(season, { dateRanges: dateRanges });
    });
  }
};

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */
module.exports = function _concat(set1, set2) {
  set1 = set1 || [];
  set2 = set2 || [];
  var idx;
  var len1 = set1.length;
  var len2 = set2.length;
  var result = [];

  idx = 0;
  while (idx < len1) {
    result[result.length] = set1[idx];
    idx += 1;
  }
  idx = 0;
  while (idx < len2) {
    result[result.length] = set2[idx];
    idx += 1;
  }
  return result;
};


/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = __webpack_require__(10).Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES


/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer
var MD5 = __webpack_require__(240)

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey


/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = exports;

curve.base = __webpack_require__(693);
curve.short = __webpack_require__(694);
curve.mont = __webpack_require__(695);
curve.edwards = __webpack_require__(696);


/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var asn1 = __webpack_require__(712)
var aesid = __webpack_require__(724)
var fixProc = __webpack_require__(725)
var ciphers = __webpack_require__(244)
var compat = __webpack_require__(513)
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = new Buffer(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen)
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global Promise */


// load the global object first:
// - it should be better integrated in the system (unhandledRejection in node)
// - the environment may have a custom Promise implementation (see zone.js)
var ES6Promise = null;
if (typeof Promise !== "undefined") {
    ES6Promise = Promise;
} else {
    ES6Promise = __webpack_require__(935);
}

/**
 * Let the user use/change some implementations.
 */
module.exports = {
    Promise: ES6Promise
};


/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var __WEBPACK_AMD_DEFINE_RESULT__;//     uuid.js
//
//     Copyright (c) 2010-2012 Robert Kieffer
//     MIT License - http://opensource.org/licenses/mit-license.php

/*global window, require, define */
(function(_window) {
  'use strict';

  // Unique ID creation requires a high quality random # generator.  We feature
  // detect to determine the best RNG source, normalizing to a function that
  // returns 128-bits of randomness, since that's what's usually required
  var _rng, _mathRNG, _nodeRNG, _whatwgRNG, _previousRoot;

  function setupBrowser() {
    // Allow for MSIE11 msCrypto
    var _crypto = _window.crypto || _window.msCrypto;

    if (!_rng && _crypto && _crypto.getRandomValues) {
      // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
      //
      // Moderately fast, high quality
      try {
        var _rnds8 = new Uint8Array(16);
        _whatwgRNG = _rng = function whatwgRNG() {
          _crypto.getRandomValues(_rnds8);
          return _rnds8;
        };
        _rng();
      } catch(e) {}
    }

    if (!_rng) {
      // Math.random()-based (RNG)
      //
      // If all else fails, use Math.random().  It's fast, but is of unspecified
      // quality.
      var  _rnds = new Array(16);
      _mathRNG = _rng = function() {
        for (var i = 0, r; i < 16; i++) {
          if ((i & 0x03) === 0) { r = Math.random() * 0x100000000; }
          _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }

        return _rnds;
      };
      if ('undefined' !== typeof console && console.warn) {
        console.warn("[SECURITY] node-uuid: crypto not usable, falling back to insecure Math.random()");
      }
    }
  }

  function setupNode() {
    // Node.js crypto-based RNG - http://nodejs.org/docs/v0.6.2/api/crypto.html
    //
    // Moderately fast, high quality
    if (true) {
      try {
        var _rb = __webpack_require__(659).randomBytes;
        _nodeRNG = _rng = _rb && function() {return _rb(16);};
        _rng();
      } catch(e) {}
    }
  }

  if (_window) {
    setupBrowser();
  } else {
    setupNode();
  }

  // Buffer class to use
  var BufferClass = ('function' === typeof Buffer) ? Buffer : Array;

  // Maps for number <-> hex string conversion
  var _byteToHex = [];
  var _hexToByte = {};
  for (var i = 0; i < 256; i++) {
    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
    _hexToByte[_byteToHex[i]] = i;
  }

  // **`parse()` - Parse a UUID into it's component bytes**
  function parse(s, buf, offset) {
    var i = (buf && offset) || 0, ii = 0;

    buf = buf || [];
    s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
      if (ii < 16) { // Don't overflow!
        buf[i + ii++] = _hexToByte[oct];
      }
    });

    // Zero out remaining bytes if string was short
    while (ii < 16) {
      buf[i + ii++] = 0;
    }

    return buf;
  }

  // **`unparse()` - Convert UUID byte array (ala parse()) into a string**
  function unparse(buf, offset) {
    var i = offset || 0, bth = _byteToHex;
    return  bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]];
  }

  // **`v1()` - Generate time-based UUID**
  //
  // Inspired by https://github.com/LiosK/UUID.js
  // and http://docs.python.org/library/uuid.html

  // random #'s we need to init node and clockseq
  var _seedBytes = _rng();

  // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
  var _nodeId = [
    _seedBytes[0] | 0x01,
    _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
  ];

  // Per 4.2.2, randomize (14 bit) clockseq
  var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

  // Previous uuid creation time
  var _lastMSecs = 0, _lastNSecs = 0;

  // See https://github.com/broofa/node-uuid for API details
  function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];

    options = options || {};

    var clockseq = (options.clockseq != null) ? options.clockseq : _clockseq;

    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = (options.msecs != null) ? options.msecs : new Date().getTime();

    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = (options.nsecs != null) ? options.nsecs : _lastNSecs + 1;

    // Time since last uuid creation (in msecs)
    var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq == null) {
      clockseq = clockseq + 1 & 0x3fff;
    }

    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs == null) {
      nsecs = 0;
    }

    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) {
      throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    }

    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;

    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;

    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;

    // `time_mid`
    var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;

    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;

    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;

    // `clock_seq_low`
    b[i++] = clockseq & 0xff;

    // `node`
    var node = options.node || _nodeId;
    for (var n = 0; n < 6; n++) {
      b[i + n] = node[n];
    }

    return buf ? buf : unparse(b);
  }

  // **`v4()` - Generate random UUID**

  // See https://github.com/broofa/node-uuid for API details
  function v4(options, buf, offset) {
    // Deprecated - 'format' argument, as supported in v1.2
    var i = buf && offset || 0;

    if (typeof(options) === 'string') {
      buf = (options === 'binary') ? new BufferClass(16) : null;
      options = null;
    }
    options = options || {};

    var rnds = options.random || (options.rng || _rng)();

    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80;

    // Copy bytes to buffer, if provided
    if (buf) {
      for (var ii = 0; ii < 16; ii++) {
        buf[i + ii] = rnds[ii];
      }
    }

    return buf || unparse(rnds);
  }

  // Export public API
  var uuid = v4;
  uuid.v1 = v1;
  uuid.v4 = v4;
  uuid.parse = parse;
  uuid.unparse = unparse;
  uuid.BufferClass = BufferClass;
  uuid._rng = _rng;
  uuid._mathRNG = _mathRNG;
  uuid._nodeRNG = _nodeRNG;
  uuid._whatwgRNG = _whatwgRNG;

  if (('undefined' !== typeof module) && module.exports) {
    // Publish as node.js module
    module.exports = uuid;
  } else if (true) {
    // Publish as AMD module
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {return uuid;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


  } else {
    // Publish as global (in browsers)
    _previousRoot = _window.uuid;

    // **`noConflict()` - (browser only) to reset global 'uuid' var**
    uuid.noConflict = function() {
      _window.uuid = _previousRoot;
      return uuid;
    };

    _window.uuid = uuid;
  }
})('undefined' !== typeof window ? window : null);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(685).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      r.strip();
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(236)(module)))

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "31d482aeaac8657a877c23b5ac53465c.svg";

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = '[workspace] ';

var CHANGE_SELECTION = exports.CHANGE_SELECTION = prefix + 'CHANGE_SELECTION';
// connections
var CONNECTIONS_FETCH = exports.CONNECTIONS_FETCH = prefix + 'CONNECTIONS_FETCH';
var CONNECTIONS_SELECT = exports.CONNECTIONS_SELECT = prefix + 'CONNECTIONS_SELECT';
var CONNECTIONS_ARCHIVE = exports.CONNECTIONS_ARCHIVE = prefix + 'CONNECTIONS_ARCHIVE';

// channels
var CHANNELS_FETCH = exports.CHANNELS_FETCH = prefix + 'CHANNELS_FETCH';
var CHANNELS_SELECT = exports.CHANNELS_SELECT = prefix + 'CHANNELS_SELECT';
var CHANNELS_SELECT_SAVE = exports.CHANNELS_SELECT_SAVE = prefix + 'CHANNELS_SELECT_SAVE';
var CHANNELS_RESET = exports.CHANNELS_RESET = prefix + 'CHANNELS_RESET';
var CHANNELS_ARCHIVE = exports.CHANNELS_ARCHIVE = prefix + 'CHANNELS_ARCHIVE';

// conversations
var CONVERSATIONS_FETCH = exports.CONVERSATIONS_FETCH = prefix + 'CONVERSATIONS_FETCH';
var CONVERSATIONS_RESET = exports.CONVERSATIONS_RESET = prefix + 'CONVERSATIONS_RESET';
var CONVERSATIONS_READ = exports.CONVERSATIONS_READ = prefix + 'CONVERSATIONS_READ';
var CONVERSATIONS_READ_WITH_PARAMS = exports.CONVERSATIONS_READ_WITH_PARAMS = prefix + 'CONVERSATIONS_READ_WITH_PARAMS';

// messages
var MESSAGE_CREATE = exports.MESSAGE_CREATE = prefix + 'MESSAGE_CREATE';
var MESSAGE_DELETE = exports.MESSAGE_DELETE = prefix + 'MESSAGE_DELETE';
var MESSAGE_DISABLE = exports.MESSAGE_DISABLE = prefix + 'MESSAGE_DISABLE';
var MESSAGE_ADD_FILES_TO_CONTRACT = exports.MESSAGE_ADD_FILES_TO_CONTRACT = prefix + 'MESSAGE_ADD_FILES_TO_CONTRACT';

// contract
var CONTRACT_SELECT = exports.CONTRACT_SELECT = prefix + 'CONTRACT_SELECT';

// unread headers
var STATUS_MESSAGES = exports.STATUS_MESSAGES = '$[topbar] STATUS_MESSAGES';
var STATUS_MESSAGES_REMOVE_CONNECTION = exports.STATUS_MESSAGES_REMOVE_CONNECTION = '$[topbar] REMOVE_CONNECTION';
var STATUS_CONNECTIONS_MARK_READ = exports.STATUS_CONNECTIONS_MARK_READ = '[topbar] MARK_ACCEPTED_AS_READ';

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(64);


var BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* kTrue */], put: __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */], take: __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

module.exports = {
    /**
     * True if this is running in Nodejs, will be undefined in a browser.
     * In a browser, browserify won't include this file and the whole module
     * will be resolved an empty object.
     */
    isNode : typeof Buffer !== "undefined",
    /**
     * Create a new nodejs Buffer.
     * @param {Object} data the data to pass to the constructor.
     * @param {String} encoding the encoding to use.
     * @return {Buffer} a new Buffer.
     */
    newBuffer : function(data, encoding){
        return new Buffer(data, encoding);
    },
    /**
     * Find out if an object is a Buffer.
     * @param {Object} b the object to test.
     * @return {Boolean} true if the object is a Buffer, false otherwise.
     */
    isBuffer : function(b){
        return Buffer.isBuffer(b);
    },

    isStream : function (obj) {
        return obj &&
            typeof obj.on === "function" &&
            typeof obj.pause === "function" &&
            typeof obj.resume === "function";
    }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),

/***/ 239:
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(8)
var HashBase = __webpack_require__(507)
var Buffer = __webpack_require__(10).Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5


/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(24).Buffer
var inherits = __webpack_require__(8)
var HashBase = __webpack_require__(507)

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__(660)
exports.sha1 = __webpack_require__(661)
exports.sha224 = __webpack_require__(662)
exports.sha256 = __webpack_require__(508)
exports.sha384 = __webpack_require__(663)
exports.sha512 = __webpack_require__(509)


/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__(669);
exports.Cipher = __webpack_require__(670);
exports.DES = __webpack_require__(671);
exports.CBC = __webpack_require__(672);
exports.EDE = __webpack_require__(673);


/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__(674)
var deciphers = __webpack_require__(682)
var modes = __webpack_require__(519)

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

var modeModules = {
  ECB: __webpack_require__(675),
  CBC: __webpack_require__(676),
  CFB: __webpack_require__(677),
  CFB8: __webpack_require__(678),
  CFB1: __webpack_require__(679),
  OFB: __webpack_require__(680),
  CTR: __webpack_require__(517),
  GCM: __webpack_require__(517)
}

var modes = __webpack_require__(519)

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes


/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__(22);
var randomBytes = __webpack_require__(121);
module.exports = crt;
function blind(priv) {
  var r = getr(priv);
  var blinder = r.toRed(bn.mont(priv.modulus))
  .redPow(new bn(priv.publicExponent)).fromRed();
  return {
    blinder: blinder,
    unblinder:r.invm(priv.modulus)
  };
}
function crt(msg, priv) {
  var blinds = blind(priv);
  var len = priv.modulus.byteLength();
  var mod = bn.mont(priv.modulus);
  var blinded = new bn(msg).mul(blinds.blinder).umod(priv.modulus);
  var c1 = blinded.toRed(bn.mont(priv.prime1));
  var c2 = blinded.toRed(bn.mont(priv.prime2));
  var qinv = priv.coefficient;
  var p = priv.prime1;
  var q = priv.prime2;
  var m1 = c1.redPow(priv.exponent1);
  var m2 = c2.redPow(priv.exponent2);
  m1 = m1.fromRed();
  m2 = m2.fromRed();
  var h = m1.isub(m2).imul(qinv).umod(p);
  h.imul(q);
  m2.iadd(h);
  return new Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
crt.getr = getr;
function getr(priv) {
  var len = priv.modulus.byteLength();
  var r = new bn(randomBytes(len));
  while (r.cmp(priv.modulus) >=  0 || !r.umod(priv.prime1) || !r.umod(priv.prime2)) {
    r = new bn(randomBytes(len));
  }
  return r;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

var hash = exports;

hash.utils = __webpack_require__(54);
hash.common = __webpack_require__(137);
hash.sha = __webpack_require__(698);
hash.ripemd = __webpack_require__(702);
hash.hmac = __webpack_require__(703);

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),

/***/ 248:
/***/ (function(module, exports) {

module.exports = {"en-US":{"BillingLink":"Billing","PlanLink":"Billing","Back to Admin":"Back to Admin","Billing":"Billing","Connections":"Connections","Contracting":"Rates & Contracts","Dashboard":"Dashboard","Home":"Home","Find Partners":"PartnerFinder","Log Out":"Log Out","Profile":"Profile","Settings":"Settings","Support":"Support","ConnectCommunicate":"Connect & Communicate","connectionsSplash":{"addConnection":"Add Connection","title":"Connect & Communicate","subtitle":"TourConnect is built on connections. Connect with business partners and get important messages to the right people even when contacts change."},"company":{"amenities":{"title":"Amenities"},"leftNav":{"resend":"RESEND INVITATION","accept":"ACCEPT CONNECTION?","connected":"CONNECTED","unconnected":"CONNECT"},"more":"+ More","less":"- Less"},"integration":{"routeNames":{"authentication":"Credentials","mappings":"Mappings","histories":"Exported Contracts","contracts":"Contracts to Be Exported"},"leftNav":{"addMapping":"Add Mapping"}},"connections":{"resend":{"error":{"message":"There was an error resending this email.","button":"Retry"},"success":{"message":"Invitation Resent.","button":"OK"}},"accepted":{"error":{"message":"There was an error accepting this connection.","button":"Retry"}},"rejected":{"error":{"message":"There was an error rejecting this connection.","button":"Retry"},"undo":{"message":"Connection Rejected","button":"Undo"},"undoError":{"message":"There was an error undoing your last method.","button":"Retry"}},"archive":{"error":{"message":"There was an error removing this connection.","button":"Retry"}},"routeNames":{"invites":"Sent","requests":"Received","connected":"Connected"},"findPartnerDialog":{"title":"Free Access to PartnerFinder until July 2015","dismiss":"dismiss","content":"TourConnect is built on connections. Help us by adding 5 connections with your current partners or industry colleagues and get free access to PartnerFinder until July 2015."},"leftNav":{"addConnection":"+ Add Connections","findPartners":"Find Partners","download":"Download All Contacts"},"listItem":{"editTag":"Edit Tags","addTag":"Add Tags","resendInvite":"Resend Invite","ignore":"Ignore Connection","removeConnection":"Remove Connection","accept":"Accept Connection","addConnection":"Add Connection"}},"error":{"general":"There was a problem processing your request. If this problem persists, please call us at +1 (214) 446-0721."},"signin":{"incorrectPassword":"Password you entered is not correct.","userNotFound":"We did not find any account associated with this email.","verify":"Please confirm your email address before logging in for the first time.","invalidEmail":"Please provide a valid email.","invalidPassword":"Please provide a valid password.","bothInvalid":"Invalid email or password. Please check your email and password, and try again.","deletedUser":"This user has been deleted, please contact the administrator of this account.","disabledUser":"This user has been disabled, please contact the administrator of this account."},"partnerFinder":{"leftNavTitle":"Partner Finder","searchWidget":{"searchFor":"Search For","contractors":"Contractors","suppliers":"Suppliers","country":"Country","destinationsSold":"Destinations Sold","tooltipCountry":"Where the hotel/tour/attraction is located","tooltipDestinationsSold":"Where the contractor is sending travelers to","cityOrRegion":"City/Region","cityHintText":"City/Region","destinationsSoldHintText":"Destinations Sold","searchButtonText":"Search"},"rightContent":{"searchBarText":"Search...","supplierSearchResultsTitle":"Supplier Search Results","contractorSearchResultsTitle":"Buyer Search Results","otherSearchResultsTitle":"Other Search Results","upgradeToPremiumPlan":"Upgrade to the Connected or Unlimited Plan to view company profiles and connect.","selectPremiumPlan":"Select the Connected or Unlimited Plan to view company profiles and connect.","listView":"List View","mapView":"Map View","connect":"Connect","resend":"ReSend","connected":"Connected","tootipAccept":"Accept Connection","tootipReject":"Reject Connection","lastSent":"Last sent ","ignored":"ignored"}},"onboarding":{"submitButton":"Submit Profile","verifyTitle":"Welcome back! Please check your profile.","onBoardingTitle":"Welcome! Let's Create Your Profile","onBoardingSubTitle":"Add a logo and tell us about your company.","companyTypes":"Company Types","countriesServed":"Destinations Sold","propertyTypes":"Property Types","companyLogo":"Company Logo","corporatePhone":"Corporate Phone","optional":"* Optional","logoParagraph":"Your logo is the first thing people see when they want to learn more about your company. We recommend uploading a square image of your logo for the best look.","logoButton":"Choose an Image\nFrom Your Computer","aboutYourCompany":"About Your Company","required":"* All Fields Required","shortDescription":"Short Description","shortDescriptionReminder":"Remember, this is what partners read when they search for your company.","textAreaParagraph":"We'd like to help you connect with new and existing business partners. Use the information below to tell your partners a little bit about you.","marketSegments":"Market Segments","contactInfo":"Contact Information","address":"Corporate Address","phoneInfoParagraph":"You can manage additional contacts in your profile later.","addressOnePlaceholder":"Street Address, P.O.Box, c/o","addressTwoPlaceholder":"Apartment, Suite, Unit Building, etc","city":"City","statePlaceholder":"State, Province, Region","zipPlaceholder":"Zip/Postal Code","country":"Country","website":"Website","contact":"Contact","firstName":"First Name","lastName":"Last Name","email":"Email","phone":"Phone","fax":"Fax","dialogErrorTitle":"SORRY! THERE WAS AN ERROR","dialogErrorMessage":"It looks like there was an error processing your form. Please refresh the page and try again.","dialogRefreshButton":"REFRESH","dialogVerifyAddressTitle":"IS THIS YOUR ADDRESS?","dialogYes":"YES","dialogNo":"NO","dialogSkip":"SKIP","marketSegmentsDesc":"These are the types of travelers you best serve.","destinationsSoldDesc":"These are the countries that you send travelers to.","contactInfoParagraph":"Your contact information makes it easier for global partners to find and recognize you.  Don't worry, your personal contact details will only be shared with the partners you choose to connect with."}}}

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(478);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(483)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./main.less", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./main.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var rateDraft = '{rates-draft}';
var UPDATE_SAME_AS_CORPORATE_POLICY_NOTES = exports.UPDATE_SAME_AS_CORPORATE_POLICY_NOTES = '{rates-draft} UPDATE_SAME_AS_CORPORATE_POLICY_NOTES';
var REFRESH_STARTED = exports.REFRESH_STARTED = rateDraft + ' REFRESH_STARTED';
var REFRESH_COMPLETION_CHECK = exports.REFRESH_COMPLETION_CHECK = rateDraft + ' REFRESH_COMPLETION_CHECK';
var REFRESH_LEFT_NAV = exports.REFRESH_LEFT_NAV = rateDraft + ' REFRESH_LEFT_NAV';
var REFRESH_POLICIES_NOTES = exports.REFRESH_POLICIES_NOTES = rateDraft + ' REFRESH_POLICIES_NOTES';
var REFRESH_PRODUCT_DETAILS = exports.REFRESH_PRODUCT_DETAILS = rateDraft + ' REFRESH_PRODUCT_DETAILS';
var REFRESH_FINISHED = exports.REFRESH_FINISHED = rateDraft + ' REFRESH_FINISHED';
var REVIEW_MY_RATES_DRAFT = exports.REVIEW_MY_RATES_DRAFT = rateDraft + '_REVIEW_MY_RATES_DRAFT';
var MANAGE_EXTRAS_OFFERS = exports.MANAGE_EXTRAS_OFFERS = rateDraft + ' MANAGE_EXTRAS_OFFERS';
var REMOVE_MASTER_TEMPLATE = exports.REMOVE_MASTER_TEMPLATE = rateDraft + ' REMOVE_MASTER_TEMPLATE';

var ADD_DRAFT_TO_QUEUE = exports.ADD_DRAFT_TO_QUEUE = '{contracting} ADD_DRAFT_TO_QUEUE';
var REMOVE_DRAFT_FROM_QUEUE = exports.REMOVE_DRAFT_FROM_QUEUE = '{contracting} REMOVE_DRAFT_FROM_QUEUE';

var SEND_UPDATES_FROM_QUEUE = exports.SEND_UPDATES_FROM_QUEUE = '{update-queue} SEND_UPDATES_FROM_QUEUE';
var CLEAR_QUEUE_STATE = exports.CLEAR_QUEUE_STATE = '{update-queue} CLEAR STATE';

var REFRESH_TEMPLATE_LIST = exports.REFRESH_TEMPLATE_LIST = '{template-list} REFRESH_TEMPLATE_LIST';

var SEND_TOURWRITER = exports.SEND_TOURWRITER = 'SEND_TOURWRITER';

var REMOVE_SINGLE_FEED_BY_TC_ADMIN = exports.REMOVE_SINGLE_FEED_BY_TC_ADMIN = '{history-feed} REMOVE_SINGLE_FEED_BY_TC_ADMIN';
var GET_NOTES = exports.GET_NOTES = '{history-feed} GET_NOTES';

var FILE_CONTRACT_FOR_REQUEST = exports.FILE_CONTRACT_FOR_REQUEST = '{contract-request} FILE_CONTRACT_FOR_REQUEST';

var REMOVE_CONTRACT_FROM_REQUEST = exports.REMOVE_CONTRACT_FROM_REQUEST = '{contract-request} REMOVE_CONTRACT_FROM_REQUEST';

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteUser = exports.editUser = exports.addUser = exports.approveOrRejectUser = exports.getUsersByFilter = exports.getCompanyAdmin = undefined;
exports.updateUMProps = updateUMProps;

var _constants = __webpack_require__(858);

var constants = _interopRequireWildcard(_constants);

var _http = __webpack_require__(118);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* global fetch */


function updateUMProps(payload) {
  return { type: constants.UPDATE_UM_PROP, payload: payload };
}

var getCompanyAdmin = exports.getCompanyAdmin = function getCompanyAdmin(companyType) {
  return function (dispatch) {
    dispatch({ type: constants.GETTING_COMP_ADMIN });
    return (0, _http.get)('/proxy/userManagement/admin/' + companyType).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      return dispatch({ type: constants.GOT_COMP_ADMIN, payload: response });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.GETTING_COMP_ADMIN_FAILED, payload: err });
    });
  };
};

var getUsersByFilter = exports.getUsersByFilter = function getUsersByFilter(filterBy) {
  return function (dispatch) {
    dispatch({ type: constants.GETTING_USERS_BY_FILTER });
    return (0, _http.get)('/proxy/userManagement/' + filterBy).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      return dispatch({ type: constants.GOT_USERS_BY_FILTER, payload: response });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.GETTING_USERS_BY_FILTER_FAILED, payload: err });
    });
  };
};

var approveOrRejectUser = exports.approveOrRejectUser = function approveOrRejectUser(user, action) {
  return function (dispatch) {
    dispatch({ type: constants.APPROVE_REJECT_USER_STARTED });
    return fetch('/proxy/settings/approveOrRejectUser', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ user: user, action: action })
    }).then(function (res) {
      return res.json();
    }).then(function (response) {
      if (response.error) return dispatch({ type: constants.APPROVE_REJECT_USER_FAILED, payload: response.error });
      return dispatch({ type: constants.APPROVE_REJECT_USER_DONE, payload: response });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.APPROVE_REJECT_USER_FAILED });
    });
  };
};

var addUser = exports.addUser = function addUser(payload) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var response, json;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              dispatch({ type: constants.ADD_USER_STARTING });
              _context.next = 4;
              return fetch('/proxy/userManagement/addUser', {
                method: 'put',
                credentials: 'same-origin',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
              });

            case 4:
              response = _context.sent;
              _context.next = 7;
              return response.json();

            case 7:
              json = _context.sent;

              if (!(json.error || response.status < 200 || response.status > 300)) {
                _context.next = 10;
                break;
              }

              return _context.abrupt('return', dispatch({ type: constants.ADD_USER_FAILED, payload: json || response }));

            case 10:
              return _context.abrupt('return', dispatch({ type: constants.ADDED_USER, payload: response }));

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](0);
              return _context.abrupt('return', dispatch({ type: constants.ADD_USER_FAILED, payload: _context.t0 }));

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined, [[0, 13]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var editUser = exports.editUser = function editUser(payload) {
  return function (dispatch) {
    dispatch({ type: constants.UPDATE_USER_STARTING });
    return fetch('/proxy/userManagement/editUser', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      if (response.error) return dispatch({ type: constants.UPDATE_USER_FAILED, payload: response });
      dispatch({ type: constants.UPDATED_USER, payload: response });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.UPDATE_USER_FAILED, payload: err });
    });
  };
};

var deleteUser = exports.deleteUser = function deleteUser(userId) {
  return function (dispatch) {
    dispatch({ type: constants.DELETE_USER_STARTING });
    return (0, _http.del)('/proxy/userManagement/editUser/' + userId).then(_checkStatus2.default).then(function (response) {
      if (response.error) return dispatch({ type: constants.DELETE_USER_FAILED });
      dispatch({ type: constants.DELETED_USER, payload: userId });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.DELETE_USER_FAILED, payload: err });
    });
  };
};

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.getQS = getQS;
exports.soFetch = soFetch;

__webpack_require__(1183);

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

function getQS(params) {
  if (!params || typeof params === 'object' && !Array.isArray(params) && !Object.keys(params).length) {
    throw new TypeError('Params Should be an object');
  }

  return Object.keys(params).reduce(function (string, key, index, outerKeys) {
    if (Array.isArray(params[key]) && params[key].length || !Array.isArray(params[key]) && params[key] !== undefined) {
      if (params[key] && Array.isArray(params[key])) {
        return string + (string === '?' ? '' : '&') + params[key].reduce(function (innerString, value, index, innerKeys) {
          return innerString + encodeURIComponent(key) + '[]=' + encodeURIComponent(value) + (index !== innerKeys.length - 1 ? '&' : '');
        }, '');
      } else if (params[key] && typeof params[key] === 'object' && Object.keys(params[key]).length) {
        return string + (string === '?' ? '' : '&') + Object.keys(params[key]).reduce(function (innerString, innerKey, index, innerKeys) {
          return innerString + encodeURIComponent(key) + '[' + encodeURIComponent(innerKey) + ']=' + encodeURIComponent(params[key][innerKey]) + (index !== innerKeys.length - 1 ? '&' : '');
        }, '');
      } else {
        return string + (string === '?' ? '' : '&') + encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
      }
    }
    return string;
  }, '?');
}

;

function soFetch(url, options) {
  var body = options.body;
  var method = options.method;
  var actionType = options.actionType;
  var responseBinding = options.responseBinding;
  var qs = options.qs;
  var headers = options.headers;
  var credentials = options.credentials;

  return function (dispatch) {
    var optionsForFetch = { method: method || 'get' };
    if (credentials === undefined) optionsForFetch.credentials = 'same-origin';
    if (credentials) optionsForFetch.credentials = credentials;
    if (body) optionsForFetch.body = JSON.stringify(body);
    if (method === 'put' || method === 'post') {
      optionsForFetch.headers = headers || { 'Accept': 'application/json', 'Content-Type': 'application/json' };
    }
    return fetch(url + (qs ? getQS(qs) : ''), optionsForFetch).then(checkStatus).then(function (res) {
      return res.json();
    }).then(function (res) {
      var action = { type: actionType };
      action[responseBinding || 'payload'] = res;
      return dispatch(action);
    });
  };
}

;

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

var invariant = __webpack_require__(56);
var defaultClickRejectionStrategy = __webpack_require__(261);

var alreadyInjected = false;

module.exports = function injectTapEventPlugin (strategyOverrides) {
  strategyOverrides = strategyOverrides || {}
  var shouldRejectClick = strategyOverrides.shouldRejectClick || defaultClickRejectionStrategy;

  if (false) {
    invariant(
      !alreadyInjected,
      'injectTapEventPlugin(): Can only be called once per application lifecycle.\n\n\
It is recommended to call injectTapEventPlugin() just before you call \
ReactDOM.render(). If you are using an external library which calls injectTapEventPlugin() \
itself, please contact the maintainer as it shouldn\'t be called in library code and \
should be injected by the application.'
    )
  }

  alreadyInjected = true;

  __webpack_require__(500).injection.injectEventPluginsByName({
    'TapEventPlugin':       __webpack_require__(262)(shouldRejectClick)
  });
};


/***/ }),

/***/ 261:
/***/ (function(module, exports) {

module.exports = function(lastTouchEvent, clickTimestamp) {
  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
    return true;
  }
};


/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2014 Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @providesModule TapEventPlugin
 * @typechecks static-only
 */



var EventConstants = __webpack_require__(263);
var EventPluginUtils = __webpack_require__(557);
var EventPropagators = __webpack_require__(499);
var SyntheticUIEvent = __webpack_require__(502);
var TouchEventUtils = __webpack_require__(264);
var ViewportMetrics = __webpack_require__(573);

var keyOf = __webpack_require__(265);
var topLevelTypes = EventConstants.topLevelTypes;

var isStartish = EventPluginUtils.isStartish;
var isEndish = EventPluginUtils.isEndish;

var isTouch = function(topLevelType) {
  var touchTypes = [
    'topTouchCancel',
    'topTouchEnd',
    'topTouchStart',
    'topTouchMove'
  ];
  return touchTypes.indexOf(topLevelType) >= 0;
}

/**
 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
 * in order to still be considered a 'tap' event.
 */
var tapMoveThreshold = 10;
var ignoreMouseThreshold = 750;
var startCoords = {x: null, y: null};
var lastTouchEvent = null;

var Axis = {
  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
};

function getAxisCoordOfEvent(axis, nativeEvent) {
  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
  if (singleTouch) {
    return singleTouch[axis.page];
  }
  return axis.page in nativeEvent ?
    nativeEvent[axis.page] :
    nativeEvent[axis.client] + ViewportMetrics[axis.envScroll];
}

function getDistance(coords, nativeEvent) {
  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
  return Math.pow(
    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
    0.5
  );
}

var touchEvents = [
  'topTouchStart',
  'topTouchCancel',
  'topTouchEnd',
  'topTouchMove',
];

var dependencies = [
  'topMouseDown',
  'topMouseMove',
  'topMouseUp',
].concat(touchEvents);

var eventTypes = {
  touchTap: {
    phasedRegistrationNames: {
      bubbled: keyOf({onTouchTap: null}),
      captured: keyOf({onTouchTapCapture: null})
    },
    dependencies: dependencies
  }
};

var now = (function() {
  if (Date.now) {
    return Date.now;
  } else {
    // IE8 support: http://stackoverflow.com/questions/9430357/please-explain-why-and-how-new-date-works-as-workaround-for-date-now-in
    return function () {
      return +new Date;
    }
  }
})();

function createTapEventPlugin(shouldRejectClick) {
  return {

    tapMoveThreshold: tapMoveThreshold,

    ignoreMouseThreshold: ignoreMouseThreshold,

    eventTypes: eventTypes,

    /**
     * @param {string} topLevelType Record from `EventConstants`.
     * @param {DOMEventTarget} targetInst The listening component root node.
     * @param {object} nativeEvent Native browser event.
     * @return {*} An accumulation of synthetic events.
     * @see {EventPluginHub.extractEvents}
     */
    extractEvents: function(
      topLevelType,
      targetInst,
      nativeEvent,
      nativeEventTarget
    ) {

      if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
        return null;
      }

      if (isTouch(topLevelType)) {
        lastTouchEvent = now();
      } else {
        if (shouldRejectClick(lastTouchEvent, now())) {
          return null;
        }
      }

      var event = null;
      var distance = getDistance(startCoords, nativeEvent);
      if (isEndish(topLevelType) && distance < tapMoveThreshold) {
        event = SyntheticUIEvent.getPooled(
          eventTypes.touchTap,
          targetInst,
          nativeEvent,
          nativeEventTarget
        );
      }
      if (isStartish(topLevelType)) {
        startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
        startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
      } else if (isEndish(topLevelType)) {
        startCoords.x = 0;
        startCoords.y = 0;
      }
      EventPropagators.accumulateTwoPhaseDispatches(event);
      return event;
    }

  };
}

module.exports = createTapEventPlugin;


/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Types of raw signals from the browser caught at the top level.
 */
var topLevelTypes = {
  topAbort: null,
  topAnimationEnd: null,
  topAnimationIteration: null,
  topAnimationStart: null,
  topBlur: null,
  topCanPlay: null,
  topCanPlayThrough: null,
  topChange: null,
  topClick: null,
  topCompositionEnd: null,
  topCompositionStart: null,
  topCompositionUpdate: null,
  topContextMenu: null,
  topCopy: null,
  topCut: null,
  topDoubleClick: null,
  topDrag: null,
  topDragEnd: null,
  topDragEnter: null,
  topDragExit: null,
  topDragLeave: null,
  topDragOver: null,
  topDragStart: null,
  topDrop: null,
  topDurationChange: null,
  topEmptied: null,
  topEncrypted: null,
  topEnded: null,
  topError: null,
  topFocus: null,
  topInput: null,
  topInvalid: null,
  topKeyDown: null,
  topKeyPress: null,
  topKeyUp: null,
  topLoad: null,
  topLoadedData: null,
  topLoadedMetadata: null,
  topLoadStart: null,
  topMouseDown: null,
  topMouseMove: null,
  topMouseOut: null,
  topMouseOver: null,
  topMouseUp: null,
  topPaste: null,
  topPause: null,
  topPlay: null,
  topPlaying: null,
  topProgress: null,
  topRateChange: null,
  topReset: null,
  topScroll: null,
  topSeeked: null,
  topSeeking: null,
  topSelectionChange: null,
  topStalled: null,
  topSubmit: null,
  topSuspend: null,
  topTextInput: null,
  topTimeUpdate: null,
  topTouchCancel: null,
  topTouchEnd: null,
  topTouchMove: null,
  topTouchStart: null,
  topTransitionEnd: null,
  topVolumeChange: null,
  topWaiting: null,
  topWheel: null
};

var EventConstants = {
  topLevelTypes: topLevelTypes
};

module.exports = EventConstants;

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

/**
 * Copyright 2013-2014 Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @providesModule TouchEventUtils
 */

var TouchEventUtils = {
  /**
   * Utility function for common case of extracting out the primary touch from a
   * touch event.
   * - `touchEnd` events usually do not have the `touches` property.
   *   http://stackoverflow.com/questions/3666929/
   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
   *
   * @param {Event} nativeEvent Native event that may or may not be a touch.
   * @return {TouchesObject?} an object with pageX and pageY or null.
   */
  extractSingleTouch: function(nativeEvent) {
    var touches = nativeEvent.touches;
    var changedTouches = nativeEvent.changedTouches;
    var hasTouches = touches && touches.length > 0;
    var hasChangedTouches = changedTouches && changedTouches.length > 0;

    return !hasTouches && hasChangedTouches ? changedTouches[0] :
           hasTouches ? touches[0] :
           nativeEvent;
  }
};

module.exports = TouchEventUtils;


/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Allows extraction of a minified key. Let's the build system minify keys
 * without losing the ability to dynamically use key strings as values
 * themselves. Pass in an object with a single key/val pair and it will return
 * you the string key of that single record. Suppose you want to grab the
 * value for a key 'className' inside of an object. Key/val minification may
 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
 * reuse those resolutions.
 */
var keyOf = function keyOf(oneKeyObj) {
  var key;
  for (key in oneKeyObj) {
    if (!oneKeyObj.hasOwnProperty(key)) {
      continue;
    }
    return key;
  }
  return null;
};

module.exports = keyOf;

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

var always = __webpack_require__(49);


/**
 * A function that always returns `false`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.T
 * @example
 *
 *      R.F(); //=> false
 */
module.exports = always(false);


/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

var always = __webpack_require__(49);


/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.F
 * @example
 *
 *      R.T(); //=> true
 */
module.exports = always(true);


/***/ }),

/***/ 268:
/***/ (function(module, exports) {

/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 */
module.exports = {'@@functional/placeholder': true};


/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _curry1 = __webpack_require__(4);
var curryN = __webpack_require__(13);


/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      var mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */
module.exports = _curry1(function addIndex(fn) {
  return curryN(fn.length, function() {
    var idx = 0;
    var origFn = arguments[0];
    var list = arguments[arguments.length - 1];
    var args = Array.prototype.slice.call(arguments, 0);
    args[0] = function() {
      var result = origFn.apply(this, _concat(arguments, [idx, list]));
      idx += 1;
      return result;
    };
    return fn.apply(this, args);
  });
});


/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(580);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(581);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(912);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(913);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xall = __webpack_require__(271);


/**
 * Returns `true` if all elements of the list match the predicate, `false` if
 * there are any that don't.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
 *         otherwise.
 * @see R.any, R.none, R.transduce
 * @example
 *
 *      var equals3 = R.equals(3);
 *      R.all(equals3)([3, 3, 3, 3]); //=> true
 *      R.all(equals3)([3, 3, 1, 3]); //=> false
 */
module.exports = _curry2(_dispatchable(['all'], _xall, function all(fn, list) {
  var idx = 0;
  while (idx < list.length) {
    if (!fn(list[idx])) {
      return false;
    }
    idx += 1;
  }
  return true;
}));


/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _reduced = __webpack_require__(42);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XAll(f, xf) {
    this.xf = xf;
    this.f = f;
    this.all = true;
  }
  XAll.prototype['@@transducer/init'] = _xfBase.init;
  XAll.prototype['@@transducer/result'] = function(result) {
    if (this.all) {
      result = this.xf['@@transducer/step'](result, true);
    }
    return this.xf['@@transducer/result'](result);
  };
  XAll.prototype['@@transducer/step'] = function(result, input) {
    if (!this.f(input)) {
      this.all = false;
      result = _reduced(this.xf['@@transducer/step'](result, false));
    }
    return result;
  };

  return _curry2(function _xall(f, xf) { return new XAll(f, xf); });
}());


/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var curryN = __webpack_require__(13);
var max = __webpack_require__(50);
var pluck = __webpack_require__(57);
var reduce = __webpack_require__(33);


/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if every one of the provided predicates is satisfied
 * by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.anyPass
 * @example
 *
 *      var isQueen = R.propEq('rank', 'Q');
 *      var isSpade = R.propEq('suit', '♠︎');
 *      var isQueenOfSpades = R.allPass([isQueen, isSpade]);
 *
 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
 */
module.exports = _curry1(function allPass(preds) {
  return curryN(reduce(max, 0, pluck('length', preds)), function() {
    var idx = 0;
    var len = preds.length;
    while (idx < len) {
      if (!preds[idx].apply(this, arguments)) {
        return false;
      }
      idx += 1;
    }
    return true;
  });
});


/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XMap(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XMap.prototype['@@transducer/init'] = _xfBase.init;
  XMap.prototype['@@transducer/result'] = _xfBase.result;
  XMap.prototype['@@transducer/step'] = function(result, input) {
    return this.xf['@@transducer/step'](result, this.f(input));
  };

  return _curry2(function _xmap(f, xf) { return new XMap(f, xf); });
}());


/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var curryN = __webpack_require__(13);
var max = __webpack_require__(50);
var pluck = __webpack_require__(57);
var reduce = __webpack_require__(33);


/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if at least one of the provided predicates is
 * satisfied by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.allPass
 * @example
 *
 *      var isClub = R.propEq('suit', '♣');
 *      var isSpade = R.propEq('suit', '♠');
 *      var isBlackCard = R.anyPass([isClub, isSpade]);
 *
 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
 */
module.exports = _curry1(function anyPass(preds) {
  return curryN(reduce(max, 0, pluck('length', preds)), function() {
    var idx = 0;
    var len = preds.length;
    while (idx < len) {
      if (preds[idx].apply(this, arguments)) {
        return true;
      }
      idx += 1;
    }
    return false;
  });
});


/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

var _aperture = __webpack_require__(276);
var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xaperture = __webpack_require__(277);


/**
 * Returns a new list, composed of n-tuples of consecutive elements. If `n` is
 * greater than the length of the list, an empty list is returned.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @param {Number} n The size of the tuples to create
 * @param {Array} list The list to split into `n`-length tuples
 * @return {Array} The resulting list of `n`-length tuples
 * @see R.transduce
 * @example
 *
 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
 */
module.exports = _curry2(_dispatchable([], _xaperture, _aperture));


/***/ }),

/***/ 276:
/***/ (function(module, exports) {

module.exports = function _aperture(n, list) {
  var idx = 0;
  var limit = list.length - (n - 1);
  var acc = new Array(limit >= 0 ? limit : 0);
  while (idx < limit) {
    acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
    idx += 1;
  }
  return acc;
};


/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _curry2 = __webpack_require__(1);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XAperture(n, xf) {
    this.xf = xf;
    this.pos = 0;
    this.full = false;
    this.acc = new Array(n);
  }
  XAperture.prototype['@@transducer/init'] = _xfBase.init;
  XAperture.prototype['@@transducer/result'] = function(result) {
    this.acc = null;
    return this.xf['@@transducer/result'](result);
  };
  XAperture.prototype['@@transducer/step'] = function(result, input) {
    this.store(input);
    return this.full ? this.xf['@@transducer/step'](result, this.getCopy()) : result;
  };
  XAperture.prototype.store = function(input) {
    this.acc[this.pos] = input;
    this.pos += 1;
    if (this.pos === this.acc.length) {
      this.pos = 0;
      this.full = true;
    }
  };
  XAperture.prototype.getCopy = function() {
    return _concat(Array.prototype.slice.call(this.acc, this.pos),
                   Array.prototype.slice.call(this.acc, 0, this.pos));
  };

  return _curry2(function _xaperture(n, xf) { return new XAperture(n, xf); });
}());


/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _curry2 = __webpack_require__(1);


/**
 * Returns a new list containing the contents of the given list, followed by
 * the given element.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The element to add to the end of the new list.
 * @param {Array} list The list of elements to add a new item to.
 *        list.
 * @return {Array} A new list containing the elements of the old list followed by `el`.
 * @see R.prepend
 * @example
 *
 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
 *      R.append('tests', []); //=> ['tests']
 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
 */
module.exports = _curry2(function append(el, list) {
  return _concat(list, [el]);
});


/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var apply = __webpack_require__(154);
var curryN = __webpack_require__(13);
var map = __webpack_require__(16);
var max = __webpack_require__(50);
var pluck = __webpack_require__(57);
var reduce = __webpack_require__(33);
var values = __webpack_require__(155);


/**
 * Given a spec object recursively mapping properties to functions, creates a
 * function producing an object of the same structure, by mapping each property
 * to the result of calling its associated function with the supplied arguments.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
 * @param {Object} spec an object recursively mapping properties to functions for
 *        producing the values for these properties.
 * @return {Function} A function that returns an object of the same structure
 * as `spec', with each property set to the value returned by calling its
 * associated function with the supplied arguments.
 * @see R.converge, R.juxt
 * @example
 *
 *      var getMetrics = R.applySpec({
 *                                      sum: R.add,
 *                                      nested: { mul: R.multiply }
 *                                   });
 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
 */
module.exports = _curry1(function applySpec(spec) {
  spec = map(function(v) { return typeof v == 'function' ? v : applySpec(v); },
             spec);
  return curryN(reduce(max, 0, pluck('length', values(spec))),
                function() {
                  var args = arguments;
                  return map(function(f) { return apply(f, args); }, spec);
                });
});


/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Makes an ascending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
 * @see R.descend
 * @example
 *
 *      var byAge = R.ascend(R.prop('age'));
 *      var people = [
 *        // ...
 *      ];
 *      var peopleByYoungestFirst = R.sort(byAge, people);
 */
module.exports = _curry3(function ascend(fn, a, b) {
  var aa = fn(a);
  var bb = fn(b);
  return aa < bb ? -1 : aa > bb ? 1 : 0;
});


/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var nAry = __webpack_require__(76);


/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 2 parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> c) -> (a, b -> c)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 2.
 * @see R.nAry, R.unary
 * @example
 *
 *      var takesThreeArgs = function(a, b, c) {
 *        return [a, b, c];
 *      };
 *      takesThreeArgs.length; //=> 3
 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
 *
 *      var takesTwoArgs = R.binary(takesThreeArgs);
 *      takesTwoArgs.length; //=> 2
 *      // Only 2 arguments are passed to the wrapped function
 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
 * @symb R.binary(f)(a, b, c) = f(a, b)
 */
module.exports = _curry1(function binary(fn) {
  return nAry(2, fn);
});


/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _isFunction = __webpack_require__(77);
var and = __webpack_require__(151);
var lift = __webpack_require__(78);


/**
 * A function which calls the two provided functions and returns the `&&`
 * of the results.
 * It returns the result of the first function if it is false-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * false-y value.
 *
 * In addition to functions, `R.both` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f A predicate
 * @param {Function} g Another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
 * @see R.and
 * @example
 *
 *      var gt10 = R.gt(R.__, 10)
 *      var lt20 = R.lt(R.__, 20)
 *      var f = R.both(gt10, lt20);
 *      f(15); //=> true
 *      f(30); //=> false
 */
module.exports = _curry2(function both(f, g) {
  return _isFunction(f) ?
    function _both() {
      return f.apply(this, arguments) && g.apply(this, arguments);
    } :
    lift(and)(f, g);
});


/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

var curry = __webpack_require__(79);


/**
 * Returns the result of calling its first argument with the remaining
 * arguments. This is occasionally useful as a converging function for
 * [`R.converge`](#converge): the first branch can produce a function while the
 * remaining branches produce values to be passed to that function as its
 * arguments.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig (*... -> a),*... -> a
 * @param {Function} fn The function to apply to the remaining arguments.
 * @param {...*} args Any number of positional arguments.
 * @return {*}
 * @see R.apply
 * @example
 *
 *      R.call(R.add, 1, 2); //=> 3
 *
 *      var indentN = R.pipe(R.times(R.always(' ')),
 *                           R.join(''),
 *                           R.replace(/^(?!$)/gm));
 *
 *      var format = R.converge(R.call, [
 *                                  R.pipe(R.prop('indent'), indentN),
 *                                  R.prop('value')
 *                              ]);
 *
 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
 * @symb R.call(f, a, b) = f(a, b)
 */
module.exports = curry(function call(fn) {
  return fn.apply(this, Array.prototype.slice.call(arguments, 1));
});


/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _flatCat = __webpack_require__(285);
var map = __webpack_require__(16);


module.exports = _curry2(function _xchain(f, xf) {
  return map(f, _flatCat(xf));
});


/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

var _forceReduced = __webpack_require__(286);
var _isArrayLike = __webpack_require__(74);
var _reduce = __webpack_require__(18);
var _xfBase = __webpack_require__(9);

module.exports = (function() {
  var preservingReduced = function(xf) {
    return {
      '@@transducer/init': _xfBase.init,
      '@@transducer/result': function(result) {
        return xf['@@transducer/result'](result);
      },
      '@@transducer/step': function(result, input) {
        var ret = xf['@@transducer/step'](result, input);
        return ret['@@transducer/reduced'] ? _forceReduced(ret) : ret;
      }
    };
  };

  return function _xcat(xf) {
    var rxf = preservingReduced(xf);
    return {
      '@@transducer/init': _xfBase.init,
      '@@transducer/result': function(result) {
        return rxf['@@transducer/result'](result);
      },
      '@@transducer/step': function(result, input) {
        return !_isArrayLike(input) ? _reduce(rxf, result, [input]) : _reduce(rxf, result, input);
      }
    };
  };
}());


/***/ }),

/***/ 286:
/***/ (function(module, exports) {

module.exports = function _forceReduced(x) {
  return {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
};


/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);

/**
 * Restricts a number to be within a range.
 *
 * Also works for other ordered types such as Strings and Dates.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Relation
 * @sig Ord a => a -> a -> a -> a
 * @param {Number} minimum The lower limit of the clamp (inclusive)
 * @param {Number} maximum The upper limit of the clamp (inclusive)
 * @param {Number} value Value to be clamped
 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
 * @example
 *
 *      R.clamp(1, 10, -5) // => 1
 *      R.clamp(1, 10, 15) // => 10
 *      R.clamp(1, 10, 4)  // => 4
 */
module.exports = _curry3(function clamp(min, max, value) {
  if (min > max) {
    throw new Error('min must not be greater than max in clamp(min, max, value)');
  }
  return value < min ? min :
         value > max ? max :
         value;
});


/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

var _clone = __webpack_require__(160);
var _curry1 = __webpack_require__(4);


/**
 * Creates a deep copy of the value which may contain (nested) `Array`s and
 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
 * assigned by reference rather than copied
 *
 * Dispatches to a `clone` method if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {*} -> {*}
 * @param {*} value The object or array to clone
 * @return {*} A deeply cloned copy of `val`
 * @example
 *
 *      var objects = [{}, {}, {}];
 *      var objectsClone = R.clone(objects);
 *      objects === objectsClone; //=> false
 *      objects[0] === objectsClone[0]; //=> false
 */
module.exports = _curry1(function clone(value) {
  return value != null && typeof value.clone === 'function' ?
    value.clone() :
    _clone(value, [], [], true);
});


/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Makes a comparator function out of a function that reports whether the first
 * element is less than the second.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a, b -> Boolean) -> (a, b -> Number)
 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
 * is less than the second, `false` otherwise
 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
 * @example
 *
 *      var byAge = R.comparator((a, b) => a.age < b.age);
 *      var people = [
 *        // ...
 *      ];
 *      var peopleByIncreasingAge = R.sort(byAge, people);
 */
module.exports = _curry1(function comparator(pred) {
  return function(a, b) {
    return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
  };
});


/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

var lift = __webpack_require__(78);
var not = __webpack_require__(162);


/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      var isNotNil = R.complement(R.isNil);
 *      isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      isNil(7); //=> false
 *      isNotNil(7); //=> true
 */
module.exports = lift(not);


/***/ }),

/***/ 291:
/***/ (function(module, exports) {

module.exports = function _pipe(f, g) {
  return function() {
    return g.call(this, f.apply(this, arguments));
  };
};


/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

var pipeP = __webpack_require__(165);
var reverse = __webpack_require__(80);


/**
 * Performs right-to-left composition of one or more Promise-returning
 * functions. The rightmost function may have any arity; the remaining
 * functions must be unary.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((y -> Promise z), (x -> Promise y), ..., (a -> Promise b)) -> (a -> Promise z)
 * @param {...Function} functions The functions to compose
 * @return {Function}
 * @see R.pipeP
 * @example
 *
 *      var db = {
 *        users: {
 *          JOE: {
 *            name: 'Joe',
 *            followers: ['STEVE', 'SUZY']
 *          }
 *        }
 *      }
 *
 *      // We'll pretend to do a db lookup which returns a promise
 *      var lookupUser = (userId) => Promise.resolve(db.users[userId])
 *      var lookupFollowers = (user) => Promise.resolve(user.followers)
 *      lookupUser('JOE').then(lookupFollowers)
 *
 *      //  followersForUser :: String -> Promise [UserId]
 *      var followersForUser = R.composeP(lookupFollowers, lookupUser);
 *      followersForUser('JOE').then(followers => console.log('Followers:', followers))
 *      // Followers: ["STEVE","SUZY"]
 */
module.exports = function composeP() {
  if (arguments.length === 0) {
    throw new Error('composeP requires at least one argument');
  }
  return pipeP.apply(this, reverse(arguments));
};


/***/ }),

/***/ 293:
/***/ (function(module, exports) {

module.exports = function _pipeP(f, g) {
  return function() {
    var ctx = this;
    return f.apply(ctx, arguments).then(function(x) {
      return g.call(ctx, x);
    });
  };
};


/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(46);
var _map = __webpack_require__(73);
var _quote = __webpack_require__(298);
var _toISOString = __webpack_require__(299);
var keys = __webpack_require__(32);
var reject = __webpack_require__(81);


module.exports = function _toString(x, seen) {
  var recur = function recur(y) {
    var xs = seen.concat([x]);
    return _contains(y, xs) ? '<Circular>' : _toString(y, xs);
  };

  //  mapPairs :: (Object, [String]) -> [String]
  var mapPairs = function(obj, keys) {
    return _map(function(k) { return _quote(k) + ': ' + recur(obj[k]); }, keys.slice().sort());
  };

  switch (Object.prototype.toString.call(x)) {
    case '[object Arguments]':
      return '(function() { return arguments; }(' + _map(recur, x).join(', ') + '))';
    case '[object Array]':
      return '[' + _map(recur, x).concat(mapPairs(x, reject(function(k) { return /^\d+$/.test(k); }, keys(x)))).join(', ') + ']';
    case '[object Boolean]':
      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
    case '[object Date]':
      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ')';
    case '[object Null]':
      return 'null';
    case '[object Number]':
      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
    case '[object String]':
      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);
    case '[object Undefined]':
      return 'undefined';
    default:
      if (typeof x.toString === 'function') {
        var repr = x.toString();
        if (repr !== '[object Object]') {
          return repr;
        }
      }
      return '{' + mapPairs(x, keys(x)).join(', ') + '}';
  }
};


/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

var _arrayFromIterator = __webpack_require__(296);
var _functionName = __webpack_require__(297);
var _has = __webpack_require__(14);
var identical = __webpack_require__(167);
var keys = __webpack_require__(32);
var type = __webpack_require__(100);


module.exports = function _equals(a, b, stackA, stackB) {
  if (identical(a, b)) {
    return true;
  }

  if (type(a) !== type(b)) {
    return false;
  }

  if (a == null || b == null) {
    return false;
  }

  if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
    return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) &&
           typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
  }

  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
    return typeof a.equals === 'function' && a.equals(b) &&
           typeof b.equals === 'function' && b.equals(a);
  }

  switch (type(a)) {
    case 'Arguments':
    case 'Array':
    case 'Object':
      if (typeof a.constructor === 'function' &&
          _functionName(a.constructor) === 'Promise') {
        return a === b;
      }
      break;
    case 'Boolean':
    case 'Number':
    case 'String':
      if (!(typeof a === typeof b && identical(a.valueOf(), b.valueOf()))) {
        return false;
      }
      break;
    case 'Date':
      if (!identical(a.valueOf(), b.valueOf())) {
        return false;
      }
      break;
    case 'Error':
      return a.name === b.name && a.message === b.message;
    case 'RegExp':
      if (!(a.source === b.source &&
            a.global === b.global &&
            a.ignoreCase === b.ignoreCase &&
            a.multiline === b.multiline &&
            a.sticky === b.sticky &&
            a.unicode === b.unicode)) {
        return false;
      }
      break;
    case 'Map':
    case 'Set':
      if (!_equals(_arrayFromIterator(a.entries()), _arrayFromIterator(b.entries()), stackA, stackB)) {
        return false;
      }
      break;
    case 'Int8Array':
    case 'Uint8Array':
    case 'Uint8ClampedArray':
    case 'Int16Array':
    case 'Uint16Array':
    case 'Int32Array':
    case 'Uint32Array':
    case 'Float32Array':
    case 'Float64Array':
      break;
    case 'ArrayBuffer':
      break;
    default:
      // Values of other types are only equal if identical.
      return false;
  }

  var keysA = keys(a);
  if (keysA.length !== keys(b).length) {
    return false;
  }

  var idx = stackA.length - 1;
  while (idx >= 0) {
    if (stackA[idx] === a) {
      return stackB[idx] === b;
    }
    idx -= 1;
  }

  stackA.push(a);
  stackB.push(b);
  idx = keysA.length - 1;
  while (idx >= 0) {
    var key = keysA[idx];
    if (!(_has(key, b) && _equals(b[key], a[key], stackA, stackB))) {
      return false;
    }
    idx -= 1;
  }
  stackA.pop();
  stackB.pop();
  return true;
};


/***/ }),

/***/ 296:
/***/ (function(module, exports) {

module.exports = function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
};


/***/ }),

/***/ 297:
/***/ (function(module, exports) {

module.exports = function _functionName(f) {
  // String(x => x) evaluates to "x => x", so the pattern may not match.
  var match = String(f).match(/^function (\w*)/);
  return match == null ? '' : match[1];
};


/***/ }),

/***/ 298:
/***/ (function(module, exports) {

module.exports = function _quote(s) {
  var escaped = s
    .replace(/\\/g, '\\\\')
    .replace(/[\b]/g, '\\b')  // \b matches word boundary; [\b] matches backspace
    .replace(/\f/g, '\\f')
    .replace(/\n/g, '\\n')
    .replace(/\r/g, '\\r')
    .replace(/\t/g, '\\t')
    .replace(/\v/g, '\\v')
    .replace(/\0/g, '\\0');

  return '"' + escaped.replace(/"/g, '\\"') + '"';
};


/***/ }),

/***/ 299:
/***/ (function(module, exports) {

/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */
module.exports = (function() {
  var pad = function pad(n) { return (n < 10 ? '0' : '') + n; };

  return typeof Date.prototype.toISOString === 'function' ?
    function _toISOString(d) {
      return d.toISOString();
    } :
    function _toISOString(d) {
      return (
        d.getUTCFullYear() + '-' +
        pad(d.getUTCMonth() + 1) + '-' +
        pad(d.getUTCDate()) + 'T' +
        pad(d.getUTCHours()) + ':' +
        pad(d.getUTCMinutes()) + ':' +
        pad(d.getUTCSeconds()) + '.' +
        (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z'
      );
    };
}());


/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XFilter(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XFilter.prototype['@@transducer/init'] = _xfBase.init;
  XFilter.prototype['@@transducer/result'] = _xfBase.result;
  XFilter.prototype['@@transducer/step'] = function(result, input) {
    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
  };

  return _curry2(function _xfilter(f, xf) { return new XFilter(f, xf); });
}());


/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _curry1 = __webpack_require__(4);
var map = __webpack_require__(16);
var max = __webpack_require__(50);
var reduce = __webpack_require__(33);


/**
 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
 * to `fn` are applied to each of the predicates in turn until one returns a
 * "truthy" value, at which point `fn` returns the result of applying its
 * arguments to the corresponding transformer. If none of the predicates
 * matches, `fn` returns undefined.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Logic
 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
 * @param {Array} pairs A list of [predicate, transformer]
 * @return {Function}
 * @example
 *
 *      var fn = R.cond([
 *        [R.equals(0),   R.always('water freezes at 0°C')],
 *        [R.equals(100), R.always('water boils at 100°C')],
 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
 *      ]);
 *      fn(0); //=> 'water freezes at 0°C'
 *      fn(50); //=> 'nothing special happens at 50°C'
 *      fn(100); //=> 'water boils at 100°C'
 */
module.exports = _curry1(function cond(pairs) {
  var arity = reduce(max,
                     0,
                     map(function(pair) { return pair[0].length; }, pairs));
  return _arity(arity, function() {
    var idx = 0;
    while (idx < pairs.length) {
      if (pairs[idx][0].apply(this, arguments)) {
        return pairs[idx][1].apply(this, arguments);
      }
      idx += 1;
    }
  });
});


/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var constructN = __webpack_require__(169);


/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> {*}) -> (* -> {*})
 * @param {Function} fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @see R.invoker
 * @example
 *
 *      // Constructor function
 *      function Animal(kind) {
 *        this.kind = kind;
 *      };
 *      Animal.prototype.sighting = function() {
 *        return "It's a " + this.kind + "!";
 *      }
 *
 *      var AnimalConstructor = R.construct(Animal)
 *
 *      // Notice we no longer need the 'new' keyword:
 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
 *
 *      var animalTypes = ["Lion", "Tiger", "Bear"];
 *      var animalSighting = R.invoker(0, 'sighting');
 *      var sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
 */
module.exports = _curry1(function construct(Fn) {
  return constructN(Fn.length, Fn);
});


/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(46);
var _curry2 = __webpack_require__(1);


/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.any
 * @example
 *
 *      R.contains(3, [1, 2, 3]); //=> true
 *      R.contains(4, [1, 2, 3]); //=> false
 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.contains([42], [[42]]); //=> true
 */
module.exports = _curry2(_contains);


/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

var reduceBy = __webpack_require__(82);


/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      var numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      var letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */
module.exports = reduceBy(function(acc, elem) { return acc + 1; }, 0);


/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

var _curryN = __webpack_require__(72);
var _has = __webpack_require__(14);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XReduceBy(valueFn, valueAcc, keyFn, xf) {
    this.valueFn = valueFn;
    this.valueAcc = valueAcc;
    this.keyFn = keyFn;
    this.xf = xf;
    this.inputs = {};
  }
  XReduceBy.prototype['@@transducer/init'] = _xfBase.init;
  XReduceBy.prototype['@@transducer/result'] = function(result) {
    var key;
    for (key in this.inputs) {
      if (_has(key, this.inputs)) {
        result = this.xf['@@transducer/step'](result, this.inputs[key]);
        if (result['@@transducer/reduced']) {
          result = result['@@transducer/value'];
          break;
        }
      }
    }
    this.inputs = null;
    return this.xf['@@transducer/result'](result);
  };
  XReduceBy.prototype['@@transducer/step'] = function(result, input) {
    var key = this.keyFn(input);
    this.inputs[key] = this.inputs[key] || [key, this.valueAcc];
    this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
    return result;
  };

  return _curryN(4, [],
                 function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
                   return new XReduceBy(valueFn, valueAcc, keyFn, xf);
                 });
}());


/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

var add = __webpack_require__(71);


/**
 * Decrements its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n - 1
 * @see R.inc
 * @example
 *
 *      R.dec(42); //=> 41
 */
module.exports = add(-1);


/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Makes a descending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
 * @see R.ascend
 * @example
 *
 *      var byAge = R.descend(R.prop('age'));
 *      var people = [
 *        // ...
 *      ];
 *      var peopleByOldestFirst = R.sort(byAge, people);
 */
module.exports = _curry3(function descend(fn, a, b) {
  var aa = fn(a);
  var bb = fn(b);
  return aa > bb ? -1 : aa < bb ? 1 : 0;
});


/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _isInteger = __webpack_require__(98);
var assoc = __webpack_require__(75);
var dissoc = __webpack_require__(174);
var remove = __webpack_require__(175);
var update = __webpack_require__(107);


/**
 * Makes a shallow clone of an object, omitting the property at the given path.
 * Note that this copies and flattens prototype properties onto the new object
 * as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.11.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {k: v} -> {k: v}
 * @param {Array} path The path to the value to omit
 * @param {Object} obj The object to clone
 * @return {Object} A new object without the property at path
 * @see R.assocPath
 * @example
 *
 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
 */
module.exports = _curry2(function dissocPath(path, obj) {
  switch (path.length) {
    case 0:
      return obj;
    case 1:
      return _isInteger(path[0]) ? remove(path[0], 1, obj) : dissoc(path[0], obj);
    default:
      var head = path[0];
      var tail = Array.prototype.slice.call(path, 1);
      if (obj[head] == null) {
        return obj;
      } else if (_isInteger(path[0])) {
        return update(head, dissocPath(tail, obj[head]), obj);
      } else {
        return assoc(head, dissocPath(tail, obj[head]), obj);
      }
  }
});


/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Divides two numbers. Equivalent to `a / b`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a / b`.
 * @see R.multiply
 * @example
 *
 *      R.divide(71, 100); //=> 0.71
 *
 *      var half = R.divide(R.__, 2);
 *      half(42); //=> 21
 *
 *      var reciprocal = R.divide(1);
 *      reciprocal(4);   //=> 0.25
 */
module.exports = _curry2(function divide(a, b) { return a / b; });


/***/ }),

/***/ 31:
/***/ (function(module, exports) {

module.exports = function _arity(n, fn) {
  /* eslint-disable no-unused-vars */
  switch (n) {
    case 0: return function() { return fn.apply(this, arguments); };
    case 1: return function(a0) { return fn.apply(this, arguments); };
    case 2: return function(a0, a1) { return fn.apply(this, arguments); };
    case 3: return function(a0, a1, a2) { return fn.apply(this, arguments); };
    case 4: return function(a0, a1, a2, a3) { return fn.apply(this, arguments); };
    case 5: return function(a0, a1, a2, a3, a4) { return fn.apply(this, arguments); };
    case 6: return function(a0, a1, a2, a3, a4, a5) { return fn.apply(this, arguments); };
    case 7: return function(a0, a1, a2, a3, a4, a5, a6) { return fn.apply(this, arguments); };
    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) { return fn.apply(this, arguments); };
    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) { return fn.apply(this, arguments); };
    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) { return fn.apply(this, arguments); };
    default: throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
  }
};


/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XDrop(n, xf) {
    this.xf = xf;
    this.n = n;
  }
  XDrop.prototype['@@transducer/init'] = _xfBase.init;
  XDrop.prototype['@@transducer/result'] = _xfBase.result;
  XDrop.prototype['@@transducer/step'] = function(result, input) {
    if (this.n > 0) {
      this.n -= 1;
      return result;
    }
    return this.xf['@@transducer/step'](result, input);
  };

  return _curry2(function _xdrop(n, xf) { return new XDrop(n, xf); });
}());


/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _dropLast = __webpack_require__(312);
var _xdropLast = __webpack_require__(314);


/**
 * Returns a list containing all but the last `n` elements of the given `list`.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements of `list` to skip.
 * @param {Array} list The list of elements to consider.
 * @return {Array} A copy of the list with only the first `list.length - n` elements
 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
 * @example
 *
 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(3, 'ramda');               //=> 'ra'
 */
module.exports = _curry2(_dispatchable([], _xdropLast, _dropLast));


/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

var take = __webpack_require__(108);

module.exports = function dropLast(n, xs) {
  return take(n < xs.length ? xs.length - n : 0, xs);
};


/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _reduced = __webpack_require__(42);
var _xfBase = __webpack_require__(9);

module.exports = (function() {
  function XTake(n, xf) {
    this.xf = xf;
    this.n = n;
    this.i = 0;
  }
  XTake.prototype['@@transducer/init'] = _xfBase.init;
  XTake.prototype['@@transducer/result'] = _xfBase.result;
  XTake.prototype['@@transducer/step'] = function(result, input) {
    this.i += 1;
    var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
    return this.n >= 0 && this.i >= this.n ? _reduced(ret) : ret;
  };

  return _curry2(function _xtake(n, xf) { return new XTake(n, xf); });
}());


/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XDropLast(n, xf) {
    this.xf = xf;
    this.pos = 0;
    this.full = false;
    this.acc = new Array(n);
  }
  XDropLast.prototype['@@transducer/init'] = _xfBase.init;
  XDropLast.prototype['@@transducer/result'] =  function(result) {
    this.acc = null;
    return this.xf['@@transducer/result'](result);
  };
  XDropLast.prototype['@@transducer/step'] = function(result, input) {
    if (this.full) {
      result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
    }
    this.store(input);
    return result;
  };
  XDropLast.prototype.store = function(input) {
    this.acc[this.pos] = input;
    this.pos += 1;
    if (this.pos === this.acc.length) {
      this.pos = 0;
      this.full = true;
    }
  };

  return _curry2(function _xdropLast(n, xf) { return new XDropLast(n, xf); });
}());


/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _dropLastWhile = __webpack_require__(316);
var _xdropLastWhile = __webpack_require__(317);


/**
 * Returns a new list excluding all the tailing elements of a given list which
 * satisfy the supplied predicate function. It passes each value from the right
 * to the supplied predicate function, skipping elements until the predicate
 * function returns a `falsy` value. The predicate function is applied to one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @param {Function} predicate The function to be called on each element
 * @param {Array} list The collection to iterate over.
 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
 * @example
 *
 *      var lteThree = x => x <= 3;
 *
 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
 */
module.exports = _curry2(_dispatchable([], _xdropLastWhile, _dropLastWhile));


/***/ }),

/***/ 316:
/***/ (function(module, exports) {

module.exports = function dropLastWhile(pred, list) {
  var idx = list.length - 1;
  while (idx >= 0 && pred(list[idx])) {
    idx -= 1;
  }
  return Array.prototype.slice.call(list, 0, idx + 1);
};


/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _reduce = __webpack_require__(18);
var _xfBase = __webpack_require__(9);

module.exports = (function() {
  function XDropLastWhile(fn, xf) {
    this.f = fn;
    this.retained = [];
    this.xf = xf;
  }
  XDropLastWhile.prototype['@@transducer/init'] = _xfBase.init;
  XDropLastWhile.prototype['@@transducer/result'] = function(result) {
    this.retained = null;
    return this.xf['@@transducer/result'](result);
  };
  XDropLastWhile.prototype['@@transducer/step'] = function(result, input) {
    return this.f(input) ? this.retain(result, input)
                         : this.flush(result, input);
  };
  XDropLastWhile.prototype.flush = function(result, input) {
    result = _reduce(
      this.xf['@@transducer/step'],
      result,
      this.retained
    );
    this.retained = [];
    return this.xf['@@transducer/step'](result, input);
  };
  XDropLastWhile.prototype.retain = function(result, input) {
    this.retained.push(input);
    return result;
  };

  return _curry2(function _xdropLastWhile(fn, xf) { return new XDropLastWhile(fn, xf); });
}());


/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _dispatchable = __webpack_require__(7);
var _xdropRepeatsWith = __webpack_require__(177);
var dropRepeatsWith = __webpack_require__(178);
var equals = __webpack_require__(19);


/**
 * Returns a new list without any consecutively repeating elements.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
 */
module.exports = _curry1(_dispatchable([], _xdropRepeatsWith(equals), dropRepeatsWith(equals)));


/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xdropWhile = __webpack_require__(320);


/**
 * Returns a new list excluding the leading elements of a given list which
 * satisfy the supplied predicate function. It passes each value to the supplied
 * predicate function, skipping elements while the predicate function returns
 * `true`. The predicate function is applied to one argument: *(value)*.
 *
 * Dispatches to the `dropWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @param {Function} fn The function called per iteration.
 * @param {Array} list The collection to iterate over.
 * @return {Array} A new array.
 * @see R.takeWhile, R.transduce, R.addIndex
 * @example
 *
 *      var lteTwo = x => x <= 2;
 *
 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
 */
module.exports = _curry2(_dispatchable(['dropWhile'], _xdropWhile, function dropWhile(pred, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len && pred(list[idx])) {
    idx += 1;
  }
  return Array.prototype.slice.call(list, idx);
}));


/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _has = __webpack_require__(14);
var _isArguments = __webpack_require__(150);


/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */
module.exports = (function() {
  // cover IE < 9 keys issues
  var hasEnumBug = !({toString: null}).propertyIsEnumerable('toString');
  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString',
                            'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
  // Safari bug
  var hasArgsEnumBug = (function() {
    'use strict';
    return arguments.propertyIsEnumerable('length');
  }());

  var contains = function contains(list, item) {
    var idx = 0;
    while (idx < list.length) {
      if (list[idx] === item) {
        return true;
      }
      idx += 1;
    }
    return false;
  };

  return typeof Object.keys === 'function' && !hasArgsEnumBug ?
    _curry1(function keys(obj) {
      return Object(obj) !== obj ? [] : Object.keys(obj);
    }) :
    _curry1(function keys(obj) {
      if (Object(obj) !== obj) {
        return [];
      }
      var prop, nIdx;
      var ks = [];
      var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
      for (prop in obj) {
        if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
          ks[ks.length] = prop;
        }
      }
      if (hasEnumBug) {
        nIdx = nonEnumerableProps.length - 1;
        while (nIdx >= 0) {
          prop = nonEnumerableProps[nIdx];
          if (_has(prop, obj) && !contains(ks, prop)) {
            ks[ks.length] = prop;
          }
          nIdx -= 1;
        }
      }
      return ks;
    });
}());


/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XDropWhile(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XDropWhile.prototype['@@transducer/init'] = _xfBase.init;
  XDropWhile.prototype['@@transducer/result'] = _xfBase.result;
  XDropWhile.prototype['@@transducer/step'] = function(result, input) {
    if (this.f) {
      if (this.f(input)) {
        return result;
      }
      this.f = null;
    }
    return this.xf['@@transducer/step'](result, input);
  };

  return _curry2(function _xdropWhile(f, xf) { return new XDropWhile(f, xf); });
}());


/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _isFunction = __webpack_require__(77);
var lift = __webpack_require__(78);
var or = __webpack_require__(180);


/**
 * A function wrapping calls to the two functions in an `||` operation,
 * returning the result of the first function if it is truth-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * truth-y value.
 *
 * In addition to functions, `R.either` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f a predicate
 * @param {Function} g another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
 * @see R.or
 * @example
 *
 *      var gt10 = x => x > 10;
 *      var even = x => x % 2 === 0;
 *      var f = R.either(gt10, even);
 *      f(101); //=> true
 *      f(8); //=> true
 */
module.exports = _curry2(function either(f, g) {
  return _isFunction(f) ?
    function _either() {
      return f.apply(this, arguments) || g.apply(this, arguments);
    } :
    lift(or)(f, g);
});


/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var equals = __webpack_require__(19);
var takeLast = __webpack_require__(182);

/**
 * Checks if a list ends with the provided values
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> Boolean
 * @sig String -> Boolean
 * @param {*} suffix
 * @param {*} list
 * @return {Boolean}
 * @example
 *
 *      R.endsWith('c', 'abc')                //=> true
 *      R.endsWith('b', 'abc')                //=> false
 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
 */
module.exports = _curry2(function(suffix, list) {
  return equals(takeLast(suffix.length, list), suffix);
});


/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var equals = __webpack_require__(19);


/**
 * Takes a function and two values in its domain and returns `true` if the
 * values map to the same value in the codomain; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Relation
 * @sig (a -> b) -> a -> a -> Boolean
 * @param {Function} f
 * @param {*} x
 * @param {*} y
 * @return {Boolean}
 * @example
 *
 *      R.eqBy(Math.abs, 5, -5); //=> true
 */
module.exports = _curry3(function eqBy(f, x, y) {
  return equals(f(x), f(y));
});


/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var equals = __webpack_require__(19);


/**
 * Reports whether two objects have the same value, in [`R.equals`](#equals)
 * terms, for the specified property. Useful as a curried predicate.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig k -> {k: v} -> {k: v} -> Boolean
 * @param {String} prop The name of the property to compare
 * @param {Object} obj1
 * @param {Object} obj2
 * @return {Boolean}
 *
 * @example
 *
 *      var o1 = { a: 1, b: 2, c: 3, d: 4 };
 *      var o2 = { a: 10, b: 20, c: 3, d: 40 };
 *      R.eqProps('a', o1, o2); //=> false
 *      R.eqProps('c', o1, o2); //=> true
 */
module.exports = _curry3(function eqProps(prop, obj1, obj2) {
  return equals(obj1[prop], obj2[prop]);
});


/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Creates a new object by recursively evolving a shallow copy of `object`,
 * according to the `transformation` functions. All non-primitive properties
 * are copied by reference.
 *
 * A `transformation` function will not be invoked if its corresponding key
 * does not exist in the evolved object.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
 * @param {Object} transformations The object specifying transformation functions to apply
 *        to the object.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      var tomato  = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
 *      var transformations = {
 *        firstName: R.trim,
 *        lastName: R.trim, // Will not get invoked.
 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
 *      };
 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
 */
module.exports = _curry2(function evolve(transformations, object) {
  var result = {};
  var transformation, key, type;
  for (key in object) {
    transformation = transformations[key];
    type = typeof transformation;
    result[key] = type === 'function'                 ? transformation(object[key])
                : transformation && type === 'object' ? evolve(transformation, object[key])
                                                      : object[key];
  }
  return result;
});


/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xfind = __webpack_require__(327);


/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */
module.exports = _curry2(_dispatchable(['find'], _xfind, function find(fn, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (fn(list[idx])) {
      return list[idx];
    }
    idx += 1;
  }
}));


/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _reduced = __webpack_require__(42);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XFind(f, xf) {
    this.xf = xf;
    this.f = f;
    this.found = false;
  }
  XFind.prototype['@@transducer/init'] = _xfBase.init;
  XFind.prototype['@@transducer/result'] = function(result) {
    if (!this.found) {
      result = this.xf['@@transducer/step'](result, void 0);
    }
    return this.xf['@@transducer/result'](result);
  };
  XFind.prototype['@@transducer/step'] = function(result, input) {
    if (this.f(input)) {
      this.found = true;
      result = _reduced(this.xf['@@transducer/step'](result, input));
    }
    return result;
  };

  return _curry2(function _xfind(f, xf) { return new XFind(f, xf); });
}());


/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xfindIndex = __webpack_require__(329);


/**
 * Returns the index of the first element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
 */
module.exports = _curry2(_dispatchable([], _xfindIndex, function findIndex(fn, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (fn(list[idx])) {
      return idx;
    }
    idx += 1;
  }
  return -1;
}));


/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _reduced = __webpack_require__(42);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XFindIndex(f, xf) {
    this.xf = xf;
    this.f = f;
    this.idx = -1;
    this.found = false;
  }
  XFindIndex.prototype['@@transducer/init'] = _xfBase.init;
  XFindIndex.prototype['@@transducer/result'] = function(result) {
    if (!this.found) {
      result = this.xf['@@transducer/step'](result, -1);
    }
    return this.xf['@@transducer/result'](result);
  };
  XFindIndex.prototype['@@transducer/step'] = function(result, input) {
    this.idx += 1;
    if (this.f(input)) {
      this.found = true;
      result = _reduced(this.xf['@@transducer/step'](result, this.idx));
    }
    return result;
  };

  return _curry2(function _xfindIndex(f, xf) { return new XFindIndex(f, xf); });
}());


/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var _reduce = __webpack_require__(18);


/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *                -               -10
 *               / \              / \
 *              -   4           -6   4
 *             / \              / \
 *            -   3   ==>     -3   3
 *           / \              / \
 *          -   2           -1   2
 *         / \              / \
 *        0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */
module.exports = _curry3(_reduce);


/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xfindLast = __webpack_require__(331);


/**
 * Returns the last element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
 */
module.exports = _curry2(_dispatchable([], _xfindLast, function findLast(fn, list) {
  var idx = list.length - 1;
  while (idx >= 0) {
    if (fn(list[idx])) {
      return list[idx];
    }
    idx -= 1;
  }
}));


/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XFindLast(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XFindLast.prototype['@@transducer/init'] = _xfBase.init;
  XFindLast.prototype['@@transducer/result'] = function(result) {
    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
  };
  XFindLast.prototype['@@transducer/step'] = function(result, input) {
    if (this.f(input)) {
      this.last = input;
    }
    return result;
  };

  return _curry2(function _xfindLast(f, xf) { return new XFindLast(f, xf); });
}());


/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xfindLastIndex = __webpack_require__(333);


/**
 * Returns the index of the last element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
 */
module.exports = _curry2(_dispatchable([], _xfindLastIndex, function findLastIndex(fn, list) {
  var idx = list.length - 1;
  while (idx >= 0) {
    if (fn(list[idx])) {
      return idx;
    }
    idx -= 1;
  }
  return -1;
}));


/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XFindLastIndex(f, xf) {
    this.xf = xf;
    this.f = f;
    this.idx = -1;
    this.lastIdx = -1;
  }
  XFindLastIndex.prototype['@@transducer/init'] = _xfBase.init;
  XFindLastIndex.prototype['@@transducer/result'] = function(result) {
    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.lastIdx));
  };
  XFindLastIndex.prototype['@@transducer/step'] = function(result, input) {
    this.idx += 1;
    if (this.f(input)) {
      this.lastIdx = this.idx;
    }
    return result;
  };

  return _curry2(function _xfindLastIndex(f, xf) { return new XFindLastIndex(f, xf); });
}());


/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _makeFlat = __webpack_require__(159);


/**
 * Returns a new list by pulling every item out of it (and all its sub-arrays)
 * and putting them in a new array, depth-first.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b]
 * @param {Array} list The array to consider.
 * @return {Array} The flattened list.
 * @see R.unnest
 * @example
 *
 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
 */
module.exports = _curry1(_makeFlat(true));


/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

var _checkForMethod = __webpack_require__(59);
var _curry2 = __webpack_require__(1);


/**
 * Iterate over an input `list`, calling a provided function `fn` for each
 * element in the list.
 *
 * `fn` receives one argument: *(value)*.
 *
 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.forEach` method. For more
 * details on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
 *
 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
 * the original array. In some libraries this function is named `each`.
 *
 * Dispatches to the `forEach` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> *) -> [a] -> [a]
 * @param {Function} fn The function to invoke. Receives one argument, `value`.
 * @param {Array} list The list to iterate over.
 * @return {Array} The original list.
 * @see R.addIndex
 * @example
 *
 *      var printXPlusFive = x => console.log(x + 5);
 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
 *      // logs 6
 *      // logs 7
 *      // logs 8
 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
 */
module.exports = _curry2(_checkForMethod('forEach', function forEach(fn, list) {
  var len = list.length;
  var idx = 0;
  while (idx < len) {
    fn(list[idx]);
    idx += 1;
  }
  return list;
}));


/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var keys = __webpack_require__(32);


/**
 * Iterate over an input `object`, calling a provided function `fn` for each
 * key and value in the object.
 *
 * `fn` receives three argument: *(value, key, obj)*.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Object
 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
 * @param {Object} obj The object to iterate over.
 * @return {Object} The original object.
 * @example
 *
 *      var printKeyConcatValue = (value, key) => console.log(key + ':' + value);
 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
 *      // logs x:1
 *      // logs y:2
 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
 */
module.exports = _curry2(function forEachObjIndexed(fn, obj) {
  var keyList = keys(obj);
  var idx = 0;
  while (idx < keyList.length) {
    var key = keyList[idx];
    fn(obj[key], key, obj);
    idx += 1;
  }
  return obj;
});


/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Creates a new object from a list key-value pairs. If a key appears in
 * multiple pairs, the rightmost pair is included in the object.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [[k,v]] -> {k: v}
 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
 * @return {Object} The object made by pairing up `keys` and `values`.
 * @see R.toPairs, R.pair
 * @example
 *
 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
 */
module.exports = _curry1(function fromPairs(pairs) {
  var result = {};
  var idx = 0;
  while (idx < pairs.length) {
    result[pairs[idx][0]] = pairs[idx][1];
    idx += 1;
  }
  return result;
});


/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

var _checkForMethod = __webpack_require__(59);
var _curry2 = __webpack_require__(1);
var reduceBy = __webpack_require__(82);

/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a String-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> String) -> [a] -> {String: [a]}
 * @param {Function} fn Function :: a -> String
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.transduce
 * @example
 *
 *      var byGrade = R.groupBy(function(student) {
 *        var score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      var students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */
module.exports = _curry2(_checkForMethod('groupBy', reduceBy(function(acc, item) {
  if (acc == null) {
    acc = [];
  }
  acc.push(item);
  return acc;
}, null)));


/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);

/**
 * Takes a list and returns a list of lists where each sublist's elements are
 * all satisfied pairwise comparison according to the provided function.
 * Only adjacent elements are passed to the comparison function.
 *
 * @func
 * @memberOf R
 * @since v0.21.0
 * @category List
 * @sig ((a, a) → Boolean) → [a] → [[a]]
 * @param {Function} fn Function for determining whether two given (adjacent)
 *        elements should be in the same group
 * @param {Array} list The array to group. Also accepts a string, which will be
 *        treated as a list of characters.
 * @return {List} A list that contains sublists of elements,
 *         whose concatenations are equal to the original list.
 * @example
 *
 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a + 1 === b, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0, 1], [1, 2, 3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
 *
 * R.groupWith(R.eqBy(isVowel), 'aestiou')
 * //=> ['ae', 'st', 'iou']
 */
module.exports = _curry2(function(fn, list) {
  var res = [];
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    var nextidx = idx + 1;
    while (nextidx < len && fn(list[nextidx - 1], list[nextidx])) {
      nextidx += 1;
    }
    res.push(list.slice(idx, nextidx));
    idx = nextidx;
  }
  return res;
});


/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns `true` if the first argument is greater than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.lt
 * @example
 *
 *      R.gt(2, 1); //=> true
 *      R.gt(2, 2); //=> false
 *      R.gt(2, 3); //=> false
 *      R.gt('a', 'z'); //=> false
 *      R.gt('z', 'a'); //=> true
 */
module.exports = _curry2(function gt(a, b) { return a > b; });


/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns `true` if the first argument is greater than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.lte
 * @example
 *
 *      R.gte(2, 1); //=> true
 *      R.gte(2, 2); //=> true
 *      R.gte(2, 3); //=> false
 *      R.gte('a', 'z'); //=> false
 *      R.gte('z', 'a'); //=> true
 */
module.exports = _curry2(function gte(a, b) { return a >= b; });


/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _has = __webpack_require__(14);


/**
 * Returns whether or not an object has an own property with the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      var hasName = R.has('name');
 *      hasName({name: 'alice'});   //=> true
 *      hasName({name: 'bob'});     //=> true
 *      hasName({});                //=> false
 *
 *      var point = {x: 0, y: 0};
 *      var pointHas = R.has(R.__, point);
 *      pointHas('x');  //=> true
 *      pointHas('y');  //=> true
 *      pointHas('z');  //=> false
 */
module.exports = _curry2(_has);


/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns whether or not an object or its prototype chain has a property with
 * the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      function Rectangle(width, height) {
 *        this.width = width;
 *        this.height = height;
 *      }
 *      Rectangle.prototype.area = function() {
 *        return this.width * this.height;
 *      };
 *
 *      var square = new Rectangle(2, 2);
 *      R.hasIn('width', square);  //=> true
 *      R.hasIn('area', square);  //=> true
 */
module.exports = _curry2(function hasIn(prop, obj) {
  return prop in obj;
});


/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

var nth = __webpack_require__(61);


/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> ''
 */
module.exports = nth(0);


/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var curryN = __webpack_require__(13);


/**
 * Creates a function that will process either the `onTrue` or the `onFalse`
 * function depending upon the result of the `condition` predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
 * @param {Function} condition A predicate function
 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
 * @return {Function} A new unary function that will process either the `onTrue` or the `onFalse`
 *                    function depending upon the result of the `condition` predicate.
 * @see R.unless, R.when
 * @example
 *
 *      var incCount = R.ifElse(
 *        R.has('count'),
 *        R.over(R.lensProp('count'), R.inc),
 *        R.assoc('count', 1)
 *      );
 *      incCount({});           //=> { count: 1 }
 *      incCount({ count: 1 }); //=> { count: 2 }
 */
module.exports = _curry3(function ifElse(condition, onTrue, onFalse) {
  return curryN(Math.max(condition.length, onTrue.length, onFalse.length),
    function _ifElse() {
      return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
    }
  );
});


/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

var add = __webpack_require__(71);


/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */
module.exports = add(1);


/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

var reduceBy = __webpack_require__(82);


/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
 * @param {Function} fn Function :: a -> String
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @example
 *
 *      var list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */
module.exports = reduceBy(function(acc, elem) { return elem; }, null);


/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _indexOf = __webpack_require__(166);
var _isArray = __webpack_require__(41);


/**
 * Returns the position of the first occurrence of an item in an array, or -1
 * if the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.lastIndexOf
 * @example
 *
 *      R.indexOf(3, [1,2,3,4]); //=> 2
 *      R.indexOf(10, [1,2,3,4]); //=> -1
 */
module.exports = _curry2(function indexOf(target, xs) {
  return typeof xs.indexOf === 'function' && !_isArray(xs) ?
    xs.indexOf(target) :
    _indexOf(xs, target, 0);
});


/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

var slice = __webpack_require__(45);


/**
 * Returns all but the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.last, R.head, R.tail
 * @example
 *
 *      R.init([1, 2, 3]);  //=> [1, 2]
 *      R.init([1, 2]);     //=> [1]
 *      R.init([1]);        //=> []
 *      R.init([]);         //=> []
 *
 *      R.init('abc');  //=> 'ab'
 *      R.init('ab');   //=> 'a'
 *      R.init('a');    //=> ''
 *      R.init('');     //=> ''
 */
module.exports = slice(0, -1);


/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var support = __webpack_require__(117);
var base64 = __webpack_require__(589);
var nodejsUtils = __webpack_require__(238);
var setImmediate = __webpack_require__(921);
var external = __webpack_require__(218);


/**
 * Convert a string that pass as a "binary string": it should represent a byte
 * array but may have > 255 char codes. Be sure to take only the first byte
 * and returns the byte array.
 * @param {String} str the string to transform.
 * @return {Array|Uint8Array} the string in a binary format.
 */
function string2binary(str) {
    var result = null;
    if (support.uint8array) {
      result = new Uint8Array(str.length);
    } else {
      result = new Array(str.length);
    }
    return stringToArrayLike(str, result);
}

/**
 * Create a new blob with the given content and the given type.
 * @param {Array[String|ArrayBuffer]} parts the content to put in the blob. DO NOT use
 * an Uint8Array because the stock browser of android 4 won't accept it (it
 * will be silently converted to a string, "[object Uint8Array]").
 * @param {String} type the mime type of the blob.
 * @return {Blob} the created blob.
 */
exports.newBlob = function(parts, type) {
    exports.checkSupport("blob");

    try {
        // Blob constructor
        return new Blob(parts, {
            type: type
        });
    }
    catch (e) {

        try {
            // deprecated, browser only, old way
            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
            var builder = new Builder();
            for (var i = 0; i < parts.length; i++) {
                builder.append(parts[i]);
            }
            return builder.getBlob(type);
        }
        catch (e) {

            // well, fuck ?!
            throw new Error("Bug : can't construct the Blob.");
        }
    }


};
/**
 * The identity function.
 * @param {Object} input the input.
 * @return {Object} the same input.
 */
function identity(input) {
    return input;
}

/**
 * Fill in an array with a string.
 * @param {String} str the string to use.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
 */
function stringToArrayLike(str, array) {
    for (var i = 0; i < str.length; ++i) {
        array[i] = str.charCodeAt(i) & 0xFF;
    }
    return array;
}

/**
 * An helper for the function arrayLikeToString.
 * This contains static informations and functions that
 * can be optimized by the browser JIT compiler.
 */
var arrayToStringHelper = {
    /**
     * Transform an array of int into a string, chunk by chunk.
     * See the performances notes on arrayLikeToString.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @param {String} type the type of the array.
     * @param {Integer} chunk the chunk size.
     * @return {String} the resulting string.
     * @throws Error if the chunk is too big for the stack.
     */
    stringifyByChunk: function(array, type, chunk) {
        var result = [], k = 0, len = array.length;
        // shortcut
        if (len <= chunk) {
            return String.fromCharCode.apply(null, array);
        }
        while (k < len) {
            if (type === "array" || type === "nodebuffer") {
                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
            }
            else {
                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
            }
            k += chunk;
        }
        return result.join("");
    },
    /**
     * Call String.fromCharCode on every item in the array.
     * This is the naive implementation, which generate A LOT of intermediate string.
     * This should be used when everything else fail.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @return {String} the result.
     */
    stringifyByChar: function(array){
        var resultStr = "";
        for(var i = 0; i < array.length; i++) {
            resultStr += String.fromCharCode(array[i]);
        }
        return resultStr;
    },
    applyCanBeUsed : {
        /**
         * true if the browser accepts to use String.fromCharCode on Uint8Array
         */
        uint8array : (function () {
            try {
                return support.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
            } catch (e) {
                return false;
            }
        })(),
        /**
         * true if the browser accepts to use String.fromCharCode on nodejs Buffer.
         */
        nodebuffer : (function () {
            try {
                return support.nodebuffer && String.fromCharCode.apply(null, nodejsUtils.newBuffer(1)).length === 1;
            } catch (e) {
                return false;
            }
        })()
    }
};

/**
 * Transform an array-like object to a string.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
 * @return {String} the result.
 */
function arrayLikeToString(array) {
    // Performances notes :
    // --------------------
    // String.fromCharCode.apply(null, array) is the fastest, see
    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
    // but the stack is limited (and we can get huge arrays !).
    //
    // result += String.fromCharCode(array[i]); generate too many strings !
    //
    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
    // TODO : we now have workers that split the work. Do we still need that ?
    var chunk = 65536,
        type = exports.getTypeOf(array),
        canUseApply = true;
    if (type === "uint8array") {
        canUseApply = arrayToStringHelper.applyCanBeUsed.uint8array;
    } else if (type === "nodebuffer") {
        canUseApply = arrayToStringHelper.applyCanBeUsed.nodebuffer;
    }

    if (canUseApply) {
        while (chunk > 1) {
            try {
                return arrayToStringHelper.stringifyByChunk(array, type, chunk);
            } catch (e) {
                chunk = Math.floor(chunk / 2);
            }
        }
    }

    // no apply or chunk error : slow and painful algorithm
    // default browser on android 4.*
    return arrayToStringHelper.stringifyByChar(array);
}

exports.applyFromCharCode = arrayLikeToString;


/**
 * Copy the data from an array-like to an other array-like.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
 */
function arrayLikeToArrayLike(arrayFrom, arrayTo) {
    for (var i = 0; i < arrayFrom.length; i++) {
        arrayTo[i] = arrayFrom[i];
    }
    return arrayTo;
}

// a matrix containing functions to transform everything into everything.
var transform = {};

// string to ?
transform["string"] = {
    "string": identity,
    "array": function(input) {
        return stringToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["string"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return stringToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": function(input) {
        return stringToArrayLike(input, nodejsUtils.newBuffer(input.length));
    }
};

// array to ?
transform["array"] = {
    "string": arrayLikeToString,
    "array": identity,
    "arraybuffer": function(input) {
        return (new Uint8Array(input)).buffer;
    },
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodejsUtils.newBuffer(input);
    }
};

// arraybuffer to ?
transform["arraybuffer"] = {
    "string": function(input) {
        return arrayLikeToString(new Uint8Array(input));
    },
    "array": function(input) {
        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
    },
    "arraybuffer": identity,
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodejsUtils.newBuffer(new Uint8Array(input));
    }
};

// uint8array to ?
transform["uint8array"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        // copy the uint8array: DO NOT propagate the original ArrayBuffer, it
        // can be way larger (the whole zip file for example).
        var copy = new Uint8Array(input.length);
        if (input.length) {
            copy.set(input, 0);
        }
        return copy.buffer;
    },
    "uint8array": identity,
    "nodebuffer": function(input) {
        return nodejsUtils.newBuffer(input);
    }
};

// nodebuffer to ?
transform["nodebuffer"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["nodebuffer"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": identity
};

/**
 * Transform an input into any type.
 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
 * If no output type is specified, the unmodified input will be returned.
 * @param {String} outputType the output type.
 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
 * @throws {Error} an Error if the browser doesn't support the requested output type.
 */
exports.transformTo = function(outputType, input) {
    if (!input) {
        // undefined, null, etc
        // an empty string won't harm.
        input = "";
    }
    if (!outputType) {
        return input;
    }
    exports.checkSupport(outputType);
    var inputType = exports.getTypeOf(input);
    var result = transform[inputType][outputType](input);
    return result;
};

/**
 * Return the type of the input.
 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
 * @param {Object} input the input to identify.
 * @return {String} the (lowercase) type of the input.
 */
exports.getTypeOf = function(input) {
    if (typeof input === "string") {
        return "string";
    }
    if (Object.prototype.toString.call(input) === "[object Array]") {
        return "array";
    }
    if (support.nodebuffer && nodejsUtils.isBuffer(input)) {
        return "nodebuffer";
    }
    if (support.uint8array && input instanceof Uint8Array) {
        return "uint8array";
    }
    if (support.arraybuffer && input instanceof ArrayBuffer) {
        return "arraybuffer";
    }
};

/**
 * Throw an exception if the type is not supported.
 * @param {String} type the type to check.
 * @throws {Error} an Error if the browser doesn't support the requested type.
 */
exports.checkSupport = function(type) {
    var supported = support[type.toLowerCase()];
    if (!supported) {
        throw new Error(type + " is not supported by this platform");
    }
};

exports.MAX_VALUE_16BITS = 65535;
exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1

/**
 * Prettify a string read as binary.
 * @param {string} str the string to prettify.
 * @return {string} a pretty string.
 */
exports.pretty = function(str) {
    var res = '',
        code, i;
    for (i = 0; i < (str || "").length; i++) {
        code = str.charCodeAt(i);
        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
    }
    return res;
};

/**
 * Defer the call of a function.
 * @param {Function} callback the function to call asynchronously.
 * @param {Array} args the arguments to give to the callback.
 */
exports.delay = function(callback, args, self) {
    setImmediate(function () {
        callback.apply(self || null, args || []);
    });
};

/**
 * Extends a prototype with an other, without calling a constructor with
 * side effects. Inspired by nodejs' `utils.inherits`
 * @param {Function} ctor the constructor to augment
 * @param {Function} superCtor the parent constructor to use
 */
exports.inherits = function (ctor, superCtor) {
    var Obj = function() {};
    Obj.prototype = superCtor.prototype;
    ctor.prototype = new Obj();
};

/**
 * Merge the objects passed as parameters into a new one.
 * @private
 * @param {...Object} var_args All objects to merge.
 * @return {Object} a new object with the data of the others.
 */
exports.extend = function() {
    var result = {}, i, attr;
    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
        for (attr in arguments[i]) {
            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
                result[attr] = arguments[i][attr];
            }
        }
    }
    return result;
};

/**
 * Transform arbitrary content into a Promise.
 * @param {String} name a name for the content being processed.
 * @param {Object} inputData the content to process.
 * @param {Boolean} isBinary true if the content is not an unicode string
 * @param {Boolean} isOptimizedBinaryString true if the string content only has one byte per character.
 * @param {Boolean} isBase64 true if the string content is encoded with base64.
 * @return {Promise} a promise in a format usable by JSZip.
 */
exports.prepareContent = function(name, inputData, isBinary, isOptimizedBinaryString, isBase64) {

    // if inputData is already a promise, this flatten it.
    var promise = external.Promise.resolve(inputData).then(function(data) {
        
        
        var isBlob = support.blob && (data instanceof Blob || ['[object File]', '[object Blob]'].indexOf(Object.prototype.toString.call(data)) !== -1);

        if (isBlob && typeof FileReader !== "undefined") {
            return new external.Promise(function (resolve, reject) {
                var reader = new FileReader();

                reader.onload = function(e) {
                    resolve(e.target.result);
                };
                reader.onerror = function(e) {
                    reject(e.target.error);
                };
                reader.readAsArrayBuffer(data);
            });
        } else {
            return data;
        }
    });

    return promise.then(function(data) {
        var dataType = exports.getTypeOf(data);

        if (!dataType) {
            return external.Promise.reject(
                new Error("The data of '" + name + "' is in an unsupported format !")
            );
        }
        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
        if (dataType === "arraybuffer") {
            data = exports.transformTo("uint8array", data);
        } else if (dataType === "string") {
            if (isBase64) {
                data = base64.decode(data);
            }
            else if (isBinary) {
                // optimizedBinaryString === true means that the file has already been filtered with a 0xFF mask
                if (isOptimizedBinaryString !== true) {
                    // this is a string, not in a base64 format.
                    // Be sure that this is a correct "binary string"
                    data = string2binary(data);
                }
            }
        }
        return data;
    });
};


/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

var _containsWith = __webpack_require__(83);
var _curry3 = __webpack_require__(5);
var _filter = __webpack_require__(105);


/**
 * Takes a predicate `pred`, a list `xs`, and a list `ys`, and returns a list
 * `xs'` comprising each of the elements of `xs` which is equal to one or more
 * elements of `ys` according to `pred`.
 *
 * `pred` must be a binary function expecting an element from each list.
 *
 * `xs`, `ys`, and `xs'` are treated as sets, semantically, so ordering should
 * not be significant, but since `xs'` is ordered the implementation guarantees
 * that its values are in the same order as they appear in `xs`. Duplicates are
 * not removed, so `xs'` may contain duplicates if `xs` contains duplicates.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Relation
 * @sig (a -> b -> Boolean) -> [a] -> [b] -> [a]
 * @param {Function} pred
 * @param {Array} xs
 * @param {Array} ys
 * @return {Array}
 * @see R.intersection
 * @example
 *
 *      R.innerJoin(
 *        (record, id) => record.id === id,
 *        [{id: 824, name: 'Richie Furay'},
 *         {id: 956, name: 'Dewey Martin'},
 *         {id: 313, name: 'Bruce Palmer'},
 *         {id: 456, name: 'Stephen Stills'},
 *         {id: 177, name: 'Neil Young'}],
 *        [177, 456, 999]
 *      );
 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
 */
module.exports = _curry3(function innerJoin(pred, xs, ys) {
  return _filter(function(x) { return _containsWith(pred, x, ys); }, xs);
});


/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Inserts the supplied element into the list, at the specified `index`. _Note that

 * this is not destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} index The position to insert the element
 * @param {*} elt The element to insert into the Array
 * @param {Array} list The list to insert into
 * @return {Array} A new Array with `elt` inserted at `index`.
 * @example
 *
 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
 */
module.exports = _curry3(function insert(idx, elt, list) {
  idx = idx < list.length && idx >= 0 ? idx : list.length;
  var result = Array.prototype.slice.call(list, 0);
  result.splice(idx, 0, elt);
  return result;
});


/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
 * destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig Number -> [a] -> [a] -> [a]
 * @param {Number} index The position to insert the sub-list
 * @param {Array} elts The sub-list to insert into the Array
 * @param {Array} list The list to insert the sub-list into
 * @return {Array} A new Array with `elts` inserted starting at `index`.
 * @example
 *
 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
 */
module.exports = _curry3(function insertAll(idx, elts, list) {
  idx = idx < list.length && idx >= 0 ? idx : list.length;
  return [].concat(Array.prototype.slice.call(list, 0, idx),
                   elts,
                   Array.prototype.slice.call(list, idx));
});


/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(46);
var _curry2 = __webpack_require__(1);
var _filter = __webpack_require__(105);
var flip = __webpack_require__(84);
var uniq = __webpack_require__(111);


/**
 * Combines two lists into a set (i.e. no duplicates) composed of those
 * elements common to both lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The list of elements found in both `list1` and `list2`.
 * @see R.innerJoin
 * @example
 *
 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
 */
module.exports = _curry2(function intersection(list1, list2) {
  var lookupList, filteredList;
  if (list1.length > list2.length) {
    lookupList = list1;
    filteredList = list2;
  } else {
    lookupList = list2;
    filteredList = list1;
  }
  return uniq(_filter(flip(_contains)(lookupList), filteredList));
});


/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(46);


// A simple Set type that honours R.equals semantics
module.exports = (function() {
  function _Set() {
    /* globals Set */
    this._nativeSet = typeof Set === 'function' ? new Set() : null;
    this._items = {};
  }

  // until we figure out why jsdoc chokes on this
  // @param item The item to add to the Set
  // @returns {boolean} true if the item did not exist prior, otherwise false
  //
  _Set.prototype.add = function(item) {
    return !hasOrAdd(item, true, this);
  };

  //
  // @param item The item to check for existence in the Set
  // @returns {boolean} true if the item exists in the Set, otherwise false
  //
  _Set.prototype.has = function(item) {
    return hasOrAdd(item, false, this);
  };

  //
  // Combines the logic for checking whether an item is a member of the set and
  // for adding a new item to the set.
  //
  // @param item       The item to check or add to the Set instance.
  // @param shouldAdd  If true, the item will be added to the set if it doesn't
  //                   already exist.
  // @param set        The set instance to check or add to.
  // @return {boolean} true if the item already existed, otherwise false.
  //
  function hasOrAdd(item, shouldAdd, set) {
    var type = typeof item;
    var prevSize, newSize;
    switch (type) {
      case 'string':
      case 'number':
        // distinguish between +0 and -0
        if (item === 0 && 1 / item === -Infinity) {
          if (set._items['-0']) {
            return true;
          } else {
            if (shouldAdd) {
              set._items['-0'] = true;
            }
            return false;
          }
        }
        // these types can all utilise the native Set
        if (set._nativeSet !== null) {
          if (shouldAdd) {
            prevSize = set._nativeSet.size;
            set._nativeSet.add(item);
            newSize = set._nativeSet.size;
            return newSize === prevSize;
          } else {
            return set._nativeSet.has(item);
          }
        } else {
          if (!(type in set._items)) {
            if (shouldAdd) {
              set._items[type] = {};
              set._items[type][item] = true;
            }
            return false;
          } else if (item in set._items[type]) {
            return true;
          } else {
            if (shouldAdd) {
              set._items[type][item] = true;
            }
            return false;
          }
        }

      case 'boolean':
        // set._items['boolean'] holds a two element array
        // representing [ falseExists, trueExists ]
        if (type in set._items) {
          var bIdx = item ? 1 : 0;
          if (set._items[type][bIdx]) {
            return true;
          } else {
            if (shouldAdd) {
              set._items[type][bIdx] = true;
            }
            return false;
          }
        } else {
          if (shouldAdd) {
            set._items[type] = item ? [false, true] : [true, false];
          }
          return false;
        }

      case 'function':
        // compare functions for reference equality
        if (set._nativeSet !== null) {
          if (shouldAdd) {
            prevSize = set._nativeSet.size;
            set._nativeSet.add(item);
            newSize = set._nativeSet.size;
            return newSize === prevSize;
          } else {
            return set._nativeSet.has(item);
          }
        } else {
          if (!(type in set._items)) {
            if (shouldAdd) {
              set._items[type] = [item];
            }
            return false;
          }
          if (!_contains(item, set._items[type])) {
            if (shouldAdd) {
              set._items[type].push(item);
            }
            return false;
          }
          return true;
        }

      case 'undefined':
        if (set._items[type]) {
          return true;
        } else {
          if (shouldAdd) {
            set._items[type] = true;
          }
          return false;
        }

      case 'object':
        if (item === null) {
          if (!set._items['null']) {
            if (shouldAdd) {
              set._items['null'] = true;
            }
            return false;
          }
          return true;
        }
      /* falls through */
      default:
        // reduce the search size of heterogeneous sets by creating buckets
        // for each type.
        type = Object.prototype.toString.call(item);
        if (!(type in set._items)) {
          if (shouldAdd) {
            set._items[type] = [item];
          }
          return false;
        }
        // scan through all previously applied items
        if (!_contains(item, set._items[type])) {
          if (shouldAdd) {
            set._items[type].push(item);
          }
          return false;
        }
        return true;
    }
  }
  return _Set;
}());


/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

var _containsWith = __webpack_require__(83);
var _curry3 = __webpack_require__(5);
var uniqWith = __webpack_require__(112);


/**
 * Combines two lists into a set (i.e. no duplicates) composed of those
 * elements common to both lists. Duplication is determined according to the
 * value returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate function that determines whether
 *        the two supplied elements are equal.
 * @param {Array} list1 One list of items to compare
 * @param {Array} list2 A second list of items to compare
 * @return {Array} A new list containing those elements common to both lists.
 * @see R.innerJoin
 * @deprecated since v0.24.0
 * @example
 *
 *      var buffaloSpringfield = [
 *        {id: 824, name: 'Richie Furay'},
 *        {id: 956, name: 'Dewey Martin'},
 *        {id: 313, name: 'Bruce Palmer'},
 *        {id: 456, name: 'Stephen Stills'},
 *        {id: 177, name: 'Neil Young'}
 *      ];
 *      var csny = [
 *        {id: 204, name: 'David Crosby'},
 *        {id: 456, name: 'Stephen Stills'},
 *        {id: 539, name: 'Graham Nash'},
 *        {id: 177, name: 'Neil Young'}
 *      ];
 *
 *      R.intersectionWith(R.eqBy(R.prop('id')), buffaloSpringfield, csny);
 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
 */
module.exports = _curry3(function intersectionWith(pred, list1, list2) {
  var lookupList, filteredList;
  if (list1.length > list2.length) {
    lookupList = list1;
    filteredList = list2;
  } else {
    lookupList = list2;
    filteredList = list1;
  }
  var results = [];
  var idx = 0;
  while (idx < filteredList.length) {
    if (_containsWith(pred, filteredList[idx], lookupList)) {
      results[results.length] = filteredList[idx];
    }
    idx += 1;
  }
  return uniqWith(pred, results);
});


/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

var _checkForMethod = __webpack_require__(59);
var _curry2 = __webpack_require__(1);


/**
 * Creates a new list with the separator interposed between elements.
 *
 * Dispatches to the `intersperse` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} separator The element to add to the list.
 * @param {Array} list The list to be interposed.
 * @return {Array} The new list.
 * @example
 *
 *      R.intersperse('n', ['ba', 'a', 'a']); //=> ['ba', 'n', 'a', 'n', 'a']
 */
module.exports = _curry2(_checkForMethod('intersperse', function intersperse(separator, list) {
  var out = [];
  var idx = 0;
  var length = list.length;
  while (idx < length) {
    if (idx === length - 1) {
      out.push(list[idx]);
    } else {
      out.push(list[idx], separator);
    }
    idx += 1;
  }
  return out;
}));


/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

var _clone = __webpack_require__(160);
var _curry3 = __webpack_require__(5);
var _isTransformer = __webpack_require__(95);
var _reduce = __webpack_require__(18);
var _stepCat = __webpack_require__(358);


/**
 * Transforms the items of the list with the transducer and appends the
 * transformed items to the accumulator using an appropriate iterator function
 * based on the accumulator type.
 *
 * The accumulator can be an array, string, object or a transformer. Iterated
 * items will be appended to arrays and concatenated to strings. Objects will
 * be merged directly or 2-item arrays will be merged as key, value pairs.
 *
 * The accumulator can also be a transformer object that provides a 2-arity
 * reducing iterator function, step, 0-arity initial value function, init, and
 * 1-arity result extraction function result. The step function is used as the
 * iterator function in reduce. The result function is used to convert the
 * final accumulator into the return type and in most cases is R.identity. The
 * init function is used to provide the initial accumulator.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the
 * transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig a -> (b -> b) -> [c] -> a
 * @param {*} acc The initial accumulator value.
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @example
 *
 *      var numbers = [1, 2, 3, 4];
 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
 *
 *      R.into([], transducer, numbers); //=> [2, 3]
 *
 *      var intoArray = R.into([]);
 *      intoArray(transducer, numbers); //=> [2, 3]
 */
module.exports = _curry3(function into(acc, xf, list) {
  return _isTransformer(acc) ?
    _reduce(xf(acc), acc['@@transducer/init'](), list) :
    _reduce(xf(_stepCat(acc)), _clone(acc, [], [], false), list);
});


/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

var _assign = __webpack_require__(113);
var _identity = __webpack_require__(110);
var _isArrayLike = __webpack_require__(74);
var _isTransformer = __webpack_require__(95);
var objOf = __webpack_require__(184);


module.exports = (function() {
  var _stepCatArray = {
    '@@transducer/init': Array,
    '@@transducer/step': function(xs, x) {
      xs.push(x);
      return xs;
    },
    '@@transducer/result': _identity
  };
  var _stepCatString = {
    '@@transducer/init': String,
    '@@transducer/step': function(a, b) { return a + b; },
    '@@transducer/result': _identity
  };
  var _stepCatObject = {
    '@@transducer/init': Object,
    '@@transducer/step': function(result, input) {
      return _assign(
        result,
        _isArrayLike(input) ? objOf(input[0], input[1]) : input
      );
    },
    '@@transducer/result': _identity
  };

  return function _stepCat(obj) {
    if (_isTransformer(obj)) {
      return obj;
    }
    if (_isArrayLike(obj)) {
      return _stepCatArray;
    }
    if (typeof obj === 'string') {
      return _stepCatString;
    }
    if (typeof obj === 'object') {
      return _stepCatObject;
    }
    throw new Error('Cannot create transformer for ' + obj);
  };
}());


/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

var _has = __webpack_require__(14);

// Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
module.exports = function _objectAssign(target) {
  if (target == null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  var output = Object(target);
  var idx = 1;
  var length = arguments.length;
  while (idx < length) {
    var source = arguments[idx];
    if (source != null) {
      for (var nextKey in source) {
        if (_has(nextKey, source)) {
          output[nextKey] = source[nextKey];
        }
      }
    }
    idx += 1;
  }
  return output;
};


/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_io__ = __webpack_require__(116);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "take", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takem", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "put", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "race", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "call", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "apply", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cps", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fork", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "spawn", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "join", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cancel", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "actionChannel", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cancelled", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setContext", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["q"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__ = __webpack_require__(918);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeEvery", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeLatest", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["c"]; });




/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _has = __webpack_require__(14);
var keys = __webpack_require__(32);


/**
 * Same as [`R.invertObj`](#invertObj), however this accounts for objects with
 * duplicate values by putting the values into an array.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: [ s, ... ]}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object with keys in an array.
 * @see R.invertObj
 * @example
 *
 *      var raceResultsByFirstName = {
 *        first: 'alice',
 *        second: 'jake',
 *        third: 'alice',
 *      };
 *      R.invert(raceResultsByFirstName);
 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
 */
module.exports = _curry1(function invert(obj) {
  var props = keys(obj);
  var len = props.length;
  var idx = 0;
  var out = {};

  while (idx < len) {
    var key = props[idx];
    var val = obj[key];
    var list = _has(val, out) ? out[val] : (out[val] = []);
    list[list.length] = key;
    idx += 1;
  }
  return out;
});


/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var keys = __webpack_require__(32);


/**
 * Returns a new object with the keys of the given object as values, and the
 * values of the given object, which are coerced to strings, as keys. Note
 * that the last key found is preferred when handling the same value.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: s}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object
 * @see R.invert
 * @example
 *
 *      var raceResults = {
 *        first: 'alice',
 *        second: 'jake'
 *      };
 *      R.invertObj(raceResults);
 *      //=> { 'alice': 'first', 'jake':'second' }
 *
 *      // Alternatively:
 *      var raceResults = ['alice', 'jake'];
 *      R.invertObj(raceResults);
 *      //=> { 'alice': '0', 'jake':'1' }
 */
module.exports = _curry1(function invertObj(obj) {
  var props = keys(obj);
  var len = props.length;
  var idx = 0;
  var out = {};

  while (idx < len) {
    var key = props[idx];
    out[obj[key]] = key;
    idx += 1;
  }
  return out;
});


/***/ }),

/***/ 3615:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _reactRedux = __webpack_require__(6);

var _reduxSaga = __webpack_require__(92);

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _signInReducer = __webpack_require__(3616);

var _routeReducer = __webpack_require__(909);

var _reactRouter = __webpack_require__(67);

var _reactRouterRedux = __webpack_require__(27);

var _redux = __webpack_require__(131);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(47);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactTapEventPlugin = __webpack_require__(260);

var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);

var _reduxThunk = __webpack_require__(622);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _signinContainer = __webpack_require__(3617);

var _signinContainer2 = _interopRequireDefault(_signinContainer);

var _signin = __webpack_require__(3619);

var _signin2 = _interopRequireDefault(_signin);

var _links = __webpack_require__(3621);

var _links2 = _interopRequireDefault(_links);

var _emailLink = __webpack_require__(3622);

var _emailLink2 = _interopRequireDefault(_emailLink);

var _signInSagas = __webpack_require__(3623);

var _signInSagas2 = _interopRequireDefault(_signInSagas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(250); // FOR WEBPACK

var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
var sagaMiddleware = (0, _reduxSaga2.default)();
var logger = function logger() {
  return function (next) {
    return function (action) {
      return next(action);
    };
  };
};
var createStoreWithMiddleware = composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk2.default, sagaMiddleware, logger, (0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory)))(_redux.createStore);
var reducer = (0, _redux.combineReducers)({
  signin: _signInReducer.signin,
  route: _routeReducer.route,
  routing: _reactRouterRedux.routerReducer
});

var store = createStoreWithMiddleware(reducer);
sagaMiddleware.run(_signInSagas2.default);
// Needed for onTouchTap
// Can go away when react 1.0 release
// Check this repo:
// https://github.com/zilverline/react-tap-event-plugin
(0, _reactTapEventPlugin2.default)();
var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);

/* jshint ignore:start */
/* jshint ignore:start */
_reactDom2.default.render(_react2.default.createElement(
  _reactRedux.Provider,
  { store: store },
  _react2.default.createElement(
    _reactRouter.Router,
    { history: history },
    _react2.default.createElement(
      _reactRouter.Route,
      { path: '/signin', component: _signinContainer2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _signin2.default }),
      _react2.default.createElement(_reactRouter.Route, { component: _signin2.default, path: 'sso' }),
      _react2.default.createElement(_reactRouter.Route, { component: _links2.default, path: 'forgot-password' }),
      _react2.default.createElement(_reactRouter.Route, { component: _links2.default, path: 'resend-confirmation' }),
      _react2.default.createElement(_reactRouter.Route, { component: _links2.default, path: 'resend-secondary-confirmation-email' }),
      _react2.default.createElement(_reactRouter.Route, { component: _links2.default, path: 'disassociate-secondary' }),
      _react2.default.createElement(_reactRouter.Route, { component: _links2.default, path: 'newpassword/:token' }),
      _react2.default.createElement(_reactRouter.Route, { component: _emailLink2.default, path: 'email/confirmation/:token' }),
      _react2.default.createElement(_reactRouter.Route, { component: _emailLink2.default, path: 'email/secondary-confirmation/:token' }),
      _react2.default.createElement(_reactRouter.Route, { component: _emailLink2.default, path: 'email/confirm-disassociate/:token' })
    )
  )
), document.getElementById('app'));

/* jshint ignore:end */

/***/ }),

/***/ 3616:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signin = signin;

var _immutable = __webpack_require__(26);

var initialState = (0, _immutable.Map)();

function signin() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'CONFIRM_SIGNIN_EMAIL_SUCCESS':
      if (action.payload.error) return state.set('signinError', action.payload.message);
      return state.set('signinInfo', action.payload.message);
    case 'CONFIRM_SECONDARY_EMAIL':
    case 'CONFIRM_DISASSOCIATE_SECONDARY':
      if (action.payload.error) return state.set('signinError', action.payload.message);
      return state;
    case 'UPDATE_INFO_BOX':
      return state.merge((0, _immutable.Map)({ signinInfo: action.messages.signinInfo, signinError: action.messages.signinError }));
    case 'CLEAR_INFO_BOX_MESSAGE':
      return state.merge((0, _immutable.Map)({ signinInfo: undefined, signinError: undefined }));
    case 'CLEAR_STORES':
    case 'AUTH_RECEIVED':
      return initialState;
    default:
      return state;
  }
}

/***/ }),

/***/ 3617:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(67);

var _signInActions = __webpack_require__(2048);

var _bowser = __webpack_require__(1001);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

var _languages = __webpack_require__(248);

var _languages2 = _interopRequireDefault(_languages);

var _docCookie = __webpack_require__(142);

var _docCookie2 = _interopRequireDefault(_docCookie);

var _MuiThemeProvider = __webpack_require__(627);

var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);

var _muiTheme = __webpack_require__(477);

var _muiTheme2 = _interopRequireDefault(_muiTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Dependencies


var logoGlobeSrc = __webpack_require__(231);
var logoNameSrc = __webpack_require__(612);

var languageSettings = _languages2.default['en-US'];

// Components
var acceptedBrowserVersions = {
  'Internet Explorer': 11,
  Firefox: 35,
  Chrome: 39,
  Safari: 7.1,
  Opera: 27,
  'Microsoft Edge': 12
};

var SignInContainer = function (_Component) {
  _inherits(SignInContainer, _Component);

  function SignInContainer(props) {
    _classCallCheck(this, SignInContainer);

    var _this = _possibleConstructorReturn(this, (SignInContainer.__proto__ || Object.getPrototypeOf(SignInContainer)).call(this, props));

    _this.onSubmit = function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _this.setState(options, function () {
        _this.sendCredentials();
      });
    };

    _this.onCheckboxChanged = function () {
      var rememberMe = _this.state.rememberMe;
      _this.setState({ rememberMe: !rememberMe });
    };

    _this.getLocalizedError = function (error) {
      switch (error) {
        case 'Please provide a valid email.':
          return languageSettings.signin.invalidEmail;
        case 'Please provide a password.':
          return languageSettings.signin.invalidPassword;
        case 'Invalid email or password.':
          return languageSettings.signin.bothInvalid;
        case 'Email not confirmed':
          return languageSettings.signin.verify;
        case 'Not approved':
          return 'You have not been approved as a user for your company, yet. We will notify you once your administrator has approved you as a user.';
        case 'Email not confirmed and not approved':
          return 'Please confirm your email address so that your administrator can add you as a user for your company.';
        case 'User not found':
          return languageSettings.signin.userNotFound;
        case 'Incorrect password':
          return languageSettings.signin.incorrectPassword;
        case 'Disabled':
          return languageSettings.signin.disabledUser;
        case 'Deleted':
          return languageSettings.signin.deletedUser;
        default:
          return languageSettings.error.general;
      }
    };

    _this.debounceDismissInfoBox = (0, _lodash2.default)(function () {
      _this.clearInfoBoxMessage();
    }, 15000);

    _this.sendCredentials = function () {
      var dispatch = _this.props.dispatch;
      var _this$state = _this.state,
          email = _this$state.email,
          password = _this$state.password,
          rememberMe = _this$state.rememberMe;

      if (rememberMe) {
        if (email) _docCookie2.default.setItem('email', email, undefined, '/', window.location.host.split('.')[1] + '.com');
      } else {
        if (_docCookie2.default.hasItem('email')) _docCookie2.default.removeItem('email', '/', window.location.host.split('.')[1] + '.com');
      }
      var sso = (0, _ramda.pathOr)(null, ['props', 'location', 'query', 'sso'], _this);
      var sig = (0, _ramda.pathOr)(null, ['props', 'location', 'query', 'sig'], _this);
      // console.log('query', pathOr('/', ['props', 'location', 'query'], this));
      return dispatch((0, _signInActions.sendCredentials)({
        email: email,
        password: password,
        rememberMe: rememberMe,
        sso: sso,
        sig: sig
      })).then(function (_ref) {
        var user = _ref.user;

        localStorage.setItem('jwt', user.jwt);
        var redirect = (0, _ramda.pathOr)('/', ['props', 'location', 'query', 'redirect_to'], _this);
        var genAiProds = ['bookings', 'emailAssist', 'itineraryAssist'];
        var usersAiProds = _ramda2.default.intersection(user.allApps || [], genAiProds);
        if (user.sso_redirect_url) window.location = user.sso_redirect_url;else if (redirect && redirect !== '/') {
          if (redirect.indexOf("https://app.tourconnect.com") === 0) {
            window.location = '' + redirect + (redirect.indexOf('?') > -1 ? '&' : '?') + 'jwt=' + user.jwt;
          } else {
            window.history.pushState({}, '', window.location.protocol + '//' + window.location.host);
            window.location = window.location.protocol + '//' + window.location.host + redirect;
          }
        } else if (usersAiProds.length) {
          window.location = "https://app.tourconnect.com" + '/generative-ai/' + usersAiProds[0] + '?jwt=' + localStorage.getItem('jwt');
        } else if (user.isShellAccount) {
          if (user.companyType === 'Contractor') {
            window.location = "https://app.tourconnect.com" + '/contracting/contract-list?jwt=' + localStorage.getItem('jwt');
          } else {
            window.location = window.location.protocol + '//' + window.location.host + '/contracting/contract-list/all%20contracts';
          }
        } else window.location = window.location.protocol + '//' + window.location.host + '/';
      }).catch(function (err) {
        _this._onSigninError(_this.getLocalizedError(err.message));
        _this.debounceDismissInfoBox();
      });
    };

    _this._onSigninError = function (error) {
      _this.setState({ sending: false });
      _this.updateInfoBox({ signinError: error });
    };

    _this.updateInfoBox = function () {
      var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var dispatch = _this.props.dispatch;

      dispatch((0, _signInActions.updateInfoBox)(messages));
    };

    _this.clearInfoBoxMessage = function () {
      var dispatch = _this.props.dispatch;

      dispatch((0, _signInActions.clearInfoBoxMessage)());
    };

    _this.confirmSigninEmail = function (token) {
      console.log('hit here');
      return _this.props.dispatch({ type: 'CONFIRM_SIGNIN_EMAIL', payload: { token: token } });
    };

    _this.confirmSecondaryEmail = function (token) {
      var dispatch = _this.props.dispatch;

      return dispatch((0, _signInActions.confirmSecondaryEmail)(token));
    };

    _this.confirmDisassociateSecondary = function (token) {
      var dispatch = _this.props.dispatch;

      return dispatch((0, _signInActions.confirmDisassociateSecondary)(token));
    };

    var emailInCookie = _docCookie2.default.getItem('email');
    _this.state = {
      email: props.location.query.email || emailInCookie,
      password: '',
      rememberMe: Boolean(emailInCookie)
    };
    return _this;
  }

  _createClass(SignInContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _pathOr = (0, _ramda.pathOr)('/', ['props', 'location', 'query'], this),
          reauth = _pathOr.reauth,
          auth = _pathOr.auth,
          redirect_to = _pathOr.redirect_to,
          logout = _pathOr.logout;

      if (logout) {
        localStorage.removeItem('jwt');
        // remove the logout param
        window.history.replaceState({}, '', window.location.protocol + '//' + window.location.host + '/signin');
      } else {
        var jwt = localStorage.getItem('jwt');
        if (reauth === 'true' && jwt) {
          // something is wrong with the jwt, need to reauthenticate
          localStorage.removeItem('jwt');
        } else if (auth === 'true' && jwt && redirect_to.indexOf("https://app.tourconnect.com") === 0) {
          window.location = '' + redirect_to + (redirect_to.indexOf('?') > -1 ? '&' : '?') + 'jwt=' + jwt;
        }
      }
      var acceptedBrowserVersion = acceptedBrowserVersions[_bowser.browser.name];
      var error = void 0;
      // if (browser.mobile) {
      //   error = 'TourConnect has noticed that you are on a mobile device. Please access TourConnect from a desktop to ensure the site functions properly and provides you with the best security and experience.';
      // } else
      if (!acceptedBrowserVersion) {
        error = 'TourConnect has noticed that your browser is out of date. Please update your browser to ensure the site functions properly and provides you with the best security and experience.';
      } else if (_bowser.browser.version < acceptedBrowserVersion) {
        error = 'TourConnect has noticed that your browser (' + _bowser.browser.name + ' ' + _bowser.browser.version + ') is out of date. Please update your browser to ensure the site functions properly and provides you with the best security and experience.';
      }
      if (error) {
        this._onSigninError(error);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.debounceDismissInfoBox(this);
    }
  }, {
    key: 'getRouteName',
    value: function getRouteName() {
      var pathname = this.props.location.pathname;
      if (pathname === '/signin/forgot-password') return 'forgot-password';else if (pathname === '/signin/disassociate-secondary') return 'disassociate-secondary';else if (pathname === '/signin/resend-confirmation') return 'resend-confirmation';else if (pathname === '/signin/resend-secondary-confirmation-email') return 'resend-secondary-confirmation-email';else if (pathname.indexOf('/signin/newpassword') > -1) return 'newpassword';else if (pathname.indexOf('/signin/email/confirmation') > -1) return 'confirmation';else if (pathname.indexOf('/signin/email/secondary-confirmation') > -1) return 'secondary-confirmation';else if (pathname.indexOf('/signin/email/confirm-disassociate') > -1) return 'confirm-disassociate';
    }
  }, {
    key: 'render',
    value: function render() {
      var _pathOr2 = (0, _ramda.pathOr)({}, ['props', 'location', 'query'], this),
          auth = _pathOr2.auth,
          reauth = _pathOr2.reauth,
          _pathOr2$redirect_to = _pathOr2.redirect_to,
          redirect_to = _pathOr2$redirect_to === undefined ? '' : _pathOr2$redirect_to;

      var jwt = localStorage.getItem('jwt');
      if (auth === 'true' && reauth !== 'true' && jwt && redirect_to.indexOf("https://app.tourconnect.com") === 0) {
        return _react2.default.createElement(
          'div',
          null,
          'Redirecting...'
        );
      }

      var _props = this.props,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['children']);

      var extraProps = _extends({
        sendCredentials: this.sendCredentials,
        confirmSecondaryEmail: this.confirmSecondaryEmail,
        confirmSigninEmail: this.confirmSigninEmail,
        confirmDisassociateSecondary: this.confirmDisassociateSecondary,
        onSubmit: this.onSubmit
      }, this.state, {
        signinError: this.props.signin.signinError,
        signinInfo: this.props.signin.signinInfo,
        onCheckboxChanged: this.onCheckboxChanged,
        routeName: this.getRouteName(),
        debounceDismissInfoBox: this.debounceDismissInfoBox,
        clearInfoBoxMessage: this.clearInfoBoxMessage,
        updateInfoBox: this.updateInfoBox
      }, props);
      return _react2.default.createElement(
        _MuiThemeProvider2.default,
        { muiTheme: _muiTheme2.default },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'app-bar is-not-logged-in' },
            _react2.default.createElement(
              'div',
              { className: 'app-bar-content' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'tourconnect-logo', to: '/' },
                _react2.default.createElement('img', {
                  className: 'tourconnect-logo-globe',
                  src: logoGlobeSrc
                }),
                _react2.default.createElement('img', {
                  className: 'tourconnect-logo-name',
                  src: logoNameSrc,
                  alt: 'tourconnect'
                })
              )
            )
          ),
          children ? (0, _react.cloneElement)(children, extraProps) : undefined
        )
      );
    }
  }]);

  return SignInContainer;
}(_react.Component);

SignInContainer.propTypes = {
  location: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  children: _react.PropTypes.object,
  signin: _react.PropTypes.object,
  confirmSigninEmail: _react.PropTypes.func
};

var select = function select(state) {
  return {
    signin: state.signin.toJS(),
    route: state.route
  };
};

exports.default = (0, _reactRedux.connect)(select)(SignInContainer);

/***/ }),

/***/ 3618:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var AUTH_RECEIVED = exports.AUTH_RECEIVED = 'AUTH_RECEIVED';
var SEND_CREDENTIALS = exports.SEND_CREDENTIALS = 'SEND_CREDENTIALS';
var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES';
var UPDATE_INFO_BOX = exports.UPDATE_INFO_BOX = 'UPDATE_INFO_BOX';
var CLEAR_INFO_BOX_MESSAGE = exports.CLEAR_INFO_BOX_MESSAGE = 'CLEAR_INFO_BOX_MESSAGE';
var FORGOT_PASSWORD = exports.FORGOT_PASSWORD = 'FORGOT_PASSWORD';
var SEND_CONFIRMATION_LINK = exports.SEND_CONFIRMATION_LINK = 'SEND_CONFIRMATION_LINK';
var SEND_SECONDARY_EMAIL_CONFIRMATION = exports.SEND_SECONDARY_EMAIL_CONFIRMATION = 'SEND_SECONDARY_EMAIL_CONFIRMATION';
var DISASSOCIATE_SECONDARY_EMAIL = exports.DISASSOCIATE_SECONDARY_EMAIL = 'DISASSOCIATE_SECONDARY_EMAIL';
var RESET_PASSWORD_WITH_TOKEN = exports.RESET_PASSWORD_WITH_TOKEN = 'RESET_PASSWORD_WITH_TOKEN';
var ADMIN_SIGNIN = exports.ADMIN_SIGNIN = 'ADMIN_SIGNIN';
var CONFIRM_SECONDARY_EMAIL = exports.CONFIRM_SECONDARY_EMAIL = 'CONFIRM_SECONDARY_EMAIL';
var CONFIRM_SIGNIN_EMAIL = exports.CONFIRM_SIGNIN_EMAIL = 'CONFIRM_SIGNIN_EMAIL';
var CONFIRM_DISASSOCIATE_SECONDARY = exports.CONFIRM_DISASSOCIATE_SECONDARY = 'CONFIRM_DISASSOCIATE_SECONDARY';

/***/ }),

/***/ 3619:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _signinForm = __webpack_require__(3620);

var _signinForm2 = _interopRequireDefault(_signinForm);

var _signinError = __webpack_require__(2049);

var _signinError2 = _interopRequireDefault(_signinError);

var _reactRouter = __webpack_require__(67);

var _env = __webpack_require__(2050);

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Dependencies

// Stores
// Components


// Util
// Put state hydration logic on success here - shouldn't have to do all this state stuff in other components;


var SignIn = function (_Component) {
  _inherits(SignIn, _Component);

  function SignIn(props) {
    _classCallCheck(this, SignIn);

    var _this = _possibleConstructorReturn(this, (SignIn.__proto__ || Object.getPrototypeOf(SignIn)).call(this, props));

    _this.onSubmit = function (event) {
      if (!_this.refs.email.getValue() || !_this.refs.password.getValue()) {
        if (!_this.refs.email.getValue()) {
          _this.setState({ emailErrorText: 'This is a required field' });
        }
        if (!_this.refs.password.getValue()) {
          _this.setState({ passwordErrorText: 'This is a required field' });
        }
      } else {
        event.preventDefault();
        _this.props.onSubmit({
          sending: true,
          signinError: '',
          email: _this.refs.email.getValue(),
          password: _this.refs.password.getValue()
        });
      }
    };

    _this.handleEnter = function (event) {
      var which = event.which,
          keyCode = event.keyCode;

      var code = which || keyCode;
      if (code === 13) {
        _this.onSubmit(event);
      }
    };

    _this.state = {
      emailErrorText: '',
      passwordErrorText: ''
    };
    return _this;
  }

  _createClass(SignIn, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.clearInfoBoxMessage();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'user_login' },
        _react2.default.createElement(
          'div',
          { className: 'signin_form' },
          _react2.default.createElement(
            _signinForm2.default,
            {
              onSubmit: this.onSubmit,
              sending: this.props.sending
            },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_signinError2.default, this.props),
              _react2.default.createElement(_materialUi.TextField, {
                'data-cy': 'singin-email',
                style: { width: '100%' },
                floatingLabelText: 'Email',
                hintText: 'Required',
                errorText: this.state.emailErrorText,
                onChange: function onChange() {
                  if (_this2.state.emailErrorText) _this2.setState({ emailErrorText: '' });
                },
                onKeyDown: this.handleEnter,
                defaultValue: this.props.email,
                ref: 'email',
                className: 'singin-email'
              }),
              _react2.default.createElement(_materialUi.TextField, {
                'data-cy': 'singin-password',
                style: { width: '100%' },
                floatingLabelText: 'Password',
                hintText: 'Required',
                errorText: this.state.passwordErrorText,
                onChange: function onChange() {
                  if (_this2.state.passwordErrorText) _this2.setState({ passwordErrorText: '' });
                },
                onKeyDown: this.handleEnter,
                type: 'password',
                defaultValue: this.props.password,
                ref: 'password',
                className: 'singin-password'
              }),
              _react2.default.createElement(
                'div',
                { style: { overflow: 'auto', margin: '15px 0 15px -4px' } },
                _react2.default.createElement(_materialUi.Checkbox, {
                  style: { width: '50%', float: 'left', fontSize: '12px' },
                  label: _react2.default.createElement(
                    'span',
                    { style: { marginLeft: '-10px' } },
                    'Remember me'
                  ),
                  onCheck: this.props.onCheckboxChanged,
                  checked: this.props.rememberMe
                }),
                _react2.default.createElement(
                  'div',
                  { style: { float: 'right', display: 'inline-block' } },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/signin/forgot-password', style: { fontSize: '12px' } },
                    'Forgot password?'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { borderTop: '1px solid #d0d0d0', paddingTop: '10px' } },
            _react2.default.createElement(
              'span',
              { style: { fontSize: '12px', color: 'black' } },
              "Don't have an account? "
            ),
            _react2.default.createElement(
              'a',
              { href: '/signup', style: { fontSize: '12px', display: 'block' }, id: 'SignUpLink' },
              'Sign up'
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { style: { fontSize: '12px', display: 'block' }, to: "/signin/resend-confirmation" },
            'Did not receive email confirmation?'
          )
        )
      );
    }
  }]);

  return SignIn;
}(_react.Component);

SignIn.propTypes = {
  clearInfoBoxMessage: _react.PropTypes.func,
  onSubmit: _react.PropTypes.func,
  onCheckboxChanged: _react.PropTypes.func,
  email: _react.PropTypes.string,
  password: _react.PropTypes.string,
  sending: _react.PropTypes.bool,
  rememberMe: _react.PropTypes.bool
};

exports.default = SignIn;

/* jshint ignore:end */

/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var empty = __webpack_require__(181);
var equals = __webpack_require__(19);


/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);   //=> false
 *      R.isEmpty([]);          //=> true
 *      R.isEmpty('');          //=> true
 *      R.isEmpty(null);        //=> false
 *      R.isEmpty({});          //=> true
 *      R.isEmpty({length: 0}); //=> false
 */
module.exports = _curry1(function isEmpty(x) {
  return x != null && equals(x, empty(x));
});


/***/ }),

/***/ 3620:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Dependencies


var SignInForm = function (_Component) {
  _inherits(SignInForm, _Component);

  function SignInForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SignInForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SignInForm.__proto__ || Object.getPrototypeOf(SignInForm)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (event) {
      if (_this.props.onChange) _this.props.onChange(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SignInForm, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var submitButton = function () {
        if (_this2.props.sending) return _react2.default.createElement(_raisedButtonWithLoader2.default, { 'data-cy': 'signin-loading', style: { width: '100%' }, label: 'Loading...', className: 'signin-button loader', disabled: true });
        return _react2.default.createElement(_raisedButtonWithLoader2.default, { style: { width: '100%' }, secondary: true, onClick: _this2.props.onSubmit, label: 'Log in', className: 'signin-button-clicker', 'data-cy': 'signin-button-clicker' });
      }();

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          { className: 'signin-header' },
          'Log In'
        ),
        _react2.default.createElement(
          'form',
          { onChange: this.onChange, onSubmit: this.props.onSubmit },
          this.props.children,
          submitButton
        )
      );
    }
  }]);

  return SignInForm;
}(_react.Component);

SignInForm.propTypes = {
  onChange: _react.PropTypes.func,
  sending: _react.PropTypes.bool,
  children: _react.PropTypes.object,
  onSubmit: _react.PropTypes.func
};

exports.default = SignInForm;

/* jshint ignore:end */

/***/ }),

/***/ 3621:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _signInActions = __webpack_require__(2048);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

var _materialUi = __webpack_require__(3);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

var _signinError = __webpack_require__(2049);

var _signinError2 = _interopRequireDefault(_signinError);

var _reactRouter = __webpack_require__(67);

var _env = __webpack_require__(2050);

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// Dependencies

// Stores
// Components

// Util
// Put state hydration logic on success here - shouldn't have to do all this state stuff in other components;


var SignInLink = function (_Component) {
  _inherits(SignInLink, _Component);

  function SignInLink(props) {
    _classCallCheck(this, SignInLink);

    var _this = _possibleConstructorReturn(this, (SignInLink.__proto__ || Object.getPrototypeOf(SignInLink)).call(this, props));

    _this._onSubmit = function (event) {
      _this.setState({ sending: true });
      var token = _this.props.params.token;

      event.preventDefault();
      // this.setState({sending: true});
      var dispatch = _this.props.dispatch;

      var fn = _this.getSubmitFunc();
      if (_this.props.routeName === 'newpassword') {
        dispatch(fn(_this.state.newPassword, token)).then(function () {
          _this.setState({ sending: false });
          _this.props.updateInfoBox({
            signinError: "Your password has been reset. You'll be redirected to our signin page soon.",
            signinInfo: true });
          _this.debounceTransition();
        }).catch(function (err) {
          _this.setState({ sending: false });
          if (err.message === 'Not Found') {
            _this.props.updateInfoBox({ signinError: 'This link is out of date, please try a new link.', signinInfo: false });
          } else if (err.message === 'Internal Server Error') {
            _this.props.updateInfoBox({ signinError: 'Internal Error: Please try again later.', signinInfo: false });
          }
          _this.props.debounceDismissInfoBox();
        });
      } else {
        dispatch(fn(_this.state.email)).then(function () {
          _this.setState({ sending: false });
          _this.props.updateInfoBox({
            signinError: undefined,
            signinInfo: 'An email has been sent to you.'
          });
          _this.props.debounceDismissInfoBox();
        }).catch(function (err) {
          console.log(err.message);
          _this.setState({ sending: false });
          if (err.message === '404') {
            _this.props.updateInfoBox({ signinError: "This email doesn't associate with any account.", signinInfo: false });
          } else if (err.message === '400') {
            _this.props.updateInfoBox({
              signinError: 'This email has already been confirmed.',
              signinInfo: false });
          } else if (err.message === '500') {
            _this.props.updateInfoBox({ signinError: 'Internal Error: Please try again later.', signinInfo: false });
          }
          _this.props.debounceDismissInfoBox(_this);
        });
      }
    };

    _this.debounceTransition = (0, _lodash2.default)(function () {
      var history = _this.props.history;

      history.push('/signin');
    }, 2000);

    _this.state = {};
    return _this;
  }

  _createClass(SignInLink, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.debounceDismissInfoBox();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.props.debounceDismissInfoBox();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.clearInfoBoxMessage();
    }
  }, {
    key: 'getSubmitFunc',
    value: function getSubmitFunc() {
      switch (this.props.routeName) {
        case 'forgot-password':
          return _signInActions.forgotPassword;
        case 'disassociate-secondary':
          return _signInActions.disassociateSecondaryEmail;
        case 'resend-confirmation':
          return _signInActions.sendConfirmationLink;
        case 'resend-secondary-confirmation-email':
          return _signInActions.sendSecondaryEmailConfirmation;
        case 'newpassword':
          return _signInActions.resetPasswordWithToken;
        default:
          return _signInActions.resetPasswordWithToken;
      }
    }
  }, {
    key: 'setValue',
    value: function setValue(type) {
      var update = {};
      update[type] = this.refs[type].getValue();
      this.setState(update);
    }
  }, {
    key: 'isValidEmail',
    value: function isValidEmail(email) {
      var filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
      return String(email).search(filter) !== -1;
    }
  }, {
    key: 'validate',
    value: function validate() {
      var email = this.state.email;
      if (email === '' || this.isValidEmail(email)) return undefined;
      return 'Please enter a valid email address';
    }
  }, {
    key: 'renderLinksTitle',
    value: function renderLinksTitle() {
      switch (this.props.routeName) {
        case 'forgot-password':
          return [_react2.default.createElement(
            _reactRouter.Link,
            { style: { fontSize: '12px', display: 'block' }, to: "/signin/resend-confirmation" },
            'Resend Confirmation Link'
          ), 'Forgot your password?'];
        case 'disassociate-secondary':
          return [_react2.default.createElement(
            _reactRouter.Link,
            { style: { fontSize: '12px', display: 'block' }, to: "/signin/resend-confirmation" },
            'Resend Confirmation Link'
          ), 'Disassociate Secondary Email'];
        case 'resend-confirmation':
          return [_react2.default.createElement(
            _reactRouter.Link,
            { style: { fontSize: '12px', display: 'block' }, to: "/signin/forgot-password" },
            'Forgot your password?'
          ), 'Resend Confirmation Link'];
        case 'resend-secondary-confirmation-email':
          return [_react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              {
                style: { fontSize: '12px', display: 'block' },
                to: "/signin/resend-confirmation"
              },
              'Resend Confirmation Link'
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              {
                style: { fontSize: '12px', display: 'block' },
                to: "/signin/disassociate-secondary"
              },
              'Remove Secondary Email'
            )
          ), 'Resend Secondary Email Confirmation'];
        case 'newpassword':
          return [_react2.default.createElement(
            _reactRouter.Link,
            { style: { fontSize: '12px', display: 'block' }, to: "/signin/forgot-password" },
            'Forgot your password?'
          ), 'Reset Password'];
        default:
          return [_react2.default.createElement(
            _reactRouter.Link,
            { style: { fontSize: '12px', display: 'block' }, to: "/signin/forgot-password" },
            'Forgot your password?'
          ), 'Reset Password'];
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var textfield = void 0;
      var submitButton = void 0;
      var errorText = void 0;

      var _renderLinksTitle = this.renderLinksTitle(),
          _renderLinksTitle2 = _slicedToArray(_renderLinksTitle, 2),
          links = _renderLinksTitle2[0],
          title = _renderLinksTitle2[1];

      if (this.props.routeName !== 'newpassword') {
        textfield = _react2.default.createElement(_materialUi.TextField, { hintText: 'Required', floatingLabelText: 'Email', ref: 'email', errorText: errorText, onChange: this.setValue.bind(this, 'email') });
        if (this.state.sending) submitButton = _react2.default.createElement(_raisedButtonWithLoader2.default, { style: { width: '100%', margin: '20px auto' }, className: 'signin-button loader', disabled: true, label: "Submit" });else if (!this.isValidEmail(this.state.email)) submitButton = _react2.default.createElement(_raisedButtonWithLoader2.default, { style: { width: '100%', margin: '20px auto' }, disabled: true, label: "Submit" });else submitButton = _react2.default.createElement(_raisedButtonWithLoader2.default, { style: { width: '100%', margin: '20px auto' }, secondary: true, onClick: this._onSubmit, label: "Submit" });
      } else {
        textfield = _react2.default.createElement(_materialUi.TextField, { hintText: 'Required', floatingLabelText: 'New Password', ref: 'newPassword', type: 'password', onChange: this.setValue.bind(this, 'newPassword') });
        if (this.state.sending) submitButton = _react2.default.createElement(_raisedButtonWithLoader2.default, { style: { width: '100%', margin: '20px auto' }, className: 'signin-button loader', disabled: true, label: "Submit" });else submitButton = _react2.default.createElement(_raisedButtonWithLoader2.default, { style: { width: '100%', margin: '20px auto' }, secondary: true, onClick: this._onSubmit, label: "Submit" });
      }

      if (!this.isValidEmail(this.state.email) && this.state.email) errorText = 'Please enter a valid email address';

      return _react2.default.createElement(
        'div',
        { className: 'user_login' },
        _react2.default.createElement(
          'div',
          { className: 'signin_form' },
          _react2.default.createElement(
            'h2',
            { className: 'signin-header' },
            title
          ),
          _react2.default.createElement(_signinError2.default, { signinError: this.props.signinError, signinInfo: this.props.signinInfo }),
          textfield,
          submitButton,
          _react2.default.createElement(
            'div',
            { style: { borderTop: '1px solid #d0d0d0', paddingTop: '10px' } },
            _react2.default.createElement(
              _reactRouter.Link,
              { style: { fontSize: '12px', display: 'block' }, to: '/signin' },
              'Sign in'
            ),
            function () {
              // if production, use external links, Otherwise, add to links Array to be mapped as a legacy link.
              if (_env2.default === 'prod') {
                return _react2.default.createElement(
                  'a',
                  { href: window.location.protocol + '//' + window.location.host + '/signup', rel: 'external', style: { fontSize: '12px' } },
                  'Sign up'
                );
              }
              return _react2.default.createElement(
                'a',
                { href: 'http://tourconnect2.staging.wpengine.com/sign-up/', style: { fontSize: '12px', display: 'block' } },
                'Sign up'
              );
            }()
          ),
          links
        )
      );
    }
  }]);

  return SignInLink;
}(_react.Component);

SignInLink.propTypes = {
  debounceDismissInfoBox: _react.PropTypes.func,
  routeName: _react.PropTypes.string,
  params: _react.PropTypes.object,
  history: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  updateInfoBox: _react.PropTypes.func,
  clearInfoBoxMessage: _react.PropTypes.func,
  signinError: _react.PropTypes.string,
  signinInfo: _react.PropTypes.boolean
};

exports.default = SignInLink;

/* jshint ignore:end */

/***/ }),

/***/ 3622:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmailLink = function (_Component) {
  _inherits(EmailLink, _Component);

  function EmailLink(props) {
    _classCallCheck(this, EmailLink);

    var _this = _possibleConstructorReturn(this, (EmailLink.__proto__ || Object.getPrototypeOf(EmailLink)).call(this, props));

    _this.debounceTransition = (0, _lodash2.default)(function () {
      window.location = window.location.protocol + '//' + window.location.host + '/settings';
    }, 4000);

    _this.state = {
      content: 'We are processing your request ...'
    };
    return _this;
  }

  _createClass(EmailLink, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var _props = this.props,
          routeName = _props.routeName,
          params = _props.params,
          history = _props.history;
      var token = params.token;

      if (routeName === 'confirmation') {
        return this.props.confirmSigninEmail(token);
      }
      var fn = this.getProcessEmailLinkFunc();
      fn(token).then(function (res) {
        if (routeName === 'secondary-confirmation') {
          if (res.payload.error) {
            history.push('/signin/resend-confirmation');
          } else {
            _this2.setState({ content: res.payload.message });
            _this2.debounceTransition();
          }
        } else if (routeName === 'confirmation') {
          var error = res ? res.payload.error : undefined;
          if (error) history.push('/signin/resend-confirmation');else history.push('/signin');
        } else if (routeName === 'confirm-disassociate') {
          if (res.payload.error) {
            history.push('/signin/disassociate-secondary');
          } else {
            _this2.setState({ content: res.payload.message });
            (0, _lodash2.default)(function () {
              history.push('/signin');
            })();
          }
        }
      }).catch(function (err) {
        console.log('err in email-link', err);
      });
    }
  }, {
    key: 'getProcessEmailLinkFunc',
    value: function getProcessEmailLinkFunc() {
      switch (this.props.routeName) {
        case 'secondary-confirmation':
          return this.props.confirmSecondaryEmail;
        case 'confirm-disassociate':
          return this.props.confirmDisassociateSecondary;
        default:
          return this.props.confirmSecondaryEmail;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'l-app-content', style: { textAlign: 'center' } },
        _react2.default.createElement(
          'h2',
          null,
          this.state.content
        )
      );
    }
  }]);

  return EmailLink;
}(_react.Component);

EmailLink.propTypes = {
  routeName: _react.PropTypes.string,
  history: _react.PropTypes.object,
  params: _react.PropTypes.object,
  confirmSigninEmail: _react.PropTypes.func,
  confirmSecondaryEmail: _react.PropTypes.func,
  confirmDisassociateSecondary: _react.PropTypes.func
};

exports.default = EmailLink;

/***/ }),

/***/ 3623:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = rootSaga;

var _effects = __webpack_require__(36);

var _api = __webpack_require__(37);

var _sagas = __webpack_require__(43);

var _reactRouterRedux = __webpack_require__(27);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(doConfirmEmail),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(afterConfirmationSuccess),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(afterLoginSuccess),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(rootSaga);

function doConfirmEmail(_ref) {
  var type = _ref.type,
      payload = _ref.payload;
  return regeneratorRuntime.wrap(function doConfirmEmail$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _sagas.apiSaga)(type, _api.account.confirmEmail, [payload.token]);

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}
var sendIntercom = function sendIntercom() {
  if (window.Intercom) {
    var _window;

    (_window = window).Intercom.apply(_window, arguments); // eslint-disable-line new-cap
  }
};
function afterConfirmationSuccess(_ref2) {
  var payload = _ref2.payload;
  return regeneratorRuntime.wrap(function afterConfirmationSuccess$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          sendIntercom('boot', {
            app_id: "jfwd6pzo",
            user_id: payload.userId,
            email: payload.email
          });
          sendIntercom('trackEvent', 'Email_Confirmation_Success');

          if (!payload.autoLoginToken) {
            _context2.next = 7;
            break;
          }

          _context2.next = 5;
          return (0, _sagas.apiSaga)('AUTO_LOGIN', _api.account.loginAsUser, [_extends({}, payload, {
            hashToken: payload.autoLoginToken
          })]);

        case 5:
          _context2.next = 12;
          break;

        case 7:
          if (!payload.message) {
            _context2.next = 12;
            break;
          }

          _context2.next = 10;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/signin'));

        case 10:
          _context2.next = 12;
          return (0, _effects.put)({
            type: 'UPDATE_INFO_BOX',
            messages: _defineProperty({}, payload.message ? 'signinError' : 'signinInfo', payload.message)
          });

        case 12:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function afterLoginSuccess(_ref3) {
  var payload = _ref3.payload;
  var genAiProds, usersAiProds;
  return regeneratorRuntime.wrap(function afterLoginSuccess$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          localStorage.setItem('jwt', payload.user.jwt);
          genAiProds = ['bookings', 'emailAssist', 'itineraryAssist'];
          usersAiProds = _ramda2.default.intersection(payload.user.allApps || [], genAiProds);

          if (usersAiProds.length) {
            window.location = "https://app.tourconnect.com" + '/generative-ai/' + genAiProds[0] + '?jwt=' + payload.user.jwt;
          } else {
            window.location = window.location.origin;
          }

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}
function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return [(0, _effects.takeLatest)('CONFIRM_SIGNIN_EMAIL', doConfirmEmail), (0, _effects.takeLatest)('CONFIRM_SIGNIN_EMAIL_SUCCESS', afterConfirmationSuccess), (0, _effects.takeLatest)('AUTO_LOGIN_SUCCESS', afterLoginSuccess)];

        case 2:
          return _context4.abrupt('return', _context4.sent);

        case 3:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

var invoker = __webpack_require__(62);


/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      var spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */
module.exports = invoker(1, 'join');


/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Returns a list containing the names of all the properties of the supplied
 * object, including prototype properties.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own and prototype properties.
 * @see R.keys, R.valuesIn
 * @example
 *
 *      var F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      var f = new F();
 *      R.keysIn(f); //=> ['x', 'y']
 */
module.exports = _curry1(function keysIn(obj) {
  var prop;
  var ks = [];
  for (prop in obj) {
    ks[ks.length] = prop;
  }
  return ks;
});


/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _isArray = __webpack_require__(41);
var equals = __webpack_require__(19);


/**
 * Returns the position of the last occurrence of an item in an array, or -1 if
 * the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.indexOf
 * @example
 *
 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
 */
module.exports = _curry2(function lastIndexOf(target, xs) {
  if (typeof xs.lastIndexOf === 'function' && !_isArray(xs)) {
    return xs.lastIndexOf(target);
  } else {
    var idx = xs.length - 1;
    while (idx >= 0) {
      if (equals(xs[idx], target)) {
        return idx;
      }
      idx -= 1;
    }
    return -1;
  }
});


/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var lens = __webpack_require__(85);
var nth = __webpack_require__(61);
var update = __webpack_require__(107);


/**
 * Returns a lens whose focus is the specified index.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Number -> Lens s a
 * @param {Number} n
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      var headLens = R.lensIndex(0);
 *
 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
 */
module.exports = _curry1(function lensIndex(n) {
  return lens(nth(n), update(n));
});


/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var assocPath = __webpack_require__(156);
var lens = __webpack_require__(85);
var path = __webpack_require__(63);


/**
 * Returns a lens whose focus is the specified path.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @typedefn Idx = String | Int
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig [Idx] -> Lens s a
 * @param {Array} path The path to use.
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      var xHeadYLens = R.lensPath(['x', 0, 'y']);
 *
 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> 2
 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
 */
module.exports = _curry1(function lensPath(p) {
  return lens(path(p), assocPath(p));
});


/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var assoc = __webpack_require__(75);
var lens = __webpack_require__(85);
var prop = __webpack_require__(96);


/**
 * Returns a lens whose focus is the specified property.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig String -> Lens s a
 * @param {String} k
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      var xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */
module.exports = _curry1(function lensProp(k) {
  return lens(prop(k), assoc(k));
});


/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns `true` if the first argument is less than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.gt
 * @example
 *
 *      R.lt(2, 1); //=> false
 *      R.lt(2, 2); //=> false
 *      R.lt(2, 3); //=> true
 *      R.lt('a', 'z'); //=> true
 *      R.lt('z', 'a'); //=> false
 */
module.exports = _curry2(function lt(a, b) { return a < b; });


/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.billing = exports.integration = exports.contentful = exports.settings = exports.assetLanding = exports.profile = exports.massMessage = exports.connection = exports.admin = exports.masterTemplates = exports.contracting = exports.downloads = exports.fileUrls = exports.historyFeed = exports.workspace = exports.partner = exports.account = exports.callApiwithToken = exports.callApiJWT = exports.callApi = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

var _locationGraphqlQuery = __webpack_require__(862);

var _profileGraphqlQuery = __webpack_require__(863);

var _graphqlQueries = __webpack_require__(864);

var contractInfoQueries = _interopRequireWildcard(_graphqlQueries);

var _productGraphqlQuery = __webpack_require__(865);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* global window */


// import * as companyGQL from './stores/company/company/company-graphql-query';

var API_ROOT = '/proxy/';
var API_CONTENTFUL = 'https://cdn.contentful.com/';
var API_URL = undefined || "https://rest.tourconnect.com";

var jsonDecode = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
    var jsonRet;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return response.json();

          case 3:
            jsonRet = _context.sent;
            return _context.abrupt('return', jsonRet);

          case 7:
            _context.prev = 7;
            _context.t0 = _context['catch'](0);
            return _context.abrupt('return', {});

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[0, 7]]);
  }));

  return function jsonDecode(_x) {
    return _ref.apply(this, arguments);
  };
}();

var callApi = exports.callApi = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(endpoint) {
    var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
    var bodyParam = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var useOriginalUrl = arguments[3];
    var fullUrl, body, response, json;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            fullUrl = endpoint.indexOf(API_ROOT) === -1 && !useOriginalUrl ? API_ROOT + endpoint : endpoint;
            body = bodyParam ? JSON.stringify(bodyParam) : null;
            response = void 0;
            _context2.prev = 3;
            _context2.next = 6;
            return fetch(fullUrl, {
              method: method,
              credentials: 'same-origin',
              headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
              body: body
            });

          case 6:
            response = _context2.sent;
            _context2.next = 12;
            break;

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2['catch'](3);

            response = _context2.t0;

          case 12:
            _context2.next = 14;
            return jsonDecode(response);

          case 14:
            json = _context2.sent;

            if (response.ok) {
              _context2.next = 17;
              break;
            }

            return _context2.abrupt('return', {
              error: {
                response: response,
                json: json,
                request: {
                  url: fullUrl,
                  body: body,
                  method: method
                }
              }
            });

          case 17:
            return _context2.abrupt('return', { response: json });

          case 18:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[3, 9]]);
  }));

  return function callApi(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var callApiJWT = exports.callApiJWT = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(endpoint) {
    var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
    var bodyParam = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var fullUrl, token, body, response, json, newToken;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            fullUrl = /^https?:\/\/*/.test(endpoint) ? endpoint : '' + API_URL + endpoint;
            token = localStorage.getItem('jwt');

            if (token) {
              _context3.next = 4;
              break;
            }

            return _context3.abrupt('return', {});

          case 4:
            body = bodyParam ? JSON.stringify(bodyParam) : null;
            response = void 0;
            _context3.prev = 6;
            _context3.next = 9;
            return fetch(fullUrl, {
              method: method,
              credentials: 'same-origin',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
              },
              body: body
            });

          case 9:
            response = _context3.sent;
            _context3.next = 15;
            break;

          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3['catch'](6);

            response = _context3.t0;

          case 15:
            _context3.next = 17;
            return jsonDecode(response);

          case 17:
            json = _context3.sent;

            if (response.ok) {
              _context3.next = 21;
              break;
            }

            // if something is wrong with jwt, force reauthenticate
            if (json.code === 'InvalidCredentials') {
              if (json.message.indexOf('jwt expired') > -1) {
                localStorage.removeItem('jwt');
              }
              window.location.assign(window.location.protocol + '//' + window.location.host + '/signin?logout=true');
            }
            return _context3.abrupt('return', {
              error: {
                response: response,
                json: json,
                request: {
                  url: fullUrl,
                  body: body,
                  method: method
                }
              }
            });

          case 21:
            newToken = response.headers.get('new-token');

            if (Boolean(newToken)) localStorage.setItem('jwt', newToken);
            return _context3.abrupt('return', { response: json });

          case 24:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[6, 12]]);
  }));

  return function callApiJWT(_x5) {
    return _ref3.apply(this, arguments);
  };
}();

var callApiwithToken = exports.callApiwithToken = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(endpoint) {
    var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
    var bodyParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var fullUrl, body, hashtoken, encryptedemail, response, json;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            fullUrl = /^https?:\/\/*/.test(endpoint) ? endpoint : API_URL + endpoint;
            body = bodyParams ? JSON.stringify(bodyParams) : null;
            hashtoken = sessionStorage.getItem('hashtoken') || '';
            encryptedemail = sessionStorage.getItem('encryptedemail') || '';
            response = void 0;
            _context4.prev = 5;
            _context4.next = 8;
            return fetch(fullUrl, {
              method: method,
              // credentials: 'same-origin',
              // mode: 'no-cors',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                hashtoken: hashtoken,
                encryptedemail: encryptedemail
              },
              body: body
            });

          case 8:
            response = _context4.sent;
            _context4.next = 14;
            break;

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4['catch'](5);

            response = _context4.t0;

          case 14:
            _context4.next = 16;
            return jsonDecode(response);

          case 16:
            json = _context4.sent;

            if (response.ok) {
              _context4.next = 19;
              break;
            }

            return _context4.abrupt('return', {
              error: {
                response: response,
                json: json,
                request: {
                  url: fullUrl,
                  body: body,
                  method: method
                }
              }
            });

          case 19:
            return _context4.abrupt('return', { response: json });

          case 20:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined, [[5, 11]]);
  }));

  return function callApiwithToken(_x8) {
    return _ref4.apply(this, arguments);
  };
}();

// api services
var account = exports.account = {
  getUsersById: function getUsersById(_ref5) {
    var companyId = _ref5.companyId;
    return callApi('/proxy/company/' + companyId + '/users', 'get');
  },
  confirmEmail: function confirmEmail(token) {
    return callApi('/proxy/confirm-signin-email', 'put', { token: token });
  },
  login: function login(payload) {
    return callApi('/signin', 'post', payload, true);
  },
  shellSignUp: function shellSignUp(payload) {
    return callApiwithToken('/contractingSignUp/signUp', 'post', payload);
  },
  loginAsUser: function loginAsUser(payload) {
    return callApi('/loginAsUser', 'post', payload, true);
  },
  sendInternalEmail: function sendInternalEmail(payload) {
    return callApi('/internal/notification', 'post', payload);
  },
  sendNotification: function sendNotification(payload) {
    return callApiJWT('/sendNotification', 'post', payload);
  },
  updateUIpreferences: function updateUIpreferences(payload) {
    return callApiJWT('/updateUIpreferences', 'put', payload);
  }
};

var partner = exports.partner = {
  getCompanyInfo: function getCompanyInfo(_ref6) {
    var partnerId = _ref6.partnerId;
    return callApi('partner/' + partnerId, 'get');
  },
  getActivities: function getActivities(_ref7) {
    var assetId = _ref7.assetId,
        activityType = _ref7.activityType;
    return callApiJWT('/asset-activities/' + assetId + '?activityType=' + (activityType || ''), 'get');
  },
  addConnectionAsPartner: function addConnectionAsPartner(_ref8) {
    var connectionId = _ref8.connectionId,
        targetCompanyId = _ref8.targetCompanyId;
    return callApiJWT('/partner-management/partner/connection', 'post', { connectionId: connectionId, targetCompanyId: targetCompanyId });
  }
};

var workspace = exports.workspace = {
  getConnections: function getConnections() {
    var selectedConnection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return callApi('workspace/connections' + (selectedConnection ? '/' + selectedConnection : ''), 'get');
  },
  archiveConnection: function archiveConnection(connection) {
    return callApi('workspace/connections/' + connection + '/archive', 'get');
  },
  deleteMessage: function deleteMessage(message) {
    return callApi('workspace/message/' + message, 'delete');
  },
  getChannels: function getChannels(connection) {
    var channel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var contract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    if (!contract) return callApi('workspace/connections/' + connection + '/channels', 'get');
    return callApi('workspace/connections/' + connection + '/channels/' + channel + '/' + contract, 'get');
  },
  getConversations: function getConversations(assetId, channelId) {
    return callApi('workspace/connections/' + assetId + '/channels/' + channelId + '/conversation', 'get');
  },
  archiveConversation: function archiveConversation(connection, channel, contract) {
    return callApi('workspace/connections/' + connection + '/channels/' + channel + '/archive/' + (contract || ''), 'post');
  },
  newMessage: function newMessage(body) {
    return callApi('workspace/newMessage', 'post', body);
  },
  saveSelectedChannel: function saveSelectedChannel(partnerId, channel) {
    return callApi('workspace/connections/' + partnerId, 'post', { lastChannel: channel });
  },
  conversationsRead: function conversationsRead(_ref9) {
    var assetId = _ref9.assetId,
        _ref9$assetType = _ref9.assetType,
        assetType = _ref9$assetType === undefined ? 'partner' : _ref9$assetType,
        messageId = _ref9.messageId;
    return callApiJWT('/workspace/markRead', 'post', { assetId: assetId, assetType: assetType, messageId: messageId });
  },
  statusMessages: function statusMessages() {
    return callApiJWT('/statusMessages', 'get');
  },
  unreadAcceptedRead: function unreadAcceptedRead(connectionIds) {
    return callApi('/statusMessages/markConnectionAcceptedAsRead', 'post', { connectionIds: connectionIds });
  },
  getActivities: partner.getActivities
};

var historyFeed = exports.historyFeed = {
  getHistory: function getHistory(contractId) {
    return callApi('/proxy/contracting/getHistoryFeed/' + contractId + '/contract', 'get');
  }
};

var fileUrls = exports.fileUrls = {
  getDownloadUrlSync: function getDownloadUrlSync(path) {
    if (path && path.indexOf('/') > -1) return API_ROOT + 's3/file?key=' + encodeURIComponent(path);
    return '/filebyhash/' + path;
  },
  getDownloadTCContractingDoc: function getDownloadTCContractingDoc(_ref10) {
    var docId = _ref10.docId,
        _ref10$collection = _ref10.collection,
        collection = _ref10$collection === undefined ? 'contract' : _ref10$collection,
        locale = _ref10.locale,
        ratesOnly = _ref10.ratesOnly,
        downloadRateFormat = _ref10.downloadRateFormat,
        forAL = _ref10.forAL;

    var url = void 0;
    if (forAL) {
      url = (downloadRateFormat || '').split('_')[0] === 'quickview' ? '/landingproxy/contracting/pipeXls' : '/landingproxy/download-pdf';
    } else {
      url = (downloadRateFormat || '').split('_')[0] === 'quickview' ? '/proxy/contracting/pipeXls' : '/proxy/download-pdf';
    }
    var qs = _queryString2.default.stringify({
      docId: docId,
      locale: locale,
      collection: collection,
      ratesOnly: downloadRateFormat === 'condensed' || ratesOnly,
      type: (downloadRateFormat || '').indexOf('quickview') > -1 ? (downloadRateFormat || '').split('_')[1] : ''
    });
    return url + '?' + qs;
  },
  downloadGroup: function downloadGroup(_ref11) {
    var _ref11$collection = _ref11.collection,
        collection = _ref11$collection === undefined ? 'contract' : _ref11$collection,
        locale = _ref11.locale,
        downloadRateFormat = _ref11.downloadRateFormat,
        forAL = _ref11.forAL,
        docIds = _ref11.docIds;

    var qs = _queryString2.default.stringify({
      locale: locale,
      collection: collection,
      downloadRateFormat: downloadRateFormat
    });
    var url = '/contracting/download-group?' + qs;
    var params = { docIds: docIds };
    var callFunc = forAL ? callApiwithToken : callApiJWT;
    return callFunc(url, 'post', params);
  },
  checkJobUrl: function checkJobUrl(_ref12) {
    var jobUrl = _ref12.jobUrl,
        forAL = _ref12.forAL;

    var callFunc = forAL ? callApiwithToken : callApiJWT;
    return callFunc(jobUrl, 'get');
  }
};

var downloads = exports.downloads = {
  downloadTCContractingDoc: function downloadTCContractingDoc(payload) {
    // window.open(fileUrls.getDownloadTCContractingDoc(payload));
    var downloadUrl = fileUrls.getDownloadTCContractingDoc(payload);
    var a = document.createElement('a');
    a.download = true;
    a.target = '_blank';
    a.setAttribute('download', true);
    a.href = downloadUrl;
    a.dispatchEvent(new MouseEvent('click'));
  },
  getXls: function getXls(docType, docId, exportType) {
    return callApi('contracting/exportXls/' + docType + '/' + docId + '?type=' + exportType, 'get');
  }
};

var contracting = {
  deleteOrUndelete: function deleteOrUndelete(params) {
    return callApi('/proxy/contracting/deleteOrUndelete', 'put', params);
  }, // params: { contractIds, state: <true or false> } true means delete, false means restore
  getContractList: function getContractList(params) {
    return callApiJWT('/contracting/contracts', 'post', params);
  },
  checkContractReadiness: function checkContractReadiness(draftId) {
    return callApiJWT('/contracting/checkContractReadiness/' + draftId, 'put');
  },
  getRespondedContractList: function getRespondedContractList(_ref13) {
    var requestId = _ref13.requestId;
    return callApiJWT('/contracting/request/' + requestId + '/contracts', 'get');
  },
  getContractRequestInfo: function getContractRequestInfo(_ref14) {
    var requestId = _ref14.requestId;

    return callApiJWT('/contracting/getContractInfo/' + requestId, 'post', {
      query: '\n          query getContract ($contractId: ID!, $viewerId: ID!, $viewBy: String!) {\n            Contract (id: $contractId, viewerId: $viewerId, viewBy: $viewBy) {\n              contractId\n              startDate\n              endDate\n              supplierId\n              buyerId\n              buyerChecked\n              buyerInfo {\n                submissionCriteria\n                termsAndConditions\n              }\n              partners {\n                id\n                name\n                avatar\n                tags {\n                  id\n                  name\n                }\n                contacts {\n                  firstName\n                  lastName\n                  email\n                  id\n                }\n              }\n              contacts {\n                id\n                firstName\n                lastName\n                email\n              }\n              from {\n                avatar\n                name\n                email\n              }\n              to {\n                avatar\n                name\n                partnerId\n                contactIds\n              }\n            }\n          }\n        ',
      contractId: requestId,
      collection: 'contract'
    });
  },
  getContractPartners: function getContractPartners(_ref15) {
    var contractId = _ref15.contractId;

    return callApiJWT('/contracting/getContractInfo/' + contractId, 'post', {
      query: '\n          query getContract ($contractId: ID!, $viewerId: ID!, $viewBy: String!) {\n            Contract (id: $contractId, viewerId: $viewerId, viewBy: $viewBy) {\n              partners {\n                id\n                name\n                tags {\n                  id\n                  name\n                }\n                contacts {\n                  id\n                  firstName\n                  lastName\n                  email\n                }\n              }\n            }\n          }\n        ',
      contractId: contractId,
      collection: 'contract'
    });
  },
  getContractInfo: function getContractInfo(_ref16) {
    var collection = _ref16.collection,
        docId = _ref16.docId,
        type = _ref16.type,
        forAL = _ref16.forAL;

    // type: 'metaData', 'content'
    var callFunc = forAL ? callApi : callApiJWT;
    return callFunc((forAL ? '/landingproxy' : '') + '/contracting/getContractInfo/' + docId, 'post', {
      query: function () {
        if (type === 'policyNotes') {
          return collection === 'contract' || collection === 'workspace' ? contractInfoQueries.getContractDetailsQuery : contractInfoQueries.draftTemplateContractDetails;
        }
        return collection === 'contract' || collection === 'workspace' ? contractInfoQueries.getLeftNavQuery : contractInfoQueries.draftTemplateLeftNav;
      }(),
      contractId: docId,
      collection: collection === 'workspace' ? 'contract' : collection
    }, true);
  },
  getContractProductInfo: function getContractProductInfo(_ref17) {
    var docId = _ref17.docId,
        productId = _ref17.productId,
        ratePackage = _ref17.ratePackage,
        collection = _ref17.collection;

    return callApiJWT('/contracting/getProductInfo/' + docId + '/' + productId + '/' + ratePackage, 'post', {
      query: collection === 'contract' || collection === 'workspace' ? contractInfoQueries.getProductDetailsQuery : contractInfoQueries.draftTemplateProductQuery,
      contractId: docId,
      productId: productId,
      collection: collection === 'workspace' ? 'contract' : collection
    });
  },
  manageExtrasOffers: function manageExtrasOffers(_ref18) {
    var draftId = _ref18.draftId,
        list = _ref18.list,
        type = _ref18.type;

    return callApiJWT('/contracting/contract/product/shared-data', 'put', { draftId: draftId, list: list, type: type });
  },
  archiveUnarchiveTemplate: function archiveUnarchiveTemplate(_ref19) {
    var templateId = _ref19.templateId,
        isArchived = _ref19.isArchived;
    return callApi('/proxy/contracting/template/' + templateId + '/archiveUnarchive', 'put', { isArchived: isArchived });
  },
  updateFolders: function updateFolders(_ref20) {
    var folders = _ref20.folders,
        originalFolder = _ref20.originalFolder,
        newFolderName = _ref20.newFolderName;

    return callApi('/proxy/contracting/contract-list/folder', 'put', { folders: folders, originalFolder: originalFolder, newFolderName: newFolderName });
  },
  updatePartnerForSentDoc: function updatePartnerForSentDoc(_ref21) {
    var contractId = _ref21.contractId,
        extraPayload = _objectWithoutProperties(_ref21, ['contractId']);

    return callApi('/proxy/contracting/contract/' + contractId + '/partner', 'put', extraPayload);
  },
  addFilesToContract: function addFilesToContract(_ref22) {
    var contractId = _ref22.contractId,
        files = _ref22.files,
        msgId = _ref22.msgId;
    return callApi('/proxy/contracting/contract/files', 'post', { contractId: contractId, files: files, msgId: msgId });
  },
  submitContractingComment: function submitContractingComment(_ref23) {
    var historyFeedId = _ref23.historyFeedId,
        payload = _objectWithoutProperties(_ref23, ['historyFeedId']);

    return callApi('/proxy/contracting/saveComment/' + historyFeedId, 'put', payload);
  },
  getContractForwardingEmail: function getContractForwardingEmail(contractId) {
    return callApi('/proxy/contracting/contract/forwardingemail', 'post', { contractId: contractId });
  },
  getDiffReport: function getDiffReport(_ref24) {
    var docs = _ref24.docs,
        onlyGetSummary = _ref24.onlyGetSummary;
    return callApi('/proxy/contracting/report/diff/' + docs + '?onlyGetSummary=' + onlyGetSummary, 'get');
  },
  /*
  * difference between getTemplates and getTemplateList
  *
  * getTemplates only provides completed templates and template groups,
  * and is currently being used in send rates wizard
  *
  * getTemplateList provides all templates, initial drafts, and template groups
  * */
  getTemplates: function getTemplates(_ref25) {
    var query = _ref25.query;

    var qs = query ? _queryString2.default.stringify({ additionalQuery: JSON.stringify(query) }) : '';
    return callApi('/proxy/contracting/templates?' + qs);
  },
  getTemplateList: function getTemplateList() {
    return callApi('/proxy/contracting/template-list?');
  },
  getTemplatesForLocOrCC: function getTemplatesForLocOrCC(_ref26) {
    var locationId = _ref26.locationId,
        searchInput = _ref26.searchInput;

    return callApi('/proxy/contracting/location/' + locationId + '/templates?searchInput=' + searchInput);
  },
  getContracts: function getContracts(_ref27) {
    var query = _ref27.query,
        _ref27$includeTemplat = _ref27.includeTemplateNames,
        includeTemplateNames = _ref27$includeTemplat === undefined ? false : _ref27$includeTemplat;

    var qs = query ? _queryString2.default.stringify({ additionalQuery: JSON.stringify(query), includeTemplateNames: includeTemplateNames }) : '';
    return callApi('/proxy/contracting/contracts?' + qs);
  },
  getFolders: function getFolders() {
    return callApi('/proxy/contracting/contract-list/folder');
  },
  sendContract: function sendContract(_ref28) {
    var payload = _ref28.payload;
    return callApi('contracting/supplier/sendContracts', 'post', payload);
  },
  sendContractRequest: function sendContractRequest(_ref29) {
    var payload = _ref29.payload;
    return callApi('contracting/request', 'post', payload);
  },
  supplierSendUpdates: function supplierSendUpdates(_ref30) {
    var templateIds = _ref30.templateIds,
        subject = _ref30.subject;
    return callApi('contracting/supplier-updates', 'post', { templateIds: templateIds, subject: subject });
  },
  updateSameAsCorporatePolicyNotes: function updateSameAsCorporatePolicyNotes(_ref31) {
    var templateDraftId = _ref31.templateDraftId,
        sameAsCorporatePolicyNotes = _ref31.sameAsCorporatePolicyNotes;
    return callApi('/proxy/contracting/draft/sameAsCorporatePolicyNotes', 'put', { templateDraftId: templateDraftId, sameAsCorporatePolicyNotes: sameAsCorporatePolicyNotes });
  },
  removePolicyNotesTemplate: function removePolicyNotesTemplate(templateDraftId) {
    return callApi('/proxy/contracting/draft/policyNotesTemplate/' + templateDraftId, 'delete');
  },
  contractFromHF: function contractFromHF(payload) {
    return callApi('contracting/contractIdFromHistoryFeedId/' + payload.historyFeedId, 'post', payload);
  },
  addDraftToQueue: function addDraftToQueue(_ref32) {
    var templateId = _ref32.templateId,
        source = _ref32.source,
        sourceId = _ref32.sourceId,
        message = _ref32.message;
    return callApi('/proxy/contracting/supplier-updates/queue', 'post', {
      templateId: templateId,
      source: source,
      sourceId: sourceId,
      message: message
    });
  },
  removeDraftOutOfQueue: function removeDraftOutOfQueue(_ref33) {
    var templateId = _ref33.templateId,
        sourceId = _ref33.sourceId;
    return callApi('/proxy/contracting/supplier-updates/queue', 'delete', {
      templateId: templateId,
      sourceId: sourceId
    });
  },
  removeSingleFeedByTCAdmin: function removeSingleFeedByTCAdmin(_ref34) {
    var messageId = _ref34.messageId,
        historyFeedId = _ref34.historyFeedId;
    return callApi('/proxy/asset-activity/' + messageId, 'put', {
      assetId: historyFeedId
    });
  },
  fileContractForRequest: function fileContractForRequest(_ref35) {
    var requestId = _ref35.requestId,
        contractId = _ref35.contractId;
    return callApi('/proxy/contracting/buyer/fileContractForRequest', 'post', {
      requestId: requestId,
      contractId: contractId
    });
  },
  removeContractsFromRequests: function removeContractsFromRequests(_ref36) {
    var requestId = _ref36.requestId,
        contractIds = _ref36.contractIds;
    return callApi('/proxy/contracting/buyer/removeContractsFromRequests', 'post', {
      requestId: requestId,
      contractIds: contractIds
    });
  },
  updateContractStatus: function updateContractStatus(payload) {
    return callApi(payload.forAL ? '/landingproxy/contracting/updateContractStatus' : '/proxy/contracting/updateContractStatus', 'put', payload, true);
  },
  requestDL: function requestDL(payload) {
    return callApiJWT('/contracting/requestDL', 'put', payload);
  },
  getTemplateChangeLog: function getTemplateChangeLog(threadId, search) {
    return callApiJWT('/contracting/template/logs/' + threadId + search, 'get');
  },
  createTemplatesInDummyAcct: function createTemplatesInDummyAcct(payload) {
    return callApiJWT('/contracting/cr-dl/start', 'post', payload);
  },
  acceptDummyTemplate: function acceptDummyTemplate(payload) {
    return callApiJWT('/contracting/dummy/template/accept', 'put', payload);
  },
  sendRCMsg: function sendRCMsg(payload) {
    return callApiJWT('/contracting/send-rc-msg', 'post', payload);
  },
  // update data in the rate container/request that's only for the buyer
  updateWorkspaceContract: function updateWorkspaceContract(payload) {
    return callApiJWT('/contracting/workspace-contract', 'put', payload);
  },
  submitRCRates: function submitRCRates(payload) {
    return callApiJWT('/contracting/submitRCRates', 'post', payload);
  },
  createTemplateDraft: function createTemplateDraft(payload) {
    return callApiJWT('/contracting/draft/' + payload.contractId, 'post', payload);
  },
  createEditedDraftForBuyer: function createEditedDraftForBuyer(payload) {
    return callApiJWT('/contracting/buyer/draft', 'post', payload);
  },
  omniImport: function omniImport(payload) {
    return callApiJWT('/contracting/template/omniimport', 'put', payload);
  },
  deleteTemplateDraft: function deleteTemplateDraft(payload) {
    return callApiJWT('/contracting/template/draft', 'delete', payload);
  },
  loadDataForIframe: function loadDataForIframe(payload) {
    return callApiJWT('/contracting/getContractInfo/' + payload.rateDocId, 'post', {
      query: '\n          query getContract ($contractId: ID!, $collection: String!, $viewerId: ID!, $viewBy: String!) {\n            DraftnTemplate (id: $contractId, collection: $collection, viewerId: $viewerId, viewBy: $viewBy) {\n              completionPercent\n              acceptedBy\n              crIds\n              ownerIds\n              defaultInvitees\n              signatures {\n                 invitee\n                 inviteSentAt\n                 signedBy\n                 signedAt\n              }\n              originFrom\n              draftType\n              editHistory {\n                detail\n                productId\n                ratePackageName\n              }\n            }\n          }\n        ',
      contractId: payload.rateDocId,
      collection: payload.collection
    });
  },
  deleteEditedDraft: function deleteEditedDraft(originalContractId) {
    return callApiJWT('/contracting/discardEditedDraft/' + originalContractId, 'delete');
  },
  updateProductNameBeddingConfig: function updateProductNameBeddingConfig(payload) {
    return callApiJWT('/contracting/updateProductNameBeddingConfig', 'put', payload);
  },
  makeACopyForBuyer: function makeACopyForBuyer(payload) {
    return callApiJWT('/contracting/buyer/makeACopy', 'post', payload);
  },
  resendContract: function resendContract(payload) {
    return callApiJWT('/contracting/resendContract/' + payload.contractId, 'put', payload);
  }
};

exports.contracting = contracting;
var masterTemplates = exports.masterTemplates = {
  getAll: function getAll(type) {
    return callApi('/proxy/contracting/master-templates/' + type, 'get');
  },
  getOne: function getOne(id) {
    return callApi('/proxy/contracting/master-template/' + id, 'get');
  },
  getDiff: function getDiff(_ref37) {
    var lhsDocId = _ref37.lhsDocId,
        rhsDocId = _ref37.rhsDocId,
        onlyGetSummary = _ref37.onlyGetSummary;
    return callApi('/proxy/contracting/master-template-diff', 'post', { lhsDocId: lhsDocId, rhsDocId: rhsDocId, onlyGetSummary: onlyGetSummary });
  },
  createInitial: function createInitial(_ref38) {
    var type = _ref38.type,
        templateName = _ref38.templateName;
    return callApi('/proxy/contracting/initial-master-template-draft', 'post', { type: type, templateName: templateName });
  },
  createEditedDraft: function createEditedDraft(id) {
    return callApi('/proxy/contracting/edited-master-template-draft', 'post', { id: id });
  },
  edit: function edit(id, updates) {
    return callApi('/proxy/contracting/master-template/edit/' + id, 'put', { updates: updates });
  },
  finalise: function finalise(draftId) {
    return callApi('/proxy/contracting/master-template/finalise', 'put', { draftId: draftId });
  },
  applyMasterToTemplates: function applyMasterToTemplates(_ref39) {
    var masterTemplateId = _ref39.masterTemplateId,
        type = _ref39.type,
        templateDraftIds = _ref39.templateDraftIds,
        sameAsCorporatePolicyNotes = _ref39.sameAsCorporatePolicyNotes,
        honorPreloadContent = _ref39.honorPreloadContent;
    return callApi('/proxy/contracting/master-template/associate/templates', 'put', {
      masterTemplateId: masterTemplateId,
      type: type,
      templateDraftIds: templateDraftIds,
      sameAsCorporatePolicyNotes: sameAsCorporatePolicyNotes,
      honorPreloadContent: honorPreloadContent
    });
  },
  discardDraft: function discardDraft(draftId) {
    return callApi('/proxy/contracting/master-template-draft/' + draftId, 'delete');
  },
  getAssociatedTemplates: function getAssociatedTemplates(_ref40) {
    var id = _ref40.id,
        type = _ref40.type;
    return callApi('/proxy/contracting/master-template/templates', 'post', { id: id, type: type });
  },
  renameTemplate: function renameTemplate(_ref41) {
    var id = _ref41.id,
        newName = _ref41.newName;
    return callApi('/proxy/contracting/master-template/name', 'put', { id: id, newName: newName });
  },
  deleteTemplate: function deleteTemplate(_ref42) {
    var id = _ref42.id;
    return callApi('/proxy/contracting/master-template/' + id, 'delete');
  },
  getAffectedBuyers: function getAffectedBuyers(id) {
    return callApi('/proxy/contracting/master-template/buyers/' + id, 'get');
  }
};

var admin = exports.admin = {
  toogleTourWriter: function toogleTourWriter(companyId, enabled) {
    return callApi('/proxy/admin/toggleTourWriter', 'post', { companyId: companyId, enabled: enabled });
  },
  toogleTourplan: function toogleTourplan(companyId, enabled) {
    return callApi('/proxy/admin/toggleTourplan', 'post', { companyId: companyId, enabled: enabled });
  },
  convertUserToAssociatedEmail: function convertUserToAssociatedEmail(userId) {
    return callApi('/proxy/admin/turnUserIntoAssociatedEmail', 'post', { userId: userId });
  },
  consolidateAccount: function consolidateAccount(email, companyId, associateEmail) {
    return callApi('/proxy/admin/consolidate', 'post', { email: email, companyId: companyId, associateEmail: associateEmail, getList: false });
  },
  consolidateAccountTest: function consolidateAccountTest(email, companyId) {
    return callApi('/proxy/admin/consolidate', 'post', { email: email, companyId: companyId, getList: true });
  },
  updatePropertyNameForContractingDocs: function updatePropertyNameForContractingDocs(payload) {
    return callApi('/proxy/admin/contracting/docs', 'put', payload);
  },
  getSignedToken: function getSignedToken(payload) {
    return callApi('/proxy/admin/getSignedToken', 'post', payload);
  },
  getSessionInfo: function getSessionInfo() {
    return callApi('/getSessionInfo', 'get', null, true);
  },
  getDLQueue: function getDLQueue() {
    return callApi('/proxy/dl-queue', 'get');
  },
  updateTemplateInQueue: function updateTemplateInQueue(payload) {
    return callApi('/proxy/dl-queue/template', 'put', payload);
  },
  addNote: function addNote(payload) {
    return callApi('/proxy/dl-queue/note', 'post', payload);
  },
  addTemplate: function addTemplate(id) {
    return callApi('/proxy/dl-queue/template', 'post', { id: id });
  },
  deleteTemplateFromQueue: function deleteTemplateFromQueue(templateId) {
    return callApi('/proxy/dl-queue/template/' + templateId, 'delete');
  },
  deleteSupplierFromQueue: function deleteSupplierFromQueue(supplierId) {
    return callApi('/proxy/dl-queue/supplier/' + supplierId, 'delete');
  },
  toggleTCVerified: function toggleTCVerified(payload) {
    return callApi('admin/toggleTCVerified', 'post', payload);
  },
  resendBulkMessage: function resendBulkMessage(payload) {
    return callApi('admin/resendBulkMessage', 'post', payload);
  }
};

var connection = exports.connection = {
  pendingInvites: function pendingInvites(payload) {
    return callApi('/proxy/connections?status=invites&get=' + payload.get, 'get');
  }
};

var massMessage = exports.massMessage = {
  newMessage: function newMessage(body) {
    return callApi('workspace/newMassMessage', 'post', body);
  },
  getPartners: function getPartners() {
    return callApi('partners', 'get');
  }
};

var profile = exports.profile = {
  getUserLocationProfile: function getUserLocationProfile() {
    var _ref43 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        locationId = _ref43.locationId;

    var qs = _queryString2.default.stringify({ query: _locationGraphqlQuery.myLocationProfileQuery });
    return callApi('/proxy/profile/locations/' + locationId + '?' + qs, 'get');
  },
  getCompanyProfile: function getCompanyProfile() {
    return callApi('/proxy/profile?query=' + _profileGraphqlQuery.profileQuery, 'get');
  },
  updateGroup: function updateGroup(payload) {
    return callApi('/proxy/profile/group', 'put', payload);
  },
  deleteGroup: function deleteGroup(payload) {
    return callApi('/proxy/profile/group', 'delete', payload);
  },
  reorderLocations: function reorderLocations(locationIds) {
    return callApi('/proxy/profile/reorderLocations', 'put', { locationIds: locationIds });
  },
  reorderProducts: function reorderProducts(productIds) {
    return callApi('/proxy/profile/reorderProducts', 'put', { productIds: productIds });
  },
  editProductField: function editProductField(_ref44) {
    var updateField = _ref44.updateField,
        updateBody = _ref44.updateBody,
        productId = _ref44.productId,
        locationId = _ref44.locationId;

    var body = updateBody;
    if ((updateField === 'coverImageUrl' || updateField === 'profileImageUrl') && updateBody) {
      body += '?' + Date.now();
    }
    return callApiJWT('/profile/products/' + productId + '?mutation=' + _productGraphqlQuery.myProductMutation, 'put', {
      locationId: locationId,
      update: _defineProperty({}, updateField, body)
    });
  }
};

var assetLanding = exports.assetLanding = {
  ezLoadRequest: function ezLoadRequest(payload) {
    return callApiwithToken('/dl-queue/supplier', 'post', {
      supplierId: payload.supplierId,
      files: payload.files,
      requests: payload.requests,
      email: payload.email
    });
  },
  sendExternalRates: function sendExternalRates(payload) {
    return callApiwithToken('/landing/sendExternalRates', 'post', {
      subject: payload.subject,
      message: payload.message,
      files: payload.files,
      requests: payload.requests,
      userId: payload.userId,
      fromEmail: payload.fromEmail,
      supplierId: payload.supplierId
    });
  },
  authByToken: function authByToken() {
    var hashToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'oldUrl';
    var encryptedEmail = arguments[1];
    return callApi('/authByToken', 'post', { hashToken: hashToken, encryptedEmail: encryptedEmail }, true);
  },
  verifyToken: function verifyToken() {
    var hashToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'oldUrl';
    var oldUrlPayload = arguments[1];
    return callApiwithToken('/verifyToken/' + hashToken, 'post', { oldUrlPayload: oldUrlPayload });
  },
  getAssets: function getAssets(senderId) {
    return callApiwithToken('/landing/assets?senderId=' + senderId, 'get', null);
  },
  // TODO: replace with real endpoint
  checkDummyAccount: function checkDummyAccount(payload) {
    return callApiwithToken('/landing/checkDummyAccount?hashToken=' + payload.shortid + '&contractId=' + payload.contractId, 'get');
  },
  signRateDocs: function signRateDocs(payload) {
    return callApiwithToken('/contracting/submitRCRates', 'post', payload);
  },
  markDummyTemplateAsViewed: function markDummyTemplateAsViewed(payload) {
    return callApiwithToken('/contracting/dummy/template/viewed', 'put', payload);
  }
};

var settings = exports.settings = {
  getSettings: function getSettings() {
    return callApi('settings', 'get');
  },
  saveSettings: function saveSettings(payload) {
    return callApi('settings', 'put', payload);
  }
};

// Contentful for sidebar

var buildURLQuery = function buildURLQuery(obj) {
  return Object.entries(obj).map(function (pair) {
    return pair.map(encodeURIComponent).join('=');
  }).join('&');
};

function contentfulApi() {
  var _ref45 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref45$accessToken = _ref45.accessToken,
      accessToken = _ref45$accessToken === undefined ? '' + "5829e984567fa554706e6cfed3a025cfcf1df1d9a1495ef9b32962299e4400ac" : _ref45$accessToken,
      _ref45$bodyParam = _ref45.bodyParam,
      bodyParam = _ref45$bodyParam === undefined ? null : _ref45$bodyParam,
      endpoint = _ref45.endpoint,
      _ref45$environment = _ref45.environment,
      environment = _ref45$environment === undefined ? 'master' : _ref45$environment,
      _ref45$method = _ref45.method,
      method = _ref45$method === undefined ? 'get' : _ref45$method,
      _ref45$searchParams = _ref45.searchParams,
      searchParams = _ref45$searchParams === undefined ? {} : _ref45$searchParams,
      _ref45$space = _ref45.space,
      space = _ref45$space === undefined ? 'wwevjgfp8hg4' : _ref45$space;

  searchParams.access_token = accessToken;
  var fullUrl = API_CONTENTFUL + 'spaces/' + space + '/environments/' + environment + '/' + endpoint + '?' + buildURLQuery(searchParams);
  var body = bodyParam ? JSON.stringify(bodyParam) : null;
  return fetch(fullUrl, {
    method: method,
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: body
  }).then(function (response) {
    return response.json().then(function (json) {
      return { json: json, response: response };
    });
  }).then(function (_ref46) {
    var json = _ref46.json,
        response = _ref46.response;

    if (!response.ok) {
      return Promise.reject(json);
    }
    if (Array.isArray(json)) return json;
    return _extends({}, json);
  }).then(function (response) {
    return { response: response };
  }, function (error) {
    return { error: error || 'Something bad happened' };
  });
}

var contentful = exports.contentful = {
  sidebarHelp: {
    getAllEntries: function getAllEntries() {
      return contentfulApi({ endpoint: 'entries', searchParams: { content_type: 'sidebarHelp', select: 'sys.id,fields.matchingUrls,fields.matchingRole,fields.title' } });
    },
    getHelp: function getHelp(articleId) {
      return contentfulApi({ endpoint: 'entries', searchParams: { content_type: 'sidebarHelp', 'sys.id': articleId } });
    }
  }
};

var integration = exports.integration = {
  saveExportResponse: function saveExportResponse(payload) {
    return callApiJWT('/integration/saveExportResponse', 'post', payload);
  },
  getJobStatus: function getJobStatus(payload) {
    return callApi('/integrationproxy/jobStatus?jobId=' + payload.jobId, 'get', null, true);
  }
};

var billing = exports.billing = {
  getInvoices: function getInvoices(payload) {
    return callApiJWT('/billing/invoices?starting_after=' + (payload.starting_after || '') + '&ending_before=' + (payload.ending_before || ''), 'get');
  }
};

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns `true` if the first argument is less than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.gte
 * @example
 *
 *      R.lte(2, 1); //=> false
 *      R.lte(2, 2); //=> true
 *      R.lte(2, 3); //=> true
 *      R.lte('a', 'z'); //=> true
 *      R.lte('z', 'a'); //=> false
 */
module.exports = _curry2(function lte(a, b) { return a <= b; });


/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * The `mapAccum` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from left to right, and returning a final value of this
 * accumulator together with the new list.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (acc -> x -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.addIndex, R.mapAccumRight
 * @example
 *
 *      var digits = ['1', '2', '3', '4'];
 *      var appender = (a, b) => [a + b, a + b];
 *
 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
 * @symb R.mapAccum(f, a, [b, c, d]) = [
 *   f(f(f(a, b)[0], c)[0], d)[0],
 *   [
 *     f(a, b)[1],
 *     f(f(a, b)[0], c)[1],
 *     f(f(f(a, b)[0], c)[0], d)[1]
 *   ]
 * ]
 */
module.exports = _curry3(function mapAccum(fn, acc, list) {
  var idx = 0;
  var len = list.length;
  var result = [];
  var tuple = [acc];
  while (idx < len) {
    tuple = fn(tuple[0], list[idx]);
    result[idx] = tuple[1];
    idx += 1;
  }
  return [tuple[0], result];
});


/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * The `mapAccumRight` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from right to left, and returning a final value of this
 * accumulator together with the new list.
 *
 * Similar to [`mapAccum`](#mapAccum), except moves through the input list from
 * the right to the left.
 *
 * The iterator function receives two arguments, *value* and *acc*, and should
 * return a tuple *[value, acc]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (x-> acc -> (y, acc)) -> acc -> [x] -> ([y], acc)
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.addIndex, R.mapAccum
 * @example
 *
 *      var digits = ['1', '2', '3', '4'];
 *      var append = (a, b) => [a + b, a + b];
 *
 *      R.mapAccumRight(append, 5, digits); //=> [['12345', '2345', '345', '45'], '12345']
 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
 *   [
 *     f(b, f(c, f(d, a)[0])[0])[1],
 *     f(c, f(d, a)[0])[1],
 *     f(d, a)[1],
 *   ]
 *   f(b, f(c, f(d, a)[0])[0])[0],
 * ]
 */
module.exports = _curry3(function mapAccumRight(fn, acc, list) {
  var idx = list.length - 1;
  var result = [];
  var tuple = [acc];
  while (idx >= 0) {
    tuple = fn(list[idx], tuple[0]);
    result[idx] = tuple[1];
    idx -= 1;
  }
  return [result, tuple[0]];
});


/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _reduce = __webpack_require__(18);
var keys = __webpack_require__(32);


/**
 * An Object-specific version of [`map`](#map). The function is applied to three
 * arguments: *(value, key, obj)*. If only the value is significant, use
 * [`map`](#map) instead.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig ((*, String, Object) -> *) -> Object -> Object
 * @param {Function} fn
 * @param {Object} obj
 * @return {Object}
 * @see R.map
 * @example
 *
 *      var values = { x: 1, y: 2, z: 3 };
 *      var prependKeyAndDouble = (num, key, obj) => key + (num * 2);
 *
 *      R.mapObjIndexed(prependKeyAndDouble, values); //=> { x: 'x2', y: 'y4', z: 'z6' }
 */
module.exports = _curry2(function mapObjIndexed(fn, obj) {
  return _reduce(function(acc, key) {
    acc[key] = fn(obj[key], key, obj);
    return acc;
  }, {}, keys(obj));
});


/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Tests a regular expression against a String. Note that this function will
 * return an empty array when there are no matches. This differs from
 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
 * which returns `null` when there are no matches.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig RegExp -> String -> [String | Undefined]
 * @param {RegExp} rx A regular expression.
 * @param {String} str The string to match against
 * @return {Array} The list of matches or empty array.
 * @see R.test
 * @example
 *
 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
 *      R.match(/a/, 'b'); //=> []
 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
 */
module.exports = _curry2(function match(rx, str) {
  return str.match(rx) || [];
});


/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _isInteger = __webpack_require__(98);


/**
 * `mathMod` behaves like the modulo operator should mathematically, unlike the
 * `%` operator (and by extension, [`R.modulo`](#modulo)). So while
 * `-17 % 5` is `-2`, `mathMod(-17, 5)` is `3`. `mathMod` requires Integer
 * arguments, and returns NaN when the modulus is zero or negative.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} m The dividend.
 * @param {Number} p the modulus.
 * @return {Number} The result of `b mod a`.
 * @see R.modulo
 * @example
 *
 *      R.mathMod(-17, 5);  //=> 3
 *      R.mathMod(17, 5);   //=> 2
 *      R.mathMod(17, -5);  //=> NaN
 *      R.mathMod(17, 0);   //=> NaN
 *      R.mathMod(17.2, 5); //=> NaN
 *      R.mathMod(17, 5.3); //=> NaN
 *
 *      var clock = R.mathMod(R.__, 12);
 *      clock(15); //=> 3
 *      clock(24); //=> 0
 *
 *      var seventeenMod = R.mathMod(17);
 *      seventeenMod(3);  //=> 2
 *      seventeenMod(4);  //=> 1
 *      seventeenMod(10); //=> 7
 */
module.exports = _curry2(function mathMod(m, p) {
  if (!_isInteger(m)) { return NaN; }
  if (!_isInteger(p) || p < 1) { return NaN; }
  return ((m % p) + p) % p;
});


/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Takes a function and two values, and returns whichever value produces the
 * larger result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.max, R.minBy
 * @example
 *
 *      //  square :: Number -> Number
 *      var square = n => n * n;
 *
 *      R.maxBy(square, -3, 2); //=> -3
 *
 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
 *      R.reduce(R.maxBy(square), 0, []); //=> 0
 */
module.exports = _curry3(function maxBy(f, a, b) {
  return f(b) > f(a) ? b : a;
});


/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var mean = __webpack_require__(189);


/**
 * Returns the median of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.mean
 * @example
 *
 *      R.median([2, 9, 7]); //=> 7
 *      R.median([7, 2, 10, 9]); //=> 8
 *      R.median([]); //=> NaN
 */
module.exports = _curry1(function median(list) {
  var len = list.length;
  if (len === 0) {
    return NaN;
  }
  var width = 2 - len % 2;
  var idx = (len - width) / 2;
  return mean(Array.prototype.slice.call(list, 0).sort(function(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }).slice(idx, idx + width));
});


/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

var memoizeWith = __webpack_require__(191);
var toString = __webpack_require__(60);


/**
 * Creates a new function that, when invoked, caches the result of calling `fn`
 * for a given argument set and returns the result. Subsequent calls to the
 * memoized `fn` with the same argument set will not result in an additional
 * call to `fn`; instead, the cached result for that set of arguments will be
 * returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @see R.memoizeWith
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoize(n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */
module.exports = memoizeWith(toString);


/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

var _assign = __webpack_require__(113);
var _curry2 = __webpack_require__(1);


/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      var resetToDefault = R.merge(R.__, {x: 0});
 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
 * @symb R.merge({ x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: 5, z: 3 }
 */
module.exports = _curry2(function merge(l, r) {
  return _assign({}, l, r);
});


/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

var _assign = __webpack_require__(113);
var _curry1 = __webpack_require__(4);


/**
 * Merges a list of objects together into one object.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig [{k: v}] -> {k: v}
 * @param {Array} list An array of objects
 * @return {Object} A merged object.
 * @see R.reduce
 * @example
 *
 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
 */
module.exports = _curry1(function mergeAll(list) {
  return _assign.apply(null, [{}].concat(list));
});


/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var mergeDeepWithKey = __webpack_require__(86);


/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */
module.exports = _curry2(function mergeDeepLeft(lObj, rObj) {
  return mergeDeepWithKey(function(k, lVal, rVal) {
    return lVal;
  }, lObj, rObj);
});


/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var mergeDeepWithKey = __webpack_require__(86);


/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                       { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
 */
module.exports = _curry2(function mergeDeepRight(lObj, rObj) {
  return mergeDeepWithKey(function(k, lVal, rVal) {
    return rVal;
  }, lObj, rObj);
});


/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var mergeDeepWithKey = __webpack_require__(86);


/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to associated values using the
 *   resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig (a -> a -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWith, R.mergeDeep, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepWith(R.concat,
 *                      { a: true, c: { values: [10, 20] }},
 *                      { b: true, c: { values: [15, 35] }});
 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
 */
module.exports = _curry3(function mergeDeepWith(fn, lObj, rObj) {
  return mergeDeepWithKey(function(k, lVal, rVal) {
    return fn(lVal, rVal);
  }, lObj, rObj);
});


/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var mergeWithKey = __webpack_require__(114);


/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the values
 * associated with the key in each object, with the result being used as the
 * value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig (a -> a -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWith, R.merge, R.mergeWithKey
 * @example
 *
 *      R.mergeWith(R.concat,
 *                  { a: true, values: [10, 20] },
 *                  { b: true, values: [15, 35] });
 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
 */
module.exports = _curry3(function mergeWith(fn, l, r) {
  return mergeWithKey(function(_, _l, _r) {
    return fn(_l, _r);
  }, l, r);
});


/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns the smaller of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.minBy, R.max
 * @example
 *
 *      R.min(789, 123); //=> 123
 *      R.min('a', 'b'); //=> 'a'
 */
module.exports = _curry2(function min(a, b) { return b < a ? b : a; });


/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Takes a function and two values, and returns whichever value produces the
 * smaller result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.min, R.maxBy
 * @example
 *
 *      //  square :: Number -> Number
 *      var square = n => n * n;
 *
 *      R.minBy(square, -3, 2); //=> 2
 *
 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
 */
module.exports = _curry3(function minBy(f, a, b) {
  return f(b) < f(a) ? b : a;
});


/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Divides the first parameter by the second and returns the remainder. Note
 * that this function preserves the JavaScript-style behavior for modulo. For
 * mathematical modulo see [`mathMod`](#mathMod).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The value to the divide.
 * @param {Number} b The pseudo-modulus
 * @return {Number} The result of `b % a`.
 * @see R.mathMod
 * @example
 *
 *      R.modulo(17, 3); //=> 2
 *      // JS behavior:
 *      R.modulo(-17, 3); //=> -2
 *      R.modulo(17, -3); //=> 2
 *
 *      var isOdd = R.modulo(R.__, 2);
 *      isOdd(42); //=> 0
 *      isOdd(21); //=> 1
 */
module.exports = _curry2(function modulo(a, b) { return a % b; });


/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Negates its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number}
 * @example
 *
 *      R.negate(42); //=> -42
 */
module.exports = _curry1(function negate(n) { return -n; });


/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

var _complement = __webpack_require__(168);
var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xany = __webpack_require__(153);
var any = __webpack_require__(152);


/**
 * Returns `true` if no elements of the list match the predicate, `false`
 * otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
 * @see R.all, R.any
 * @example
 *
 *      var isEven = n => n % 2 === 0;
 *
 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
 *      R.none(isEven, [1, 3, 5, 7, 8, 11]); //=> false
 */
module.exports = _curry2(_complement(_dispatchable(['any'], _xany, any)));


/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var curryN = __webpack_require__(13);
var nth = __webpack_require__(61);


/**
 * Returns a function which returns its nth argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig Number -> *... -> *
 * @param {Number} n
 * @return {Function}
 * @example
 *
 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
 * @symb R.nthArg(-1)(a, b, c) = c
 * @symb R.nthArg(0)(a, b, c) = a
 * @symb R.nthArg(1)(a, b, c) = b
 */
module.exports = _curry1(function nthArg(n) {
  var arity = n < 0 ? 1 : n + 1;
  return curryN(arity, function() {
    return nth(n, arguments);
  });
});


/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * `o` is a curried composition function that returns a unary function.
 * Like [`compose`](#compose), `o` performs right-to-left function composition.
 * Unlike [`compose`](#compose), the rightmost function passed to `o` will be
 * invoked with only one argument.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (b -> c) -> (a -> b) -> a -> c
 * @param {Function} f
 * @param {Function} g
 * @return {Function}
 * @see R.compose, R.pipe
 * @example
 *
 *      var classyGreeting = name => "The name's " + name.last + ", " + name.first + " " + lastName
 *      var yellGreeting = R.o(R.toUpper, classyGreeting);
 *      yellGreeting({first: 'James', last: 'Bond'}); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.o(R.multiply(10), R.add(10))(-4) //=> 60
 *
 * @symb R.o(f, g, x) = f(g(x))
 */
module.exports = _curry3(function o(f, g, x) {
  return f(g(x));
});


/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _of = __webpack_require__(393);


/**
 * Returns a singleton array containing the value provided.
 *
 * Note this `of` is different from the ES6 `of`; See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> [a]
 * @param {*} x any value
 * @return {Array} An array wrapping `x`.
 * @example
 *
 *      R.of(null); //=> [null]
 *      R.of([42]); //=> [[42]]
 */
module.exports = _curry1(_of);


/***/ }),

/***/ 393:
/***/ (function(module, exports) {

module.exports = function _of(x) { return [x]; };


/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(46);
var _curry2 = __webpack_require__(1);


/**
 * Returns a partial copy of an object omitting the keys specified.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [String] -> {String: *} -> {String: *}
 * @param {Array} names an array of String property names to omit from the new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with properties from `names` not on it.
 * @see R.pick
 * @example
 *
 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
 */
module.exports = _curry2(function omit(names, obj) {
  var result = {};
  for (var prop in obj) {
    if (!_contains(prop, names)) {
      result[prop] = obj[prop];
    }
  }
  return result;
});


/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _curry1 = __webpack_require__(4);


/**
 * Accepts a function `fn` and returns a function that guards invocation of
 * `fn` such that `fn` can only ever be called once, no matter how many times
 * the returned function is invoked. The first value calculated is returned in
 * subsequent invocations.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a... -> b) -> (a... -> b)
 * @param {Function} fn The function to wrap in a call-only-once wrapper.
 * @return {Function} The wrapped function.
 * @example
 *
 *      var addOneOnce = R.once(x => x + 1);
 *      addOneOnce(10); //=> 11
 *      addOneOnce(addOneOnce(50)); //=> 11
 */
module.exports = _curry1(function once(fn) {
  var called = false;
  var result;
  return _arity(fn.length, function() {
    if (called) {
      return result;
    }
    called = true;
    result = fn.apply(this, arguments);
    return result;
  });
});


/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category List
 * @sig a -> b -> (a,b)
 * @param {*} fst
 * @param {*} snd
 * @return {Array}
 * @see R.objOf, R.of
 * @example
 *
 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
 */
module.exports = _curry2(function pair(fst, snd) { return [fst, snd]; });


/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _createPartialApplicator = __webpack_require__(194);


/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided initially followed by the arguments provided to `g`.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partialRight
 * @example
 *
 *      var multiply2 = (a, b) => a * b;
 *      var double = R.partial(multiply2, [2]);
 *      double(2); //=> 4
 *
 *      var greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      var sayHello = R.partial(greet, ['Hello']);
 *      var sayHelloToMs = R.partial(sayHello, ['Ms.']);
 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
 */
module.exports = _createPartialApplicator(_concat);


/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _createPartialApplicator = __webpack_require__(194);
var flip = __webpack_require__(84);


/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided to `g` followed by the arguments provided initially.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partial
 * @example
 *
 *      var greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      var greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
 *
 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
 */
module.exports = _createPartialApplicator(flip(_concat));


/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

var filter = __webpack_require__(104);
var juxt = __webpack_require__(186);
var reject = __webpack_require__(81);


/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.contains('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.contains('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */
module.exports = juxt([filter, reject]);


/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

var _isPlaceholder = __webpack_require__(70);


/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
module.exports = function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
};


/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var equals = __webpack_require__(19);
var path = __webpack_require__(63);


/**
 * Determines whether a nested path on an object has a specific value, in
 * [`R.equals`](#equals) terms. Most likely used to filter a list.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Relation
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> Boolean
 * @param {Array} path The path of the nested property to use
 * @param {*} val The value to compare the nested property with
 * @param {Object} obj The object to check the nested property in
 * @return {Boolean} `true` if the value equals the nested object property,
 *         `false` otherwise.
 * @example
 *
 *      var user1 = { address: { zipCode: 90210 } };
 *      var user2 = { address: { zipCode: 55555 } };
 *      var user3 = { name: 'Bob' };
 *      var users = [ user1, user2, user3 ];
 *      var isFamous = R.pathEq(['address', 'zipCode'], 90210);
 *      R.filter(isFamous, users); //=> [ user1 ]
 */
module.exports = _curry3(function pathEq(_path, val, obj) {
  return equals(path(_path, obj), val);
});


/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var defaultTo = __webpack_require__(171);
var path = __webpack_require__(63);


/**
 * If the given, non-null object has a value at the given path, returns the
 * value at that path. Otherwise returns the provided default value.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig a -> [Idx] -> {a} -> a
 * @param {*} d The default value.
 * @param {Array} p The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path` of the supplied object or the default value.
 * @example
 *
 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */
module.exports = _curry3(function pathOr(d, p, obj) {
  return defaultTo(d, path(p, obj));
});


/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var path = __webpack_require__(63);


/**
 * Returns `true` if the specified object property at given path satisfies the
 * given predicate; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Logic
 * @typedefn Idx = String | Int
 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
 * @param {Function} pred
 * @param {Array} propPath
 * @param {*} obj
 * @return {Boolean}
 * @see R.propSatisfies, R.path
 * @example
 *
 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
 */
module.exports = _curry3(function pathSatisfies(pred, propPath, obj) {
  return propPath.length > 0 && pred(path(propPath, obj));
});


/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns a partial copy of an object containing only the keys specified. If
 * the key does not exist, the property is ignored.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.omit, R.props
 * @example
 *
 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
 */
module.exports = _curry2(function pick(names, obj) {
  var result = {};
  var idx = 0;
  while (idx < names.length) {
    if (names[idx] in obj) {
      result[names[idx]] = obj[names[idx]];
    }
    idx += 1;
  }
  return result;
});


/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns a partial copy of an object containing only the keys that satisfy
 * the supplied predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig (v, k -> Boolean) -> {k: v} -> {k: v}
 * @param {Function} pred A predicate to determine whether or not a key
 *        should be included on the output object.
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties that satisfy `pred`
 *         on it.
 * @see R.pick, R.filter
 * @example
 *
 *      var isUpperCase = (val, key) => key.toUpperCase() === key;
 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
 */
module.exports = _curry2(function pickBy(test, obj) {
  var result = {};
  for (var prop in obj) {
    if (test(obj[prop], prop, obj)) {
      result[prop] = obj[prop];
    }
  }
  return result;
});


/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

var composeK = __webpack_require__(164);
var reverse = __webpack_require__(80);

/**
 * Returns the left-to-right Kleisli composition of the provided functions,
 * each of which must return a value of a type supported by [`chain`](#chain).
 *
 * `R.pipeK(f, g, h)` is equivalent to `R.pipe(R.chain(f), R.chain(g), R.chain(h))`.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Function
 * @sig Chain m => ((a -> m b), (b -> m c), ..., (y -> m z)) -> (a -> m z)
 * @param {...Function}
 * @return {Function}
 * @see R.composeK
 * @example
 *
 *      //  parseJson :: String -> Maybe *
 *      //  get :: String -> Object -> Maybe *
 *
 *      //  getStateCode :: Maybe String -> Maybe String
 *      var getStateCode = R.pipeK(
 *        parseJson,
 *        get('user'),
 *        get('address'),
 *        get('state'),
 *        R.compose(Maybe.of, R.toUpper)
 *      );
 *
 *      getStateCode('{"user":{"address":{"state":"ny"}}}');
 *      //=> Just('NY')
 *      getStateCode('[Invalid JSON]');
 *      //=> Nothing()
 * @symb R.pipeK(f, g, h)(a) = R.chain(h, R.chain(g, f(a)))
 */
module.exports = function pipeK() {
  if (arguments.length === 0) {
    throw new Error('pipeK requires at least one argument');
  }
  return composeK.apply(this, reverse(arguments));
};


/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

var multiply = __webpack_require__(192);
var reduce = __webpack_require__(33);


/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */
module.exports = reduce(multiply, 1);


/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

var _map = __webpack_require__(73);
var identity = __webpack_require__(109);
var pickAll = __webpack_require__(195);
var useWith = __webpack_require__(197);


/**
 * Reasonable analog to SQL `select` statement.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @category Relation
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array} props The property names to project
 * @param {Array} objs The objects to query
 * @return {Array} An array of objects with just the `props` properties.
 * @example
 *
 *      var abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
 *      var fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
 *      var kids = [abby, fred];
 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
 */
module.exports = useWith(_map, [pickAll, identity]); // passing `identity` gives correct arity


/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var equals = __webpack_require__(19);


/**
 * Returns `true` if the specified object property is equal, in
 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig String -> a -> Object -> Boolean
 * @param {String} name
 * @param {*} val
 * @param {*} obj
 * @return {Boolean}
 * @see R.equals, R.propSatisfies
 * @example
 *
 *      var abby = {name: 'Abby', age: 7, hair: 'blond'};
 *      var fred = {name: 'Fred', age: 12, hair: 'brown'};
 *      var rusty = {name: 'Rusty', age: 10, hair: 'brown'};
 *      var alois = {name: 'Alois', age: 15, disposition: 'surly'};
 *      var kids = [abby, fred, rusty, alois];
 *      var hasBrownHair = R.propEq('hair', 'brown');
 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
 */
module.exports = _curry3(function propEq(name, val, obj) {
  return equals(val, obj[name]);
});


/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var is = __webpack_require__(185);


/**
 * Returns `true` if the specified object property is of the given type;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Type
 * @sig Type -> String -> Object -> Boolean
 * @param {Function} type
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.is, R.propSatisfies
 * @example
 *
 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
 *      R.propIs(Number, 'x', {});            //=> false
 */
module.exports = _curry3(function propIs(type, name, obj) {
  return is(type, obj[name]);
});


/***/ }),

/***/ 41:
/***/ (function(module, exports) {

/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */
module.exports = Array.isArray || function _isArray(val) {
  return (val != null &&
          val.length >= 0 &&
          Object.prototype.toString.call(val) === '[object Array]');
};


/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var _has = __webpack_require__(14);


/**
 * If the given, non-null object has an own property with the specified name,
 * returns the value of that property. Otherwise returns the provided default
 * value.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Object
 * @sig a -> String -> Object -> a
 * @param {*} val The default value.
 * @param {String} p The name of the property to return.
 * @param {Object} obj The object to query.
 * @return {*} The value of given property of the supplied object or the default value.
 * @example
 *
 *      var alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      var favorite = R.prop('favoriteLibrary');
 *      var favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
 *
 *      favorite(alice);  //=> undefined
 *      favoriteWithDefault(alice);  //=> 'Ramda'
 */
module.exports = _curry3(function propOr(val, p, obj) {
  return (obj != null && _has(p, obj)) ? obj[p] : val;
});


/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Returns `true` if the specified object property satisfies the given
 * predicate; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Logic
 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
 * @param {Function} pred
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.propEq, R.propIs
 * @example
 *
 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
 */
module.exports = _curry3(function propSatisfies(pred, name, obj) {
  return pred(obj[name]);
});


/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> [v]
 * @param {Array} ps The property names to fetch
 * @param {Object} obj The object to query
 * @return {Array} The corresponding values or partially applied function.
 * @example
 *
 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
 *
 *      var fullName = R.compose(R.join(' '), R.props(['first', 'last']));
 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
 */
module.exports = _curry2(function props(ps, obj) {
  var len = ps.length;
  var out = [];
  var idx = 0;

  while (idx < len) {
    out[idx] = obj[ps[idx]];
    idx += 1;
  }

  return out;
});


/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _isNumber = __webpack_require__(188);


/**
 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> Number -> [Number]
 * @param {Number} from The first number in the list.
 * @param {Number} to One more than the last number in the list.
 * @return {Array} The list of numbers in tthe set `[a, b)`.
 * @example
 *
 *      R.range(1, 5);    //=> [1, 2, 3, 4]
 *      R.range(50, 53);  //=> [50, 51, 52]
 */
module.exports = _curry2(function range(from, to) {
  if (!(_isNumber(from) && _isNumber(to))) {
    throw new TypeError('Both arguments to range must be numbers');
  }
  var result = [];
  var n = from;
  while (n < to) {
    result.push(n);
    n += 1;
  }
  return result;
});


/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

var _curryN = __webpack_require__(72);
var _reduce = __webpack_require__(18);
var _reduced = __webpack_require__(42);


/**
 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
 * through the list, successively calling the iterator function. `reduceWhile`
 * also takes a predicate that is evaluated before each step. If the predicate
 * returns `false`, it "short-circuits" the iteration and returns the current
 * value of the accumulator.
 *
 * @func
 * @memberOf R
 * @since v0.22.0
 * @category List
 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} pred The predicate. It is passed the accumulator and the
 *        current element.
 * @param {Function} fn The iterator function. Receives two values, the
 *        accumulator and the current element.
 * @param {*} a The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced
 * @example
 *
 *      var isOdd = (acc, x) => x % 2 === 1;
 *      var xs = [1, 3, 5, 60, 777, 800];
 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
 *
 *      var ys = [2, 4, 6]
 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
 */
module.exports = _curryN(4, [], function _reduceWhile(pred, fn, a, list) {
  return _reduce(function(acc, x) {
    return pred(acc, x) ? fn(acc, x) : _reduced(acc);
  }, a, list);
});


/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _reduced = __webpack_require__(42);

/**
 * Returns a value wrapped to indicate that it is the final value of the reduce
 * and transduce functions. The returned value should be considered a black
 * box: the internal structure is not guaranteed to be stable.
 *
 * Note: this optimization is unavailable to functions not explicitly listed
 * above. For instance, it is not currently supported by
 * [`reduceRight`](#reduceRight).
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category List
 * @sig a -> *
 * @param {*} x The final value of the reduce.
 * @return {*} The wrapped value.
 * @see R.reduce, R.transduce
 * @example
 *
 *     R.reduce(
 *       (acc, item) => item > 3 ? R.reduced(acc) : acc.concat(item),
 *       [],
 *       [1, 2, 3, 4, 5]) // [1, 2, 3]
 */

module.exports = _curry1(_reduced);


/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var always = __webpack_require__(49);
var times = __webpack_require__(199);


/**
 * Returns a fixed list of size `n` containing a specified identical value.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig a -> n -> [a]
 * @param {*} value The value to repeat.
 * @param {Number} n The desired size of the output list.
 * @return {Array} A new array containing `n` `value`s.
 * @see R.times
 * @example
 *
 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
 *
 *      var obj = {};
 *      var repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
 * @symb R.repeat(a, 0) = []
 * @symb R.repeat(a, 1) = [a]
 * @symb R.repeat(a, 2) = [a, a]
 */
module.exports = _curry2(function repeat(value, n) {
  return times(always(value), n);
});


/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Replace a substring or regex match in a string with a replacement.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category String
 * @sig RegExp|String -> String -> String -> String
 * @param {RegExp|String} pattern A regular expression or a substring to match.
 * @param {String} replacement The string to replace the matches with.
 * @param {String} str The String to do the search and replacement in.
 * @return {String} The result.
 * @example
 *
 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *
 *      // Use the "g" (global) flag to replace all occurrences:
 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
 */
module.exports = _curry3(function replace(regex, replacement, str) {
  return str.replace(regex, replacement);
});


/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Scan is similar to [`reduce`](#reduce), but returns a list of successively
 * reduced values from the left
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (a,b -> a) -> a -> [b] -> [a]
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {Array} A list of all intermediately reduced values.
 * @see R.reduce
 * @example
 *
 *      var numbers = [1, 2, 3, 4];
 *      var factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
 */
module.exports = _curry3(function scan(fn, acc, list) {
  var idx = 0;
  var len = list.length;
  var result = [acc];
  while (idx < len) {
    acc = fn(acc, list[idx]);
    result[idx + 1] = acc;
    idx += 1;
  }
  return result;
});


/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var always = __webpack_require__(49);
var over = __webpack_require__(193);


/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the given value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> a -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      var xLens = R.lensProp('x');
 *
 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
 */
module.exports = _curry3(function set(lens, v, x) {
  return over(lens, always(v), x);
});


/***/ }),

/***/ 42:
/***/ (function(module, exports) {

module.exports = function _reduced(x) {
  return x && x['@@transducer/reduced'] ? x :
    {
      '@@transducer/value': x,
      '@@transducer/reduced': true
    };
};


/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns a copy of the list, sorted according to the comparator function,
 * which should accept two values at a time and return a negative number if the
 * first value is smaller, a positive number if it's larger, and zero if they
 * are equal. Please note that this is a **copy** of the list. It does not
 * modify the original.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a,a -> Number) -> [a] -> [a]
 * @param {Function} comparator A sorting function :: a -> b -> Int
 * @param {Array} list The list to sort
 * @return {Array} a new array with its elements sorted by the comparator function.
 * @example
 *
 *      var diff = function(a, b) { return a - b; };
 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
 */
module.exports = _curry2(function sort(comparator, list) {
  return Array.prototype.slice.call(list, 0).sort(comparator);
});


/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Sorts the list according to the supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord b => (a -> b) -> [a] -> [a]
 * @param {Function} fn
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted by the keys generated by `fn`.
 * @example
 *
 *      var sortByFirstItem = R.sortBy(R.prop(0));
 *      var sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
 *      var pairs = [[-1, 1], [-2, 2], [-3, 3]];
 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
 *      var alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      var bob = {
 *        name: 'Bob',
 *        age: -10
 *      };
 *      var clara = {
 *        name: 'clara',
 *        age: 314.159
 *      };
 *      var people = [clara, bob, alice];
 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
 */
module.exports = _curry2(function sortBy(fn, list) {
  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
  });
});


/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Sorts a list according to a list of comparators.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Relation
 * @sig [a -> a -> Number] -> [a] -> [a]
 * @param {Array} functions A list of comparator functions.
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted according to the comarator functions.
 * @example
 *
 *      var alice = {
 *        name: 'alice',
 *        age: 40
 *      };
 *      var bob = {
 *        name: 'bob',
 *        age: 30
 *      };
 *      var clara = {
 *        name: 'clara',
 *        age: 40
 *      };
 *      var people = [clara, bob, alice];
 *      var ageNameSort = R.sortWith([
 *        R.descend(R.prop('age')),
 *        R.ascend(R.prop('name'))
 *      ]);
 *      ageNameSort(people); //=> [alice, clara, bob]
 */
module.exports = _curry2(function sortWith(fns, list) {
  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
    var result = 0;
    var i = 0;
    while (result === 0 && i < fns.length) {
      result = fns[i](a, b);
      i += 1;
    }
    return result;
  });
});


/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

var invoker = __webpack_require__(62);


/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `str`.
 * @see R.join
 * @example
 *
 *      var pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */
module.exports = invoker(1, 'split');


/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var length = __webpack_require__(187);
var slice = __webpack_require__(45);


/**
 * Splits a given list or string at a given index.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig Number -> [a] -> [[a], [a]]
 * @sig Number -> String -> [String, String]
 * @param {Number} index The index where the array/string is split.
 * @param {Array|String} array The array/string to be split.
 * @return {Array}
 * @example
 *
 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
 */
module.exports = _curry2(function splitAt(index, array) {
  return [slice(0, index, array), slice(index, length(array), array)];
});


/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var slice = __webpack_require__(45);


/**
 * Splits a collection into slices of the specified length.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @sig Number -> String -> [String]
 * @param {Number} n
 * @param {Array} list
 * @return {Array}
 * @example
 *
 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
 */
module.exports = _curry2(function splitEvery(n, list) {
  if (n <= 0) {
    throw new Error('First argument to splitEvery must be a positive integer');
  }
  var result = [];
  var idx = 0;
  while (idx < list.length) {
    result.push(slice(idx, idx += n, list));
  }
  return result;
});


/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Takes a list and a predicate and returns a pair of lists with the following properties:
 *
 *  - the result of concatenating the two output lists is equivalent to the input list;
 *  - none of the elements of the first output list satisfies the predicate; and
 *  - if the second output list is non-empty, its first element satisfies the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
 * @param {Function} pred The predicate that determines where the array is split.
 * @param {Array} list The array to be split.
 * @return {Array}
 * @example
 *
 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
 */
module.exports = _curry2(function splitWhen(pred, list) {
  var idx = 0;
  var len = list.length;
  var prefix = [];

  while (idx < len && !pred(list[idx])) {
    prefix.push(list[idx]);
    idx += 1;
  }

  return [prefix, Array.prototype.slice.call(list, idx)];
});


/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var equals = __webpack_require__(19);
var take = __webpack_require__(108);

/**
 * Checks if a list starts with the provided values
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> Boolean
 * @sig String -> Boolean
 * @param {*} prefix
 * @param {*} list
 * @return {Boolean}
 * @example
 *
 *      R.startsWith('a', 'abc')                //=> true
 *      R.startsWith('b', 'abc')                //=> false
 *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
 *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
 */
module.exports = _curry2(function(prefix, list) {
  return equals(take(prefix.length, list), prefix);
});


/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Subtracts its second argument from its first argument.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a - b`.
 * @see R.add
 * @example
 *
 *      R.subtract(10, 8); //=> 2
 *
 *      var minus5 = R.subtract(R.__, 5);
 *      minus5(17); //=> 12
 *
 *      var complementaryAngle = R.subtract(90);
 *      complementaryAngle(30); //=> 60
 *      complementaryAngle(72); //=> 18
 */
module.exports = _curry2(function subtract(a, b) {
  return Number(a) - Number(b);
});


/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var concat = __webpack_require__(103);
var difference = __webpack_require__(172);


/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
 * @example
 *
 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
 */
module.exports = _curry2(function symmetricDifference(list1, list2) {
  return concat(difference(list1, list2), difference(list2, list1));
});


/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = rootSaga;
exports.checkUpload = checkUpload;
exports.apiSaga = apiSaga;
exports.zipDownloadContracts = zipDownloadContracts;
exports.zipDownloadTemplates = zipDownloadTemplates;

var _effects = __webpack_require__(36);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _jszip = __webpack_require__(587);

var _jszip2 = _interopRequireDefault(_jszip);

var _jszipUtils = __webpack_require__(606);

var _jszipUtils2 = _interopRequireDefault(_jszipUtils);

var _fileSaver = __webpack_require__(607);

var _sagas = __webpack_require__(954);

var _sagas2 = _interopRequireDefault(_sagas);

var _sagas3 = __webpack_require__(955);

var _sagas4 = _interopRequireDefault(_sagas3);

var _sagas5 = __webpack_require__(956);

var _sagas6 = _interopRequireDefault(_sagas5);

var _sagas7 = __webpack_require__(957);

var _sagas8 = __webpack_require__(958);

var _sagas9 = __webpack_require__(609);

var _sagas10 = _interopRequireDefault(_sagas9);

var _saga = __webpack_require__(960);

var _saga2 = _interopRequireDefault(_saga);

var _sagas11 = __webpack_require__(961);

var _sagas12 = _interopRequireDefault(_sagas11);

var _sagas13 = __webpack_require__(962);

var _sagas14 = _interopRequireDefault(_sagas13);

var _saga3 = __webpack_require__(963);

var _saga4 = _interopRequireDefault(_saga3);

var _sagas15 = __webpack_require__(964);

var _sagas16 = _interopRequireDefault(_sagas15);

var _sagas17 = __webpack_require__(965);

var _sagas18 = _interopRequireDefault(_sagas17);

var _sagas19 = __webpack_require__(969);

var _sagas20 = _interopRequireDefault(_sagas19);

var _thirdPartyTracking = __webpack_require__(970);

var _thirdPartyTracking2 = _interopRequireDefault(_thirdPartyTracking);

var _sagas21 = __webpack_require__(971);

var _sagas22 = _interopRequireDefault(_sagas21);

var _sagas23 = __webpack_require__(972);

var _sagas24 = _interopRequireDefault(_sagas23);

var _sagas25 = __webpack_require__(973);

var _sagas26 = _interopRequireDefault(_sagas25);

var _integrationSagas = __webpack_require__(974);

var _integrationSagas2 = _interopRequireDefault(_integrationSagas);

var _billingSagas = __webpack_require__(975);

var _billingSagas2 = _interopRequireDefault(_billingSagas);

var _s3Upload = __webpack_require__(564);

var _s3Upload2 = _interopRequireDefault(_s3Upload);

var _api = __webpack_require__(37);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(refreshDataInPage),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(handleDummyTemplateErrors),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(updateUIpreferences),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(rootSaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(checkUpload),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(apiSaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(getBinaryContent),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(generateZipAsync),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(updateDownloadCountNFinalise),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(zipDownloadContracts),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(zipDownloadTemplates);

function refreshDataInPage() {
  var _ref, crId;

  return regeneratorRuntime.wrap(function refreshDataInPage$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(window.location.href.indexOf('assets-landing-signing') > -1)) {
            _context.next = 8;
            break;
          }

          _context.next = 3;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 3:
          _ref = _context.sent;
          crId = _ref.crId;

          if (!crId) {
            _context.next = 8;
            break;
          }

          _context.next = 8;
          return (0, _sagas25.refreshPolicyNotes)({ args: [{ crId: crId }] });

        case 8:
          if (!(window.location.pathname.indexOf('/contracting/contract/') === 0 || window.location.pathname.indexOf('/contracting/draft/') === 0 || window.location.pathname.indexOf('/contracting/workspace/') === 0)) {
            _context.next = 11;
            break;
          }

          _context.next = 11;
          return (0, _sagas9.refreshContractDoc)({ bgRefresh: true });

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function handleDummyTemplateErrors(_ref2) {
  var error = _ref2.error;
  return regeneratorRuntime.wrap(function handleDummyTemplateErrors$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!(error.message === 'Not Authorized to This Doc')) {
            _context2.next = 3;
            break;
          }

          _context2.next = 3;
          return (0, _effects.put)({
            type: 'GET_CONTRACT_INFO_ERROR',
            payload: {
              errorOccurs: window.location.href.indexOf("https://sec.tourconnect.com") > -1 ? 'In order to protect the security and integrity of rate data, you can only have one rate sheet open at a time.' : 'Something is wrong, please close the tab and reopen.'
            }
          });

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function updateUIpreferences(_ref3) {
  var type = _ref3.type,
      payload = _ref3.payload;
  return regeneratorRuntime.wrap(function updateUIpreferences$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return apiSaga(type, _api.account.updateUIpreferences, [payload]);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

/* Sagas from components export */

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return [(0, _effects.takeLatest)('REFRESH_DATA_IN_PAGE_BACKGROUND', refreshDataInPage), (0, _effects.takeLatest)('{rates-draft} REFRESH_LEFT_NAV_ERROR', handleDummyTemplateErrors), (0, _effects.takeLatest)('updateUIpreferences', updateUIpreferences)].concat(_sagas7.workspaceSagas).concat(_sagas2.default).concat(_sagas10.default).concat(_sagas8.massMessageSagas).concat(_sagas12.default).concat(_sagas14.default).concat(_saga4.default).concat(_sagas16.default).concat(_sagas20.default).concat(_thirdPartyTracking2.default).concat(_sagas18.default).concat(_sagas4.default).concat(_sagas6.default).concat(_sagas22.default).concat(_saga2.default).concat(_sagas24.default).concat(_sagas26.default).concat(_integrationSagas2.default).concat(_billingSagas2.default).concat([]);

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

/* Saga Utils */

// checks if a value is an uploadable File class
function checkUpload(val, type) {
  var retval;
  return regeneratorRuntime.wrap(function checkUpload$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)({ type: type + '_S3UPLOAD_STARTED' });

        case 2:
          _context5.next = 4;
          return _s3Upload2.default.s3uploadPromise(val);

        case 4:
          retval = _context5.sent;
          _context5.next = 7;
          return (0, _effects.put)({ type: type + '_S3UPLOAD_SUCCESS', payload: retval });

        case 7:
          return _context5.abrupt('return', retval);

        case 8:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

// generic API call wrapper
function apiSaga(type, fn, args) {
  var nuArgs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, arg, item, key, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, val, _item, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _val, _ref4, response, error, url, errorStr;

  return regeneratorRuntime.wrap(function apiSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)({ type: type + '_STARTED', args: args });

        case 2:

          // look for files and upload them
          nuArgs = [];
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context6.prev = 6;
          _iterator = args[Symbol.iterator]();

        case 8:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context6.next = 106;
            break;
          }

          arg = _step.value;

          if (!((typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg !== null && !Array.isArray(arg))) {
            _context6.next = 64;
            break;
          }

          item = {};
          _context6.t0 = regeneratorRuntime.keys(arg);

        case 13:
          if ((_context6.t1 = _context6.t0()).done) {
            _context6.next = 61;
            break;
          }

          key = _context6.t1.value;

          if (!Array.isArray(arg[key])) {
            _context6.next = 52;
            break;
          }

          item[key] = [];
          _iteratorNormalCompletion2 = true;
          _didIteratorError2 = false;
          _iteratorError2 = undefined;
          _context6.prev = 20;
          _iterator2 = arg[key][Symbol.iterator]();

        case 22:
          if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
            _context6.next = 36;
            break;
          }

          val = _step2.value;

          if (!(val instanceof File)) {
            _context6.next = 32;
            break;
          }

          _context6.t2 = item[key];
          _context6.next = 28;
          return checkUpload(val, type);

        case 28:
          _context6.t3 = _context6.sent;

          _context6.t2.push.call(_context6.t2, _context6.t3);

          _context6.next = 33;
          break;

        case 32:
          item[key].push(val);

        case 33:
          _iteratorNormalCompletion2 = true;
          _context6.next = 22;
          break;

        case 36:
          _context6.next = 42;
          break;

        case 38:
          _context6.prev = 38;
          _context6.t4 = _context6['catch'](20);
          _didIteratorError2 = true;
          _iteratorError2 = _context6.t4;

        case 42:
          _context6.prev = 42;
          _context6.prev = 43;

          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }

        case 45:
          _context6.prev = 45;

          if (!_didIteratorError2) {
            _context6.next = 48;
            break;
          }

          throw _iteratorError2;

        case 48:
          return _context6.finish(45);

        case 49:
          return _context6.finish(42);

        case 50:
          _context6.next = 59;
          break;

        case 52:
          if (!(arg[key] instanceof File)) {
            _context6.next = 58;
            break;
          }

          _context6.next = 55;
          return checkUpload(arg[key], type);

        case 55:
          item[key] = _context6.sent;
          _context6.next = 59;
          break;

        case 58:
          item[key] = arg[key];

        case 59:
          _context6.next = 13;
          break;

        case 61:
          nuArgs.push(item);
          _context6.next = 103;
          break;

        case 64:
          if (!Array.isArray(arg)) {
            _context6.next = 102;
            break;
          }

          _item = [];
          _iteratorNormalCompletion3 = true;
          _didIteratorError3 = false;
          _iteratorError3 = undefined;
          _context6.prev = 69;
          _iterator3 = arg[Symbol.iterator]();

        case 71:
          if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
            _context6.next = 85;
            break;
          }

          _val = _step3.value;

          if (!(_val instanceof File)) {
            _context6.next = 81;
            break;
          }

          _context6.t5 = _item;
          _context6.next = 77;
          return checkUpload(_val, type);

        case 77:
          _context6.t6 = _context6.sent;

          _context6.t5.push.call(_context6.t5, _context6.t6);

          _context6.next = 82;
          break;

        case 81:
          _item.push(_val);

        case 82:
          _iteratorNormalCompletion3 = true;
          _context6.next = 71;
          break;

        case 85:
          _context6.next = 91;
          break;

        case 87:
          _context6.prev = 87;
          _context6.t7 = _context6['catch'](69);
          _didIteratorError3 = true;
          _iteratorError3 = _context6.t7;

        case 91:
          _context6.prev = 91;
          _context6.prev = 92;

          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }

        case 94:
          _context6.prev = 94;

          if (!_didIteratorError3) {
            _context6.next = 97;
            break;
          }

          throw _iteratorError3;

        case 97:
          return _context6.finish(94);

        case 98:
          return _context6.finish(91);

        case 99:
          nuArgs.push(_item);
          _context6.next = 103;
          break;

        case 102:
          nuArgs.push(arg);

        case 103:
          _iteratorNormalCompletion = true;
          _context6.next = 8;
          break;

        case 106:
          _context6.next = 112;
          break;

        case 108:
          _context6.prev = 108;
          _context6.t8 = _context6['catch'](6);
          _didIteratorError = true;
          _iteratorError = _context6.t8;

        case 112:
          _context6.prev = 112;
          _context6.prev = 113;

          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }

        case 115:
          _context6.prev = 115;

          if (!_didIteratorError) {
            _context6.next = 118;
            break;
          }

          throw _iteratorError;

        case 118:
          return _context6.finish(115);

        case 119:
          return _context6.finish(112);

        case 120:
          _context6.next = 122;
          return _effects.call.apply(undefined, [fn].concat(nuArgs));

        case 122:
          _ref4 = _context6.sent;
          response = _ref4.response;
          error = _ref4.error;

          if (!error) {
            _context6.next = 136;
            break;
          }

          if (!(_ramda2.default.pathOr(0, ['response', 'status'], error) === 403)) {
            _context6.next = 129;
            break;
          }

          _context6.next = 129;
          return (0, _effects.put)({
            type: 'GLOBAL_ERROR_TRIGGERED',
            payload: { noAccessDialog: true }
          });

        case 129:
          _context6.next = 131;
          return (0, _effects.put)({ type: type + '_ERROR', payload: error.message, error: error, args: args });

        case 131:
          url = _ramda2.default.pathOr('<??>', ['request', 'url'], error);

          errorStr = function () {
            var method = _ramda2.default.pathOr('access', ['request', 'method'], error);
            return '[API] unable to ' + method + ' ' + url;
          }();

          if (window.Rollbar) {
            window.Rollbar.warning(errorStr, {
              error: error,
              args: _ramda2.default.omit(['headers'], args)
            });
          } else {
            console.warn(errorStr);
          }
          _context6.next = 138;
          break;

        case 136:
          _context6.next = 138;
          return (0, _effects.put)({ type: type + '_SUCCESS', payload: response, args: args });

        case 138:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this, [[6, 108, 112, 120], [20, 38, 42, 50], [43,, 45, 49], [69, 87, 91, 99], [92,, 94, 98], [113,, 115, 119]]);
}

function getBinaryContent(url) {
  return regeneratorRuntime.wrap(function getBinaryContent$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          return _context7.abrupt('return', new Promise(function (resolve, reject) {
            return _jszipUtils2.default.getBinaryContent(url, function (err, data) {
              if (err) return resolve(null);
              resolve(data);
            });
          }));

        case 1:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}
function generateZipAsync(zip) {
  return regeneratorRuntime.wrap(function generateZipAsync$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          return _context8.abrupt('return', new Promise(function (resolve) {
            return zip.generateAsync({ type: 'blob' }).then(resolve).catch(function (err) {
              console.log('generateZipAsync error', err);
            });
          }));

        case 1:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}
function updateDownloadCountNFinalise(zip, count, totalLength, actionType, zipFileName) {
  return regeneratorRuntime.wrap(function updateDownloadCountNFinalise$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          if (!(count === totalLength)) {
            _context9.next = 6;
            break;
          }

          _context9.next = 3;
          return (0, _effects.put)({ type: (actionType || '[contracting-download]BULK_DOWNLOAD') + '_SUCCESS' });

        case 3:
          zip.generateAsync({ type: 'blob' }).then(function (content) {
            return (0, _fileSaver.saveAs)(content, zipFileName);
          });
          _context9.next = 8;
          break;

        case 6:
          _context9.next = 8;
          return (0, _effects.put)({ type: '[contracting-download]UPDATE_PROPS', payload: { downloadedCount: count + 1 } });

        case 8:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function zipDownloadContracts(_ref5) {
  var actionType = _ref5.actionType,
      contractIds = _ref5.contractIds,
      extraPayload = _objectWithoutProperties(_ref5, ['actionType', 'contractIds']);

  var zipFileName, _ref6, response, error, contracts, zip, count, contractIndex, contract, from, to, locationName, files, templateId, respondedContracts, externalZip, fileCount, fileIndex, file, bufferData, fileData, content, respondedZip, subContractCount, rcIndex, respondedContract, _bufferData, contractData, contractName, _content, _bufferData2, data, fileName;

  return regeneratorRuntime.wrap(function zipDownloadContracts$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          zipFileName = function () {
            var downloadRateFormat = extraPayload.downloadRateFormat,
                zipFileName = extraPayload.zipFileName;

            if (downloadRateFormat === 'quickview_desummarized') {
              return '' + (zipFileName || '') + (zipFileName ? '-' : '') + 'Quickview (xls) Rates.zip';
            } else if (downloadRateFormat === 'quickview_summarized') {
              return '' + (zipFileName || '') + (zipFileName ? '-' : '') + 'Quickview w/summary (xls) Rates.zip';
            } else if (downloadRateFormat === 'condensed') {
              return '' + (zipFileName || '') + (zipFileName ? '-' : '') + 'Compact Version Rates.zip';
            }
            return '' + (zipFileName || '') + (zipFileName ? '-' : '') + 'Full Version Rates.zip';
          }();

          _context10.next = 3;
          return (0, _effects.put)({ type: (actionType || '[contracting-download]BULK_DOWNLOAD') + '_STARTED' });

        case 3:
          _context10.next = 5;
          return (0, _api.callApi)('/proxy/contracting/pdf-zip', 'post', { contractIds: contractIds });

        case 5:
          _ref6 = _context10.sent;
          response = _ref6.response;
          error = _ref6.error;

          if (!error) {
            _context10.next = 12;
            break;
          }

          _context10.next = 11;
          return (0, _effects.put)({ type: (actionType || '[contracting-download]BULK_DOWNLOAD') + '_ERROR' });

        case 11:
          return _context10.abrupt('return', _context10.sent);

        case 12:
          contracts = response;

          if (contracts && contracts.length) {
            _context10.next = 17;
            break;
          }

          _context10.next = 16;
          return (0, _effects.put)({ type: (actionType || '[contracting-download]BULK_DOWNLOAD') + '_SUCCESS' });

        case 16:
          return _context10.abrupt('return', _context10.sent);

        case 17:
          _context10.next = 19;
          return (0, _effects.put)({ type: '[contracting-download]UPDATE_PROPS', payload: { validLengthForBulkDownload: contracts.length } });

        case 19:
          zip = new _jszip2.default();
          count = 0;
          contractIndex = 0;

        case 22:
          if (!(contractIndex < contracts.length)) {
            _context10.next = 101;
            break;
          }

          contract = contracts[contractIndex];
          from = contract.from, to = contract.to, locationName = contract.locationName, files = contract.files, templateId = contract.templateId, respondedContracts = contract.respondedContracts;
          // if external, download files

          if (!(files && files.length && !templateId)) {
            _context10.next = 51;
            break;
          }

          externalZip = new _jszip2.default();
          fileCount = 0;
          fileIndex = 0;

        case 29:
          if (!(fileIndex < files.length)) {
            _context10.next = 49;
            break;
          }

          file = files[fileIndex];
          return _context10.delegateYield(getBinaryContent('/proxy/s3/file?key=' + encodeURIComponent(file.path)), 't0', 32);

        case 32:
          bufferData = _context10.t0;
          _context10.next = 35;
          return bufferData;

        case 35:
          fileData = _context10.sent;
          // not sure why need to yield twice, but it works
          if (fileData) externalZip.file(count + 1 + '-' + (fileCount + 1) + '-' + file.name, fileData, { binary: true });
          fileCount++;

          if (!(fileCount === files.length)) {
            _context10.next = 46;
            break;
          }

          _context10.next = 41;
          return generateZipAsync(externalZip);

        case 41:
          content = _context10.sent;

          if (content) zip.file(contractIndex + 1 + '-' + to.name + '.zip', content, { binary: true });
          count++;
          _context10.next = 46;
          return updateDownloadCountNFinalise(zip, count, contracts.length, actionType, zipFileName);

        case 46:
          fileIndex++;
          _context10.next = 29;
          break;

        case 49:
          _context10.next = 98;
          break;

        case 51:
          if (!(respondedContracts && respondedContracts.length && !templateId)) {
            _context10.next = 83;
            break;
          }

          respondedZip = new _jszip2.default();
          subContractCount = 0;
          rcIndex = 0;

        case 55:
          if (!(rcIndex < respondedContracts.length)) {
            _context10.next = 81;
            break;
          }

          respondedContract = respondedContracts[rcIndex];
          _context10.t1 = getBinaryContent;
          _context10.t2 = _api.fileUrls.getDownloadTCContractingDoc(_extends({}, extraPayload, {
            docId: respondedContract._id
          }));
          _context10.next = 61;
          return;

        case 61:
          _context10.t3 = _context10.sent;
          _context10.next = 64;
          return (0, _context10.t1)(_context10.t2, _context10.t3);

        case 64:
          _bufferData = _context10.sent;
          _context10.next = 67;
          return _bufferData;

        case 67:
          contractData = _context10.sent;
          // not sure why need to yield twice, but it works
          if (contractData) {
            contractName = contractIndex + 1 + '-' + respondedContract.from.name + '-' + respondedContract.locationName;

            respondedZip.file(contractName + '.' + ((extraPayload.downloadRateFormat || '').split('_')[0] === 'quickview' ? 'xlsx' : 'pdf'), contractData, { binary: true });
          }
          subContractCount++;

          if (!(subContractCount === respondedContracts.length)) {
            _context10.next = 78;
            break;
          }

          _context10.next = 73;
          return generateZipAsync(respondedZip);

        case 73:
          _content = _context10.sent;

          if (_content) zip.file(contractIndex + 1 + '-' + to.name + '.zip', _content, { binary: true });
          count++;
          _context10.next = 78;
          return updateDownloadCountNFinalise(zip, count, contracts.length, actionType, zipFileName);

        case 78:
          rcIndex++;
          _context10.next = 55;
          break;

        case 81:
          _context10.next = 98;
          break;

        case 83:
          _context10.t4 = getBinaryContent;
          _context10.t5 = _api.fileUrls.getDownloadTCContractingDoc(_extends({}, extraPayload, {
            docId: contract._id
          }));
          _context10.next = 87;
          return;

        case 87:
          _context10.t6 = _context10.sent;
          _context10.next = 90;
          return (0, _context10.t4)(_context10.t5, _context10.t6);

        case 90:
          _bufferData2 = _context10.sent;
          _context10.next = 93;
          return _bufferData2;

        case 93:
          data = _context10.sent;

          if (data) {
            fileName = contractIndex + 1 + '-' + to.name + '-' + from.name + '-' + locationName;

            zip.file(fileName + '.' + ((extraPayload.downloadRateFormat || '').split('_')[0] === 'quickview' ? 'xlsx' : 'pdf'), data, { binary: true });
          }
          count++;
          _context10.next = 98;
          return updateDownloadCountNFinalise(zip, count, contracts.length, actionType, zipFileName);

        case 98:
          contractIndex++;
          _context10.next = 22;
          break;

        case 101:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function zipDownloadTemplates(_ref7) {
  var actionType = _ref7.actionType,
      templates = _ref7.templates,
      downloadRateFormat = _ref7.downloadRateFormat,
      templateGroupName = _ref7.templateGroupName,
      extraPayload = _objectWithoutProperties(_ref7, ['actionType', 'templates', 'downloadRateFormat', 'templateGroupName']);

  var zip, count, templateIndex, template, templateName, _locationName, data;

  return regeneratorRuntime.wrap(function zipDownloadTemplates$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.put)({ type: (actionType || '[contracting-download]BULK_DOWNLOAD') + '_STARTED\'' });

        case 2:
          zip = new _jszip2.default();
          count = 0;
          templateIndex = 0;

        case 5:
          if (!(templateIndex < templates.length)) {
            _context11.next = 18;
            break;
          }

          template = templates[templateIndex];
          templateName = template.templateName, _locationName = template.locationName;
          _context11.next = 10;
          return getBinaryContent(_api.fileUrls.getDownloadTCContractingDoc({
            docId: template._id,
            collection: 'template',
            locale: extraPayload.locale,
            ratesOnly: extraPayload.ratesOnly,
            downloadRateFormat: downloadRateFormat
          }));

        case 10:
          data = _context11.sent;

          if (data) zip.file(count + 1 + '-' + _locationName + '-' + templateName + '.pdf', data, { binary: true });
          count++;
          _context11.next = 15;
          return updateDownloadCountNFinalise(zip, count, templates.length, actionType, extraPayload.ratesOnly ? templateGroupName + ' Compact Version Rates.zip' : templateGroupName + ' Full Version Rates.zip');

        case 15:
          templateIndex++;
          _context11.next = 5;
          break;

        case 18:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var concat = __webpack_require__(103);
var differenceWith = __webpack_require__(173);


/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both. Duplication is determined according to the value
 * returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifference, R.difference, R.differenceWith
 * @example
 *
 *      var eqA = R.eqBy(R.prop('a'));
 *      var l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
 *      var l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
 */
module.exports = _curry3(function symmetricDifferenceWith(pred, list1, list2) {
  return concat(differenceWith(pred, list1, list2), differenceWith(pred, list2, list1));
});


/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns a new list containing the last `n` elements of a given list, passing
 * each value to the supplied predicate function, and terminating when the
 * predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @param {Function} fn The function called per iteration.
 * @param {Array} list The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropLastWhile, R.addIndex
 * @example
 *
 *      var isNotOne = x => x !== 1;
 *
 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
 */
module.exports = _curry2(function takeLastWhile(fn, list) {
  var idx = list.length - 1;
  while (idx >= 0 && fn(list[idx])) {
    idx -= 1;
  }
  return Array.prototype.slice.call(list, idx + 1);
});


/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xtakeWhile = __webpack_require__(433);


/**
 * Returns a new list containing the first `n` elements of a given list,
 * passing each value to the supplied predicate function, and terminating when
 * the predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * Dispatches to the `takeWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @param {Function} fn The function called per iteration.
 * @param {Array} list The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropWhile, R.transduce, R.addIndex
 * @example
 *
 *      var isNotFour = x => x !== 4;
 *
 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
 */
module.exports = _curry2(_dispatchable(['takeWhile'], _xtakeWhile, function takeWhile(fn, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len && fn(list[idx])) {
    idx += 1;
  }
  return Array.prototype.slice.call(list, 0, idx);
}));


/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _reduced = __webpack_require__(42);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XTakeWhile(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XTakeWhile.prototype['@@transducer/init'] = _xfBase.init;
  XTakeWhile.prototype['@@transducer/result'] = _xfBase.result;
  XTakeWhile.prototype['@@transducer/step'] = function(result, input) {
    return this.f(input) ? this.xf['@@transducer/step'](result, input) : _reduced(result);
  };

  return _curry2(function _xtakeWhile(f, xf) { return new XTakeWhile(f, xf); });
}());


/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Runs the given function with the supplied object, then returns the object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a -> *) -> a -> a
 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
 * @param {*} x
 * @return {*} `x`.
 * @example
 *
 *      var sayX = x => console.log('x is ' + x);
 *      R.tap(sayX, 100); //=> 100
 *      // logs 'x is 100'
 * @symb R.tap(f, a) = a
 */
module.exports = _curry2(function tap(fn, x) {
  fn(x);
  return x;
});


/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

var _cloneRegExp = __webpack_require__(161);
var _curry2 = __webpack_require__(1);
var _isRegExp = __webpack_require__(436);
var toString = __webpack_require__(60);


/**
 * Determines whether a given string matches a given regular expression.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category String
 * @sig RegExp -> String -> Boolean
 * @param {RegExp} pattern
 * @param {String} str
 * @return {Boolean}
 * @see R.match
 * @example
 *
 *      R.test(/^x/, 'xyz'); //=> true
 *      R.test(/^y/, 'xyz'); //=> false
 */
module.exports = _curry2(function test(pattern, str) {
  if (!_isRegExp(pattern)) {
    throw new TypeError('‘test’ requires a value of type RegExp as its first argument; received ' + toString(pattern));
  }
  return _cloneRegExp(pattern).test(str);
});


/***/ }),

/***/ 436:
/***/ (function(module, exports) {

module.exports = function _isRegExp(x) {
  return Object.prototype.toString.call(x) === '[object RegExp]';
};


/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

var invoker = __webpack_require__(62);


/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */
module.exports = invoker(0, 'toLowerCase');


/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _has = __webpack_require__(14);


/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */
module.exports = _curry1(function toPairs(obj) {
  var pairs = [];
  for (var prop in obj) {
    if (_has(prop, obj)) {
      pairs[pairs.length] = [prop, obj[prop]];
    }
  }
  return pairs;
});


/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Converts an object into an array of key, value arrays. The object's own
 * properties and prototype properties are used. Note that the order of the
 * output array is not guaranteed to be consistent across different JS
 * platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own
 *         and prototype properties.
 * @example
 *
 *      var F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      var f = new F();
 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
 */
module.exports = _curry1(function toPairsIn(obj) {
  var pairs = [];
  for (var prop in obj) {
    pairs[pairs.length] = [prop, obj[prop]];
  }
  return pairs;
});


/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = exports;

elliptic.version = __webpack_require__(691).version;
elliptic.utils = __webpack_require__(692);
elliptic.rand = __webpack_require__(524);
elliptic.curve = __webpack_require__(214);
elliptic.curves = __webpack_require__(697);

// Protocols
elliptic.ec = __webpack_require__(705);
elliptic.eddsa = __webpack_require__(709);


/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

var invoker = __webpack_require__(62);


/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */
module.exports = invoker(0, 'toUpperCase');


/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

var _reduce = __webpack_require__(18);
var _xwrap = __webpack_require__(148);
var curryN = __webpack_require__(13);


/**
 * Initializes a transducer using supplied iterator function. Returns a single
 * item by iterating through the list, successively calling the transformed
 * iterator function and passing it an accumulator value and the current value
 * from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It will be
 * wrapped as a transformer to initialize the transducer. A transformer can be
 * passed directly in place of an iterator function. In both cases, iteration
 * may be stopped early with the [`R.reduced`](#reduced) function.
 *
 * A transducer is a function that accepts a transformer and returns a
 * transformer and can be composed directly.
 *
 * A transformer is an an object that provides a 2-arity reducing iterator
 * function, step, 0-arity initial value function, init, and 1-arity result
 * extraction function, result. The step function is used as the iterator
 * function in reduce. The result function is used to convert the final
 * accumulator into the return type and in most cases is
 * [`R.identity`](#identity). The init function can be used to provide an
 * initial accumulator, but is ignored by transduce.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (c -> c) -> (a,b -> a) -> a -> [b] -> a
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array. Wrapped as transformer, if necessary, and used to
 *        initialize the transducer
 * @param {*} acc The initial accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced, R.into
 * @example
 *
 *      var numbers = [1, 2, 3, 4];
 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
 *
 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
 */
module.exports = curryN(4, function transduce(xf, fn, acc, list) {
  return _reduce(xf(typeof fn === 'function' ? _xwrap(fn) : fn), acc, list);
});


/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Transposes the rows and columns of a 2D list.
 * When passed a list of `n` lists of length `x`,
 * returns a list of `x` lists of length `n`.
 *
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [[a]] -> [[a]]
 * @param {Array} list A 2D list
 * @return {Array} A 2D list
 * @example
 *
 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 *
 *      // If some of the rows are shorter than the following rows, their elements are skipped:
 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
 */
module.exports = _curry1(function transpose(outerlist) {
  var i = 0;
  var result = [];
  while (i < outerlist.length) {
    var innerlist = outerlist[i];
    var j = 0;
    while (j < innerlist.length) {
      if (typeof result[j] === 'undefined') {
        result[j] = [];
      }
      result[j].push(innerlist[j]);
      j += 1;
    }
    i += 1;
  }
  return result;
});


/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var map = __webpack_require__(16);
var sequence = __webpack_require__(200);


/**
 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
 * into an Applicative of Traversable.
 *
 * Dispatches to the `sequence` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
 * @param {Function} of
 * @param {Function} f
 * @param {*} traversable
 * @return {*}
 * @see R.sequence
 * @example
 *
 *      // Returns `Nothing` if the given divisor is `0`
 *      safeDiv = n => d => d === 0 ? Nothing() : Just(n / d)
 *
 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Just([5, 2.5, 2])
 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Nothing
 */
module.exports = _curry3(function traverse(of, f, traversable) {
  return typeof traversable['fantasy-land/traverse'] === 'function' ?
    traversable['fantasy-land/traverse'](f, of) :
    sequence(of, map(f, traversable));
});


/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */
module.exports = (function() {
  var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
           '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' +
           '\u2029\uFEFF';
  var zeroWidth = '\u200b';
  var hasProtoTrim = (typeof String.prototype.trim === 'function');
  if (!hasProtoTrim || (ws.trim() || !zeroWidth.trim())) {
    return _curry1(function trim(str) {
      var beginRx = new RegExp('^[' + ws + '][' + ws + ']*');
      var endRx = new RegExp('[' + ws + '][' + ws + ']*$');
      return str.replace(beginRx, '').replace(endRx, '');
    });
  } else {
    return _curry1(function trim(str) {
      return str.trim();
    });
  }
}());


/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _concat = __webpack_require__(21);
var _curry2 = __webpack_require__(1);


/**
 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
 * function evaluates the `tryer`; if it does not throw, it simply returns the
 * result. If the `tryer` *does* throw, the returned function evaluates the
 * `catcher` function and returns its result. Note that for effective
 * composition with this function, both the `tryer` and `catcher` functions
 * must return the same type of results.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
 * @param {Function} tryer The function that may throw.
 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
 * @return {Function} A new function that will catch exceptions and send then to the catcher.
 * @example
 *
 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
 *      R.tryCatch(R.prop('x'), R.F)(null);      //=> false
 */
module.exports = _curry2(function _tryCatch(tryer, catcher) {
  return _arity(tryer.length, function() {
    try {
      return tryer.apply(this, arguments);
    } catch (e) {
      return catcher.apply(this, _concat([e], arguments));
    }
  });
});


/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Takes a function `fn`, which takes a single array argument, and returns a
 * function which:
 *
 *   - takes any number of positional arguments;
 *   - passes these arguments to `fn` as an array; and
 *   - returns the result.
 *
 * In other words, `R.unapply` derives a variadic function from a function which
 * takes an array. `R.unapply` is the inverse of [`R.apply`](#apply).
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Function
 * @sig ([*...] -> a) -> (*... -> a)
 * @param {Function} fn
 * @return {Function}
 * @see R.apply
 * @example
 *
 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
 * @symb R.unapply(f)(a, b) = f([a, b])
 */
module.exports = _curry1(function unapply(fn) {
  return function() {
    return fn(Array.prototype.slice.call(arguments, 0));
  };
});


/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var nAry = __webpack_require__(76);


/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 1 parameter. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> b) -> (a -> b)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 1.
 * @see R.binary, R.nAry
 * @example
 *
 *      var takesTwoArgs = function(a, b) {
 *        return [a, b];
 *      };
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      var takesOneArg = R.unary(takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only 1 argument is passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.unary(f)(a, b, c) = f(a)
 */
module.exports = _curry1(function unary(fn) {
  return nAry(1, fn);
});


/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var curryN = __webpack_require__(13);


/**
 * Returns a function of arity `n` from a (manually) curried function.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Function
 * @sig Number -> (a -> b) -> (a -> c)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to uncurry.
 * @return {Function} A new function.
 * @see R.curry
 * @example
 *
 *      var addFour = a => b => c => d => a + b + c + d;
 *
 *      var uncurriedAddFour = R.uncurryN(4, addFour);
 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
 */
module.exports = _curry2(function uncurryN(depth, fn) {
  return curryN(depth, function() {
    var currentDepth = 1;
    var value = fn;
    var idx = 0;
    var endIdx;
    while (currentDepth <= depth && typeof value === 'function') {
      endIdx = currentDepth === depth ? arguments.length : idx + value.length;
      value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
      currentDepth += 1;
      idx = endIdx;
    }
    return value;
  });
});


/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Builds a list from a seed value. Accepts an iterator function, which returns
 * either false to stop iteration or an array of length 2 containing the value
 * to add to the resulting list and the seed to be used in the next call to the
 * iterator function.
 *
 * The iterator function receives one argument: *(seed)*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (a -> [b]) -> * -> [b]
 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
 *        either false to quit iteration or an array of length two to proceed. The element
 *        at index 0 of this array will be added to the resulting array, and the element
 *        at index 1 will be passed to the next call to `fn`.
 * @param {*} seed The seed value.
 * @return {Array} The final list.
 * @example
 *
 *      var f = n => n > 50 ? false : [-n, n + 10];
 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
 */
module.exports = _curry2(function unfold(fn, seed) {
  var pair = fn(seed);
  var result = [];
  while (pair && pair.length) {
    result[result.length] = pair[0];
    pair = fn(pair[1]);
  }
  return result;
});


/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

var _checkForMethod = __webpack_require__(59);
var _curry3 = __webpack_require__(5);


/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */
module.exports = _curry3(_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
  return Array.prototype.slice.call(list, fromIndex, toIndex);
}));


/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _curry2 = __webpack_require__(1);
var compose = __webpack_require__(101);
var uniq = __webpack_require__(111);


/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */
module.exports = _curry2(compose(uniq, _concat));


/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _curry3 = __webpack_require__(5);
var uniqWith = __webpack_require__(112);


/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list. Duplication is determined according to the value returned by
 * applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> a -> Boolean) -> [*] -> [*] -> [*]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @see R.union
 * @example
 *
 *      var l1 = [{a: 1}, {a: 2}];
 *      var l2 = [{a: 1}, {a: 4}];
 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
 */
module.exports = _curry3(function unionWith(pred, list1, list2) {
  return uniqWith(pred, _concat(list1, list2));
});


/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is not satisfied, the function will return the result of
 * calling the `whenFalseFn` function with the same argument. If the predicate
 * is satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred        A predicate function
 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
 *                               to a falsy value.
 * @param {*}        x           An object to test with the `pred` function and
 *                               pass to `whenFalseFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
 * @see R.ifElse, R.when
 * @example
 *
 *      let safeInc = R.unless(R.isNil, R.inc);
 *      safeInc(null); //=> null
 *      safeInc(1); //=> 2
 */
module.exports = _curry3(function unless(pred, whenFalseFn, x) {
  return pred(x) ? x : whenFalseFn(x);
});


/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

var _identity = __webpack_require__(110);
var chain = __webpack_require__(99);


/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */
module.exports = chain(_identity);


/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Takes a predicate, a transformation function, and an initial value,
 * and returns a value of the same type as the initial value.
 * It does so by applying the transformation until the predicate is satisfied,
 * at which point it returns the satisfactory value.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred A predicate function
 * @param {Function} fn The iterator function
 * @param {*} init Initial value
 * @return {*} Final value that satisfies predicate
 * @example
 *
 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
 */
module.exports = _curry3(function until(pred, fn, init) {
  var val = init;
  while (!pred(val)) {
    val = fn(val);
  }
  return val;
});


/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Returns a list of all the properties, including prototype properties, of the
 * supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own and prototype properties.
 * @see R.values, R.keysIn
 * @example
 *
 *      var F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      var f = new F();
 *      R.valuesIn(f); //=> ['X', 'Y']
 */
module.exports = _curry1(function valuesIn(obj) {
  var prop;
  var vs = [];
  for (prop in obj) {
    vs[vs.length] = obj[prop];
  }
  return vs;
});


/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns a "view" of the given data structure, determined by the given lens.
 * The lens's focus determines which portion of the data structure is visible.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> s -> a
 * @param {Lens} lens
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      var xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});  //=> 1
 *      R.view(xLens, {x: 4, y: 2});  //=> 4
 */
module.exports = (function() {
  // `Const` is a functor that effectively ignores the function given to `map`.
  var Const = function(x) {
    return {value: x, 'fantasy-land/map': function() { return this; }};
  };

  return _curry2(function view(lens, x) {
    // Using `Const` effectively ignores the setter function of the `lens`,
    // leaving the value returned by the getter function unmodified.
    return lens(Const)(x).value;
  });
}());


/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is satisfied, the function will return the result of calling
 * the `whenTrueFn` function with the same argument. If the predicate is not
 * satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred       A predicate function
 * @param {Function} whenTrueFn A function to invoke when the `condition`
 *                              evaluates to a truthy value.
 * @param {*}        x          An object to test with the `pred` function and
 *                              pass to `whenTrueFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
 * @see R.ifElse, R.unless
 * @example
 *
 *      // truncate :: String -> String
 *      var truncate = R.when(
 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
 *        R.pipe(R.take(10), R.append('…'), R.join(''))
 *      );
 *      truncate('12345');         //=> '12345'
 *      truncate('0123456789ABC'); //=> '0123456789…'
 */
module.exports = _curry3(function when(pred, whenTrueFn, x) {
  return pred(x) ? whenTrueFn(x) : x;
});


/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var equals = __webpack_require__(19);
var map = __webpack_require__(16);
var where = __webpack_require__(201);


/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec, false otherwise. An object satisfies the spec if, for each of the
 * spec's own properties, accessing that property of the object gives the same
 * value (in [`R.equals`](#equals) terms) as accessing that property of the
 * spec.
 *
 * `whereEq` is a specialization of [`where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @sig {String: *} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.where
 * @example
 *
 *      // pred :: Object -> Boolean
 *      var pred = R.whereEq({a: 1, b: 2});
 *
 *      pred({a: 1});              //=> false
 *      pred({a: 1, b: 2});        //=> true
 *      pred({a: 1, b: 2, c: 3});  //=> true
 *      pred({a: 1, b: 1});        //=> false
 */
module.exports = _curry2(function whereEq(spec, testObj) {
  return where(map(equals, spec), testObj);
});


/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(46);
var _curry2 = __webpack_require__(1);
var flip = __webpack_require__(84);
var reject = __webpack_require__(81);


/**
 * Returns a new list without values in the first argument.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @param {Array} list1 The values to be removed from `list2`.
 * @param {Array} list2 The array to remove values from.
 * @return {Array} The new array without values in `list1`.
 * @see R.transduce, R.difference
 * @example
 *
 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
 */
module.exports = _curry2(function(xs, list) {
  return reject(flip(_contains)(xs), list);
});


/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

var _indexOf = __webpack_require__(166);


module.exports = function _contains(a, list) {
  return _indexOf(list, a, 0) >= 0;
};


/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Creates a new list out of the two supplied by creating each possible pair
 * from the lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The list made by combining each possible pair from
 *         `as` and `bs` into pairs (`[a, b]`).
 * @example
 *
 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
 */
module.exports = _curry2(function xprod(a, b) { // = xprodWith(prepend); (takes about 3 times as long...)
  var idx = 0;
  var ilen = a.length;
  var j;
  var jlen = b.length;
  var result = [];
  while (idx < ilen) {
    j = 0;
    while (j < jlen) {
      result[result.length] = [a[idx], b[j]];
      j += 1;
    }
    idx += 1;
  }
  return result;
});


/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Creates a new list out of the two supplied by pairing up equally-positioned
 * items from both lists. The returned list is truncated to the length of the
 * shorter of the two input lists.
 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
 * @example
 *
 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
 */
module.exports = _curry2(function zip(a, b) {
  var rv = [];
  var idx = 0;
  var len = Math.min(a.length, b.length);
  while (idx < len) {
    rv[idx] = [a[idx], b[idx]];
    idx += 1;
  }
  return rv;
});


/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Creates a new object out of a list of keys and a list of values.
 * Key/value pairing is truncated to the length of the shorter of the two lists.
 * Note: `zipObj` is equivalent to `pipe(zipWith(pair), fromPairs)`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [String] -> [*] -> {String: *}
 * @param {Array} keys The array that will be properties on the output object.
 * @param {Array} values The list of values on the output object.
 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
 * @example
 *
 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
 */
module.exports = _curry2(function zipObj(keys, values) {
  var idx = 0;
  var len = Math.min(keys.length, values.length);
  var out = {};
  while (idx < len) {
    out[keys[idx]] = values[idx];
    idx += 1;
  }
  return out;
});


/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Creates a new list out of the two supplied by applying the function to each
 * equally-positioned pair in the lists. The returned list is truncated to the
 * length of the shorter of the two input lists.
 *
 * @function
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a,b -> c) -> [a] -> [b] -> [c]
 * @param {Function} fn The function used to combine the two elements into one value.
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
 *         using `fn`.
 * @example
 *
 *      var f = (x, y) => {
 *        // ...
 *      };
 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
 */
module.exports = _curry3(function zipWith(fn, a, b) {
  var rv = [];
  var idx = 0;
  var len = Math.min(a.length, b.length);
  while (idx < len) {
    rv[idx] = fn(a[idx], b[idx]);
    idx += 1;
  }
  return rv;
});


/***/ }),

/***/ 465:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(115);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  Provider.displayName = 'Provider';

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(467);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),

/***/ 469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(474);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),

/***/ 470:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),

/***/ 471:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(205);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),

/***/ 472:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(205);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),

/***/ 473:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(206);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),

/***/ 474:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(475);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),

/***/ 475:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(115);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markAcceptedRead = exports.addFilesToContract = exports.deleteMessage = exports.changeSelection = exports.removeConnectionFromStatus = exports.getStatusMessages = exports.markReadWithParams = exports.markRead = exports.getConversations = exports.selectContract = exports.sendMessage = exports.archiveConversation = exports.resetConversations = exports.resetChannels = exports.selectChannel = exports.getChannels = exports.archiveConnection = exports.selectConnection = exports.getConnections = undefined;

var _constants = __webpack_require__(233);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getConnections = exports.getConnections = function getConnections() {
  return { type: cnt.CONNECTIONS_FETCH };
};
var selectConnection = exports.selectConnection = function selectConnection(connection) {
  return { type: cnt.CONNECTIONS_SELECT, payload: connection };
};
var archiveConnection = exports.archiveConnection = function archiveConnection(connection) {
  return { type: cnt.CONNECTIONS_ARCHIVE, payload: connection };
};
var getChannels = exports.getChannels = function getChannels(payload) {
  return { type: cnt.CHANNELS_FETCH, payload: payload };
};
var selectChannel = exports.selectChannel = function selectChannel(channel) {
  return { type: cnt.CHANNELS_SELECT, payload: channel };
};
var resetChannels = exports.resetChannels = function resetChannels(channel) {
  return { type: cnt.CHANNELS_RESET, payload: channel };
};
var resetConversations = exports.resetConversations = function resetConversations(channel) {
  return { type: cnt.CONVERSATIONS_RESET, payload: channel };
};
var archiveConversation = exports.archiveConversation = function archiveConversation(channel, contract) {
  return { type: cnt.CHANNELS_ARCHIVE, payload: { channel: channel, contract: contract } };
};
var sendMessage = exports.sendMessage = function sendMessage(message) {
  return { type: cnt.MESSAGE_CREATE, payload: message };
};
var selectContract = exports.selectContract = function selectContract(contractId) {
  return { type: cnt.CONTRACT_SELECT, payload: contractId };
};
var getConversations = exports.getConversations = function getConversations() {
  return { type: cnt.CONVERSATIONS_FETCH };
};
var markRead = exports.markRead = function markRead() {
  return { type: cnt.CONVERSATIONS_READ };
};
var markReadWithParams = exports.markReadWithParams = function markReadWithParams(payload) {
  return { type: cnt.CONVERSATIONS_READ_WITH_PARAMS, payload: payload };
};
var getStatusMessages = exports.getStatusMessages = function getStatusMessages() {
  return { type: cnt.STATUS_MESSAGES };
};
var removeConnectionFromStatus = exports.removeConnectionFromStatus = function removeConnectionFromStatus(payload) {
  return { type: cnt.STATUS_MESSAGES_REMOVE_CONNECTION, payload: payload };
};
var changeSelection = exports.changeSelection = function changeSelection(connection, channel) {
  return { type: cnt.CHANGE_SELECTION, payload: { connection: connection, channel: channel } };
};
var deleteMessage = exports.deleteMessage = function deleteMessage(message) {
  return { type: cnt.MESSAGE_DELETE, payload: message };
};
var addFilesToContract = exports.addFilesToContract = function addFilesToContract(message) {
  return { type: cnt.MESSAGE_ADD_FILES_TO_CONTRACT, payload: message };
};
var markAcceptedRead = exports.markAcceptedRead = function markAcceptedRead(payload) {
  return { type: cnt.STATUS_CONNECTIONS_MARK_READ, payload: payload };
};

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getMuiTheme = __webpack_require__(628);

var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);

var _colors = __webpack_require__(259);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var muiTheme = (0, _getMuiTheme2.default)({
  fontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
  palette: {
    textColor: 'rgba(0, 0, 0, 0.84)'
  },
  raisedButton: {
    primaryColor: _colors.pinkA200,
    secondaryColor: _colors.cyan500
  },
  flatButton: {
    primaryTextColor: _colors.pinkA200,
    secondaryTextColor: _colors.cyan500
  }
});

exports.default = muiTheme;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(479)();
// imports


// module
exports.push([module.i, "@font-face {\n  font-family: 'TourConnect-Icons';\n  src: url(" + __webpack_require__(207) + ");\n  src: url(" + __webpack_require__(207) + "#iefix) format('embedded-opentype'), url(" + __webpack_require__(480) + ") format('truetype'), url(" + __webpack_require__(481) + ") format('woff'), url(" + __webpack_require__(482) + "#TourConnect-Icons) format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n[class^=\"tc-icon-\"],\n[class*=\" tc-icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'TourConnect-Icons' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.tc-icon-newspaper:before {\n  content: \"\\E91A\";\n}\n.tc-icon-move-up:before {\n  content: \"\\EA46\";\n}\n.tc-icon-move-down:before {\n  content: \"\\EA47\";\n}\n.tc-icon-filter:before {\n  content: \"\\EA5B\";\n}\n.tc-icon-star-empty:before {\n  content: \"\\E9D7\";\n}\n.tc-icon-star-half:before {\n  content: \"\\E9D8\";\n}\n.tc-icon-cursor-default-outline:before {\n  content: \"\\E919\";\n}\n.tc-icon-email-open:before {\n  content: \"\\E910\";\n}\n.tc-icon-email-alert:before {\n  content: \"\\E914\";\n}\n.tc-icon-email-open-outline:before {\n  content: \"\\E915\";\n}\n.tc-icon-email-outline:before {\n  content: \"\\E918\";\n}\n.tc-icon-send-plus:before {\n  content: \"\\E90F\";\n}\n.tc-icon-marketing-materials:before {\n  content: \"\\E906\";\n}\n.tc-icon-partner-finder:before {\n  content: \"\\E90A\";\n}\n.tc-icon-exchange-rates:before {\n  content: \"\\E90B\";\n}\n.tc-icon-bulb:before {\n  content: \"\\E907\";\n}\n.tc-icon-paperplane:before {\n  content: \"\\E616\";\n}\n.tc-icon-amex:before {\n  content: \"\\E901\";\n  color: #2e77bc;\n}\n.tc-icon-discover:before {\n  content: \"\\E903\";\n  color: #ff6000;\n}\n.tc-icon-mastercard:before {\n  content: \"\\E902\";\n  color: #eb001b;\n}\n.tc-icon-paypal:before {\n  content: \"\\E905\";\n  color: #00457c;\n}\n.tc-icon-visa:before {\n  content: \"\\E904\";\n  color: #142787;\n}\n.tc-icon-swap_vert:before {\n  content: \"\\E8D5\";\n}\n.tc-icon-lock:before {\n  content: \"\\E908\";\n}\n.tc-icon-folder_open:before {\n  content: \"\\E909\";\n}\n.tc-icon-restore:before {\n  content: \"\\E8B3\";\n}\n.tc-icon-create_new_folder:before {\n  content: \"\\E2CC\";\n}\n.tc-icon-inbox:before {\n  content: \"\\E156\";\n}\n.tc-icon-av_timer:before {\n  content: \"\\E01B\";\n}\n.tc-icon-email:before {\n  content: \"\\E0BE\";\n}\n.tc-icon-archive2:before {\n  content: \"\\E149\";\n}\n.tc-icon-content_copy:before {\n  content: \"\\E14D\";\n}\n.tc-icon-move_to_inbox:before {\n  content: \"\\E168\";\n}\n.tc-icon-attach_file:before {\n  content: \"\\E226\";\n}\n.tc-icon-picture_as_pdf:before {\n  content: \"\\E415\";\n}\n.tc-icon-assignment_turned_in:before {\n  content: \"\\E862\";\n}\n.tc-icon-change_history:before {\n  content: \"\\E86B\";\n}\n.tc-icon-chrome_reader_mode:before {\n  content: \"\\E86D\";\n}\n.tc-icon-language:before {\n  content: \"\\E894\";\n}\n.tc-icon-question_answer:before {\n  content: \"\\E8AF\";\n}\n.tc-icon-receipt:before {\n  content: \"\\E8B0\";\n}\n.tc-icon-thumb_down:before {\n  content: \"\\E8DB\";\n}\n.tc-icon-thumb_up:before {\n  content: \"\\E8DC\";\n}\n.tc-icon-location_on:before {\n  content: \"\\E900\";\n}\n.tc-icon-info:before {\n  content: \"\\E2A2\";\n}\n.tc-icon-hotel:before {\n  content: \"\\E1D2\";\n}\n.tc-icon-add:before {\n  content: \"\\E614\";\n}\n.tc-icon-menu:before {\n  content: \"\\E613\";\n}\n.tc-icon-check:before {\n  content: \"\\E612\";\n}\n.tc-icon-chevron-left:before {\n  content: \"\\E60E\";\n}\n.tc-icon-chevron-right:before {\n  content: \"\\E60F\";\n}\n.tc-icon-archive:before {\n  content: \"\\E60A\";\n}\n.tc-icon-perm-contact-cal:before {\n  content: \"\\E60B\";\n}\n.tc-icon-cloud-download:before {\n  content: \"\\E60C\";\n}\n.tc-icon-more-vert:before {\n  content: \"\\E60D\";\n}\n.tc-icon-arrow-drop-up:before {\n  content: \"\\E609\";\n}\n.tc-icon-close:before {\n  content: \"\\E608\";\n}\n.tc-icon-office:before {\n  content: \"\\E600\";\n  color: #444;\n}\n.tc-icon-checkbox-marked-circle:before {\n  content: \"\\E605\";\n  color: #444;\n}\n.tc-icon-search:before {\n  content: \"\\E606\";\n  color: #444;\n}\n.tc-icon-tag:before {\n  content: \"\\E602\";\n  color: #444;\n}\n.tc-icon-users:before {\n  content: \"\\E603\";\n  color: #444;\n}\n.tc-icon-user:before {\n  content: \"\\E604\";\n  color: #444;\n}\n.tc-icon-arrow-drop-down:before {\n  content: \"\\E601\";\n  color: #444;\n}\n.tc-icon-print:before {\n  content: \"\\E617\";\n}\n.tc-icon-insert-drive-file:before {\n  content: \"\\E615\";\n}\n.tc-icon-local-phone:before {\n  content: \"\\E618\";\n}\n.tc-icon-ticket:before {\n  content: \"\\E62A\";\n}\n.tc-icon-briefcase:before {\n  content: \"\\E628\";\n}\n.tc-icon-earth:before {\n  content: \"\\E629\";\n}\n.tc-icon-flag:before {\n  content: \"\\E62B\";\n}\n.tc-icon-remove_red_eye:before {\n  content: \"\\E417\";\n}\n.tc-icon-date_range:before {\n  content: \"\\E916\";\n}\n.tc-icon-watch_later:before {\n  content: \"\\E924\";\n}\n.tc-icon-alarm:before {\n  content: \"\\E855\";\n}\n.tc-icon-access_alarms:before {\n  content: \"\\E191\";\n}\n.tc-icon-schedule:before {\n  content: \"\\E8B5\";\n}\n.tc-icon-account_balance_wallet:before {\n  content: \"\\E850\";\n}\n.tc-icon-account_box:before {\n  content: \"\\E851\";\n}\n.tc-icon-account_circle:before {\n  content: \"\\E853\";\n}\n.tc-icon-add2:before {\n  content: \"\\E145\";\n}\n.tc-icon-add_a_photo:before {\n  content: \"\\E439\";\n}\n.tc-icon-add_box:before {\n  content: \"\\E146\";\n}\n.tc-icon-add_circle:before {\n  content: \"\\E147\";\n}\n.tc-icon-control_point:before {\n  content: \"\\E3BA\";\n}\n.tc-icon-add_shopping_cart:before {\n  content: \"\\E854\";\n}\n.tc-icon-queue:before {\n  content: \"\\E03C\";\n}\n.tc-icon-add_to_queue:before {\n  content: \"\\E05C\";\n}\n.tc-icon-airplay:before {\n  content: \"\\E055\";\n}\n.tc-icon-announcement:before {\n  content: \"\\E85A\";\n}\n.tc-icon-archive3:before {\n  content: \"\\E14A\";\n}\n.tc-icon-arrow_back:before {\n  content: \"\\E5C4\";\n}\n.tc-icon-arrow_downward:before {\n  content: \"\\E5DB\";\n}\n.tc-icon-arrow_drop_down:before {\n  content: \"\\E5C5\";\n}\n.tc-icon-arrow_drop_down_circle:before {\n  content: \"\\E5C6\";\n}\n.tc-icon-arrow_drop_up:before {\n  content: \"\\E5C7\";\n}\n.tc-icon-arrow_forward:before {\n  content: \"\\E5C8\";\n}\n.tc-icon-arrow_upward:before {\n  content: \"\\E5D8\";\n}\n.tc-icon-art_track:before {\n  content: \"\\E060\";\n}\n.tc-icon-aspect_ratio:before {\n  content: \"\\E85B\";\n}\n.tc-icon-poll:before {\n  content: \"\\E805\";\n}\n.tc-icon-assignment:before {\n  content: \"\\E85D\";\n}\n.tc-icon-assistant:before {\n  content: \"\\E39F\";\n}\n.tc-icon-flag2:before {\n  content: \"\\E153\";\n}\n.tc-icon-attach_file2:before {\n  content: \"\\E227\";\n}\n.tc-icon-attach_money:before {\n  content: \"\\E228\";\n}\n.tc-icon-attachment:before {\n  content: \"\\E2BC\";\n}\n.tc-icon-autorenew:before {\n  content: \"\\E863\";\n}\n.tc-icon-av_timer2:before {\n  content: \"\\E01C\";\n}\n.tc-icon-backspace:before {\n  content: \"\\E14B\";\n}\n.tc-icon-cloud_upload:before {\n  content: \"\\E2C3\";\n}\n.tc-icon-beenhere:before {\n  content: \"\\E52D\";\n}\n.tc-icon-block:before {\n  content: \"\\E14C\";\n}\n.tc-icon-class:before {\n  content: \"\\E86E\";\n}\n.tc-icon-turned_in:before {\n  content: \"\\E8E6\";\n}\n.tc-icon-turned_in_not:before {\n  content: \"\\E8E7\";\n}\n.tc-icon-border_color:before {\n  content: \"\\E22B\";\n}\n.tc-icon-brightness_1:before {\n  content: \"\\E3A6\";\n}\n.tc-icon-build:before {\n  content: \"\\E869\";\n}\n.tc-icon-burst_mode:before {\n  content: \"\\E43C\";\n}\n.tc-icon-cached:before {\n  content: \"\\E86A\";\n}\n.tc-icon-phone:before {\n  content: \"\\E0CD\";\n}\n.tc-icon-call_end:before {\n  content: \"\\E0B1\";\n}\n.tc-icon-call_made:before {\n  content: \"\\E0B2\";\n}\n.tc-icon-call_received:before {\n  content: \"\\E0B5\";\n}\n.tc-icon-call_to_action:before {\n  content: \"\\E06C\";\n}\n.tc-icon-photo_camera:before {\n  content: \"\\E412\";\n}\n.tc-icon-camera_enhance:before {\n  content: \"\\E8FC\";\n}\n.tc-icon-cancel:before {\n  content: \"\\E5C9\";\n}\n.tc-icon-card_membership:before {\n  content: \"\\E8F7\";\n}\n.tc-icon-card_travel:before {\n  content: \"\\E8F8\";\n}\n.tc-icon-cast:before {\n  content: \"\\E307\";\n}\n.tc-icon-cast_connected:before {\n  content: \"\\E308\";\n}\n.tc-icon-center_focus_strong:before {\n  content: \"\\E3B4\";\n}\n.tc-icon-center_focus_weak:before {\n  content: \"\\E3B5\";\n}\n.tc-icon-change_history2:before {\n  content: \"\\E86C\";\n}\n.tc-icon-chat:before {\n  content: \"\\E0B7\";\n}\n.tc-icon-chat_bubble:before {\n  content: \"\\E0CA\";\n}\n.tc-icon-chat_bubble_outline:before {\n  content: \"\\E0CB\";\n}\n.tc-icon-check2:before {\n  content: \"\\E5CA\";\n}\n.tc-icon-check_box:before {\n  content: \"\\E834\";\n}\n.tc-icon-check_box_outline_blank:before {\n  content: \"\\E835\";\n}\n.tc-icon-check_circle:before {\n  content: \"\\E86F\";\n}\n.tc-icon-navigate_before:before {\n  content: \"\\E408\";\n}\n.tc-icon-navigate_next:before {\n  content: \"\\E409\";\n}\n.tc-icon-close2:before {\n  content: \"\\E5CD\";\n}\n.tc-icon-closed_caption:before {\n  content: \"\\E01D\";\n}\n.tc-icon-wb_cloudy:before {\n  content: \"\\E42D\";\n}\n.tc-icon-cloud_circle:before {\n  content: \"\\E2BE\";\n}\n.tc-icon-cloud_done:before {\n  content: \"\\E2BF\";\n}\n.tc-icon-cloud_download:before {\n  content: \"\\E2C0\";\n}\n.tc-icon-code:before {\n  content: \"\\E870\";\n}\n.tc-icon-photo_library:before {\n  content: \"\\E413\";\n}\n.tc-icon-contact_mail:before {\n  content: \"\\E0D0\";\n}\n.tc-icon-contact_phone:before {\n  content: \"\\E0CF\";\n}\n.tc-icon-content_copy2:before {\n  content: \"\\E14E\";\n}\n.tc-icon-content_cut:before {\n  content: \"\\E14F\";\n}\n.tc-icon-content_paste:before {\n  content: \"\\E150\";\n}\n.tc-icon-copyright:before {\n  content: \"\\E90C\";\n}\n.tc-icon-mode_edit:before {\n  content: \"\\E254\";\n}\n.tc-icon-create_new_folder2:before {\n  content: \"\\E2CD\";\n}\n.tc-icon-payment:before {\n  content: \"\\E8A1\";\n}\n.tc-icon-crop_original:before {\n  content: \"\\E3C4\";\n}\n.tc-icon-date_range2:before {\n  content: \"\\E917\";\n}\n.tc-icon-delete2:before {\n  content: \"\\E872\";\n}\n.tc-icon-description:before {\n  content: \"\\E873\";\n}\n.tc-icon-done:before {\n  content: \"\\E876\";\n}\n.tc-icon-drafts:before {\n  content: \"\\E151\";\n}\n.tc-icon-drag_handle:before {\n  content: \"\\E25D\";\n}\n.tc-icon-markunread:before {\n  content: \"\\E159\";\n}\n.tc-icon-error:before {\n  content: \"\\E000\";\n}\n.tc-icon-error_outline:before {\n  content: \"\\E001\";\n}\n.tc-icon-event_note:before {\n  content: \"\\E62C\";\n}\n.tc-icon-expand_less:before {\n  content: \"\\E5CE\";\n}\n.tc-icon-expand_more:before {\n  content: \"\\E5CF\";\n}\n.tc-icon-fast_forward:before {\n  content: \"\\E01F\";\n}\n.tc-icon-fast_rewind:before {\n  content: \"\\E020\";\n}\n.tc-icon-featured_play_list:before {\n  content: \"\\E06D\";\n}\n.tc-icon-sms_failed:before {\n  content: \"\\E62D\";\n}\n.tc-icon-fiber_manual_record:before {\n  content: \"\\E061\";\n}\n.tc-icon-fiber_pin:before {\n  content: \"\\E06A\";\n}\n.tc-icon-get_app:before {\n  content: \"\\E884\";\n}\n.tc-icon-file_upload:before {\n  content: \"\\E2C6\";\n}\n.tc-icon-filter2:before {\n  content: \"\\E3D3\";\n}\n.tc-icon-format_shapes:before {\n  content: \"\\E25E\";\n}\n.tc-icon-question_answer2:before {\n  content: \"\\E8B1\";\n}\n.tc-icon-forward:before {\n  content: \"\\E154\";\n}\n.tc-icon-star:before {\n  content: \"\\E838\";\n}\n.tc-icon-people:before {\n  content: \"\\E7FB\";\n}\n.tc-icon-group_add:before {\n  content: \"\\E7F0\";\n}\n.tc-icon-help:before {\n  content: \"\\E887\";\n}\n.tc-icon-help_outline:before {\n  content: \"\\E8FD\";\n}\n.tc-icon-highlight_off:before {\n  content: \"\\E888\";\n}\n.tc-icon-restore2:before {\n  content: \"\\E8B4\";\n}\n.tc-icon-home:before {\n  content: \"\\E88A\";\n}\n.tc-icon-local_hotel:before {\n  content: \"\\E549\";\n}\n.tc-icon-photo:before {\n  content: \"\\E410\";\n}\n.tc-icon-indeterminate_check_box:before {\n  content: \"\\E90D\";\n}\n.tc-icon-info2:before {\n  content: \"\\E88E\";\n}\n.tc-icon-info_outline:before {\n  content: \"\\E88F\";\n}\n.tc-icon-insert_drive_file:before {\n  content: \"\\E24D\";\n}\n.tc-icon-keyboard_arrow_down:before {\n  content: \"\\E313\";\n}\n.tc-icon-keyboard_arrow_left:before {\n  content: \"\\E314\";\n}\n.tc-icon-keyboard_arrow_right:before {\n  content: \"\\E315\";\n}\n.tc-icon-keyboard_arrow_up:before {\n  content: \"\\E316\";\n}\n.tc-icon-keyboard_backspace:before {\n  content: \"\\E317\";\n}\n.tc-icon-language2:before {\n  content: \"\\E895\";\n}\n.tc-icon-last_page:before {\n  content: \"\\E5DD\";\n}\n.tc-icon-linked_camera:before {\n  content: \"\\E438\";\n}\n.tc-icon-restaurant_menu:before {\n  content: \"\\E561\";\n}\n.tc-icon-print2:before {\n  content: \"\\E8AD\";\n}\n.tc-icon-sync:before {\n  content: \"\\E62E\";\n}\n.tc-icon-mail_outline:before {\n  content: \"\\E0E1\";\n}\n.tc-icon-message:before {\n  content: \"\\E0C9\";\n}\n.tc-icon-mms:before {\n  content: \"\\E62F\";\n}\n.tc-icon-mode_comment:before {\n  content: \"\\E253\";\n}\n.tc-icon-monetization_on:before {\n  content: \"\\E263\";\n}\n.tc-icon-money_off:before {\n  content: \"\\E25C\";\n}\n.tc-icon-more_horiz:before {\n  content: \"\\E5D3\";\n}\n.tc-icon-more_vert:before {\n  content: \"\\E5D4\";\n}\n.tc-icon-near_me:before {\n  content: \"\\E569\";\n}\n.tc-icon-signal_cellular_no_sim:before {\n  content: \"\\E1CE\";\n}\n.tc-icon-note_add:before {\n  content: \"\\E89C\";\n}\n.tc-icon-notifications:before {\n  content: \"\\E7F4\";\n}\n.tc-icon-pan_tool:before {\n  content: \"\\E925\";\n}\n.tc-icon-panorama:before {\n  content: \"\\E40B\";\n}\n.tc-icon-radio_button_unchecked:before {\n  content: \"\\E836\";\n}\n.tc-icon-pause:before {\n  content: \"\\E034\";\n}\n.tc-icon-pause_circle_filled:before {\n  content: \"\\E035\";\n}\n.tc-icon-pause_circle_outline:before {\n  content: \"\\E036\";\n}\n.tc-icon-perm_media:before {\n  content: \"\\E8A7\";\n}\n.tc-icon-person:before {\n  content: \"\\E7FD\";\n}\n.tc-icon-person_add:before {\n  content: \"\\E7FE\";\n}\n.tc-icon-photo_size_select_actual:before {\n  content: \"\\E432\";\n}\n.tc-icon-play_arrow:before {\n  content: \"\\E037\";\n}\n.tc-icon-play_circle_filled:before {\n  content: \"\\E038\";\n}\n.tc-icon-play_circle_outline:before {\n  content: \"\\E039\";\n}\n.tc-icon-portrait:before {\n  content: \"\\E416\";\n}\n.tc-icon-priority_high:before {\n  content: \"\\E645\";\n}\n.tc-icon-remove_shopping_cart:before {\n  content: \"\\E928\";\n}\n.tc-icon-report:before {\n  content: \"\\E160\";\n}\n.tc-icon-warning2:before {\n  content: \"\\E002\";\n}\n.tc-icon-security:before {\n  content: \"\\E32A\";\n}\n.tc-icon-sentiment_dissatisfied:before {\n  content: \"\\E811\";\n}\n.tc-icon-sentiment_neutral:before {\n  content: \"\\E812\";\n}\n.tc-icon-sentiment_satisfied:before {\n  content: \"\\E813\";\n}\n.tc-icon-sentiment_very_dissatisfied:before {\n  content: \"\\E814\";\n}\n.tc-icon-sentiment_very_satisfied:before {\n  content: \"\\E815\";\n}\n.tc-icon-shopping_basket:before {\n  content: \"\\E8CB\";\n}\n.tc-icon-skip_next:before {\n  content: \"\\E044\";\n}\n.tc-icon-skip_previous:before {\n  content: \"\\E045\";\n}\n.tc-icon-slideshow:before {\n  content: \"\\E41B\";\n}\n.tc-icon-swap_calls:before {\n  content: \"\\E0D7\";\n}\n.tc-icon-swap_horiz:before {\n  content: \"\\E8D4\";\n}\n.tc-icon-swap_vert2:before {\n  content: \"\\E8D6\";\n}\n.tc-icon-swap_vertical_circle:before {\n  content: \"\\E8D7\";\n}\n.tc-icon-thumb_down2:before {\n  content: \"\\E8DD\";\n}\n.tc-icon-thumb_up2:before {\n  content: \"\\E8DE\";\n}\n.tc-icon-toc:before {\n  content: \"\\E8DF\";\n}\n.tc-icon-trending_down:before {\n  content: \"\\E8E3\";\n}\n.tc-icon-trending_flat:before {\n  content: \"\\E8E4\";\n}\n.tc-icon-trending_up:before {\n  content: \"\\E8E5\";\n}\n.tc-icon-update:before {\n  content: \"\\E923\";\n}\n.tc-icon-verified_user:before {\n  content: \"\\E8E8\";\n}\n.tc-icon-vertical_align_bottom:before {\n  content: \"\\E258\";\n}\n.tc-icon-vertical_align_center:before {\n  content: \"\\E259\";\n}\n.tc-icon-vertical_align_top:before {\n  content: \"\\E25A\";\n}\n.tc-icon-video_library:before {\n  content: \"\\E04A\";\n}\n.tc-icon-wallpaper:before {\n  content: \"\\E1BC\";\n}\n.tc-icon-watch_later2:before {\n  content: \"\\E926\";\n}\n.tc-icon-weekend:before {\n  content: \"\\E16B\";\n}\n.tc-icon-zoom_in:before {\n  content: \"\\E8FF\";\n}\n.tc-icon-zoom_out:before {\n  content: \"\\E90E\";\n}\n.tc-icon-zoom_out_map:before {\n  content: \"\\E56B\";\n}\n.tc-icon-alarm2:before {\n  content: \"\\E856\";\n}\n.tc-icon-access_alarms2:before {\n  content: \"\\E192\";\n}\n.tc-icon-schedule2:before {\n  content: \"\\E8B6\";\n}\n.tc-icon-account_box2:before {\n  content: \"\\E852\";\n}\n.tc-icon-add22:before {\n  content: \"\\E157\";\n}\n.tc-icon-add_a_photo2:before {\n  content: \"\\E43B\";\n}\n.tc-icon-add_box2:before {\n  content: \"\\E158\";\n}\n.tc-icon-add_circle2:before {\n  content: \"\\E148\";\n}\n.tc-icon-control_point2:before {\n  content: \"\\E3BB\";\n}\n.tc-icon-adjust:before {\n  content: \"\\E39E\";\n}\n.tc-icon-alarm_on:before {\n  content: \"\\E858\";\n}\n.tc-icon-announcement2:before {\n  content: \"\\E85C\";\n}\n.tc-icon-arrow_back2:before {\n  content: \"\\E5D1\";\n}\n.tc-icon-arrow_downward2:before {\n  content: \"\\E5DF\";\n}\n.tc-icon-arrow_drop_down2:before {\n  content: \"\\E5D2\";\n}\n.tc-icon-arrow_drop_down_circle2:before {\n  content: \"\\E5D7\";\n}\n.tc-icon-arrow_drop_up2:before {\n  content: \"\\E5E0\";\n}\n.tc-icon-arrow_forward2:before {\n  content: \"\\E5E1\";\n}\n.tc-icon-arrow_upward2:before {\n  content: \"\\E5DC\";\n}\n.tc-icon-assignment_late:before {\n  content: \"\\E85F\";\n}\n.tc-icon-assignment_turned_in2:before {\n  content: \"\\E865\";\n}\n.tc-icon-attach_file22:before {\n  content: \"\\E229\";\n}\n.tc-icon-autorenew2:before {\n  content: \"\\E864\";\n}\n.tc-icon-backspace2:before {\n  content: \"\\E152\";\n}\n.tc-icon-beenhere2:before {\n  content: \"\\E52E\";\n}\n.tc-icon-border_color2:before {\n  content: \"\\E22C\";\n}\n.tc-icon-brightness_12:before {\n  content: \"\\E3A7\";\n}\n.tc-icon-build2:before {\n  content: \"\\E87A\";\n}\n.tc-icon-cached2:before {\n  content: \"\\E879\";\n}\n.tc-icon-phone2:before {\n  content: \"\\E0D2\";\n}\n.tc-icon-call_end2:before {\n  content: \"\\E0B4\";\n}\n.tc-icon-call_made2:before {\n  content: \"\\E0B3\";\n}\n.tc-icon-merge_type:before {\n  content: \"\\E252\";\n}\n.tc-icon-call_missed:before {\n  content: \"\\E0B9\";\n}\n.tc-icon-call_missed_outgoing:before {\n  content: \"\\E0E4\";\n}\n.tc-icon-call_received2:before {\n  content: \"\\E0B6\";\n}\n.tc-icon-call_split:before {\n  content: \"\\E0BA\";\n}\n.tc-icon-photo_camera2:before {\n  content: \"\\E414\";\n}\n.tc-icon-cancel2:before {\n  content: \"\\E5CC\";\n}\n.tc-icon-center_focus_strong2:before {\n  content: \"\\E3B6\";\n}\n.tc-icon-change_history22:before {\n  content: \"\\E875\";\n}\n.tc-icon-chat2:before {\n  content: \"\\E0B8\";\n}\n.tc-icon-chat_bubble2:before {\n  content: \"\\E0D1\";\n}\n.tc-icon-chat_bubble_outline2:before {\n  content: \"\\E0CE\";\n}\n.tc-icon-check22:before {\n  content: \"\\E5CB\";\n}\n.tc-icon-check_box2:before {\n  content: \"\\E83B\";\n}\n.tc-icon-check_box_outline_blank2:before {\n  content: \"\\E83A\";\n}\n.tc-icon-check_circle2:before {\n  content: \"\\E871\";\n}\n.tc-icon-navigate_before2:before {\n  content: \"\\E40D\";\n}\n.tc-icon-navigate_next2:before {\n  content: \"\\E40A\";\n}\n.tc-icon-close22:before {\n  content: \"\\E5D0\";\n}\n.tc-icon-copyright2:before {\n  content: \"\\E913\";\n}\n.tc-icon-delete_forever:before {\n  content: \"\\E92B\";\n}\n.tc-icon-do_not_disturb_off:before {\n  content: \"\\E643\";\n}\n.tc-icon-remove_circle:before {\n  content: \"\\E15C\";\n}\n.tc-icon-done2:before {\n  content: \"\\E877\";\n}\n.tc-icon-done_all:before {\n  content: \"\\E878\";\n}\n.tc-icon-drafts2:before {\n  content: \"\\E155\";\n}\n.tc-icon-markunread2:before {\n  content: \"\\E15A\";\n}\n.tc-icon-error2:before {\n  content: \"\\E005\";\n}\n.tc-icon-error_outline2:before {\n  content: \"\\E004\";\n}\n.tc-icon-event_available:before {\n  content: \"\\E630\";\n}\n.tc-icon-event_busy:before {\n  content: \"\\E631\";\n}\n.tc-icon-fast_forward2:before {\n  content: \"\\E022\";\n}\n.tc-icon-fast_rewind2:before {\n  content: \"\\E021\";\n}\n.tc-icon-favorite:before {\n  content: \"\\E87D\";\n}\n.tc-icon-favorite_border:before {\n  content: \"\\E87E\";\n}\n.tc-icon-fiber_manual_record2:before {\n  content: \"\\E062\";\n}\n.tc-icon-format_shapes2:before {\n  content: \"\\E261\";\n}\n.tc-icon-fullscreen:before {\n  content: \"\\E5E4\";\n}\n.tc-icon-fullscreen_exit:before {\n  content: \"\\E5E5\";\n}\n.tc-icon-people2:before {\n  content: \"\\E7FC\";\n}\n.tc-icon-group_add2:before {\n  content: \"\\E7F1\";\n}\n.tc-icon-home2:before {\n  content: \"\\E88B\";\n}\n.tc-icon-local_hotel2:before {\n  content: \"\\E54A\";\n}\n.tc-icon-hourglass_empty:before {\n  content: \"\\E88C\";\n}\n.tc-icon-hourglass_full:before {\n  content: \"\\E88D\";\n}\n.tc-icon-tag_faces:before {\n  content: \"\\E420\";\n}\n.tc-icon-keyboard_arrow_down2:before {\n  content: \"\\E31C\";\n}\n.tc-icon-keyboard_arrow_left2:before {\n  content: \"\\E31B\";\n}\n.tc-icon-keyboard_arrow_right2:before {\n  content: \"\\E31A\";\n}\n.tc-icon-keyboard_arrow_up2:before {\n  content: \"\\E319\";\n}\n.tc-icon-keyboard_backspace2:before {\n  content: \"\\E318\";\n}\n.tc-icon-keyboard_capslock:before {\n  content: \"\\E31D\";\n}\n.tc-icon-keyboard_return:before {\n  content: \"\\E31E\";\n}\n.tc-icon-keyboard_tab:before {\n  content: \"\\E31F\";\n}\n.tc-icon-last_page2:before {\n  content: \"\\E5DE\";\n}\n.tc-icon-lens:before {\n  content: \"\\E3FA\";\n}\n.tc-icon-linked_camera2:before {\n  content: \"\\E43A\";\n}\n.tc-icon-local_airport:before {\n  content: \"\\E53D\";\n}\n.tc-icon-shopping_cart:before {\n  content: \"\\E8CC\";\n}\n.tc-icon-location_off:before {\n  content: \"\\E0C7\";\n}\n.tc-icon-room:before {\n  content: \"\\E8B7\";\n}\n.tc-icon-message2:before {\n  content: \"\\E0CC\";\n}\n.tc-icon-more_horiz2:before {\n  content: \"\\E5D5\";\n}\n.tc-icon-more_vert2:before {\n  content: \"\\E5D6\";\n}\n.tc-icon-new_releases:before {\n  content: \"\\E031\";\n}\n.tc-icon-notifications_active:before {\n  content: \"\\E7F7\";\n}\n.tc-icon-panorama2:before {\n  content: \"\\E40C\";\n}\n.tc-icon-radio_button_unchecked2:before {\n  content: \"\\E837\";\n}\n.tc-icon-person_outline:before {\n  content: \"\\E807\";\n}\n.tc-icon-perm_media2:before {\n  content: \"\\E8A8\";\n}\n.tc-icon-person2:before {\n  content: \"\\E7FF\";\n}\n.tc-icon-person_add2:before {\n  content: \"\\E806\";\n}\n.tc-icon-person_pin:before {\n  content: \"\\E55A\";\n}\n.tc-icon-person_pin_circle:before {\n  content: \"\\E56A\";\n}\n.tc-icon-photo_size_select_actual2:before {\n  content: \"\\E433\";\n}\n.tc-icon-play_arrow2:before {\n  content: \"\\E03D\";\n}\n.tc-icon-play_circle_filled2:before {\n  content: \"\\E03B\";\n}\n.tc-icon-play_circle_outline2:before {\n  content: \"\\E03A\";\n}\n.tc-icon-priority_high2:before {\n  content: \"\\E646\";\n}\n.tc-icon-report2:before {\n  content: \"\\E161\";\n}\n.tc-icon-warning22:before {\n  content: \"\\E003\";\n}\n.tc-icon-cog:before {\n  content: \"\\E8B8\";\n}\n.tc-icon-subdirectory_arrow_left:before {\n  content: \"\\E5D9\";\n}\n.tc-icon-subdirectory_arrow_right:before {\n  content: \"\\E5DA\";\n}\n.tc-icon-subscriptions:before {\n  content: \"\\E064\";\n}\n.tc-icon-thumb_down22:before {\n  content: \"\\E8E1\";\n}\n.tc-icon-thumb_up22:before {\n  content: \"\\E8E0\";\n}\n.tc-icon-unfold_less:before {\n  content: \"\\E5E2\";\n}\n.tc-icon-unfold_more:before {\n  content: \"\\E5E3\";\n}\n.tc-icon-verified_user2:before {\n  content: \"\\E8E9\";\n}\n.tc-icon-volume_down:before {\n  content: \"\\E04D\";\n}\n.tc-icon-volume_mute:before {\n  content: \"\\E04E\";\n}\n.tc-icon-volume_off:before {\n  content: \"\\E04F\";\n}\n.tc-icon-volume_up:before {\n  content: \"\\E050\";\n}\n.tc-icon-watch_later22:before {\n  content: \"\\E927\";\n}\n.tc-icon-weekend2:before {\n  content: \"\\E16C\";\n}\n.tc-icon-zoom_in2:before {\n  content: \"\\E912\";\n}\n.tc-icon-zoom_out2:before {\n  content: \"\\E911\";\n}\n.tc-icon-google:before {\n  content: \"\\EA88\";\n}\n.tc-icon-yahoo:before {\n  content: \"\\EABB\";\n}\n.tc-icon-windows8:before {\n  content: \"\\EAC2\";\n}\n.tc-icon-linkedin:before {\n  content: \"\\EACA\";\n}\n/**\n * React Select\n * ============\n * Created by Jed Watson and Joss Mackison for KeystoneJS, http://www.keystonejs.com/\n * https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs\n * MIT License: https://github.com/JedWatson/react-select\n*/\n.Select {\n  position: relative;\n}\n.Select,\n.Select div,\n.Select input,\n.Select span {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.Select.is-disabled > .Select-control {\n  background-color: #f9f9f9;\n}\n.Select.is-disabled > .Select-control:hover {\n  box-shadow: none;\n}\n.Select.is-disabled .Select-arrow-zone {\n  cursor: default;\n  pointer-events: none;\n  opacity: 0.35;\n}\n.Select-control {\n  background-color: #fff;\n  border-color: #d9d9d9 #ccc #b3b3b3;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  color: #333;\n  cursor: default;\n  display: table;\n  border-spacing: 0;\n  border-collapse: separate;\n  height: 36px;\n  outline: none;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n.Select-control:hover {\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n}\n.Select-control .Select-input:focus {\n  outline: none;\n}\n.is-searchable.is-open > .Select-control {\n  cursor: text;\n}\n.is-open > .Select-control {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n  background: #fff;\n  border-color: #b3b3b3 #ccc #d9d9d9;\n}\n.is-open > .Select-control .Select-arrow {\n  top: -2px;\n  border-color: transparent transparent #999;\n  border-width: 0 5px 5px;\n}\n.is-searchable.is-focused:not(.is-open) > .Select-control {\n  cursor: text;\n}\n.is-focused:not(.is-open) > .Select-control {\n  border-color: #007eff;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 126, 255, 0.1);\n}\n.Select-placeholder,\n.Select--single > .Select-control .Select-value {\n  bottom: 0;\n  color: #aaa;\n  left: 0;\n  line-height: 34px;\n  padding-left: 10px;\n  padding-right: 10px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.has-value.Select--single > .Select-control .Select-value .Select-value-label,\n.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value .Select-value-label {\n  color: #333;\n}\n.has-value.Select--single > .Select-control .Select-value a.Select-value-label,\n.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label {\n  cursor: pointer;\n  text-decoration: none;\n}\n.has-value.Select--single > .Select-control .Select-value a.Select-value-label:hover,\n.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label:hover,\n.has-value.Select--single > .Select-control .Select-value a.Select-value-label:focus,\n.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label:focus {\n  color: #007eff;\n  outline: none;\n  text-decoration: underline;\n}\n.Select-input {\n  height: 34px;\n  padding-left: 10px;\n  padding-right: 10px;\n  vertical-align: middle;\n}\n.Select-input > input {\n  width: 100%;\n  background: none transparent;\n  border: 0 none;\n  box-shadow: none;\n  cursor: default;\n  display: inline-block;\n  font-family: inherit;\n  font-size: inherit;\n  margin: 0;\n  outline: none;\n  line-height: 14px;\n  /* For IE 8 compatibility */\n  padding: 8px 0 12px;\n  /* For IE 8 compatibility */\n  -webkit-appearance: none;\n}\n.is-focused .Select-input > input {\n  cursor: text;\n}\n.has-value.is-pseudo-focused .Select-input {\n  opacity: 0;\n}\n.Select-control:not(.is-searchable) > .Select-input {\n  outline: none;\n}\n.Select-loading-zone {\n  cursor: pointer;\n  display: table-cell;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: 16px;\n}\n.Select-loading {\n  -webkit-animation: Select-animation-spin 400ms infinite linear;\n  -o-animation: Select-animation-spin 400ms infinite linear;\n  animation: Select-animation-spin 400ms infinite linear;\n  width: 16px;\n  height: 16px;\n  box-sizing: border-box;\n  border-radius: 50%;\n  border: 2px solid #ccc;\n  border-right-color: #333;\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n}\n.Select-clear-zone {\n  -webkit-animation: Select-animation-fadeIn 200ms;\n  -o-animation: Select-animation-fadeIn 200ms;\n  animation: Select-animation-fadeIn 200ms;\n  color: #999;\n  cursor: pointer;\n  display: table-cell;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: 17px;\n}\n.Select-clear-zone:hover {\n  color: #D0021B;\n}\n.Select-clear {\n  display: inline-block;\n  font-size: 18px;\n  line-height: 1;\n}\n.Select--multi .Select-clear-zone {\n  width: 17px;\n}\n.Select-arrow-zone {\n  cursor: pointer;\n  display: table-cell;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: 25px;\n  padding-right: 5px;\n}\n.Select-arrow {\n  border-color: #999 transparent transparent;\n  border-style: solid;\n  border-width: 5px 5px 2.5px;\n  display: inline-block;\n  height: 0;\n  width: 0;\n  position: relative;\n}\n.is-open .Select-arrow,\n.Select-arrow-zone:hover > .Select-arrow {\n  border-top-color: #666;\n}\n.Select--multi .Select-multi-value-wrapper {\n  display: inline-block;\n}\n.Select .Select-aria-only {\n  display: inline-block;\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  clip: rect(0, 0, 0, 0);\n  overflow: hidden;\n  float: left;\n}\n@-webkit-keyframes Select-animation-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes Select-animation-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.Select-menu-outer {\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-top-color: #e6e6e6;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n  box-sizing: border-box;\n  margin-top: -1px;\n  max-height: 200px;\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  z-index: 1;\n  -webkit-overflow-scrolling: touch;\n}\n.Select-menu {\n  max-height: 198px;\n  overflow-y: auto;\n}\n.Select-option {\n  box-sizing: border-box;\n  background-color: #fff;\n  color: #666666;\n  cursor: pointer;\n  display: block;\n  padding: 8px 10px;\n}\n.Select-option:last-child {\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.Select-option.is-selected {\n  background-color: #f5faff;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 126, 255, 0.04);\n  color: #333;\n}\n.Select-option.is-focused {\n  background-color: #ebf5ff;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 126, 255, 0.08);\n  color: #333;\n}\n.Select-option.is-disabled {\n  color: #cccccc;\n  cursor: default;\n}\n.Select-noresults {\n  box-sizing: border-box;\n  color: #999999;\n  cursor: default;\n  display: block;\n  padding: 8px 10px;\n}\n.Select--multi .Select-input {\n  vertical-align: middle;\n  margin-left: 10px;\n  padding: 0;\n}\n.Select--multi.has-value .Select-input {\n  margin-left: 5px;\n}\n.Select--multi .Select-value {\n  background-color: #ebf5ff;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 126, 255, 0.08);\n  border-radius: 2px;\n  border: 1px solid #c2e0ff;\n  /* Fallback color for IE 8 */\n  border: 1px solid rgba(0, 126, 255, 0.24);\n  color: #007eff;\n  display: inline-block;\n  font-size: 0.9em;\n  line-height: 1.4;\n  margin-left: 5px;\n  margin-top: 5px;\n  vertical-align: top;\n}\n.Select--multi .Select-value-icon,\n.Select--multi .Select-value-label {\n  display: inline-block;\n  vertical-align: middle;\n}\n.Select--multi .Select-value-label {\n  border-bottom-right-radius: 2px;\n  border-top-right-radius: 2px;\n  cursor: default;\n  padding: 2px 5px;\n}\n.Select--multi a.Select-value-label {\n  color: #007eff;\n  cursor: pointer;\n  text-decoration: none;\n}\n.Select--multi a.Select-value-label:hover {\n  text-decoration: underline;\n}\n.Select--multi .Select-value-icon {\n  cursor: pointer;\n  border-bottom-left-radius: 2px;\n  border-top-left-radius: 2px;\n  border-right: 1px solid #c2e0ff;\n  /* Fallback color for IE 8 */\n  border-right: 1px solid rgba(0, 126, 255, 0.24);\n  padding: 1px 5px 3px;\n}\n.Select--multi .Select-value-icon:hover,\n.Select--multi .Select-value-icon:focus {\n  background-color: #d8eafd;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 113, 230, 0.08);\n  color: #0071e6;\n}\n.Select--multi .Select-value-icon:active {\n  background-color: #c2e0ff;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 126, 255, 0.24);\n}\n.Select--multi.is-disabled .Select-value {\n  background-color: #fcfcfc;\n  border: 1px solid #e3e3e3;\n  color: #333;\n}\n.Select--multi.is-disabled .Select-value-icon {\n  cursor: not-allowed;\n  border-right: 1px solid #e3e3e3;\n}\n.Select--multi.is-disabled .Select-value-icon:hover,\n.Select--multi.is-disabled .Select-value-icon:focus,\n.Select--multi.is-disabled .Select-value-icon:active {\n  background-color: #fcfcfc;\n}\n@keyframes Select-animation-spin {\n  to {\n    transform: rotate(1turn);\n  }\n}\n@-webkit-keyframes Select-animation-spin {\n  to {\n    -webkit-transform: rotate(1turn);\n  }\n}\n/*! normalize.css v3.0.2 | MIT License | git.io/normalize */\n/**\n * 1. Set default font family to sans-serif.\n * 2. Prevent iOS text size adjust after orientation change, without disabling\n *    user zoom.\n */\nhtml {\n  font-family: sans-serif;\n  /* 1 */\n  -ms-text-size-adjust: 100%;\n  /* 2 */\n  -webkit-text-size-adjust: 100%;\n  /* 2 */\n}\n/**\n * Remove default margin.\n */\nbody {\n  margin: 0;\n}\n/* HTML5 display definitions\n   ========================================================================== */\n/**\n * Correct `block` display not defined for any HTML5 element in IE 8/9.\n * Correct `block` display not defined for `details` or `summary` in IE 10/11\n * and Firefox.\n * Correct `block` display not defined for `main` in IE 11.\n */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block;\n}\n/**\n * 1. Correct `inline-block` display not defined in IE 8/9.\n * 2. Normalize vertical alignment of `progress` in Chrome, Firefox, and Opera.\n */\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  /* 1 */\n  vertical-align: baseline;\n  /* 2 */\n}\n/**\n * Prevent modern browsers from displaying `audio` without controls.\n * Remove excess height in iOS 5 devices.\n */\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n/**\n * Address `[hidden]` styling not present in IE 8/9/10.\n * Hide the `template` element in IE 8/9/11, Safari, and Firefox < 22.\n */\n[hidden],\ntemplate {\n  display: none;\n}\n/* Links\n   ========================================================================== */\n/**\n * Remove the gray background color from active links in IE 10.\n */\na {\n  background-color: transparent;\n}\n/**\n * Improve readability when focused and also mouse hovered in all browsers.\n */\na:active,\na:hover {\n  outline: 0;\n}\n/* Text-level semantics\n   ========================================================================== */\n/**\n * Address styling not present in IE 8/9/10/11, Safari, and Chrome.\n */\nabbr[title] {\n  border-bottom: 1px dotted;\n}\n/**\n * Address style set to `bolder` in Firefox 4+, Safari, and Chrome.\n */\nb,\nstrong {\n  font-weight: bold;\n}\n/**\n * Address styling not present in Safari and Chrome.\n */\ndfn {\n  font-style: italic;\n}\n/**\n * Address variable `h1` font-size and margin within `section` and `article`\n * contexts in Firefox 4+, Safari, and Chrome.\n */\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n/**\n * Address styling not present in IE 8/9.\n */\nmark {\n  background: #ff0;\n  color: #000;\n}\n/**\n * Address inconsistent and variable font size in all browsers.\n */\nsmall {\n  font-size: 80%;\n}\n/**\n * Prevent `sub` and `sup` affecting `line-height` in all browsers.\n */\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\nsup {\n  top: -0.5em;\n}\nsub {\n  bottom: -0.25em;\n}\n/* Embedded content\n   ========================================================================== */\n/**\n * Remove border when inside `a` element in IE 8/9/10.\n */\nimg {\n  border: 0;\n}\n/**\n * Correct overflow not hidden in IE 9/10/11.\n */\nsvg:not(:root) {\n  overflow: hidden;\n}\n/* Grouping content\n   ========================================================================== */\n/**\n * Address margin not present in IE 8/9 and Safari.\n */\nfigure {\n  margin: 1em 40px;\n}\n/**\n * Address differences between Firefox and other browsers.\n */\nhr {\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n  height: 0;\n}\n/**\n * Contain overflow in all browsers.\n */\npre {\n  overflow: auto;\n}\n/**\n * Address odd `em`-unit font size rendering in all browsers.\n */\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\n/* Forms\n   ========================================================================== */\n/**\n * Known limitation: by default, Chrome and Safari on OS X allow very limited\n * styling of `select`, unless a `border` property is set.\n */\n/**\n * 1. Correct color not being inherited.\n *    Known issue: affects color of disabled elements.\n * 2. Correct font properties not being inherited.\n * 3. Address margins set differently in Firefox 4+, Safari, and Chrome.\n */\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  color: inherit;\n  /* 1 */\n  font: inherit;\n  /* 2 */\n  margin: 0;\n  /* 3 */\n}\n/**\n * Address `overflow` set to `hidden` in IE 8/9/10/11.\n */\nbutton {\n  overflow: visible;\n}\n/**\n * Address inconsistent `text-transform` inheritance for `button` and `select`.\n * All other form control elements do not inherit `text-transform` values.\n * Correct `button` style inheritance in Firefox, IE 8/9/10/11, and Opera.\n * Correct `select` style inheritance in Firefox.\n */\nbutton,\nselect {\n  text-transform: none;\n}\n/**\n * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`\n *    and `video` controls.\n * 2. Correct inability to style clickable `input` types in iOS.\n * 3. Improve usability and consistency of cursor style between image-type\n *    `input` and others.\n */\nbutton,\nhtml input[type=\"button\"],\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  /* 2 */\n  cursor: pointer;\n  /* 3 */\n}\n/**\n * Re-set default cursor for disabled elements.\n */\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\n/**\n * Remove inner padding and border in Firefox 4+.\n */\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n/**\n * Address Firefox 4+ setting `line-height` on `input` using `!important` in\n * the UA stylesheet.\n */\ninput {\n  line-height: normal;\n}\n/**\n * It's recommended that you don't attempt to style these elements.\n * Firefox's implementation doesn't respect box-sizing, padding, or width.\n *\n * 1. Address box sizing set to `content-box` in IE 8/9/10.\n * 2. Remove excess padding in IE 8/9/10.\n */\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box;\n  /* 1 */\n  padding: 0;\n  /* 2 */\n}\n/**\n * Fix the cursor style for Chrome's increment/decrement buttons. For certain\n * `font-size` values of the `input`, it causes the cursor style of the\n * decrement button to change from `default` to `text`.\n */\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n/**\n * 1. Address `appearance` set to `searchfield` in Safari and Chrome.\n * 2. Address `box-sizing` set to `border-box` in Safari and Chrome\n *    (include `-moz` to future-proof).\n */\ninput[type=\"search\"] {\n  -webkit-appearance: textfield;\n  /* 1 */\n  -moz-box-sizing: content-box;\n  -webkit-box-sizing: content-box;\n  /* 2 */\n  box-sizing: content-box;\n}\n/**\n * Remove inner padding and search cancel button in Safari and Chrome on OS X.\n * Safari (but not Chrome) clips the cancel button when the search input has\n * padding (and `textfield` appearance).\n */\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n/**\n * Define consistent border, margin, and padding.\n */\n/*\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}*/\n/**\n * 1. Correct `color` not being inherited in IE 8/9/10/11.\n * 2. Remove padding so people aren't caught out if they zero out fieldsets.\n */\nlegend {\n  border: 0;\n  /* 1 */\n  padding: 0;\n  /* 2 */\n}\n/**\n * Remove default vertical scrollbar in IE 8/9/10/11.\n */\ntextarea {\n  overflow: auto;\n}\n/**\n * Don't inherit the `font-weight` (applied by a rule above).\n * NOTE: the default cannot safely be changed in Chrome and Safari on OS X.\n */\noptgroup {\n  font-weight: bold;\n}\n/* Tables\n   ========================================================================== */\n/**\n * Remove most spacing between table cells.\n */\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\ntd,\nth {\n  padding: 0;\n}\n/*------------------------------------*\n  RESET\n*------------------------------------*/\nbody,\ndiv,\ndl,\ndt,\ndd,\nul,\nol,\nli,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\npre,\nform,\nfieldset,\ninput,\ntextarea,\np,\nblockquote,\nth,\ntd {\n  margin: 0;\n  padding: 0;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\nfieldset,\nimg {\n  border: 0;\n}\naddress,\ncaption,\ncite,\ndfn,\nth,\nvar {\n  font-style: normal;\n  font-weight: normal;\n}\ncaption,\nth {\n  text-align: left;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: 100%;\n  font-weight: normal;\n}\nq:before,\nq:after {\n  content: '';\n}\nabbr,\nacronym {\n  border: 0;\n}\n.no-wrap {\n  white-space: nowrap;\n}\n* {\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n*:before,\n*:after {\n  box-sizing: border-box;\n}\nhtml,\nbody {\n  height: 100%;\n  width: 100%;\n}\nhtml {\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n  -webkit-font-smoothing: antialiased;\n  color: rgba(0, 0, 0, 0.54);\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  background-color: #fafafa;\n}\nhr {\n  border: none;\n  border-bottom: solid 1px #e0e0e0;\n}\n.mui-text-full-black {\n  color: #000000;\n}\n.mui-text-dark-black {\n  color: rgba(0, 0, 0, 0.87);\n}\n.mui-text-light-black {\n  color: rgba(0, 0, 0, 0.54);\n}\n.mui-text-min-black {\n  color: rgba(0, 0, 0, 0.26);\n}\n.mui-text-full-white {\n  color: #ffffff;\n}\n.mui-text-dark-white {\n  color: rgba(255, 255, 255, 0.87);\n}\n.mui-text-light-white {\n  color: rgba(255, 255, 255, 0.54);\n}\n.mui-font-weight-light {\n  font-weight: 300;\n}\n.mui-font-weight-normal {\n  font-weight: 400;\n}\n.mui-font-weight-medium {\n  font-weight: 500;\n}\n/* Type Styles */\n.mui-font-style-display-4 {\n  font-size: 112px;\n  line-height: 128px;\n  letter-spacing: -7px;\n  padding-top: 17px;\n  margin-bottom: 15px;\n  font-weight: 300;\n  color: rgba(0, 0, 0, 0.54);\n}\n.mui-font-style-display-3 {\n  font-size: 56px;\n  line-height: 64px;\n  letter-spacing: -2px;\n  padding-top: 8px;\n  margin-bottom: 28px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.54);\n}\n.mui-font-style-display-2 {\n  font-size: 45px;\n  line-height: 48px;\n  margin-bottom: 11px;\n  letter-spacing: -1px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.54);\n}\n.mui-font-style-display-1 {\n  font-size: 34px;\n  line-height: 40px;\n  padding-top: 8px;\n  margin-bottom: 12px;\n  letter-spacing: -1px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.54);\n}\n.mui-font-style-headline {\n  font-size: 24px;\n  line-height: 32px;\n  padding-top: 16px;\n  margin-bottom: 12px;\n  letter-spacing: 0;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.87);\n}\n.mui-font-style-title {\n  font-size: 20px;\n  line-height: 28px;\n  padding-top: 19px;\n  margin-bottom: 13px;\n  letter-spacing: 0;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n}\n.mui-font-style-subhead-2 {\n  font-size: 15px;\n  line-height: 28px;\n  padding-top: 2px;\n  margin-bottom: 10px;\n  letter-spacing: 0;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.87);\n}\n.mui-font-style-subhead-1 {\n  font-size: 15px;\n  line-height: 28px;\n  padding-top: 2px;\n  margin-bottom: 10px;\n  letter-spacing: 0;\n  font-weight: 400;\n  line-height: 24px;\n  padding-top: 3px;\n  margin-bottom: 13px;\n  color: rgba(0, 0, 0, 0.87);\n}\n.mui-font-style-body-2 {\n  font-size: 13px;\n  line-height: 24px;\n  padding-top: 4px;\n  margin-bottom: 12px;\n  letter-spacing: 0;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n}\n.mui-font-style-body-1 {\n  font-size: 13px;\n  line-height: 20px;\n  padding-top: 6px;\n  margin-bottom: 14px;\n  letter-spacing: 0;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.87);\n}\n.mui-font-style-caption {\n  font-size: 12px;\n  line-height: 20px;\n  padding-top: 6px;\n  margin-bottom: 14px;\n  letter-spacing: 0;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.54);\n}\n.mui-font-style-menu {\n  font-size: 13px;\n  line-height: 20px;\n  padding-top: 6px;\n  margin-bottom: 14px;\n  letter-spacing: 0;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n}\n.mui-font-style-button {\n  font-size: 14px;\n  line-height: 20px;\n  padding-top: 5px;\n  margin-bottom: 15px;\n  letter-spacing: 0;\n  text-transform: uppercase;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n}\n/* General HTML Typography */\nbody {\n  font-size: 13px;\n  line-height: 20px;\n}\nh1 {\n  font-size: 45px;\n  line-height: 48px;\n  margin-bottom: 11px;\n  letter-spacing: -1px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.54);\n}\nh2 {\n  font-size: 34px;\n  line-height: 40px;\n  padding-top: 8px;\n  margin-bottom: 12px;\n  letter-spacing: -1px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.54);\n}\nh3 {\n  font-size: 24px;\n  line-height: 32px;\n  padding-top: 16px;\n  margin-bottom: 12px;\n  letter-spacing: 0;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.87);\n}\nh4 {\n  font-size: 20px;\n  line-height: 28px;\n  padding-top: 19px;\n  margin-bottom: 13px;\n  letter-spacing: 0;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n}\nh5 {\n  font-size: 15px;\n  line-height: 28px;\n  padding-top: 2px;\n  margin-bottom: 10px;\n  letter-spacing: 0;\n  font-weight: 400;\n  line-height: 24px;\n  padding-top: 3px;\n  margin-bottom: 13px;\n  color: rgba(0, 0, 0, 0.87);\n}\nh6 {\n  font-size: 13px;\n  line-height: 24px;\n  padding-top: 4px;\n  margin-bottom: 12px;\n  letter-spacing: 0;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n}\np {\n  font-size: 13px;\n  line-height: 20px;\n  padding-top: 6px;\n  margin-bottom: 14px;\n  letter-spacing: 0;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.87);\n}\nhr {\n  margin-top: 0;\n  margin-bottom: 18px;\n}\n.mui-predefined-layout-1 .mui-app-content-canvas {\n  padding-top: 64px;\n}\n.mui-predefined-layout-1 .mui-app-bar {\n  position: fixed;\n  height: 64px;\n}\n.mui-key-width-1 {\n  width: 64px;\n}\n.mui-key-width-2 {\n  width: 128px;\n}\n.mui-key-width-3 {\n  width: 192px;\n}\n.mui-key-width-4 {\n  width: 256px;\n}\n.mui-key-width-5 {\n  width: 320px;\n}\n.mui-key-width-6 {\n  width: 384px;\n}\n.mui-key-width-7 {\n  width: 448px;\n}\n.mui-key-width-8 {\n  width: 512px;\n}\n.mui-key-width-9 {\n  width: 576px;\n}\n.mui-key-width-10 {\n  width: 640px;\n}\n.mui-key-height-1 {\n  height: 64px;\n}\n.mui-key-height-2 {\n  height: 128px;\n}\n.mui-key-height-3 {\n  height: 192px;\n}\n.mui-key-height-4 {\n  height: 256px;\n}\n.mui-key-height-5 {\n  height: 320px;\n}\n.mui-key-height-6 {\n  height: 384px;\n}\n.mui-key-height-7 {\n  height: 448px;\n}\n.mui-key-height-8 {\n  height: 512px;\n}\n.mui-key-height-9 {\n  height: 576px;\n}\n.mui-key-height-10 {\n  height: 640px;\n}\n.mui-paper.mui-rounded {\n  border-radius: 2px;\n}\n.mui-paper.mui-rounded > .mui-paper-container {\n  border-radius: 2px;\n}\n.mui-paper.mui-circle {\n  border-radius: 50%;\n}\n.mui-paper.mui-circle > .mui-paper-container {\n  border-radius: 50%;\n}\n.mui-paper > .mui-paper-container {\n  height: 100%;\n  width: 100%;\n}\n.mui-paper.mui-z-depth-1 {\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.24);\n}\n.mui-paper.mui-z-depth-1 > .mui-z-depth-bottom {\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);\n}\n.mui-paper.mui-z-depth-2 {\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23);\n}\n.mui-paper.mui-z-depth-2 > .mui-z-depth-bottom {\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.16);\n}\n.mui-paper.mui-z-depth-3 {\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.23);\n}\n.mui-paper.mui-z-depth-3 > .mui-z-depth-bottom {\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.19);\n}\n.mui-paper.mui-z-depth-4 {\n  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.22);\n}\n.mui-paper.mui-z-depth-4 > .mui-z-depth-bottom {\n  box-shadow: 0 14px 45px rgba(0, 0, 0, 0.25);\n}\n.mui-paper.mui-z-depth-5 {\n  box-shadow: 0 15px 20px rgba(0, 0, 0, 0.22);\n}\n.mui-paper.mui-z-depth-5 > .mui-z-depth-bottom {\n  box-shadow: 0 19px 60px rgba(0, 0, 0, 0.3);\n}\n.mui-dialog .mui-dialog-title {\n  padding: 24px 24px 0 24px;\n  margin-bottom: 0;\n}\n.mui-dialog .mui-dialog-content {\n  padding: 24px;\n}\n.mui-dialog-window {\n  position: fixed;\n  z-index: 10;\n  top: 0px;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms;\n}\n.mui-dialog-window .mui-dialog-window-contents {\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  position: relative;\n  width: 75%;\n  max-width: 768px;\n  margin: 0 auto;\n  z-index: 10;\n  background: #fafafa;\n  opacity: 0;\n}\n.mui-dialog-window .mui-dialog-window-actions {\n  padding: 8px;\n  margin-bottom: 8px;\n  width: 100%;\n  text-align: right;\n}\n.mui-dialog-window .mui-dialog-window-actions .mui-dialog-window-action {\n  margin-right: 8px;\n}\n.mui-dialog-window.mui-is-shown {\n  left: 0px;\n  transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-dialog-window.mui-is-shown .mui-dialog-window-contents {\n  opacity: 1;\n  top: 0px;\n  transform: translate3d(0, 64px, 0);\n}\n.mui-enhanced-button {\n  border: 0;\n  background: none;\n}\n.mui-enhanced-button:focus {\n  outline: none;\n}\n.mui-enhanced-button.mui-is-link-button {\n  display: inline-block;\n  cursor: pointer;\n  text-decoration: none;\n}\n.mui-enhanced-button.mui-is-link-button:hover {\n  text-decoration: none;\n}\n.mui-enhanced-button.mui-is-link-button.mui-is-disabled {\n  cursor: default;\n}\n.mui-enhanced-textarea .mui-enhanced-textarea-shadow,\n.mui-enhanced-textarea .mui-enhanced-textarea-input {\n  width: 100%;\n  resize: none;\n}\n.mui-enhanced-textarea .mui-enhanced-textarea-input {\n  overflow: hidden;\n}\n.mui-enhanced-textarea .mui-enhanced-textarea-shadow {\n  transform: scale(0);\n  position: absolute;\n}\n.mui-icon-button {\n  position: relative;\n  padding: 12px;\n}\n.mui-icon-button * {\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-icon-button .mui-focus-ripple .mui-focus-ripple-inner {\n  background-color: rgba(0, 0, 0, 0.1);\n  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.1);\n  border: solid 6px rgba(0, 0, 0, 0);\n  background-clip: padding-box;\n  animation: icon-button-focus-ripple-pulsate 1.5s ease 0s infinite;\n}\n@keyframes icon-button-focus-ripple-pulsate {\n  0%,\n  100% {\n    transform: scale(0.75);\n  }\n  50% {\n    transform: scale(1);\n  }\n}\n.mui-icon-button .mui-icon-button-tooltip {\n  margin-top: 52px;\n}\n.mui-icon-button.mui-is-disabled * {\n  color: rgba(191, 191, 191, 0.54);\n  fill: rgba(191, 191, 191, 0.54);\n}\n.mui-dark-theme .mui-touch-ripple .mui-ripple-circle-inner {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n.mui-dark-theme .mui-focus-ripple .mui-focus-ripple-inner {\n  background-color: rgba(255, 255, 255, 0.3);\n  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.3);\n}\n.mui-tooltip {\n  position: absolute;\n  font-size: 12px;\n  line-height: 22px;\n  padding: 0 8px;\n  color: #ffffff;\n  overflow: hidden;\n  top: -10000px;\n  border-radius: 2px;\n  user-select: none;\n  opacity: 0;\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-tooltip .mui-tooltip-label {\n  position: relative;\n  white-space: nowrap;\n}\n.mui-tooltip .mui-tooltip-ripple {\n  position: absolute;\n  left: 50%;\n  top: 0px;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  background-color: transparent;\n  transition: width 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms, height 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms, background-color 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-tooltip.mui-is-shown {\n  top: 24px;\n  opacity: 1;\n  transform: translate3d(0px, 16px, 0px);\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-tooltip.mui-is-shown .mui-tooltip-ripple {\n  background-color: #757575;\n  transition: width 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, height 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, background-color 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-tooltip.mui-is-touch {\n  font-size: 14px;\n  line-height: 44px;\n  padding: 0 16px;\n}\n.mui-tooltip.mui-is-touch.mui-is-shown .mui-tooltip-ripple {\n  height: 105px;\n  width: 105px;\n}\n.mui-flat-button {\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  font-size: 14px;\n  line-height: 20px;\n  padding-top: 5px;\n  margin-bottom: 15px;\n  letter-spacing: 0;\n  text-transform: uppercase;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n  border-radius: 2px;\n  user-select: none;\n  position: relative;\n  overflow: hidden;\n  background-color: #ffffff;\n  color: rgba(0, 0, 0, 0.54);\n  line-height: 36px;\n  min-width: 88px;\n  padding: 0 16px;\n  margin: 0;\n  transform: translate3d(0, 0, 0);\n}\n.mui-flat-button .mui-touch-ripple .mui-ripple-circle-inner {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.mui-flat-button .mui-focus-ripple .mui-focus-ripple-inner {\n  background-color: rgba(0, 0, 0, 0.07);\n}\n.mui-flat-button .mui-flat-button-label {\n  position: relative;\n}\n.mui-flat-button:hover,\n.mui-flat-button.mui-is-keyboard-focused {\n  background-color: #e6e6e6;\n}\n.mui-flat-button.mui-is-disabled {\n  color: rgba(0, 0, 0, 0.3);\n}\n.mui-flat-button.mui-is-disabled:hover {\n  background-color: inherit;\n}\n.mui-flat-button.mui-is-primary {\n  color: #ff4081;\n}\n.mui-flat-button.mui-is-primary:hover,\n.mui-flat-button.mui-is-primary.mui-is-keyboard-focused {\n  background-color: #ffe3ed;\n}\n.mui-flat-button.mui-is-primary .mui-touch-ripple .mui-ripple-circle-inner {\n  background-color: rgba(255, 64, 129, 0.2);\n}\n.mui-flat-button.mui-is-primary .mui-focus-ripple .mui-focus-ripple-inner {\n  background-color: rgba(255, 64, 129, 0.2);\n}\n.mui-flat-button.mui-is-secondary {\n  color: #00bcd4;\n}\n.mui-flat-button.mui-is-secondary:hover,\n.mui-flat-button.mui-is-secondary.mui-is-keyboard-focused {\n  background-color: #defbff;\n}\n.mui-flat-button.mui-is-secondary .mui-touch-ripple .mui-ripple-circle-inner {\n  background-color: rgba(0, 188, 212, 0.2);\n}\n.mui-flat-button.mui-is-secondary .mui-focus-ripple .mui-focus-ripple-inner {\n  background-color: rgba(0, 188, 212, 0.2);\n}\n.mui-font-icon {\n  position: relative;\n  font-size: 24px;\n  display: inline-block;\n  user-select: none;\n}\n.mui-raised-button {\n  display: inline-block;\n  min-width: 88px;\n  height: 36px;\n}\n.mui-raised-button,\n.mui-raised-button * {\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-raised-button .mui-raised-button-container {\n  position: relative;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n  border-radius: 2px;\n  background-color: #ffffff;\n  transform: translate3d(0, 0, 0);\n}\n.mui-raised-button .mui-raised-button-container.mui-is-keyboard-focused {\n  background-color: #e6e6e6;\n}\n.mui-raised-button .mui-raised-button-container.mui-is-disabled {\n  background-color: #e6e6e6;\n}\n.mui-raised-button .mui-raised-button-container.mui-is-disabled .mui-raised-button-label {\n  color: rgba(0, 0, 0, 0.3);\n}\n.mui-raised-button .mui-raised-button-container.mui-is-disabled:hover {\n  background-color: #e6e6e6;\n}\n.mui-raised-button .mui-touch-ripple .mui-ripple-circle-inner {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.mui-raised-button .mui-focus-ripple .mui-focus-ripple-inner {\n  background-color: rgba(0, 0, 0, 0.07);\n}\n.mui-raised-button .mui-raised-button-label {\n  position: relative;\n  font-size: 14px;\n  line-height: 20px;\n  padding-top: 5px;\n  margin-bottom: 15px;\n  letter-spacing: 0;\n  text-transform: uppercase;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n  margin: 0;\n  padding: 0 16px;\n  user-select: none;\n  line-height: 36px;\n  color: rgba(0, 0, 0, 0.54);\n}\n.mui-raised-button:hover .mui-raised-button-container {\n  background-color: #e6e6e6;\n}\n.mui-raised-button.mui-is-primary .mui-raised-button-container {\n  background-color: #ff4081;\n}\n.mui-raised-button.mui-is-primary .mui-raised-button-container.mui-is-keyboard-focused {\n  background-color: #f30053;\n}\n.mui-raised-button.mui-is-primary .mui-touch-ripple .mui-ripple-circle-inner {\n  background-color: rgba(255, 255, 255, 0.5);\n}\n.mui-raised-button.mui-is-primary .mui-focus-ripple .mui-focus-ripple-inner {\n  background-color: rgba(255, 255, 255, 0.5);\n}\n.mui-raised-button.mui-is-primary .mui-raised-button-label {\n  color: #ffffff;\n}\n.mui-raised-button.mui-is-primary:hover .mui-raised-button-container {\n  background-color: #f30053;\n}\n.mui-raised-button.mui-is-secondary .mui-raised-button-container {\n  background-color: #00bcd4;\n}\n.mui-raised-button.mui-is-secondary .mui-raised-button-container.mui-is-keyboard-focused {\n  background-color: #00aac0;\n}\n.mui-raised-button.mui-is-secondary .mui-touch-ripple .mui-ripple-circle-inner {\n  background-color: rgba(255, 255, 255, 0.35);\n}\n.mui-raised-button.mui-is-secondary .mui-focus-ripple .mui-focus-ripple-inner {\n  background-color: rgba(255, 255, 255, 0.35);\n}\n.mui-raised-button.mui-is-secondary .mui-raised-button-label {\n  color: #ffffff;\n}\n.mui-raised-button.mui-is-secondary:hover .mui-raised-button-container {\n  background-color: #00aac0;\n}\n.mui-focus-ripple {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  transform: scale(0);\n  opacity: 0;\n}\n.mui-focus-ripple .mui-focus-ripple-inner {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  border-radius: 50%;\n  background-color: rgba(0, 0, 0, 0.1);\n  animation: focus-ripple-pulsate 1.5s ease 0s infinite;\n}\n@keyframes focus-ripple-pulsate {\n  0%,\n  100% {\n    transform: scale(0.75);\n  }\n  50% {\n    transform: scale(0.85);\n  }\n}\n.mui-focus-ripple.mui-is-shown {\n  transform: scale(1);\n  opacity: 1;\n}\n.mui-ripple-circle {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  opacity: 0.7;\n  transition: opacity 2s cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-ripple-circle .mui-ripple-circle-inner {\n  height: 100%;\n  width: 100%;\n  border-radius: 50%;\n  transform: scale(0);\n  background-color: rgba(0, 0, 0, 0.2);\n  transition: transform 1s cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-ripple-circle.mui-is-started {\n  opacity: 1;\n}\n.mui-ripple-circle.mui-is-started .mui-ripple-circle-inner {\n  transform: scale(1);\n}\n.mui-ripple-circle.mui-is-ending {\n  opacity: 0;\n}\n.mui-touch-ripple {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.mui-snackbar {\n  color: white;\n  background-color: #323232;\n  border-radius: 2px;\n  padding: 0 24px;\n  height: 48px;\n  line-height: 48px;\n  min-width: 288px;\n  max-width: 568px;\n  position: fixed;\n  z-index: 10;\n  bottom: 24px;\n  margin-left: 24px;\n  left: -10000px;\n  opacity: 0;\n  transform: translate3d(0, 20px, 0);\n  transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 400ms, opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-snackbar .mui-snackbar-action {\n  color: #ff4081;\n  float: right;\n  margin-top: 6px;\n  margin-right: -16px;\n  margin-left: 24px;\n  background-color: transparent;\n}\n.mui-snackbar.mui-is-open {\n  left: 0;\n  opacity: 1;\n  transform: translate3d(0, 0, 0);\n  transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.individual-invitation {\n  height: 60px;\n}\n.individual-invitation .mui-text-field {\n  width: 220px;\n  margin-right: 16px;\n}\n.individual-invitation .mui-text-field:nth-child(4) {\n  margin-right: 0px;\n}\n.individual-invitation .tc-icon {\n  float: none;\n  vertical-align: bottom;\n  font-size: 24px;\n  line-height: 48px;\n  margin-left: 12px;\n  cursor: pointer;\n}\n.individual-invitation .tc-icon.tc-icon-add {\n  margin-left: 0;\n}\n.mui-text-field {\n  font-size: 14px;\n  line-height: 24px;\n  height: 48px;\n  width: 100%;\n  display: inline-block;\n  position: relative;\n  transition: height 200ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-text-field .mui-text-field-hint,\n.mui-text-field .mui-text-field-floating-label {\n  position: absolute;\n  line-height: 48px;\n  color: rgba(0, 0, 0, 0.3);\n  opacity: 1;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-text-field .mui-text-field-error {\n  position: absolute;\n  bottom: -10px;\n  font-size: 12px;\n  line-height: 12px;\n  color: #f44336;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-text-field .mui-text-field-character-count {\n  position: absolute;\n  bottom: -10px;\n  font-size: 12px;\n  line-height: 12px;\n  right: 0;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-text-field .mui-text-field-character-count.mui-text-field-character-count-error {\n  color: #f44336;\n}\n.mui-text-field .mui-text-field-input,\n.mui-text-field .mui-text-field-textarea {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border: none;\n  outline: none;\n  background-color: rgba(0, 0, 0, 0);\n  color: rgba(0, 0, 0, 0.54);\n}\n.mui-text-field .mui-text-field-textarea {\n  margin-top: 12px;\n}\n.mui-text-field .mui-text-field-underline,\n.mui-text-field .mui-text-field-focus-underline {\n  position: absolute;\n  width: 100%;\n  bottom: 8px;\n  margin: 0;\n}\n.mui-text-field .mui-text-field-focus-underline {\n  border-color: #00bcd4;\n  border-bottom-width: 2px;\n  transform: scaleX(0);\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-text-field.mui-has-error .mui-text-field-focus-underline {\n  border-color: #f44336;\n  transform: scaleX(1);\n}\n.mui-text-field.mui-has-value .mui-text-field-hint {\n  opacity: 0;\n}\n.mui-text-field.mui-is-disabled .mui-text-field-input {\n  color: rgba(0, 0, 0, 0.3);\n}\n.mui-text-field.mui-is-disabled .mui-text-field-underline {\n  border: none;\n  height: 40px;\n  border-bottom: 1px dotted #9e9e9e;\n}\n.mui-text-field.mui-is-focused .mui-text-field-focus-underline {\n  transform: scaleX(1);\n}\n.mui-text-field.mui-has-floating-labels {\n  height: 72px;\n}\n.mui-text-field.mui-has-floating-labels .mui-text-field-floating-label {\n  top: 24px;\n  transform: scale(1) translate3d(0, 0, 0);\n  transform-origin: left top;\n}\n.mui-text-field.mui-has-floating-labels .mui-text-field-hint {\n  top: 24px;\n  opacity: 0;\n}\n.mui-text-field.mui-has-floating-labels .mui-text-field-input {\n  padding-top: 24px;\n}\n.mui-text-field.mui-has-floating-labels.mui-has-value .mui-text-field-floating-label,\n.mui-text-field.mui-has-floating-labels.mui-is-focused .mui-text-field-floating-label {\n  transform: scale(0.75) translate3d(0, -18px, 0);\n}\n.mui-text-field.mui-has-floating-labels.mui-has-value .mui-text-field-floating-label {\n  color: rgba(0, 0, 0, 0.5);\n}\n.mui-text-field.mui-has-floating-labels.mui-is-disabled .mui-text-field-hint {\n  color: rgba(0, 0, 0, 0.3);\n}\n.mui-text-field.mui-has-floating-labels.mui-is-focused .mui-text-field-hint {\n  opacity: 1;\n}\n.mui-text-field.mui-has-floating-labels.mui-is-focused .mui-text-field-floating-label {\n  transform: scale(0.75) translate3d(0, -18px, 0);\n  color: #00bcd4;\n}\n.mui-text-field.mui-has-floating-labels.mui-is-focused.mui-has-error .mui-text-field-floating-label {\n  color: #f44336;\n}\n.mui-text-field.mui-has-floating-labels.mui-is-focused.mui-has-value .mui-text-field-hint {\n  opacity: 0;\n}\nbody {\n  font-size: 14px;\n  line-height: 21px;\n  width: 100%;\n  height: 100%;\n}\n.flex-tc-sb {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.flex-center {\n  display: flex;\n  align-items: center;\n}\n.flex-tc-stretch {\n  display: flex;\n  align-items: stretch;\n}\n.autocomplete-list-container {\n  height: 200px;\n  width: 100%;\n  z-index: 4000 !important;\n  border-bottom: honeydew;\n  border-left: honeydew;\n  border-right: honeydew;\n  border-top: 1px solid #e6e6e6;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  border-radius: 0 0 2px 2px;\n}\n#livechat-compact-container,\n#livechat-full {\n  left: 20px;\n  right: auto;\n}\n::-ms-clear {\n  display: none;\n}\na {\n  color: #00bcd4;\n  text-decoration: none;\n}\na:hover {\n  color: #ff4081;\n}\n.mui-overlay.mui-is-shown {\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  top: 0;\n}\n.last-sent {\n  font-size: 10px;\n  width: auto;\n  display: inline-block;\n  line-height: 48px;\n  vertical-align: middle;\n}\n.individual-tags-container {\n  max-height: 190px;\n  overflow-x: auto;\n  padding-right: 10px;\n}\n.tags-typeahead-search-bar-container {\n  width: calc(96.25% - 22px);\n  display: inline-block;\n  position: relative;\n}\n.tags-typeahead-search-bar-container .tc-icon-add {\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 40px;\n  float: right;\n  cursor: pointer;\n  padding-left: 15px;\n}\n.individual-tag {\n  display: block;\n  vertical-align: middle;\n  line-height: 36px;\n}\n.company-tags-container {\n  display: inline;\n  overflow: auto;\n  clear: both;\n}\n.diff-deleted {\n  background-color: rgba(255, 0, 0, 0.1) !important;\n}\n.diff-added {\n  background-color: rgba(0, 128, 0, 0.1) !important;\n}\n.diff-block-deleted {\n  background-color: rgba(255, 0, 0, 0.1) !important;\n  border: 1px solid rgba(255, 0, 0, 0.4) !important;\n  margin-top: 8px;\n}\n.diff-block-added {\n  background-color: rgba(0, 128, 0, 0.1) !important;\n  border: 1px solid rgba(0, 128, 0, 0.4) !important;\n  margin-top: 8px;\n}\n.send-email-more {\n  color: #00bcd4;\n}\n.send-email-more:hover {\n  color: #ff4081;\n}\n.diff-nav-active {\n  font-size: 18px;\n}\n.individual-company-tag {\n  display: inline-block;\n  margin-right: 8px;\n  padding: 0px 5px;\n  line-height: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  vertical-align: baseline;\n  font-size: 12px;\n  color: white;\n  background-color: #00bcd4;\n  border-radius: 8px;\n}\n.image-loading-indicater {\n  transition: all 0s linear;\n}\n.image-loading-indicater:before {\n  position: absolute;\n  content: '';\n  top: calc(50% - 25px);\n  left: calc(50% - 25px);\n  width: 50px;\n  height: 50px;\n  border-radius: 100%;\n  border: 3px solid rgba(202, 204, 205, 0.15);\n}\n.image-loading-indicater.black-border:after {\n  border-color: #000 transparent transparent;\n}\n.image-loading-indicater:after {\n  position: absolute;\n  content: '';\n  top: calc(50% - 25px);\n  left: calc(50% - 25px);\n  width: 50px;\n  height: 50px;\n  animation: loader .6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 100%;\n  border-color: #fff transparent transparent;\n  border-style: solid;\n  border-width: 3px;\n  box-shadow: 0 0 0 1px transparent;\n}\n.font-weight-light {\n  font-weight: 300;\n}\n.font-weight-normal {\n  font-weight: 400;\n}\n.font-weight-bold {\n  font-weight: 700;\n}\n.tc-card {\n  background-color: #ffffff;\n}\n.tc-card .tc-card-header {\n  background-color: #f5f5f5;\n  padding: 0 16px;\n  border-radius: 2px 2px 0 0;\n}\n.tc-card .tc-card-header:before,\n.tc-card .tc-card-header:after {\n  content: \" \";\n  display: table;\n}\n.tc-card .tc-card-header:after {\n  clear: both;\n}\n.tc-card .tc-card-header.search-header {\n  position: relative;\n  padding: 0;\n  height: auto;\n}\n.tc-card .tc-card-header-tags {\n  width: 50%;\n  float: left;\n  margin: 6.5px 0px;\n}\n.tc-card .tc-card-header-title,\n.tc-card .tc-card-header-subtitle {\n  margin: 0;\n  padding: 0;\n  line-height: 48px;\n}\n.tc-card .tc-card-header-title {\n  float: left;\n}\n.tc-card .tc-card-header-subtitle {\n  float: right;\n}\n.tc-card .tc-card-contents {\n  position: relative;\n}\n.tc-card .tc-card-contents:before,\n.tc-card .tc-card-contents:after {\n  content: \" \";\n  display: table;\n}\n.tc-card .tc-card-contents:after {\n  clear: both;\n}\n.tc-card.is-padded .tc-card-contents {\n  padding: 16px;\n}\n.tc-card.is-sticky {\n  background-color: #ffffff;\n  margin-bottom: 32px;\n  position: relative;\n}\n.tc-card.is-sticky .tc-card-header {\n  background-color: #f5f5f5;\n  position: relative;\n  padding: 0 16px;\n  width: 100%;\n}\n.tc-card.is-sticky .tc-card-header:before,\n.tc-card.is-sticky .tc-card-header:after {\n  content: \" \";\n  display: table;\n}\n.tc-card.is-sticky .tc-card-header:after {\n  clear: both;\n}\n.tc-card.is-sticky.is-fixed {\n  top: 92px;\n}\n.tc-card.is-sticky.is-fixed .tc-header-container {\n  position: fixed;\n  top: 64px;\n  z-index: 5;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.24);\n}\n.tc-card.is-sticky.is-fixed .tc-card-header {\n  border-radius: 0;\n}\n.tc-card.is-sticky.is-fixed .tc-card-contents:before,\n.tc-card.is-sticky.is-fixed .tc-card-contents:after {\n  content: \" \";\n  display: table;\n}\n.tc-card.is-sticky.is-fixed .tc-card-contents:after {\n  clear: both;\n}\n.send-email-card {\n  width: 512px;\n  margin: auto;\n}\n.cardGradient {\n  background: linear-gradient(to top, #ffffff 20%, rgba(255, 255, 255, 0) 80%);\n  bottom: 32px;\n  width: 95%;\n  height: 46px;\n  display: block;\n  position: absolute;\n}\n.cardGradient.productsGradient {\n  bottom: 12px;\n}\n.tc-card-rating.header {\n  float: right;\n  color: rgba(0, 0, 0, 0.87);\n}\n.tc-card-rating.inner-description {\n  top: 3px;\n  position: absolute;\n  right: 28px;\n}\n.tc-card-rating .tc-icon-star,\n.tc-card-rating .tc-icon-star-half {\n  line-height: 44px;\n  font-size: 20px;\n}\n.tc-icon {\n  position: relative;\n  font-size: 24px;\n  display: inline-block;\n  user-select: none;\n}\n.tc-icon-with-label:hover {\n  color: #ff4081;\n}\n.tc-section-heading {\n  margin-bottom: 32px;\n  text-align: center;\n}\n.tc-section-heading .tc-section-heading-title {\n  display: inline-block;\n  padding: 0 24px;\n  font-size: 24px;\n  line-height: 24px;\n  margin: 0;\n  background-color: #fafafa;\n  letter-spacing: 0;\n  font-weight: 300;\n}\n.tc-section-heading .tc-section-heading-subtitle {\n  font-size: 14px;\n  line-height: 21px;\n  max-width: 80%;\n  margin: 0 auto;\n  letter-spacing: 0;\n  font-weight: 400;\n}\n.tc-section-heading .tc-section-heading-underline {\n  margin-top: -13px;\n}\n.carousel {\n  position: relative;\n  margin: 0;\n  overflow: hidden;\n}\n.carousel-info-left,\n.carousel-info-right {\n  font-size: 26px;\n  position: absolute;\n  z-index: 2;\n  top: 0px;\n  cursor: pointer;\n  opacity: .9;\n  height: 100%;\n  background-color: #fafafa;\n  transition: opacity 0.8s cubic-bezier(0.77, 0, 0.175, 1);\n}\n.carousel-info-left .tc-icon,\n.carousel-info-right .tc-icon {\n  line-height: 320px;\n  vertical-align: middle;\n  color: #ff4081;\n}\n.carousel-info-left:hover .tc-icon,\n.carousel-info-right:hover .tc-icon {\n  color: #00bcd4;\n}\n.carousel-info-left.hidden,\n.carousel-info-right.hidden {\n  opacity: 0;\n  cursor: auto;\n}\n.carousel-info-left {\n  left: 0;\n}\n.carousel-info-right {\n  right: 0;\n}\n.carousel-inner {\n  width: 100%;\n  height: 100%;\n  background-color: #000000;\n  overflow: hidden;\n  position: relative;\n  height: 320px;\n}\n.carousel-inner ul {\n  list-style: none;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n  left: 0px;\n  transition: left 0.8s cubic-bezier(0.77, 0, 0.175, 1);\n}\n.carousel-inner ul .carouselBackground {\n  width: 744px;\n  height: 320px;\n  float: left;\n  position: relative;\n}\n.carousel-inner ul .carouselBackground img {\n  position: relative;\n}\n/*keyframe animations*/\n.first-filmstrip {\n  -webkit-animation: bannermove 30s linear infinite;\n  -moz-animation: bannermove 30s linear infinite;\n  -ms-animation: bannermove 30s linear infinite;\n  -o-animation: bannermove 30s linear infinite;\n  animation: bannermove 30s linear infinite;\n}\n@keyframes \"bannermove\" {\n  0% {\n    margin-left: 0px;\n  }\n  100% {\n    margin-left: -100%;\n  }\n}\n@-moz-keyframes bannermove {\n  0% {\n    margin-left: 0px;\n  }\n  100% {\n    margin-left: -100%;\n  }\n}\n@-webkit-keyframes \"bannermove\" {\n  0% {\n    margin-left: 0px;\n  }\n  100% {\n    margin-left: -100%;\n  }\n}\n@-ms-keyframes \"bannermove\" {\n  0% {\n    margin-left: 0px;\n  }\n  100% {\n    margin-left: -100%;\n  }\n}\n@-o-keyframes \"bannermove\" {\n  0% {\n    margin-left: 0px;\n  }\n  100% {\n    margin-left: -100%;\n  }\n}\n.filmstrip-container {\n  overflow: hidden;\n  padding: 5px 0px;\n}\n.photobanner {\n  height: 50px;\n}\n.photobanner img {\n  -webkit-transition: all 0.5s ease;\n  -moz-transition: all 0.5s ease;\n  -o-transition: all 0.5s ease;\n  -ms-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n  height: 50px;\n  margin: 0 5px;\n  border-radius: 7px;\n}\n.photobanner img:hover {\n  -webkit-transform: scale(1.1);\n  -moz-transform: scale(1.1);\n  -o-transform: scale(1.1);\n  -ms-transform: scale(1.1);\n  transform: scale(1.1);\n  cursor: pointer;\n  -webkit-box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);\n  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);\n}\n.photobanner:hover .first-filmstrip {\n  -webkit-animation-play-state: paused;\n  -moz-animation-play-state: paused;\n  -ms-animation-play-state: paused;\n  -o-animation-play-state: paused;\n  animation-play-state: paused;\n}\n.more-vert {\n  position: relative;\n}\n.more-vert .tc-icon-more-vert {\n  position: static;\n}\n.more-vert .more-vert-action-container {\n  box-shadow: 0 0 !important;\n}\n.more-vert .more-vert-drop-down {\n  top: 18px;\n  font-size: 14px;\n  padding: 8px 16px;\n  position: absolute;\n  right: 0;\n  background-color: #ffffff;\n  min-width: 170px;\n  margin-top: 4px;\n  text-align: left;\n  opacity: 1;\n  transform: translate3d(0, 0, 0) scale(1);\n  transform-origin: top right;\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.more-vert .more-vert-drop-down.is-closed {\n  top: -500px;\n  opacity: 0;\n  transform: translate3d(0, -20px, 0) scale(0);\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.more-vert .more-vert-drop-down.is-vert-multi-select {\n  transform: translateX(50%);\n  width: 250px;\n}\n.more-vert .more-vert-drop-down .more-vert-link {\n  display: block;\n  z-index: 1000;\n  line-height: 36px;\n  color: rgba(0, 0, 0, 0.54);\n}\n.more-vert .more-vert-drop-down .more-vert-link:hover,\n.more-vert .more-vert-drop-down .more-vert-link.active {\n  cursor: pointer;\n  color: #ff4081;\n}\n.more-vert .more-vert-drop-down .more-vert-link .tc-icon-chevron-right,\n.more-vert .more-vert-drop-down .more-vert-link .tc-icon-chevron-left {\n  line-height: 36px;\n  vertical-align: middle;\n  font-size: 24px;\n}\n.more-vert .more-vert-drop-down .more-vert-link .multi-select {\n  font-size: 15px;\n}\n.more-vert .more-vert-drop-down .more-vert-link .multi-select .multi-select-input-container {\n  margin: 0;\n  border: 0;\n}\n.more-vert .more-vert-drop-down .more-vert-link .multi-select .multi-select-input-container input {\n  padding: 0 0 0 8px;\n  line-height: 40px;\n}\n.more-vert .more-vert-drop-down .more-vert-link .multi-select .multi-select-input-dropdown {\n  background-color: initial;\n}\n.more-vert .more-vert-drop-down .more-vert-link .multi-select .multi-select-option-container {\n  width: 100%;\n}\n.more-vert .more-vert-drop-down .more-vert-link .multi-select .multi-select-option-container .multi-select-option-checkbox {\n  width: 23px;\n  line-height: 42.5px;\n}\n.more-vert .more-vert-drop-down .more-vert-link .multi-select .multi-select-option-container .multi-select-option {\n  width: calc(100% - 29px);\n  line-height: 34px;\n}\n.accordian-list-title {\n  display: inline-block;\n  width: calc(98% - 120px);\n  min-height: 80px;\n  padding: 16px 0px;\n}\n.accordian-list-title h4 {\n  padding-top: 0px;\n  margin-bottom: 0px;\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 46px;\n}\n.accordian-chevron {\n  display: inline-block;\n  width: 2%;\n}\n.arrow-box {\n  background: white;\n  -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12), 0 3px 10px rgba(0, 0, 0, 0.24);\n  -moz-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12), 0 3px 10px rgba(0, 0, 0, 0.24);\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12), 0 3px 10px rgba(0, 0, 0, 0.24);\n}\n.arrow-box-inner {\n  background: white;\n  margin-top: -50px;\n  /* transform z-index hack */\n  -moz-transform: rotate(0deg);\n  -webkit-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  -ms-transform: rotate(0deg);\n  transform: rotate(0deg);\n}\n.arrow-box:before {\n  content: '';\n  position: relative;\n  margin-left: 25px;\n  top: -10px;\n  background: white;\n  display: block;\n  width: 50px;\n  height: 50px;\n  -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12), 0 3px 10px rgba(0, 0, 0, 0.24);\n  -moz-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12), 0 3px 10px rgba(0, 0, 0, 0.24);\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12), 0 3px 10px rgba(0, 0, 0, 0.24);\n  -moz-transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n  -o-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.blue-arrow-box:before {\n  background: #4285f4;\n}\n.counter {\n  display: inline-block;\n  background-color: #00bcd4;\n  float: right;\n  color: #ffffff;\n  line-height: 18px;\n  font-size: 12px;\n  margin-top: -1px;\n  min-width: 18px;\n  text-align: center;\n  border-radius: 9px;\n  padding: 0 5px;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.counter.is-zero {\n  background-color: #bdbdbd;\n  color: #f5f5f5;\n}\n.counter:hover {\n  background-color: #ff4081;\n}\n.counter.is-active {\n  background-color: #00bcd4;\n}\n.app-bar {\n  width: 100%;\n  z-index: 3;\n  height: 64px;\n  position: fixed;\n  background-color: white;\n  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.26);\n}\n.app-bar .app-bar-content {\n  padding: 0 24px 0 24px;\n  height: 100%;\n  margin: 0 auto;\n  position: relative;\n}\n.app-bar .tourconnect-logo {\n  margin-top: 12px;\n  margin-left: 24px;\n  width: 42px;\n  position: absolute;\n  display: block;\n  left: 0;\n  overflow: hidden;\n  text-align: left;\n  transition: left 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, width 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms;\n}\n.app-bar .tourconnect-logo .tourconnect-logo-globe,\n.app-bar .tourconnect-logo .tourconnect-logo-name {\n  height: 42px;\n}\n.app-bar .tourconnect-logo .tourconnect-logo-name {\n  position: absolute;\n  transition: opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  opacity: 0;\n}\n.app-bar .nav-link-container {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  line-height: 64px;\n  font-size: 13px;\n  position: relative;\n  z-index: 0;\n  margin-left: 32px;\n  width: calc(100% - 108px);\n  opacity: 1;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 450ms;\n}\n.app-bar .nav-link-container .invitation-request-container {\n  height: 100%;\n  max-height: 64px;\n  float: right;\n}\n.app-bar .nav-link-container .invitation-request-container:hover .tc-icon-user {\n  color: #00bcd4;\n  transition: all 200ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.app-bar .nav-link-container .invitation-request-container:hover .tc-icon-cog {\n  color: #00bcd4;\n  transition: all 200ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.app-bar .nav-link-container .invitation-request-container .invitation-request-icon {\n  font-size: 28px;\n  line-height: 64px;\n  color: rgba(0, 0, 0, 0.54);\n}\n.app-bar .nav-link-container .invitation-request-container .invitation-request-counter {\n  border-radius: 9px;\n  font-size: 12px;\n  min-width: 18px;\n  line-height: 16px;\n  padding: 0px 4px;\n  top: 10px;\n  right: 29px;\n  position: absolute;\n  color: #ffffff;\n  text-align: center;\n  background-color: #f44336;\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.26);\n  border: solid 1px #ffffff;\n}\n.app-bar .nav-link-container .nav-link {\n  float: left;\n  margin-left: 24px;\n  text-decoration: none;\n  color: rgba(0, 0, 0, 0.54);\n  font-weight: 500;\n  font-size: 14px;\n  position: relative;\n  overflow: hidden;\n  background-color: rgba(0, 0, 0, 0);\n  transition: all 200ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.app-bar .nav-link-container .nav-link:focus {\n  outline: none;\n}\n.app-bar .nav-link-container .nav-link:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  height: 4px;\n  width: 100%;\n  background-color: #ff4081;\n  transform: translate3d(0, 0, 0);\n  transition: all 200ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.app-bar .nav-link-container .nav-link:hover,\n.app-bar .nav-link-container .nav-link.active {\n  color: #ff4081;\n}\n.app-bar .nav-link-container .nav-link:hover:after,\n.app-bar .nav-link-container .nav-link.active:after {\n  transform: translate3d(0, -4px, 0);\n}\n.app-bar .app-bar-profile-link {\n  position: absolute;\n  right: 24px;\n}\n.app-bar.is-on-onboarding .tourconnect-logo,\n.app-bar.is-not-logged-in .tourconnect-logo {\n  left: calc(50% - 117.25px);\n  width: 235px;\n  transition: left 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, width 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.app-bar.is-on-onboarding .tourconnect-logo .tourconnect-logo-name,\n.app-bar.is-not-logged-in .tourconnect-logo .tourconnect-logo-name {\n  opacity: 1;\n}\n.app-bar.is-on-onboarding .nav-link-container,\n.app-bar.is-not-logged-in .nav-link-container,\n.app-bar.is-on-onboarding .app-bar-profile-link,\n.app-bar.is-not-logged-in .app-bar-profile-link {\n  z-index: -1;\n  opacity: 0;\n}\n.app-bar.is-on-onboarding .nav-link-container,\n.app-bar.is-not-logged-in .nav-link-container {\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.app-bar.is-on-modal {\n  display: none;\n}\n.app-bar.is-on-admin {\n  display: none;\n}\n.app-window {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n}\n.underline:hover {\n  text-decoration: underline;\n}\n.marketing-readiness-div {\n  margin-top: 32px;\n  color: rgba(0, 0, 0, 0.870588);\n  border-bottom: solid 1px #eeeeee;\n}\n.marketing-readiness-div.marketing-is-ready .market-readiness-error-container {\n  border: 2px solid #5bbd72;\n}\n.marketing-readiness-div.marketing-is-not-ready .market-readiness-error-container {\n  border: 2px solid #f2c037;\n}\n.marketing-readiness-div.marketing-is-not-ready .l-paper-split-segment,\n.marketing-readiness-div.marketing-is-ready .l-paper-split-segment {\n  color: rgba(0, 0, 0, 0.541176);\n}\n.marketing-readiness-div.marketing-is-not-ready .l-paper-split-segment ul,\n.marketing-readiness-div.marketing-is-ready .l-paper-split-segment ul {\n  position: relative;\n  width: 90%;\n  float: right;\n}\n.marketing-readiness-div.marketing-is-not-ready .l-paper-split-segment ul li,\n.marketing-readiness-div.marketing-is-ready .l-paper-split-segment ul li {\n  margin-top: 8px 0px;\n}\n.marketing-readiness-div.marketing-is-not-ready .market-readiness-error-container,\n.marketing-readiness-div.marketing-is-ready .market-readiness-error-container {\n  position: relative;\n  border-radius: 0px 0px 2px 2px;\n  padding: 16px;\n  width: 100%;\n  display: block;\n  height: 100%;\n  overflow: hidden;\n  clear: both;\n  background-color: white;\n}\n.textarea-container {\n  margin-bottom: 16px;\n  min-height: 83px;\n}\n.textarea-container .error-message {\n  color: red;\n  margin-top: 4px;\n}\n.l-app-profile-content {\n  width: 100%;\n  z-index: 0;\n  padding: 0;\n}\n.l-app-profile-content .profile-cover-photo {\n  height: auto;\n  width: 100%;\n  max-height: 381px;\n}\n.l-app-profile-content .profile-cover-photo img {\n  height: 100%;\n  width: 100%;\n  display: block;\n}\n.l-app-profile-content .full-container {\n  width: 100%;\n}\n.add-cover-image-url {\n  top: 40%;\n  left: calc(50% - 286px);\n  position: absolute;\n  color: #00bcd4;\n  font-size: 64px;\n}\n.add-cover-image-url input {\n  cursor: default;\n}\n.add-cover-image-url:hover {\n  color: #ff4081;\n}\n.cover-photo-gradient {\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0) 33%);\n  bottom: 32px;\n  width: 95%;\n  height: 46px;\n  display: block;\n  position: absolute;\n  bottom: 0;\n  height: 100%;\n  width: 100%;\n}\n.add-item-card {\n  vertical-align: middle;\n  background-color: #f5f5f5;\n  border: 2px dashed #00bcd4;\n  margin: auto;\n  margin-top: 32px;\n  width: 100%;\n  cursor: pointer;\n  padding: 30px 30px;\n  color: #00bcd4;\n}\n.add-item-card:hover {\n  border-color: #ff4081;\n  color: #ff4081;\n}\n.profile-add-individual-photo-container {\n  width: 128px;\n  display: inline-block;\n  margin: 16px;\n  height: 128px;\n  line-height: 128px;\n  position: relative;\n  color: #00bcd4;\n  background-color: #f5f5f5;\n  text-align: center;\n  border: 2px dashed #00bcd4;\n  overflow: hidden;\n  clear: both;\n  cursor: pointer;\n}\n.profile-add-individual-photo-container .tc-icon-add {\n  color: #00bcd4;\n}\n.profile-add-individual-photo-container:hover {\n  border-color: #ff4081;\n  color: #ff4081;\n}\n.profile-add-individual-photo-container:hover .tc-icon-add {\n  color: #ff4081;\n}\n.profile-top-bar-top-info {\n  display: block;\n  bottom: 0;\n  color: white;\n  padding: 8px;\n  position: relative;\n  max-width: 1232px;\n  width: 100%;\n  margin: auto;\n  left: 275px;\n  line-height: 24px;\n}\n.profile-top-bar-top-info .tc-icon-star,\n.profile-top-bar-top-info .tc-icon-star-half,\n.profile-top-bar-top-info .tc-icon-star-empty {\n  font-size: 14px;\n}\n.profile-cover-photo-ideal-size-text {\n  position: absolute;\n  display: block;\n  bottom: 35px;\n  right: 40px;\n  cursor: pointer;\n  overflow: hidden;\n  margin-right: 16px;\n  padding: 8px;\n  color: white;\n  font-weight: 500;\n}\n.profile-cover-edit-image-icon {\n  position: absolute;\n  display: block;\n  bottom: 0;\n  cursor: pointer;\n  overflow: hidden;\n  margin-right: 16px;\n  background-color: rgba(138, 138, 138, 0.5);\n  padding: 8px;\n  color: white;\n  font-weight: 600;\n}\n.profile-edit-address .profile-edit-address-break {\n  margin-bottom: 12px;\n}\n.profile-edit-icon,\n.profile-edit-icon-white {\n  cursor: pointer;\n  font-size: 14px;\n  margin-right: 4px;\n}\n.description-segments-add-icon {\n  cursor: pointer;\n}\n.top-bar-edit-container,\n.profile-edit-icon-container {\n  cursor: pointer;\n  display: inline-block;\n  margin-left: 8px;\n  color: #00bcd4;\n}\n.top-bar-edit-container .description-segments-add-icon,\n.profile-edit-icon-container .description-segments-add-icon {\n  font-size: 16px;\n  border: 1px dashed #00bcd4;\n  color: #00bcd4;\n  margin-top: 8px;\n  margin-right: 8px;\n}\n.top-bar-edit-container:hover,\n.profile-edit-icon-container:hover {\n  color: #ff4081;\n}\n.top-bar-edit-container:hover .description-segments-add-icon,\n.profile-edit-icon-container:hover .description-segments-add-icon {\n  border: 1px dashed #ff4081;\n  color: #ff4081;\n}\n.profile-edit {\n  cursor: pointer;\n  line-height: 48px;\n  float: right;\n  color: #00bcd4;\n}\n.profile-edit:hover {\n  color: #ff4081;\n}\n.div-link {\n  cursor: pointer;\n  color: #00bcd4;\n}\n.div-link:hover {\n  color: #ff4081;\n}\n.l-profile-tool-panel-container {\n  height: 139px;\n  background-color: white;\n  position: relative;\n  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.26);\n}\n.l-profile-tool-panel-container .profile-connection-info {\n  z-index: 1;\n  width: 216px;\n  line-height: 18px;\n  top: -53px;\n  position: relative;\n  text-align: center;\n}\n.l-profile-tool-panel-container .views-info {\n  width: 166px;\n  line-height: 8px;\n  top: -60px;\n  position: relative;\n  text-align: center;\n}\n.l-profile-tool-panel-container .l-profile-logo-edit {\n  cursor: pointer;\n  position: absolute;\n  background-color: white;\n  line-height: 30px;\n  width: 128px;\n  height: 30px;\n  vertical-align: middle;\n  top: 34px;\n  left: 19px;\n  border: 1px solid;\n  text-align: center;\n  z-index: 1;\n}\n.l-profile-tool-panel-container .l-profile-logo-container {\n  height: 100%;\n  float: left;\n  width: 256px;\n}\n.l-profile-tool-panel-container .l-profile-logo-container .l-profile-logo {\n  width: 128px;\n  height: 128px;\n  top: -64px;\n  left: 47px;\n  line-height: 128px;\n  position: relative;\n  color: white;\n  border-radius: 50%;\n  text-align: center;\n}\n.l-profile-tool-panel-container .l-profile-logo-container .l-profile-logo:hover + .l-profile-logo-background {\n  visibility: visible;\n}\n.l-profile-tool-panel-container .l-profile-logo-container .l-profile-logo.l-profile-logo-grey-background {\n  background-color: rgba(184, 184, 184, 0.8);\n}\n.l-profile-tool-panel-container .l-profile-logo-container .l-profile-logo .profileViewImage {\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n}\n.l-profile-tool-panel-container .l-profile-logo-container .l-profile-logo-background {\n  width: 128px;\n  height: 128px;\n  top: -64px;\n  left: 19px;\n  line-height: 128px;\n  position: absolute;\n  color: #fff;\n  background-color: rgba(184, 184, 184, 0.8);\n  background-size: cover;\n  text-align: center;\n  visibility: hidden;\n}\n.l-profile-tool-panel-container .l-profile-logo-container .l-profile-logo-background:hover {\n  visibility: visible;\n  cursor: pointer;\n}\n.l-profile-tool-panel-container .l-profile-tool-panel {\n  padding: 16px;\n  padding-left: 28px;\n  height: 100%;\n  float: left;\n  width: calc(100% - 256px);\n}\n.l-profile-content .l-profile-left-content {\n  padding: 0px 16px 32px 0px;\n  width: 256px;\n  float: left;\n}\n.l-profile-content .l-profile-right-content {\n  padding: 32px 0px 32px 16px;\n  padding-right: 0px;\n  float: left;\n  width: calc(100% - 256px);\n}\n.l-profile-content .l-profile-right-content .add-contacts .profile-image-add,\n.l-profile-content .l-profile-right-content .profile-image-add-container .profile-image-add {\n  border: dashed 1px #00bcd4;\n}\n.l-profile-content .l-profile-right-content .add-contacts .profile-image-add .profile-image-letter,\n.l-profile-content .l-profile-right-content .profile-image-add-container .profile-image-add .profile-image-letter {\n  color: #00bcd4;\n}\n.l-profile-content .l-profile-right-content .add-contacts .add-contacts-header,\n.l-profile-content .l-profile-right-content .profile-image-add-container .add-contacts-header,\n.l-profile-content .l-profile-right-content .add-contacts .add-location-header,\n.l-profile-content .l-profile-right-content .profile-image-add-container .add-location-header {\n  color: #00bcd4;\n}\n.l-profile-content .l-profile-right-content .add-contacts:hover .profile-image-add,\n.l-profile-content .l-profile-right-content .profile-image-add-container:hover .profile-image-add {\n  border-color: #ff4081;\n}\n.l-profile-content .l-profile-right-content .add-contacts:hover .profile-image-add .profile-image-letter,\n.l-profile-content .l-profile-right-content .profile-image-add-container:hover .profile-image-add .profile-image-letter {\n  color: #ff4081;\n}\n.l-profile-content .l-profile-right-content .add-contacts:hover .add-contacts-header,\n.l-profile-content .l-profile-right-content .profile-image-add-container:hover .add-contacts-header,\n.l-profile-content .l-profile-right-content .add-contacts:hover .add-location-header,\n.l-profile-content .l-profile-right-content .profile-image-add-container:hover .add-location-header {\n  color: #ff4081;\n}\n.l-profile-content .l-profile-right-content .location-content {\n  display: flex;\n  min-height: 48px;\n  max-height: 48px;\n  height: 48px;\n}\n.l-profile-content .l-profile-right-content .tc-icon-more-vert {\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n}\n.l-profile-content .l-profile-right-content .location-content-link {\n  display: inline-block;\n}\n.l-profile-content .l-profile-right-content .location-content-contract-readiness {\n  display: inline-block;\n  margin-left: 10px;\n  padding: 0px 5px;\n  line-height: 16px;\n  font-weight: bold;\n  cursor: default;\n  font-size: 12px;\n  color: white;\n  background-color: #00bcd4;\n  border-radius: 8px;\n}\n.l-profile-content .l-profile-right-content .location-content-contract-readiness-draft {\n  display: inline-block;\n  margin-left: 10px;\n  padding: 0px 5px;\n  line-height: 16px;\n  font-weight: bold;\n  cursor: default;\n  font-size: 12px;\n  color: white;\n  background-color: #911ba8;\n  border-radius: 8px;\n}\n.l-profile-content .l-profile-right-content .location-product-count {\n  display: inline-block;\n  width: 15%;\n  text-align: center;\n  vertical-align: middle;\n}\n.l-profile-content .l-profile-right-content .location-content-menu {\n  display: inline-block;\n  width: 5%;\n  text-align: right;\n  vertical-align: middle;\n}\n.l-profile-content .l-profile-right-content .profile-image:not(.profile-image-add) {\n  cursor: default;\n}\n.l-profile-content .l-profile-right-content .profile-image-add-container {\n  cursor: pointer;\n}\n.l-profile-content .l-profile-right-content .location-name h4 {\n  color: grey;\n  font-weight: 300;\n  padding-top: 4px;\n  margin-bottom: 10px;\n}\n.l-profile-content .l-profile-right-content .location-data,\n.l-profile-content .l-profile-right-content .contact-sale,\n.l-profile-content .l-profile-right-content .multiple-locations {\n  margin-top: 32px;\n}\n.l-profile-content .l-profile-right-content .multiple-locations .multiple-locations-question,\n.l-profile-content .l-profile-right-content .multiple-locations .multiple-locations-yes,\n.l-profile-content .l-profile-right-content .multiple-locations .multiple-locations-no {\n  display: inline-block;\n}\n.l-profile-content .l-profile-right-content .multiple-locations .multiple-locations-question {\n  width: 88%;\n}\n.l-profile-content .l-profile-right-content .multiple-locations .multiple-locations-yes {\n  width: 9%;\n}\n.l-profile-content .l-profile-right-content .multiple-locations .multiple-locations-no {\n  width: 3%;\n}\n.l-profile-content .l-profile-right-content .multiple-locations .multiple-locations-answer {\n  color: #00bcd4;\n}\n.l-profile-content .l-profile-right-content .multiple-locations .multiple-locations-answer:hover {\n  cursor: pointer;\n  color: #ff4081;\n}\n.tc-icon-star.is-editing {\n  color: grey;\n}\n.form-dialog .cancel-modal {\n  float: left;\n}\n.form-dialog .save-modal {\n  float: right;\n}\n.l-profile-address {\n  clear: both;\n}\n.change-color-on-hover {\n  color: #ffffff;\n}\n.change-color-on-hover:hover {\n  color: #00bcd4 !important;\n}\n.contact-div-hover:hover,\n.contact-div-hover:focus,\n.contact-div-hover:active {\n  background-color: #f6f6f6;\n}\n.profile-views {\n  z-index: 1100;\n  display: inline-block;\n}\n.profile-views .profile-views-container {\n  position: absolute;\n  z-index: 1;\n  right: 0;\n  background-color: #ffffff;\n  width: 150px;\n  margin-top: 8px;\n  text-align: left;\n  opacity: 1;\n  transform: translate3d(0, 0, 0) scale(1);\n  transform-origin: top right;\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.profile-views.is-closed .profile-views-container {\n  top: -500px;\n  opacity: 0;\n  transform: translate3d(0, -20px, 0) scale(0);\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.logo .l-profile-logo {\n  display: inline-block;\n  width: 80px;\n  height: 80px;\n  top: -40px;\n  line-height: 80px;\n  position: relative;\n  color: white;\n  border-radius: 50%;\n  text-align: center;\n}\n.logo .l-profile-logo:hover + .logo-background {\n  visibility: visible;\n}\n.logo .l-profile-logo.l-profile-logo-grey-background {\n  background-color: rgba(184, 184, 184, 0.8);\n}\n.logo .logo-background {\n  top: -10px;\n  position: absolute;\n  color: #fff;\n  left: calc(45.5%);\n  visibility: hidden;\n}\n.logo .logo-background:hover {\n  visibility: visible;\n  cursor: pointer;\n}\n.profile-cover-photo-edit-image {\n  position: absolute;\n  bottom: 0;\n  cursor: pointer;\n  overflow: hidden;\n  color: white;\n}\n.full-cover-photo-gradient {\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.87), rgba(0, 0, 0, 0) 100%);\n  display: block;\n  position: absolute;\n  bottom: 0;\n  height: 100%;\n  width: 100%;\n}\n.verified-member-block:hover > .what-is-org-hover {\n  display: block;\n}\n.what-is-org-hover {\n  display: none;\n}\n.what-is-org-hover:active {\n  display: block;\n}\n.image-container .video-playbutton-mask {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  overflow: hidden;\n  top: 0;\n  left: 0;\n}\n.effect .video-playbutton-mask {\n  opacity: 0;\n  overflow: visible;\n  box-sizing: border-box;\n  transition: all 0.4s ease-in-out;\n}\n.effect:hover .video-playbutton-mask {\n  opacity: 1;\n  background-color: rgba(0, 0, 0, 0.7);\n}\n#marketing-materials ::-webkit-scrollbar {\n  width: 0px;\n  /* remove scrollbar space */\n  background: transparent;\n  /* optional: just make scrollbar invisible */\n}\n.blur-photos {\n  filter: blur(10px);\n  -webkit-filter: blur(10px);\n  -moz-filter: blur(10px);\n  -o-filter: blur(10px);\n  -ms-filter: blur(10px);\n}\n.flip-icon {\n  -webkit-transform: scale(-1, 1);\n  -moz-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  -o-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n/*==================================================\n=            Bootstrap 3 Media Queries             =\n==================================================*/\n/* Large Devices, Wide Screens */\n@media only screen and (min-width: 1200px) {\n  .arrow_box {\n    display: none;\n  }\n}\n@media only screen and (min-width: 1170px) {\n}\n@media only screen and (min-width: 1500px) {\n  .connections-floating-help-box {\n    display: none;\n  }\n}\n@media only screen and (max-width: 1358px) {\n  .connections-floating-help-box {\n    display: none;\n  }\n}\n@media only screen and (min-width: 1529px) {\n  .contracting-floating-help-box {\n    display: none;\n  }\n}\n@media only screen and (max-width: 1306px) {\n  .contracting-floating-help-box {\n    display: none;\n  }\n}\n/* Medium Devices, Desktops */\n/* Small Devices, Tablets */\n@media only screen and (max-width: 768px) {\n  .top-action-bar {\n    display: none !important;\n  }\n}\n/* Extra Small Devices, Phones */\n@media only screen and (max-width: 480px) {\n  .two-column-row-right-button {\n    float: left !important;\n    margin-top: 10px;\n  }\n  .full-width-block-label {\n    display: block;\n    width: 100%;\n  }\n}\n/* Custom, iPhone Retina */\n.breadcrumb-container .tc-icon-chevron-right {\n  display: inline-block;\n  vertical-align: middle;\n}\n.breadcrumb-container .breadcrumb {\n  display: inline-block;\n  position: relative;\n  margin-bottom: 8px;\n}\n.breadcrumb-container .breadcrumb.breadcrumb-link {\n  cursor: pointer;\n  color: #00bcd4;\n}\n.breadcrumb-container .breadcrumb.breadcrumb-link:hover {\n  color: #ff4081;\n}\n.address-data {\n  border: 1px solid #f5f5f5;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.24);\n  height: 300px;\n  margin-bottom: 20px;\n  position: relative;\n  margin-top: 32px;\n}\n.address-data .gmap {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.address-data .l-paper-right-address {\n  width: 100%;\n  max-width: 1232px;\n  margin-top: 5px;\n  font-size: 16px;\n  position: relative;\n  z-index: 9;\n  border: 1px solid #e6e6fa;\n  margin: auto;\n}\n.address-data .l-paper-right-address .title {\n  font-size: 16px;\n  padding-left: 20px;\n}\n.address-data .l-paper-right-address .address-column {\n  padding: 20px;\n  margin-top: 5px;\n  font-size: 16px;\n  width: 200px;\n  background-color: rgba(255, 255, 255, 0.8);\n}\n.address-data .l-paper-right-address .address-column p {\n  font-size: 14px;\n  margin-bottom: 3px;\n}\n.l-paper-right-info.profile-description-paragraph {\n  white-space: pre-wrap;\n}\n.company-right-panel .profile-card {\n  margin-bottom: 20px;\n}\n.company-right-panel .profile-card .tc-card-contents {\n  position: relative;\n}\n.company-right-panel .profile-card .tc-card-contents .l-paper-right-info {\n  margin-bottom: 8px;\n}\n.company-right-panel .profile-card .tc-card-contents .l-paper-right-info.description-info {\n  word-wrap: break-word;\n  white-space: pre;\n}\n.company-right-panel .profile-card .tc-card-contents .short-info {\n  height: 126px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.company-right-panel .profile-card .tc-card-contents .short-contacts {\n  height: 362.5px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.company-right-panel .profile-card .tc-card-contents .short-location {\n  height: 362.5px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.company-right-panel .profile-card .tc-card-contents .load-more {\n  position: relative;\n  float: right;\n  right: 15px;\n  bottom: 10px;\n}\n.contact-details {\n  margin-bottom: 20px;\n}\n.contact-details .contact .contact-header {\n  width: 172px;\n  display: inline-block;\n  font-size: 14px;\n  margin-bottom: 3px;\n  line-height: 20px;\n}\n.contact-details .contact .name-detail,\n.contact-details .contact .email-detail {\n  width: 196px;\n}\n.contact-details .contact .phone-detail,\n.contact-details .contact .fax-detail {\n  width: 148px;\n}\n.contact-details .contact-info .contact-detail {\n  width: 172px;\n  display: inline-block;\n  word-wrap: break-word;\n  margin-bottom: 0px;\n  font-size: 13px;\n  line-height: 20px;\n}\n.contact-details .contact-info .name-detail,\n.contact-details .contact-info .email-detail {\n  width: 196px;\n  word-wrap: break-word;\n}\n.contact-details .contact-info .phone-detail,\n.contact-details .contact-info .fax-detail {\n  width: 148px;\n}\n.contact-details hr {\n  margin-bottom: 0px;\n}\n.profile-logo {\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n.profile-logo .profile-image {\n  height: 128px;\n  width: 128px;\n  margin: 0 auto;\n}\n.profile-logo .profile-image .profile-image-letter {\n  line-height: 128px;\n  font-size: 35px;\n}\n.profile-logo .company-name {\n  margin-top: 8px;\n  font-size: 16px;\n}\n.company-left-nav {\n  position: fixed;\n  height: 100%;\n  margin-top: -96px;\n  text-align: center;\n}\n.company-left-nav .company-left-nav-inner {\n  margin-top: 96px;\n}\n.company-connected-status {\n  display: inline-block;\n  min-width: 88px;\n  height: 36px;\n}\n.company-connected-status .tc-icon-users {\n  vertical-align: middle;\n  padding-right: 4px;\n}\n.company-connected-status .company-connection-buttons {\n  position: relative;\n  z-index: 1;\n  margin: 8px;\n}\n.company-connected-status .company-connection-buttons .tc-icon-check {\n  color: green;\n  margin-right: 16px;\n}\n.company-connected-status .company-connection-buttons .tc-icon-check,\n.company-connected-status .company-connection-buttons .tc-icon-close {\n  cursor: pointer;\n}\n.l-paper-split-location .location-name {\n  display: block;\n  clear: both;\n}\n.l-paper-split-location .location-name .profile-image {\n  float: left;\n}\n.l-paper-split-location .location-name .location-content {\n  margin-left: 70px;\n  min-height: 80px;\n  padding: 16px 0px;\n}\n.l-paper-split-location .location-name .location-content h5 {\n  line-height: 15px;\n  padding-top: 0px;\n  margin-bottom: 0px;\n}\n.l-paper-split-location .location-name .location-content .location-list-content {\n  line-height: 20px;\n  padding-top: 6px;\n  margin-bottom: 14px;\n  letter-spacing: 0;\n}\n.l-paper-split-location .location-name:last-child hr {\n  border: none;\n}\n.segment-content {\n  font-size: 14px;\n  padding-left: 16px;\n  line-height: 48px;\n}\n.segment-option {\n  cursor: pointer;\n  display: inline-block;\n}\n.segment-option span {\n  line-height: 27px;\n  vertical-align: middle;\n}\n.segment-icon {\n  color: #4caf50;\n}\n.segment-icon.hide {\n  visibility: hidden;\n}\n.segment-icon.show {\n  visibility: visible;\n}\n.description-segments-title {\n  display: inline-block;\n  width: 80%;\n  color: rgba(0, 0, 0, 0.870588);\n}\n.description-segments-edit {\n  cursor: pointer;\n  text-align: right;\n  display: inline-block;\n  width: 20%;\n  color: #00bcd4;\n}\n.description-segments-edit:hover {\n  color: #ff4081;\n}\n.description-segments-add {\n  cursor: pointer;\n  color: #00bcd4;\n}\n.description-segments-add .description-segments-add-icon {\n  font-size: 14px;\n  border: 1px dashed;\n}\n.description-segments-add .description-segments-add-label {\n  font-size: 16px;\n  margin-left: 6px;\n}\n.description-segments-add:hover {\n  color: #ff4081;\n}\n.segments-options {\n  max-height: 375px;\n  overflow: auto;\n}\n.description-segments {\n  font-size: 14px;\n  line-height: 48px;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  border-bottom: solid 1px #eeeeee;\n}\n.product-paragraph {\n  height: 20px;\n}\n.amenity {\n  display: inline-block;\n  width: 33%;\n}\n.connections-splash {\n  text-align: center;\n  max-width: 75%;\n  margin: 0 auto;\n}\n.connections-splash .connections-splash-icon {\n  color: #00bcd4;\n  font-size: 128px;\n  margin: 32px 0;\n}\n.connections-splash ul {\n  list-style-type: none;\n}\n.connections-splash ul li {\n  margin-bottom: 5px;\n}\n.connections-splash span.connections-info {\n  display: block;\n}\n.connections-splash .connections-splash-details-container {\n  font-size: 16px;\n  line-height: 28px;\n}\n.connections-splash .connections-splash-details-container .connections-splash-details {\n  width: 291px;\n  text-align: left;\n  margin: 20px auto;\n}\n.connections-splash .connections-splash-details-container .connections-splash-details .tc-icon {\n  margin-right: 6px;\n  font-size: 24px;\n  color: #00bcd4;\n  line-height: 28px;\n  float: left;\n}\n.connections-left-nav {\n  position: fixed;\n  height: 100%;\n  margin-top: -96px;\n}\n.connections-left-nav .connections-left-nav-inner {\n  margin-top: 96px;\n}\n.connections-left-nav .connections-left-nav-heading {\n  font-size: 14px;\n  padding-left: 16px;\n  line-height: 48px;\n  text-transform: uppercase;\n  border-bottom: solid 1px #eeeeee;\n}\n/**\n * Author:      Matt Hinchliffe <www.maketea.co.uk>\n * Description: Responsive image placeholders\n */\ninput::-ms-close {\n  width: 0;\n  display: none;\n  height: 0;\n}\n/* Preload and loaded animations */\n@-webkit-keyframes bobble {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(0);\n  }\n  35% {\n    opacity: 1;\n    -webkit-transform: translateY(-20px);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(0);\n  }\n}\n@keyframes bobble {\n  0% {\n    opacity: 0;\n    transform: translateY(0);\n  }\n  35% {\n    opacity: 1;\n    transform: translateY(-20px);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(0);\n  }\n}\n.no-connections-loading {\n  background: white;\n}\n.no-connections-loading::after {\n  content: ' ';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 1em;\n  height: 1em;\n  margin: -0.5em 0 0 -0.5em;\n  background: #8C8C8C;\n  border-radius: 100%;\n  animation: bobble 2s cubic-bezier(0.6, 1, 1, 1) infinite;\n}\n.no-connections {\n  padding: 16px;\n  height: 110px;\n}\n.no-connections h4.no-connections-message {\n  padding: 0;\n  margin: 0;\n  line-height: 78px;\n  vertical-align: middle;\n  font-size: 16px;\n}\n.connections-list {\n  padding-left: 16px;\n}\n.connections-list .loader {\n  position: relative;\n  transition: all 0s linear;\n  background-color: 'black';\n  height: 30px;\n}\n.connections-list .loader:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285em 0 0 -0.64285em;\n  width: 1.2857em;\n  height: 1.2857em;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.15);\n}\n.connections-list .loader:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285em 0 0 -0.64285em;\n  width: 1.2857em;\n  height: 1.2857em;\n  animation: loader .6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: #fff transparent transparent;\n  border-style: solid;\n  border-width: .2em;\n  box-shadow: 0 0 0 1px transparent;\n}\n.connections-actions {\n  float: right;\n  line-height: 48px;\n}\n.connections-actions .tc-icon-more-vert {\n  padding-right: 8px;\n  display: inline;\n  position: relative;\n  vertical-align: middle;\n  cursor: pointer;\n}\n.connections-actions .connections-actions-dropdown {\n  top: 50%;\n  transform: translateY(-50%);\n}\n.connections-actions .connections-action-container {\n  display: inline;\n  vertical-align: middle;\n  position: relative;\n}\n.connections-actions .connections-action-container .mui-flat-button {\n  height: 36px;\n  border: 1px solid #f5f5f5;\n  border-radius: 0px;\n  padding-left: 18px;\n  padding-right: 0px;\n}\n.connections-actions .connections-action-container .mui-flat-button .tc-icon-arrow-drop-down.tc-icon {\n  float: right;\n  line-height: 36px;\n}\n.connections-actions .connections-action-drop-down {\n  font-size: 14px;\n  position: absolute;\n  top: 34px;\n  z-index: 2;\n  right: 0;\n  background-color: #ffffff;\n  min-width: 224px;\n  margin-top: 4px;\n  text-align: left;\n  opacity: 1;\n  transform: translate3d(0, 0, 0) scale(1);\n  transform-origin: top right;\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.connections-actions .connections-action-drop-down.is-vert-multi-select {\n  transform: translateX(50%);\n  width: 250px;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-contents {\n  padding: 8px 16px;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link {\n  display: block;\n  z-index: 1000;\n  line-height: 36px;\n  color: rgba(0, 0, 0, 0.54);\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link .tc-icon-chevron-right,\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link .tc-icon-chevron-left {\n  line-height: 36px;\n  vertical-align: middle;\n  font-size: 24px;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link .multi-select {\n  font-size: 15px;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link .multi-select .multi-select-input-container {\n  margin: 0;\n  border: 0;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link .multi-select .multi-select-input-container input {\n  padding: 0 0 0 8px;\n  line-height: 40px;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link .multi-select .multi-select-input-dropdown {\n  background-color: initial;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link .multi-select .multi-select-option-container {\n  width: 100%;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link .multi-select .multi-select-option-container .multi-select-option-checkbox {\n  width: 23px;\n  line-height: 42.5px;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link .multi-select .multi-select-option-container .multi-select-option {\n  width: calc(100% - 29px);\n  line-height: 34px;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link:hover,\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link.active {\n  cursor: pointer;\n  color: #ff4081;\n}\n.connections-actions .connections-action-drop-down.is-closed {\n  top: -500px;\n  opacity: 0;\n  transform: translate3d(0, -20px, 0) scale(0);\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.connections-list-header,\n.connections-list-email {\n  width: auto;\n  display: inline;\n  margin-right: 16px;\n  min-height: 24px;\n  line-height: 24px;\n  color: rgba(0, 0, 0, 0.54);\n  padding-left: 0px;\n}\n.connections-list-header {\n  font-size: 16px;\n}\n.connections-company-container {\n  padding-left: 0px;\n  padding: 16px 0px;\n  min-height: 80px;\n  display: inline-block;\n  float: right;\n  width: calc(100% - 128px);\n}\n.connections-tags-container {\n  display: inline-block;\n  position: relative;\n  white-space: pre;\n  width: calc(100% - 177px);\n  margin-top: 3px;\n  min-height: 21px;\n  padding-left: 5px;\n}\n.connections-tags-container .connections-tags-tag-icon {\n  font-size: 16px;\n  float: left;\n  margin-left: 2px;\n  padding: 0px 4px;\n  display: none;\n  cursor: pointer;\n}\n.connections-tags-container .connections-tags {\n  color: #00bcd4;\n  font-weight: 700;\n  cursor: pointer;\n  font-size: 12px;\n  position: relative;\n  box-sizing: border-box;\n  display: inline-block;\n  text-align: center;\n  float: left;\n  vertical-align: baseline;\n}\n.connections-tags-container .connections-tags:hover {\n  color: #ff4081;\n}\n.connections-profile-image-container {\n  display: inline-block;\n  float: left;\n  width: 48px;\n  height: 48px;\n  padding: 16px 16px 16px 0px;\n}\n.connections-profile-image-container .profile-image {\n  border-radius: 50%;\n  height: 48px;\n  width: 48px;\n}\n.connections-profile-image-container .profile-image .profile-image-image {\n  height: 48px;\n  width: 48px;\n}\n.connections-profile-image-container .profile-image .profile-image-letter {\n  line-height: 48px;\n}\n.connections-list-item {\n  width: 100%;\n  position: relative;\n}\n.connections-list-item .connections-accept-button {\n  opacity: 0;\n}\n.connections-list-item:first-child .connections-accept-button {\n  opacity: 1;\n}\n.connections-list-item:last-child .connections-company-container {\n  border-bottom: none;\n}\n.connections-list-item.is-open {\n  z-index: 1;\n}\n.connections-list-item:hover .connections-accept-button {\n  opacity: 1;\n}\n.connections-list-item:before,\n.connections-list-item:after {\n  content: \" \";\n  display: table;\n}\n.connections-list-item:after {\n  clear: both;\n}\n.connections-search-bar {\n  position: relative;\n  line-height: 36px;\n  height: 36px;\n  float: right;\n  margin-top: 6px;\n  clear: right;\n}\n.connections-search-bar.search-header-tool-bar {\n  width: auto;\n}\n.connections-search-bar.search-header-search-bar {\n  width: 100%;\n}\n.connections-search-bar .connections-more-options {\n  float: none;\n  display: inline-block;\n}\n.connections-search-bar .connections-more-options .connections-action-drop-down {\n  z-index: 1001;\n  top: 36px;\n}\n.connections-search-bar .more-vert-label {\n  font-size: 16px;\n}\n.connections-search-bar .tc-icon-close,\n.connections-search-bar .tc-icon-search {\n  position: absolute;\n  right: 6px;\n  padding-left: 12.25px;\n}\n.connections-search-bar .connections-more-options,\n.connections-search-bar .tc-icon-cloud-download,\n.connections-search-bar .tc-icon-close,\n.connections-search-bar .tc-icon-menu,\n.connections-search-bar .tc-icon-search {\n  cursor: pointer;\n  vertical-align: middle;\n  line-height: 36px;\n  font-size: 18px;\n  color: rgba(0, 0, 0, 0.26);\n}\n.connections-search-bar .connections-more-options:hover,\n.connections-search-bar .tc-icon-cloud-download:hover,\n.connections-search-bar .tc-icon-close:hover,\n.connections-search-bar .tc-icon-menu:hover,\n.connections-search-bar .tc-icon-search:hover {\n  color: #ff4081;\n  transition: all 200ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.connections-search-bar .tc-icon-cloud-download {\n  font-size: 24px;\n  margin: 0px 6px;\n}\n.connections-search-bar .connections-search-input {\n  float: left;\n  line-height: 36px;\n  height: 36px;\n  border: 0;\n  opacity: 1;\n  display: inline-block;\n  border-bottom: 2px solid #e8e8e8;\n  background-color: #f5f5f5;\n  transform-origin: 100% 100%;\n  width: 99.5%;\n  position: relative;\n  transition: transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.connections-search-bar .connections-search-input:focus {\n  outline: 0;\n}\n.request-action-buttons {\n  display: inline;\n  position: relative;\n  vertical-align: middle;\n  cursor: pointer;\n  margin-right: 16px;\n}\n.request-action-buttons.accept-button {\n  color: green;\n}\n.request-action-buttons.reject-button {\n  margin-right: 8px;\n}\n.connections-company-name {\n  padding-left: 5px;\n  max-width: 65%;\n  word-wrap: break-word;\n  display: inline-block;\n  vertical-align: top;\n  overflow: auto;\n  clear: both;\n}\n.connections-company-name.is-link .connections-list-header {\n  color: #00bcd4;\n}\n.connections-company-name.is-link .connections-list-header:hover {\n  cursor: pointer;\n  color: #ff4081;\n}\n.connections-widget {\n  padding: 8px 0;\n  width: 100%;\n  margin-bottom: 8px;\n}\n.connections-widget .connections-widget-link {\n  display: block;\n  position: relative;\n  line-height: 16px;\n  padding: 16px;\n  overflow: hidden;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.connections-widget .connections-widget-link:focus {\n  outline: none;\n}\n.connections-widget .connections-widget-link.is-zero {\n  color: #bdbdbd;\n}\n.connections-widget .connections-widget-link:after {\n  content: '';\n  position: absolute;\n  top: 0px;\n  left: -3px;\n  width: 3px;\n  height: 100%;\n  background-color: #ff4081;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.connections-widget .connections-widget-link:hover:after {\n  transform: translate3d(3px, 0px, 0px);\n  background-color: #ff4081;\n}\n.connections-widget .connections-widget-link:hover .counter {\n  background-color: #ff4081;\n}\n.connections-widget .connections-widget-link.is-active {\n  background-color: #f5f5f5;\n  cursor: default;\n}\n.connections-widget .connections-widget-link.is-active:after {\n  transform: translate3d(3px, 0px, 0px);\n  background-color: #00bcd4;\n}\n.connections-widget .connections-widget-link.is-active .counter {\n  background-color: #00bcd4;\n}\n.connections-widget .connections-widget-link.is-active:hover {\n  color: #00bcd4;\n}\n.connections-widget .connections-widget-link.is-active:hover:after {\n  background-color: #00bcd4;\n}\n.connections-widget .counter {\n  display: inline-block;\n  background-color: #00bcd4;\n  float: right;\n  color: #ffffff;\n  line-height: 18px;\n  font-size: 12px;\n  margin-top: -1px;\n  min-width: 18px;\n  text-align: center;\n  border-radius: 9px;\n  padding: 0 5px;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.connections-widget .counter.is-zero {\n  background-color: #bdbdbd;\n  color: #f5f5f5;\n}\n.partnerbutton,\n.addbutton {\n  display: block;\n  width: calc(100% - 32px);\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 16px;\n}\n.partnerbutton {\n  background-color: #eeeeee;\n}\n.connections {\n  width: 100%;\n  height: 100%;\n}\n.mui-tooltip {\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n.connections-tag-contianer {\n  display: inline-block;\n  margin: .125em;\n  background-color: #e8e8e8;\n  vertical-align: middle;\n  border-color: #e8e8e8;\n  background-image: none;\n  padding: 3px 8px;\n  color: rgba(0, 0, 0, 0.6);\n  text-transform: none;\n  font-weight: 700;\n  border-radius: 15px;\n  box-sizing: border-box;\n  transition: background .2s ease;\n}\n.connections-tag-contianer .connections-tag-name {\n  display: inline-block;\n  float: left;\n  clear: left;\n}\n.connections-tag-contianer .tc-icon-close {\n  display: inline-block;\n  float: right;\n  font-size: 12px;\n  line-height: 24px;\n  padding-left: 10px;\n  clear: right;\n  cursor: pointer;\n}\n.type-ahead-search-input {\n  width: 100%;\n  background-color: #e8e8e8;\n  color: black;\n  line-height: 24px;\n  border: none;\n  margin-bottom: 12px;\n  border-radius: 2px;\n  padding: 8px;\n}\n.type-ahead-search-input:focus {\n  outline: 0;\n}\n.type-ahead-input-add {\n  position: absolute;\n  color: green;\n}\n.type-ahead-container {\n  line-height: 24px;\n}\n.individual-tag {\n  line-height: 36px;\n  border-bottom: 2px solid #e8e8e8;\n}\n.individual-tag .tc-icon-close {\n  float: right;\n  line-height: 36px;\n  vertical-align: middle;\n  cursor: pointer;\n}\n.tags-modal .mui-dialog-window-contents {\n  max-width: none;\n  width: 25%;\n}\n.connections-tags-container {\n  width: 100%;\n}\n.type-ahead-options-container {\n  overflow: auto;\n  width: 95%;\n}\n.connections-typeahead-tag-icon {\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 40px;\n  cursor: pointer;\n  position: absolute;\n  right: 55px;\n}\n.connections-company-container {\n  padding-left: 0px;\n  padding: 16px 0px;\n  min-height: 80px;\n  display: inline-block;\n  float: right;\n  display: flex;\n  justify-content: space-between;\n  margin-right: 18px;\n}\n.connections-company-container .connections-typeahead-container,\n.connections-company-container .connections-tags-container {\n  display: inline-block;\n  position: relative;\n}\n.connections-company-container .connections-typeahead-container .connections-tags-tag-icon,\n.connections-company-container .connections-tags-container .connections-tags-tag-icon {\n  font-size: 16px;\n  margin-left: 2px;\n  padding: 0px 4px;\n  cursor: pointer;\n}\n.connections-company-container .connections-typeahead-container .connections-tags,\n.connections-company-container .connections-tags-container .connections-tags {\n  color: #00bcd4;\n  font-weight: 700;\n  cursor: pointer;\n  font-size: 0.9em;\n  position: relative;\n  box-sizing: border-box;\n  display: inline-block;\n  text-align: center;\n  float: left;\n  vertical-align: baseline;\n}\n.connections-company-container .connections-typeahead-container .connections-tags:hover,\n.connections-company-container .connections-tags-container .connections-tags:hover {\n  color: #ff4081;\n}\n.connections-company-container .connections-typeahead-container .connection-typeahead-tag-icon {\n  display: inline-block;\n  float: right;\n  vertical-align: super;\n  font-size: 0.9em;\n  line-height: 24px;\n  padding-left: 10px;\n  clear: right;\n  cursor: pointer;\n}\n.connections-company-container .connections-typeahead-container .connections-tag-contianer {\n  display: inline-block;\n  margin-bottom: 8px;\n  background-color: #e8e8e8;\n  border-color: #e8e8e8;\n  background-image: none;\n  padding: 2px 6px;\n  color: rgba(0, 0, 0, 0.6);\n  text-transform: none;\n  font-weight: 700;\n  border-radius: .2857rem;\n  box-sizing: border-box;\n  transition: background .2s ease;\n}\n.connections-company-container .connections-typeahead-container .connections-tag-contianer .connections-tag-name {\n  display: inline-block;\n  font-size: 0.9em;\n  float: left;\n  clear: left;\n}\n.connections-company-container .connections-typeahead-container .connections-tag-contianer .tc-icon-close {\n  display: inline-block;\n  float: right;\n  font-size: 0.9em;\n  line-height: 24px;\n  padding-left: 10px;\n  clear: right;\n  cursor: pointer;\n}\n.connections-company-container .connections-tags-container .connection-tags-tag-icon {\n  display: none;\n  float: left;\n}\n.connections-company-container .connections-tags-container:hover .connections-tags-tag-icon {\n  display: inline-block;\n}\n.connections-typeahead-container {\n  width: 100%;\n}\n.connections-typeahead-container .type-ahead-search-input {\n  border-radius: 3px;\n  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.1);\n  padding-left: 10px;\n  width: calc(100% - 40px);\n  position: relative;\n  float: left;\n  display: inline-block;\n  background-color: #fafafa;\n  min-height: 24px;\n  transform-origin: 100% 100%;\n  opacity: 1;\n  transition: transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.connections-typeahead-container .type-ahead-search-input.is-closed {\n  transform: scaleX(0);\n  opacity: 0;\n}\n.connections-typeahead-container .type-ahead-search-input:focus {\n  outline: 0;\n}\n.connections-typeahead-container .connections-typeahead-tag-icon {\n  display: inline-block;\n  float: right;\n  vertical-align: super;\n  font-size: 24px;\n  line-height: 24px;\n  padding-left: 5px;\n  padding-right: 5px;\n  clear: right;\n  cursor: pointer;\n}\n.new-connection-container .csvRow {\n  clear: both;\n}\n.new-connection-container .csvItem,\n.new-connection-container .multi-select,\n.new-connection-container input {\n  width: 200px;\n}\n.new-connection-container .csvItem,\n.new-connection-container .multi-select {\n  margin-left: 10px;\n  float: left;\n}\n.new-connection-container .csvItem:first-of-type,\n.new-connection-container .multi-select:first-of-type {\n  margin-left: 0px;\n}\n.new-connection-container .tc-card {\n  font-size: 16px;\n  line-height: 28px;\n  max-height: 500px;\n}\n.new-connection-container .tc-card.send-email-card {\n  max-height: none;\n}\n.new-connection-container .tc-card .connections-splash-details {\n  width: 291px;\n  text-align: left;\n  margin: 20px auto;\n}\n.new-connection-container .tc-card .connections-splash-details ul {\n  list-style-type: none;\n}\n.new-connection-container .tc-card .connections-splash-details ul li {\n  margin-bottom: 5px;\n}\n.new-connection-container .tc-card .connections-splash-details .tc-icon {\n  margin-right: 6px;\n  font-size: 24px;\n  color: #00bcd4;\n  line-height: 28px;\n  float: left;\n}\n.exchange-rates-long-card {\n  position: relative;\n  display: block;\n  margin: 20px 256px auto;\n  clear: both;\n  overflow: hidden;\n}\n.justify-rates-paragraph {\n  font-size: 16px;\n  margin-bottom: 5%;\n  color: rgba(0, 0, 0, 0.54);\n  text-align: justify;\n  -webkit-hyphens: auto;\n  -moz-hyphens: auto;\n  hyphens: auto;\n}\n.hyphen-get-started {\n  color: #00bcd4;\n  font-size: 16px;\n  margin-bottom: 5%;\n  -webkit-hyphens: auto;\n  -moz-hyphens: auto;\n  hyphens: auto;\n}\n.new-contract-paper {\n  margin: 24px 128px auto;\n  position: relative;\n  clear: both;\n  overflow: auto;\n}\n.more-vert-link {\n  clear: both;\n  display: inline-block;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.terms-conditions-overlay {\n  width: 100%;\n  text-align: center;\n}\n.terms-conditions-content {\n  width: 448px !important;\n}\n.add-circle-icon:before {\n  font-family: 'Material Icons';\n  content: \"\\E147\";\n  position: relative;\n  top: -4px;\n}\n.connection-list-search-input {\n  border: none;\n  margin-left: 2%;\n  font-size: 14px;\n}\n.connection-list-search-input:focus {\n  outline: 0;\n}\n.add-individ-connection-dialog {\n  display: flex;\n  width: 100%;\n  align-items: center;\n}\n.edit-button {\n  display: flex;\n  align-items: center;\n  color: #00bcd4;\n  margin-right: 4px;\n  cursor: pointer;\n  margin-left: auto;\n}\n.season-start-and-end-dates {\n  display: flex;\n  margin-bottom: 12px;\n  align-items: flex-end;\n}\n.retail-rate {\n  display: flex;\n  font-size: 12px;\n  margin-top: 12px;\n}\n.rates-saved {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: auto;\n  margin: 0 auto;\n  position: relative;\n  background-color: #00bcd4;\n  color: #fff;\n  padding: 18px;\n}\n.retail-rate {\n  display: flex;\n  font-size: 12px;\n  padding-top: 4px;\n}\n.without-retail-rate {\n  display: flex;\n  font-size: 12px;\n  margin-top: 12px;\n}\n.Select-menu-outer {\n  z-index: 2000 !important;\n  position: absolute;\n}\n.Select-multi-value-wrapper {\n  max-height: 150px;\n  overflow-y: scroll;\n}\n.DayPicker-Month:nth-child(odd) {\n  float: right;\n}\n@media only screen and (max-width: 1008px) {\n  .step-container .step-grey-line {\n    display: none;\n  }\n}\n@media only screen and (max-width: 611px) {\n  .step-container .step-title {\n    display: none;\n  }\n}\n@media screen and (min-width: 1232px) {\n  .step-container .step-title {\n    font-size: 14px;\n  }\n}\n.step-grey-line {\n  display: inline-block;\n  border-bottom: solid #BDBDBD;\n  border-width: thin;\n  position: relative;\n  margin-left: auto;\n  bottom: 8px;\n}\n_::-webkit-full-page-media .step-grey-line,\n_:future .step-grey-line,\n:root .step-grey-line {\n  margin-left: 20px;\n  margin-top: 22px;\n  margin-right: -20px;\n}\n.step-container {\n  display: inline-block;\n  vertical-align: middle;\n}\n.stepper-container {\n  padding: 17px;\n  box-shadow: 0px 1px 1px #E0E0E0;\n  display: inline-block;\n  width: 100%;\n}\n.stepper-container li {\n  display: inline-block;\n  text-align: center;\n  cursor: pointer;\n  float: left;\n}\n.stepper-container li:before {\n  float: left;\n}\n.stepper-container li.stepper-container-todo {\n  color: #BDBDBD;\n  cursor: default;\n}\n.stepper-container li.stepper-container-todo:before {\n  content: \" \";\n  background: #BDBDBD;\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n  color: #FFFFFF;\n  line-height: 1.6em;\n  font-size: 16px;\n}\n.stepper-container li.stepper-container-doing {\n  color: #000000;\n  opacity: 87%;\n  cursor: default;\n}\n.stepper-container li.stepper-container-doing:before {\n  content: \"\";\n  background: #00bcd4;\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n  color: #FFFFFF;\n  line-height: 1.6em;\n  font-size: 16px;\n}\n.stepper-container li.stepper-container-done:before {\n  font-family: 'Material Icons';\n  content: '\\E150';\n  color: #FFFFFF;\n  background: #00bcd4;\n  line-height: 1.7em;\n  border-radius: 1.2em;\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n}\n.step-title {\n  display: inline-block;\n  margin-left: 15px;\n  margin-top: 3px;\n  font-family: 'Roboto', sans-serif;\n  cursor: default;\n  float: left;\n  font-size: 1vw;\n}\nli.stepper-container-doing .step-title {\n  font-weight: 600;\n  color: #616161;\n}\nli.stepper-container-done .step-title {\n  color: #616161;\n}\n.stepper-body {\n  display: flex;\n}\n.contracting-left-nav-widget .contracting-left-nav-title {\n  font-weight: 600;\n  line-height: 36px;\n  margin-top: 12px;\n  margin-left: 18px;\n}\n.contracting-left-nav-widget .counter {\n  background-color: #e0e0e0;\n  color: #424242;\n  margin-top: 4px;\n  margin-right: 4px;\n}\n.contracting-left-nav-widget .content-with-icon {\n  color: #424242;\n  position: relative;\n  top: -4px;\n  margin-left: 8px;\n}\n.contracting-left-nav-widget .content-without-icon {\n  color: #424242;\n}\n.contracting-left-nav-widget .icon {\n  color: #424242;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link {\n  margin: 8px 0;\n  cursor: pointer;\n  display: block;\n  position: relative;\n  line-height: 16px;\n  padding: 12px;\n  padding-left: 16px;\n  overflow: hidden;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link:focus {\n  outline: none;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link.is-zero {\n  color: #bdbdbd;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link:after {\n  content: '';\n  position: absolute;\n  top: 0px;\n  left: -3px;\n  width: 3px;\n  height: 100%;\n  background-color: #ff4081;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link:hover:after {\n  transform: translate3d(3px, 0px, 0px);\n  background-color: #ff4081;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link:hover .counter {\n  color: #ffffff;\n  background-color: #ff4081;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link:hover .content-with-icon {\n  color: #ff4081;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link:hover .content-without-icon {\n  color: #ff4081;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link:hover .icon {\n  color: #ff4081;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link.is-active {\n  cursor: default;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link.is-active:after {\n  transform: translate3d(3px, 0px, 0px);\n  background-color: #00bcd4;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link.is-active .counter {\n  color: white;\n  background-color: #00bcd4;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link.is-active .content-with-icon {\n  color: #00bcd4;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link.is-active .content-without-icon {\n  color: #00bcd4;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link.is-active .icon {\n  color: #00bcd4;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link.is-active:hover {\n  color: #00bcd4;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link.is-active:hover:after {\n  background-color: #00bcd4;\n}\n.dashboard-checkbox {\n  margin-top: 16px;\n  margin-left: 16px;\n  float: left;\n  width: 15% !important;\n}\n.dashboard-profile-image {\n  margin-top: 8px !important;\n  height: 40px !important;\n  width: 40px !important;\n}\n.activities-profile-image {\n  height: 40px !important;\n  width: 40px !important;\n}\n.dashboard-parent-row-card {\n  font-size: 13px;\n  line-height: 52px;\n}\n.dashboard-parent-row-card .card-header {\n  padding: 0 !important;\n  height: 44px !important;\n}\n.dashboard-parent-row-card .company-parent-div {\n  width: 15%;\n  float: left;\n}\n.dashboard-parent-row-card .company-parent-right {\n  width: 85%;\n  float: right;\n}\n.dashboard-parent-row-card .company-parent-right span {\n  display: inline-block;\n  color: black;\n}\n.dashboard-parent-row-card .contracting-sign-up-company-parent-div {\n  width: 7%;\n  float: left;\n}\n.dashboard-parent-row-card .contracting-sign-up-company-parent-right {\n  width: 93%;\n  float: right;\n}\n.dashboard-parent-row-card .contracting-sign-up-company-parent-right span {\n  display: inline-block;\n  color: black;\n}\n.assign-folder-dialog {\n  display: flex;\n  flex-direction: row;\n}\n.dashboard-header {\n  display: flex;\n  background-color: #00b3cf;\n  height: 48px;\n  color: white;\n  width: 100.1%;\n}\n.grey-background-on-hover:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n.pieChart:hover {\n  cursor: pointer;\n}\n.report {\n  cursor: pointer;\n}\n.report:hover {\n  border-left: 3px solid #ff4081;\n}\n.report:after {\n  display: block;\n  font-weight: bold;\n  height: 1px;\n  color: transparent;\n  overflow: hidden;\n  visibility: hidden;\n  margin-bottom: -1px;\n}\n.report.is-active {\n  cursor: default;\n  border-left: 3px solid #00bcd4;\n}\n.contracting-comment-box {\n  border: none;\n  margin-top: 16px;\n  margin-bottom: 16px;\n  margin-left: 20px;\n  padding: 0;\n  width: 90%;\n  max-with: 90%;\n  float: right;\n  resize: vertical;\n}\n.contracting-comment-box:focus {\n  outline: 0;\n}\n.clickEditCell {\n  background-color: transparent;\n  border: none;\n  width: 48px;\n}\n.clickEditCell:focus {\n  color: #ff4081;\n}\n.rates-table {\n  display: flex;\n  font-size: 12px;\n}\n.rates-table-titles {\n  display: flex;\n  font-size: 12px;\n  padding-top: 4px;\n}\n.right-side-product-flex {\n  display: flex;\n  margin-bottom: 12px;\n}\n.add-item-card-flex {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  max-width: 300px;\n}\n.product-column-flex {\n  display: flex;\n  clear: both;\n}\n.check-in-check-out {\n  display: flex;\n}\n.inclusion-exclusion {\n  display: flex;\n  margin: 24px 0;\n  font-weight: 600;\n  font-size: 12px;\n}\n.contract-window {\n  display: flex;\n}\n.mouse-over-edit {\n  display: flex;\n}\n::-webkit-input-placeholder {\n  /* WebKit, Blink, Edge */\n  font-style: italic;\n}\n:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  font-style: italic;\n}\n::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  font-style: italic;\n}\n:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  font-style: italic;\n}\n::-ms-input-placeholder {\n  /* Microsoft Edge */\n  font-style: italic;\n}\n.settings-left-nav {\n  position: fixed;\n  height: 100%;\n  margin-top: -96px;\n}\n.settings-left-nav .settings-left-nav-inner {\n  margin-top: 96px;\n}\n.settings-left-nav .settings-left-nav-heading {\n  font-weight: bold;\n  font-size: 14px;\n  padding-left: 16px;\n  line-height: 48px;\n  text-transform: uppercase;\n  border-bottom: solid 1px #eeeeee;\n}\n.multi-select-input-container,\n.input-container {\n  position: relative;\n  margin: 12px;\n  margin-left: 0px;\n  display: inline-block;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n}\n.multi-select-input-container .multi-select-input,\n.input-container .multi-select-input,\n.multi-select-input-container input,\n.input-container input {\n  margin: 0;\n  width: 100%;\n  outline: 0;\n  tap-highlight-color: rgba(255, 255, 255, 0);\n  text-align: left;\n  line-height: 1.2142em;\n  padding: .67861em 1em;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  color: rgba(0, 0, 0, 0.8);\n  border-radius: .2857rem;\n  text-overflow: ellipsis;\n  transition: background-color 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n  box-shadow: none;\n}\n.form-container {\n  position: relative;\n  max-width: 72%;\n  margin: 0px auto;\n  display: block;\n}\n.form-container .error-message {\n  display: none;\n}\n.form-container .tc-section-heading {\n  padding: 32px 0px;\n}\n.form-container .form-header {\n  padding-bottom: .25rem;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  font-weight: 700;\n  line-height: 1.33em;\n  text-transform: none;\n  color: rgba(0, 0, 0, 0.8);\n}\n.form-container.is-disabled-form .is-not-valid-multiselect {\n  border-color: #dbb1b1;\n  border-radius: 0 .2857rem .2857rem 0;\n  background: #fff0f0;\n}\n.form-container.is-disabled-form .is-not-valid-multiselect .multi-select-input {\n  background: #fff0f0;\n  color: #d95c5c;\n}\n.form-container.is-disabled-form .is-not-valid-multiselect ~ .error-message {\n  color: #d95c5c;\n  opacity: .7;\n  display: block;\n}\n.form-container.is-disabled-form :required:invalid {\n  background: #fff0f0;\n  border-color: #dbb1b1;\n  color: #d95c5c;\n  border-radius: 0 .2857rem .2857rem 0;\n}\n.form-container.is-disabled-form :required:invalid ~ .error-message {\n  color: #d95c5c;\n  opacity: .7;\n  display: block;\n}\n.form-container.is-disabled-form :required:invalid:focus {\n  box-shadow: 2px 0 0 0 #d95c5c inset;\n}\n.field {\n  display: block;\n  clear: both;\n  margin: 0 0 1em;\n}\n.field .form-label {\n  display: block;\n  float: right;\n  margin: 0 0 .2857rem;\n  color: rgba(0, 0, 0, 0.8);\n  font-size: .9285em;\n  font-weight: 700;\n  text-transform: none;\n}\n.field textarea {\n  height: 64px;\n  min-height: 64px;\n}\ntextarea {\n  vertical-align: top;\n  width: 100%;\n  overflow: auto;\n  margin: 0;\n  padding: .78571em 1em;\n  background: #fff;\n  border: 1px solid rgba(39, 41, 43, 0.15);\n  outline: 0;\n  color: rgba(0, 0, 0, 0.8);\n  border-radius: .2857rem;\n  box-shadow: 0 0 transparent inset;\n  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n  font-size: 1em;\n  max-width: 100%;\n}\ntextarea:required.is-invalid {\n  background: #fff0f0;\n  border-color: #dbb1b1;\n  color: #d95c5c;\n  border-radius: 0 .2857rem .2857rem 0;\n}\ntextarea:required.is-invalid:focus {\n  box-shadow: 2px 0 0 0 #d95c5c inset;\n}\n.form-line {\n  position: relative;\n  width: 100%;\n}\n.form-line .form-line-three {\n  display: inline-block;\n  position: relative;\n  width: calc(100% / 3 - 8px);\n}\n.form-line .form-line-three:nth-child(2) {\n  margin: 0px 12px;\n}\n.form-line .form-line-four {\n  display: inline-block;\n  position: relative;\n  margin: 0px 12px 0px 0px;\n  width: calc(100% / 4 - 9px);\n}\n.form-line .form-line-four:last-child {\n  margin: 0;\n}\n.form-line .form-line-two {\n  display: inline-block;\n  position: relative;\n  width: calc(100%/2 - 6px);\n  vertical-align: middle;\n  clear: both;\n}\n.form-line .form-line-two:first-child {\n  margin-right: 12px;\n}\n.form-dialog {\n  background-color: rgba(0, 0, 0, 0.3);\n}\n.inline-error {\n  color: #FF5E5C;\n  line-height: 18px;\n  margin-bottom: 12px;\n  border-radius: 4px;\n  opacity: 0;\n  padding: 20px 40px;\n  background: none repeat scroll 0 0 #FFF5F5;\n  transition: opacity 0.15s linear;\n  padding: 16px 23px 16px 16px;\n  font-size: 12px;\n}\n.inline-error.opacity {\n  opacity: 1;\n}\n.inline-error .close {\n  font-size: 19px;\n  cursor: pointer;\n  float: right;\n  opacity: .2;\n  margin-top: -5px;\n  margin-right: -8px;\n}\n.inline-error .close:hover {\n  opacity: .6;\n}\n.multi-select-input-container,\n.input-container {\n  position: relative;\n  margin: 12px;\n  margin-left: 0px;\n  display: inline-block;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n}\n.multi-select-input-container .multi-select-input,\n.input-container .multi-select-input,\n.multi-select-input-container input,\n.input-container input {\n  margin: 0;\n  width: 100%;\n  outline: 0;\n  tap-highlight-color: rgba(255, 255, 255, 0);\n  text-align: left;\n  line-height: 1.2142em;\n  padding: .67861em 1em;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  color: rgba(0, 0, 0, 0.8);\n  border-radius: .2857rem;\n  text-overflow: ellipsis;\n  transition: background-color 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n  box-shadow: none;\n}\n.legacy-frame {\n  overflow: hidden;\n}\n.legacy-frame,\n.legacy-frame iframe {\n  height: 100%;\n  width: 100%;\n  border: none;\n}\n.legacy-frame .spinny-gif {\n  display: block;\n  position: fixed;\n  top: calc(50% - 64px);\n  left: calc(50% - 42px);\n}\n.legacy-frame .spinny-gif.hidden {\n  display: none;\n}\n@keyframes loader {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.dimmer {\n  z-index: 2;\n  border-radius: inherit;\n  display: block;\n  opacity: 1;\n  position: fixed;\n  top: 64px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  vertical-align: middle;\n  background: rgba(0, 0, 0, 0.85);\n  line-height: 1;\n  animation-fill-mode: both;\n  animation-duration: .5s;\n  transition: background-color 0.5s linear;\n  user-select: none;\n  will-change: opacity;\n}\n.dimmer:after {\n  box-sizing: inherit;\n}\n.dimmer .loader {\n  color: #ffffff;\n  display: block;\n  min-width: 64px;\n  min-height: 64px;\n  font-size: 1em;\n  position: fixed;\n  top: calc(50% - 64px);\n  left: calc(50% - 48px);\n  margin: 0px;\n  text-align: center;\n  z-index: 2;\n  transform: translateX(-50%), translateY(-50%);\n}\n.dimmer .loader:before {\n  border-color: rgba(255, 255, 255, 0.15);\n  width: 64px;\n  height: 64px;\n  margin: 0em 0em 0em -1.12925em;\n  position: absolute;\n  content: '';\n  top: 0%;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n  border-radius: 500rem;\n}\n.dimmer .loader:after {\n  position: absolute;\n  content: '';\n  top: 0%;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n  animation: loader 0.6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: #aaaaaa transparent transparent;\n  border-style: solid;\n  border-width: 0.2em;\n  box-shadow: 0px 0px 0px 1px transparent;\n}\n.dimmer.hidden {\n  display: none;\n}\n.l-app-content .l-left-nav {\n  background-color: #fff;\n  box-shadow: none;\n}\n.l-app-content .l-left-nav .location-head {\n  margin-top: 96px;\n}\n.l-app-content .l-left-nav .location-head .addbutton {\n  margin-bottom: 30px;\n}\n.l-app-content .l-left-nav .location-head .segment-content {\n  text-align: center;\n}\n.l-app-content .l-left-nav .location-head .segment-content h4 {\n  padding-top: 0;\n  margin-bottom: 0;\n  font-size: 18px;\n}\n.l-app-content .l-left-nav .location-head .segment-content .l-paper-split-segment {\n  padding: 0 12px;\n}\n.l-app-content .l-left-nav .location-head .type-content {\n  text-align: center;\n}\n.l-app-content .l-left-nav .location-head .type-content h4 {\n  padding-top: 0;\n  margin-bottom: 0;\n  font-size: 18px;\n}\n.l-app-content .l-left-nav .location-head .type-content .l-paper-split-type {\n  padding: 0 12px;\n}\n.l-app-content .l-left-nav .location-head .profile-link-image {\n  /*position: absolute;\n        top: 30px;\n        left: 66px;*/\n  height: 128px;\n  width: 128px;\n  margin: 20px auto;\n}\n.l-app-content .l-left-nav .location-head .profile-link-image .profile-image-letter {\n  line-height: 128px;\n  font-size: 35px;\n}\n.l-app-content .l-left-nav-content .location-description {\n  margin-bottom: 10px;\n}\n.l-app-content .l-left-nav-content .location-description .short-info {\n  height: 126px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.l-app-content .l-left-nav-content .location-description .location-card {\n  margin-bottom: 30px;\n  position: relative;\n}\n.l-app-content .l-left-nav-content .location-description .location-card .tc-card-image-header {\n  height: 320px;\n  width: 100%;\n}\n.l-app-content .l-left-nav-content .location-description .location-card .tc-card-contents .load-more {\n  position: absolute;\n  right: 15px;\n  bottom: 10px;\n}\n.l-app-content .l-left-nav-content .location-description .location-card .cardGradient {\n  bottom: 21px;\n}\n.l-app-content .l-left-nav-content .location-product .short-product {\n  height: 150px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.l-app-content .l-left-nav-content .location-product .location-card {\n  margin-bottom: 30px;\n  position: relative;\n}\n.l-app-content .l-left-nav-content .location-product .location-card .tc-card-contents .product-box {\n  display: block;\n  margin-bottom: 12px;\n  clear: both;\n}\n.l-app-content .l-left-nav-content .location-product .location-card .tc-card-contents .product-box img {\n  float: left;\n  width: 48px;\n  height: 48px;\n}\n.l-app-content .l-left-nav-content .location-product .location-card .tc-card-contents .product-box .product-info {\n  margin-left: 70px;\n}\n.l-app-content .l-left-nav-content .location-product .location-card .tc-card-contents .product-box .product-info p {\n  padding-top: 0;\n  margin-bottom: 8px;\n}\n.l-app-content .l-left-nav-content .location-product .location-card .tc-card-contents .load-more {\n  position: absolute;\n  right: 15px;\n  bottom: 10px;\n}\n.l-app-content .l-left-nav-content .location-map {\n  position: relative;\n  height: 300px;\n  margin-bottom: 20px;\n}\n.l-app-content .l-left-nav-content .location-map .gmap {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.l-app-content .l-left-nav-content .location-contacts {\n  margin-bottom: 20px;\n}\n.l-app-content .l-left-nav-content .location-contacts .contact-details {\n  margin-bottom: 20px;\n}\n.l-app-content .l-left-nav-content .location-contacts .contact-details .contact h5 {\n  width: 172px;\n  display: inline-block;\n  font-size: 14px;\n  margin-bottom: 3px;\n  line-height: 20px;\n}\n.l-app-content .l-left-nav-content .location-contacts .contact-details .contact-info h6 {\n  width: 172px;\n  display: inline-block;\n  margin-bottom: 0px;\n  font-size: 13px;\n  line-height: 20px;\n}\n.l-app-content .l-left-nav-content .location-contacts .contact-details hr {\n  margin-bottom: 0px;\n}\n.location-address {\n  margin-bottom: 30px;\n  font-size: 14px;\n}\n.location-address .location-address-header {\n  font-size: 16px;\n}\n.location-address p {\n  padding-top: 0px;\n}\n.multi-select {\n  position: relative;\n  user-select: none;\n}\n.multi-select .multi-select-dropdown {\n  position: absolute;\n  visibility: hidden;\n  height: auto;\n  width: 100%;\n  z-index: 2;\n  transform: translate3d(0, -36px, 0);\n  transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.multi-select .multi-select-dropdown.is-vert-drop-down {\n  width: 250px;\n  left: -16px;\n  top: 12px;\n}\n.multi-select .multi-select-dropdown .mui-paper {\n  margin-top: 0px;\n  margin-bottom: 6.25px;\n}\n.multi-select .multi-select-dropdown .multi-select-search-bar {\n  position: relative;\n  visibility: hidden;\n  line-height: 36px;\n  opacity: 0;\n}\n.multi-select .multi-select-dropdown .multi-select-search-bar .tc-icon-search {\n  vertical-align: middle;\n  padding-left: 6.25px;\n}\n.multi-select .multi-select-dropdown .multi-select-search-bar .multi-select-search-input {\n  width: calc(100% - 30.25px);\n  position: relative;\n  float: right;\n  display: inline-block;\n  min-height: 24px;\n  height: 36px;\n  border-color: transparent;\n}\n.multi-select .multi-select-dropdown .multi-select-search-bar .multi-select-search-input:focus {\n  outline: 0;\n}\n.multi-select .multi-select-dropdown .multi-select-options-container {\n  z-index: 2;\n  position: relative;\n  visibility: hidden;\n  opacity: 0;\n  cursor: pointer;\n  max-height: 300px;\n}\n.multi-select .multi-select-dropdown .multi-select-options-container.is-scrollable {\n  overflow: scroll;\n}\n.multi-select .multi-select-dropdown .multi-select-options-container.overflow-hidden {\n  overflow: hidden;\n}\n.multi-select .multi-select-dropdown .multi-select-options-container .multi-select-option-container {\n  z-index: 2;\n  padding: 6.25px;\n  width: 50%;\n  display: inline-block;\n}\n.multi-select .multi-select-dropdown .multi-select-options-container .multi-select-option-container.is-smaller-select {\n  width: 100%;\n}\n.multi-select .multi-select-dropdown .multi-select-options-container .multi-select-option-container .multi-select-option-checkbox {\n  z-index: 2;\n  width: 10%;\n  height: 100%;\n  display: inline-block;\n  visibility: hidden;\n}\n.multi-select .multi-select-dropdown .multi-select-options-container .multi-select-option-container .multi-select-option {\n  z-index: 2;\n  color: rgba(0, 0, 0, 0.54);\n  width: 90%;\n  float: right;\n  display: inline-block;\n  min-height: 1.2em;\n}\n.multi-select .multi-select-dropdown.is-open {\n  visibility: visible;\n  transform: translate3d(0, 0px, 0);\n  transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.multi-select .multi-select-dropdown.is-open .multi-select-options-container {\n  height: auto;\n  background-color: white;\n  z-index: 2;\n  max-height: 300px;\n  visibility: visible;\n  opacity: 1;\n}\n.multi-select .multi-select-dropdown.is-open .multi-select-options-container .is-checked .multi-select-option-checkbox {\n  color: #4caf50;\n  visibility: visible;\n}\n.multi-select .multi-select-dropdown.is-open .multi-select-options-container .is-checked .multi-select-option {\n  color: #4caf50;\n}\n.multi-select .multi-select-dropdown.is-open .multi-select-search-bar {\n  visibility: visible;\n  background-color: white;\n  opacity: 1;\n  z-index: 2;\n}\n.multi-select .multi-select-input-container {\n  margin-bottom: 6.25px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: .2857rem;\n}\n.multi-select .multi-select-input-container .multi-select-input {\n  border: none;\n  width: calc(100% - 24px);\n  cursor: pointer;\n}\n.multi-select .multi-select-input-container .multi-select-input-dropdown {\n  cursor: pointer;\n  display: inline-block;\n  width: 24px;\n  line-height: 40px;\n  float: right;\n  background-color: #f5f5f5;\n}\n.multi-select .multi-select-input-container .multi-select-input-dropdown-arrow {\n  display: inline-block;\n  vertical-align: middle;\n}\n.onboarding-image-background {\n  position: absolute;\n  top: 0;\n  left: auto;\n  opacity: 0.3;\n  display: inline-block;\n  vertical-align: bottom;\n  overflow: hidden;\n  background-color: #cacccd;\n  backface-visibility: hidden;\n  width: 225px;\n  height: 225px;\n}\n.onboarding-image-container {\n  border-width: 0;\n  backface-visibility: hidden;\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  overflow: hidden;\n  background-color: #cacccd;\n  width: 225px;\n  height: 225px;\n  border-radius: 50%;\n}\n.onboarding-image-container.loader {\n  transition: all 0s linear;\n}\n.onboarding-image-container.loader:before {\n  position: absolute;\n  content: '';\n  top: calc(50% - 25px);\n  left: calc(50% - 25px);\n  width: 50px;\n  height: 50px;\n  border-radius: 100%;\n  border: 3px solid rgba(202, 204, 205, 0.15);\n}\n.onboarding-image-container.loader:after {\n  position: absolute;\n  content: '';\n  top: calc(50% - 25px);\n  left: calc(50% - 25px);\n  width: 50px;\n  height: 50px;\n  animation: loader .6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 100%;\n  border-color: #fff transparent transparent;\n  border-style: solid;\n  border-width: 3px;\n  box-shadow: 0 0 0 1px transparent;\n}\n.onboarding-image-container .profileViewImage {\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n}\n.tc-icon-office {\n  font-size: 100px;\n  margin: 0px 60.5px;\n  color: white;\n  line-height: 225px;\n}\n.tc-icon-office.normal-height {\n  line-height: 0px;\n}\n.submit-button {\n  width: 33%;\n}\n.on-boarding-card {\n  margin: 24px 0;\n}\n.on-boarding-card .onboarding-short-description-reminder {\n  margin-top: 0px;\n}\n.address-dialog-info {\n  white-space: pre;\n}\n.tc-icon-delete.onboarding-delete {\n  visibility: hidden;\n  z-index: -1;\n  position: absolute;\n  left: 201px;\n}\n.mui-dialog .mui-dialog-title,\n.mui-dialog h3 {\n  background-color: #f5f5f5;\n  padding: 0 24px;\n  border-radius: 2px 2px 0 0;\n  margin: 0;\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-size: 20px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n  line-height: 48px;\n}\n.mui-dialog .mui-dialog-content {\n  font-size: 13px;\n  line-height: 20px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.87);\n  font: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n.standard-modal {\n  font-size: 13px !important;\n  line-height: 20px !important;\n  font-weight: 400 !important;\n  color: rgba(0, 0, 0, 0.87) !important;\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif !important;\n}\n.standard-modal h3 {\n  background-color: #f5f5f5 !important;\n  padding: 0 24px !important;\n  border-radius: 2px 2px 0 0 !important;\n  margin: 0 !important;\n  font-size: 20px !important;\n  font-weight: 500 !important;\n  color: rgba(0, 0, 0, 0.87) !important;\n  line-height: 48px !important;\n}\n.profile-image {\n  border-radius: 50%;\n  height: 44px;\n  width: 44px;\n  text-align: center;\n  overflow: hidden;\n}\n.profile-image .profile-image-image {\n  height: 44px;\n  width: 44px;\n  vertical-align: inherit;\n}\n.profile-image .profile-image-letter {\n  line-height: 44px;\n  font-size: 24px;\n  font-weight: 300;\n  border: solid 1px rgba(0, 0, 0, 0.12);\n}\n.profile-image .profile-image-letter {\n  border: solid 1px rgba(0, 0, 0, 0.12);\n  color: white;\n}\n.profile-image .profile-image-letter.is-grey {\n  background-color: darkgray;\n}\n.profile-image .profile-image-letter.is-red {\n  background-color: #f44336;\n}\n.profile-image .profile-image-letter.is-pink {\n  background-color: #e91e63;\n}\n.profile-image .profile-image-letter.is-purple {\n  background-color: #9c27b0;\n}\n.profile-image .profile-image-letter.is-deep-purple {\n  background-color: #673ab7;\n}\n.profile-image .profile-image-letter.is-indigo {\n  background-color: #3f51b5;\n}\n.profile-image .profile-image-letter.is-blue {\n  background-color: #2196f3;\n}\n.profile-image .profile-image-letter.is-light-blue {\n  background-color: #03a9f4;\n}\n.profile-image .profile-image-letter.is-cyan {\n  background-color: #00bcd4;\n}\n.profile-image .profile-image-letter.is-teal {\n  background-color: #009688;\n}\n.profile-image .profile-image-letter.is-green {\n  background-color: #4caf50;\n}\n.profile-image .profile-image-letter.is-deep-orange {\n  background-color: #ff5722;\n}\n.profile-link {\n  z-index: 1100;\n}\n.profile-link .profile-link-target {\n  cursor: pointer;\n}\n.profile-link .profile-link-dropdown-arrow {\n  float: right;\n  color: rgba(0, 0, 0, 0.54);\n  line-height: 48px;\n  margin-top: 8px;\n}\n.profile-link .profile-link-image {\n  float: left;\n  margin-top: 10px;\n  margin-left: 24px;\n}\n.profile-link .profile-link-container {\n  position: absolute;\n  top: 56px;\n  right: 0;\n  background-color: #ffffff;\n  width: 150px;\n  margin-top: 4px;\n  text-align: left;\n  opacity: 1;\n  transform: translate3d(0, 0, 0) scale(1);\n  transform-origin: top right;\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.profile-link .profile-link-container-contents {\n  padding: 8px 16px;\n}\n.profile-link .profile-link-support-link {\n  cursor: pointer;\n}\n.profile-link .profile-link-container-link {\n  display: block;\n  line-height: 36px;\n  margin-left: 0;\n  color: rgba(0, 0, 0, 0.54);\n  cursor: pointer;\n}\n.profile-link .profile-link-container-link:hover,\n.profile-link .profile-link-container-link.active {\n  color: #ff4081;\n}\n.profile-link .profile-link-container-link.profile-link-admin-link {\n  display: none;\n}\n.profile-link .profile-link-container-link.profile-link-billing-link {\n  display: none;\n}\n.profile-link.is-closed .profile-link-container {\n  top: -500px;\n  opacity: 0;\n  transform: translate3d(0, -20px, 0) scale(0);\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.profile-link.is-an-admin .profile-link-admin-link.profile-link-container-link {\n  display: block;\n}\n.profile-link.is-a-supplier .profile-link-billing-link.profile-link-container-link {\n  display: block;\n}\n.submit-button {\n  width: 33%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 24px;\n}\n.submit-button.loader {\n  position: relative;\n  transition: all 0s linear;\n  background-color: #00bcd4;\n  z-index: -1;\n}\n.submit-button.loader:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285em 0 0 -0.64285em;\n  width: 1.2857em;\n  height: 1.2857em;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.15);\n}\n.submit-button.loader:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285em 0 0 -0.64285em;\n  width: 1.2857em;\n  height: 1.2857em;\n  animation: loader .6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: #fff transparent transparent;\n  border-style: solid;\n  border-width: .2em;\n  box-shadow: 0 0 0 1px transparent;\n}\n.temp-connection-next-button.loader,\n.billing-button.loader {\n  position: relative;\n  transition: all 0s linear;\n  background-color: #e6e6e6;\n  z-index: -1;\n}\n.temp-connection-next-button.loader:before,\n.billing-button.loader:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285em 0 0 -0.64285em;\n  width: 1.2857em;\n  height: 1.2857em;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.15);\n}\n.temp-connection-next-button.loader:after,\n.billing-button.loader:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285em 0 0 -0.64285em;\n  width: 1.2857em;\n  height: 1.2857em;\n  animation: loader .6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: #fff transparent transparent;\n  border-style: solid;\n  border-width: .2em;\n  box-shadow: 0 0 0 1px transparent;\n}\n.image-input {\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  width: 100%;\n  opacity: 0;\n}\n.user_login {\n  /* width: 372px; */\n  height: 460px;\n  width: 372px;\n  position: relative;\n  left: 50%;\n  top: 96px;\n  margin: 0 0 0 -186px;\n  float: left;\n}\n.user_login .signin_form {\n  margin: 16px 0 0;\n  float: none;\n  padding: 16px 50px;\n  background: #ffffff;\n  border: 1px solid #d0d0d0;\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);\n  border-radius: 3px;\n  display: block;\n}\n.user_login .signin_form a.signin-link {\n  font-size: 12px;\n  color: #617189;\n}\n.user_login .signin_form a.signin-link:hover {\n  color: #005580;\n}\n.user_login .signin_form form {\n  margin-bottom: 18px;\n}\n.user_login .signin_form fieldset.control-group label.checkbox {\n  display: block;\n  font-size: 13px;\n  font-weight: normal;\n  line-height: 14px;\n  margin-bottom: 20px !important;\n  color: #5E7080;\n  cursor: pointer;\n  padding-left: 24px;\n}\n.user_login .signin_form fieldset.control-group label.checkbox input[type=checkbox] {\n  float: left;\n  margin: 0 0 0 -19px;\n  clear: both;\n  cursor: pointer;\n}\n.user_login .signin_form fieldset.control-group input[type=email],\n.user_login .signin_form fieldset.control-group input[type=password] {\n  box-sizing: content-box;\n  width: 330px;\n  height: 25px;\n  padding: 3px 5px;\n  margin-bottom: 9px;\n  font-size: 13px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n}\n.user_login .signin_form fieldset.control-group label.control-label {\n  color: #5E7080;\n  font-size: 16px;\n  line-height: 18px;\n  font-weight: bold;\n  display: block;\n  margin-bottom: 5px;\n}\n.signin-button {\n  border-style: none;\n  padding: 7px 14px;\n  font-size: 15px;\n  line-height: normal;\n  border-radius: 5px;\n  color: #ffffff;\n  background-color: #28B0DF;\n  cursor: pointer;\n  font-weight: 600;\n  outline: none;\n}\n.signin-button:hover {\n  border: none;\n}\n.signin-button.loader {\n  color: #28B0DF;\n  background-color: #28B0DF;\n  position: relative;\n  transition: all 0s linear;\n}\n.signin-button.loader:hover {\n  border: none;\n}\n.signin-button.loader:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285em 0 0 -0.64285em;\n  width: 1.2857em;\n  height: 1.2857em;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.15);\n}\n.signin-button.loader:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285em 0 0 -0.64285em;\n  width: 1.2857em;\n  height: 1.2857em;\n  animation: loader .6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: #fff transparent transparent;\n  border-style: solid;\n  border-width: .2em;\n  box-shadow: 0 0 0 1px transparent;\n}\n.signin-header {\n  text-align: center;\n  padding-bottom: 10px;\n  margin-bottom: -10px;\n  line-height: 26px;\n  font-size: 24px;\n  color: #5E7080;\n}\n.type-ahead-options-container {\n  height: auto !important;\n  position: absolute;\n  z-index: 2;\n  display: block;\n  background-color: white;\n  max-height: 300px;\n  opacity: 1;\n  width: 95%;\n  cursor: pointer;\n}\n.type-ahead-options-container .type-ahead-option-container {\n  z-index: 2;\n  position: relative;\n  padding-left: 6.25px;\n  width: 100%;\n  height: 24px;\n  margin: 8px 0px;\n  display: block;\n}\n.type-ahead-options-container .type-ahead-option {\n  z-index: 2;\n  position: relative;\n  color: rgba(0, 0, 0, 0.54);\n  width: 100%;\n  display: inline-block;\n  min-height: 1.2em;\n}\n.integration-refresh {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  pointer: cursor;\n  cursor: pointer;\n  padding: 10px;\n  font-size: 18px;\n}\n.integration-contract-title {\n  font-size: 38px;\n}\n.integration-contract-label {\n  font-weight: 600;\n  font-size: 18px;\n}\n.integration-contract-detail {\n  font-size: 18px;\n}\n.integration-export {\n  margin-left: 14px;\n}\n.integration-left-nav {\n  position: fixed;\n  height: 100%;\n  margin-top: -96px;\n}\n.integration-left-nav .integration-left-nav-inner {\n  margin-top: 96px;\n}\n.integration-left-nav .integration-left-nav-heading {\n  font-size: 14px;\n  padding-left: 16px;\n  line-height: 48px;\n  text-transform: uppercase;\n  border-bottom: solid 1px #eeeeee;\n}\n.plan-graph .plan-graph-li-white {\n  background-color: #fff;\n  border-bottom: 1px solid #efefef;\n  border-left: 1px solid #efefef;\n  color: #888;\n  padding: 10px 0px 10px 32px;\n  text-align: left;\n  line-height: 24px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-grey {\n  background-color: #fbfbfb;\n  border-bottom: 1px solid #efefef;\n  border-left: 1px solid #efefef;\n  color: #888;\n  padding: 10px 0px 10px 32px;\n  text-align: left;\n  line-height: 24px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-grey-less-padding {\n  background-color: #fbfbfb;\n  border-bottom: 1px solid #efefef;\n  border-left: 1px solid #efefef;\n  color: #888;\n  padding: 10px 0px 10px 16px;\n  text-align: left;\n  line-height: 24px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-white-less-padding {\n  background-color: #fff;\n  border-bottom: 1px solid #efefef;\n  border-left: 1px solid #efefef;\n  color: #888;\n  padding: 10px 0px 10px 16px;\n  text-align: left;\n  line-height: 24px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-grey-less-line-height {\n  background-color: #fbfbfb;\n  border-bottom: 1px solid #efefef;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 18px;\n}\n.plan-graph .plan-graph-li-grey-less-font-size {\n  background-color: #fbfbfb;\n  border-bottom: 1px solid #efefef;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 24px;\n  font-size: 16px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-white-less-font-size {\n  background-color: #fff;\n  border-bottom: 1px solid #efefef;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 24px;\n  font-size: 16px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-white-less-line-height {\n  background-color: #fff;\n  border-bottom: 1px solid #efefef;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 18px;\n}\n.plan-graph .dollar-sign {\n  font-size: 22px;\n  line-height: 22px;\n  top: -14px;\n  right: -6px;\n  position: relative;\n}\n.plan-graph .pricing-column.no-highlight.accent-color {\n  width: 24%;\n  display: inline-block;\n  background-color: #fff;\n  border-left: 1px solid #e4e4e4;\n  overflow: hidden;\n  text-align: center;\n  vertical-align: top;\n  padding: 0px;\n  tranisition: box-shadow 0.2px linear;\n}\n.plan-graph .plan-graph-li-empty-grey-box {\n  background-color: #fbfbfb;\n  border-bottom: 1px solid #efefef;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 18px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-empty-white-box {\n  background-color: #fff;\n  border-bottom: 1px solid #efefef;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 18px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-empty-grey-box-border-bottom-only {\n  background-color: #fbfbfb;\n  border-bottom: 1px solid #efefef;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 18px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-empty-white-box-border-bottom-only {\n  background-color: #fff;\n  border-bottom: 1px solid #efefef;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 18px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-unique-white-box {\n  background-color: #fff;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 24px;\n  font-size: 16px;\n  height: 24px;\n}\n.plan-graph .plan-graph-li-contract-header {\n  background-color: #fff;\n  border-bottom: 1px solid #efefef;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 24px;\n  font-size: 16px;\n  height: 47px;\n}\n.plan-graph .interval {\n  color: #999;\n  min-height: 38px;\n  display: block;\n  padding-bottom: 17px;\n}\n.plan-graph .pricing-column-content {\n  padding: 0px;\n}\n.plan-graph .blank-interval {\n  color: #999;\n  min-height: 38px;\n  display: block;\n  height: 46px;\n  padding-bottom: 17px;\n}\n.plan-graph ul.features {\n  margin-bottom: 0px;\n}\n.plan-graph .connect-and-communicate {\n  background-color: #fbfbfb;\n  border-top: 1px solid #efefef;\n  border-bottom: 1px solid #efefef;\n  border-left: 1px solid #efefef;\n  color: #888;\n  padding: 10px 0px 10px 16px;\n  text-align: left;\n  line-height: 24px;\n  height: 47px;\n}\n.plan-graph .pricing-column-content {\n  border: none;\n}\n.plan-graph .pricing-column-content-header {\n  margin-bottom: 8px;\n  margin-left: -22px;\n  padding: 20px 30px 6px 30px;\n  font-size: 54px;\n  line-height: 42px;\n  color: #333;\n  letter-spacing: -0.5px;\n}\n.plan-graph h3.pricing-column-content-h3 {\n  font-size: 20px;\n  letter-spacing: 2px;\n  color: #21cdec;\n  background-color: #fff;\n  line-height: 28px;\n  border-right: 1px solid #e4e4e4;\n  border-bottom: 1px solid #efefef;\n  border-top: 1px solid #e4e4e4;\n  padding: 18px 0px 18px 0px;\n  margin-bottom: 0px;\n}\n.plan-graph h3.pricing-column-content-h3.right {\n  border-right: none;\n}\n.plan-graph h3.pricing-column-header.left {\n  letter-spacing: 2px;\n  color: #21cdec;\n  line-height: 28px;\n  height: 66px;\n  padding: 18px 0px 18px 0px;\n  margin-bottom: 0px;\n  border: none;\n}\n.plan-graph h4.pricing-column-content-h4.left {\n  margin-bottom: 0px;\n  margin-left: -22px;\n  padding: 20px 30px 6px 30px;\n  font-size: 54px;\n  line-height: 42px;\n  height: 70px;\n  color: #333;\n  letter-spacing: -0.5px;\n}\n.plan-graph .pricing-column-right {\n  border-right: 1px solid #e4e4e4;\n  float: none;\n}\n.plan-graph .pricing-column-right.pricing-column-content-h3 {\n  border-right: none;\n}\n.plan-graph .unlimited-plan-h3 {\n  font-size: 20px;\n  letter-spacing: 2px;\n  background-color: #21cdec;\n  color: #fff;\n  line-height: 56px;\n  vertical-align: middle;\n  height: 86px;\n  padding: 15px 0px;\n  margin-bottom: 0px;\n}\n.plan-graph .unlimited-plan-container {\n  width: 24%;\n  display: inline-block;\n  position: relative;\n  z-index: 100;\n  margin: -20px -1px 0px -1px;\n  background-color: #fff;\n  box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.09);\n  overflow: hidden;\n  text-align: center;\n  padding: 0px;\n  tranisition: box-shadow 0.2px linear;\n}\n.plan-graph .unlimited-plan-container ul li {\n  list-style: none;\n  list-style-position: none;\n}\n.plan-graph .unlimited-plan-container ul {\n  margin-left: 0px;\n  margin-bottom: 0px;\n}\n.view-link {\n  z-index: 1100;\n  height: 100px;\n}\n.view-link .view-link-container {\n  position: relative;\n  z-index: 1;\n  top: -56px;\n  right: 0;\n  background-color: #ffffff;\n  width: 150px;\n  margin-top: 4px;\n  text-align: left;\n  opacity: 1;\n  transform: translate3d(0, 0, 0) scale(1);\n  transform-origin: top right;\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.view-link.is-closed .view-link-container {\n  top: -500px;\n  opacity: 0;\n  transform: translate3d(0, -20px, 0) scale(0);\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.transformation {\n  -moz-transition: transform 1s;\n  -webkit-transition: transform 1s;\n  -ms-transition: transform 1s;\n  -o-transition: transform 1s;\n  transition: transform 1s;\n}\n.upgrade-and-save-container {\n  margin-top: 150px;\n}\n.textfield-container {\n  margin-top: 16px;\n  padding-bottom: 8px;\n  margin-bottom: 8px;\n}\n.field-label-container {\n  height: 24px;\n  margin-bottom: 15px;\n}\n.label-text-initial {\n  font-size: 16px;\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n.label-text-left-nav {\n  display: inline-block;\n  font-size: 14px;\n  color: black;\n  margin: 10px 0 10px 15px;\n  height: 22px;\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n.select-field-container-initial {\n  padding: 15px;\n  margin-top: 10px;\n}\n.select-field-container-left-nav {\n  padding-bottom: 8px;\n  margin-top: 16px;\n}\n/* DayPicker styles */\n.DayPicker {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  position: relative;\n  padding: 1rem 0;\n  user-select: none;\n}\n.DayPicker-Month {\n  display: table;\n  border-collapse: collapse;\n  border-spacing: 0;\n  user-select: none;\n  margin: 0 0.5rem;\n}\n.DayPicker-NavBar {\n  position: absolute;\n  left: 0;\n  right: 0;\n  padding: 0 .5rem;\n}\n.DayPicker-NavButton {\n  position: absolute;\n  width: 1rem;\n  height: 1rem;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  cursor: pointer;\n}\n.DayPicker-NavButton--prev {\n  left: 1rem;\n  background-image: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjI2cHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDI2IDUwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy4zLjIgKDEyMDQzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5wcmV2PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc2tldGNoOnR5cGU9Ik1TUGFnZSI+CiAgICAgICAgPGcgaWQ9InByZXYiIHNrZXRjaDp0eXBlPSJNU0xheWVyR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzLjM5MzE5MywgMjUuMDAwMDAwKSBzY2FsZSgtMSwgMSkgdHJhbnNsYXRlKC0xMy4zOTMxOTMsIC0yNS4wMDAwMDApIHRyYW5zbGF0ZSgwLjg5MzE5MywgMC4wMDAwMDApIiBmaWxsPSIjNTY1QTVDIj4KICAgICAgICAgICAgPHBhdGggZD0iTTAsNDkuMTIzNzMzMSBMMCw0NS4zNjc0MzQ1IEwyMC4xMzE4NDU5LDI0LjcyMzA2MTIgTDAsNC4yMzEzODMxNCBMMCwwLjQ3NTA4NDQ1OSBMMjUsMjQuNzIzMDYxMiBMMCw0OS4xMjM3MzMxIEwwLDQ5LjEyMzczMzEgWiIgaWQ9InJpZ2h0IiBza2V0Y2g6dHlwZT0iTVNTaGFwZUdyb3VwIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K\");\n}\n.DayPicker-NavButton--next {\n  right: 1rem;\n  width: 10px;\n  background-image: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjI2cHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDI2IDUwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy4zLjIgKDEyMDQzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5uZXh0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc2tldGNoOnR5cGU9Ik1TUGFnZSI+CiAgICAgICAgPGcgaWQ9Im5leHQiIHNrZXRjaDp0eXBlPSJNU0xheWVyR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuOTUxNDUxLCAwLjAwMDAwMCkiIGZpbGw9IiM1NjVBNUMiPgogICAgICAgICAgICA8cGF0aCBkPSJNMCw0OS4xMjM3MzMxIEwwLDQ1LjM2NzQzNDUgTDIwLjEzMTg0NTksMjQuNzIzMDYxMiBMMCw0LjIzMTM4MzE0IEwwLDAuNDc1MDg0NDU5IEwyNSwyNC43MjMwNjEyIEwwLDQ5LjEyMzczMzEgTDAsNDkuMTIzNzMzMSBaIiBpZD0icmlnaHQiIHNrZXRjaDp0eXBlPSJNU1NoYXBlR3JvdXAiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=\");\n}\n.DayPicker-Caption {\n  display: table-caption;\n  height: 1rem;\n  font-size: 0.8em;\n  text-align: center;\n}\n.DayPicker-Weekdays {\n  display: table-header-group;\n}\n.DayPicker-WeekdaysRow {\n  display: table-row;\n}\n.DayPicker-Weekday {\n  display: table-cell;\n  padding: .3rem;\n  font-size: .7em;\n  text-align: center;\n  color: #8b9898;\n}\n.DayPicker-Body {\n  display: table-row-group;\n}\n.DayPicker-Week {\n  display: table-row;\n}\n.DayPicker-Day {\n  display: table-cell;\n  padding: .15rem;\n  border: 1px solid #eaecec;\n  text-align: center;\n  cursor: pointer;\n  vertical-align: middle;\n  font-size: 14px;\n}\n.DayPicker--interactionDisabled .DayPicker-Day {\n  cursor: default;\n}\n/* Default modifiers */\n.DayPicker-Day--today {\n  color: #d0021b;\n  font-weight: 500;\n}\n.DayPicker-Day--disabled {\n  color: #dce0e0;\n  cursor: default;\n  background-color: #eff1f1;\n}\n.DayPicker-Day--outside {\n  cursor: default;\n  color: #dce0e0;\n}\n/* Example modifiers */\n.DayPicker-Day--sunday {\n  color: #dce0e0;\n  background-color: #f7f8f8;\n}\n.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n  color: #FFF;\n  background-color: rgba(74, 144, 255, 0.78);\n}\n.remove-hover-color:hover {\n  background-color: transparent !important;\n}\n@media only screen and (max-width: 590px) {\n  .company-type-checkboxes {\n    width: 100% !important;\n  }\n}\n.nav-add-hover {\n  padding: 8px;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n.nav-add-hover:hover {\n  background-color: #e7e8ea;\n}\n@media (max-width: 768px) {\n  .left-nav-mobile-breakpoint {\n    display: none;\n  }\n  .right-side-mobile-breakpoint {\n    display: none;\n  }\n  .main-feed {\n    width: 90%;\n    margin: 0 auto;\n  }\n  .news-feed-avatar {\n    display: none !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 1000px) {\n  .newsfeed-container {\n    display: flex;\n  }\n  .main-feed {\n    width: 70%;\n    margin: 0 5%;\n  }\n  .news-feed-avatar {\n    display: none !important;\n  }\n  .right-side-mobile-breakpoint {\n    display: none;\n  }\n}\n@media (min-width: 1000px) {\n  .newsfeed-container {\n    display: flex;\n    justify-content: space-between;\n  }\n  .left-nav-mobile-breakpoint {\n    width: 20%;\n  }\n  .main-feed {\n    width: 50%;\n    margin: 0 auto;\n  }\n  .right-side-mobile-breakpoint {\n    width: 25%;\n  }\n  .news-feed-avatar {\n    border: 0px solid #E0E0E0;\n    height: 50px !important;\n    position: relative;\n    width: 50px !important;\n  }\n}\n@media screen and (max-width: 692px) {\n  .hide-float-center {\n    width: 100% !important;\n    float: none !important;\n    text-align: center;\n  }\n}\n@media screen and (max-width: 342px) {\n  .share-icons-outer-div {\n    margin-left: 0 !important;\n    overflow: hidden;\n  }\n}\n@media screen and (max-width: 342px) {\n  .share-icons {\n    display: none !important;\n  }\n}\n.outer-div-hide-scroll {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n.inner-div-allow-scroll {\n  width: 100%;\n  height: 100%;\n  overflow-y: scroll;\n}\n.file-preview-close:hover {\n  opacity: 1 !important;\n  font-weight: 600;\n}\n.padded-border-container {\n  border-color: #e0e0e0;\n  border-radius: .2857rem;\n  box-sizing: border-box;\n  color: #ffffff;\n  display: inline-block;\n  float: right;\n  font-weight: 700;\n  line-height: 1;\n  padding: .3em .6em;\n  text-align: center;\n}\n.l-app-content {\n  max-width: 1232px;\n  margin: 0 auto;\n  padding-top: 96px;\n  z-index: 0;\n}\n.l-app-content.l-app-profile-content {\n  padding: 0px 16px 0px 16px;\n}\n.l-left-nav-with-content {\n  width: 100%;\n  height: 100%;\n}\n.l-left-nav-with-content .l-left-nav {\n  background-color: #ffffff;\n  width: 256px;\n  height: 100%;\n  float: left;\n  clear: both;\n  display: inline-block;\n  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);\n  position: fixed;\n  margin-top: -96px;\n}\n.l-left-nav-with-content .l-left-nav-content {\n  width: calc(100% - 256px);\n  padding-left: 32px;\n  float: right;\n  display: inline-block;\n}\n.l-paper-left {\n  position: relative;\n  width: 25%;\n  padding-right: 6.25px;\n  float: left;\n  clear: both;\n  display: inline-block;\n}\n.l-paper-left:hover .tc-icon-delete {\n  visibility: visible;\n  z-index: 5;\n  opacity: 1;\n}\n.l-paper-left .short-description {\n  line-height: 12px;\n}\n.l-paper-right {\n  position: relative;\n  width: calc(100% - 25%);\n  padding-left: 6.25px;\n  clear: both;\n  display: inline-block;\n}\n.l-paper-right p {\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n.l-paper-right .multi-select-paragraph {\n  margin-top: -6.25px;\n}\n.l-paper-split-form {\n  width: 100%;\n  position: relative;\n}\n.l-paper-split-form.textarea {\n  padding: 20px 0px;\n}\n.l-paper-split-form .l-paper-left {\n  line-height: 64px;\n  max-height: 64px;\n}\n.l-paper-split-form.image .l-paper-left {\n  width: 35%;\n  float: inherit;\n  max-height: inherit;\n  line-height: inherit;\n}\n.l-paper-split-form.image .l-paper-right {\n  width: 65%;\n  vertical-align: top;\n}\n.Grid {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.Grid-cell {\n  flex: 1;\n}\n.Grid--flexCells > .Grid-cell {\n  display: flex;\n}\n.Grid--top {\n  align-items: flex-start;\n}\n.Grid--bottom {\n  align-items: flex-end;\n}\n.Grid--center {\n  align-items: center;\n}\n.Grid--justifyCenter {\n  justify-content: center;\n}\n.Grid-cell--top {\n  align-self: flex-start;\n}\n.Grid-cell--bottom {\n  align-self: flex-end;\n}\n.Grid-cell--center {\n  align-self: center;\n}\n.Grid-cell--autoSize {\n  flex: none;\n}\n.Grid--fit > .Grid-cell {\n  flex: 1;\n}\n.Grid--full > .Grid-cell {\n  flex: 0 0 100%;\n}\n.Grid--1of2 > .Grid-cell {\n  flex: 0 0 50%;\n}\n.Grid--1of3 > .Grid-cell {\n  flex: 0 0 33.3333%;\n}\n.Grid--1of4 > .Grid-cell {\n  flex: 0 0 25%;\n}\n@media (--break-sm) {\n  .small-Grid--fit > .Grid-cell {\n    flex: 1;\n  }\n  .small-Grid--full > .Grid-cell {\n    flex: 0 0 100%;\n  }\n  .small-Grid--1of2 > .Grid-cell {\n    flex: 0 0 50%;\n  }\n  .small-Grid--1of3 > .Grid-cell {\n    flex: 0 0 33.3333%;\n  }\n  .small-Grid--1of4 > .Grid-cell {\n    flex: 0 0 25%;\n  }\n}\n@media (--break-md) {\n  .med-Grid--fit > .Grid-cell {\n    flex: 1;\n  }\n  .med-Grid--full > .Grid-cell {\n    flex: 0 0 100%;\n  }\n  .med-Grid--1of2 > .Grid-cell {\n    flex: 0 0 50%;\n  }\n  .med-Grid--1of3 > .Grid-cell {\n    flex: 0 0 33.3333%;\n  }\n  .med-Grid--1of4 > .Grid-cell {\n    flex: 0 0 25%;\n  }\n}\n@media (--break-lg) {\n  .large-Grid--fit > .Grid-cell {\n    flex: 1;\n  }\n  .large-Grid--full > .Grid-cell {\n    flex: 0 0 100%;\n  }\n  .large-Grid--1of2 > .Grid-cell {\n    flex: 0 0 50%;\n  }\n  .large-Grid--1of3 > .Grid-cell {\n    flex: 0 0 33.3333%;\n  }\n  .large-Grid--1of4 > .Grid-cell {\n    flex: 0 0 25%;\n  }\n}\n.Grid--gutters {\n  margin: -1em 0 1em -1em;\n}\n.Grid--gutters > .Grid-cell {\n  padding: 1em 0 0 1em;\n}\n.Grid--guttersLg {\n  margin: -1.5em 0 1.5em -1.5em;\n}\n.Grid--guttersLg > .Grid-cell {\n  padding: 1.5em 0 0 1.5em;\n}\n.Grid--guttersXl {\n  margin: -2em 0 2em -2em;\n}\n.Grid--guttersXl > .Grid-cell {\n  padding: 2em 0 0 2em;\n}\n@media (--break-sm) {\n  .small-Grid--gutters {\n    margin: -1em 0 1em -1em;\n  }\n  .small-Grid--gutters > .Grid-cell {\n    padding: 1em 0 0 1em;\n  }\n  .small-Grid--guttersLg {\n    margin: -1.5em 0 1.5em -1.5em;\n  }\n  .small-Grid--guttersLg > .Grid-cell {\n    padding: 1.5em 0 0 1.5em;\n  }\n  .small-Grid--guttersXl {\n    margin: -2em 0 2em -2em;\n  }\n  .small-Grid--guttersXl > .Grid-cell {\n    padding: 2em 0 0 2em;\n  }\n}\n@media (--break-md) {\n  .med-Grid--gutters {\n    margin: -1em 0 1em -1em;\n  }\n  .med-Grid--gutters > .Grid-cell {\n    padding: 1em 0 0 1em;\n  }\n  .med-Grid--guttersLg {\n    margin: -1.5em 0 1.5em -1.5em;\n  }\n  .med-Grid--guttersLg > .Grid-cell {\n    padding: 1.5em 0 0 1.5em;\n  }\n  .med-Grid--guttersXl {\n    margin: -2em 0 2em -2em;\n  }\n  .med-Grid--guttersXl > .Grid-cell {\n    padding: 2em 0 0 2em;\n  }\n}\n@media (--break-lg) {\n  .large-Grid--gutters {\n    margin: -1em 0 1em -1em;\n  }\n  .large-Grid--gutters > .Grid-cell {\n    padding: 1em 0 0 1em;\n  }\n  .large-Grid--guttersLg {\n    margin: -1.5em 0 1.5em -1.5em;\n  }\n  .large-Grid--guttersLg > .Grid-cell {\n    padding: 1.5em 0 0 1.5em;\n  }\n  .large-Grid--guttersXl {\n    margin: -2em 0 2em -2em;\n  }\n  .large-Grid--guttersXl > .Grid-cell {\n    padding: 2em 0 0 2em;\n  }\n}\ndiv.filepicker {\n  background-color: #E1E1E1;\n  border-radius: 5px;\n  border: 2px dashed #C7C7C7;\n  min-height: 60px;\n  padding: 5px;\n  text-align: center;\n}\n.filepicker-file-icon {\n  color: black;\n  display: inline-block;\n  margin: 1.5em 0 2.5em 0;\n  padding-left: 45px;\n  position: relative;\n}\n.filepicker-file-icon::before {\n  border-radius: 2px;\n  border: solid 2px #7F7F7F;\n  content: '';\n  height: 34px;\n  left: 0;\n  position: absolute;\n  top: -7px;\n  width: 29px;\n}\n.filepicker-file-icon::after {\n  background-color: #000000;\n  color: #ffffff;\n  content: 'file';\n  content: attr(data-filetype);\n  font-size: 11px;\n  left: -4px;\n  letter-spacing: 1px;\n  line-height: 1.3;\n  padding: 0 2px;\n  position: absolute;\n  text-align: right;\n  text-transform: uppercase;\n  top: 9px;\n}\n.filepicker-file-icon .fileCorner {\n  border-color: white transparent transparent #920035;\n  border-style: solid;\n  border-width: 11px 0 0 11px;\n  height: 0;\n  left: 22px;\n  position: absolute;\n  top: -7px;\n  width: 0;\n}\n.dz-error-mark {\n  display: none;\n  visibility: hidden;\n}\n.dz-error-message {\n  display: none;\n  visibility: hidden;\n}\n@-webkit-keyframes passing-through {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n  }\n  30% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n  }\n  70% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-40px);\n  }\n}\n@keyframes passing-through {\n  0% {\n    opacity: 0;\n    transform: translateY(40px);\n  }\n  10% {\n    transform: scale(1.1);\n  }\n  20% {\n    transform: scale(1);\n  }\n}\n@-webkit-keyframes slide-in {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n  }\n  30% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n  }\n  70% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-40px);\n  }\n}\n@keyframes slide-in {\n  0% {\n    opacity: 0;\n    transform: translateY(40px);\n  }\n  10% {\n    transform: scale(1.1);\n  }\n  20% {\n    transform: scale(1);\n  }\n}\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n  }\n  30% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n  }\n  70% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-40px);\n  }\n}\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  10% {\n    transform: scale(1.1);\n  }\n  20% {\n    transform: scale(1);\n  }\n}\n.dropzone {\n  background: white;\n  border: 2px solid rgba(0, 0, 0, 0.3);\n  box-sizing: border-box;\n  min-height: 150px;\n  padding: 20px 20px;\n}\n.dropzone * {\n  box-sizing: border-box;\n}\n.dropzone .dz-message {\n  margin: 2em 0;\n  text-align: center;\n}\n.dropzone .dz-preview {\n  display: inline-block;\n  margin: 16px;\n  min-height: 100px;\n  position: relative;\n  vertical-align: top;\n}\n.dropzone .dz-preview:hover {\n  z-index: 1000;\n}\n.dropzone .dz-preview:hover .dz-details {\n  opacity: 1;\n}\n.dropzone .dz-preview:hover .dz-image img {\n  -moz-transform: scale(1.05, 1.05);\n  -ms-transform: scale(1.05, 1.05);\n  -o-transform: scale(1.05, 1.05);\n  -webkit-filter: blur(8px);\n  -webkit-transform: scale(1.05, 1.05);\n  filter: blur(8px);\n  transform: scale(1.05, 1.05);\n}\n.dropzone .dz-preview .dz-remove {\n  border: none;\n  cursor: pointer;\n  display: block;\n  font-size: 14px;\n  text-align: center;\n}\n.dropzone .dz-preview .dz-remove:hover {\n  text-decoration: underline;\n}\n.dropzone .dz-preview .dz-details {\n  color: rgba(0, 0, 0, 0.9);\n  font-size: 13px;\n  left: 0;\n  line-height: 150%;\n  max-width: 100%;\n  min-width: 100%;\n  opacity: 0;\n  padding: 2em 1em;\n  position: absolute;\n  text-align: center;\n  top: 0;\n  z-index: 20;\n}\n.dropzone .dz-preview .dz-details .dz-size {\n  font-size: 16px;\n  margin-bottom: 1em;\n}\n.dropzone .dz-preview .dz-details .dz-size span {\n  background-color: rgba(255, 255, 255, 0.4);\n  border-radius: 3px;\n  padding: 0 0.4em;\n}\n.dropzone .dz-preview .dz-details .dz-filename {\n  white-space: nowrap;\n}\n.dropzone .dz-preview .dz-details .dz-filename:hover span {\n  background-color: rgba(255, 255, 255, 0.8);\n  border: 1px solid rgba(200, 200, 200, 0.8);\n}\n.dropzone .dz-preview .dz-details .dz-filename:not(hover) {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dropzone .dz-preview .dz-details .dz-filename:not(hover) span {\n  border: 1px solid transparent;\n}\n.dropzone .dz-preview .dz-details .dz-filename span {\n  background-color: rgba(255, 255, 255, 0.4);\n  border-radius: 3px;\n  padding: 0 0.4em;\n}\n.dropzone .dz-preview .dz-image {\n  border-radius: 20px;\n  display: block;\n  height: 120px;\n  overflow: hidden;\n  position: relative;\n  width: 120px;\n  z-index: 10;\n}\n.dropzone .dz-preview .dz-image img {\n  display: block;\n}\n.dropzone .dz-preview .dz-success-mark {\n  display: block;\n  left: 50%;\n  margin-left: -27px;\n  margin-top: -27px;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  z-index: 500;\n}\n.dropzone .dz-preview .dz-success-mark svg {\n  display: block;\n  height: 54px;\n  width: 54px;\n}\n.dropzone .dz-preview .dz-error-mark {\n  display: block;\n  left: 50%;\n  margin-left: -27px;\n  margin-top: -27px;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  z-index: 500;\n}\n.dropzone .dz-preview .dz-error-mark svg {\n  display: block;\n  height: 54px;\n  width: 54px;\n}\n.dropzone .dz-preview:not(.dz-processing) .dz-progress {\n  -moz-animation: pulse 6s ease infinite;\n  -ms-animation: pulse 6s ease infinite;\n  -o-animation: pulse 6s ease infinite;\n  -webkit-animation: pulse 6s ease infinite;\n  animation: pulse 6s ease infinite;\n}\n.dropzone .dz-preview .dz-progress {\n  -webkit-transform: scale(1);\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 8px;\n  height: 16px;\n  left: 50%;\n  margin-left: -40px;\n  margin-top: -8px;\n  opacity: 1;\n  overflow: hidden;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  width: 80px;\n  z-index: 1000;\n}\n.dropzone .dz-preview .dz-progress .dz-upload {\n  -moz-transition: width 300ms ease-in-out;\n  -ms-transition: width 300ms ease-in-out;\n  -o-transition: width 300ms ease-in-out;\n  -webkit-transition: width 300ms ease-in-out;\n  background: #333333;\n  background: linear-gradient(to bottom, #666666, #444444);\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  top: 0;\n  transition: width 300ms ease-in-out;\n  width: 0;\n}\n.dropzone .dz-preview .dz-error-message {\n  -moz-transition: opacity 0.3s ease;\n  -ms-transition: opacity 0.3s ease;\n  -o-transition: opacity 0.3s ease;\n  -webkit-transition: opacity 0.3s ease;\n  background: #be2626;\n  background: linear-gradient(to bottom, #be2626, #a92222);\n  border-radius: 8px;\n  color: white;\n  display: block;\n  display: none;\n  font-size: 13px;\n  left: -10px;\n  opacity: 0;\n  padding: 0.5em 1.2em;\n  pointer-events: none;\n  position: absolute;\n  top: 130px;\n  transition: opacity 0.3s ease;\n  width: 140px;\n  z-index: 1000;\n}\n.dropzone .dz-preview .dz-error-message:after {\n  border-bottom: 6px solid #be2626;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  content: '';\n  height: 0;\n  left: 64px;\n  position: absolute;\n  top: -6px;\n  width: 0;\n}\n.dropzone .dz-preview.dz-file-preview .dz-image {\n  background: #999999;\n  background: linear-gradient(to bottom, #eeeeee, #dddddd);\n  border-radius: 20px;\n}\n.dropzone .dz-preview.dz-file-preview .dz-details {\n  opacity: 1;\n}\n.dropzone .dz-preview.dz-image-preview {\n  background: white;\n}\n.dropzone .dz-preview.dz-image-preview .dz-details {\n  -moz-transition: opacity 0.2s linear;\n  -ms-transition: opacity 0.2s linear;\n  -o-transition: opacity 0.2s linear;\n  -webkit-transition: opacity 0.2s linear;\n  transition: opacity 0.2s linear;\n}\n.dropzone .dz-preview.dz-success .dz-success-mark {\n  -moz-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -ms-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -webkit-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n  animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n}\n.dropzone .dz-preview.dz-error .dz-error-mark {\n  -moz-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -ms-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -webkit-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n  animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n  opacity: 1;\n}\n.dropzone .dz-preview.dz-error .dz-error-message {\n  display: block;\n}\n.dropzone .dz-preview.dz-error:hover .dz-error-message {\n  opacity: 1;\n  pointer-events: auto;\n}\n.dropzone .dz-preview.dz-processing .dz-progress {\n  -moz-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  -webkit-transition: all 0.2s linear;\n  opacity: 1;\n  transition: all 0.2s linear;\n}\n.dropzone .dz-preview.dz-complete .dz-progress {\n  -moz-transition: opacity 0.4s ease-in;\n  -ms-transition: opacity 0.4s ease-in;\n  -o-transition: opacity 0.4s ease-in;\n  -webkit-transition: opacity 0.4s ease-in;\n  opacity: 0;\n  transition: opacity 0.4s ease-in;\n}\n.dropzone.dz-clickable {\n  cursor: pointer;\n}\n.dropzone.dz-clickable * {\n  cursor: default;\n}\n.dropzone.dz-clickable .dz-message {\n  cursor: pointer;\n}\n.dropzone.dz-clickable .dz-message * {\n  cursor: pointer;\n}\n.dropzone.dz-started .dz-message {\n  display: none;\n}\n.dropzone.dz-drag-hover {\n  border-style: solid;\n}\n.dropzone.dz-drag-hover .dz-message {\n  opacity: 0.5;\n}\n.full-screen-page {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 4;\n  top: 0;\n  left: 0;\n  background-color: white;\n  overflow-x: hidden;\n}\n.Select-placeholder {\n  font-size: 12px;\n  padding: 0 5px;\n}\n.with-tooltip {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n.with-tooltip .tooltiptext {\n  visibility: hidden;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px;\n  position: absolute;\n  z-index: 1;\n  top: 120%;\n  left: 100%;\n  margin-left: -50px;\n}\n.with-tooltip .tooltiptext::after {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  left: 30px;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent transparent rgba(0, 0, 0, 0.5) transparent;\n}\n.with-tooltip:hover .tooltiptext {\n  visibility: visible;\n  -moz-transition: all 500ms ease-in-out;\n  -ms-transition: all 500ms ease-in-out;\n  -o-transition: all 500ms ease-in-out;\n  -webkit-transition: all 500ms ease-in-out;\n  transition: all 500ms ease-in-out;\n}\n.left-arrow-bubble {\n  position: relative;\n  width: 100%;\n  padding: 0px;\n  background: #FFFFFF;\n  border: #d5dee3 solid 0.5px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  border-radius: 6px;\n}\n.left-arrow-bubble:after {\n  content: \"\";\n  position: absolute;\n  top: 9px;\n  right: 99.9%;\n  border-style: solid;\n  border-width: 6px;\n  border-color: transparent #FFFFFF transparent transparent;\n  display: block;\n  width: 0;\n  z-index: 1;\n}\n.message-div p {\n  margin-bottom: 8px;\n  padding-top: 1px;\n}\n.left-arrow-bubble:before {\n  content: \"\";\n  position: absolute;\n  top: 8px;\n  right: 100%;\n  border-style: solid;\n  border-width: 7px;\n  border-color: transparent #d5dee3 transparent transparent ;\n  display: block;\n  width: 0;\n  z-index: 0;\n}\n.right-arrow-bubble {\n  position: relative;\n  width: 100%;\n  padding: 0px;\n  background: #edf9ff;\n  border: #c7dce7 solid 0.5px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  border-radius: 6px;\n}\n.right-arrow-bubble:after {\n  content: \"\";\n  position: absolute;\n  top: 9px;\n  left: 99.9%;\n  border-style: solid;\n  border-width: 6px;\n  border-color: transparent transparent transparent #edf9ff;\n  display: block;\n  width: 0;\n  z-index: 1;\n}\n.right-arrow-bubble:before {\n  content: \"\";\n  position: absolute;\n  top: 8px;\n  left: 100%;\n  border-style: solid;\n  border-width: 7px;\n  border-color: transparent transparent transparent #c7dce7;\n  display: block;\n  width: 0;\n}\n.right-arrow-box {\n  position: relative;\n  width: 100%;\n  padding: 0px;\n  border-left: #e0e0e0 solid 0.5px;\n}\n.right-arrow-box:after {\n  content: \"\";\n  position: absolute;\n  top: 43.5%;\n  left: 99.9%;\n  border-style: solid;\n  border-width: 6px;\n  border-color: transparent transparent transparent white;\n  display: block;\n  width: 0;\n  z-index: 1;\n}\n.right-arrow-box:before {\n  content: \"\";\n  position: absolute;\n  top: 43%;\n  left: 100%;\n  border-style: solid;\n  border-width: 7px;\n  border-color: transparent transparent transparent #e0e0e0;\n  display: block;\n  width: 0;\n}\n.supplier-step-done {\n  border-bottom: 4px solid #00897b !important;\n}\n.buyer-step-done {\n  border-bottom: 4px solid #ff6f00 !important;\n}\n.loaded-step-done {\n  background-color: #ff6f00 !important;\n  color: white;\n}\n.flag-across-progress-bar {\n  font-size: 9px;\n  font-weight: bold;\n  height: 14px;\n  line-height: 14px;\n  text-align: center;\n  padding: 0 8px;\n  text-transform: uppercase;\n  color: white;\n}\n", ""]);

// exports


/***/ }),

/***/ 479:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),

/***/ 48:
/***/ (function(module, exports) {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "357860c5ec857a9ecfb5b19cf27bd204.ttf";

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "51cb4a6f77048ff7f54bba6d754fe419.woff";

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b08cfa2e5e2b0238f94b35749e53493a.svg";

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0;

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function createStyleElement() {
	var styleElement = document.createElement("style");
	var head = getHeadElement();
	styleElement.type = "text/css";
	head.appendChild(styleElement);
	return styleElement;
}

function createLinkElement() {
	var linkElement = document.createElement("link");
	var head = getHeadElement();
	linkElement.rel = "stylesheet";
	head.appendChild(linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement());
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement();
		update = updateLink.bind(null, styleElement);
		remove = function() {
			styleElement.parentNode.removeChild(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement();
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			styleElement.parentNode.removeChild(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;
	var sourceMap = obj.sourceMap;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var media = obj.media;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return qEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeName;
/* harmony export (immutable) */ __webpack_exports__["a"] = fsmIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(64);


var done = { done: true, value: undefined };
var qEnd = {};

function safeName(patternOrChannel) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestAccessFromAdmin = exports.triggerError = exports.clearStore = undefined;

var _globalErrorsDisplayConstants = __webpack_require__(861);

var constants = _interopRequireWildcard(_globalErrorsDisplayConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var clearStore = exports.clearStore = function clearStore() {
  return {
    type: constants.CLEAR_STORE
  };
};

// payload is an object, and it has to include errorMessage in it
var triggerError = exports.triggerError = function triggerError(payload) {
  return {
    type: constants.ERROR_TRIGGERED,
    payload: payload
  };
};

var requestAccessFromAdmin = exports.requestAccessFromAdmin = function requestAccessFromAdmin(payload) {
  return function (dispatch) {
    dispatch({ type: constants.REQUEST_ACCESS_STARTED });
    return fetch('/proxy/userManagement/requestAccess', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json();
    }).then(function (response) {
      if (response.error) return dispatch({ type: constants.REQUEST_ACCESS_FAILED, payload: response.error });
      return dispatch({ type: constants.REQUESTED_ACCESS });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.REQUEST_ACCESS_FAILED });
    });
  };
};

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(592)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var external = __webpack_require__(218);
var DataWorker = __webpack_require__(596);
var DataLengthProbe = __webpack_require__(597);
var Crc32Probe = __webpack_require__(598);
var DataLengthProbe = __webpack_require__(597);

/**
 * Represent a compressed object, with everything needed to decompress it.
 * @constructor
 * @param {number} compressedSize the size of the data compressed.
 * @param {number} uncompressedSize the size of the data after decompression.
 * @param {number} crc32 the crc32 of the decompressed file.
 * @param {object} compression the type of compression, see lib/compressions.js.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the compressed data.
 */
function CompressedObject(compressedSize, uncompressedSize, crc32, compression, data) {
    this.compressedSize = compressedSize;
    this.uncompressedSize = uncompressedSize;
    this.crc32 = crc32;
    this.compression = compression;
    this.compressedContent = data;
}

CompressedObject.prototype = {
    /**
     * Create a worker to get the uncompressed content.
     * @return {GenericWorker} the worker.
     */
    getContentWorker : function () {
        var worker = new DataWorker(external.Promise.resolve(this.compressedContent))
        .pipe(this.compression.uncompressWorker())
        .pipe(new DataLengthProbe("data_length"));

        var that = this;
        worker.on("end", function () {
            if(this.streamInfo['data_length'] !== that.uncompressedSize) {
                throw new Error("Bug : uncompressed data size mismatch");
            }
        });
        return worker;
    },
    /**
     * Create a worker to get the compressed content.
     * @return {GenericWorker} the worker.
     */
    getCompressedWorker : function () {
        return new DataWorker(external.Promise.resolve(this.compressedContent))
        .withStreamInfo("compressedSize", this.compressedSize)
        .withStreamInfo("uncompressedSize", this.uncompressedSize)
        .withStreamInfo("crc32", this.crc32)
        .withStreamInfo("compression", this.compression)
        ;
    }
};

/**
 * Chain the given worker with other workers to compress the content with the
 * given compresion.
 * @param {GenericWorker} uncompressedWorker the worker to pipe.
 * @param {Object} compression the compression object.
 * @param {Object} compressionOptions the options to use when compressing.
 * @return {GenericWorker} the new worker compressing the content.
 */
CompressedObject.createWorkerFrom = function (uncompressedWorker, compression, compressionOptions) {
    return uncompressedWorker
    .pipe(new Crc32Probe())
    .pipe(new DataLengthProbe("uncompressedSize"))
    .pipe(compression.compressWorker(compressionOptions))
    .pipe(new DataLengthProbe("compressedSize"))
    .withStreamInfo("compression", compression);
};

module.exports = CompressedObject;


/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      var t = R.always('Tee');
 *      t(); //=> 'Tee'
 */
module.exports = _curry1(function always(val) {
  return function() {
    return val;
  };
});


/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);

/**
 * The following functions come from pako, from pako/lib/zlib/crc32.js
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */

// Use ordinary array, since untyped makes no boost here
function makeTable() {
    var c, table = [];

    for(var n =0; n < 256; n++){
        c = n;
        for(var k =0; k < 8; k++){
            c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
        }
        table[n] = c;
    }

    return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
    var t = crcTable, end = pos + len;

    crc = crc ^ (-1);

    for (var i = pos; i < end; i++ ) {
        crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
    }

    return (crc ^ (-1)); // >>> 0;
}

// That's all for the pako functions.

/**
 * Compute the crc32 of a string.
 * This is almost the same as the function crc32, but for strings. Using the
 * same function for the two use cases leads to horrible performances.
 * @param {Number} crc the starting value of the crc.
 * @param {String} str the string to use.
 * @param {Number} len the length of the string.
 * @param {Number} pos the starting position for the crc32 computation.
 * @return {Number} the computed crc32.
 */
function crc32str(crc, str, len, pos) {
    var t = crcTable, end = pos + len;

    crc = crc ^ (-1);

    for (var i = pos; i < end; i++ ) {
        crc = (crc >>> 8) ^ t[(crc ^ str.charCodeAt(i)) & 0xFF];
    }

    return (crc ^ (-1)); // >>> 0;
}

module.exports = function crc32wrapper(input, crc) {
    if (typeof input === "undefined" || !input.length) {
        return 0;
    }

    var isArray = utils.getTypeOf(input) !== "string";

    if(isArray) {
        return crc32(crc|0, input, input.length, 0);
    } else {
        return crc32str(crc|0, input, input.length, 0);
    }
};
// vim: set shiftwidth=4 softtabstop=4:


/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roundDownToNearest = exports.roundUpToNearest = exports.roundToNearest = undefined;

var _roundTo = __webpack_require__(610);

var _roundTo2 = _interopRequireDefault(_roundTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var roundToNearest = function roundToNearest(num) {
  var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var newNum = Number(num);
  var incre = 100 / cents;
  return Math.round(newNum * incre) / incre;
};

var roundUpToNearest = function roundUpToNearest(num) {
  var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var newNum = Number(num);
  var incre = 100 / cents;
  return Math.ceil(newNum * incre) / incre;
};

var roundDownToNearest = function roundDownToNearest(num) {
  var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var newNum = Number(num);
  var incre = 100 / cents;
  return Math.floor(newNum * incre) / incre;
};

exports.roundToNearest = roundToNearest;
exports.roundUpToNearest = roundUpToNearest;
exports.roundDownToNearest = roundDownToNearest;

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _curry2 = __webpack_require__(1);
var _isPlaceholder = __webpack_require__(70);


/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
module.exports = function _curry3(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return _isPlaceholder(a) ? f3
             : _curry2(function(_b, _c) { return fn(a, _b, _c); });
      case 2:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f3
             : _isPlaceholder(a) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
             : _isPlaceholder(b) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
             : _curry1(function(_c) { return fn(a, b, _c); });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3
             : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function(_a, _b) { return fn(_a, _b, c); })
             : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
             : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b, c); })
             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b, c); })
             : _isPlaceholder(c) ? _curry1(function(_c) { return fn(a, b, _c); })
             : fn(a, b, c);
    }
  };
};


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */
module.exports = _curry2(function max(a, b) { return b > a ? b : a; });


/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var updateProps = exports.updateProps = function updateProps(type) {
  return 'UPDATE_PROPS_IN_MESSAGING_' + type.toUpperCase();
};

var LOADING_LIST = exports.LOADING_LIST = '[inbox]LOADING_CONVERSATION_LIST';
var LIST_LOADED = exports.LIST_LOADED = '[inbox]CONVERSATION_LIST_LOADED';

var LOADING_MSGS = exports.LOADING_MSGS = '[inbox]LOADING_MSGS_IN_MESSAGING';
var MSGS_LOADED_INITIALLY = exports.MSGS_LOADED_INITIALLY = '[inbox]MSGS_LOADED_INITIALLY_IN_MESSAGING';

var CREATING_CONTRACT = exports.CREATING_CONTRACT = '[inbox]CREATING_CONTRACT_IN_MESSAGING';
var CONTRACT_CREATED = exports.CONTRACT_CREATED = '[inbox]CONTRACT_CREATED_IN_MESSAGING';
var CREATE_CONTRACT_FAILED = exports.CREATE_CONTRACT_FAILED = '[inbox]CREATE_CONTRACT_FAILED_IN_MESSAGING';

var TOGGLE_CONV_DONESS = exports.TOGGLE_CONV_DONESS = '[inbox]TOGGLE_CONV_DONESS_IN_MESSAGING';
var TOGGLE_CONV_DONESS_SUCCESS = exports.TOGGLE_CONV_DONESS_SUCCESS = '[inbox]TOGGLE_CONV_DONESS_IN_MESSAGING_SUCCESS';

var GET_PARTNERS = exports.GET_PARTNERS = '[inbox]GET_PARTNERS';

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(10).Buffer
var Transform = __webpack_require__(229).Transform
var inherits = __webpack_require__(8)

function throwIfNotStringOrBuffer (val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer')
  }
}

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data')
  if (this._finalized) throw new Error('Digest already called')
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase


/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(8)
var Hash = __webpack_require__(122)
var Buffer = __webpack_require__(10).Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(8)
var Hash = __webpack_require__(122)
var Buffer = __webpack_require__(10).Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(8)
var Legacy = __webpack_require__(664)
var Base = __webpack_require__(87)
var Buffer = __webpack_require__(10).Buffer
var md5 = __webpack_require__(511)
var RIPEMD160 = __webpack_require__(241)

var sha = __webpack_require__(242)

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}


/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

var MD5 = __webpack_require__(240)

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}


/***/ }),

/***/ 512:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

exports.pbkdf2 = __webpack_require__(666)
exports.pbkdf2Sync = __webpack_require__(516)


/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

function checkBuffer (buf, name) {
  if (typeof buf !== 'string' && !Buffer.isBuffer(buf)) {
    throw new TypeError(name + ' must be a buffer or string')
  }
}

module.exports = function (password, salt, iterations, keylen) {
  checkBuffer(password, 'Password')
  checkBuffer(salt, 'Salt')

  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var defaultEncoding
/* istanbul ignore next */
if (process.browser) {
  defaultEncoding = 'utf-8'
} else {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
}
module.exports = defaultEncoding

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

var md5 = __webpack_require__(511)
var RIPEMD160 = __webpack_require__(241)
var sha = __webpack_require__(242)

var checkParameters = __webpack_require__(514)
var defaultEncoding = __webpack_require__(515)
var Buffer = __webpack_require__(10).Buffer
var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(password, salt, iterations, keylen)

  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2


/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(136)
var Buffer = __webpack_require__(10).Buffer
var incr32 = __webpack_require__(518)

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),

/***/ 518:
/***/ (function(module, exports) {

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32


/***/ }),

/***/ 519:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(212)
var Buffer = __webpack_require__(10).Buffer
var Transform = __webpack_require__(87)
var inherits = __webpack_require__(8)
var GHASH = __webpack_require__(681)
var xor = __webpack_require__(136)
var incr32 = __webpack_require__(518)

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher


/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(212)
var Buffer = __webpack_require__(10).Buffer
var Transform = __webpack_require__(87)
var inherits = __webpack_require__(8)

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher


/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__(121);
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__(22);
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__(523);
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__(22);
var brorand = __webpack_require__(524);

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__(686);
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}


/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};


/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;


/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var common = __webpack_require__(137);
var shaCommon = __webpack_require__(526);
var assert = __webpack_require__(48);

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var common = __webpack_require__(137);
var assert = __webpack_require__(48);

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(8);
var Reporter = __webpack_require__(139).Reporter;
var Buffer = __webpack_require__(24).Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = checkStatus;
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  var error = new Error(response.statusText);
  error.response = response;
  throw error;
}

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__(718);


/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(8);

var asn1 = __webpack_require__(138);
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(8);
var Buffer = __webpack_require__(24).Buffer;

var asn1 = __webpack_require__(138);
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),

/***/ 533:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

var createHash = __webpack_require__(135)
var Buffer = __webpack_require__(10).Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}


/***/ }),

/***/ 535:
/***/ (function(module, exports) {

module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}


/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

var BN = __webpack_require__(22)
var Buffer = __webpack_require__(10).Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic


/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUsers = exports.loadPartners = exports.bulkDownloadS3File = exports.downloadFromUrl = exports.deleteFileFromS3 = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getContractingYears = getContractingYears;

var _http = __webpack_require__(118);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _jszip = __webpack_require__(587);

var _jszip2 = _interopRequireDefault(_jszip);

var _jszipUtils = __webpack_require__(606);

var _jszipUtils2 = _interopRequireDefault(_jszipUtils);

var _fileSaver = __webpack_require__(607);

var _docCookie = __webpack_require__(142);

var _docCookie2 = _interopRequireDefault(_docCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deleteFileFromS3 = exports.deleteFileFromS3 = function deleteFileFromS3(path) {
  return (0, _http.del)('/proxy/s3/file', { path: path }).then(_checkStatus2.default);
};
var downloadFromUrl = exports.downloadFromUrl = function downloadFromUrl(file) {
  return function () {
    // return window.open(`${apiUrl}/s3/file?key=${path}`);
    var a = document.createElement('a');
    a.download = file.fileName || file.name || '';
    a.target = '_blank';
    a.setAttribute('download', file.fileName || file.name);
    a.href = '/proxy/s3/file?key=' + encodeURIComponent(file.url || file.path);
    // firefox doesn't support `a.click()`...
    a.dispatchEvent(new MouseEvent('click'));
  };
};

var bulkDownloadS3File = exports.bulkDownloadS3File = function bulkDownloadS3File(files, zipName) {
  // IMPORTANT: file.path here does not include s3 url and s3bucket
  var zip = new _jszip2.default();
  var count = 0;
  files.forEach(function (file, fileIndex) {
    _jszipUtils2.default.getBinaryContent('/proxy/s3/file?key=' + encodeURIComponent(file.path || file.url), function (err, data) {
      if (!err) zip.file(fileIndex + 1 + '-' + (file.name || file.fileName), data, { binary: true });
      count++;
      if (count === files.length) {
        zip.generateAsync({ type: 'blob' }).then(function (content) {
          (0, _fileSaver.saveAs)(content, (zipName || 'TCFiles') + '.zip');
        });
      }
    });
  });
};

var loadPartners = exports.loadPartners = function loadPartners(loadingConstant, doneConstant) {
  return function (dispatch, getState) {
    if (loadingConstant) dispatch({ type: loadingConstant });
    return (0, _http.get)('/proxy/partners').then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      return dispatch({ type: doneConstant, payload: response });
    });
  };
};

var getUsers = exports.getUsers = function getUsers(companyId, constant) {
  return function (dispatch, getState) {
    return (0, _http.get)('/proxy/company/' + companyId + '/users').then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      return dispatch({ type: constant, payload: res });
    });
  };
};

function getContractingYears() {
  return function (dispatch) {
    dispatch({ type: 'GETTING_CONTRACTING_YEARS' });
    return fetch('/proxy/contracting/contractingYears', {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      dispatch({ type: 'GOT_CONTRACTING_YEARS', payload: response });
      if (response && response.length) {
        var startInCookie = _docCookie2.default.getItem('contractYearStartDate');
        var endInCookie = _docCookie2.default.getItem('contractYearEndDate');
        if (!(startInCookie && endInCookie)) {
          _docCookie2.default.setItem('contractYearStartDate', response[0].startDate, Infinity, '/');
          _docCookie2.default.setItem('contractYearEndDate', response[0].endDate, Infinity, '/');
          dispatch({ type: '[contracting]INIT_SELECTED_YEAR_FOR_CONTRACTING', payload: _extends({}, response[0], { firstLoad: true }) });
        } else {
          dispatch({ type: '[contracting]INIT_SELECTED_YEAR_FOR_CONTRACTING', payload: { startDate: startInCookie, endDate: endInCookie, firstLoad: true } });
        }
      } else {
        dispatch({ type: '[contracting]INIT_SELECTED_YEAR_FOR_CONTRACTING', payload: { startDate: '2018-04-01 00:00:00.000Z', endDate: '2019-03-31 00:00:00.000Z', firstLoad: true } });
      }
    });
  };
}

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(48);
var inherits = __webpack_require__(8);

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;


/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOADING_LIST = exports.LOADING_LIST = 'LOADING_CONTRACT_LIST_FROM_BACKEND';
var LOAD_LIST = exports.LOAD_LIST = 'LOAD_CONTRACT_LIST_FROM_BACKEND';
var UPDATE_PROPS = exports.UPDATE_PROPS = 'UPDATE_PROPS_IN_CONTRACT_LISTING';
var UPDATE_FOLDER_NAME = exports.UPDATE_FOLDER_NAME = '[contract-list]UPDATE_FOLDER_NAME';
var UPDATE_PARAMS = exports.UPDATE_PARAMS = '[contract-list]UPDATE_SEARCH_PARAMS';
var RESET_PARAMS = exports.RESET_PARAMS = '[contract-list]RESET_SEARCH_PARAMS';
var SHOW_FREE_CONTRACT_DIALOG = exports.SHOW_FREE_CONTRACT_DIALOG = 'SHOW_FREE_CONTRACT_DIALOG';
var SELECT_ONE_CONTRACT = exports.SELECT_ONE_CONTRACT = 'SELECT_ONE_CONTRACT_CONTRACT_LIST';
var MASS_ASSIGN_FOLDER = exports.MASS_ASSIGN_FOLDER = 'MASS_ASSIGN_FOLDER_CONTRACT_LIST';
var DELETE_FOLDER = exports.DELETE_FOLDER = 'DELETE_FOLDER_CONTRACT_LIST';
var CREATE_FOLDER = exports.CREATE_FOLDER = 'CREATE_FOLDER_CONTRACT_LIST';
var STATE_CHANGE = exports.STATE_CHANGE = 'STATE_CHANGE_CONTRACT_LIST';
var MARK_AS_RECEIVED = exports.MARK_AS_RECEIVED = 'MARK_AS_RECEIVED_CONTRACT_LIST';
var SELECT_CURRENT_ALL = exports.SELECT_CURRENT_ALL = 'SELECT_CURRENT_ALL_CONTRACT_LIST';
var MASS_DELETE_RESTORE = exports.MASS_DELETE_RESTORE = 'MASS_DELETE_RESTORE_CONTRACT_LIST';
var MASS_ARCHIVE_OR_RESTORE = exports.MASS_ARCHIVE_OR_RESTORE = '[contract-list] MASS_ARCHIVE_OR_RESTORE';
var DOWNLOADING_PDF_ZIP = exports.DOWNLOADING_PDF_ZIP = 'DOWNLOADING_PDF_ZIP_CONTRACT_LIST';
var PDF_ZIP_DOWNLOADED = exports.PDF_ZIP_DOWNLOADED = 'PDF_ZIP_DOWNLOADED_CONTRACT_LIST';
var TOGGLE_BULK_RESEND_DIALOG = exports.TOGGLE_BULK_RESEND_DIALOG = 'TOGGLE_BULK_RESEND_DIALOG_CONTRACT_LIST';
var POPULATE_BULK_RESEND = exports.POPULATE_BULK_RESEND = 'POPULATE_BULK_RESEND_DIALOG_CONTRACT_LIST';
var BULK_SENDING = exports.BULK_SENDING = 'BULK_SENDING_CONTRACTS_IN_CONTRACT_LIST';
var BULK_SEND_FINISHED = exports.BULK_SEND_FINISHED = 'BULK_SEND_FINISHED_IN_CONTRACT_LIST';
var UPDATE_BULK_RESEND_PROPS = exports.UPDATE_BULK_RESEND_PROPS = 'UPDATE_BULK_RESEND_PROPS_IN_CONTRACT_LIST';
var GET_CONTRACT_EMAIL = exports.GET_CONTRACT_EMAIL = '[contract-list]GET_CONTRACT_FORWARDING_EMAIL';
var LOAD_CONTRACT_LIST = exports.LOAD_CONTRACT_LIST = '[contract-list]LOAD_CONTRACT_LIST';
var GET_MORE_CONTRACT_INFO = exports.GET_MORE_CONTRACT_INFO = '[contract-list] GET_MORE_CONTRACT_INFO';

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleConvDone = exports.loadConvList = exports.initialLoadAMsg = exports.searchContractRequest = exports.addFilesToRequestsInDialog = exports.createContractWithFiles = exports.getPartners = exports.downloadFromUrl = exports.updateProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _http = __webpack_require__(118);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _messagingConstants = __webpack_require__(506);

var constants = _interopRequireWildcard(_messagingConstants);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateProps = exports.updateProps = function updateProps(type, payload) {
  return {
    type: constants.updateProps(type),
    payload: payload
  };
};
var downloadFromUrl = exports.downloadFromUrl = function downloadFromUrl(path) {
  return function (dispatch, getState) {
    var apiUrl = getState().config.get('apiUrl');
    return window.open(apiUrl + '/s3/file?key=' + encodeURIComponent(path));
  };
};

var getPartners = exports.getPartners = function getPartners(payload) {
  return function (dispatch) {
    dispatch({ type: constants.GET_PARTNERS + '_START' });
    return (0, _http.post)('/proxy/partner-management/partners', payload).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      dispatch({ type: constants.GET_PARTNERS + '_SUCCESS', payload: res });
    });
  };
};

var createContractWithFiles = exports.createContractWithFiles = function createContractWithFiles(payload) {
  return function (dispatch, getState) {
    dispatch({ type: constants.CREATING_CONTRACT });
    var messageId = getState().messaging.actionDialog.getIn(['msg', 'messageId']);
    return (0, _http.post)('/proxy/contracting/contractWithFiles', _ramda2.default.merge(payload, { messageId: messageId })).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      dispatch({ type: constants.CONTRACT_CREATED, payload: _ramda2.default.merge({ messageId: messageId }, res) });
      dispatch(initialLoadAMsg(messageId));
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.CREATE_CONTRACT_FAILED });
    });
  };
};

var addFilesToRequestsInDialog = exports.addFilesToRequestsInDialog = function addFilesToRequestsInDialog(request, files) {
  return function (dispatch, getState) {
    var messageId = getState().messaging.actionDialog.toJS().msg.messageId;

    return (0, _http.post)('/proxy/contracting/contract/files', {
      contractId: request._id,
      files: files,
      messageId: messageId
    }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function () {
      dispatch({
        type: constants.CONTRACT_CREATED,
        payload: _ramda2.default.merge(request, { messageId: messageId, files: files })
      });
      dispatch(initialLoadAMsg(messageId));
    });
  };
};

var searchContractRequest = exports.searchContractRequest = function searchContractRequest(payload) {
  return function (dispatch, getState) {
    dispatch(updateProps('ACTION_DIALOG', { searchingRequests: true }));
    return (0, _http.get)('/proxy/contracting/requests?' + _queryString2.default.stringify(_ramda2.default.merge(payload, {
      emails: JSON.stringify(payload.emails)
    }))).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      return dispatch({
        type: 'GOT_MATCHED_REQUESTS_FOR_ADD_FILE_TO_CONTRACT',
        payload: { requests: res, searchByInput: payload.searchInput }
      });
    }).catch(function (err) {
      console.log(err);
      dispatch(updateProps('ACTION_DIALOG', { searchingRequests: false }));
    });
  };
};

var initialLoadAMsg = exports.initialLoadAMsg = function initialLoadAMsg(messageId) {
  return function (dispatch) {
    dispatch({ type: constants.LOADING_MSGS, payload: true });
    return (0, _http.get)('/proxy/asset-activity/' + messageId).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      dispatch({
        type: constants.MSGS_LOADED_INITIALLY,
        payload: {
          conv: res,
          messages: [res],
          messagesLoaded: true,
          loadingMessages: false
        }
      });
      // mark read
      dispatch({
        type: '[workspace] CONVERSATIONS_READ_WITH_PARAMS',
        payload: {
          assetId: 'inbox',
          assetType: 'unassigned',
          messageId: res.messageId
        }
      });
    }).catch(function (err) {
      console.log('loadConvList', err);
      dispatch({ type: constants.LOADING_MSGS, payload: false });
    });
  };
};

var loadConvList = exports.loadConvList = function loadConvList(filter, loadFirstConv) {
  return function (dispatch) {
    dispatch({ type: constants.LOADING_LIST });
    dispatch(updateProps('CONVS', { selectedConv: {} }));
    return (0, _http.get)('/proxy/asset-activities/inbox?assetType=unassigned').then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      dispatch({ type: constants.LIST_LOADED, payload: res });
      if (res && res[0] && loadFirstConv) {
        // since now this area is only for self forwarding
        // one conv is one message from workspacemessages
        dispatch({
          type: constants.MSGS_LOADED_INITIALLY,
          payload: {
            conv: res[0],
            messages: [res[0]],
            messagesLoaded: true,
            loadingMessages: false
          }
        });
        dispatch({
          type: '[workspace] CONVERSATIONS_READ_WITH_PARAMS',
          payload: {
            assetId: 'inbox',
            assetType: 'unassigned',
            messageId: res[0].messageId
          }
        });
      }
    }).catch(function (err) {
      console.log('loadConvList', err);
      dispatch({ type: constants.LOADING_LIST });
    });
  };
};

var toggleConvDone = exports.toggleConvDone = function toggleConvDone(messageId, done) {
  return function (dispatch, getState) {
    dispatch({ type: constants.TOGGLE_CONV_DONESS, payload: { messageId: messageId, done: done } });
    return (0, _http.put)('/proxy/asset-activity/' + messageId, { assetId: 'inbox' }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      dispatch({
        type: constants.TOGGLE_CONV_DONESS_SUCCESS,
        payload: _extends({}, res, { messageId: messageId })
      });
    }).catch(function (err) {
      dispatch({ type: constants.TOGGLE_CONV_DONESS, payload: { messageId: messageId, done: !done } });
    });
  };
};

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContractForwardingEmail = exports.openResendContractDialog = exports.selectAContract = exports.resetSearchParams = exports.updateSearchParams = exports.updateProps = exports.updateBulkResendDialogProps = exports.bulkResend = exports.openBulkResendDialog = exports.closeBulkResendDialog = exports.moveToArchiveOrRestore = exports.moveToTrashOrRestore = exports.manageFolders = exports.getContractFolders = exports.stateChange = exports.selectCurrentAll = exports.getContractList = exports.markAsViewed = exports.downloadPdfZip = exports.downloadContractPdf = undefined;
exports.saveNewFolder = saveNewFolder;
exports.changeRoute = changeRoute;
exports.updateFolders = updateFolders;
exports.deleteFolder = deleteFolder;
exports.showFreeContractDialogAction = showFreeContractDialogAction;

var _contractListConstants = __webpack_require__(560);

var constants = _interopRequireWildcard(_contractListConstants);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _actions = __webpack_require__(537);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var callApiGet = function callApiGet(url) {
  return fetch(url, {
    method: 'get',
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
  }).then(_checkStatus2.default);
};
var callApiPut = function callApiPut(url, body) {
  return fetch(url, {
    method: 'put',
    body: body,
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
  }).then(_checkStatus2.default);
};
var callApiPost = function callApiPost(url, body) {
  return fetch(url, {
    method: 'post',
    body: body,
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
  }).then(_checkStatus2.default);
};
var callApiDelete = function callApiDelete(url, body) {
  return fetch(url, {
    method: 'delete',
    body: body,
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
  }).then(_checkStatus2.default);
};
var downloadContractPdf = exports.downloadContractPdf = function downloadContractPdf(_ref) {
  var docId = _ref.docId,
      contractIds = _ref.contractIds,
      files = _ref.files,
      zipFileName = _ref.zipFileName,
      zipNameWhenFileExists = _ref.zipNameWhenFileExists,
      anchorEl = _ref.anchorEl;
  return function (dispatch, getState) {
    if (files && files.length) {
      (0, _actions.bulkDownloadS3File)(files, zipNameWhenFileExists);
    } else {
      dispatch({
        type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
        payload: {
          docId: docId,
          contractIds: contractIds,
          zipFileName: zipFileName,
          collection: 'contract',
          anchorEl: anchorEl
        }
      });
    }
  };
};

var downloadPdfZip = exports.downloadPdfZip = function downloadPdfZip(event) {
  return function (dispatch, getState) {
    var contractIds = getState().contracting.contractList.get('selectedContracts').toJS();
    dispatch({
      type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
      payload: {
        contractIds: contractIds,
        collection: 'contract',
        anchorEl: event.currentTarget,
        isBulk: true
      }
    });
  };
};
var markAsViewed = exports.markAsViewed = function markAsViewed(contractId) {
  return callApiPut('/proxy/contracting/contractViewed/' + contractId, JSON.stringify({}));
};
var getContractList = exports.getContractList = function getContractList(doNotShowLoadingOverlay) {
  return {
    type: constants.LOAD_LIST,
    payload: !doNotShowLoadingOverlay
  };
};

var selectCurrentAll = exports.selectCurrentAll = function selectCurrentAll(payload) {
  return function (dispatch) {
    dispatch({ type: constants.LOADING_LIST, payload: true });
    return callApiPost('/proxy/contracting/contracts', JSON.stringify(_ramda2.default.merge(payload, { getContractIds: true }))).then(function (res) {
      return res.json();
    }).then(function (contractIds) {
      dispatch({ type: constants.SELECT_CURRENT_ALL, payload: { allContractIds: contractIds } });
      dispatch({ type: constants.LOADING_LIST, payload: false });
    }).catch(function (err) {
      dispatch({ type: constants.LOADING_LIST, payload: false });
      var permissionDenied = _ramda2.default.pathOr(0, ['response', 'status'], err) === 403;
      dispatch({
        type: 'GLOBAL_ERROR_TRIGGERED',
        payload: permissionDenied ? { noAccessDialog: true } : { errorMessage: 'Select all failed' }
      });
    });
  };
};
var stateChange = exports.stateChange = function stateChange(contractIds, newState) {
  return function (dispatch) {
    dispatch({ type: constants.LOADING_LIST, payload: true });
    return callApiPut('/proxy/contracting/updateContractStatus', JSON.stringify({ contractIds: contractIds, state: newState })).then(function () {
      dispatch({ type: constants.STATE_CHANGE, payload: { contractIds: contractIds, newState: newState } });
      dispatch({ type: constants.LOADING_LIST, payload: false });
    }).catch(function (err) {
      dispatch({ type: constants.LOADING_LIST, payload: false });
      var permissionDenied = _ramda2.default.pathOr(0, ['response', 'status'], err) === 403;
      dispatch({
        type: 'GLOBAL_ERROR_TRIGGERED',
        payload: permissionDenied ? { noAccessDialog: true, message: 'You will need write access in order to change contract status.' } : { errorMessage: 'Update status failed' }
      });
    });
  };
};

var getContractFolders = exports.getContractFolders = function getContractFolders() {
  return function (dispatch) {
    dispatch({ type: constants.UPDATE_PROPS, payload: { folderLoading: true } });
    return callApiGet('/proxy/contracting/contract-list/folder').then(function (res) {
      return res.json();
    }).then(function (res) {
      dispatch({
        type: constants.UPDATE_PROPS,
        payload: {
          folders: res.folders,
          hideContractInFolder: res.hideContractInFolder,
          folderLoading: false
        }
      });
    }).catch(function (err) {
      console.log(err.stack);
      dispatch({ type: constants.UPDATE_PROPS, payload: { folderLoading: false } });
    });
  };
};

var manageFolders = exports.manageFolders = function manageFolders(payload) {
  return function (dispatch) {
    return callApiPut('/proxy/contracting/old-assignFolder', JSON.stringify(payload)).then(function () {
      return dispatch({ type: constants.MASS_ASSIGN_FOLDER, payload: payload });
    }).catch(function (err) {
      var permissionDenied = _ramda2.default.pathOr(0, ['response', 'status'], err) === 403;
      dispatch({
        type: 'GLOBAL_ERROR_TRIGGERED',
        payload: permissionDenied ? { noAccessDialog: true, message: 'You will need write access in order to move contracts to folders.' } : { errorMessage: 'Move to folder failed.' }
      });
    });
  };
};

/*
 toTrash: Boolean
 */
var moveToTrashOrRestore = exports.moveToTrashOrRestore = function moveToTrashOrRestore(toTrash, contractIds) {
  return function (dispatch) {
    return callApiPut('/proxy/contracting/deleteOrUndelete', JSON.stringify({ contractIds: contractIds, state: toTrash })).then(function () {
      return dispatch({ type: constants.MASS_DELETE_RESTORE, payload: { contractIds: contractIds, state: toTrash } });
    }).catch(function (err) {
      var permissionDenied = _ramda2.default.pathOr(0, ['response', 'status'], err) === 403;
      dispatch({
        type: 'GLOBAL_ERROR_TRIGGERED',
        payload: permissionDenied ? { noAccessDialog: true, message: 'You will need write access in order to perform this action.' } : { errorMessage: toTrash ? 'Move to trash failed.' : 'Restore failed' }
      });
    });
  };
};

var moveToArchiveOrRestore = exports.moveToArchiveOrRestore = function moveToArchiveOrRestore(toArchived, contractIds) {
  return function (dispatch) {
    return callApiPut('/proxy/contracting/archiveOrUnarchive', JSON.stringify({ contractIds: contractIds, state: toArchived })).then(function () {
      return dispatch({ type: constants.MASS_ARCHIVE_OR_RESTORE, payload: { contractIds: contractIds, state: toArchived } });
    }).catch(function (err) {
      var permissionDenied = _ramda2.default.pathOr(0, ['response', 'status'], err) === 403;
      dispatch({
        type: 'GLOBAL_ERROR_TRIGGERED',
        payload: permissionDenied ? { noAccessDialog: true, message: 'You will need write access in order to perform this action.' } : { errorMessage: toArchived ? 'Move to archived failed.' : 'Restore failed' }
      });
    });
  };
};

function saveNewFolder(folderName) {
  return function (dispatch) {
    return callApiPost('/proxy/contracting/contract-list/folder', JSON.stringify({ folderName: folderName })).then(function () {
      return dispatch({ type: constants.CREATE_FOLDER, payload: folderName });
    }).catch(function (err) {
      var permissionDenied = _ramda2.default.pathOr(0, ['response', 'status'], err) === 403;
      dispatch({
        type: 'GLOBAL_ERROR_TRIGGERED',
        payload: permissionDenied ? { noAccessDialog: true } : { errorMessage: 'Create folder failed.' }
      });
    });
  };
}
function changeRoute(routeName, isFolder) {
  return { type: '[contract-list]CHANGE_ROUTE', payload: { routeName: routeName, isFolder: isFolder } };
}
function updateFolders(_ref2) {
  var folders = _ref2.folders,
      originalFolder = _ref2.originalFolder,
      newFolderName = _ref2.newFolderName;

  return { type: constants.UPDATE_FOLDER_NAME, payload: { folders: folders, originalFolder: originalFolder, newFolderName: newFolderName } };
}

function deleteFolder(folderName) {
  return function (dispatch) {
    return callApiDelete('/proxy/contracting/contract-list/folder', JSON.stringify({ folderName: folderName })).then(function () {
      return dispatch({ type: constants.DELETE_FOLDER, payload: folderName });
    }).catch(function (err) {
      var permissionDenied = _ramda2.default.pathOr(0, ['response', 'status'], err) === 403;
      dispatch({
        type: 'GLOBAL_ERROR_TRIGGERED',
        payload: permissionDenied ? { noAccessDialog: true } : { errorMessage: 'Delete folder failed.' }
      });
    });
  };
};

function showFreeContractDialogAction(activiesOrDetails, contractId) {
  var url = '/contracting/contract/' + contractId + '/' + activiesOrDetails;
  return {
    type: constants.SHOW_FREE_CONTRACT_DIALOG,
    payload: {
      url: url,
      contractId: contractId
    }
  };
}
var toggleBulkResendDialog = function toggleBulkResendDialog(open) {
  return { type: constants.TOGGLE_BULK_RESEND_DIALOG, payload: open };
};
var closeBulkResendDialog = exports.closeBulkResendDialog = function closeBulkResendDialog() {
  return toggleBulkResendDialog(false);
};
var openBulkResendDialog = exports.openBulkResendDialog = function openBulkResendDialog() {
  return function (dispatch, getState) {
    var contractIds = getState().contracting.contractList.get('selectedContracts').toJS();
    var companyType = getState().user.getIn(['user', 'type']);
    var companyName = getState().user.getIn(['company', 'companyName']);
    dispatch(toggleBulkResendDialog(true));
    return callApiPost('/proxy/contracting/groupContractsForBulkResend', JSON.stringify({ contractIds: contractIds })).then(function (res) {
      return res.json();
    }).then(function (result) {
      dispatch({ type: constants.POPULATE_BULK_RESEND, payload: {
          partners: result,
          subject: 'Rates Reminder: ' + companyName,
          customizedMessage: companyType === 'Supplier' ? 'For your convenience, I\'m resending rates for ' + companyName + ' via TourConnect.' : 'If you have not done so already, this is a friendly reminder that we need your rates.  Using TourConnect will make it easier for us to load your rates. More importantly, it will help us sell more of your products.'
        } });
    }).catch(function (err) {
      var permissionDenied = _ramda2.default.pathOr(0, ['response', 'status'], err) === 403;
      dispatch({
        type: 'GLOBAL_ERROR_TRIGGERED',
        payload: permissionDenied ? { noAccessDialog: true, message: 'You will need write access in order to resend contracts.' } : { errorMessage: 'Failed to get data for bulk resending.' }
      });
    });
  };
};
var bulkResend = exports.bulkResend = function bulkResend() {
  return function (dispatch, getState) {
    var _getState$contracting = getState().contracting.contractList.get('bulkResendDialog').toJS(),
        partners = _getState$contracting.partners,
        customizedMessage = _getState$contracting.customizedMessage,
        BCCToSelf = _getState$contracting.BCCToSelf;

    dispatch({ type: constants.BULK_SENDING });
    return callApiPut('/proxy/contracting/bulkResendContracts', JSON.stringify({ partners: partners, customizedMessage: customizedMessage, BCCToSelf: BCCToSelf })).then(function () {
      return dispatch({ type: constants.BULK_SEND_FINISHED });
    }).catch(function (err) {
      console.log(err.stack);
      dispatch({ type: constants.BULK_SEND_FINISHED });
      dispatch({ type: 'GLOBAL_ERROR_TRIGGERED', payload: { errorMessage: 'Failed to resend contracts in bulk.' } });
    });
  };
};
var updateBulkResendDialogProps = exports.updateBulkResendDialogProps = function updateBulkResendDialogProps(payload) {
  return { type: constants.UPDATE_BULK_RESEND_PROPS, payload: payload };
};
var updateProps = exports.updateProps = function updateProps(payload) {
  return { type: constants.UPDATE_PROPS, payload: payload };
};
var updateSearchParams = exports.updateSearchParams = function updateSearchParams(payload) {
  return { type: constants.UPDATE_PARAMS, payload: payload };
};
var resetSearchParams = exports.resetSearchParams = function resetSearchParams() {
  return { type: constants.RESET_PARAMS };
};

var selectAContract = exports.selectAContract = function selectAContract(id) {
  return { type: constants.SELECT_ONE_CONTRACT, payload: id };
};
var openResendContractDialog = exports.openResendContractDialog = function openResendContractDialog(payload) {
  return { type: 'CHANGE_RESEND_CONTRACT_DIALOG_STATE', payload: payload };
};
var getContractForwardingEmail = exports.getContractForwardingEmail = function getContractForwardingEmail(payload) {
  return { type: constants.GET_CONTRACT_EMAIL, payload: payload };
};

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contentFromFile = undefined;

var _nodeUuid = __webpack_require__(219);

var _nodeUuid2 = _interopRequireDefault(_nodeUuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contentFromFile = exports.contentFromFile = function contentFromFile(file) {
  if (file.type) return file.type;
  var extension = ((file.name || '').split('.').pop() || '').toLowerCase();
  if (extension === 'xlsx') return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  if (extension === 'xls') return 'application/vnd.ms-excel';
  if (extension === 'pdf') return 'application/pdf';
  if (extension === 'txt') return 'text/plain';
  if (extension === 'csv') return 'text/csv';
  if (extension === 'doc') return 'application/msword';
  if (extension === 'docx') return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  return undefined;
}; // Original source: https://github.com/flyingsparx/s3upload-coffee-javascript/blob/master/s3upload.js
// Modified to match our needs
exports.default = {

  s3_sign_put_url: '/proxy/s3/sign',

  s3uploadPromise: function s3uploadPromise(file) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      _this.s3upload({
        file_to_upload: file,
        file_name: file.name,
        ACL: 'private',
        onFinishS3Put: function onFinishS3Put(path) {
          resolve({
            path: path,
            downloadUrl: path, // for insurance file
            name: file.name,
            fileName: file.name, // for insurance file
            type: file.type,
            size: file.size
          });
        },
        onProgress: function onProgress() {},
        onError: function onError(status) {
          reject(status);
        }
      });
    });
  },
  s3upload: function s3upload(options) {
    var _this2 = this;

    var file = options.file_to_upload;
    var fileName = options.file_name;
    return this.executeOnSignedUrl(file, fileName, options, function (signedURL, publicURL) {
      return _this2.uploadToS3(file, signedURL, publicURL, fileName, options);
    });
  },
  executeOnSignedUrl: function executeOnSignedUrl(file, fileName, options, callback) {
    var onError = options.onError;
    var xhr = new XMLHttpRequest();
    var contentType = contentFromFile(file);
    xhr.open('GET', this.s3_sign_put_url + '?s3_object_type=' + contentType + '&s3_file_name=' + _nodeUuid2.default.v1() + (options.ACL ? '&ACL=' + options.ACL : ''), true);
    xhr.overrideMimeType('text/plain; charset=x-user-defined');
    xhr.onreadystatechange = function () {
      var result = void 0;
      if (this.readyState === 4 && this.status === 200) {
        try {
          result = JSON.parse(this.responseText);
        } catch (error) {
          console.log(error);
          return false;
        }
        return callback(result.signedUrl, result.url);
      } else if (this.readyState === 4 && this.status !== 200) {
        return onError('Could not contact request signing server. Status = ' + this.status);
      }
    };
    return xhr.send();
  },
  uploadToS3: function uploadToS3(file, url, publicUrl, fileName, options) {
    var onFinishS3Put = options.onFinishS3Put;
    var onProgress = options.onProgress;
    var onError = options.onError;

    var xhr = this.createCORSRequest('PUT', url);
    if (!xhr) {
      onError('CORS not supported');
    } else {
      xhr.onload = function () {
        if (xhr.status === 200) return onFinishS3Put(publicUrl, fileName);
        return onError('Upload error: ' + xhr.status);
      };
      xhr.onerror = function () {
        return onError('XHR error.');
      };
      xhr.upload.onprogress = function (e) {
        var percentLoaded = void 0;
        if (e.lengthComputable) {
          percentLoaded = Math.round(e.loaded / e.total * 100);
          return onProgress(percentLoaded);
        }
      };
    }
    var contentType = contentFromFile(file);
    xhr.setRequestHeader('Content-Type', contentType);
    // xhr.setRequestHeader('x-amz-acl', 'public-read');
    return xhr.send(file);
  },
  createCORSRequest: function createCORSRequest(method, url) {
    var xhr = new XMLHttpRequest();
    if (xhr.withCredentials !== null) {
      xhr.open(method, url, true);
    } else if (typeof XDomainRequest !== 'undefined') {
      xhr = new XDomainRequest();
      xhr.open(method, url);
    } else {
      xhr = null;
    }
    return xhr;
  },
  resizeCoverImage: function resizeCoverImage(image, dimensions, context, type) {
    var maxWidth = 1440;
    var maxHeight = 350;
    var imageWidth = image.width;
    var imageHeight = image.height;
    if (imageWidth > imageHeight) {
      if (imageWidth > maxWidth) {
        imageHeight *= maxWidth / imageWidth;
        imageWidth = maxWidth;
      }
    } else {
      if (imageHeight > maxHeight) {
        imageWidth *= maxHeight / imageHeight;
        imageHeight = maxHeight;
      }
    }

    var canvasWidth = imageWidth;
    var canvasHeight = maxHeight;
    if (imageHeight < maxHeight) canvasHeight = imageHeight;

    var canvas = document.createElement('canvas');
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    var ctx = canvas.getContext('2d');
    ctx.drawImage(context, 0, 0, imageWidth, imageHeight);
    return canvas.toDataURL(type);
  },
  resizeImage: function resizeImage(image, dimensions, context, type) {
    var maxWidth = dimensions;
    var maxHeight = dimensions;
    var imageWidth = image.width;
    var imageHeight = image.height;

    if (imageWidth > imageHeight) {
      if (imageWidth > maxWidth) {
        imageHeight *= maxWidth / imageWidth;
        imageWidth = maxWidth;
      }
    } else {
      if (imageHeight > maxHeight) {
        imageWidth *= maxHeight / imageHeight;
        imageHeight = maxHeight;
      }
    }

    var canvas = document.createElement('canvas');
    canvas.width = imageWidth;
    canvas.height = imageHeight;

    var ctx = canvas.getContext('2d');
    ctx.drawImage(context, 0, 0, imageWidth, imageHeight);
    return canvas.toDataURL(type);
  },
  dataURItoBlob: function dataURItoBlob(dataURI, imageType) {
    var binary = atob(dataURI.split(',')[1]);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {
      type: imageType
    });
  }
};

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

/**
 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = getNative;


/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var map = __webpack_require__(16);
var prop = __webpack_require__(96);


/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.props
 * @example
 *
 *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
 *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */
module.exports = _curry2(function pluck(p, list) {
  return map(prop(p), list);
});


/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_DOC = exports.GET_DOC = '{master-template} GET_DOC';
var CREATE_EDITED_DRAFT = exports.CREATE_EDITED_DRAFT = '{master-template} CREATE_EDITED_DRAFT';
var GET_DIFF_SUMMARY = exports.GET_DIFF_SUMMARY = '{master-template} GET_DIFF_SUMMARY';
var INITIATE_EDIT_WITH_TYPE = exports.INITIATE_EDIT_WITH_TYPE = '{master-template} INITIATE_EDIT_WITH_TYPE';
var POPULATE_EDIT_DIALOG_DATA = exports.POPULATE_EDIT_DIALOG_DATA = '{master-template} POPULATE_EDIT_DIALOG_DATA';
var CANCEL_EDIT = exports.CANCEL_EDIT = '{master-template} CANCEL_EDIT';
var CLICK_FINALISE = exports.CLICK_FINALISE = '{master-template} CLICK_FINALISE_BUTTON';
var FINALISE = exports.FINALISE = '{master-template} FINALISE_BUTTON';
var OPEN_FINALISE_DIALOG = exports.OPEN_FINALISE_DIALOG = '{master-template} OPEN_FINALISE_DIALOG';
var CLOSE_FINALISE_DIALOG = exports.CLOSE_FINALISE_DIALOG = '{master-template} CLOSE_FINALISE_DIALOG';
var SEND_UPDATES = exports.SEND_UPDATES = '{master-template} SEND_UPDATES';
var DISCARD_DRAFT = exports.DISCARD_DRAFT = '{master-template} DISCARD_DRAFT';
var GET_ASSOCIATED_TEMPLATES = exports.GET_ASSOCIATED_TEMPLATES = '{master-template} GET_ASSOCIATED_TEMPLATES';
var TOGGLE_ASSOCIATED_TEMPLATES = exports.TOGGLE_ASSOCIATED_TEMPLATES = '{master-template} TOGGLE_ASSOCIATED_TEMPLATES';
var GET_AFFECTED_BUYERS = exports.GET_AFFECTED_BUYERS = '{master-template} GET_AFFECTED_BUYERS';

var SAVE_EDITS = exports.SAVE_EDITS = '{edit-dialog} SAVE_EDITS';
var TEXT_FIELD_CHANGE = exports.TEXT_FIELD_CHANGE = '{edit-dialog} TEXT_FIELD_CHANGE';
var ATTACH_INS_FILE = exports.ATTACH_INS_FILE = '{edit-dialog} ATTACH_INS_FILE';
var REMOVE_INSURANCE_FILE = exports.REMOVE_INSURANCE_FILE = '{edit-dialog} REMOVE_INSURANCE_FILE';

var apply = exports.apply = {
  INIT: '{apply-master-to-template} INIT',
  GET_TEMPLATES: '{apply-master-to-template} GET_TEMPLATES',
  SELECT_UNSELECT_TEMPLATE: '{apply-master-to-template} SELECT_UNSELECT_TEMPLATE',
  APPLY_TO_TEMPLATES: '{apply-master-to-template} APPLY_TO_TEMPLATES_TO_TEMPLATE_DRAFTS',
  CLICK_OK_SUCCESS: '{apply-master-to-template} CLICK_OK_SUCCESS',
  CHECK_SAME_AS: '{apply-master-to-template} CHECK_SAME_AS',
  SELECT_MASTER: '{apply-master-to-template} SELECT_MASTER',
  GET_MASTERS: '{apply-master-to-template} GET_MASTERS',
  CLEAR_STORE: '{apply-master-to-template} CLEAR_STORE',
  CHECK_HONOR_PRELOAD: '{apply-master-to-template} CHECK_HONOR_PRELOAD'
};

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

module.exports = function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
};


/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = '[sidebarHelp] ';

var SIDEBARHELP_INIT = exports.SIDEBARHELP_INIT = prefix + 'INIT';
var LOAD_HELPFILES = exports.LOAD_HELPFILES = prefix + 'LOAD_INDEX';
var LOAD_HELP_ARTICLE = exports.LOAD_HELP_ARTICLE = prefix + 'LOAD_HELP';
var OPEN_WIDGET = exports.OPEN_WIDGET = 'HELPWIDGET_OPEN';

/***/ }),

/***/ 583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony export (immutable) */ __webpack_exports__["c"] = suspend;
/* harmony export (immutable) */ __webpack_exports__["b"] = flush;
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),

/***/ 584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__proc__ = __webpack_require__(585);



var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';

function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(storeInterface)) {
    if (false) {
      log('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
    }
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(saga, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
      subscribe = _storeInterface.subscribe,
      dispatch = _storeInterface.dispatch,
      getState = _storeInterface.getState,
      context = _storeInterface.context,
      sagaMonitor = _storeInterface.sagaMonitor,
      logger = _storeInterface.logger,
      onError = _storeInterface.onError;


  var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["y" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = Object(__WEBPACK_IMPORTED_MODULE_1__proc__["b" /* default */])(iterator, subscribe, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["A" /* wrapSagaDispatch */])(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),

/***/ 585:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NOT_ITERATOR_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL_END; });
/* unused harmony export TASK_CANCEL */
/* harmony export (immutable) */ __webpack_exports__["b"] = proc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__io__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buffers__ = __webpack_require__(237);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }







var NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* kTrue */];
  },
  default: function _default(pattern) {
    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
      return input.type === pattern;
    } : function (input) {
      return input.type === String(pattern);
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return matcher(p)(input);
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  // prettier-ignore
  return (pattern === '*' ? matchers.wildcard : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(pattern) ? matchers.array : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].stringableFunc(pattern) ? matchers.default : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* remove */])(tasks, task);
      task.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* makeIterator */])(function () {
    throw error;
  }) : Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* makeIterator */])(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

var wrapHelper = function wrapHelper(helper) {
  return { fn: helper };
};

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
  var cont = arguments[8];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator, NOT_ITERATOR_ERROR);

  var effectsString = '[...effects]';
  var runParallelEffect = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* deprecate */])(runAllEffect, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* updateIncentive */])(effectsString, 'all(' + effectsString + ')'));

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;

  var log = logger || __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* log */];
  var logError = function logError(err) {
    var message = err.sagaStack;

    if (!message && err.stack) {
      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
    }

    log('error', 'uncaught at ' + name, message || err.message || err);
  };
  var stdChannel = Object(__WEBPACK_IMPORTED_MODULE_3__channel__["f" /* stdChannel */])(subscribe);
  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        logError(error);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        Object.defineProperty(result, 'sagaStack', {
          value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
          configurable: true
        });
      }
      if (!task.cont) {
        if (result instanceof Error && onError) {
          onError(result);
        } else {
          logError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["y" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */]; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        logError(err);
      }
      currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    // prettier-ignore
    return (
      // Non declarative effect
      __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].promise(effect) ? resolvePromise(effect, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* CANCEL */]];
    if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(cancelPromise)) {
      cb.cancel = cancelPromise;
    } else if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(promise.abort)) {
      cb.cancel = function () {
        return promise.abort();
      };
      // TODO: add support for the fetch API, whenever they get around to
      // adding cancel support
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* isEnd */])(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["a" /* asap */])(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        logError(error);
      }

      if (resolve && __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].promise(result) ? resolvePromise(result, cb) : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["c" /* suspend */])();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["b" /* flush */])();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* remove */])(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      return cb(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(effects) ? __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* array */].from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _response;

          cb.cancel();
          completed = true;
          var response = (_response = {}, _response[key] = res, _response);
          cb(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(effects) ? [].slice.call(_extends({}, response, { length: keys.length })) : response);
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb(Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* eventChannel */])(subscribe, buffer || __WEBPACK_IMPORTED_MODULE_4__buffers__["a" /* buffers */].fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["v" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["l" /* deferred */])();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* createSetContextWarning */])('task', props));
      __WEBPACK_IMPORTED_MODULE_0__utils__["v" /* object */].assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}

/***/ }),

/***/ 586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return takeEvery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return takeLatest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return throttle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__takeEvery__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLatest__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throttle__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(64);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__takeEvery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__takeLatest__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__throttle__["a"]; });






var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var takeEvery = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["n" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_0__takeEvery__["a" /* default */], /*#__PURE__*/deprecationWarning('takeEvery'));
var takeLatest = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["n" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_1__takeLatest__["a" /* default */], /*#__PURE__*/deprecationWarning('takeLatest'));
var throttle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["n" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_2__throttle__["a" /* default */], /*#__PURE__*/deprecationWarning('throttle'));



/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Representation a of zip file in js
 * @constructor
 */
function JSZip() {
    // if this constructor is used without `new`, it adds `new` before itself:
    if(!(this instanceof JSZip)) {
        return new JSZip();
    }

    if(arguments.length) {
        throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
    }

    // object containing the files :
    // {
    //   "folder/" : {...},
    //   "folder/data.txt" : {...}
    // }
    this.files = {};

    this.comment = null;

    // Where we are in the hierarchy
    this.root = "";
    this.clone = function() {
        var newObj = new JSZip();
        for (var i in this) {
            if (typeof this[i] !== "function") {
                newObj[i] = this[i];
            }
        }
        return newObj;
    };
}
JSZip.prototype = __webpack_require__(920);
JSZip.prototype.loadAsync = __webpack_require__(948);
JSZip.support = __webpack_require__(117);
JSZip.defaults = __webpack_require__(595);

// TODO find a better way to handle this version,
// a require('package.json').version doesn't work with webpack, see #327
JSZip.version = "3.1.3";

JSZip.loadAsync = function (content, options) {
    return new JSZip().loadAsync(content, options);
};

JSZip.external = __webpack_require__(218);
module.exports = JSZip;


/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

/*
 * This file is used by module bundlers (browserify/webpack/etc) when
 * including a stream implementation. We use "readable-stream" to get a
 * consistent behavior between nodejs versions but bundlers often have a shim
 * for "stream". Using this shim greatly improve the compatibility and greatly
 * reduce the final size of the bundle (only one stream implementation, not
 * two).
 */
module.exports = __webpack_require__(229);


/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var utils = __webpack_require__(35);
var support = __webpack_require__(117);
// private property
var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";


// public method for encoding
exports.encode = function(input) {
    var output = [];
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0, len = input.length, remainingBytes = len;

    var isArray = utils.getTypeOf(input) !== "string";
    while (i < input.length) {
        remainingBytes = len - i;

        if (!isArray) {
            chr1 = input.charCodeAt(i++);
            chr2 = i < len ? input.charCodeAt(i++) : 0;
            chr3 = i < len ? input.charCodeAt(i++) : 0;
        } else {
            chr1 = input[i++];
            chr2 = i < len ? input[i++] : 0;
            chr3 = i < len ? input[i++] : 0;
        }

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = remainingBytes > 1 ? (((chr2 & 15) << 2) | (chr3 >> 6)) : 64;
        enc4 = remainingBytes > 2 ? (chr3 & 63) : 64;

        output.push(_keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4));

    }

    return output.join("");
};

// public method for decoding
exports.decode = function(input) {
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0, resultIndex = 0;

    var dataUrlPrefix = "data:";

    if (input.substr(0, dataUrlPrefix.length) === dataUrlPrefix) {
        // This is a common error: people give a data url
        // (data:image/png;base64,iVBOR...) with a {base64: true} and
        // wonders why things don't work.
        // We can detect that the string input looks like a data url but we
        // *can't* be sure it is one: removing everything up to the comma would
        // be too dangerous.
        throw new Error("Invalid base64 input, it looks like a data url.");
    }

    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    var totalLength = input.length * 3 / 4;
    if(input.charAt(input.length - 1) === _keyStr.charAt(64)) {
        totalLength--;
    }
    if(input.charAt(input.length - 2) === _keyStr.charAt(64)) {
        totalLength--;
    }
    if (totalLength % 1 !== 0) {
        // totalLength is not an integer, the length does not match a valid
        // base64 content. That can happen if:
        // - the input is not a base64 content
        // - the input is *almost* a base64 content, with a extra chars at the
        //   beginning or at the end
        // - the input uses a base64 variant (base64url for example)
        throw new Error("Invalid base64 input, bad content length.");
    }
    var output;
    if (support.uint8array) {
        output = new Uint8Array(totalLength|0);
    } else {
        output = new Array(totalLength|0);
    }

    while (i < input.length) {

        enc1 = _keyStr.indexOf(input.charAt(i++));
        enc2 = _keyStr.indexOf(input.charAt(i++));
        enc3 = _keyStr.indexOf(input.charAt(i++));
        enc4 = _keyStr.indexOf(input.charAt(i++));

        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        output[resultIndex++] = chr1;

        if (enc3 !== 64) {
            output[resultIndex++] = chr2;
        }
        if (enc4 !== 64) {
            output[resultIndex++] = chr3;
        }

    }

    return output;
};


/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

var _isArray = __webpack_require__(41);


/**
 * This checks whether a function has a [methodname] function. If it isn't an
 * array it will execute that function otherwise it will default to the ramda
 * implementation.
 *
 * @private
 * @param {Function} fn ramda implemtation
 * @param {String} methodname property to check for a custom implementation
 * @return {Object} Whatever the return value of the method is.
 */
module.exports = function _checkForMethod(methodname, fn) {
  return function() {
    var length = arguments.length;
    if (length === 0) {
      return fn();
    }
    var obj = arguments[length - 1];
    return (_isArray(obj) || typeof obj[methodname] !== 'function') ?
      fn.apply(this, arguments) :
      obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
  };
};


/***/ }),

/***/ 590:
/***/ (function(module, exports) {

var core = module.exports = {version: '2.3.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(924);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(487)
  , document = __webpack_require__(239).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

var utils = __webpack_require__(35);
var ConvertWorker = __webpack_require__(937);
var GenericWorker = __webpack_require__(65);
var base64 = __webpack_require__(589);
var support = __webpack_require__(117);
var external = __webpack_require__(218);

var NodejsStreamOutputAdapter = null;
if (support.nodestream) {
    try {
        NodejsStreamOutputAdapter = __webpack_require__(938);
    } catch(e) {}
}

/**
 * Apply the final transformation of the data. If the user wants a Blob for
 * example, it's easier to work with an U8intArray and finally do the
 * ArrayBuffer/Blob conversion.
 * @param {String} resultType the name of the final type
 * @param {String} chunkType the type of the data in the given array.
 * @param {Array} dataArray the array containing the data chunks to concatenate
 * @param {String|Uint8Array|Buffer} content the content to transform
 * @param {String} mimeType the mime type of the content, if applicable.
 * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the content in the right format.
 */
function transformZipOutput(resultType, chunkType, dataArray, mimeType) {
    var content = null;
    switch(resultType) {
        case "blob" :
            return utils.newBlob(dataArray, mimeType);
        case "base64" :
            content = concat(chunkType, dataArray);
            return base64.encode(content);
        default :
            content = concat(chunkType, dataArray);
            return utils.transformTo(resultType, content);
    }
}

/**
 * Concatenate an array of data of the given type.
 * @param {String} type the type of the data in the given array.
 * @param {Array} dataArray the array containing the data chunks to concatenate
 * @return {String|Uint8Array|Buffer} the concatenated data
 * @throws Error if the asked type is unsupported
 */
function concat (type, dataArray) {
    var i, index = 0, res = null, totalLength = 0;
    for(i = 0; i < dataArray.length; i++) {
        totalLength += dataArray[i].length;
    }
    switch(type) {
        case "string":
            return dataArray.join("");
          case "array":
            return Array.prototype.concat.apply([], dataArray);
        case "uint8array":
            res = new Uint8Array(totalLength);
            for(i = 0; i < dataArray.length; i++) {
                res.set(dataArray[i], index);
                index += dataArray[i].length;
            }
            return res;
        case "nodebuffer":
            return Buffer.concat(dataArray);
        default:
            throw new Error("concat : unsupported type '"  + type + "'");
    }
}

/**
 * Listen a StreamHelper, accumulate its content and concatenate it into a
 * complete block.
 * @param {StreamHelper} helper the helper to use.
 * @param {Function} updateCallback a callback called on each update. Called
 * with one arg :
 * - the metadata linked to the update received.
 * @return Promise the promise for the accumulation.
 */
function accumulate(helper, updateCallback) {
    return new external.Promise(function (resolve, reject){
        var dataArray = [];
        var chunkType = helper._internalType,
            resultType = helper._outputType,
            mimeType = helper._mimeType;
        helper
        .on('data', function (data, meta) {
            dataArray.push(data);
            if(updateCallback) {
                updateCallback(meta);
            }
        })
        .on('error', function(err) {
            dataArray = [];
            reject(err);
        })
        .on('end', function (){
            try {
                var result = transformZipOutput(resultType, chunkType, dataArray, mimeType);
                resolve(result);
            } catch (e) {
                reject(e);
            }
            dataArray = [];
        })
        .resume();
    });
}

/**
 * An helper to easily use workers outside of JSZip.
 * @constructor
 * @param {Worker} worker the worker to wrap
 * @param {String} outputType the type of data expected by the use
 * @param {String} mimeType the mime type of the content, if applicable.
 */
function StreamHelper(worker, outputType, mimeType) {
    var internalType = outputType;
    switch(outputType) {
        case "blob":
            internalType = "arraybuffer";
        break;
        case "arraybuffer":
            internalType = "uint8array";
        break;
        case "base64":
            internalType = "string";
        break;
    }

    try {
        // the type used internally
        this._internalType = internalType;
        // the type used to output results
        this._outputType = outputType;
        // the mime type
        this._mimeType = mimeType;
        utils.checkSupport(internalType);
        this._worker = worker.pipe(new ConvertWorker(internalType));
        // the last workers can be rewired without issues but we need to
        // prevent any updates on previous workers.
        worker.lock();
    } catch(e) {
        this._worker = new GenericWorker("error");
        this._worker.error(e);
    }
}

StreamHelper.prototype = {
    /**
     * Listen a StreamHelper, accumulate its content and concatenate it into a
     * complete block.
     * @param {Function} updateCb the update callback.
     * @return Promise the promise for the accumulation.
     */
    accumulate : function (updateCb) {
        return accumulate(this, updateCb);
    },
    /**
     * Add a listener on an event triggered on a stream.
     * @param {String} evt the name of the event
     * @param {Function} fn the listener
     * @return {StreamHelper} the current helper.
     */
    on : function (evt, fn) {
        var self = this;

        if(evt === "data") {
            this._worker.on(evt, function (chunk) {
                fn.call(self, chunk.data, chunk.meta);
            });
        } else {
            this._worker.on(evt, function () {
                utils.delay(fn, arguments, self);
            });
        }
        return this;
    },
    /**
     * Resume the flow of chunks.
     * @return {StreamHelper} the current helper.
     */
    resume : function () {
        utils.delay(this._worker.resume, [], this._worker);
        return this;
    },
    /**
     * Pause the flow of chunks.
     * @return {StreamHelper} the current helper.
     */
    pause : function () {
        this._worker.pause();
        return this;
    },
    /**
     * Return a nodejs stream for this helper.
     * @param {Function} updateCb the update callback.
     * @return {NodejsStreamOutputAdapter} the nodejs stream.
     */
    toNodejsStream : function (updateCb) {
        utils.checkSupport("nodestream");
        if (this._outputType !== "nodebuffer") {
            // an object stream containing blob/arraybuffer/uint8array/string
            // is strange and I don't know if it would be useful.
            // I you find this comment and have a good usecase, please open a
            // bug report !
            throw new Error(this._outputType + " is not supported by this method");
        }

        return new NodejsStreamOutputAdapter(this, {
            objectMode : this._outputType !== "nodebuffer"
        }, updateCb);
    }
};


module.exports = StreamHelper;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.base64 = false;
exports.binary = false;
exports.dir = false;
exports.createFolders = true;
exports.date = null;
exports.compression = null;
exports.compressionOptions = null;
exports.comment = null;
exports.unixPermissions = null;
exports.dosPermissions = null;


/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var GenericWorker = __webpack_require__(65);

// the size of the generated chunks
// TODO expose this as a public variable
var DEFAULT_BLOCK_SIZE = 16 * 1024;

/**
 * A worker that reads a content and emits chunks.
 * @constructor
 * @param {Promise} dataP the promise of the data to split
 */
function DataWorker(dataP) {
    GenericWorker.call(this, "DataWorker");
    var self = this;
    this.dataIsReady = false;
    this.index = 0;
    this.max = 0;
    this.data = null;
    this.type = "";

    this._tickScheduled = false;

    dataP.then(function (data) {
        self.dataIsReady = true;
        self.data = data;
        self.max = data && data.length || 0;
        self.type = utils.getTypeOf(data);
        if(!self.isPaused) {
            self._tickAndRepeat();
        }
    }, function (e) {
        self.error(e);
    });
}

utils.inherits(DataWorker, GenericWorker);

/**
 * @see GenericWorker.cleanUp
 */
DataWorker.prototype.cleanUp = function () {
    GenericWorker.prototype.cleanUp.call(this);
    this.data = null;
};

/**
 * @see GenericWorker.resume
 */
DataWorker.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if (!this._tickScheduled && this.dataIsReady) {
        this._tickScheduled = true;
        utils.delay(this._tickAndRepeat, [], this);
    }
    return true;
};

/**
 * Trigger a tick a schedule an other call to this function.
 */
DataWorker.prototype._tickAndRepeat = function() {
    this._tickScheduled = false;
    if(this.isPaused || this.isFinished) {
        return;
    }
    this._tick();
    if(!this.isFinished) {
        utils.delay(this._tickAndRepeat, [], this);
        this._tickScheduled = true;
    }
};

/**
 * Read and push a chunk.
 */
DataWorker.prototype._tick = function() {

    if(this.isPaused || this.isFinished) {
        return false;
    }

    var size = DEFAULT_BLOCK_SIZE;
    var data = null, nextIndex = Math.min(this.max, this.index + size);
    if (this.index >= this.max) {
        // EOF
        return this.end();
    } else {
        switch(this.type) {
            case "string":
                data = this.data.substring(this.index, nextIndex);
            break;
            case "uint8array":
                data = this.data.subarray(this.index, nextIndex);
            break;
            case "array":
            case "nodebuffer":
                data = this.data.slice(this.index, nextIndex);
            break;
        }
        this.index = nextIndex;
        return this.push({
            data : data,
            meta : {
                percent : this.max ? this.index / this.max * 100 : 0
            }
        });
    }
};

module.exports = DataWorker;


/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var GenericWorker = __webpack_require__(65);

/**
 * A worker which calculate the total length of the data flowing through.
 * @constructor
 * @param {String} propName the name used to expose the length
 */
function DataLengthProbe(propName) {
    GenericWorker.call(this, "DataLengthProbe for " + propName);
    this.propName = propName;
    this.withStreamInfo(propName, 0);
}
utils.inherits(DataLengthProbe, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
DataLengthProbe.prototype.processChunk = function (chunk) {
    if(chunk) {
        var length = this.streamInfo[this.propName] || 0;
        this.streamInfo[this.propName] = length + chunk.data.length;
    }
    GenericWorker.prototype.processChunk.call(this, chunk);
};
module.exports = DataLengthProbe;



/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GenericWorker = __webpack_require__(65);
var crc32 = __webpack_require__(490);
var utils = __webpack_require__(35);

/**
 * A worker which calculate the crc32 of the data flowing through.
 * @constructor
 */
function Crc32Probe() {
    GenericWorker.call(this, "Crc32Probe");
    this.withStreamInfo("crc32", 0);
}
utils.inherits(Crc32Probe, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Crc32Probe.prototype.processChunk = function (chunk) {
    this.streamInfo.crc32 = crc32(chunk.data, this.streamInfo.crc32 || 0);
    this.push(chunk);
};
module.exports = Crc32Probe;


/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GenericWorker = __webpack_require__(65);

exports.STORE = {
    magic: "\x00\x00",
    compressWorker : function (compressionOptions) {
        return new GenericWorker("STORE compression");
    },
    uncompressWorker : function () {
        return new GenericWorker("STORE decompression");
    }
};
exports.DEFLATE = __webpack_require__(941);


/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(469);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _toString = __webpack_require__(294);


/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */
module.exports = _curry1(function toString(val) { return _toString(val, []); });


/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// String encode/decode helpers



var utils = __webpack_require__(230);


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var STR_APPLY_OK = true;
var STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new utils.Buf8(256);
for (var q = 0; q < 256; q++) {
  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
}
_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start


// convert string to array (typed, when possible)
exports.string2buf = function (str) {
  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new utils.Buf8(buf_len);

  // convert
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper (used in 2 places)
function buf2binstring(buf, len) {
  // On Chrome, the arguments in a function call that are allowed is `65534`.
  // If the length of the buffer is smaller than that, we can use this optimization,
  // otherwise we will take a slower path.
  if (len < 65534) {
    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
    }
  }

  var result = '';
  for (var i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
}


// Convert byte array to binary string
exports.buf2binstring = function (buf) {
  return buf2binstring(buf, buf.length);
};


// Convert binary string (typed, when possible)
exports.binstring2buf = function (str) {
  var buf = new utils.Buf8(str.length);
  for (var i = 0, len = buf.length; i < len; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
};


// convert array to string
exports.buf2string = function (buf, max) {
  var i, out, c, c_len;
  var len = max || buf.length;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  var utf16buf = new Array(len * 2);

  for (out = 0, i = 0; i < len;) {
    c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
exports.utf8border = function (buf, max) {
  var pos;

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  pos = max - 1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means buffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};


/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.LOCAL_FILE_HEADER = "PK\x03\x04";
exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
exports.DATA_DESCRIPTOR = "PK\x07\x08";


/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var support = __webpack_require__(117);
var ArrayReader = __webpack_require__(603);
var StringReader = __webpack_require__(950);
var NodeBufferReader = __webpack_require__(951);
var Uint8ArrayReader = __webpack_require__(605);

/**
 * Create a reader adapted to the data.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data to read.
 * @return {DataReader} the data reader.
 */
module.exports = function (data) {
    var type = utils.getTypeOf(data);
    utils.checkSupport(type);
    if (type === "string" && !support.uint8array) {
        return new StringReader(data);
    }
    if (type === "nodebuffer") {
        return new NodeBufferReader(data);
    }
    if (support.uint8array) {
        return new Uint8ArrayReader(utils.transformTo("uint8array", data));
    }
    return new ArrayReader(utils.transformTo("array", data));
};

// vim: set shiftwidth=4 softtabstop=4:


/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DataReader = __webpack_require__(604);
var utils = __webpack_require__(35);

function ArrayReader(data) {
    DataReader.call(this, data);
	for(var i = 0; i < this.data.length; i++) {
		data[i] = data[i] & 0xFF;
	}
}
utils.inherits(ArrayReader, DataReader);
/**
 * @see DataReader.byteAt
 */
ArrayReader.prototype.byteAt = function(i) {
    return this.data[this.zero + i];
};
/**
 * @see DataReader.lastIndexOfSignature
 */
ArrayReader.prototype.lastIndexOfSignature = function(sig) {
    var sig0 = sig.charCodeAt(0),
        sig1 = sig.charCodeAt(1),
        sig2 = sig.charCodeAt(2),
        sig3 = sig.charCodeAt(3);
    for (var i = this.length - 4; i >= 0; --i) {
        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
            return i - this.zero;
        }
    }

    return -1;
};
/**
 * @see DataReader.readAndCheckSignature
 */
ArrayReader.prototype.readAndCheckSignature = function (sig) {
    var sig0 = sig.charCodeAt(0),
        sig1 = sig.charCodeAt(1),
        sig2 = sig.charCodeAt(2),
        sig3 = sig.charCodeAt(3),
        data = this.readData(4);
    return sig0 === data[0] && sig1 === data[1] && sig2 === data[2] && sig3 === data[3];
};
/**
 * @see DataReader.readData
 */
ArrayReader.prototype.readData = function(size) {
    this.checkOffset(size);
    if(size === 0) {
        return [];
    }
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = ArrayReader;


/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var utils = __webpack_require__(35);

function DataReader(data) {
    this.data = data; // type : see implementation
    this.length = data.length;
    this.index = 0;
    this.zero = 0;
}
DataReader.prototype = {
    /**
     * Check that the offset will not go too far.
     * @param {string} offset the additional offset to check.
     * @throws {Error} an Error if the offset is out of bounds.
     */
    checkOffset: function(offset) {
        this.checkIndex(this.index + offset);
    },
    /**
     * Check that the specifed index will not be too far.
     * @param {string} newIndex the index to check.
     * @throws {Error} an Error if the index is out of bounds.
     */
    checkIndex: function(newIndex) {
        if (this.length < this.zero + newIndex || newIndex < 0) {
            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
        }
    },
    /**
     * Change the index.
     * @param {number} newIndex The new index.
     * @throws {Error} if the new index is out of the data.
     */
    setIndex: function(newIndex) {
        this.checkIndex(newIndex);
        this.index = newIndex;
    },
    /**
     * Skip the next n bytes.
     * @param {number} n the number of bytes to skip.
     * @throws {Error} if the new index is out of the data.
     */
    skip: function(n) {
        this.setIndex(this.index + n);
    },
    /**
     * Get the byte at the specified index.
     * @param {number} i the index to use.
     * @return {number} a byte.
     */
    byteAt: function(i) {
        // see implementations
    },
    /**
     * Get the next number with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {number} the corresponding number.
     */
    readInt: function(size) {
        var result = 0,
            i;
        this.checkOffset(size);
        for (i = this.index + size - 1; i >= this.index; i--) {
            result = (result << 8) + this.byteAt(i);
        }
        this.index += size;
        return result;
    },
    /**
     * Get the next string with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {string} the corresponding string.
     */
    readString: function(size) {
        return utils.transformTo("string", this.readData(size));
    },
    /**
     * Get raw data without conversion, <size> bytes.
     * @param {number} size the number of bytes to read.
     * @return {Object} the raw data, implementation specific.
     */
    readData: function(size) {
        // see implementations
    },
    /**
     * Find the last occurence of a zip signature (4 bytes).
     * @param {string} sig the signature to find.
     * @return {number} the index of the last occurence, -1 if not found.
     */
    lastIndexOfSignature: function(sig) {
        // see implementations
    },
    /**
     * Read the signature (4 bytes) at the current position and compare it with sig.
     * @param {string} sig the expected signature
     * @return {boolean} true if the signature matches, false otherwise.
     */
    readAndCheckSignature: function(sig) {
        // see implementations
    },
    /**
     * Get the next date.
     * @return {Date} the date.
     */
    readDate: function() {
        var dostime = this.readInt(4);
        return new Date(Date.UTC(
        ((dostime >> 25) & 0x7f) + 1980, // year
        ((dostime >> 21) & 0x0f) - 1, // month
        (dostime >> 16) & 0x1f, // day
        (dostime >> 11) & 0x1f, // hour
        (dostime >> 5) & 0x3f, // minute
        (dostime & 0x1f) << 1)); // second
    }
};
module.exports = DataReader;


/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayReader = __webpack_require__(603);
var utils = __webpack_require__(35);

function Uint8ArrayReader(data) {
    ArrayReader.call(this, data);
}
utils.inherits(Uint8ArrayReader, ArrayReader);
/**
 * @see DataReader.readData
 */
Uint8ArrayReader.prototype.readData = function(size) {
    this.checkOffset(size);
    if(size === 0) {
        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
        return new Uint8Array(0);
    }
    var result = this.data.subarray(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = Uint8ArrayReader;


/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var JSZipUtils = {};
// just use the responseText with xhr1, response with xhr2.
// The transformation doesn't throw away high-order byte (with responseText)
// because JSZip handles that case. If not used with JSZip, you may need to
// do it, see https://developer.mozilla.org/En/Using_XMLHttpRequest#Handling_binary_data
JSZipUtils._getBinaryFromXHR = function (xhr) {
    // for xhr.responseText, the 0xFF mask is applied by JSZip
    return xhr.response || xhr.responseText;
};

// taken from jQuery
function createStandardXHR() {
    try {
        return new window.XMLHttpRequest();
    } catch( e ) {}
}

function createActiveXHR() {
    try {
        return new window.ActiveXObject("Microsoft.XMLHTTP");
    } catch( e ) {}
}

// Create the request object
var createXHR = window.ActiveXObject ?
    /* Microsoft failed to properly
     * implement the XMLHttpRequest in IE7 (can't request local files),
     * so we use the ActiveXObject when it is available
     * Additionally XMLHttpRequest can be disabled in IE7/IE8 so
     * we need a fallback.
     */
    function() {
    return createStandardXHR() || createActiveXHR();
} :
    // For all other browsers, use the standard XMLHttpRequest object
    createStandardXHR;



JSZipUtils.getBinaryContent = function(path, callback) {
    /*
     * Here is the tricky part : getting the data.
     * In firefox/chrome/opera/... setting the mimeType to 'text/plain; charset=x-user-defined'
     * is enough, the result is in the standard xhr.responseText.
     * cf https://developer.mozilla.org/En/XMLHttpRequest/Using_XMLHttpRequest#Receiving_binary_data_in_older_browsers
     * In IE <= 9, we must use (the IE only) attribute responseBody
     * (for binary data, its content is different from responseText).
     * In IE 10, the 'charset=x-user-defined' trick doesn't work, only the
     * responseType will work :
     * http://msdn.microsoft.com/en-us/library/ie/hh673569%28v=vs.85%29.aspx#Binary_Object_upload_and_download
     *
     * I'd like to use jQuery to avoid this XHR madness, but it doesn't support
     * the responseType attribute : http://bugs.jquery.com/ticket/11461
     */
    try {

        var xhr = createXHR();

        xhr.open('GET', path, true);

        // recent browsers
        if ("responseType" in xhr) {
            xhr.responseType = "arraybuffer";
        }

        // older browser
        if(xhr.overrideMimeType) {
            xhr.overrideMimeType("text/plain; charset=x-user-defined");
        }

        xhr.onreadystatechange = function(evt) {
            var file, err;
            // use `xhr` and not `this`... thanks IE
            if (xhr.readyState === 4) {
                if (xhr.status === 200 || xhr.status === 0) {
                    file = null;
                    err = null;
                    try {
                        file = JSZipUtils._getBinaryFromXHR(xhr);
                    } catch(e) {
                        err = new Error(e);
                    }
                    callback(err, file);
                } else {
                    callback(new Error("Ajax error for " + path + " : " + this.status + " " + this.statusText), null);
                }
            }
        };

        xhr.send();

    } catch (e) {
        callback(new Error(e), null);
    }
};

// export
module.exports = JSZipUtils;

// enforcing Stuk's coding style
// vim: set shiftwidth=4 softtabstop=4:


/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
	"use strict";
	// IE <10 is explicitly unsupported
	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var
		  doc = view.document
		  // only get URL when necessary in case Blob.js hasn't overridden it yet
		, get_URL = function() {
			return view.URL || view.webkitURL || view;
		}
		, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
		, can_use_save_link = "download" in save_link
		, click = function(node) {
			var event = new MouseEvent("click");
			node.dispatchEvent(event);
		}
		, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
		, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
		, throw_outside = function(ex) {
			(view.setImmediate || view.setTimeout)(function() {
				throw ex;
			}, 0);
		}
		, force_saveable_type = "application/octet-stream"
		// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
		, arbitrary_revoke_timeout = 1000 * 40 // in ms
		, revoke = function(file) {
			var revoker = function() {
				if (typeof file === "string") { // file is an object URL
					get_URL().revokeObjectURL(file);
				} else { // file is a File
					file.remove();
				}
			};
			setTimeout(revoker, arbitrary_revoke_timeout);
		}
		, dispatch = function(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		}
		, auto_bom = function(blob) {
			// prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
			if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
			}
			return blob;
		}
		, FileSaver = function(blob, name, no_auto_bom) {
			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			// First try a.download, then web filesystem, then object URLs
			var
				  filesaver = this
				, type = blob.type
				, force = type === force_saveable_type
				, object_url
				, dispatch_all = function() {
					dispatch(filesaver, "writestart progress write writeend".split(" "));
				}
				// on any filesys errors revert to saving with object URLs
				, fs_error = function() {
					if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
						// Safari doesn't allow downloading of blob urls
						var reader = new FileReader();
						reader.onloadend = function() {
							var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
							var popup = view.open(url, '_blank');
							if(!popup) view.location.href = url;
							url=undefined; // release reference before dispatching
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
						};
						reader.readAsDataURL(blob);
						filesaver.readyState = filesaver.INIT;
						return;
					}
					// don't create more object URLs than needed
					if (!object_url) {
						object_url = get_URL().createObjectURL(blob);
					}
					if (force) {
						view.location.href = object_url;
					} else {
						var opened = view.open(object_url, "_blank");
						if (!opened) {
							// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
							view.location.href = object_url;
						}
					}
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
					revoke(object_url);
				}
			;
			filesaver.readyState = filesaver.INIT;

			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				setTimeout(function() {
					save_link.href = object_url;
					save_link.download = name;
					click(save_link);
					dispatch_all();
					revoke(object_url);
					filesaver.readyState = filesaver.DONE;
				});
				return;
			}

			fs_error();
		}
		, FS_proto = FileSaver.prototype
		, saveAs = function(blob, name, no_auto_bom) {
			return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
		}
	;
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function(blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function(){};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error =
	FS_proto.onwritestart =
	FS_proto.onprogress =
	FS_proto.onwrite =
	FS_proto.onabort =
	FS_proto.onerror =
	FS_proto.onwriteend =
		null;

	return saveAs;
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
  module.exports.saveAs = saveAs;
} else if (("function" !== "undefined" && __webpack_require__(1082) !== null) && (__webpack_require__(953) !== null)) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
    return saveAs;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}


/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeForPolicyNotes = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _nodeUuid = __webpack_require__(219);

var _nodeUuid2 = _interopRequireDefault(_nodeUuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var checkIfArrayVaryBySeason = function checkIfArrayVaryBySeason(array) {
  return array && array.length && (array.length > 1 || _ramda2.default.path([0, 'dateRanges', 'length'], array) > 1);
};

var composeForPolicyNotes = exports.composeForPolicyNotes = function composeForPolicyNotes(dialog, draftContentInView) {
  var editType = dialog.type,
      policyType = dialog.policyType,
      data = dialog.data;

  return _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('billingInfo'), function () {
    // billing-info-node.jsx
    var billingInformation = draftContentInView.billingInformation;

    return _extends({}, billingInformation, {
      insuranceFiles: billingInformation.insuranceFiles || []
    });
  }], [_ramda2.default.equals('checkInOut'), function () {
    // checkinout.jsx
    var checkInOutInfo = _ramda2.default.pick(['checkIn', 'checkOut', 'earlyCheckIn', 'earlyCheckInFee', 'earlyCheckInCostType', 'earlyCheckInPercentageType', 'lateCheckOut', 'lateCheckOutFee', 'lateCheckOutCostType', 'lateCheckOutPercentageType'], draftContentInView);
    return _extends({}, checkInOutInfo, {
      lateCheckOutChecked: Boolean(checkInOutInfo.lateCheckOut),
      earlyCheckInChecked: Boolean(checkInOutInfo.earlyCheckIn),
      earlyCheckInCostType: checkInOutInfo.earlyCheckInCostType || '$',
      lateCheckOutCostType: checkInOutInfo.lateCheckOutCostType || '$'
    });
  }], [_ramda2.default.equals('policy'), function () {
    var locationPolicy = draftContentInView.locationPolicy;

    var getLocationPolicyEditInfo = function getLocationPolicyEditInfo() {
      var _filter = (locationPolicy || []).filter(function (policy) {
        return policy.policyType === policyType;
      }),
          _filter2 = _slicedToArray(_filter, 1),
          policyInfo = _filter2[0];

      var _ref = function () {
        switch (policyType) {
          case 'cancellation':
            return { note: 'Your cancellation policy tells your partners when, and how much, they will be charged for cancelling a booking.' };
          case 'group':
            return { note: 'Please note any special conditions or policies that apply for group bookings.' };
          case 'freeOfCharge':
            return { note: 'On occasion, your partners will have tour leaders, escorts, or guides accompany a group. Please note any conditions in which they will not be charged as part of the booking.' };
          case 'family':
            return { note: 'How many adults and children are included in your family rates?' };
          case 'child':
            return { note: 'What ages are included in your Child Policy?' };
          case 'infant':
            return { note: 'What ages are included in your Infant Policy?' };
          default:
            return {};
        }
      }(),
          note = _ref.note;

      return _extends({
        note: note,
        cancelHoursDays: 'hours',
        focChildrenAllowed: Boolean(policyInfo && policyInfo.focChildrenCount),
        policyType: policyType
      }, _ramda2.default.omit(['applicable'], policyInfo));
    };
    return getLocationPolicyEditInfo();
  }], [function () {
    return _ramda2.default.contains(editType, ['corporateIdentificationNumber', 'termsAndConditions', 'submissionCriteria', 'marketInfo']);
  }, function () {
    // terms-criteria-node.jsx
    var forSupplier = data.forSupplier;

    var info = draftContentInView[forSupplier ? 'supplierInfo' : 'buyerInfo'];
    return {
      fieldName: editType,
      value: info[editType]
    };
  }]]), editType);
};

exports.default = function (dialog, contractActivitiesProducts) {
  var draftContentInView = contractActivitiesProducts.rightSideContent,
      metaDataForDraft = contractActivitiesProducts.leftNav,
      draftErrors = contractActivitiesProducts.draftErrors;
  var allContractingReadyProducts = metaDataForDraft.allContractingReadyProducts,
      productsArray = metaDataForDraft.productsArray,
      startDate = metaDataForDraft.startDate,
      endDate = metaDataForDraft.endDate,
      _metaDataForDraft$pro = metaDataForDraft.productSharedData;
  _metaDataForDraft$pro = _metaDataForDraft$pro === undefined ? {} : _metaDataForDraft$pro;
  var allExtras = _metaDataForDraft$pro.allExtras,
      allOffers = _metaDataForDraft$pro.allOffers,
      contractId = metaDataForDraft.contractId,
      locationId = metaDataForDraft.locationId,
      supplierId = metaDataForDraft.supplierId;
  var editType = dialog.type,
      policyType = dialog.policyType,
      data = dialog.data,
      offersOrExtras = dialog.offersOrExtras;
  var ratePackageId = draftContentInView._id,
      productName = draftContentInView.productName,
      ratePackageName = draftContentInView.ratePackageName,
      seasons = draftContentInView.seasons,
      seasonRates = draftContentInView.seasonRates,
      productType = draftContentInView.productType;

  var existingSeasons = (seasonRates || []).length > (seasons || []).length ? seasonRates : seasons || [];
  var isSingleSeason = _ramda2.default.path([0, 'dateRanges', 0, 'seasonStartDate'], existingSeasons) === new Date(startDate).toISOString() && _ramda2.default.path([0, 'dateRanges', 0, 'seasonEndDate'], existingSeasons) === new Date(endDate).toISOString();

  var checkIfSeasonalSectionsIsIncomplete = function checkIfSeasonalSectionsIsIncomplete(array) {
    var varyBySeason = checkIfArrayVaryBySeason(array);
    return varyBySeason && array.length < existingSeasons.length;
  };
  return _ramda2.default.call(_ramda2.default.cond([[function () {
    return _ramda2.default.contains(editType, ['corporateIdentificationNumber', 'termsAndConditions', 'submissionCriteria', 'marketInfo', 'policy', 'checkInOut', 'billingInfo']);
  }, function () {
    return composeForPolicyNotes(dialog, draftContentInView);
  }], [_ramda2.default.equals('addRates'), _ramda2.default.always({})], // left-three-rates.jsx
  [_ramda2.default.equals('addProducts'), function () {
    // add-product-button.jsx
    return {
      products: [].concat(_toConsumableArray(allContractingReadyProducts), [{
        productName: '',
        added: false,
        checked: false,
        bedsAndSofas: { isApartment: false, rooms: [] }
      }])
    };
  }], [_ramda2.default.equals('manageRatePackage'), function () {
    // rate-set-infor-template.jsx
    // three-dots-menuItems.jsx
    var existingPackagesForProduct = productsArray.filter(function (prod) {
      return prod.productId === data.productId;
    }).map(function (prod) {
      return _extends({}, prod, { ratePackageName: prod.ratePackageName || 'Primary', oldRatePackageName: prod.ratePackageName || 'Primary' });
    });
    return {
      title: ratePackageName ? 'Manage Rate Packages for ' + productName : 'Create Rate Package for ' + productName,
      existingPackagesForProduct: existingPackagesForProduct
    };
  }], [_ramda2.default.equals('allocation'), function () {
    // right-one.jsx
    var allocation = draftContentInView.allocation;

    var allocationEmpty = !(allocation && allocation.length);
    if (allocationEmpty) {
      return {
        allocation: isSingleSeason ? existingSeasons.map(function (season) {
          return {
            allotments: [{}],
            releaseBackDays: '',
            dateRanges: season.dateRanges
          };
        }) : [{
          allotments: [{}],
          releaseBackDays: ''
        }]
      };
    }
    var varyBySeason = checkIfArrayVaryBySeason(allocation);
    var incomplete = checkIfSeasonalSectionsIsIncomplete(allocation);
    return {
      title: 'Edit Allocation',
      varyBySeason: varyBySeason,
      allocation: incomplete ? _dateUtils2.default.matchAllocationOrPolicyWithSeasons(existingSeasons, allocation) : allocation
    };
  }], [_ramda2.default.equals('addProductPolicy'), function () {
    var productPolicy = draftContentInView.productPolicy;

    return {
      productPolicy: productPolicy,
      selectedPolicy: {}
    };
  }], [_ramda2.default.equals('editProductPolicy'), function () {
    var productPolicy = draftContentInView.productPolicy;

    var policyObject = (productPolicy || []).reduce(function (result, policy) {
      if (policy.policyType === 'child') {
        result.child = _extends({}, policy, { focChildrenAllowed: Boolean(policy.focChildrenCount) });
      } else result[policy.policyType] = policy;
      return result;
    }, {});
    return {
      productPolicy: productPolicy,
      selectedPolicy: policyObject[policyType]
    };
  }], [_ramda2.default.equals('seasonalCancelPolicies'), function () {
    var productPolicy = draftContentInView.productPolicy;

    var _filter3 = (productPolicy || []).filter(function (policy) {
      return policy.policyType === 'cancellation';
    }),
        _filter4 = _slicedToArray(_filter3, 1),
        policyInfo = _filter4[0];

    var contentLength = _ramda2.default.path(['cancellations', 'length'], policyInfo);
    if (contentLength) {
      var _varyBySeason = checkIfArrayVaryBySeason(policyInfo.cancellations);
      var incomplete = checkIfSeasonalSectionsIsIncomplete(policyInfo.cancellations);
      return _extends({
        varyBySeason: _varyBySeason
      }, policyInfo, {
        cancellations: incomplete ? _dateUtils2.default.matchAllocationOrPolicyWithSeasons(existingSeasons, policyInfo.cancellations) : policyInfo.cancellations
      });
    }
    var varyBySeason = productType === 'Non-Accommodation' ? false : !isSingleSeason;
    return {
      varyBySeason: varyBySeason,
      policyType: 'cancellation',
      conditions: '',
      cancellations: varyBySeason ? existingSeasons.map(function (season) {
        return { dateRanges: season.dateRanges };
      }) : [{ dateRanges: [{ seasonStartDate: startDate, seasonEndDate: endDate }] }]
    };
  }], [_ramda2.default.equals('blackouts'), function () {
    var blackouts = draftContentInView.blackouts;

    return {
      blackouts: blackouts ? [].concat(_toConsumableArray(blackouts.map(function (obj) {
        return _ramda2.default.assoc('dataKey', _nodeUuid2.default.v1(), obj);
      })), [{ dataKey: _nodeUuid2.default.v1() }]) : [{}]
    };
  }], [_ramda2.default.equals('addExtra'), _ramda2.default.always({})], [_ramda2.default.equals('editExtra'), function () {
    // left-extras.jsx
    var extras = draftContentInView.extras;

    return { extras: extras };
  }], [_ramda2.default.equals('pickupDropoff'), function () {
    // right-four-pickup-dropoff.jsx
    var pickupOrDropoff = data.pickupOrDropoff;

    var infoArray = draftContentInView[pickupOrDropoff];
    if (infoArray && infoArray.length) {
      var useSeasons = infoArray.length > 1 && infoArray.length === existingSeasons.length;
      var varyBySeason = checkIfArrayVaryBySeason(infoArray);
      // const incomplete = checkIfSeasonalSectionsIsIncomplete(infoArray);
      return _defineProperty({
        varyBySeason: useSeasons || varyBySeason,
        useSeasons: useSeasons
      }, pickupOrDropoff, useSeasons ? _dateUtils2.default.matchAllocationOrPolicyWithSeasons(existingSeasons, infoArray) : infoArray.map(function (obj) {
        return obj && _ramda2.default.isEmpty(obj.dateRanges) ? _ramda2.default.merge(obj, { dateRanges: [{}] }) : obj;
      }));
    }
    return _defineProperty({
      varyBySeason: false,
      useSeasons: false
    }, pickupOrDropoff, [{
      notes: '',
      timeLocArray: [{}],
      dateRanges: [{ seasonStartDate: startDate, seasonEndDate: endDate }]
    }]);
  }], [_ramda2.default.equals('importFromTemplate'), _ramda2.default.always({ step: 1 })], [_ramda2.default.equals('omniImport'), _ramda2.default.always({
    showCC: true,
    templates: data.templates || [],
    importPoliciesNotes: true,
    targetTemplate: {
      docId: contractId,
      locationId: locationId,
      supplierId: supplierId,
      products: allContractingReadyProducts
    }
  })], [_ramda2.default.equals('copyDataFromAnotherProduct'), function () {
    var noShowIfEmpty = dialog.data.noShowIfEmpty;

    var currentProductId = draftContentInView.productId;
    var currentRatePackage = draftContentInView.ratePackageName || '';
    var notEmptyRatePackages = (draftErrors.products || []).filter(function (prod) {
      var notEmpty = prod.productCompletionScore > 0;
      var notSameProductId = prod.productId !== currentProductId;
      var notSamePackageName = (prod.ratePackageName || '') !== currentRatePackage;
      return notEmpty && (notSameProductId || notSamePackageName);
    });
    var availableFields = productType === 'Accommodation' ? ['seasonRates', 'extras', 'offers', 'allocation', 'blackouts', 'productPolicy'] : ['seasonRates', 'extras', 'offers', 'allocation', 'blackouts', 'pickup', 'dropoff', 'productPolicy'];
    return {
      addedProducts: notEmptyRatePackages,
      withoutRates: true,
      productSelectedToBeCopied: notEmptyRatePackages.length === 1 ? 0 : -1,
      availableFields: availableFields.map(function (field) {
        return { field: field, checked: true };
      }),
      thisProductType: productType,
      noShowIfEmpty: noShowIfEmpty
    };
  }], [_ramda2.default.equals('editSeason'), _ramda2.default.always({
    existingSeasons: existingSeasons
  })], [_ramda2.default.equals('manageExtrasOffers'), function () {
    var list = offersOrExtras.type === 'offers' ? allOffers.map(function (obj) {
      return _ramda2.default.merge(obj, {
        validDatesOfSale: function () {
          if (obj.isStayPay) return [{ fromDate: new Date().toISOString(), toDate: endDate }];
          if (obj.validDatesOfSale.length) return obj.validDatesOfSale;
          return [{}];
        }(),
        validDatesOfTravel: obj.validDatesOfTravel.length ? obj.validDatesOfTravel : [{}]
      });
    }) : allExtras;
    var retVal = {
      offersOrExtras: {
        selectedId: offersOrExtras.selectedId || _ramda2.default.path([0, '_id'], list),
        toDelete: offersOrExtras.toDelete ? ratePackageId : null,
        productsArray: productsArray,
        productType: productType,
        list: list
      }
    };
    if (offersOrExtras.createNew) {
      if (offersOrExtras.type === 'offers') {
        retVal.data = {
          title: data.title,
          offerName: '',
          offerDetail: '',
          specialConditions: '',
          allowCombination: false,
          validDatesOfSale: [{ fromDate: (0, _moment2.default)(new Date()).isAfter(endDate) ? startDate : _moment2.default.utc().startOf('day').toISOString(), toDate: endDate }],
          validDatesOfTravel: [{}],
          ratePackages: productsArray.map(function (p) {
            return p._id;
          })
        };
      } else {
        retVal.data = {
          title: data.title,
          ratePackages: productsArray.map(function (p) {
            return p._id;
          })
        };
      }
    }
    if (offersOrExtras.toDelete) {
      retVal.offersOrExtras.list = retVal.offersOrExtras.list.map(function (o) {
        if (o._id === retVal.offersOrExtras.selectedId) return _extends({}, o, { ratePackages: o.ratePackages.filter(function (x) {
            return x !== ratePackageId;
          }) });
        return o;
      });
    }
    return retVal;
  }], [_ramda2.default.equals('updateBeddingConfig'), function () {
    var foundProd = allContractingReadyProducts.find(function (p) {
      return p.productId === draftContentInView.productId;
    });
    return {
      title: 'Update Bedding Configuration',
      bedsAndSofas: foundProd ? foundProd.bedsAndSofas : { rooms: [[]], isApartment: false }
    };
  }]]), editType);
};

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.importSuccess = importSuccess;
exports.refreshContractDoc = refreshContractDoc;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _effects = __webpack_require__(36);

var _reduxSaga = __webpack_require__(92);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRouterRedux = __webpack_require__(27);

var _string = __webpack_require__(959);

var _api = __webpack_require__(37);

var _composeDraftEditDataByType = __webpack_require__(608);

var _composeDraftEditDataByType2 = _interopRequireDefault(_composeDraftEditDataByType);

var _sagas = __webpack_require__(43);

var _contractListConstants = __webpack_require__(560);

var conListConst = _interopRequireWildcard(_contractListConstants);

var _constants = __webpack_require__(252);

var cnt = _interopRequireWildcard(_constants);

var _constants2 = __webpack_require__(233);

var wpCnts = _interopRequireWildcard(_constants2);

var _globalErrorsDisplayActions = __webpack_require__(486);

var _contractListActions = __webpack_require__(563);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchContracts),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(archiveSelectedContracts),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(populateEditDialog),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(createProductOrImport),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(getRespondedContractsForRequest),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(getContractNotes),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(deleteContractNote),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(afterGettingMetaData),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(triggerLoadContractList),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(getContractList),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(doUpdateFolders),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(doChangeContractListRoute),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(getRequestForSupplierWizard),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(downloadContractingDocs),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(downloadContractingDocsSuccess),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(shouldAskToAccept),
    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(acceptRatesAfterDownload),
    _marked18 = /*#__PURE__*/regeneratorRuntime.mark(exportExcel),
    _marked19 = /*#__PURE__*/regeneratorRuntime.mark(handleExportExcel),
    _marked20 = /*#__PURE__*/regeneratorRuntime.mark(handleExportExcelError),
    _marked21 = /*#__PURE__*/regeneratorRuntime.mark(handleArchiveUnarchiveTemplate),
    _marked22 = /*#__PURE__*/regeneratorRuntime.mark(updateContractRequestPartner),
    _marked23 = /*#__PURE__*/regeneratorRuntime.mark(submitContractingComment),
    _marked24 = /*#__PURE__*/regeneratorRuntime.mark(getContractForwardingEmail),
    _marked25 = /*#__PURE__*/regeneratorRuntime.mark(getDiffReport),
    _marked26 = /*#__PURE__*/regeneratorRuntime.mark(getDiffReportForDraft),
    _marked27 = /*#__PURE__*/regeneratorRuntime.mark(getAvailDocsForDiffReport),
    _marked28 = /*#__PURE__*/regeneratorRuntime.mark(getDiffReportForViewChanges),
    _marked29 = /*#__PURE__*/regeneratorRuntime.mark(doSendReviewRatesEmail),
    _marked30 = /*#__PURE__*/regeneratorRuntime.mark(updateTemplateListUrl),
    _marked31 = /*#__PURE__*/regeneratorRuntime.mark(manageExtrasOffers),
    _marked32 = /*#__PURE__*/regeneratorRuntime.mark(importSuccess),
    _marked33 = /*#__PURE__*/regeneratorRuntime.mark(refreshContractDoc),
    _marked34 = /*#__PURE__*/regeneratorRuntime.mark(afterUpdateContractPartnerInfoSuccess),
    _marked35 = /*#__PURE__*/regeneratorRuntime.mark(updateSameAsCorporate),
    _marked36 = /*#__PURE__*/regeneratorRuntime.mark(removeMasterTemplate),
    _marked37 = /*#__PURE__*/regeneratorRuntime.mark(refreshTemplateList),
    _marked38 = /*#__PURE__*/regeneratorRuntime.mark(afterRemoveDraftFromQueue),
    _marked39 = /*#__PURE__*/regeneratorRuntime.mark(sendTourWriter),
    _marked40 = /*#__PURE__*/regeneratorRuntime.mark(tourWriterStart),
    _marked41 = /*#__PURE__*/regeneratorRuntime.mark(tourWriterError),
    _marked42 = /*#__PURE__*/regeneratorRuntime.mark(removeSingleFeedByTCAdmin),
    _marked43 = /*#__PURE__*/regeneratorRuntime.mark(markHistoryFeedAsRead),
    _marked44 = /*#__PURE__*/regeneratorRuntime.mark(updateContractActivities),
    _marked45 = /*#__PURE__*/regeneratorRuntime.mark(getTemplateChangeLogs),
    _marked46 = /*#__PURE__*/regeneratorRuntime.mark(onRouteChange),
    _marked47 = /*#__PURE__*/regeneratorRuntime.mark(fileContractForRequest),
    _marked48 = /*#__PURE__*/regeneratorRuntime.mark(fileContractForRequestSuccess),
    _marked49 = /*#__PURE__*/regeneratorRuntime.mark(removeContractsFromRequests),
    _marked50 = /*#__PURE__*/regeneratorRuntime.mark(removeContractsFromRequestsSuccess),
    _marked51 = /*#__PURE__*/regeneratorRuntime.mark(handleOpenReSendContractDialog),
    _marked52 = /*#__PURE__*/regeneratorRuntime.mark(handleAfterMadeACopyOfATemplate),
    _marked53 = /*#__PURE__*/regeneratorRuntime.mark(makeACopyForBuyer),
    _marked54 = /*#__PURE__*/regeneratorRuntime.mark(updateWorkspaceContract),
    _marked55 = /*#__PURE__*/regeneratorRuntime.mark(requestDL),
    _marked56 = /*#__PURE__*/regeneratorRuntime.mark(afterRequestDLSuccess),
    _marked57 = /*#__PURE__*/regeneratorRuntime.mark(searchCCTemplates),
    _marked58 = /*#__PURE__*/regeneratorRuntime.mark(getProductsForOmniImport),
    _marked59 = /*#__PURE__*/regeneratorRuntime.mark(doOmniImport),
    _marked60 = /*#__PURE__*/regeneratorRuntime.mark(editProductProfile),
    _marked61 = /*#__PURE__*/regeneratorRuntime.mark(editProductProfileSuccess); /* global window */


function fetchContracts() {
  var contractPeriod, searchCompanyName, searchDomain;
  return regeneratorRuntime.wrap(function fetchContracts$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_ramda2.default.path(['contracting', 'requestsWithSameNameOrDomainDialog', 'contractPeriod']));

        case 2:
          contractPeriod = _context.sent;
          _context.next = 5;
          return (0, _effects.select)(_ramda2.default.path(['contracting', 'requestsWithSameNameOrDomainDialog', 'searchCompanyName']));

        case 5:
          searchCompanyName = _context.sent;
          _context.next = 8;
          return (0, _effects.select)(_ramda2.default.path(['contracting', 'requestsWithSameNameOrDomainDialog', 'searchDomain']));

        case 8:
          searchDomain = _context.sent;
          return _context.delegateYield((0, _sagas.apiSaga)('GET_CONTRACT_REQUESTS_BY_COMPANY', _api.contracting.getContractList, [{
            currentYear: contractPeriod,
            listType: 'search',
            searchCategory: 'sent',
            searchingAllYears: false,
            page: 1,
            searchInput: searchCompanyName || searchDomain
          }]), 't0', 10);

        case 10:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function archiveSelectedContracts() {
  var selectedIds;
  return regeneratorRuntime.wrap(function archiveSelectedContracts$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)(_ramda2.default.path(['contracting', 'requestsWithSameNameOrDomainDialog', 'selectedIds']));

        case 2:
          selectedIds = _context2.sent;
          return _context2.delegateYield((0, _sagas.apiSaga)('DISCARD_SELECTED_IN_REQUESTS_WITH_SAME_NAME_DIALOG', _api.contracting.deleteOrUndelete, [{ contractIds: selectedIds, state: true }]), 't0', 4);

        case 4:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function populateEditDialog() {
  var dialogForEdit, ratePackageIndexForEdit, productIdForEdit, ratePackageNameForEdit, ratePackageIdForEdit, policiesNotesPage, type, contractActivitiesProducts, draftContentInView, draftMetaData, draftId, ratePackageIndexInView, productId, needToGoToNewProduct, needToGoToNotesPolicies, rpId, composedData;
  return regeneratorRuntime.wrap(function populateEditDialog$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.addEditContractDialog.toJS();
          });

        case 2:
          dialogForEdit = _context3.sent;
          ratePackageIndexForEdit = dialogForEdit.ratePackageIndex, productIdForEdit = dialogForEdit.productId, ratePackageNameForEdit = dialogForEdit.ratePackageName, ratePackageIdForEdit = dialogForEdit.ratePackageId, policiesNotesPage = dialogForEdit.policiesNotesPage, type = dialogForEdit.type;

          if (!type) {
            _context3.next = 38;
            break;
          }

          _context3.next = 7;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractActivitiesProducts.toJS();
          });

        case 7:
          contractActivitiesProducts = _context3.sent;
          draftContentInView = contractActivitiesProducts.rightSideContent, draftMetaData = contractActivitiesProducts.leftNav;
          draftId = draftMetaData.contractId;
          ratePackageIndexInView = draftContentInView.ratePackageIndex, productId = draftContentInView.productId;
          // the edit happens while user is in policies and notes page

          needToGoToNewProduct = !isNaN(ratePackageIndexForEdit) && ratePackageIndexForEdit !== ratePackageIndexInView;
          // the edit happens while user is in product page

          needToGoToNotesPolicies = policiesNotesPage && productId;

          if (!(needToGoToNewProduct || needToGoToNotesPolicies)) {
            _context3.next = 23;
            break;
          }

          if (!needToGoToNewProduct) {
            _context3.next = 18;
            break;
          }

          rpId = function () {
            if (ratePackageIdForEdit) return ratePackageIdForEdit;
            return ratePackageNameForEdit ? encodeURIComponent(ratePackageNameForEdit) : 'Primary';
          }();

          _context3.next = 18;
          return (0, _effects.put)((0, _reactRouterRedux.replace)('/contracting/draft/' + draftId + '/product/' + productIdForEdit + '/' + rpId));

        case 18:
          if (!needToGoToNotesPolicies) {
            _context3.next = 21;
            break;
          }

          _context3.next = 21;
          return (0, _effects.put)((0, _reactRouterRedux.replace)('/contracting/draft/' + draftId + '/policies'));

        case 21:
          _context3.next = 38;
          break;

        case 23:
          composedData = (0, _composeDraftEditDataByType2.default)(dialogForEdit, contractActivitiesProducts);

          if (!(type === 'copyDataFromAnotherProduct')) {
            _context3.next = 36;
            break;
          }

          if (!(composedData.noShowIfEmpty && _ramda2.default.isEmpty(composedData.addedProducts))) {
            _context3.next = 30;
            break;
          }

          _context3.next = 28;
          return (0, _effects.put)({ type: 'CLOSE_ADD_EDIT_CONTRACT_DIALOG' });

        case 28:
          _context3.next = 34;
          break;

        case 30:
          _context3.next = 32;
          return (0, _effects.call)(_reduxSaga.delay, 300);

        case 32:
          _context3.next = 34;
          return (0, _effects.put)({
            type: 'OPEN_AND_POPULATE_ADD_EDIT_CONTRACT_DIALOG',
            payload: composedData.offersOrExtras ? composedData : { data: composedData }
          });

        case 34:
          _context3.next = 38;
          break;

        case 36:
          _context3.next = 38;
          return (0, _effects.put)({
            type: 'OPEN_AND_POPULATE_ADD_EDIT_CONTRACT_DIALOG',
            payload: composedData && composedData.offersOrExtras ? composedData : { data: composedData }
          });

        case 38:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function createProductOrImport(payload) {
  var _ref, type, isDummyAccount, isTrueSupplier;

  return regeneratorRuntime.wrap(function createProductOrImport$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(function (state) {
            return state.user.toJS();
          });

        case 2:
          _ref = _context4.sent;
          type = _ref.user.type;
          isDummyAccount = _ref.isDummyAccount;
          isTrueSupplier = type === 'Supplier' && !isDummyAccount;
          // show import dialog when user hasn't edited the draft

          if (!(payload.hasSeenResponseWizard === false && (!isTrueSupplier || payload.templates && payload.templates.length))) {
            _context4.next = 11;
            break;
          }

          _context4.next = 9;
          return (0, _effects.put)({
            type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
            payload: {
              type: 'importFromTemplate',
              data: { forNewDraft: true }
            }
          });

        case 9:
          _context4.next = 14;
          break;

        case 11:
          if (!_ramda2.default.isEmpty(payload.productsArray)) {
            _context4.next = 14;
            break;
          }

          _context4.next = 14;
          return (0, _effects.put)({
            type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
            payload: {
              type: 'addProducts',
              data: { isFirstProduct: true }
            }
          });

        case 14:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function getRespondedContractsForRequest(type, requestId) {
  return regeneratorRuntime.wrap(function getRespondedContractsForRequest$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.getRespondedContractList, [{ requestId: requestId }]), 't0', 1);

        case 1:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

// for notes page in contract
function getContractNotes() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      payload = _ref2.payload;

  var historyFeedId;
  return regeneratorRuntime.wrap(function getContractNotes$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          if (!(payload && payload.historyFeedId)) {
            _context6.next = 4;
            break;
          }

          _context6.t0 = payload.historyFeedId;
          _context6.next = 7;
          break;

        case 4:
          _context6.next = 6;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractActivitiesProducts.getIn(['leftNav', 'historyFeedId']);
          });

        case 6:
          _context6.t0 = _context6.sent;

        case 7:
          historyFeedId = _context6.t0;
          return _context6.delegateYield((0, _sagas.apiSaga)(cnt.GET_NOTES, _api.workspace.getActivities, [{ assetId: historyFeedId, activityType: 'note' }]), 't1', 9);

        case 9:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function deleteContractNote(_ref3) {
  var payload = _ref3.payload,
      type = _ref3.type;
  return regeneratorRuntime.wrap(function deleteContractNote$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          return _context7.delegateYield((0, _sagas.apiSaga)(type, _api.workspace.deleteMessage, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function afterGettingMetaData() {
  var dialogForEdit, _ref4, leftNav, isInitialDraft, isContractRequest, isInNotes, docId;

  return regeneratorRuntime.wrap(function afterGettingMetaData$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.addEditContractDialog.toJS();
          });

        case 2:
          dialogForEdit = _context8.sent;
          _context8.next = 5;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractActivitiesProducts.toJS();
          });

        case 5:
          _ref4 = _context8.sent;
          leftNav = _ref4.leftNav;

          if (!dialogForEdit.type) {
            _context8.next = 9;
            break;
          }

          return _context8.abrupt('return');

        case 9:
          isInitialDraft = leftNav.contractState === 'draft' && leftNav.originFrom === 'initial';
          isContractRequest = !leftNav.locationId;
          isInNotes = window.location.pathname.indexOf('notes') > -1;

          if (!isInitialDraft) {
            _context8.next = 15;
            break;
          }

          _context8.next = 15;
          return createProductOrImport(leftNav);

        case 15:
          docId = leftNav.contractId;

          if (!isContractRequest) {
            _context8.next = 19;
            break;
          }

          _context8.next = 19;
          return getRespondedContractsForRequest('[contract-request]GET_RESPONDED_CONTRACT_LIST', docId);

        case 19:
          if (!isInNotes) {
            _context8.next = 22;
            break;
          }

          _context8.next = 22;
          return getContractNotes();

        case 22:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function triggerLoadContractList() {
  var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var payload, type, notTogglingAdvanceSearch, _ref5, currentRoute, _ref6, leftNav;

  return regeneratorRuntime.wrap(function triggerLoadContractList$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          if (!(window.location.pathname.indexOf('contract-list') > -1)) {
            _context9.next = 13;
            break;
          }

          payload = action.payload, type = action.type;
          notTogglingAdvanceSearch = !Boolean(type === '[contract-list]UPDATE_SEARCH_PARAMS' && _ramda2.default.keys(payload).length === 1 && _ramda2.default.has('openAdvanceSearch', payload));

          if (!notTogglingAdvanceSearch) {
            _context9.next = 11;
            break;
          }

          _context9.next = 6;
          return (0, _effects.select)(_ramda2.default.path(['routing', 'locationBeforeTransitions']));

        case 6:
          _ref5 = _context9.sent;
          currentRoute = _ref5.pathname;

          if (!(currentRoute.indexOf('contract-list') > -1)) {
            _context9.next = 11;
            break;
          }

          _context9.next = 11;
          return (0, _effects.put)({ type: 'LOAD_CONTRACT_LIST_FROM_BACKEND', payload: true });

        case 11:
          _context9.next = 19;
          break;

        case 13:
          _context9.next = 15;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractActivitiesProducts.toJS();
          });

        case 15:
          _ref6 = _context9.sent;
          leftNav = _ref6.leftNav;
          _context9.next = 19;
          return getRespondedContractsForRequest('[contract-request]GET_RESPONDED_CONTRACT_LIST', leftNav.contractId);

        case 19:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function getContractList() {
  var currentYear, _ref7, list, searchParams, params;

  return regeneratorRuntime.wrap(function getContractList$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.select)(_ramda2.default.path(['contracting', 'currentYear']));

        case 2:
          currentYear = _context10.sent;
          _context10.next = 5;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractList.toJS();
          });

        case 5:
          _ref7 = _context10.sent;
          list = _ref7.list;
          searchParams = _ref7.searchParams;
          params = _extends({
            listType: list.listType || searchParams.searchCategory || 'recent',
            page: list.page || 1,
            currentYear: currentYear
          }, searchParams);
          return _context10.delegateYield((0, _sagas.apiSaga)(conListConst.LOAD_CONTRACT_LIST, _api.contracting.getContractList, [params]), 't0', 10);

        case 10:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function doUpdateFolders() {
  var _ref8, folders, originalFolder, newFolderName;

  return regeneratorRuntime.wrap(function doUpdateFolders$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractList.toJS();
          });

        case 2:
          _ref8 = _context11.sent;
          folders = _ref8.folders;
          originalFolder = _ref8.originalFolder;
          newFolderName = _ref8.newFolderName;
          return _context11.delegateYield((0, _sagas.apiSaga)('[contract-list]UPDATE_FOLDER_NAME', _api.contracting.updateFolders, [{ folders: folders, originalFolder: originalFolder, newFolderName: newFolderName }]), 't0', 7);

        case 7:
          _context11.next = 9;
          return (0, _effects.put)({ type: '[contract-list]CHANGE_ROUTE', payload: { routeName: newFolderName, isFolder: true } });

        case 9:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function doChangeContractListRoute() {
  var _ref9, searchParams, list, uriEncoded;

  return regeneratorRuntime.wrap(function doChangeContractListRoute$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractList.toJS();
          });

        case 2:
          _ref9 = _context12.sent;
          searchParams = _ref9.searchParams;
          list = _ref9.list;
          uriEncoded = encodeURIComponent(list.listType || '');
          _context12.next = 8;
          return (0, _effects.put)((0, _reactRouterRedux.replace)({
            pathname: '/contracting/contract-list/' + uriEncoded,
            query: { isFolder: searchParams.isFolder }
          }));

        case 8:
          _context12.next = 10;
          return triggerLoadContractList();

        case 10:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function getRequestForSupplierWizard() {
  var requestId;
  return regeneratorRuntime.wrap(function getRequestForSupplierWizard$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.supplierWizard.toJS().contractRequest.contractId;
          });

        case 2:
          requestId = _context13.sent;

          if (!requestId) {
            _context13.next = 5;
            break;
          }

          return _context13.delegateYield((0, _sagas.apiSaga)('[supplier-wizard]GET_CONTRACT_REQUEST_INFO_SUPPLIER_WIZARD', _api.contracting.getContractRequestInfo, [{ requestId: requestId }]), 't0', 5);

        case 5:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function downloadContractingDocs() {
  var payload, payload2, docIds;
  return regeneratorRuntime.wrap(function downloadContractingDocs$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.select)(_ramda2.default.path(['contracting', 'downloadDocs']));

        case 2:
          payload = _context14.sent;

          if (payload) {
            _context14.next = 5;
            break;
          }

          return _context14.abrupt('return');

        case 5:
          payload2 = _ramda2.default.pick(['collection', 'locale', 'ratesOnly', 'downloadRateFormat', 'forAL'], payload);

          docIds = function () {
            if (!_ramda2.default.isEmpty(payload.contractIds || [])) {
              return payload.contractIds;
            }
            if (!_ramda2.default.isEmpty(payload.templates || [])) {
              return payload.templates.map(function (_ref10) {
                var _id = _ref10._id;
                return _id;
              });
            }
            if (payload.docId) {
              return [payload.docId];
            }
            return []; // ?? nothing to do
          }();

          if (docIds.length === 1 && _ramda2.default.last(payload2.downloadRateFormat.split('_')) === 'singlefile') {
            // should not be single file if it is a single doc
            payload2.downloadRateFormat = payload2.downloadRateFormat.split('_').splice(0, 2).join('_');
          }
          // return R.isEmpty(payload.contractIds) ? [payload.docId] : payload.contractIds;
          // });
          _context14.next = 10;
          return (0, _sagas.apiSaga)('[contracting-download] downloadGroup', _api.fileUrls.downloadGroup, [_extends({}, payload2, {
            docIds: docIds
          })]);

        case 10:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function downloadContractingDocsSuccess(_ref11) {
  var type = _ref11.type,
      payload = _ref11.payload;

  var _ref12, forAL, url;

  return regeneratorRuntime.wrap(function downloadContractingDocsSuccess$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.select)(_ramda2.default.path(['contracting', 'downloadDocs']));

        case 2:
          _ref12 = _context15.sent;
          forAL = _ref12.forAL;

          if (!(payload.status === 'processed' && payload.returnValue)) {
            _context15.next = 10;
            break;
          }

          url = _ramda2.default.path(['url'], (0, _string.jsonParseFn)(payload.returnValue));
          // check if w ehave a return value URL or product an error

          if (!url) {
            _context15.next = 10;
            break;
          }

          _context15.next = 9;
          return (0, _effects.put)({
            type: type + '_SUCCESS',
            payload: { url: url }
          });

        case 9:
          return _context15.abrupt('return', _context15.sent);

        case 10:
          if (!(payload.status === 'pending' && payload.jobUrl)) {
            _context15.next = 16;
            break;
          }

          _context15.next = 13;
          return (0, _effects.call)(_reduxSaga.delay, 3e3);

        case 13:
          _context15.next = 15;
          return (0, _sagas.apiSaga)('[contracting-download] downloadGroup', _api.fileUrls.checkJobUrl, [_extends({}, payload, {
            forAL: forAL
          })]);

        case 15:
          return _context15.abrupt('return', _context15.sent);

        case 16:
          _context15.next = 18;
          return (0, _effects.put)({
            type: type + '_ERROR'
          });

        case 18:
          return _context15.abrupt('return', _context15.sent);

        case 19:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}

function downloadContractingUrl(_ref13) {
  var payload = _ref13.payload;

  var a = document.createElement('a');
  a.download = true;
  a.target = '_blank';
  a.setAttribute('download', true);
  a.href = payload.url;
  a.dispatchEvent(new MouseEvent('click'));
  // window.open(payload.url, '_blank');
}

function shouldAskToAccept(_ref14) {
  var type = _ref14.type;

  var _ref15, contractIds, docId, _ref16, rates, viewAs, singleContractIsPending, someBulkDownloadedContractsArePending, currentState, _viewAs;

  return regeneratorRuntime.wrap(function shouldAskToAccept$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.downloadDocs;
          });

        case 2:
          _ref15 = _context16.sent;
          contractIds = _ref15.contractIds;
          docId = _ref15.docId;

          if (!(window.location.pathname.indexOf('assets-landing') > -1)) {
            _context16.next = 23;
            break;
          }

          _context16.next = 8;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 8:
          _ref16 = _context16.sent;
          rates = _ref16.rates;
          viewAs = _ref16.viewAs;
          singleContractIsPending = docId && rates.find(function (o) {
            return o._id === docId && o.state === 'pending';
          });
          someBulkDownloadedContractsArePending = contractIds && contractIds.length && contractIds.some(function (id) {
            return rates.find(function (o) {
              return o._id === id && o.state === 'pending';
            });
          });

          if (!(viewAs === 'Contractor' && (singleContractIsPending || someBulkDownloadedContractsArePending))) {
            _context16.next = 18;
            break;
          }

          _context16.next = 16;
          return (0, _effects.put)({ type: '[contracting-download]ASK_ACCEPT_AFTER_DOWNLOAD' });

        case 16:
          _context16.next = 21;
          break;

        case 18:
          if (!(type === '[contracting-download]DOWNLOAD_SINGLE_CONTRACT_DOC_SUCCESS')) {
            _context16.next = 21;
            break;
          }

          _context16.next = 21;
          return (0, _effects.put)({ type: '[contracting-download]CLOSE_DOWNLOAD_POPOVER' });

        case 21:
          _context16.next = 43;
          break;

        case 23:
          if (!(window.location.pathname.indexOf('/contracting/contract/') > -1)) {
            _context16.next = 40;
            break;
          }

          _context16.next = 26;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractActivitiesProducts.getIn(['leftNav', 'state']);
          });

        case 26:
          currentState = _context16.sent;
          _context16.next = 29;
          return (0, _effects.select)(function (state) {
            return state.user.getIn(['company', 'companyType']);
          });

        case 29:
          _viewAs = _context16.sent;

          if (!(currentState === 'pending' && _viewAs === 'Contractor')) {
            _context16.next = 35;
            break;
          }

          _context16.next = 33;
          return (0, _effects.put)({ type: '[contracting-download]ASK_ACCEPT_AFTER_DOWNLOAD' });

        case 33:
          _context16.next = 38;
          break;

        case 35:
          if (!(type === '[contracting-download]DOWNLOAD_SINGLE_CONTRACT_DOC_SUCCESS')) {
            _context16.next = 38;
            break;
          }

          _context16.next = 38;
          return (0, _effects.put)({ type: '[contracting-download]CLOSE_DOWNLOAD_POPOVER' });

        case 38:
          _context16.next = 43;
          break;

        case 40:
          if (!(type === '[contracting-download]DOWNLOAD_SINGLE_CONTRACT_DOC_SUCCESS')) {
            _context16.next = 43;
            break;
          }

          _context16.next = 43;
          return (0, _effects.put)({ type: '[contracting-download]CLOSE_DOWNLOAD_POPOVER' });

        case 43:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked16, this);
}

function acceptRatesAfterDownload(_ref17) {
  var type = _ref17.type;

  var _ref18, contractIds, docId, forAL;

  return regeneratorRuntime.wrap(function acceptRatesAfterDownload$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.downloadDocs;
          });

        case 2:
          _ref18 = _context17.sent;
          contractIds = _ref18.contractIds;
          docId = _ref18.docId;
          forAL = _ref18.forAL;
          _context17.next = 8;
          return (0, _sagas.apiSaga)(type, _api.contracting.updateContractStatus, [{
            contractIds: contractIds && contractIds.length ? contractIds : [docId],
            state: 'accepted',
            forAL: forAL
          }]);

        case 8:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked17, this);
}

function exportExcel(_ref19) {
  var type = _ref19.type,
      exportType = _ref19.payload.exportType;

  var _ref20, docId, collection;

  return regeneratorRuntime.wrap(function exportExcel$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.select)(_ramda2.default.path(['contracting', 'downloadDocs']));

        case 2:
          _ref20 = _context18.sent;
          docId = _ref20.docId;
          collection = _ref20.collection;

          if (!docId) {
            _context18.next = 8;
            break;
          }

          _context18.next = 8;
          return (0, _sagas.apiSaga)(type, _api.downloads.getXls, [collection, docId, exportType]);

        case 8:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked18, this);
}

function handleExportExcel(_ref21) {
  var location = _ref21.payload.location;
  return regeneratorRuntime.wrap(function handleExportExcel$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _effects.put)({ type: '[contracting-download]CLOSE_DOWNLOAD_POPOVER' });

        case 2:
          _context19.next = 4;
          return (0, _effects.put)((0, _globalErrorsDisplayActions.triggerError)({ errorMessageObj: _react2.default.createElement(
              'a',
              { href: location, target: '_blank', rel: 'noopener noreferrer' },
              'Click to Download'
            ) }));

        case 4:
          window.open(location);

        case 5:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked19, this);
}

function handleExportExcelError() {
  return regeneratorRuntime.wrap(function handleExportExcelError$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return (0, _effects.put)({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Unable to generate quickview file' });

        case 2:
          return _context20.delegateYield((0, _effects.put)({ type: '[contracting-download]CLOSE_DOWNLOAD_POPOVER' }), 't0', 3);

        case 3:
        case 'end':
          return _context20.stop();
      }
    }
  }, _marked20, this);
}

function handleArchiveUnarchiveTemplate(_ref22) {
  var payload = _ref22.payload;
  return regeneratorRuntime.wrap(function handleArchiveUnarchiveTemplate$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          return _context21.delegateYield((0, _sagas.apiSaga)('ARCHIVE_UNARCHIVE_TEMPLATE', _api.contracting.archiveUnarchiveTemplate, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked21, this);
}

function updateContractRequestPartner() {
  var _ref23, updatePartnerForAllContracts, contractId, newEmails, updatedEmails, removedEmails, newPartnerName, removeContactFromPartner;

  return regeneratorRuntime.wrap(function updateContractRequestPartner$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.resendContractDialog.toJS();
          });

        case 2:
          _ref23 = _context22.sent;
          updatePartnerForAllContracts = _ref23.updatePartnerForAllContracts;
          contractId = _ref23.contractId;
          newEmails = _ref23.newEmails;
          updatedEmails = _ref23.updatedEmails;
          removedEmails = _ref23.removedEmails;
          newPartnerName = _ref23.newPartnerName;
          removeContactFromPartner = _ref23.removeContactFromPartner;
          return _context22.delegateYield((0, _sagas.apiSaga)('UPDATE_CONTRACT_PARTNER_INFO', _api.contracting.updatePartnerForSentDoc, [{
            contractId: contractId,
            newEmails: newEmails.filter(function (s) {
              return s && s.trim();
            }).map(function (s) {
              return s.toLowerCase();
            }),
            updatedEmails: updatedEmails,
            newPartnerName: (newPartnerName || '').trim(),
            removedEmails: removedEmails,
            updatePartnerForAllContracts: updatePartnerForAllContracts,
            removeContactFromPartner: removeContactFromPartner
          }]), 't0', 11);

        case 11:
        case 'end':
          return _context22.stop();
      }
    }
  }, _marked22, this);
}

function submitContractingComment(_ref24) {
  var type = _ref24.type,
      payload = _ref24.payload;
  var files, message, contractId, historyFeedId;
  return regeneratorRuntime.wrap(function submitContractingComment$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          files = payload.files, message = payload.message, contractId = payload.contractId, historyFeedId = payload.historyFeedId;
          return _context23.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.submitContractingComment, [{
            files: files,
            message: message,
            contractId: contractId,
            historyFeedId: historyFeedId
          }]), 't0', 2);

        case 2:
        case 'end':
          return _context23.stop();
      }
    }
  }, _marked23, this);
}

function getContractForwardingEmail(_ref25) {
  var type = _ref25.type,
      payload = _ref25.payload;
  return regeneratorRuntime.wrap(function getContractForwardingEmail$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          return _context24.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.getContractForwardingEmail, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context24.stop();
      }
    }
  }, _marked24, this);
}

function getDiffReport(_ref26) {
  var type = _ref26.type,
      payload = _ref26.payload;
  return regeneratorRuntime.wrap(function getDiffReport$(_context25) {
    while (1) {
      switch (_context25.prev = _context25.next) {
        case 0:
          return _context25.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.getDiffReport, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context25.stop();
      }
    }
  }, _marked25, this);
}
function getDiffReportForDraft() {
  var contractActivitiesProducts, draftMetaData, draftId;
  return regeneratorRuntime.wrap(function getDiffReportForDraft$(_context26) {
    while (1) {
      switch (_context26.prev = _context26.next) {
        case 0:
          _context26.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractActivitiesProducts.toJS();
          });

        case 2:
          contractActivitiesProducts = _context26.sent;
          draftMetaData = contractActivitiesProducts.leftNav;
          draftId = draftMetaData.contractId;
          return _context26.delegateYield((0, _sagas.apiSaga)('GET_DIFF_SUMMARY_FOR_DRAFT', _api.contracting.getDiffReport, [{ docs: 'draft:' + draftId + ':' + draftId, onlyGetSummary: true }]), 't0', 6);

        case 6:
        case 'end':
          return _context26.stop();
      }
    }
  }, _marked26, this);
}
function getAvailDocsForDiffReport(_ref27) {
  var type = _ref27.type,
      payload = _ref27.payload;
  return regeneratorRuntime.wrap(function getAvailDocsForDiffReport$(_context27) {
    while (1) {
      switch (_context27.prev = _context27.next) {
        case 0:
          if (!(payload.collection === 'template')) {
            _context27.next = 4;
            break;
          }

          return _context27.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.getTemplates, [{ query: { locationId: payload.locationId } }]), 't0', 2);

        case 2:
          _context27.next = 5;
          break;

        case 4:
          return _context27.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.getContracts, [{
            query: _extends({}, { locationId: payload.locationId }, payload.buyerId ? { ownerIds: payload.buyerId } : {}, payload.email ? { toEmails: payload.email } : {})
          }]), 't1', 5);

        case 5:
        case 'end':
          return _context27.stop();
      }
    }
  }, _marked27, this);
}
function getDiffReportForViewChanges(_ref28) {
  var type = _ref28.type,
      payload = _ref28.payload;
  return regeneratorRuntime.wrap(function getDiffReportForViewChanges$(_context28) {
    while (1) {
      switch (_context28.prev = _context28.next) {
        case 0:
          if (!payload.open) {
            _context28.next = 2;
            break;
          }

          return _context28.delegateYield(getDiffReportForDraft(), 't0', 2);

        case 2:
        case 'end':
          return _context28.stop();
      }
    }
  }, _marked28, this);
}

function doSendReviewRatesEmail(_ref29) {
  var type = _ref29.type;

  var _ref30, leftNav, _ref31, _ref31$company, companyId, companyName;

  return regeneratorRuntime.wrap(function doSendReviewRatesEmail$(_context29) {
    while (1) {
      switch (_context29.prev = _context29.next) {
        case 0:
          _context29.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractActivitiesProducts.toJS();
          });

        case 2:
          _ref30 = _context29.sent;
          leftNav = _ref30.leftNav;
          _context29.next = 6;
          return (0, _effects.select)(function (state) {
            return state.user.toJS();
          });

        case 6:
          _ref31 = _context29.sent;
          _ref31$company = _ref31.company;
          companyId = _ref31$company.companyId;
          companyName = _ref31$company.companyName;
          return _context29.delegateYield((0, _sagas.apiSaga)(type, _api.account.sendInternalEmail, [{
            type: 'reviewByExpert',
            company: {
              companyId: companyId,
              companyName: companyName
            },
            draft: {
              draftId: leftNav.contractId,
              name: leftNav.templateName
            }
          }]), 't0', 11);

        case 11:
        case 'end':
          return _context29.stop();
      }
    }
  }, _marked29, this);
}

function updateTemplateListUrl(_ref32) {
  var payload = _ref32.payload;
  return regeneratorRuntime.wrap(function updateTemplateListUrl$(_context30) {
    while (1) {
      switch (_context30.prev = _context30.next) {
        case 0:
          if (!(window.location.pathname.indexOf('template-list') > -1 && window.location.pathname.indexOf('showType') === -1)) {
            _context30.next = 3;
            break;
          }

          _context30.next = 3;
          return (0, _effects.put)((0, _reactRouterRedux.replace)({
            pathname: '/contracting/template-list',
            query: {
              showType: payload.locations.length > 1 ? 'location' : ''
            }
          }));

        case 3:
        case 'end':
          return _context30.stop();
      }
    }
  }, _marked30, this);
}

function manageExtrasOffers(_ref33) {
  var type = _ref33.type,
      _ref33$payload = _ref33.payload,
      payload = _ref33$payload === undefined ? {} : _ref33$payload;

  var _ref34, addEditContractDialog, contractActivitiesProducts, _addEditContractDialo, offersOrExtras;

  return regeneratorRuntime.wrap(function manageExtrasOffers$(_context31) {
    while (1) {
      switch (_context31.prev = _context31.next) {
        case 0:
          _context31.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting;
          });

        case 2:
          _ref34 = _context31.sent;
          addEditContractDialog = _ref34.addEditContractDialog;
          contractActivitiesProducts = _ref34.contractActivitiesProducts;
          _addEditContractDialo = addEditContractDialog.toJS(), offersOrExtras = _addEditContractDialo.offersOrExtras;
          return _context31.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.manageExtrasOffers, [{
            type: offersOrExtras.type,
            list: payload.list || offersOrExtras.list,
            draftId: contractActivitiesProducts.getIn(['leftNav', 'contractId'])
          }]), 't0', 7);

        case 7:
        case 'end':
          return _context31.stop();
      }
    }
  }, _marked31, this);
}

function importSuccess() {
  var pathname, splited, collection, docId;
  return regeneratorRuntime.wrap(function importSuccess$(_context32) {
    while (1) {
      switch (_context32.prev = _context32.next) {
        case 0:
          pathname = window.location.pathname;
          splited = pathname.split('/');
          collection = splited[2];
          docId = splited[3];

          window.location = window.location.protocol + '//' + window.location.host + '/contracting/' + collection + '/' + docId + '/details';

        case 5:
        case 'end':
          return _context32.stop();
      }
    }
  }, _marked32, this);
}

function refreshContractDoc() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var bgRefresh, pathname, splited, collection, docId, isProduct, refreshLeftNav, refreshCompletionCheck, refreshProduct, refreshPolicyNotes;
  return regeneratorRuntime.wrap(function refreshContractDoc$(_context33) {
    while (1) {
      switch (_context33.prev = _context33.next) {
        case 0:
          bgRefresh = options.bgRefresh;
          pathname = window.location.pathname;
          splited = pathname.split('/');
          collection = splited[2] === 'workspace' ? 'contract' : splited[2];
          docId = splited[3];
          isProduct = splited[4] === 'product';

          if (bgRefresh) {
            _context33.next = 9;
            break;
          }

          _context33.next = 9;
          return (0, _effects.put)({ type: cnt.REFRESH_STARTED });

        case 9:
          refreshLeftNav = (0, _sagas.apiSaga)(cnt.REFRESH_LEFT_NAV, _api.contracting.getContractInfo, [{
            collection: collection,
            docId: docId,
            type: 'leftNav'
          }]);
          refreshCompletionCheck = (0, _sagas.apiSaga)(cnt.REFRESH_COMPLETION_CHECK, _api.contracting.checkContractReadiness, [docId]);
          refreshProduct = (0, _sagas.apiSaga)(cnt.REFRESH_PRODUCT_DETAILS, _api.contracting.getContractProductInfo, [{
            collection: collection,
            docId: docId,
            productId: splited[5],
            ratePackage: decodeURIComponent(splited[6] || '')
          }]);
          refreshPolicyNotes = (0, _sagas.apiSaga)(cnt.REFRESH_POLICIES_NOTES, _api.contracting.getContractInfo, [{
            collection: collection,
            docId: docId,
            type: 'policyNotes'
          }]);
          // const items = [];

          if (!isProduct) {
            _context33.next = 18;
            break;
          }

          _context33.next = 16;
          return refreshProduct;

        case 16:
          _context33.next = 20;
          break;

        case 18:
          _context33.next = 20;
          return refreshPolicyNotes;

        case 20:
          _context33.next = 22;
          return (0, _effects.put)({ type: cnt.REFRESH_FINISHED });

        case 22:
          _context33.next = 24;
          return refreshLeftNav;

        case 24:
          if (!(collection === 'draft')) {
            _context33.next = 27;
            break;
          }

          _context33.next = 27;
          return refreshCompletionCheck;

        case 27:
        case 'end':
          return _context33.stop();
      }
    }
  }, _marked33, this);
}

function afterUpdateContractPartnerInfoSuccess() {
  return regeneratorRuntime.wrap(function afterUpdateContractPartnerInfoSuccess$(_context34) {
    while (1) {
      switch (_context34.prev = _context34.next) {
        case 0:
          if (!(window.location.pathname.indexOf('/contracting/contract/') > -1)) {
            _context34.next = 5;
            break;
          }

          _context34.next = 3;
          return refreshContractDoc();

        case 3:
          _context34.next = 7;
          break;

        case 5:
          _context34.next = 7;
          return triggerLoadContractList();

        case 7:
        case 'end':
          return _context34.stop();
      }
    }
  }, _marked34, this);
}

function updateSameAsCorporate(_ref35) {
  var type = _ref35.type,
      payload = _ref35.payload;

  var _ref36, sameAsCorporatePolicyNotes, updated;

  return regeneratorRuntime.wrap(function updateSameAsCorporate$(_context35) {
    while (1) {
      switch (_context35.prev = _context35.next) {
        case 0:
          _context35.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractActivitiesProducts.toJS();
          });

        case 2:
          _ref36 = _context35.sent;
          sameAsCorporatePolicyNotes = _ref36.rightSideContent.sameAsCorporatePolicyNotes;
          updated = payload.checked ? [].concat(_toConsumableArray(sameAsCorporatePolicyNotes), [payload.sectionValue]) : sameAsCorporatePolicyNotes.filter(function (str) {
            return str !== payload.sectionValue;
          });
          return _context35.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.updateSameAsCorporatePolicyNotes, [{
            templateDraftId: payload.templateDraftId,
            sameAsCorporatePolicyNotes: updated
          }]), 't0', 6);

        case 6:
        case 'end':
          return _context35.stop();
      }
    }
  }, _marked35, this);
}

function removeMasterTemplate(_ref37) {
  var type = _ref37.type;

  var _ref38, templateDraftId;

  return regeneratorRuntime.wrap(function removeMasterTemplate$(_context36) {
    while (1) {
      switch (_context36.prev = _context36.next) {
        case 0:
          _context36.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractActivitiesProducts.toJS();
          });

        case 2:
          _ref38 = _context36.sent;
          templateDraftId = _ref38.leftNav.contractId;
          return _context36.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.removePolicyNotesTemplate, [templateDraftId]), 't0', 5);

        case 5:
        case 'end':
          return _context36.stop();
      }
    }
  }, _marked36, this);
}

function refreshTemplateList() {
  return regeneratorRuntime.wrap(function refreshTemplateList$(_context37) {
    while (1) {
      switch (_context37.prev = _context37.next) {
        case 0:
          return _context37.delegateYield((0, _sagas.apiSaga)(cnt.REFRESH_TEMPLATE_LIST, _api.contracting.getTemplateList, []), 't0', 1);

        case 1:
        case 'end':
          return _context37.stop();
      }
    }
  }, _marked37, this);
}

function afterRemoveDraftFromQueue(_ref39) {
  var args = _ref39.args;
  return regeneratorRuntime.wrap(function afterRemoveDraftFromQueue$(_context38) {
    while (1) {
      switch (_context38.prev = _context38.next) {
        case 0:
          if (!(args[0].refreshSection === 'doc')) {
            _context38.next = 3;
            break;
          }

          _context38.next = 3;
          return refreshContractDoc();

        case 3:
          if (!(args[0].refreshSection === 'list')) {
            _context38.next = 6;
            break;
          }

          _context38.next = 6;
          return refreshTemplateList();

        case 6:
        case 'end':
          return _context38.stop();
      }
    }
  }, _marked38, this);
}
function sendTourWriter(_ref40) {
  var _ref40$payload = _ref40.payload;
  _ref40$payload = _ref40$payload === undefined ? {} : _ref40$payload;
  var contractId = _ref40$payload.contractId,
      blackout = _ref40$payload.blackout;

  var selectedContracts, _ref41, docId, collection, tourwriterType;

  return regeneratorRuntime.wrap(function sendTourWriter$(_context39) {
    while (1) {
      switch (_context39.prev = _context39.next) {
        case 0:
          if (!contractId) {
            _context39.next = 4;
            break;
          }

          _context39.t0 = [contractId];
          _context39.next = 7;
          break;

        case 4:
          _context39.next = 6;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractList.get('selectedContracts').toJS();
          });

        case 6:
          _context39.t0 = _context39.sent;

        case 7:
          selectedContracts = _context39.t0;
          _context39.next = 10;
          return (0, _effects.select)(_ramda2.default.path(['contracting', 'downloadDocs']));

        case 10:
          _ref41 = _context39.sent;
          docId = _ref41.docId;
          collection = _ref41.collection;
          tourwriterType = blackout ? 'tourwriterblackout' : 'tourwriter';

          if (!(selectedContracts.length > 0)) {
            _context39.next = 21;
            break;
          }

          _context39.next = 17;
          return (0, _sagas.apiSaga)(cnt.SEND_TOURWRITER, _api.downloads.getXls, ['contract', selectedContracts.join('|'), tourwriterType]);

        case 17:
          _context39.next = 19;
          return (0, _effects.put)((0, _contractListActions.updateProps)({ selectedContracts: [], allContractIds: [] }));

        case 19:
          _context39.next = 24;
          break;

        case 21:
          if (!docId) {
            _context39.next = 24;
            break;
          }

          _context39.next = 24;
          return (0, _sagas.apiSaga)(cnt.SEND_TOURWRITER, _api.downloads.getXls, [collection, docId, tourwriterType]);

        case 24:
        case 'end':
          return _context39.stop();
      }
    }
  }, _marked39, this);
}
function tourWriterStart() {
  return regeneratorRuntime.wrap(function tourWriterStart$(_context40) {
    while (1) {
      switch (_context40.prev = _context40.next) {
        case 0:
          _context40.next = 2;
          return (0, _effects.put)((0, _globalErrorsDisplayActions.triggerError)({ errorMessage: 'Generating File' }));

        case 2:
        case 'end':
          return _context40.stop();
      }
    }
  }, _marked40, this);
}
function tourWriterError() {
  return regeneratorRuntime.wrap(function tourWriterError$(_context41) {
    while (1) {
      switch (_context41.prev = _context41.next) {
        case 0:
          _context41.next = 2;
          return (0, _effects.put)((0, _globalErrorsDisplayActions.triggerError)({ errorMessage: 'Cound not generate the file' }));

        case 2:
        case 'end':
          return _context41.stop();
      }
    }
  }, _marked41, this);
}

function removeSingleFeedByTCAdmin(_ref42) {
  var type = _ref42.type,
      payload = _ref42.payload;
  var confirmed;
  return regeneratorRuntime.wrap(function removeSingleFeedByTCAdmin$(_context42) {
    while (1) {
      switch (_context42.prev = _context42.next) {
        case 0:
          confirmed = window.confirm('Are you sure?');

          if (!confirmed) {
            _context42.next = 4;
            break;
          }

          _context42.next = 4;
          return (0, _sagas.apiSaga)(type, _api.contracting.removeSingleFeedByTCAdmin, [payload]);

        case 4:
        case 'end':
          return _context42.stop();
      }
    }
  }, _marked42, this);
}
function markHistoryFeedAsRead(_ref43) {
  var _ref43$payload$respon = _ref43.payload.response,
      historyFeedId = _ref43$payload$respon.historyFeedId,
      messageArray = _ref43$payload$respon.messageArray;
  var currentRoute;
  return regeneratorRuntime.wrap(function markHistoryFeedAsRead$(_context43) {
    while (1) {
      switch (_context43.prev = _context43.next) {
        case 0:
          _context43.next = 2;
          return (0, _effects.select)(_ramda2.default.path(['routing', 'locationBeforeTransitions', 'pathname']));

        case 2:
          currentRoute = _context43.sent.split('/');

          if (!(currentRoute[1] === 'contracting' && currentRoute[2] === 'contract' && currentRoute[currentRoute.length - 1] === 'activities' && messageArray.length > 0)) {
            _context43.next = 6;
            break;
          }

          _context43.next = 6;
          return (0, _sagas.apiSaga)('[contracting] CONVERSATIONS_READ_WITH_PARAMS', _api.workspace.conversationsRead, [{
            assetId: historyFeedId,
            assetType: 'contract'
          }]);

        case 6:
        case 'end':
          return _context43.stop();
      }
    }
  }, _marked43, this);
}
function updateContractActivities(contractId) {
  return regeneratorRuntime.wrap(function updateContractActivities$(_context44) {
    while (1) {
      switch (_context44.prev = _context44.next) {
        case 0:
          _context44.next = 2;
          return (0, _sagas.apiSaga)('LOADING_HISTORY_FEEDS', _api.historyFeed.getHistory, [contractId]);

        case 2:
        case 'end':
          return _context44.stop();
      }
    }
  }, _marked44, this);
}

function getTemplateChangeLogs(threadId, search) {
  return regeneratorRuntime.wrap(function getTemplateChangeLogs$(_context45) {
    while (1) {
      switch (_context45.prev = _context45.next) {
        case 0:
          _context45.next = 2;
          return (0, _sagas.apiSaga)('[contract-template]GET_CHANGE_LOGS', _api.contracting.getTemplateChangeLog, [threadId, search]);

        case 2:
        case 'end':
          return _context45.stop();
      }
    }
  }, _marked45, this);
}

function onRouteChange(_ref44) {
  var _ref44$payload = _ref44.payload,
      pathname = _ref44$payload.pathname,
      search = _ref44$payload.search;
  var contractIdForActivitiesPage, threadIdForChangeLogs;
  return regeneratorRuntime.wrap(function onRouteChange$(_context46) {
    while (1) {
      switch (_context46.prev = _context46.next) {
        case 0:
          contractIdForActivitiesPage = (pathname.match(/^\/contracting\/contract\/([a-f\d]{24})\/activities/) || [])[1];

          if (!contractIdForActivitiesPage) {
            _context46.next = 4;
            break;
          }

          _context46.next = 4;
          return updateContractActivities(contractIdForActivitiesPage);

        case 4:
          threadIdForChangeLogs = (pathname.match(/^\/contracting\/template\/([a-f\d]{24})\/logs/) || [])[1];

          if (!threadIdForChangeLogs) {
            _context46.next = 8;
            break;
          }

          _context46.next = 8;
          return getTemplateChangeLogs(threadIdForChangeLogs, search);

        case 8:
        case 'end':
          return _context46.stop();
      }
    }
  }, _marked46, this);
}

function fileContractForRequest(_ref45) {
  var type = _ref45.type,
      payload = _ref45.payload;
  return regeneratorRuntime.wrap(function fileContractForRequest$(_context47) {
    while (1) {
      switch (_context47.prev = _context47.next) {
        case 0:
          _context47.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.fileContractForRequest, [payload]);

        case 2:
        case 'end':
          return _context47.stop();
      }
    }
  }, _marked47, this);
}
function fileContractForRequestSuccess() {
  var pathname, splited, docId;
  return regeneratorRuntime.wrap(function fileContractForRequestSuccess$(_context48) {
    while (1) {
      switch (_context48.prev = _context48.next) {
        case 0:
          pathname = window.location.pathname;
          splited = pathname.split('/');
          docId = splited[3];
          _context48.next = 5;
          return getRespondedContractsForRequest('[contract-request]GET_RESPONDED_CONTRACT_LIST', docId);

        case 5:
        case 'end':
          return _context48.stop();
      }
    }
  }, _marked48, this);
}
function removeContractsFromRequests(_ref46) {
  var type = _ref46.type,
      payload = _ref46.payload;
  return regeneratorRuntime.wrap(function removeContractsFromRequests$(_context49) {
    while (1) {
      switch (_context49.prev = _context49.next) {
        case 0:
          _context49.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.removeContractsFromRequests, [payload]);

        case 2:
        case 'end':
          return _context49.stop();
      }
    }
  }, _marked49, this);
}
function removeContractsFromRequestsSuccess(_ref47) {
  var requestId = _ref47.payload.requestId;
  return regeneratorRuntime.wrap(function removeContractsFromRequestsSuccess$(_context50) {
    while (1) {
      switch (_context50.prev = _context50.next) {
        case 0:
          _context50.next = 2;
          return getRespondedContractsForRequest('[contract-request]GET_RESPONDED_CONTRACT_LIST', requestId);

        case 2:
        case 'end':
          return _context50.stop();
      }
    }
  }, _marked50, this);
}
function handleOpenReSendContractDialog(_ref48) {
  var contractId = _ref48.payload.contractId;
  return regeneratorRuntime.wrap(function handleOpenReSendContractDialog$(_context51) {
    while (1) {
      switch (_context51.prev = _context51.next) {
        case 0:
          _context51.next = 2;
          return (0, _sagas.apiSaga)('GET_PARTNER_FOR_RESEND_DIALOG', _api.contracting.getContractPartners, [{ contractId: contractId }]);

        case 2:
        case 'end':
          return _context51.stop();
      }
    }
  }, _marked51, this);
}
function handleAfterMadeACopyOfATemplate() {
  return regeneratorRuntime.wrap(function handleAfterMadeACopyOfATemplate$(_context52) {
    while (1) {
      switch (_context52.prev = _context52.next) {
        case 0:
          if (!(window.location.href.indexOf('template-list') > -1)) {
            _context52.next = 3;
            break;
          }

          _context52.next = 3;
          return refreshTemplateList();

        case 3:
        case 'end':
          return _context52.stop();
      }
    }
  }, _marked52, this);
}

function makeACopyForBuyer(_ref49) {
  var type = _ref49.type,
      payload = _ref49.payload;
  return regeneratorRuntime.wrap(function makeACopyForBuyer$(_context53) {
    while (1) {
      switch (_context53.prev = _context53.next) {
        case 0:
          _context53.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.makeACopyForBuyer, [payload]);

        case 2:
        case 'end':
          return _context53.stop();
      }
    }
  }, _marked53, this);
}

function updateWorkspaceContract(_ref50) {
  var type = _ref50.type,
      payload = _ref50.payload;
  return regeneratorRuntime.wrap(function updateWorkspaceContract$(_context54) {
    while (1) {
      switch (_context54.prev = _context54.next) {
        case 0:
          _context54.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.updateWorkspaceContract, [payload]);

        case 2:
        case 'end':
          return _context54.stop();
      }
    }
  }, _marked54, this);
}

function requestDL() {
  var _ref51, contractId, rateConversionSetting, messageForDL, priority;

  return regeneratorRuntime.wrap(function requestDL$(_context55) {
    while (1) {
      switch (_context55.prev = _context55.next) {
        case 0:
          _context55.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.requestDL;
          });

        case 2:
          _ref51 = _context55.sent;
          contractId = _ref51.contractId;
          rateConversionSetting = _ref51.rateConversionSetting;
          messageForDL = _ref51.messageForDL;
          priority = _ref51.priority;
          _context55.next = 9;
          return (0, _sagas.apiSaga)('REQUEST_DL', _api.contracting.requestDL, [{ contractId: contractId, rateConversionSetting: rateConversionSetting, messageForDL: messageForDL, priority: priority }]);

        case 9:
        case 'end':
          return _context55.stop();
      }
    }
  }, _marked55, this);
}

function afterRequestDLSuccess() {
  return regeneratorRuntime.wrap(function afterRequestDLSuccess$(_context56) {
    while (1) {
      switch (_context56.prev = _context56.next) {
        case 0:
          if (!(window.location.href.indexOf('contract-list') > -1)) {
            _context56.next = 5;
            break;
          }

          _context56.next = 3;
          return triggerLoadContractList();

        case 3:
          _context56.next = 7;
          break;

        case 5:
          _context56.next = 7;
          return refreshContractDoc();

        case 7:
        case 'end':
          return _context56.stop();
      }
    }
  }, _marked56, this);
}

function searchCCTemplates(_ref52) {
  var type = _ref52.type,
      payload = _ref52.payload;
  return regeneratorRuntime.wrap(function searchCCTemplates$(_context57) {
    while (1) {
      switch (_context57.prev = _context57.next) {
        case 0:
          _context57.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.getTemplatesForLocOrCC, [payload]);

        case 2:
        case 'end':
          return _context57.stop();
      }
    }
  }, _marked57, this);
}

function getProductsForOmniImport(_ref53) {
  var type = _ref53.type,
      payload = _ref53.payload;
  return regeneratorRuntime.wrap(function getProductsForOmniImport$(_context58) {
    while (1) {
      switch (_context58.prev = _context58.next) {
        case 0:
          _context58.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.getContractInfo, [{
            collection: payload.template.collection,
            docId: payload.template.idFromTCAdmin,
            type: 'leftNav'
          }]);

        case 2:
        case 'end':
          return _context58.stop();
      }
    }
  }, _marked58, this);
}

function doOmniImport(_ref54) {
  var type = _ref54.type,
      payload = _ref54.payload;
  return regeneratorRuntime.wrap(function doOmniImport$(_context59) {
    while (1) {
      switch (_context59.prev = _context59.next) {
        case 0:
          _context59.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.omniImport, [payload]);

        case 2:
        case 'end':
          return _context59.stop();
      }
    }
  }, _marked59, this);
}

function editProductProfile(_ref55) {
  var type = _ref55.type,
      payload = _ref55.payload;
  return regeneratorRuntime.wrap(function editProductProfile$(_context60) {
    while (1) {
      switch (_context60.prev = _context60.next) {
        case 0:
          _context60.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.updateProductNameBeddingConfig, [payload]);

        case 2:
        case 'end':
          return _context60.stop();
      }
    }
  }, _marked60, this);
}

function editProductProfileSuccess(_ref56) {
  var payload = _ref56.payload,
      args = _ref56.args;
  return regeneratorRuntime.wrap(function editProductProfileSuccess$(_context61) {
    while (1) {
      switch (_context61.prev = _context61.next) {
        case 0:
          if (!(args[0].productId !== payload.productId)) {
            _context61.next = 3;
            break;
          }

          _context61.next = 3;
          return (0, _effects.put)((0, _reactRouterRedux.replace)('/contracting/draft/' + args[0].contractId + '/product/' + payload.productId + '/' + payload.ratePackageId));

        case 3:
          _context61.next = 5;
          return refreshContractDoc({ bgRefresh: true });

        case 5:
        case 'end':
          return _context61.stop();
      }
    }
  }, _marked61, this);
}

// UPDATE_NEW_EMAIL_IN_CONTRACT
exports.default = [(0, _effects.takeLatest)('[supplier-wizard]GET_CONTRACT_REQUEST_INFO_SUPPLIER_WIZARD', getRequestForSupplierWizard), (0, _effects.takeLatest)('OPEN_DIALOG_SHOW_REQUESTS_WITH_SAME_NAME', fetchContracts), (0, _effects.takeLatest)('DISCARD_SELECTED_IN_REQUESTS_WITH_SAME_NAME_DIALOG', archiveSelectedContracts), (0, _effects.takeLatest)('INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE', populateEditDialog), (0, _effects.takeLatest)('PRODUCTS_SAVED_UPDATE_REDUX', populateEditDialog), (0, _effects.takeLatest)('GET_PRODUCT_DETAILS', populateEditDialog), (0, _effects.takeLatest)('GET_CONTRACT_DETAILS', populateEditDialog), (0, _effects.takeLatest)('GET_CONTRACT_LEFT_NAV', afterGettingMetaData), (0, _effects.takeLatest)('[contract-list]UPDATE_SEARCH_PARAMS', triggerLoadContractList), // trigger
(0, _effects.takeLatest)('[contracting]SELECTED_YEAR_FOR_CONTRACTING', triggerLoadContractList), // trigger
(0, _effects.takeLatest)('[contract-list]RESET_SEARCH_PARAMS', triggerLoadContractList), // trigger
(0, _effects.takeLatest)('MASS_ASSIGN_FOLDER_CONTRACT_LIST', triggerLoadContractList), // trigger
(0, _effects.takeLatest)('MASS_DELETE_RESTORE_CONTRACT_LIST', triggerLoadContractList), // trigger
(0, _effects.takeLatest)('[contract-list] MASS_ARCHIVE_OR_RESTORE', triggerLoadContractList), // trigger
(0, _effects.takeLatest)('[contract-list]UPDATE_FOLDER_NAME', doUpdateFolders), (0, _effects.takeLatest)('[contract-list]CHANGE_ROUTE', doChangeContractListRoute), (0, _effects.takeLatest)('LOAD_CONTRACT_LIST_FROM_BACKEND', getContractList), (0, _effects.takeLatest)('[contracting-download]DOWLOAD_CONTRACTING_DOCS', downloadContractingDocs), (0, _effects.takeEvery)('[contracting-download] downloadGroup_SUCCESS', downloadContractingDocsSuccess), (0, _effects.takeEvery)('[contracting-download] downloadGroup_SUCCESS_SUCCESS', downloadContractingUrl), (0, _effects.takeLatest)('[contracting-download]ACCEPT_RATES', acceptRatesAfterDownload), (0, _effects.takeLatest)('[contracting-download]DOWNLOAD_SINGLE_CONTRACT_DOC_SUCCESS', shouldAskToAccept), (0, _effects.takeLatest)('[contracting-download]BULK_DOWNLOAD_SUCCESS', shouldAskToAccept), (0, _effects.takeLatest)('[contracting-download]downloadGroup_SUCCESS_SUCCESS', shouldAskToAccept), (0, _effects.takeLatest)('[contracting-download]EXPORT_EXCEL', exportExcel), (0, _effects.takeEvery)('[contracting-download]EXPORT_EXCEL_SUCCESS', handleExportExcel), (0, _effects.takeEvery)('[contracting-download]EXPORT_EXCEL_ERROR', handleExportExcelError), (0, _effects.takeLatest)('ARCHIVE_UNARCHIVE_TEMPLATE', handleArchiveUnarchiveTemplate), (0, _effects.takeLatest)('UPDATE_CONTRACT_PARTNER_INFO', updateContractRequestPartner), (0, _effects.takeLatest)('UPDATE_CONTRACT_PARTNER_INFO_SUCCESS', afterUpdateContractPartnerInfoSuccess), // trigger
(0, _effects.takeLatest)('SUBMIT_CONTRACTING_COMMENT', submitContractingComment), (0, _effects.takeEvery)(conListConst.GET_CONTRACT_EMAIL, getContractForwardingEmail), (0, _effects.takeLatest)('GET_CONTRACTING_DIFF_REPORT', getDiffReport), (0, _effects.takeLatest)('GET_AVAIL_DOCS_FOR_DIFF_REPORTS', getAvailDocsForDiffReport), (0, _effects.takeLatest)('SEND_UPDATES_IN_PUBLISH_DRAFT_DIALOG', getDiffReportForDraft), (0, _effects.takeLatest)('TOGGLE_SHOW_DRAFT_CHANGES_POPOVER', getDiffReportForViewChanges), (0, _effects.takeLatest)(cnt.REVIEW_MY_RATES_DRAFT, doSendReviewRatesEmail), (0, _effects.takeLatest)('GET_SUPPLIER_LOCATIONS_LIST_IN_TEMPLATE_LIST', updateTemplateListUrl), (0, _effects.takeLatest)(cnt.MANAGE_EXTRAS_OFFERS, manageExtrasOffers), (0, _effects.takeLatest)(cnt.MANAGE_EXTRAS_OFFERS + '_SUCCESS', function () {
  return refreshContractDoc({ bgRefresh: true });
}), (0, _effects.takeLatest)('CONTRACT_PRODUCT_UPDATED', function () {
  return refreshContractDoc({ bgRefresh: true });
}), (0, _effects.takeLatest)(cnt.UPDATE_SAME_AS_CORPORATE_POLICY_NOTES, updateSameAsCorporate), (0, _effects.takeLatest)(cnt.UPDATE_SAME_AS_CORPORATE_POLICY_NOTES + '_SUCCESS', refreshContractDoc), (0, _effects.takeLatest)(cnt.REMOVE_MASTER_TEMPLATE, removeMasterTemplate), (0, _effects.takeLatest)(cnt.REMOVE_MASTER_TEMPLATE + '_SUCCESS', refreshContractDoc), (0, _effects.takeLatest)(cnt.REMOVE_DRAFT_FROM_QUEUE + '_SUCCESS', afterRemoveDraftFromQueue), (0, _effects.takeLatest)(cnt.ADD_DRAFT_TO_QUEUE + '_SUCCESS', refreshContractDoc), (0, _effects.takeLatest)('UPDATE_CONTRACT_PARTNER_INFO_SUCCESS', refreshContractDoc), (0, _effects.takeLatest)('RESEND_CONTRACT_FINISHED', refreshContractDoc), (0, _effects.takeLatest)(cnt.SEND_UPDATES_FROM_QUEUE + '_SUCCESS', refreshTemplateList), (0, _effects.takeLatest)(cnt.SEND_TOURWRITER, sendTourWriter), (0, _effects.takeEvery)(cnt.SEND_TOURWRITER + '_SUCCESS', handleExportExcel), (0, _effects.takeEvery)(cnt.SEND_TOURWRITER + '_STARTED', tourWriterStart), (0, _effects.takeEvery)(cnt.SEND_TOURWRITER + '_ERROR', tourWriterError), (0, _effects.takeLatest)(cnt.REMOVE_SINGLE_FEED_BY_TC_ADMIN, removeSingleFeedByTCAdmin), (0, _effects.takeLatest)(wpCnts.MESSAGE_CREATE + '_SUCCESS', getContractNotes), (0, _effects.takeLatest)('GET_HISTORY_FEEDS', markHistoryFeedAsRead), (0, _effects.takeLatest)('@@router/LOCATION_CHANGE', onRouteChange), (0, _effects.takeLatest)(cnt.FILE_CONTRACT_FOR_REQUEST, fileContractForRequest), (0, _effects.takeLatest)(cnt.FILE_CONTRACT_FOR_REQUEST + '_SUCCESS', fileContractForRequestSuccess), (0, _effects.takeLatest)(cnt.REMOVE_CONTRACT_FROM_REQUEST, removeContractsFromRequests), (0, _effects.takeLatest)(cnt.REMOVE_CONTRACT_FROM_REQUEST + '_SUCCESS', removeContractsFromRequestsSuccess), (0, _effects.takeLatest)('SEARCH_CC_RATES_TEMPLATES', searchCCTemplates), (0, _effects.takeLatest)('LOAD_PRODUCTS_FOR_OMNI_IMPORT_SOURCE_TEMPLATE', getProductsForOmniImport), (0, _effects.takeLatest)('OMNI_IMPORT', doOmniImport), (0, _effects.takeLatest)('OMNI_IMPORT_SUCCESS', importSuccess), (0, _effects.takeLatest)('IMPORT_DATA_FROM_ANOTHER_TEMPLATE_SUCCESS', importSuccess), (0, _effects.takeLatest)('CHANGE_RESEND_CONTRACT_DIALOG_STATE', handleOpenReSendContractDialog), (0, _effects.takeLatest)('SAVED_TEMPLATE_AFTER_DRAFT_PUBLISHED', handleAfterMadeACopyOfATemplate), (0, _effects.takeLatest)('{dummy_account} makeACopyForBuyer', makeACopyForBuyer), (0, _effects.takeLatest)('REQUEST_DL', requestDL), (0, _effects.takeLatest)('REQUEST_DL_SUCCESS', afterRequestDLSuccess), (0, _effects.takeLatest)('[contract] UPDATE_CONTRACT_ASSIGNEE', updateWorkspaceContract), (0, _effects.takeLatest)('[contract] UPDATE_CONTRACT_ASSIGNEE_SUCCESS', afterRequestDLSuccess), (0, _effects.takeLatest)('{draft}EDIT_PRODUCT_PROFILE_INFO', editProductProfile), (0, _effects.takeLatest)('{draft}EDIT_PRODUCT_PROFILE_INFO_SUCCESS', editProductProfileSuccess), (0, _effects.takeLatest)('{contract} DELETE_CONTRACT_NOTE', deleteContractNote), (0, _effects.takeLatest)(['{contract} DELETE_CONTRACT_NOTE_SUCCESS', cnt.GET_NOTES], getContractNotes)];

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _isString = __webpack_require__(58);


/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      var list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */
module.exports = _curry2(function nth(offset, list) {
  var idx = offset < 0 ? list.length + offset : offset;
  return _isString(list) ? list.charAt(idx) : list[idx];
});


/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function round(fn, val, precision) {
	if (typeof val !== 'number') {
		throw new TypeError('Expected value to be a number');
	}

	if (!Number.isInteger(precision)) {
		throw new TypeError('Expected precision to be an integer');
	}

	var exponent = precision > 0 ? 'e' : 'e-';
	var exponentNeg = precision > 0 ? 'e-' : 'e';
	precision = Math.abs(precision);

	if (fn === 'round') {
		return Number(Math.sign(val) * (Math.round(Math.abs(val) + exponent + precision) + exponentNeg + precision));
	}

	return Number(Math[fn](val + exponent + precision) + exponentNeg + precision);
}

module.exports = round.bind(null, 'round');
module.exports.up = round.bind(null, 'ceil');
module.exports.down = round.bind(null, 'floor');

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5f363f11047168d126b14465a2703e21.svg";

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _isFunction = __webpack_require__(77);
var curryN = __webpack_require__(13);
var toString = __webpack_require__(60);


/**
 * Turns a named method with a specified arity into a function that can be
 * called directly supplied with arguments and a target object.
 *
 * The returned function is curried and accepts `arity + 1` parameters where
 * the final parameter is the target object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of the method to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *
 *      var sliceFrom = R.invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *      var sliceFrom6 = R.invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */
module.exports = _curry2(function invoker(arity, method) {
  return curryN(arity + 1, function() {
    var target = arguments[arity];
    if (target != null && _isFunction(target[method])) {
      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
    }
    throw new TypeError(toString(target) + ' does not have a method named "' + method + '"');
  });
});


/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_USER_LOCATION_PROFILE = exports.GET_USER_LOCATION_PROFILE = 'GET_USER_LOCATION_PROFILE';
var GET_USER_LOCATION_PROFILE_FAILED = exports.GET_USER_LOCATION_PROFILE_FAILED = 'GET_USER_LOCATION_PROFILE_FAILED';
var EDIT_USER_LOCATION_PROFILE_FIELD_STARTING = exports.EDIT_USER_LOCATION_PROFILE_FIELD_STARTING = 'EDIT_USER_LOCATION_PROFILE_FIELD_STARTING';
var EDIT_USER_LOCATION_PROFILE_FIELD = exports.EDIT_USER_LOCATION_PROFILE_FIELD = 'EDIT_USER_LOCATION_PROFILE_FIELD';
var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES';
var CLEAR_USER_LOCATION_STORE = exports.CLEAR_USER_LOCATION_STORE = 'CLEAR_USER_LOCATION_STORE';
var REMOVE_PRODUCT = exports.REMOVE_PRODUCT = 'REMOVE_PRODUCT_FROM_PROFILE';
var REMOVE_PRODUCT_FAILED = exports.REMOVE_PRODUCT_FAILED = 'REMOVE_PRODUCT_FAILED';
var ADD_PRODUCT = exports.ADD_PRODUCT = 'ADD_PRODUCT';
var LOG_OUT = exports.LOG_OUT = 'LOG_OUT';
var PROFILE_IMAGE_CHANGED = exports.PROFILE_IMAGE_CHANGED = 'PROFILE_IMAGE_CHANGED';
var DELETE_COVER_IMAGE_FROM_LOCATION = exports.DELETE_COVER_IMAGE_FROM_LOCATION = 'DELETE_COVER_IMAGE_FROM_LOCATION';
var IMPORTING_PROD = exports.IMPORTING_PROD = 'IMPORTING_PROD';
var FINISHED_IMPORTING_PROD = exports.FINISHED_IMPORTING_PROD = '{profile}FINISHED_IMPORTING_PROD';

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 */
module.exports = _curry2(function path(paths, obj) {
  var val = obj;
  var idx = 0;
  while (idx < paths.length) {
    if (val == null) {
      return;
    }
    val = val[paths[idx]];
    idx += 1;
  }
  return val;
});


/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var prefixA = '{create-master-template}';

var INIT = exports.INIT = prefixA + ' INIT';
var CREATE = exports.CREATE = prefixA + ' CREATE';
var TYPE_NAME = exports.TYPE_NAME = prefixA + ' TYPE_NAME';

var prefixB = 'master-template-list';
var GET_LIST = exports.GET_LIST = prefixB + ' GET_LIST';
var UPDATE_TEMPLATE_PROPS = exports.UPDATE_TEMPLATE_PROPS = prefixB + ' UPDATE_TEMPLATE_PROPS';
var GET_ASSOCIATED_TEMPLATES = exports.GET_ASSOCIATED_TEMPLATES = prefixB + ' GET_ASSOCIATED_TEMPLATES';
var DELETE_TEMPLATE = exports.DELETE_TEMPLATE = prefixB + ' DELETE TEMPLATE';
var RENAME_TEMPLATE = exports.RENAME_TEMPLATE = prefixB + ' RENAME_TEMPLATE';

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return sym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TASK; });
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ident; });
/* harmony export (immutable) */ __webpack_exports__["h"] = check;
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return object; });
/* harmony export (immutable) */ __webpack_exports__["w"] = remove;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return array; });
/* harmony export (immutable) */ __webpack_exports__["l"] = deferred;
/* harmony export (immutable) */ __webpack_exports__["g"] = arrayOfDeffered;
/* harmony export (immutable) */ __webpack_exports__["m"] = delay;
/* harmony export (immutable) */ __webpack_exports__["j"] = createMockTask;
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return uid; });
/* harmony export (immutable) */ __webpack_exports__["t"] = makeIterator;
/* harmony export (immutable) */ __webpack_exports__["s"] = log;
/* harmony export (immutable) */ __webpack_exports__["n"] = deprecate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return createSetContextWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return wrapSagaDispatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return cloneableGenerator; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = /*#__PURE__*/sym('TASK');
var HELPER = /*#__PURE__*/sym('HELPER');
var MATCH = /*#__PURE__*/sym('MATCH');
var CANCEL = /*#__PURE__*/sym('CANCEL_PROMISE');
var SAGA_ACTION = /*#__PURE__*/sym('SAGA_ACTION');
var SELF_CANCELLATION = /*#__PURE__*/sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = /*#__PURE__*/konst(true);
var kFalse = /*#__PURE__*/konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  from: function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = /*#__PURE__*/autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_PROFILE = exports.GET_PROFILE = 'GET_PROFILE';
var LOG_OUT = exports.LOG_OUT = 'LOG_OUT';
var ADD_LOCATION = exports.ADD_LOCATION = 'ADD_LOCATION';
var GET_PROFILE_FAILED = exports.GET_PROFILE_FAILED = 'GET_PROFILE_FAILED';
var EDIT_PROFILE_FIELD_STARTING = exports.EDIT_PROFILE_FIELD_STARTING = 'EDIT_PROFILE_FIELD_STARTING';
var EDIT_PROFILE_FIELD = exports.EDIT_PROFILE_FIELD = 'EDIT_PROFILE_FIELD';
var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES';
var CLEAR_PROFILE_STORE = exports.CLEAR_PROFILE_STORE = 'CLEAR_PROFILE_STORE';
var REMOVE_LOCATION_STARTING = exports.REMOVE_LOCATION_STARTING = 'REMOVE_LOCATION_STARTING';
var REMOVE_LOCATION_FAILED = exports.REMOVE_LOCATION_FAILED = 'REMOVE_LOCATION_FAILED';
var REMOVE_LOCATION = exports.REMOVE_LOCATION = 'REMOVE_LOCATION';
var SEND_INVITATION_VIEWS = exports.SEND_INVITATION_VIEWS = 'SEND_INVITATION_VIEWS';
var PROFILE_IMAGE_CHANGED = exports.PROFILE_IMAGE_CHANGED = 'PROFILE_IMAGE_CHANGED';
var DELETE_COVER_IMAGE_FROM_PROFILE = exports.DELETE_COVER_IMAGE_FROM_PROFILE = 'DELETE_COVER_IMAGE_FROM_PROFILE';
var UPDATE_SUPP_PROFILE_PROP = exports.UPDATE_SUPP_PROFILE_PROP = 'UPDATE_SUPP_PROFILE_PROP';
var IMPORTING_LOC = exports.IMPORTING_LOC = '{profile}IMPORTING_LOC';
var IMPORTED_LOC = exports.IMPORTED_LOC = '{profile}IMPORTED_LOC';

var UPDATE_GROUP = exports.UPDATE_GROUP = '{profile} UPDATE_GROUP';
var DELETE_GROUP = exports.DELETE_GROUP = '{profile} DELETE_GROUP';

var REORDER_LOCATIONS = exports.REORDER_LOCATIONS = '{profile} REORDER_LOCATIONS';
var REORDER_PRODUCTS = exports.REORDER_PRODUCTS = '{profile} REORDER_PRODUCTS';

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_CONNECTION_AS_PARTNER = exports.ADD_CONNECTION_AS_PARTNER = '{connection-list}ADD_CONNECTION_AS_PARTNER';

var addConnectionAsPartner = exports.addConnectionAsPartner = function addConnectionAsPartner(connectionId, targetCompanyId) {
  return {
    type: ADD_CONNECTION_AS_PARTNER,
    payload: {
      connectionId: connectionId,
      targetCompanyId: targetCompanyId
    }
  };
};

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_PROPS = exports.UPDATE_PROPS = 'UPDATE_PROPS_IN_SUPPLIER_SEND_TEMPLATE_WIZARD';
var LOADING_TEMPLATES = exports.LOADING_TEMPLATES = 'LOADING_TEMPLATES_SUPPLIER_SEND_TEMPLATE_WIZARD';
var TEMPLATES_LOADED = exports.TEMPLATES_LOADED = 'LOADED_TEMPLATES_SUPPLIER_SEND_TEMPLATE_WIZARD';
var LOCATIONS_LOADED = exports.LOCATIONS_LOADED = 'LOCATIONS_LOADED_SUPPLIER_SEND_TEMPLATE_WIZARD';
var PROCESSING_PARTNERS = exports.PROCESSING_PARTNERS = 'PROCESSING_PARTNERS_SUPPLIER_SEND_TEMPLATE_WIZARD';
var PARTNERS_PROCESSED = exports.PARTNERS_PROCESSED = 'PARTNERS_PROCESSED_SUPPLIER_SEND_TEMPLATE_WIZARD';
var SENDING_CONTRACTS = exports.SENDING_CONTRACTS = 'SENDING_CONTRACTS_SUPPLIER_SEND_TEMPLATE_WIZARD';
var CONTRACTS_CREATED = exports.CONTRACTS_CREATED = 'CONTRACTS_CREATED_SUPPLIER_SEND_TEMPLATE_WIZARD';
var GET_CONTRACT_REQUEST_INFO = exports.GET_CONTRACT_REQUEST_INFO = '[supplier-wizard]GET_CONTRACT_REQUEST_INFO_SUPPLIER_WIZARD';
var CLEAR_STORE = exports.CLEAR_STORE = 'CLEAR_STORE_SUPPLIER_SEND_TEMPLATE_WIZARD';

var RESET_TEMPLATE_SELECTION = exports.RESET_TEMPLATE_SELECTION = '[supplier-wizard]RESET_TEMPLATE_SELECTION';
var RESET_LOCATION_SELECTION = exports.RESET_LOCATION_SELECTION = '[supplier-wizard]RESET_LOCATION_SELECTION';

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GETTING_TEMPLATES = exports.GETTING_TEMPLATES = 'LOADING_TEMPLATES_IN_SMALL_TEMPLATES_LIST';
var POPULATE_REDUCER = exports.POPULATE_REDUCER = 'POPULATE_SMALL_TEMPLATE_LIST';
var CALLING_API = exports.CALLING_API = 'ASYNC_ACTION_STARTING_IN_SMALL_TEMPLATE_LIST';
var CLEAR_STORE = exports.CLEAR_STORE = 'CLEAR_SMALL_TEMPLATE_LIST_STORE';

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A worker that does nothing but passing chunks to the next one. This is like
 * a nodejs stream but with some differences. On the good side :
 * - it works on IE 6-9 without any issue / polyfill
 * - it weights less than the full dependencies bundled with browserify
 * - it forwards errors (no need to declare an error handler EVERYWHERE)
 *
 * A chunk is an object with 2 attributes : `meta` and `data`. The former is an
 * object containing anything (`percent` for example), see each worker for more
 * details. The latter is the real data (String, Uint8Array, etc).
 *
 * @constructor
 * @param {String} name the name of the stream (mainly used for debugging purposes)
 */
function GenericWorker(name) {
    // the name of the worker
    this.name = name || "default";
    // an object containing metadata about the workers chain
    this.streamInfo = {};
    // an error which happened when the worker was paused
    this.generatedError = null;
    // an object containing metadata to be merged by this worker into the general metadata
    this.extraStreamInfo = {};
    // true if the stream is paused (and should not do anything), false otherwise
    this.isPaused = true;
    // true if the stream is finished (and should not do anything), false otherwise
    this.isFinished = false;
    // true if the stream is locked to prevent further structure updates (pipe), false otherwise
    this.isLocked = false;
    // the event listeners
    this._listeners = {
        'data':[],
        'end':[],
        'error':[]
    };
    // the previous worker, if any
    this.previous = null;
}

GenericWorker.prototype = {
    /**
     * Push a chunk to the next workers.
     * @param {Object} chunk the chunk to push
     */
    push : function (chunk) {
        this.emit("data", chunk);
    },
    /**
     * End the stream.
     * @return {Boolean} true if this call ended the worker, false otherwise.
     */
    end : function () {
        if (this.isFinished) {
            return false;
        }

        this.flush();
        try {
            this.emit("end");
            this.cleanUp();
            this.isFinished = true;
        } catch (e) {
            this.emit("error", e);
        }
        return true;
    },
    /**
     * End the stream with an error.
     * @param {Error} e the error which caused the premature end.
     * @return {Boolean} true if this call ended the worker with an error, false otherwise.
     */
    error : function (e) {
        if (this.isFinished) {
            return false;
        }

        if(this.isPaused) {
            this.generatedError = e;
        } else {
            this.isFinished = true;

            this.emit("error", e);

            // in the workers chain exploded in the middle of the chain,
            // the error event will go downward but we also need to notify
            // workers upward that there has been an error.
            if(this.previous) {
                this.previous.error(e);
            }

            this.cleanUp();
        }
        return true;
    },
    /**
     * Add a callback on an event.
     * @param {String} name the name of the event (data, end, error)
     * @param {Function} listener the function to call when the event is triggered
     * @return {GenericWorker} the current object for chainability
     */
    on : function (name, listener) {
        this._listeners[name].push(listener);
        return this;
    },
    /**
     * Clean any references when a worker is ending.
     */
    cleanUp : function () {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null;
        this._listeners = [];
    },
    /**
     * Trigger an event. This will call registered callback with the provided arg.
     * @param {String} name the name of the event (data, end, error)
     * @param {Object} arg the argument to call the callback with.
     */
    emit : function (name, arg) {
        if (this._listeners[name]) {
            for(var i = 0; i < this._listeners[name].length; i++) {
                this._listeners[name][i].call(this, arg);
            }
        }
    },
    /**
     * Chain a worker with an other.
     * @param {Worker} next the worker receiving events from the current one.
     * @return {worker} the next worker for chainability
     */
    pipe : function (next) {
        return next.registerPrevious(this);
    },
    /**
     * Same as `pipe` in the other direction.
     * Using an API with `pipe(next)` is very easy.
     * Implementing the API with the point of view of the next one registering
     * a source is easier, see the ZipFileWorker.
     * @param {Worker} previous the previous worker, sending events to this one
     * @return {Worker} the current worker for chainability
     */
    registerPrevious : function (previous) {
        if (this.isLocked) {
            throw new Error("The stream '" + this + "' has already been used.");
        }

        // sharing the streamInfo...
        this.streamInfo = previous.streamInfo;
        // ... and adding our own bits
        this.mergeStreamInfo();
        this.previous =  previous;
        var self = this;
        previous.on('data', function (chunk) {
            self.processChunk(chunk);
        });
        previous.on('end', function () {
            self.end();
        });
        previous.on('error', function (e) {
            self.error(e);
        });
        return this;
    },
    /**
     * Pause the stream so it doesn't send events anymore.
     * @return {Boolean} true if this call paused the worker, false otherwise.
     */
    pause : function () {
        if(this.isPaused || this.isFinished) {
            return false;
        }
        this.isPaused = true;

        if(this.previous) {
            this.previous.pause();
        }
        return true;
    },
    /**
     * Resume a paused stream.
     * @return {Boolean} true if this call resumed the worker, false otherwise.
     */
    resume : function () {
        if(!this.isPaused || this.isFinished) {
            return false;
        }
        this.isPaused = false;

        // if true, the worker tried to resume but failed
        var withError = false;
        if(this.generatedError) {
            this.error(this.generatedError);
            withError = true;
        }
        if(this.previous) {
            this.previous.resume();
        }

        return !withError;
    },
    /**
     * Flush any remaining bytes as the stream is ending.
     */
    flush : function () {},
    /**
     * Process a chunk. This is usually the method overridden.
     * @param {Object} chunk the chunk to process.
     */
    processChunk : function(chunk) {
        this.push(chunk);
    },
    /**
     * Add a key/value to be added in the workers chain streamInfo once activated.
     * @param {String} key the key to use
     * @param {Object} value the associated value
     * @return {Worker} the current worker for chainability
     */
    withStreamInfo : function (key, value) {
        this.extraStreamInfo[key] = value;
        this.mergeStreamInfo();
        return this;
    },
    /**
     * Merge this worker's streamInfo into the chain's streamInfo.
     */
    mergeStreamInfo : function () {
        for(var key in this.extraStreamInfo) {
            if (!this.extraStreamInfo.hasOwnProperty(key)) {
                continue;
            }
            this.streamInfo[key] = this.extraStreamInfo[key];
        }
    },

    /**
     * Lock the stream to prevent further updates on the workers chain.
     * After calling this method, all calls to pipe will fail.
     */
    lock: function () {
        if (this.isLocked) {
            throw new Error("The stream '" + this + "' has already been used.");
        }
        this.isLocked = true;
        if (this.previous) {
            this.previous.lock();
        }
    },

    /**
     *
     * Pretty print the workers chain.
     */
    toString : function () {
        var me = "Worker " + this.name;
        if (this.previous) {
            return this.previous + " -> " + me;
        } else {
            return me;
        }
    }
};

module.exports = GenericWorker;


/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_CD_PROP = exports.UPDATE_CD_PROP = 'UPDATE_CONTRACTING_DASHBOARD_PROP';

var GETTING_CONTRACTING_DASHBOARD = exports.GETTING_CONTRACTING_DASHBOARD = 'GETTING_CONTRACTING_DASHBOARD';
var GOT_CONTRACTING_DASHBOARD = exports.GOT_CONTRACTING_DASHBOARD = 'GOT_CONTRACTING_DASHBOARD';

var GETTING_CONTRACTING_YEARS = exports.GETTING_CONTRACTING_YEARS = 'GETTING_CONTRACTING_YEARS';
var GOT_CONTRACTING_YEARS = exports.GOT_CONTRACTING_YEARS = 'GOT_CONTRACTING_YEARS';

var INIT_DASHBOARD = exports.INIT_DASHBOARD = '{contracting} INIT_DASHBOARD';
var LOAD_DASHBOARD = exports.LOAD_DASHBOARD = '{contracting} LOAD_DASHBOARD';
var UPDATE_WIDGET_DATA = exports.UPDATE_WIDGET_DATA = '{contracting} UPDATE_DASHBOARD_WIDGET_DATA';

var UPDATE_GLOBAL_LIST_FILTER = exports.UPDATE_GLOBAL_LIST_FILTER = '{contracting} UPDATE_GLOBAL_LIST_FILTER';
var CLEAR_GLOBAL_LIST_FILTER = exports.CLEAR_GLOBAL_LIST_FILTER = '{contracting} CLEAR_GLOBAL_LIST_FILTER';

var RESET_GLOBAL_DASHBOARD_FILTER = exports.RESET_GLOBAL_DASHBOARD_FILTER = '{contracting} RESET_GLOBAL_DASHBOARD_FILTER';
var LOAD_FOLDERS = exports.LOAD_FOLDERS = '{contracting} LOAD_FOLDERS_FOR_DASHBOARD_FILTER';

var UPDATE_GLOBAL_FILTER = exports.UPDATE_GLOBAL_FILTER = '{contracting} UPDATE_GLOBAL_FILTER';

var UPDATE_WIDGET_FILTER = exports.UPDATE_WIDGET_FILTER = '{contracting} UPDATE_DASHBOARD_WIDGET_FILTER';

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SEARCH = exports.SEARCH = 'SEARCH';
var SEARCH_STARTING = exports.SEARCH_STARTING = 'SEARCH_STARTING';
var SEARCH_FAILED = exports.SEARCH_FAILED = 'SEARCH_FAILED';
var SEARCH_COUNT_ONLY = exports.SEARCH_COUNT_ONLY = 'SEARCH_COUNT_ONLY';

var LOAD_MORE = exports.LOAD_MORE = 'LOAD_MORE';
var MODIFY_PARAMS = exports.MODIFY_PARAMS = 'MODIFY_PARAMS';
var FILTER = exports.FILTER = 'FILTER';

var FAKE_RESEND = exports.FAKE_RESEND = 'FAKE_RESEND';
var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES';

var SEND_INVITATION_PF = exports.SEND_INVITATION_PF = 'SEND_INVITATION_PF';
var RESEND_INVITATION_PF = exports.RESEND_INVITATION_PF = 'RESEND_INVITATION_PF';
var IGNORE_CONNECTION_PF = exports.IGNORE_CONNECTION_PF = 'IGNORE_CONNECTION_PF';
var ACCEPT_CONNECTION_PF = exports.ACCEPT_CONNECTION_PF = 'ACCEPT_CONNECTION_PF';
var FLIP_LOADER_STATUS = exports.FLIP_LOADER_STATUS = 'FLIP_LOADER_STATUS';
var ADD_SEARCH_COUNT = exports.ADD_SEARCH_COUNT = 'ADD_SEARCH_COUNT';
var UPDATE_SEARCH_COUNT_DB = exports.UPDATE_SEARCH_COUNT_DB = 'UPDATE_SEARCH_COUNT_DB';

var OPEN_PF_CUSTOM_MSG_POPOVER = exports.OPEN_PF_CUSTOM_MSG_POPOVER = 'OPEN_PF_CUSTOM_MSG_POPOVER';
var CLOSE_PF_CUSTOM_MSG_POPOVER = exports.CLOSE_PF_CUSTOM_MSG_POPOVER = 'CLOSE_PF_CUSTOM_MSG_POPOVER';
var UPDATE_CUSTOM_MSG = exports.UPDATE_CUSTOM_MSG = 'UPDATE_CUSTOM_MSG_IN_PARTNER_FINDER';

var GETTING_RESPONSE_TIME = exports.GETTING_RESPONSE_TIME = 'GETTING_RESPONSE_TIME';
var GOT_RESPONSE_TIME = exports.GOT_RESPONSE_TIME = 'GOT_RESPONSE_TIME';

// FOR ADDING MM TO PF
// export const GETTING_MARKETING_MATERIALS = 'GETTING_MARKETING_MATERIALS';
// export const GOT_MARKETING_MATERIALS = 'GOT_MARKETING_MATERIALS';

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = '[massmessaging] ';

// modal
var OPENMODAL = exports.OPENMODAL = prefix + 'OPEN_MODAL';
var CLOSEMODAL = exports.CLOSEMODAL = prefix + 'CLOSE_MODAL';
var SENDMESSAGE = exports.SENDMESSAGE = prefix + 'SEND_MESSAGE';
var GETPARTNERS = exports.GETPARTNERS = prefix + 'GETPARTNERS';

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_PROPS = exports.UPDATE_PROPS = '[asset-consolidation]UPDATE_PROPS';
var PROCESS_HASHTOKEN = exports.PROCESS_HASHTOKEN = '[asset-consolidation]PROCESS_HASHTOKEN';
var GET_ASSETS = exports.GET_ASSETS = '[asset-consolidation]GET_ASSETS';
var CONSOLIDATE_ASSETS = exports.CONSOLIDATE_ASSETS = '[asset-consolidation]CONSOLIDATE_ASSETS';
var CLEAR_STORE = exports.CLEAR_STORE = '[asset-landing]CLEAR_STORE';

/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = '[partner details] ';

var CHANGE_PARTNER = exports.CHANGE_PARTNER = prefix + 'CHANGE_PARTNER';

// new-activity
var RESET_SELECTED_RATE = exports.RESET_SELECTED_RATE = prefix + 'RESET_SELECTED_RATE';
var RESET_SELECTED_LOCATION = exports.RESET_SELECTED_LOCATION = prefix + 'RESET_SELECTED_LOCATION';
var RESET_SELECTED_ALL = exports.RESET_SELECTED_ALL = prefix + 'RESET_SELECTED_RATE_ALL';
var SEND_RATES = exports.SEND_RATES = prefix + 'SEND_RATES';
var SEND_RATE_REQUESTS = exports.SEND_RATE_REQUESTS = prefix + 'SEND_RATE_REQUEST';
var SEND_MESSAGE = exports.SEND_MESSAGE = prefix + 'SEND_MESSAGE';
var RESET_CONTRACTING_REQUEST = exports.RESET_CONTRACTING_REQUEST = prefix + 'RESET_CONTRACTING_REQUEST';

// activities
var GET_ACTIVITY = exports.GET_ACTIVITY = prefix + 'GET_ACTIVITY';

// files
var GET_FILES = exports.GET_FILES = prefix + 'GET_FILES';

// PartnerInfo
var GET_PARTNER_INFO = exports.GET_PARTNER_INFO = prefix + 'GET_PARTNER_INFO';

var CLEAR_STORE = exports.CLEAR_STORE = prefix + 'CLEAR_STORE';

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = '[settings]';

var GET_SETTINGS = exports.GET_SETTINGS = prefix + ' GET_SETTINGS';
var SAVE_SETTINGS = exports.SAVE_SETTINGS = prefix + ' SAVE_SETTINGS';

/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var INIT = exports.INIT = '[asset-landing]INIT';
var AUTH_BY_TOKEN = exports.AUTH_BY_TOKEN = '[asset-landing]AUTH_BY_TOKEN';
var GET_LOGGED_IN_SESSION = exports.GET_LOGGED_IN_SESSION = '[asset-landing]GET_LOGGED_IN_SESSION';
var DOWNLOAD_RATES_CONTRACT = exports.DOWNLOAD_RATES_CONTRACT = '[asset-landing]DOWNLOAD_RATES_CONTRACT';
var GET_ASSETS = exports.GET_ASSETS = '[asset-landing]GET_ASSET';
var GET_MORE_CONTRACT_INFO = exports.GET_MORE_CONTRACT_INFO = '[asset-landing]GET_MORE_CONTRACT_INFO';
var CHANGE_CONTRACT_STATUS = exports.CHANGE_CONTRACT_STATUS = '[asset-landing]CHANGE_CONTRACT_STATUS';
var OPEN_DIALOG = exports.OPEN_DIALOG = '[asset-landing]OPEN_DIALOG';
var CLOSE_DIALOG = exports.CLOSE_DIALOG = '[asset-landing]CLOSE_DIALOG';
var UPDATE_PROPS_DIALOG = exports.UPDATE_PROPS_DIALOG = '[asset-landing]UPDATE_PROPS_DIALOG';
var LOG_IN = exports.LOG_IN = '[asset-landing]LOG_IN';
var SIGN_UP = exports.SIGN_UP = '[asset-landing]SIGN_UP';
var AUTO_LOGIN = exports.AUTO_LOGIN = '[asset-landing]AUTO_LOGIN';
var SCHEDULE_DEMO = exports.SCHEDULE_DEMO = '[asset-landing]SCHEDULE_DEMO';
var REQUEST_EZ_LOAD = exports.REQUEST_EZ_LOAD = '[asset-landing]REQUEST_EZ_LOAD';
var SEND_RATES = exports.SEND_RATES = '[asset-landing]SEND_RATES';
var SEND_RATES_FOR_ONE_REQUEST = exports.SEND_RATES_FOR_ONE_REQUEST = '[asset-landing]SEND_RATES_FOR_ONE_REQUEST';
var GET_XLS = exports.GET_XLS = '[asset-landing]GET_XLS';
var DOWNLOAD_ALL_CURRENT = exports.DOWNLOAD_ALL_CURRENT = '[asset-landing] DOWNLOAD_ALL_CURRENT';
var DOWNLOAD_ALL = exports.DOWNLOAD_ALL = '[asset-landing] DOWNLOAD_ALL';
var DOWNLOAD_ALL_OUTDATED = exports.DOWNLOAD_ALL_OUTDATED = '[asset-landing] DOWNLOAD_ALL_OUTDATED';

/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__(121)
exports.createHash = exports.Hash = __webpack_require__(135)
exports.createHmac = exports.Hmac = __webpack_require__(510)

var algos = __webpack_require__(665)
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = __webpack_require__(513)
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = __webpack_require__(667)

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = __webpack_require__(684)

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = __webpack_require__(689)

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = __webpack_require__(727)

var publicEncrypt = __webpack_require__(728)

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = __webpack_require__(731)

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}


/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__(8)
var Hash = __webpack_require__(122)
var Buffer = __webpack_require__(10).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__(8)
var Hash = __webpack_require__(122)
var Buffer = __webpack_require__(10).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(8)
var Sha256 = __webpack_require__(508)
var Hash = __webpack_require__(122)
var Buffer = __webpack_require__(10).Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(8)
var SHA512 = __webpack_require__(509)
var Hash = __webpack_require__(122)
var Buffer = __webpack_require__(10).Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(8)
var Buffer = __webpack_require__(10).Buffer

var Base = __webpack_require__(87)

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac


/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(512)


/***/ }),

/***/ 666:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var checkParameters = __webpack_require__(514)
var defaultEncoding = __webpack_require__(515)
var sync = __webpack_require__(516)
var Buffer = __webpack_require__(10).Buffer

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  'sha': 'SHA-1',
  'sha-1': 'SHA-1',
  'sha1': 'SHA-1',
  'sha256': 'SHA-256',
  'sha-256': 'SHA-256',
  'sha384': 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  'sha512': 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}

function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, {name: 'PBKDF2'}, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    process.nextTick(function () {
      callback(null, out)
    })
  }, function (e) {
    process.nextTick(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    return process.nextTick(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
  }

  checkParameters(password, salt, iterations, keylen)
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51), __webpack_require__(93)))

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

var DES = __webpack_require__(668)
var aes = __webpack_require__(244)
var aesModes = __webpack_require__(245)
var desModes = __webpack_require__(683)
var ebtk = __webpack_require__(213)

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

var CipherBase = __webpack_require__(87)
var des = __webpack_require__(243)
var inherits = __webpack_require__(8)
var Buffer = __webpack_require__(10).Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}


/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(48);

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(48);
var inherits = __webpack_require__(8);

var des = __webpack_require__(243);
var utils = des.utils;
var Cipher = des.Cipher;

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(48);
var inherits = __webpack_require__(8);

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(48);
var inherits = __webpack_require__(8);

var des = __webpack_require__(243);
var Cipher = des.Cipher;
var DES = des.DES;

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

var MODES = __webpack_require__(245)
var AuthCipher = __webpack_require__(520)
var Buffer = __webpack_require__(10).Buffer
var StreamCipher = __webpack_require__(521)
var Transform = __webpack_require__(87)
var aes = __webpack_require__(212)
var ebtk = __webpack_require__(213)
var inherits = __webpack_require__(8)

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher


/***/ }),

/***/ 675:
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(136)

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer
var xor = __webpack_require__(136)

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}


/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(136)

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH


/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

var AuthCipher = __webpack_require__(520)
var Buffer = __webpack_require__(10).Buffer
var MODES = __webpack_require__(245)
var StreamCipher = __webpack_require__(521)
var Transform = __webpack_require__(87)
var aes = __webpack_require__(212)
var ebtk = __webpack_require__(213)
var inherits = __webpack_require__(8)

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv


/***/ }),

/***/ 683:
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}


/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__(522)
var primes = __webpack_require__(687)

var DH = __webpack_require__(688)

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),

/***/ 685:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 686:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 687:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__(22);
var MillerRabin = __webpack_require__(523);
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__(522);
var randomBytes = __webpack_require__(121);
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(135)
var stream = __webpack_require__(229)
var inherits = __webpack_require__(8)
var sign = __webpack_require__(690)
var verify = __webpack_require__(726)

var algorithms = __webpack_require__(512)
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = new Buffer(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = new Buffer(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var createHmac = __webpack_require__(510)
var crt = __webpack_require__(246)
var EC = __webpack_require__(44).ec
var BN = __webpack_require__(22)
var parseKeys = __webpack_require__(215)
var curves = __webpack_require__(533)

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [ 0, 1 ]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return new Buffer(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [ 0 ].concat(r)
  if (s[0] & 0x80) s = [ 0 ].concat(s)

  var total = r.length + s.length + 4
  var res = [ 0x30, total, 0x02, r.length ]
  res = res.concat(r, [ 0x02, s.length ], s)
  return new Buffer(res)
}

function getKey (x, q, hash, algo) {
  x = new Buffer(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - x.length)
    zeros.fill(0)
    x = Buffer.concat([ zeros, x ])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = new Buffer(hlen)
  v.fill(1)
  var k = new Buffer(hlen)
  k.fill(0)
  k = createHmac(algo, k).update(v).update(new Buffer([ 0 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(new Buffer([ 1 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = new Buffer(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - out.length)
    zeros.fill(0)
    out = Buffer.concat([ zeros, out ])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = new Buffer(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([ t, kv.v ])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(new Buffer([ 0 ])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),

/***/ 691:
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.4.1","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"}}

/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;
var BN = __webpack_require__(22);
var minAssert = __webpack_require__(48);
var minUtils = __webpack_require__(525);

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w) {
  var naf = [];
  var ws = 1 << (w + 1);
  var k = num.clone();
  while (k.cmpn(1) >= 0) {
    var z;
    if (k.isOdd()) {
      var mod = k.andln(ws - 1);
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }
    naf.push(z);

    // Optimization, shift by word if possible
    var shift = (k.cmpn(0) !== 0 && k.andln(ws - 1) === 0) ? (w + 1) : 1;
    for (var i = 1; i < shift; i++)
      naf.push(0);
    k.iushrn(shift);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    []
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {

    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      var m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      var m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
           this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
                                     bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(22);
var elliptic = __webpack_require__(44);
var utils = elliptic.utils;
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  for (var j = 0; j < naf.length; j += doubles.step) {
    var nafW = 0;
    for (var k = j + doubles.step - 1; k >= j; k--)
      nafW = (nafW << 1) + naf[k];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (var j = 0; j < repr.length; j++) {
      var nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var k = 0; i >= 0 && naf[i] === 0; i--)
      k++;
    if (i >= 0)
      k++;
    acc = acc.dblp(k);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
                                                       points,
                                                       coeffs,
                                                       len,
                                                       jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  for (var i = 0; i < len; i++) {
    var p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (var i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a]);
      naf[b] = getNAF(coeffs[b], wndWidth[b]);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b] /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (var j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (var i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (var j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (var j = 0; j < len; j++) {
      var z = tmp[j];
      var p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (var i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
                          bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len)) ;
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(214);
var elliptic = __webpack_require__(44);
var BN = __webpack_require__(22);
var inherits = __webpack_require__(8);
var Base = curve.base;

var assert = elliptic.utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16)
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 }
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
  var npoints = this._endoWnafT1;
  var ncoeffs = this._endoWnafT2;
  for (var i = 0; i < points.length; i++) {
    var split = this._endoSplit(coeffs[i]);
    var p = points[i];
    var beta = p._getBeta();

    if (split.k1.negative) {
      split.k1.ineg();
      p = p.neg(true);
    }
    if (split.k2.negative) {
      split.k2.ineg();
      beta = beta.neg(true);
    }

    npoints[i * 2] = p;
    npoints[i * 2 + 1] = beta;
    ncoeffs[i * 2] = split.k1;
    ncoeffs[i * 2 + 1] = split.k2;
  }
  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

  // Clean-up references to points and coefficients
  for (var j = 0; j < i * 2; j++) {
    npoints[j] = null;
    ncoeffs[j] = null;
  }
  return res;
};

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul)
      }
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point))
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point))
    }
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);

  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate)
      }
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (var i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (var i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(214);
var BN = __webpack_require__(22);
var inherits = __webpack_require__(8);
var Base = curve.base;

var elliptic = __webpack_require__(44);
var utils = elliptic.utils;

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(214);
var elliptic = __webpack_require__(44);
var BN = __webpack_require__(22);
var inherits = __webpack_require__(8);
var Base = curve.base;

var assert = elliptic.utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  if (this.curve.twisted) {
    // E = a * C
    var e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      var h = this.z.redSqr();
      // J = F - 2 * H
      var j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    var e = c.redAdd(d);
    // H = (c * Z1)^2
    var h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    var j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
                          this.y,
                          this.z,
                          this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curves = exports;

var hash = __webpack_require__(247);
var elliptic = __webpack_require__(44);

var assert = elliptic.utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new elliptic.curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new elliptic.curve.edwards(options);
  else
    this.curve = new elliptic.curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve
      });
      return curve;
    }
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
  ]
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
  ]
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
  ]
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f'
  ]
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650'
  ]
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9'
  ]
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658'
  ]
});

var pre;
try {
  pre = __webpack_require__(704);
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3'
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15'
    }
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre
  ]
});


/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.sha1 = __webpack_require__(699);
exports.sha224 = __webpack_require__(700);
exports.sha256 = __webpack_require__(527);
exports.sha384 = __webpack_require__(701);
exports.sha512 = __webpack_require__(528);


/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var common = __webpack_require__(137);
var shaCommon = __webpack_require__(526);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

var _isArray = __webpack_require__(41);
var _isTransformer = __webpack_require__(95);


/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer [xf] to return a new transformer (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} xf transducer to initialize if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */
module.exports = function _dispatchable(methodNames, xf, fn) {
  return function() {
    if (arguments.length === 0) {
      return fn();
    }
    var args = Array.prototype.slice.call(arguments, 0);
    var obj = args.pop();
    if (!_isArray(obj)) {
      var idx = 0;
      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === 'function') {
          return obj[methodNames[idx]].apply(obj, args);
        }
        idx += 1;
      }
      if (_isTransformer(obj)) {
        var transducer = xf.apply(null, args);
        return transducer(obj);
      }
    }
    return fn.apply(this, arguments);
  };
};


/***/ }),

/***/ 70:
/***/ (function(module, exports) {

module.exports = function _isPlaceholder(a) {
  return a != null &&
         typeof a === 'object' &&
         a['@@functional/placeholder'] === true;
};


/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var SHA256 = __webpack_require__(527);

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};



/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);

var SHA512 = __webpack_require__(528);

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};


/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var common = __webpack_require__(137);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var assert = __webpack_require__(48);

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),

/***/ 704:
/***/ (function(module, exports) {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
      ]
    ]
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
      ]
    ]
  }
};


/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(22);
var HmacDRBG = __webpack_require__(706);
var elliptic = __webpack_require__(44);
var utils = elliptic.utils;
var assert = utils.assert;

var KeyPair = __webpack_require__(707);
var Signature = __webpack_require__(708);

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(elliptic.curves.hasOwnProperty(options), 'Unknown curve ' + options);

    options = elliptic.curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof elliptic.curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || elliptic.rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray()
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  do {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  } while (true);
};

EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8'
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; true; iter++) {
    var k = options.k ?
        options.k(iter) :
        new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);

  if (!this.curve._maxwellTrick) {
    var p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  var p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(247);
var utils = __webpack_require__(525);
var assert = __webpack_require__(48);

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};


/***/ }),

/***/ 707:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(22);
var elliptic = __webpack_require__(44);
var utils = elliptic.utils;
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(22);

var elliptic = __webpack_require__(44);
var utils = elliptic.utils;
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;
  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
  }
  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0 && (r[1] & 0x80)) {
    r = r.slice(1);
  }
  if (s[0] === 0 && (s[1] & 0x80)) {
    s = s.slice(1);
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(247);
var elliptic = __webpack_require__(44);
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__(710);
var Signature = __webpack_require__(711);

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  var curve = elliptic.curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
               .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */
module.exports = _curry2(function add(a, b) {
  return Number(a) + Number(b);
});


/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = __webpack_require__(44);
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(22);
var elliptic = __webpack_require__(44);
var utils = elliptic.utils;
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength)
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.


var asn1 = __webpack_require__(138)

exports.certificate = __webpack_require__(723)

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})


/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(138);
var inherits = __webpack_require__(8);

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = __webpack_require__(714).runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

var indexOf = __webpack_require__(715);

var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    forEach(Object_keys(ctx), function (key) {
        context[key] = ctx[key];
    });

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};


/***/ }),

/***/ 715:
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(8);

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};


/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

var Reporter = __webpack_require__(139).Reporter;
var EncoderBuffer = __webpack_require__(139).EncoderBuffer;
var DecoderBuffer = __webpack_require__(139).DecoderBuffer;
var assert = __webpack_require__(48);

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};


/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

var constants = __webpack_require__(530);

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);


/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

var decoders = exports;

decoders.der = __webpack_require__(531);
decoders.pem = __webpack_require__(720);


/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _isPlaceholder = __webpack_require__(70);


/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
module.exports = function _curryN(length, received, fn) {
  return function() {
    var combined = [];
    var argsIdx = 0;
    var left = length;
    var combinedIdx = 0;
    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result;
      if (combinedIdx < received.length &&
          (!_isPlaceholder(received[combinedIdx]) ||
           argsIdx >= arguments.length)) {
        result = received[combinedIdx];
      } else {
        result = arguments[argsIdx];
        argsIdx += 1;
      }
      combined[combinedIdx] = result;
      if (!_isPlaceholder(result)) {
        left -= 1;
      }
      combinedIdx += 1;
    }
    return left <= 0 ? fn.apply(this, combined)
                     : _arity(left, _curryN(length, combined, fn));
  };
};


/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(8);
var Buffer = __webpack_require__(24).Buffer;

var DERDecoder = __webpack_require__(531);

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),

/***/ 721:
/***/ (function(module, exports, __webpack_require__) {

var encoders = exports;

encoders.der = __webpack_require__(532);
encoders.pem = __webpack_require__(722);


/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(8);

var DEREncoder = __webpack_require__(532);

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),

/***/ 723:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__(138)

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate


/***/ }),

/***/ 724:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 725:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m
var evp = __webpack_require__(213)
var ciphers = __webpack_require__(244)
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = new Buffer(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = new Buffer(match[2], 'hex')
    var cipherText = new Buffer(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),

/***/ 726:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var BN = __webpack_require__(22)
var EC = __webpack_require__(44).ec
var parseKeys = __webpack_require__(215)
var curves = __webpack_require__(533)

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [ 1 ]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = new Buffer(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = new Buffer(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),

/***/ 727:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__(44)
var BN = __webpack_require__(22)

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),

/***/ 728:
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__(729)
exports.privateDecrypt = __webpack_require__(730)

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}


/***/ }),

/***/ 729:
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(215)
var randomBytes = __webpack_require__(121)
var createHash = __webpack_require__(135)
var mgf = __webpack_require__(534)
var xor = __webpack_require__(535)
var BN = __webpack_require__(22)
var withPublic = __webpack_require__(536)
var crt = __webpack_require__(246)
var Buffer = __webpack_require__(10).Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}


/***/ }),

/***/ 73:
/***/ (function(module, exports) {

module.exports = function _map(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result = Array(len);
  while (idx < len) {
    result[idx] = fn(functor[idx]);
    idx += 1;
  }
  return result;
};


/***/ }),

/***/ 730:
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(215)
var mgf = __webpack_require__(534)
var xor = __webpack_require__(535)
var BN = __webpack_require__(22)
var crt = __webpack_require__(246)
var createHash = __webpack_require__(135)
var withPublic = __webpack_require__(536)
var Buffer = __webpack_require__(10).Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}


/***/ }),

/***/ 731:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = __webpack_require__(10)
var randombytes = __webpack_require__(121)
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51), __webpack_require__(93)))

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _isArray = __webpack_require__(41);
var _isString = __webpack_require__(58);


/**
 * Tests whether or not an object is similar to an array.
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @deprecated since v0.23.0
 * @example
 *
 *      R.isArrayLike([]); //=> true
 *      R.isArrayLike(true); //=> false
 *      R.isArrayLike({}); //=> false
 *      R.isArrayLike({length: 10}); //=> false
 *      R.isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */
module.exports = _curry1(function isArrayLike(x) {
  if (_isArray(x)) { return true; }
  if (!x) { return false; }
  if (typeof x !== 'object') { return false; }
  if (_isString(x)) { return false; }
  if (x.nodeType === 1) { return !!x.length; }
  if (x.length === 0) { return true; }
  if (x.length > 0) {
    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
  }
  return false;
});


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig String -> a -> {k: v} -> {k: v}
 * @param {String} prop The property name to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except for the changed property.
 * @see R.dissoc
 * @example
 *
 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
 */
module.exports = _curry3(function assoc(prop, val, obj) {
  var result = {};
  for (var p in obj) {
    result[p] = obj[p];
  }
  result[prop] = val;
  return result;
});


/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly `n` parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} n The desired arity of the new function.
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity `n`.
 * @see R.binary, R.unary
 * @example
 *
 *      var takesTwoArgs = (a, b) => [a, b];
 *
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      var takesOneArg = R.nAry(1, takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only `n` arguments are passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.nAry(0, f)(a, b) = f()
 * @symb R.nAry(1, f)(a, b) = f(a)
 * @symb R.nAry(2, f)(a, b) = f(a, b)
 */
module.exports = _curry2(function nAry(n, fn) {
  switch (n) {
    case 0: return function() {return fn.call(this);};
    case 1: return function(a0) {return fn.call(this, a0);};
    case 2: return function(a0, a1) {return fn.call(this, a0, a1);};
    case 3: return function(a0, a1, a2) {return fn.call(this, a0, a1, a2);};
    case 4: return function(a0, a1, a2, a3) {return fn.call(this, a0, a1, a2, a3);};
    case 5: return function(a0, a1, a2, a3, a4) {return fn.call(this, a0, a1, a2, a3, a4);};
    case 6: return function(a0, a1, a2, a3, a4, a5) {return fn.call(this, a0, a1, a2, a3, a4, a5);};
    case 7: return function(a0, a1, a2, a3, a4, a5, a6) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6);};
    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);};
    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);};
    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);};
    default: throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
  }
});


/***/ }),

/***/ 77:
/***/ (function(module, exports) {

module.exports = function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
};


/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var liftN = __webpack_require__(158);


/**
 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      var madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 *
 *      var madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
 */
module.exports = _curry1(function lift(fn) {
  return liftN(fn.length, fn);
});


/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var curryN = __webpack_require__(13);


/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN
 * @example
 *
 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */
module.exports = _curry1(function curry(fn) {
  return curryN(fn.length, fn);
});


/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _isString = __webpack_require__(58);


/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */
module.exports = _curry1(function reverse(list) {
  return _isString(list) ? list.split('').reverse().join('') :
                           Array.prototype.slice.call(list, 0).reverse();
});


/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

var _complement = __webpack_require__(168);
var _curry2 = __webpack_require__(1);
var filter = __webpack_require__(104);


/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      var isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */
module.exports = _curry2(function reject(pred, filterable) {
  return filter(_complement(pred), filterable);
});


/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

var _curryN = __webpack_require__(72);
var _dispatchable = __webpack_require__(7);
var _has = __webpack_require__(14);
var _reduce = __webpack_require__(18);
var _xreduceBy = __webpack_require__(305);


/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce
 * @example
 *
 *      var reduceToNamesBy = R.reduceBy((acc, student) => acc.concat(student.name), []);
 *      var namesByGrade = reduceToNamesBy(function(student) {
 *        var score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      var students = [{name: 'Lucy', score: 92},
 *                      {name: 'Drew', score: 85},
 *                      // ...
 *                      {name: 'Bart', score: 62}];
 *      namesByGrade(students);
 *      // {
 *      //   'A': ['Lucy'],
 *      //   'B': ['Drew']
 *      //   // ...,
 *      //   'F': ['Bart']
 *      // }
 */
module.exports = _curryN(4, [], _dispatchable([], _xreduceBy,
  function reduceBy(valueFn, valueAcc, keyFn, list) {
    return _reduce(function(acc, elt) {
      var key = keyFn(elt);
      acc[key] = valueFn(_has(key, acc) ? acc[key] : valueAcc, elt);
      return acc;
    }, {}, list);
  }));


/***/ }),

/***/ 83:
/***/ (function(module, exports) {

module.exports = function _containsWith(pred, x, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
};


/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var curry = __webpack_require__(79);


/**
 * Returns a new function much like the supplied one, except that the first two
 * arguments' order is reversed.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a -> b -> c -> ... -> z) -> (b -> a -> c -> ... -> z)
 * @param {Function} fn The function to invoke with its first two parameters reversed.
 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
 * @example
 *
 *      var mergeThree = (a, b, c) => [].concat(a, b, c);
 *
 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
 *
 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
 * @symb R.flip(f)(a, b, c) = f(b, a, c)
 */
module.exports = _curry1(function flip(fn) {
  return curry(function(a, b) {
    var args = Array.prototype.slice.call(arguments, 0);
    args[0] = b;
    args[1] = a;
    return fn.apply(this, args);
  });
});


/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var map = __webpack_require__(16);


/**
 * Returns a lens for the given getter and setter functions. The getter "gets"
 * the value of the focus; the setter "sets" the value of the focus. The setter
 * should not mutate the data structure.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
 * @param {Function} getter
 * @param {Function} setter
 * @return {Lens}
 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
 * @example
 *
 *      var xLens = R.lens(R.prop('x'), R.assoc('x'));
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */
module.exports = _curry2(function lens(getter, setter) {
  return function(toFunctorFn) {
    return function(target) {
      return map(
        function(focus) {
          return setter(focus, target);
        },
        toFunctorFn(getter(target))
      );
    };
  };
});


/***/ }),

/***/ 858:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_UM_PROP = exports.UPDATE_UM_PROP = 'UPDATE_UM_PROP';

var ADD_USER_STARTING = exports.ADD_USER_STARTING = 'ADD_USER_STARTING';
var ADD_USER_FAILED = exports.ADD_USER_FAILED = 'ADD_USER_FAILED';
var ADDED_USER = exports.ADDED_USER = 'ADDED_USER';

var UPDATE_USER_STARTING = exports.UPDATE_USER_STARTING = 'UPDATE_USER_STARTING';
var UPDATED_USER = exports.UPDATED_USER = 'UPDATED_USER';
var UPDATE_USER_FAILED = exports.UPDATE_USER_FAILED = 'UPDATE_USER_FAILED';

var DELETE_USER_STARTING = exports.DELETE_USER_STARTING = 'DELETE_USER_STARTING';
var DELETED_USER = exports.DELETED_USER = 'DELETED_USER';
var DELETE_USER_FAILED = exports.DELETE_USER_FAILED = 'DELETE_USER_FAILED';

var GETTING_USERS_BY_FILTER = exports.GETTING_USERS_BY_FILTER = 'GETTING_USERS_BY_FILTER';
var GOT_USERS_BY_FILTER = exports.GOT_USERS_BY_FILTER = 'GOT_USERS_BY_FILTER';
var GETTING_USERS_BY_FILTER_FAILED = exports.GETTING_USERS_BY_FILTER_FAILED = 'GETTING_USERS_BY_FILTER_FAILED';

var GETTING_COMP_ADMIN = exports.GETTING_COMP_ADMIN = 'GETTING_COMP_ADMIN';
var GOT_COMP_ADMIN = exports.GOT_COMP_ADMIN = 'GOT_COMP_ADMIN';
var GETTING_COMP_ADMIN_FAILED = exports.GETTING_COMP_ADMIN_FAILED = 'GETTING_COMP_ADMIN_FAILED';

var APPROVE_REJECT_USER_STARTED = exports.APPROVE_REJECT_USER_STARTED = 'APPROVE_REJECT_USER_STARTED';
var APPROVE_REJECT_USER_DONE = exports.APPROVE_REJECT_USER_DONE = 'APPROVE_REJECT_USER_DONE';
var APPROVE_REJECT_USER_FAILED = exports.APPROVE_REJECT_USER_FAILED = 'APPROVE_REJECT_USER_FAILED';

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var _isObject = __webpack_require__(106);
var mergeWithKey = __webpack_require__(114);


/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig (String -> a -> a -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeep, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */
module.exports = _curry3(function mergeDeepWithKey(fn, lObj, rObj) {
  return mergeWithKey(function(k, lVal, rVal) {
    if (_isObject(lVal) && _isObject(rVal)) {
      return mergeDeepWithKey(fn, lVal, rVal);
    } else {
      return fn(k, lVal, rVal);
    }
  }, lObj, rObj);
});


/***/ }),

/***/ 861:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ERROR_TRIGGERED = exports.ERROR_TRIGGERED = 'GLOBAL_ERROR_TRIGGERED';
var CLEAR_STORE = exports.CLEAR_STORE = 'CLEAR_STORE_FOR_GLOBAL_ERROR_CONTAINER';

var REQUEST_ACCESS_STARTED = exports.REQUEST_ACCESS_STARTED = 'REQUEST_ACCESS_STARTED';
var REQUESTED_ACCESS = exports.REQUESTED_ACCESS = 'REQUESTED_ACCESS';
var REQUEST_ACCESS_FAILED = exports.REQUEST_ACCESS_FAILED = 'REQUEST_ACCESS_FAILED';

/***/ }),

/***/ 862:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var myLocationProfileQuery = exports.myLocationProfileQuery = "query getMyLocationProfile ($locationId: ID!) {\n      locationProfile  (id: $locationId) {\n        companyName\n        locationName\n        id\n        companyId\n        isMarketingReady\n        name\n        coverImageUrl\n        marketSegments\n        companyTypes\n        website\n        phone\n        productType\n        amenities\n        locationId\n        roomCount\n        isProductMarketingReady\n        rating {\n          value\n          type\n        }\n        profileImageUrl\n        imageUrls\n        profileViews {\n          timeViewed\n          profileImageUrl\n          companyId\n          companyName\n        }\n        address {\n          addressOne\n          addressTwo\n          city\n          state\n          country\n          postalCode\n          formattedAddress\n        }\n        type\n        notes\n        description\n        contacts {\n          firstName\n          lastName\n          name\n          type\n          phone\n          fax\n          email\n        }\n        groups {\n          _id\n          tag\n          items\n        }\n        products {\n          name\n          id\n          images\n          isMarketingReady\n          updatedAt\n        }\n      }\n    }";

var addProductMutation = exports.addProductMutation = "mutation addProduct($supplierId:ID!, $locationId: ID!, $name: String!) {\n  addProduct (locationId: $locationId, supplierId: $supplierId, name: $name) {\n    name\n    productId\n    locationId\n  }\n}";

var editLocationMutation = exports.editLocationMutation = "mutation editLocation($locationId: ID!, $supplierId: ID!, $update: LocationProfileInputType) {\n  editLocation (locationId: $locationId, supplierId: $supplierId, update: $update) {\n    isMarketingReady\n    isProductMarketingReady\n    locationId\n  }\n}";

/***/ }),

/***/ 863:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var profileQuery = exports.profileQuery = 'query getMyProfile ($companyId: ID!, $email: String) {\n      companyProfile  (id: $companyId) {\n        companyName\n        id\n        companyId\n        isMarketingReady\n        productType\n        name\n        coverImageUrl\n        marketSegments\n        marketServed\n        companyTypes\n        website\n        phone\n        profileImageUrl\n        imageUrls\n        media {\n          url\n          mediaType\n          created_at\n          name\n          size\n          storageProvider\n          username\n          password\n          tags\n        }\n        profileViews {\n          timeViewed\n          profileImageUrl\n          companyId\n          companyName\n        }\n        address {\n          addressOne\n          addressTwo\n          city\n          state\n          country\n          postalCode\n          formattedAddress\n        }\n        quickResponder\n        onBoardingStatus\n        destinationsSold\n        corporateIdentifier\n        type\n        description\n        acctCreationReason\n        contacts (email: $email) {\n          firstName\n          lastName\n          name\n          type\n          phone\n          fax\n          email\n        }\n        groups {\n          _id\n          tag\n          items\n        }\n        locations {\n          name\n          id\n          city\n          state\n          country\n          images\n          isMarketingReady\n          numOfProducts\n          updatedAt\n          products {\n            name\n            id\n            updatedAt\n          }\n        }\n        companyBadges {\n          membershipId\n          verifiedStatus\n          name\n          badgeId\n          logo\n          companyBadgeId\n          acronym\n          website\n        }\n        isLocationMarketingReady\n      }\n    }'.replace(/ +(?= )/g, '');

var addLocationMutation = exports.addLocationMutation = 'mutation addLocation($supplierId:ID!, $propertyName: String!, $userFirstName: String!, $userLastName: String!, $userEmail: String!, $userId: ID!) {\n  addLocation (supplierId: $supplierId, propertyName: $propertyName, userFirstName: $userFirstName, userLastName: $userLastName, userEmail: $userEmail, userId: $userId) {\n    locationName\n    locationId\n  }\n}'.replace(/ +(?= )/g, '');

var editCompanyMutation = exports.editCompanyMutation = 'mutation editCompany($companyId: ID!, $update: CompanyInputType, $companyType: String!) {\n  editCompany (companyId: $companyId, update: $update, companyType: $companyType) {\n    isMarketingReady\n    isLocationMarketingReady\n  }\n}'.replace(/ +(?= )/g, '');

/***/ }),

/***/ 864:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var supplierProductFields = "\n      supplierId\n      product (productId: $productId, ratePackage: $ratePackage) {\n        _id\n        productType\n        ratePackageIndex\n        productId\n        productName\n        ratePackageName\n        bedsAndSofas {\n          isApartment\n          rooms {\n            count\n            bedType\n            other\n          }\n        }\n        seasons {\n          _id\n          seasonName\n          dateRanges {\n            eventName\n            seasonStartDate\n            seasonEndDate\n          }\n        }\n        extras {\n          _id\n          extraType\n          extraCode\n          description\n          taxInclusion\n          currency\n          taxType\n          nonStandardTemplateType\n          commissionPercentage\n          nettCommission\n          rateType\n          rates { ...rateFragment }\n        }\n        offers (hideOffers: $hideOffers) {\n          _id\n          rates { ...rateFragment }\n          offerName\n          bookingCode\n          offerDetail\n          specialConditions\n          allowCombination\n          offerType\n          numberOfGuests\n          rate\n          discountType\n          amount\n          nonStandardTemplateType\n          commissionPercentage\n          nettCommission\n          rateType\n          validDatesOfSale {\n            fromDate\n            toDate\n          }\n          validDatesOfTravel {\n            fromDate\n            toDate\n          }\n          isStayPay\n          stayPays {\n            stayDays\n            payDays\n            maxFOC\n          }\n          daysOfWeek\n        }\n        allocation (hideAllocation: $hideAllocation) {\n          dateRanges { ...seasonDatesFragment }\n          allocationType\n          releaseBackDays\n          numberOfRooms\n          allotments {\n            releaseBackDays\n            numberOfRooms\n          }\n        }\n        blackouts {\n          name\n          startDate\n          endDate\n        }\n        pickup { ...pickupDropoff }\n        dropoff { ...pickupDropoff }\n        productPolicy (hideCancellation: $hideCancellation) {\n          policyType\n          ageFrom\n          ageTo\n          adultCount\n          childrenCount\n          focChildrenCount\n          infantAsOccupant\n          conditions\n          cancellations {\n            dateRanges { ...seasonDatesFragment }\n            conditions\n            cancelNum\n            cancelHoursDays\n            additionalRules {\n              cancelNum\n              cancelHoursDays\n              arrivalDeparture\n              cancelFee\n              feeDollarPercent\n              feeBase\n            }\n          }\n        }\n        seasonRates {\n          _id\n          seasonName\n          dateRanges { ...seasonDatesFragment }\n          rateSets {\n            ratePackageName\n            rates { ...rateFragment },\n            rateSetName\n            rateSetCode\n            daysOfWeek\n            commissionPercentage\n            nettCommission\n            includedGuestsinBaseRate\n            rateType\n            minStay\n            maxStay\n            taxInclusion\n            currency\n            taxType\n            nonStandardTemplateType\n          }\n        }\n      }\n    }\n  }\n  fragment pickupDropoff on pickupDropoffType {\n    dateRanges { ...seasonDatesFragment }\n    time\n    location\n    notes\n    timeLocArray {\n      time\n      location\n    }\n  }\n  fragment seasonDatesFragment on seasonDateRangesType {\n    eventName\n    seasonStartDate\n    seasonEndDate\n  }\n  fragment rateFragment on ratesType {\n    priceCode\n    notApplicable\n    description\n    minGuests\n    maxAdults\n    maxAdultsPlusChild\n    retailRate (hideRates: $hideRates)\n    nettRate (hideRates: $hideRates)\n    extraAdult\n    extraChild\n  }\n";
var contractDetailsQuery = "\n      contractId\n      supplierId\n      supplierProfileImageUrl\n      supplierName\n      locationId\n      locationName\n      propertyName\n      productType\n      supplierInfo {\n        termsAndConditions\n        submissionCriteria\n        marketInfo\n      }\n      checkIn\n      checkOut\n      earlyCheckIn\n      earlyCheckInCostType\n      earlyCheckInFee\n      earlyCheckInPercentageType\n      lateCheckOut\n      lateCheckOutFee\n      lateCheckOutCostType\n      lateCheckOutPercentageType\n      locationPolicy (hideCancellation: $hideCancellation) {\n        policyType\n        conditions\n        cancelNum\n        cancelHoursDays\n        additionalRules {\n          cancelNum\n          cancelHoursDays\n          arrivalDeparture\n          cancelFee\n          feeDollarPercent\n          feeBase\n        }\n        ageFrom\n        ageTo\n        adultCount\n        childrenCount\n        focChildrenCount\n        infantAsOccupant\n      }\n      billingInformation {\n        terms\n        financialInstitution\n        branch\n        accountName\n        accountNumber\n        bsbRoutingNumber\n        ibanSwiftCode\n        currency\n        insuranceExpirationYear\n        insuranceExpirationMonth\n        insuranceFiles {\n          fileName\n          downloadUrl\n          hash\n        }\n      }\n    }\n  }";
var leftNavFields = "\n      contractId\n      templateId\n      isLatest\n      supplierId\n      supplierProfileImageUrl\n      locationId\n      locationName\n      startDate\n      endDate\n      supplierEditable\n      contractState\n      supplierInfo {\n        termsAndConditions\n        submissionCriteria\n        marketInfo\n      }\n      productsArray {\n        _id\n        ratePackageIndex\n        productId\n        productName\n        ratePackageName\n        productType\n      }\n    }\n  }\n";

var getMoreContractInfoForContractList = exports.getMoreContractInfoForContractList = "\n  query getContract ($contractId: ID!, $viewerId: ID!, $viewBy: String!) {\n    Contract (id: $contractId, viewerId: $viewerId, viewBy: $viewBy) {\n      partners {\n        id\n        name\n        avatar\n        tags {\n          id\n          name\n        }\n        contacts {\n          firstName\n          lastName\n          email\n          id\n        }\n      }\n      contacts {\n        id\n        firstName\n        lastName\n        email\n      }\n      from {\n        avatar\n        name\n        email\n      }\n      to {\n        avatar\n        name\n        partnerId\n        contactIds\n      }\n      toEmails\n      supplierInfo {\n        termsAndConditions\n        submissionCriteria\n        marketInfo\n      }\n      hasNewComments\n    }\n  }\n";
var getContractDetailsQuery = exports.getContractDetailsQuery = "\n  query getContract ($contractId: ID!, $viewerId: ID, $viewBy: String!, $email: String, $realActorEmail: String,\n    $hideCancellation: Boolean) {\n    Contract (id: $contractId, viewerId: $viewerId, viewBy: $viewBy, email: $email) {\n      buyerName\n      email\n      startDate\n      endDate\n      buyerId\n      buyerProfileImageUrl\n      buyerInfo {\n        termsAndConditions\n        submissionCriteria\n        corporateIdentificationNumber\n      }\n      buyerChecked\n      files {\n        _id\n        name\n        path\n        createdAt\n        source\n        category\n      }\n      deadlineDate\n      createdAt\n      shouldSendReminders\n      rateConversionSetting\n      rateConversionStatus\n      priority\n      assignee {\n        userId\n        name\n        email\n      }\n      partners {\n        id\n        name\n        avatar\n        tags {\n          id\n          name\n        }\n        contacts {\n          firstName\n          lastName\n          email\n          id\n        }\n      }\n      contacts {\n        id\n        firstName\n        lastName\n        email\n      }\n      from {\n        avatar\n        name\n        email\n      }\n      to {\n        avatar\n        name\n        partnerId\n        contactIds\n      }\n      toEmails\n      dummySupplierForCR {\n         accountId\n         productType\n         oneOrMulti\n         locations {\n            locationId\n            name\n            products {\n               productId\n               productType\n               name\n            }\n         }\n         templates (realActorEmail: $realActorEmail) {\n            _id\n            threadId\n            originalContractId\n            templateName\n            status\n            magicLink\n            magicLinkForDiffing\n            buyerCreatedFrom\n            startDate\n            endDate\n            locationName\n            createdAt\n            updatedAt\n            completionPercent\n            templateVersions\n            originFrom\n            activities {\n               actor\n               action\n               createdAt\n            }\n            acceptedBy\n         }\n      }\n      " + contractDetailsQuery + "\n";

var draftTemplateContractDetails = exports.draftTemplateContractDetails = "\n  query getContract ($contractId: ID!, $collection: String!, $viewerId: ID!, $viewBy: String!,\n    $hideCancellation: Boolean, $viewOnly: Boolean) {\n    DraftnTemplate (id: $contractId, collection: $collection, viewerId: $viewerId, viewBy: $viewBy, viewOnly: $viewOnly) {\n      draftId\n      policyNotesTemplateId\n      policyNotesTemplateName\n      sameAsCorporatePolicyNotes\n      " + contractDetailsQuery + "\n";

var getLeftNavQuery = exports.getLeftNavQuery = "\n  query getContract ($contractId: ID!, $viewerId: ID!, $realActorEmail: String, $viewBy: String!) {\n    Contract (id: $contractId, viewerId: $viewerId, viewBy: $viewBy) {\n      lastSent\n      buyerId\n      buyerProfileImageUrl\n      buyerName\n      companyName\n      email\n      forGroupQuote\n      rateContainer {\n        id\n        year\n        partnerName\n      }\n      rateConversionSetting\n      rateConversionStatus\n      priority\n      assignee {\n        userId\n        name\n        email\n      }\n      signatures {\n        signatureText\n        signedBy\n        signedAt\n      }\n      templateFromDummy\n      templateHasDraft\n      buyerHasDraftId\n      buyerCreatedFrom\n      buyerInfo {\n        termsAndConditions\n        submissionCriteria\n        corporateIdentificationNumber\n      }\n      state\n      buyerHasNewComments\n      supplierHasNewComments\n      oldContractId\n      buyerDownloaded\n      productType\n      amended\n      amendedFrom\n      amendmentInfo {\n        amendedFromId\n        isInitialAmendmentDraft\n        amended\n        amendmentId\n      }\n      respondedContracts\n      hasDraft\n      draftMagicLink (realActorEmail: $realActorEmail)\n      buyerChecked\n      supplierChecked\n      emailStatus\n      versions\n      allVersions\n      buyerChecked\n      files {\n        _id\n        name\n        path\n        createdAt\n        source\n      }\n      privateDomain\n      domain\n      historyFeedId\n      senderCompanyId\n      viewedBy\n      isViewed\n      isSender\n      isRequest\n      viewingAs\n      partners {\n        id\n        name\n        avatar\n        tags {\n          id\n          name\n        }\n        contacts {\n          firstName\n          lastName\n          email\n          id\n        }\n      }\n      contacts {\n        id\n        firstName\n        lastName\n        email\n      }\n      from {\n        avatar\n        name\n        email\n      }\n      to {\n        avatar\n        name\n        partnerId\n        contactIds\n      }\n      toEmails\n      hasNewComments\n      " + leftNavFields + "\n";
var draftTemplateLeftNav = exports.draftTemplateLeftNav = "\n  query getContract ($contractId: ID!, $collection: String!, $viewerId: ID!, $viewBy: String!, $realActorEmail: String, $email: String, $hideRates: Boolean, $viewOnly: Boolean) {\n    DraftnTemplate (id: $contractId, collection: $collection, viewerId: $viewerId, viewBy: $viewBy, viewOnly: $viewOnly) {\n      originFrom\n      draftId\n      originalContractId\n      productType\n      templateName\n      templateHasDraft\n      defaultInvitees\n      signatures {\n         invitee\n         inviteSentAt\n         inviteSentBy\n      }\n      acceptedBy\n      draftType\n      threadId\n      state\n      supplierName\n      hasSeenResponseWizard\n      templateVersions\n      allTemplateVersions\n      allContractingReadyProducts {\n        productId\n        productName\n        productType\n        bedsAndSofasComplete\n        bedsAndSofas {\n          isApartment\n          rooms {\n            count\n            bedType\n            other\n          }\n        }\n        added\n      }\n      partnersCount\n      sentPartners {\n        _id\n        from {\n          avatar\n          name\n          email\n        }\n        to {\n          avatar\n          name\n          partnerId\n          contactIds\n        }\n        toEmails\n        locationId\n        email\n        companyName\n        locationName\n        state\n        versions\n        startDate\n        endDate\n        updatedAt\n      }\n      stagedUpdates {\n        source\n        sourceId\n        message\n      }\n      templates (realActorEmail: $realActorEmail, accountUserEmail: $email) {\n        _id\n        templateName\n        startDate\n        endDate\n        locationId\n        createdAt\n      }\n      editHistory {\n        detail\n        productId\n        ratePackageName\n      }\n      syncedSections\n      createdAt\n      productSharedData {\n        allExtras {\n          _id\n          extraType\n          extraCode\n          description\n          taxInclusion\n          currency\n          taxType\n          nonStandardTemplateType\n          commissionPercentage\n          nettCommission\n          rateType\n          rates { ...rateFragment }\n          ratePackages\n        }\n        allOffers {\n          _id\n          rates { ...rateFragment }\n          offerName\n          bookingCode\n          offerDetail\n          specialConditions\n          allowCombination\n          offerType\n          numberOfGuests\n          rate\n          discountType\n          amount\n          nonStandardTemplateType\n          commissionPercentage\n          nettCommission\n          rateType\n          validDatesOfSale {\n            fromDate\n            toDate\n          }\n          validDatesOfTravel {\n            fromDate\n            toDate\n          }\n          isStayPay\n          stayPays {\n            stayDays\n            payDays\n            maxFOC\n          }\n          daysOfWeek\n          ratePackages\n        }\n      }\n      " + leftNavFields + "\n  fragment rateFragment on ratesType {\n    priceCode\n    notApplicable\n    description\n    minGuests\n    maxAdults\n    maxAdultsPlusChild\n    retailRate (hideRates: $hideRates)\n    nettRate (hideRates: $hideRates)\n    extraAdult\n    extraChild\n  }\n";
var getProductDetailsQuery = exports.getProductDetailsQuery = "\n  query getProduct(\n    $contractId: ID!,\n    $productId: ID!,\n    $viewerId: ID!,\n    $viewBy: String!,\n    $ratePackage: String,\n    $hideRates: Boolean,\n    $hideCancellation: Boolean,\n    $hideOffers: Boolean,\n    $hideAllocation: Boolean,\n    ) {\n    Contract (id: $contractId, viewerId: $viewerId, viewBy: $viewBy) {\n      buyerId\n      " + supplierProductFields;

var draftTemplateProductQuery = exports.draftTemplateProductQuery = "\n  query getProduct(\n    $contractId: ID!,\n    $collection: String!,\n    $productId: ID!,\n    $viewerId: ID!,\n    $viewBy: String!,\n    $ratePackage: String,\n    $hideRates: Boolean,\n    $hideCancellation: Boolean,\n    $hideOffers: Boolean,\n    $hideAllocation: Boolean,\n    $viewOnly: Boolean,\n    ) {\n    DraftnTemplate (id: $contractId, collection: $collection, viewerId: $viewerId, viewBy: $viewBy, viewOnly: $viewOnly) {\n    draftId\n    productType\n    formData (productId: $productId){\n      currency\n      rateType\n      taxType\n      taxInclusion\n      commissionPercentage\n      nettCommission\n      includedGuestsinBaseRate\n      maxAdultsChildren\n      maxAdults\n      additionalAdult\n      additionalAdultRetail\n      additionalChild\n      additionalChildRetail\n      paxMax\n      twinBedsAvail\n    }\n    " + supplierProductFields;

/***/ }),

/***/ 865:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var myProductMutation = exports.myProductMutation = "mutation mutate ($productId: ID!, $supplierId: ID!, $update: ProfileProductInputType! ){\n  editProduct (\n    productId: $productId,\n    supplierId: $supplierId,\n    update:$update,\n  ) {\n    locationId\n    productId\n    isMarketingReady\n  }\n}";

var myProductProfileQuery = exports.myProductProfileQuery = "query getMyProductProfile ($productId: ID!) {\n      productProfile  (id: $productId) {\n        id\n        name\n        productId\n        amenities\n        bedsAndSofas {\n          isApartment\n          rooms {\n            count\n            bedType\n            other\n          }\n        }\n        checkIn\n        checkOut\n        description\n        imageUrls\n        isMarketingReady\n        interconnectingRooms\n        locationName\n        locationId\n        productCode\n        notes\n        totalMaxPassengers\n        totalMinPassengers\n        productName\n        companyId\n        companyName\n        profileImageUrl\n        coverImageUrl\n        tourDuration {\n          value\n          unit\n        }\n        tourDurationDoesNotApply\n        roomCountInfo {\n          value\n          unit\n        }\n        roomSizeInfo {\n          value\n          unit\n        }\n        productInfo {\n          include\n          exclude\n          whatToBring\n        }\n        roomSize\n        productType\n        type\n      }\n    }";

/***/ }),

/***/ 866:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(26);

var policiesInCaps = {
  cancellation: 'Cancellation',
  group: 'Group',
  freeOfCharge: 'Free of Charge',
  family: 'Family',
  child: 'Child',
  infant: 'Infant'
};
var editSupplierContract = function editSupplierContract(contractDetails, payload) {
  var initialContractDetails = (0, _immutable.fromJS)(contractDetails);
  switch (payload.updateType) {
    case 'SAVED_CHECKIN_AND_CHECKOUT':
      return {
        contractDetails: (0, _immutable.fromJS)({
          checkIn: payload.data.checkIn,
          checkOut: payload.data.checkOut,
          earlyCheckIn: payload.data.earlyCheckInChecked ? payload.data.earlyCheckIn : undefined,
          earlyCheckInFee: payload.data.earlyCheckInChecked ? payload.data.earlyCheckInFee : undefined,
          earlyCheckInCostType: payload.data.earlyCheckInChecked ? payload.data.earlyCheckInCostType : undefined,
          earlyCheckInPercentageType: payload.data.earlyCheckInChecked ? payload.data.earlyCheckInPercentageType : undefined,
          lateCheckOut: payload.data.lateCheckOutChecked ? payload.data.lateCheckOut : undefined,
          lateCheckOutFee: payload.data.lateCheckOutChecked ? payload.data.lateCheckOutFee : undefined,
          lateCheckOutCostType: payload.data.lateCheckOutChecked ? payload.data.lateCheckOutCostType : undefined,
          lateCheckOutPercentageType: payload.data.lateCheckOutChecked ? payload.data.lateCheckOutPercentageType : undefined,
          sameAsCorporatePolicyNotes: !initialContractDetails.get('sameAsCorporatePolicyNotes') ? [] : initialContractDetails.get('sameAsCorporatePolicyNotes').filter(function (str) {
            return str !== 'checkinout';
          })
        }),
        editHistory: {
          detail: 'Updated Check-in & Check-out information',
          contractId: payload.contractId
        }
      };
    case 'SAVE_POLICY_ADD_EDIT':
      var updateCxl = (initialContractDetails.toJS().locationPolicy || []).some(function (policy) {
        return policy.policyType === payload.data.policyType;
      });
      return {
        contractDetails: (0, _immutable.fromJS)({
          locationPolicy: initialContractDetails.get('locationPolicy'),
          sameAsCorporatePolicyNotes: !initialContractDetails.get('sameAsCorporatePolicyNotes') ? [] : initialContractDetails.get('sameAsCorporatePolicyNotes').filter(function (str) {
            return str !== payload.data.policyType;
          })
        }).update('locationPolicy', function (locationPolicy) {
          if (locationPolicy && locationPolicy.every(function (policy) {
            return policy.get('policyType') !== payload.data.policyType;
          })) {
            return locationPolicy.push((0, _immutable.fromJS)(payload.data));
          }
          return locationPolicy.map(function (policy) {
            if (policy.get('policyType') === payload.data.policyType) {
              return policy.merge((0, _immutable.fromJS)(payload.data));
            }
            return policy;
          });
        }),
        editHistory: {
          detail: (updateCxl ? 'Updated' : 'Added') + ' ' + policiesInCaps[payload.data.policyType] + ' Policy Info',
          contractId: payload.contractId
        }
      };
    case 'DELETE_LOCATION_POLICY':
      return {
        contractDetails: (0, _immutable.fromJS)({
          locationPolicy: initialContractDetails.get('locationPolicy').filter(function (policy) {
            return policy.get('policyType') !== payload.data.policyType;
          }),
          sameAsCorporatePolicyNotes: !initialContractDetails.get('sameAsCorporatePolicyNotes') ? [] : initialContractDetails.get('sameAsCorporatePolicyNotes').filter(function (str) {
            return str !== payload.data.policyType;
          })
        }),
        editHistory: {
          detail: 'Deleted ' + policiesInCaps[payload.data.policyType] + ' Policy Info',
          contractId: payload.contractId
        }
      };
    case 'UPDATE_SUPPLIER_INFO_TERMS_NOTES':
      return {
        contractDetails: (0, _immutable.fromJS)({
          supplierInfo: initialContractDetails.get('supplierInfo'),
          sameAsCorporatePolicyNotes: !initialContractDetails.get('sameAsCorporatePolicyNotes') ? [] : initialContractDetails.get('sameAsCorporatePolicyNotes').filter(function (str) {
            return str !== payload.data.fieldName;
          })
        }).setIn(['supplierInfo', payload.data.fieldName], payload.data.value),
        editHistory: { detail: 'Updated Terms and Notes', contractId: payload.contractId }
      };
    case 'UPDATE_MARKET_INFO':
      return {
        contractDetails: (0, _immutable.fromJS)({
          supplierInfo: initialContractDetails.get('supplierInfo'),
          sameAsCorporatePolicyNotes: !initialContractDetails.get('sameAsCorporatePolicyNotes') ? [] : initialContractDetails.get('sameAsCorporatePolicyNotes').filter(function (str) {
            return str !== 'marketInfo';
          })
        }).setIn(['supplierInfo', payload.data.fieldName], payload.data.value),
        editHistory: { detail: 'Updated Market Information', contractId: payload.contractId }
      };
    case 'SAVE_BILLING_INFO_ADD_EDIT':
      return {
        contractDetails: (0, _immutable.fromJS)({
          billingInformation: payload.data,
          sameAsCorporatePolicyNotes: !initialContractDetails.get('sameAsCorporatePolicyNotes') ? [] : initialContractDetails.get('sameAsCorporatePolicyNotes').filter(function (str) {
            return str !== payload.type;
          })
        }),
        editHistory: { detail: 'Updated Billing Information', contractId: payload.contractId }
      };
    case 'SAVE_CONTRACT_PERIOD':
      // for workspace or template draft
      return {
        contractDetails: (0, _immutable.fromJS)({
          startDate: payload.data.newStartDate,
          endDate: payload.data.newEndDate
        }),
        editHistory: { detail: 'Update Contract Period', contractId: payload.contractId }
      };
    case 'SAVE_LOCATION_NAME':
      // only for buyer's dummy rate sheet
      return {
        contractDetails: (0, _immutable.fromJS)({
          locationName: payload.data.newLocationName
        }),
        editHistory: { detail: 'Update Location Name', contractId: payload.contractId }
      };
    default:
      return {
        contractDetails: initialContractDetails
      };
  }
};

exports.default = editSupplierContract;

/***/ }),

/***/ 867:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ACCEPT_CONNECTION = exports.ACCEPT_CONNECTION = 'ACCEPT_CONNECTION';
var ACCEPT_CONNECTION_STARTING = exports.ACCEPT_CONNECTION_STARTING = 'ACCEPT_CONNECTION_STARTING';
var ADD_TAG = exports.ADD_TAG = 'ADD_TAG';
var ADD_TAG_STARTING = exports.ADD_TAG_STARTING = 'ADD_TAG_STARTING';
var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES';
var FILTER_CONNECTIONS = exports.FILTER_CONNECTIONS = 'FILTER_CONNECTIONS';
var FILTER_CONNECTIONS_BY_COUNTRY = exports.FILTER_CONNECTIONS_BY_COUNTRY = 'FILTER_CONNECTIONS_BY_COUNTRY';
var GET_COUNTRIES = exports.GET_COUNTRIES = 'GET_COUNTRIES';
var IGNORE_CONNECTION = exports.IGNORE_CONNECTION = 'IGNORE_CONNECTION';
var IGNORE_CONNECTION_STARTING = exports.IGNORE_CONNECTION_STARTING = 'IGNORE_CONNECTION_STARTING';
var LOAD_MORE_CONNECTIONS = exports.LOAD_MORE_CONNECTIONS = 'LOAD_MORE_CONNECTIONS';
var RESEND_CONNECTION_STARTING = exports.RESEND_CONNECTION_STARTING = 'RESEND_CONNECTION_STARTING';
var RESEND_CONNECTION = exports.RESEND_CONNECTION = 'RESEND_CONNECTION';
var REMOVE_COUNTRY_FILTER = exports.REMOVE_COUNTRY_FILTER = 'REMOVE_COUNTRY_FILTER';
var REMOVE_TAG_STARTING = exports.REMOVE_TAG_STARTING = 'REMOVE_TAG_STARTING';
var REMOVE_CONNECTION = exports.REMOVE_CONNECTION = 'REMOVE_CONNECTION';
var REMOVE_TAG = exports.REMOVE_TAG = 'REMOVE_TAG';
var REMOVE_CONNECTION_STARTING = exports.REMOVE_CONNECTION_STARTING = 'REMOVE_CONNECTION_STARTING';
var SEARCH_CONTACTS_BY_COMPANY_NAME = exports.SEARCH_CONTACTS_BY_COMPANY_NAME = 'SEARCH_CONTACTS_BY_COMPANY_NAME';
var CONNECTIONS_IS_SYNCING = exports.CONNECTIONS_IS_SYNCING = 'CONNECTIONS_IS_SYNCING';
var UNDO_CONNECTION_CHANGE = exports.UNDO_CONNECTION_CHANGE = 'UNDO_CONNECTION_CHANGE';
var LOG_OUT = exports.LOG_OUT = 'LOG_OUT';

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer
var Transform = __webpack_require__(229).Transform
var StringDecoder = __webpack_require__(905).StringDecoder
var inherits = __webpack_require__(8)

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase


/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = {
  init: function() {
    return this.xf['@@transducer/init']();
  },
  result: function(result) {
    return this.xf['@@transducer/result'](result);
  }
};


/***/ }),

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.route = route;

var _immutable = __webpack_require__(26);

var initialState = {
  currentRoute: '',
  previousRoute: ''
};

function route() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case '@@router/LOCATION_CHANGE':
      if (payload.action === 'REPLACE') {
        return {
          currentRoute: payload.pathname,
          previousRoute: state.previousRoute
        };
      }
      return {
        currentRoute: payload.pathname,
        previousRoute: state.currentRoute
      };
    case 'CLEAR_STORES':
      return initialState;
    default:
      return state;
  }
}

/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(580);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),

/***/ 913:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(581);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),

/***/ 914:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sagaMiddlewareFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__runSaga__ = __webpack_require__(584);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;


  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (logger && !__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {
    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
  }

  if (onError && !__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;

    var sagaEmitter = Object(__WEBPACK_IMPORTED_MODULE_1__channel__["c" /* emitter */])();
    sagaEmitter.emit = (options.emitter || __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* ident */])(sagaEmitter.emit);

    sagaMiddleware.run = __WEBPACK_IMPORTED_MODULE_2__runSaga__["a" /* runSaga */].bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError
    });

    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* createSetContextWarning */])('sagaMiddleware', props));
    __WEBPACK_IMPORTED_MODULE_0__utils__["v" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}

/***/ }),

/***/ 915:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(143);




function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["s" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["k" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),

/***/ 916:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(143);




function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["s" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["k" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["f" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),

/***/ 917:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buffers__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(64);






function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["a" /* actionChannel */])(pattern, __WEBPACK_IMPORTED_MODULE_3__buffers__["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["s" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["k" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["e" /* call */])(__WEBPACK_IMPORTED_MODULE_4__utils__["m" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(pattern) + ', ' + worker.name + ')');
}

/***/ }),

/***/ 918:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony export (immutable) */ __webpack_exports__["b"] = takeLatest;
/* harmony export (immutable) */ __webpack_exports__["c"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__io__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sagaHelpers__ = __webpack_require__(586);



function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["k" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["b" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["k" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["d" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["k" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["f" /* throttleHelper */], ms, pattern, worker].concat(args));
}

/***/ }),

/***/ 919:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(64);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TASK", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SAGA_ACTION", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "is", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "deferred", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "arrayOfDeffered", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMockTask", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cloneableGenerator", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io__ = __webpack_require__(116);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "asEffect", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_proc__ = __webpack_require__(585);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CHANNEL_END", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_proc__["a"]; });




/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_middleware__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__ = __webpack_require__(584);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "runSaga", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_channel__ = __webpack_require__(143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "END", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "eventChannel", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "channel", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_buffers__ = __webpack_require__(237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "buffers", function() { return __WEBPACK_IMPORTED_MODULE_3__internal_buffers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__ = __webpack_require__(586);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeEvery", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeLatest", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_utils__ = __webpack_require__(64);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return __WEBPACK_IMPORTED_MODULE_5__internal_utils__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL", function() { return __WEBPACK_IMPORTED_MODULE_5__internal_utils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_io__ = __webpack_require__(116);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "detach", function() { return __WEBPACK_IMPORTED_MODULE_6__internal_io__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__effects__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(919);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "effects", function() { return __WEBPACK_IMPORTED_MODULE_7__effects__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "utils", function() { return __WEBPACK_IMPORTED_MODULE_8__utils__; });

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__internal_middleware__["a" /* default */]);













/***/ }),

/***/ 920:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var utf8 = __webpack_require__(144);
var utils = __webpack_require__(35);
var GenericWorker = __webpack_require__(65);
var StreamHelper = __webpack_require__(594);
var defaults = __webpack_require__(595);
var CompressedObject = __webpack_require__(489);
var ZipObject = __webpack_require__(939);
var generate = __webpack_require__(940);
var nodejsUtils = __webpack_require__(238);
var NodejsStreamInputAdapter = __webpack_require__(947);


/**
 * Add a file in the current folder.
 * @private
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
 * @param {Object} originalOptions the options of the file
 * @return {Object} the new file.
 */
var fileAdd = function(name, data, originalOptions) {
    // be sure sub folders exist
    var dataType = utils.getTypeOf(data),
        parent;


    /*
     * Correct options.
     */

    var o = utils.extend(originalOptions || {}, defaults);
    o.date = o.date || new Date();
    if (o.compression !== null) {
        o.compression = o.compression.toUpperCase();
    }

    if (typeof o.unixPermissions === "string") {
        o.unixPermissions = parseInt(o.unixPermissions, 8);
    }

    // UNX_IFDIR  0040000 see zipinfo.c
    if (o.unixPermissions && (o.unixPermissions & 0x4000)) {
        o.dir = true;
    }
    // Bit 4    Directory
    if (o.dosPermissions && (o.dosPermissions & 0x0010)) {
        o.dir = true;
    }

    if (o.dir) {
        name = forceTrailingSlash(name);
    }
    if (o.createFolders && (parent = parentFolder(name))) {
        folderAdd.call(this, parent, true);
    }

    var isUnicodeString = dataType === "string" && o.binary === false && o.base64 === false;
    if (!originalOptions || typeof originalOptions.binary === "undefined") {
        o.binary = !isUnicodeString;
    }


    var isCompressedEmpty = (data instanceof CompressedObject) && data.uncompressedSize === 0;

    if (isCompressedEmpty || o.dir || !data || data.length === 0) {
        o.base64 = false;
        o.binary = true;
        data = "";
        o.compression = "STORE";
        dataType = "string";
    }

    /*
     * Convert content to fit.
     */

    var zipObjectContent = null;
    if (data instanceof CompressedObject || data instanceof GenericWorker) {
        zipObjectContent = data;
    } else if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
        zipObjectContent = new NodejsStreamInputAdapter(name, data);
    } else {
        zipObjectContent = utils.prepareContent(name, data, o.binary, o.optimizedBinaryString, o.base64);
    }

    var object = new ZipObject(name, zipObjectContent, o);
    this.files[name] = object;
    /*
    TODO: we can't throw an exception because we have async promises
    (we can have a promise of a Date() for example) but returning a
    promise is useless because file(name, data) returns the JSZip
    object for chaining. Should we break that to allow the user
    to catch the error ?

    return external.Promise.resolve(zipObjectContent)
    .then(function () {
        return object;
    });
    */
};

/**
 * Find the parent folder of the path.
 * @private
 * @param {string} path the path to use
 * @return {string} the parent folder, or ""
 */
var parentFolder = function (path) {
    if (path.slice(-1) === '/') {
        path = path.substring(0, path.length - 1);
    }
    var lastSlash = path.lastIndexOf('/');
    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
};

/**
 * Returns the path with a slash at the end.
 * @private
 * @param {String} path the path to check.
 * @return {String} the path with a trailing slash.
 */
var forceTrailingSlash = function(path) {
    // Check the name ends with a /
    if (path.slice(-1) !== "/") {
        path += "/"; // IE doesn't like substr(-1)
    }
    return path;
};

/**
 * Add a (sub) folder in the current folder.
 * @private
 * @param {string} name the folder's name
 * @param {boolean=} [createFolders] If true, automatically create sub
 *  folders. Defaults to false.
 * @return {Object} the new folder.
 */
var folderAdd = function(name, createFolders) {
    createFolders = (typeof createFolders !== 'undefined') ? createFolders : defaults.createFolders;

    name = forceTrailingSlash(name);

    // Does this folder already exist?
    if (!this.files[name]) {
        fileAdd.call(this, name, null, {
            dir: true,
            createFolders: createFolders
        });
    }
    return this.files[name];
};

/**
* Cross-window, cross-Node-context regular expression detection
* @param  {Object}  object Anything
* @return {Boolean}        true if the object is a regular expression,
* false otherwise
*/
function isRegExp(object) {
    return Object.prototype.toString.call(object) === "[object RegExp]";
}

// return the actual prototype of JSZip
var out = {
    /**
     * @see loadAsync
     */
    load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },


    /**
     * Call a callback function for each entry at this folder level.
     * @param {Function} cb the callback function:
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     */
    forEach: function(cb) {
        var filename, relativePath, file;
        for (filename in this.files) {
            if (!this.files.hasOwnProperty(filename)) {
                continue;
            }
            file = this.files[filename];
            relativePath = filename.slice(this.root.length, filename.length);
            if (relativePath && filename.slice(0, this.root.length) === this.root) { // the file is in the current root
                cb(relativePath, file); // TODO reverse the parameters ? need to be clean AND consistent with the filter search fn...
            }
        }
    },

    /**
     * Filter nested files/folders with the specified function.
     * @param {Function} search the predicate to use :
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     * @return {Array} An array of matching elements.
     */
    filter: function(search) {
        var result = [];
        this.forEach(function (relativePath, entry) {
            if (search(relativePath, entry)) { // the file matches the function
                result.push(entry);
            }

        });
        return result;
    },

    /**
     * Add a file to the zip file, or search a file.
     * @param   {string|RegExp} name The name of the file to add (if data is defined),
     * the name of the file to find (if no data) or a regex to match files.
     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
     * @param   {Object} o     File options
     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
     * a file (when searching by string) or an array of files (when searching by regex).
     */
    file: function(name, data, o) {
        if (arguments.length === 1) {
            if (isRegExp(name)) {
                var regexp = name;
                return this.filter(function(relativePath, file) {
                    return !file.dir && regexp.test(relativePath);
                });
            }
            else { // text
                var obj = this.files[this.root + name];
                if (obj && !obj.dir) {
                    return obj;
                } else {
                    return null;
                }
            }
        }
        else { // more than one argument : we have data !
            name = this.root + name;
            fileAdd.call(this, name, data, o);
        }
        return this;
    },

    /**
     * Add a directory to the zip file, or search.
     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
     */
    folder: function(arg) {
        if (!arg) {
            return this;
        }

        if (isRegExp(arg)) {
            return this.filter(function(relativePath, file) {
                return file.dir && arg.test(relativePath);
            });
        }

        // else, name is a new folder
        var name = this.root + arg;
        var newFolder = folderAdd.call(this, name);

        // Allow chaining by returning a new object with this folder as the root
        var ret = this.clone();
        ret.root = newFolder.name;
        return ret;
    },

    /**
     * Delete a file, or a directory and all sub-files, from the zip
     * @param {string} name the name of the file to delete
     * @return {JSZip} this JSZip object
     */
    remove: function(name) {
        name = this.root + name;
        var file = this.files[name];
        if (!file) {
            // Look for any folders
            if (name.slice(-1) !== "/") {
                name += "/";
            }
            file = this.files[name];
        }

        if (file && !file.dir) {
            // file
            delete this.files[name];
        } else {
            // maybe a folder, delete recursively
            var kids = this.filter(function(relativePath, file) {
                return file.name.slice(0, name.length) === name;
            });
            for (var i = 0; i < kids.length; i++) {
                delete this.files[kids[i].name];
            }
        }

        return this;
    },

    /**
     * Generate the complete zip file
     * @param {Object} options the options to generate the zip file :
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
     */
    generate: function(options) {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },

    /**
     * Generate the complete zip file as an internal stream.
     * @param {Object} options the options to generate the zip file :
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {StreamHelper} the streamed zip file.
     */
    generateInternalStream: function(options) {
      var worker, opts = {};
      try {
          opts = utils.extend(options || {}, {
              streamFiles: false,
              compression: "STORE",
              compressionOptions : null,
              type: "",
              platform: "DOS",
              comment: null,
              mimeType: 'application/zip',
              encodeFileName: utf8.utf8encode
          });

          opts.type = opts.type.toLowerCase();
          opts.compression = opts.compression.toUpperCase();

          // "binarystring" is prefered but the internals use "string".
          if(opts.type === "binarystring") {
            opts.type = "string";
          }

          if (!opts.type) {
            throw new Error("No output type specified.");
          }

          utils.checkSupport(opts.type);

          // accept nodejs `process.platform`
          if(
              opts.platform === 'darwin' ||
              opts.platform === 'freebsd' ||
              opts.platform === 'linux' ||
              opts.platform === 'sunos'
          ) {
              opts.platform = "UNIX";
          }
          if (opts.platform === 'win32') {
              opts.platform = "DOS";
          }

          var comment = opts.comment || this.comment || "";
          worker = generate.generateWorker(this, opts, comment);
      } catch (e) {
        worker = new GenericWorker("error");
        worker.error(e);
      }
      return new StreamHelper(worker, opts.type || "string", opts.mimeType);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */
    generateAsync: function(options, onUpdate) {
        return this.generateInternalStream(options).accumulate(onUpdate);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */
    generateNodeStream: function(options, onUpdate) {
        options = options || {};
        if (!options.type) {
            options.type = "nodebuffer";
        }
        return this.generateInternalStream(options).toNodejsStream(onUpdate);
    }
};
module.exports = out;


/***/ }),

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(922);
module.exports = __webpack_require__(590).setImmediate;

/***/ }),

/***/ 922:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(923)
  , $task   = __webpack_require__(931);
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});

/***/ }),

/***/ 923:
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(239)
  , core      = __webpack_require__(590)
  , ctx       = __webpack_require__(591)
  , hide      = __webpack_require__(925)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),

/***/ 924:
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),

/***/ 925:
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(926)
  , createDesc = __webpack_require__(930);
module.exports = __webpack_require__(488) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),

/***/ 926:
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(927)
  , IE8_DOM_DEFINE = __webpack_require__(928)
  , toPrimitive    = __webpack_require__(929)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(488) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),

/***/ 927:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(487);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),

/***/ 928:
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(488) && !__webpack_require__(592)(function(){
  return Object.defineProperty(__webpack_require__(593)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),

/***/ 929:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(487);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),

/***/ 930:
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(591)
  , invoke             = __webpack_require__(932)
  , html               = __webpack_require__(933)
  , cel                = __webpack_require__(593)
  , global             = __webpack_require__(239)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(934)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),

/***/ 932:
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(239).document && document.documentElement;

/***/ }),

/***/ 934:
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),

/***/ 935:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var immediate = __webpack_require__(936);

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

Promise.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

Promise.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

Promise.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

Promise.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}


/***/ }),

/***/ 936:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),

/***/ 937:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GenericWorker = __webpack_require__(65);
var utils = __webpack_require__(35);

/**
 * A worker which convert chunks to a specified type.
 * @constructor
 * @param {String} destType the destination type.
 */
function ConvertWorker(destType) {
    GenericWorker.call(this, "ConvertWorker to " + destType);
    this.destType = destType;
}
utils.inherits(ConvertWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
ConvertWorker.prototype.processChunk = function (chunk) {
    this.push({
        data : utils.transformTo(this.destType, chunk.data),
        meta : chunk.meta
    });
};
module.exports = ConvertWorker;


/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Readable = __webpack_require__(588).Readable;

var util = __webpack_require__(1046);
util.inherits(NodejsStreamOutputAdapter, Readable);

/**
* A nodejs stream using a worker as source.
* @see the SourceWrapper in http://nodejs.org/api/stream.html
* @constructor
* @param {StreamHelper} helper the helper wrapping the worker
* @param {Object} options the nodejs stream options
* @param {Function} updateCb the update callback.
*/
function NodejsStreamOutputAdapter(helper, options, updateCb) {
    Readable.call(this, options);
    this._helper = helper;

    var self = this;
    helper.on("data", function (data, meta) {
        if (!self.push(data)) {
            self._helper.pause();
        }
        if(updateCb) {
            updateCb(meta);
        }
    })
    .on("error", function(e) {
        self.emit('error', e);
    })
    .on("end", function () {
        self.push(null);
    });
}


NodejsStreamOutputAdapter.prototype._read = function() {
    this._helper.resume();
};

module.exports = NodejsStreamOutputAdapter;


/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StreamHelper = __webpack_require__(594);
var DataWorker = __webpack_require__(596);
var utf8 = __webpack_require__(144);
var CompressedObject = __webpack_require__(489);
var GenericWorker = __webpack_require__(65);

/**
 * A simple object representing a file in the zip file.
 * @constructor
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
 * @param {Object} options the options of the file
 */
var ZipObject = function(name, data, options) {
    this.name = name;
    this.dir = options.dir;
    this.date = options.date;
    this.comment = options.comment;
    this.unixPermissions = options.unixPermissions;
    this.dosPermissions = options.dosPermissions;

    this._data = data;
    this._dataBinary = options.binary;
    // keep only the compression
    this.options = {
        compression : options.compression,
        compressionOptions : options.compressionOptions
    };
};

ZipObject.prototype = {
    /**
     * Create an internal stream for the content of this object.
     * @param {String} type the type of each chunk.
     * @return StreamHelper the stream.
     */
    internalStream: function (type) {
        var outputType = type.toLowerCase();
        var askUnicodeString = outputType === "string" || outputType === "text";
        if (outputType === "binarystring" || outputType === "text") {
            outputType = "string";
        }
        var result = this._decompressWorker();

        var isUnicodeString = !this._dataBinary;

        if (isUnicodeString && !askUnicodeString) {
            result = result.pipe(new utf8.Utf8EncodeWorker());
        }
        if (!isUnicodeString && askUnicodeString) {
            result = result.pipe(new utf8.Utf8DecodeWorker());
        }

        return new StreamHelper(result, outputType, "");
    },

    /**
     * Prepare the content in the asked type.
     * @param {String} type the type of the result.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Promise the promise of the result.
     */
    async: function (type, onUpdate) {
        return this.internalStream(type).accumulate(onUpdate);
    },

    /**
     * Prepare the content as a nodejs stream.
     * @param {String} type the type of each chunk.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Stream the stream.
     */
    nodeStream: function (type, onUpdate) {
        return this.internalStream(type || "nodebuffer").toNodejsStream(onUpdate);
    },

    /**
     * Return a worker for the compressed content.
     * @private
     * @param {Object} compression the compression object to use.
     * @param {Object} compressionOptions the options to use when compressing.
     * @return Worker the worker.
     */
    _compressWorker: function (compression, compressionOptions) {
        if (
            this._data instanceof CompressedObject &&
            this._data.compression.magic === compression.magic
        ) {
            return this._data.getCompressedWorker();
        } else {
            var result = this._decompressWorker();
            if(!this._dataBinary) {
                result = result.pipe(new utf8.Utf8EncodeWorker());
            }
            return CompressedObject.createWorkerFrom(result, compression, compressionOptions);
        }
    },
    /**
     * Return a worker for the decompressed content.
     * @private
     * @return Worker the worker.
     */
    _decompressWorker : function () {
        if (this._data instanceof CompressedObject) {
            return this._data.getContentWorker();
        } else if (this._data instanceof GenericWorker) {
            return this._data;
        } else {
            return new DataWorker(this._data);
        }
    }
};

var removedMethods = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"];
var removedFn = function () {
    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
};

for(var i = 0; i < removedMethods.length; i++) {
    ZipObject.prototype[removedMethods[i]] = removedFn;
}
module.exports = ZipObject;


/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compressions = __webpack_require__(599);
var ZipFileWorker = __webpack_require__(946);

/**
 * Find the compression to use.
 * @param {String} fileCompression the compression defined at the file level, if any.
 * @param {String} zipCompression the compression defined at the load() level.
 * @return {Object} the compression object to use.
 */
var getCompression = function (fileCompression, zipCompression) {

    var compressionName = fileCompression || zipCompression;
    var compression = compressions[compressionName];
    if (!compression) {
        throw new Error(compressionName + " is not a valid compression method !");
    }
    return compression;
};

/**
 * Create a worker to generate a zip file.
 * @param {JSZip} zip the JSZip instance at the right root level.
 * @param {Object} options to generate the zip file.
 * @param {String} comment the comment to use.
 */
exports.generateWorker = function (zip, options, comment) {

    var zipFileWorker = new ZipFileWorker(options.streamFiles, comment, options.platform, options.encodeFileName);
    var entriesCount = 0;
    try {

        zip.forEach(function (relativePath, file) {
            entriesCount++;
            var compression = getCompression(file.options.compression, options.compression);
            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};
            var dir = file.dir, date = file.date;

            file._compressWorker(compression, compressionOptions)
            .withStreamInfo("file", {
                name : relativePath,
                dir : dir,
                date : date,
                comment : file.comment || "",
                unixPermissions : file.unixPermissions,
                dosPermissions : file.dosPermissions
            })
            .pipe(zipFileWorker);
        });
        zipFileWorker.entriesCount = entriesCount;
    } catch (e) {
        zipFileWorker.error(e);
    }

    return zipFileWorker;
};


/***/ }),

/***/ 941:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var USE_TYPEDARRAY = (typeof Uint8Array !== 'undefined') && (typeof Uint16Array !== 'undefined') && (typeof Uint32Array !== 'undefined');

var pako = __webpack_require__(942);
var utils = __webpack_require__(35);
var GenericWorker = __webpack_require__(65);

var ARRAY_TYPE = USE_TYPEDARRAY ? "uint8array" : "array";

exports.magic = "\x08\x00";

/**
 * Create a worker that uses pako to inflate/deflate.
 * @constructor
 * @param {String} action the name of the pako function to call : either "Deflate" or "Inflate".
 * @param {Object} options the options to use when (de)compressing.
 */
function FlateWorker(action, options) {
    GenericWorker.call(this, "FlateWorker/" + action);

    this._pako = new pako[action]({
        raw:true,
        level : options.level || -1 // default compression
    });
    // the `meta` object from the last chunk received
    // this allow this worker to pass around metadata
    this.meta = {};

    var self = this;
    this._pako.onData = function(data) {
        self.push({
            data : data,
            meta : self.meta
        });
    };
}

utils.inherits(FlateWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
FlateWorker.prototype.processChunk = function (chunk) {
    this.meta = chunk.meta;
    this._pako.push(utils.transformTo(ARRAY_TYPE, chunk.data), false);
};

/**
 * @see GenericWorker.flush
 */
FlateWorker.prototype.flush = function () {
    GenericWorker.prototype.flush.call(this);
    this._pako.push([], true);
};
/**
 * @see GenericWorker.cleanUp
 */
FlateWorker.prototype.cleanUp = function () {
    GenericWorker.prototype.cleanUp.call(this);
    this._pako = null;
};

exports.compressWorker = function (compressionOptions) {
    return new FlateWorker("Deflate", compressionOptions);
};
exports.uncompressWorker = function () {
    return new FlateWorker("Inflate", {});
};


/***/ }),

/***/ 942:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Top level file is just a mixin of submodules & constants


var assign    = __webpack_require__(230).assign;

var deflate   = __webpack_require__(943);
var inflate   = __webpack_require__(944);
var constants = __webpack_require__(642);

var pako = {};

assign(pako, deflate, inflate, constants);

module.exports = pako;


/***/ }),

/***/ 943:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var zlib_deflate = __webpack_require__(1091);
var utils        = __webpack_require__(230);
var strings      = __webpack_require__(600);
var msg          = __webpack_require__(641);
var ZStream      = __webpack_require__(640);

var toString = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

var Z_NO_FLUSH      = 0;
var Z_FINISH        = 4;

var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_SYNC_FLUSH    = 2;

var Z_DEFAULT_COMPRESSION = -1;

var Z_DEFAULT_STRATEGY    = 0;

var Z_DEFLATED  = 8;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/

/**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
function Deflate(options) {
  if (!(this instanceof Deflate)) return new Deflate(options);

  this.options = utils.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY,
    to: ''
  }, options || {});

  var opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new ZStream();
  this.strm.avail_out = 0;

  var status = zlib_deflate.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK) {
    throw new Error(msg[status]);
  }

  if (opt.header) {
    zlib_deflate.deflateSetHeader(this.strm, opt.header);
  }

  if (opt.dictionary) {
    var dict;
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      // If we need to compress text, change encoding to utf8.
      dict = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      dict = new Uint8Array(opt.dictionary);
    } else {
      dict = opt.dictionary;
    }

    status = zlib_deflate.deflateSetDictionary(this.strm, dict);

    if (status !== Z_OK) {
      throw new Error(msg[status]);
    }

    this._dict_set = true;
  }
}

/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;

  if (this.ended) { return false; }

  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings.string2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }
    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */

    if (status !== Z_STREAM_END && status !== Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }
    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
      if (this.options.to === 'string') {
        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
      } else {
        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
      }
    }
  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);

  // Finalize on the last chunk.
  if (_mode === Z_FINISH) {
    status = zlib_deflate.deflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === Z_SYNC_FLUSH) {
    this.onEnd(Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/
function deflate(input, options) {
  var deflator = new Deflate(options);

  deflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (deflator.err) { throw deflator.msg || msg[deflator.err]; }

  return deflator.result;
}


/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function deflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return deflate(input, options);
}


/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/
function gzip(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate(input, options);
}


exports.Deflate = Deflate;
exports.deflate = deflate;
exports.deflateRaw = deflateRaw;
exports.gzip = gzip;


/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var zlib_inflate = __webpack_require__(1092);
var utils        = __webpack_require__(230);
var strings      = __webpack_require__(600);
var c            = __webpack_require__(642);
var msg          = __webpack_require__(641);
var ZStream      = __webpack_require__(640);
var GZheader     = __webpack_require__(945);

var toString = Object.prototype.toString;

/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/

/* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/

/**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/

/**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/


/**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/
function Inflate(options) {
  if (!(this instanceof Inflate)) return new Inflate(options);

  this.options = utils.assign({
    chunkSize: 16384,
    windowBits: 0,
    to: ''
  }, options || {});

  var opt = this.options;

  // Force window size for `raw` data, if not set directly,
  // because we have no header for autodetect.
  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) { opt.windowBits = -15; }
  }

  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
      !(options && options.windowBits)) {
    opt.windowBits += 32;
  }

  // Gzip header has no info about windows size, we can do autodetect only
  // for deflate. So, if window size not set, force it to max when gzip possible
  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
    // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm   = new ZStream();
  this.strm.avail_out = 0;

  var status  = zlib_inflate.inflateInit2(
    this.strm,
    opt.windowBits
  );

  if (status !== c.Z_OK) {
    throw new Error(msg[status]);
  }

  this.header = new GZheader();

  zlib_inflate.inflateGetHeader(this.strm, this.header);
}

/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Inflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var dictionary = this.options.dictionary;
  var status, _mode;
  var next_out_utf8, tail, utf8str;
  var dict;

  // Flag to properly process Z_BUF_ERROR on testing inflate call
  // when we check that all output data was flushed.
  var allowBufError = false;

  if (this.ended) { return false; }
  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // Only binary strings can be decompressed on practice
    strm.input = strings.binstring2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */

    if (status === c.Z_NEED_DICT && dictionary) {
      // Convert data if needed
      if (typeof dictionary === 'string') {
        dict = strings.string2buf(dictionary);
      } else if (toString.call(dictionary) === '[object ArrayBuffer]') {
        dict = new Uint8Array(dictionary);
      } else {
        dict = dictionary;
      }

      status = zlib_inflate.inflateSetDictionary(this.strm, dict);

    }

    if (status === c.Z_BUF_ERROR && allowBufError === true) {
      status = c.Z_OK;
      allowBufError = false;
    }

    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }

    if (strm.next_out) {
      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {

        if (this.options.to === 'string') {

          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);

          tail = strm.next_out - next_out_utf8;
          utf8str = strings.buf2string(strm.output, next_out_utf8);

          // move tail
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }

          this.onData(utf8str);

        } else {
          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
        }
      }
    }

    // When no more input data, we should check that internal inflate buffers
    // are flushed. The only way to do it when avail_out = 0 - run one more
    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
    // Here we set flag to process this error properly.
    //
    // NOTE. Deflate does not return error in this case and does not needs such
    // logic.
    if (strm.avail_in === 0 && strm.avail_out === 0) {
      allowBufError = true;
    }

  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);

  if (status === c.Z_STREAM_END) {
    _mode = c.Z_FINISH;
  }

  // Finalize on the last chunk.
  if (_mode === c.Z_FINISH) {
    status = zlib_inflate.inflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === c.Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === c.Z_SYNC_FLUSH) {
    this.onEnd(c.Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Inflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Inflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === c.Z_OK) {
    if (this.options.to === 'string') {
      // Glue & convert here, until we teach pako to send
      // utf8 aligned strings to onData
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/
function inflate(input, options) {
  var inflator = new Inflate(options);

  inflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (inflator.err) { throw inflator.msg || msg[inflator.err]; }

  return inflator.result;
}


/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function inflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return inflate(input, options);
}


/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/


exports.Inflate = Inflate;
exports.inflate = inflate;
exports.inflateRaw = inflateRaw;
exports.ungzip  = inflate;


/***/ }),

/***/ 945:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function GZheader() {
  /* true if compressed data believed to be text */
  this.text       = 0;
  /* modification time */
  this.time       = 0;
  /* extra flags (not used when writing a gzip file) */
  this.xflags     = 0;
  /* operating system */
  this.os         = 0;
  /* pointer to extra field or Z_NULL if none */
  this.extra      = null;
  /* extra field length (valid if extra != Z_NULL) */
  this.extra_len  = 0; // Actually, we don't need it in JS,
                       // but leave for few code modifications

  //
  // Setup limits is not necessary because in js we should not preallocate memory
  // for inflate use constant limit in 65536 bytes
  //

  /* space at extra (only when reading header) */
  // this.extra_max  = 0;
  /* pointer to zero-terminated file name or Z_NULL */
  this.name       = '';
  /* space at name (only when reading header) */
  // this.name_max   = 0;
  /* pointer to zero-terminated comment or Z_NULL */
  this.comment    = '';
  /* space at comment (only when reading header) */
  // this.comm_max   = 0;
  /* true if there was or will be a header crc */
  this.hcrc       = 0;
  /* true when done reading gzip header (not used when writing a gzip file) */
  this.done       = false;
}

module.exports = GZheader;


/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var GenericWorker = __webpack_require__(65);
var utf8 = __webpack_require__(144);
var crc32 = __webpack_require__(490);
var signature = __webpack_require__(601);

/**
 * Transform an integer into a string in hexadecimal.
 * @private
 * @param {number} dec the number to convert.
 * @param {number} bytes the number of bytes to generate.
 * @returns {string} the result.
 */
var decToHex = function(dec, bytes) {
    var hex = "", i;
    for (i = 0; i < bytes; i++) {
        hex += String.fromCharCode(dec & 0xff);
        dec = dec >>> 8;
    }
    return hex;
};

/**
 * Generate the UNIX part of the external file attributes.
 * @param {Object} unixPermissions the unix permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
 *
 * TTTTsstrwxrwxrwx0000000000ADVSHR
 * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
 *     ^^^_________________________ setuid, setgid, sticky
 *        ^^^^^^^^^________________ permissions
 *                 ^^^^^^^^^^______ not used ?
 *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
 */
var generateUnixExternalFileAttr = function (unixPermissions, isDir) {

    var result = unixPermissions;
    if (!unixPermissions) {
        // I can't use octal values in strict mode, hence the hexa.
        //  040775 => 0x41fd
        // 0100664 => 0x81b4
        result = isDir ? 0x41fd : 0x81b4;
    }
    return (result & 0xFFFF) << 16;
};

/**
 * Generate the DOS part of the external file attributes.
 * @param {Object} dosPermissions the dos permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * Bit 0     Read-Only
 * Bit 1     Hidden
 * Bit 2     System
 * Bit 3     Volume Label
 * Bit 4     Directory
 * Bit 5     Archive
 */
var generateDosExternalFileAttr = function (dosPermissions, isDir) {

    // the dir flag is already set for compatibility
    return (dosPermissions || 0)  & 0x3F;
};

/**
 * Generate the various parts used in the construction of the final zip file.
 * @param {Object} streamInfo the hash with informations about the compressed file.
 * @param {Boolean} streamedContent is the content streamed ?
 * @param {Boolean} streamingEnded is the stream finished ?
 * @param {number} offset the current offset from the start of the zip file.
 * @param {String} platform let's pretend we are this platform (change platform dependents fields)
 * @param {Function} encodeFileName the function to encode the file name / comment.
 * @return {Object} the zip parts.
 */
var generateZipParts = function(streamInfo, streamedContent, streamingEnded, offset, platform, encodeFileName) {
    var file = streamInfo['file'],
    compression = streamInfo['compression'],
    useCustomEncoding = encodeFileName !== utf8.utf8encode,
    encodedFileName = utils.transformTo("string", encodeFileName(file.name)),
    utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
    comment = file.comment,
    encodedComment = utils.transformTo("string", encodeFileName(comment)),
    utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
    useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
    useUTF8ForComment = utfEncodedComment.length !== comment.length,
    dosTime,
    dosDate,
    extraFields = "",
    unicodePathExtraField = "",
    unicodeCommentExtraField = "",
    dir = file.dir,
    date = file.date;


    var dataInfo = {
        crc32 : 0,
        compressedSize : 0,
        uncompressedSize : 0
    };

    // if the content is streamed, the sizes/crc32 are only available AFTER
    // the end of the stream.
    if (!streamedContent || streamingEnded) {
        dataInfo.crc32 = streamInfo['crc32'];
        dataInfo.compressedSize = streamInfo['compressedSize'];
        dataInfo.uncompressedSize = streamInfo['uncompressedSize'];
    }

    var bitflag = 0;
    if (streamedContent) {
        // Bit 3: the sizes/crc32 are set to zero in the local header.
        // The correct values are put in the data descriptor immediately
        // following the compressed data.
        bitflag |= 0x0008;
    }
    if (!useCustomEncoding && (useUTF8ForFileName || useUTF8ForComment)) {
        // Bit 11: Language encoding flag (EFS).
        bitflag |= 0x0800;
    }


    var extFileAttr = 0;
    var versionMadeBy = 0;
    if (dir) {
        // dos or unix, we set the dos dir flag
        extFileAttr |= 0x00010;
    }
    if(platform === "UNIX") {
        versionMadeBy = 0x031E; // UNIX, version 3.0
        extFileAttr |= generateUnixExternalFileAttr(file.unixPermissions, dir);
    } else { // DOS or other, fallback to DOS
        versionMadeBy = 0x0014; // DOS, version 2.0
        extFileAttr |= generateDosExternalFileAttr(file.dosPermissions, dir);
    }

    // date
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html

    dosTime = date.getUTCHours();
    dosTime = dosTime << 6;
    dosTime = dosTime | date.getUTCMinutes();
    dosTime = dosTime << 5;
    dosTime = dosTime | date.getUTCSeconds() / 2;

    dosDate = date.getUTCFullYear() - 1980;
    dosDate = dosDate << 4;
    dosDate = dosDate | (date.getUTCMonth() + 1);
    dosDate = dosDate << 5;
    dosDate = dosDate | date.getUTCDate();

    if (useUTF8ForFileName) {
        // set the unicode path extra field. unzip needs at least one extra
        // field to correctly handle unicode path, so using the path is as good
        // as any other information. This could improve the situation with
        // other archive managers too.
        // This field is usually used without the utf8 flag, with a non
        // unicode path in the header (winrar, winzip). This helps (a bit)
        // with the messy Windows' default compressed folders feature but
        // breaks on p7zip which doesn't seek the unicode path extra field.
        // So for now, UTF-8 everywhere !
        unicodePathExtraField =
            // Version
            decToHex(1, 1) +
            // NameCRC32
            decToHex(crc32(encodedFileName), 4) +
            // UnicodeName
            utfEncodedFileName;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x70" +
            // size
            decToHex(unicodePathExtraField.length, 2) +
            // content
            unicodePathExtraField;
    }

    if(useUTF8ForComment) {

        unicodeCommentExtraField =
            // Version
            decToHex(1, 1) +
            // CommentCRC32
            decToHex(crc32(encodedComment), 4) +
            // UnicodeName
            utfEncodedComment;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x63" +
            // size
            decToHex(unicodeCommentExtraField.length, 2) +
            // content
            unicodeCommentExtraField;
    }

    var header = "";

    // version needed to extract
    header += "\x0A\x00";
    // general purpose bit flag
    header += decToHex(bitflag, 2);
    // compression method
    header += compression.magic;
    // last mod file time
    header += decToHex(dosTime, 2);
    // last mod file date
    header += decToHex(dosDate, 2);
    // crc-32
    header += decToHex(dataInfo.crc32, 4);
    // compressed size
    header += decToHex(dataInfo.compressedSize, 4);
    // uncompressed size
    header += decToHex(dataInfo.uncompressedSize, 4);
    // file name length
    header += decToHex(encodedFileName.length, 2);
    // extra field length
    header += decToHex(extraFields.length, 2);


    var fileRecord = signature.LOCAL_FILE_HEADER + header + encodedFileName + extraFields;

    var dirRecord = signature.CENTRAL_FILE_HEADER +
        // version made by (00: DOS)
        decToHex(versionMadeBy, 2) +
        // file header (common to file and central directory)
        header +
        // file comment length
        decToHex(encodedComment.length, 2) +
        // disk number start
        "\x00\x00" +
        // internal file attributes TODO
        "\x00\x00" +
        // external file attributes
        decToHex(extFileAttr, 4) +
        // relative offset of local header
        decToHex(offset, 4) +
        // file name
        encodedFileName +
        // extra field
        extraFields +
        // file comment
        encodedComment;

    return {
        fileRecord: fileRecord,
        dirRecord: dirRecord
    };
};

/**
 * Generate the EOCD record.
 * @param {Number} entriesCount the number of entries in the zip file.
 * @param {Number} centralDirLength the length (in bytes) of the central dir.
 * @param {Number} localDirLength the length (in bytes) of the local dir.
 * @param {String} comment the zip file comment as a binary string.
 * @param {Function} encodeFileName the function to encode the comment.
 * @return {String} the EOCD record.
 */
var generateCentralDirectoryEnd = function (entriesCount, centralDirLength, localDirLength, comment, encodeFileName) {
    var dirEnd = "";
    var encodedComment = utils.transformTo("string", encodeFileName(comment));

    // end of central dir signature
    dirEnd = signature.CENTRAL_DIRECTORY_END +
        // number of this disk
        "\x00\x00" +
        // number of the disk with the start of the central directory
        "\x00\x00" +
        // total number of entries in the central directory on this disk
        decToHex(entriesCount, 2) +
        // total number of entries in the central directory
        decToHex(entriesCount, 2) +
        // size of the central directory   4 bytes
        decToHex(centralDirLength, 4) +
        // offset of start of central directory with respect to the starting disk number
        decToHex(localDirLength, 4) +
        // .ZIP file comment length
        decToHex(encodedComment.length, 2) +
        // .ZIP file comment
        encodedComment;

    return dirEnd;
};

/**
 * Generate data descriptors for a file entry.
 * @param {Object} streamInfo the hash generated by a worker, containing informations
 * on the file entry.
 * @return {String} the data descriptors.
 */
var generateDataDescriptors = function (streamInfo) {
    var descriptor = "";
    descriptor = signature.DATA_DESCRIPTOR +
        // crc-32                          4 bytes
        decToHex(streamInfo['crc32'], 4) +
        // compressed size                 4 bytes
        decToHex(streamInfo['compressedSize'], 4) +
        // uncompressed size               4 bytes
        decToHex(streamInfo['uncompressedSize'], 4);

    return descriptor;
};


/**
 * A worker to concatenate other workers to create a zip file.
 * @param {Boolean} streamFiles `true` to stream the content of the files,
 * `false` to accumulate it.
 * @param {String} comment the comment to use.
 * @param {String} platform the platform to use, "UNIX" or "DOS".
 * @param {Function} encodeFileName the function to encode file names and comments.
 */
function ZipFileWorker(streamFiles, comment, platform, encodeFileName) {
    GenericWorker.call(this, "ZipFileWorker");
    // The number of bytes written so far. This doesn't count accumulated chunks.
    this.bytesWritten = 0;
    // The comment of the zip file
    this.zipComment = comment;
    // The platform "generating" the zip file.
    this.zipPlatform = platform;
    // the function to encode file names and comments.
    this.encodeFileName = encodeFileName;
    // Should we stream the content of the files ?
    this.streamFiles = streamFiles;
    // If `streamFiles` is false, we will need to accumulate the content of the
    // files to calculate sizes / crc32 (and write them *before* the content).
    // This boolean indicates if we are accumulating chunks (it will change a lot
    // during the lifetime of this worker).
    this.accumulate = false;
    // The buffer receiving chunks when accumulating content.
    this.contentBuffer = [];
    // The list of generated directory records.
    this.dirRecords = [];
    // The offset (in bytes) from the beginning of the zip file for the current source.
    this.currentSourceOffset = 0;
    // The total number of entries in this zip file.
    this.entriesCount = 0;
    // the name of the file currently being added, null when handling the end of the zip file.
    // Used for the emited metadata.
    this.currentFile = null;



    this._sources = [];
}
utils.inherits(ZipFileWorker, GenericWorker);

/**
 * @see GenericWorker.push
 */
ZipFileWorker.prototype.push = function (chunk) {

    var currentFilePercent = chunk.meta.percent || 0;
    var entriesCount = this.entriesCount;
    var remainingFiles = this._sources.length;

    if(this.accumulate) {
        this.contentBuffer.push(chunk);
    } else {
        this.bytesWritten += chunk.data.length;

        GenericWorker.prototype.push.call(this, {
            data : chunk.data,
            meta : {
                currentFile : this.currentFile,
                percent : entriesCount ? (currentFilePercent + 100 * (entriesCount - remainingFiles - 1)) / entriesCount : 100
            }
        });
    }
};

/**
 * The worker started a new source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the new source.
 */
ZipFileWorker.prototype.openedSource = function (streamInfo) {
    this.currentSourceOffset = this.bytesWritten;
    this.currentFile = streamInfo['file'].name;

    var streamedContent = this.streamFiles && !streamInfo['file'].dir;

    // don't stream folders (because they don't have any content)
    if(streamedContent) {
        var record = generateZipParts(streamInfo, streamedContent, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        this.push({
            data : record.fileRecord,
            meta : {percent:0}
        });
    } else {
        // we need to wait for the whole file before pushing anything
        this.accumulate = true;
    }
};

/**
 * The worker finished a source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the finished source.
 */
ZipFileWorker.prototype.closedSource = function (streamInfo) {
    this.accumulate = false;
    var streamedContent = this.streamFiles && !streamInfo['file'].dir;
    var record = generateZipParts(streamInfo, streamedContent, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);

    this.dirRecords.push(record.dirRecord);
    if(streamedContent) {
        // after the streamed file, we put data descriptors
        this.push({
            data : generateDataDescriptors(streamInfo),
            meta : {percent:100}
        });
    } else {
        // the content wasn't streamed, we need to push everything now
        // first the file record, then the content
        this.push({
            data : record.fileRecord,
            meta : {percent:0}
        });
        while(this.contentBuffer.length) {
            this.push(this.contentBuffer.shift());
        }
    }
    this.currentFile = null;
};

/**
 * @see GenericWorker.flush
 */
ZipFileWorker.prototype.flush = function () {

    var localDirLength = this.bytesWritten;
    for(var i = 0; i < this.dirRecords.length; i++) {
        this.push({
            data : this.dirRecords[i],
            meta : {percent:100}
        });
    }
    var centralDirLength = this.bytesWritten - localDirLength;

    var dirEnd = generateCentralDirectoryEnd(this.dirRecords.length, centralDirLength, localDirLength, this.zipComment, this.encodeFileName);

    this.push({
        data : dirEnd,
        meta : {percent:100}
    });
};

/**
 * Prepare the next source to be read.
 */
ZipFileWorker.prototype.prepareNextSource = function () {
    this.previous = this._sources.shift();
    this.openedSource(this.previous.streamInfo);
    if (this.isPaused) {
        this.previous.pause();
    } else {
        this.previous.resume();
    }
};

/**
 * @see GenericWorker.registerPrevious
 */
ZipFileWorker.prototype.registerPrevious = function (previous) {
    this._sources.push(previous);
    var self = this;

    previous.on('data', function (chunk) {
        self.processChunk(chunk);
    });
    previous.on('end', function () {
        self.closedSource(self.previous.streamInfo);
        if(self._sources.length) {
            self.prepareNextSource();
        } else {
            self.end();
        }
    });
    previous.on('error', function (e) {
        self.error(e);
    });
    return this;
};

/**
 * @see GenericWorker.resume
 */
ZipFileWorker.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if (!this.previous && this._sources.length) {
        this.prepareNextSource();
        return true;
    }
    if (!this.previous && !this._sources.length && !this.generatedError) {
        this.end();
        return true;
    }
};

/**
 * @see GenericWorker.error
 */
ZipFileWorker.prototype.error = function (e) {
    var sources = this._sources;
    if(!GenericWorker.prototype.error.call(this, e)) {
        return false;
    }
    for(var i = 0; i < sources.length; i++) {
        try {
            sources[i].error(e);
        } catch(e) {
            // the `error` exploded, nothing to do
        }
    }
    return true;
};

/**
 * @see GenericWorker.lock
 */
ZipFileWorker.prototype.lock = function () {
    GenericWorker.prototype.lock.call(this);
    var sources = this._sources;
    for(var i = 0; i < sources.length; i++) {
        sources[i].lock();
    }
};

module.exports = ZipFileWorker;


/***/ }),

/***/ 947:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var GenericWorker = __webpack_require__(65);

/**
 * A worker that use a nodejs stream as source.
 * @constructor
 * @param {String} filename the name of the file entry for this stream.
 * @param {Readable} stream the nodejs stream.
 */
function NodejsStreamInputAdapter(filename, stream) {
    GenericWorker.call(this, "Nodejs stream input adapter for " + filename);
    this._upstreamEnded = false;
    this._bindStream(stream);
}

utils.inherits(NodejsStreamInputAdapter, GenericWorker);

/**
 * Prepare the stream and bind the callbacks on it.
 * Do this ASAP on node 0.10 ! A lazy binding doesn't always work.
 * @param {Stream} stream the nodejs stream to use.
 */
NodejsStreamInputAdapter.prototype._bindStream = function (stream) {
    var self = this;
    this._stream = stream;
    stream.pause();
    stream
    .on("data", function (chunk) {
        self.push({
            data: chunk,
            meta : {
                percent : 0
            }
        });
    })
    .on("error", function (e) {
        if(self.isPaused) {
            this.generatedError = e;
        } else {
            self.error(e);
        }
    })
    .on("end", function () {
        if(self.isPaused) {
            self._upstreamEnded = true;
        } else {
            self.end();
        }
    });
};
NodejsStreamInputAdapter.prototype.pause = function () {
    if(!GenericWorker.prototype.pause.call(this)) {
        return false;
    }
    this._stream.pause();
    return true;
};
NodejsStreamInputAdapter.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if(this._upstreamEnded) {
        this.end();
    } else {
        this._stream.resume();
    }

    return true;
};

module.exports = NodejsStreamInputAdapter;


/***/ }),

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var utils = __webpack_require__(35);
var external = __webpack_require__(218);
var utf8 = __webpack_require__(144);
var utils = __webpack_require__(35);
var ZipEntries = __webpack_require__(949);
var Crc32Probe = __webpack_require__(598);
var nodejsUtils = __webpack_require__(238);

/**
 * Check the CRC32 of an entry.
 * @param {ZipEntry} zipEntry the zip entry to check.
 * @return {Promise} the result.
 */
function checkEntryCRC32(zipEntry) {
    return new external.Promise(function (resolve, reject) {
        var worker = zipEntry.decompressed.getContentWorker().pipe(new Crc32Probe());
        worker.on("error", function (e) {
            reject(e);
        })
        .on("end", function () {
            if (worker.streamInfo.crc32 !== zipEntry.decompressed.crc32) {
                reject(new Error("Corrupted zip : CRC32 mismatch"));
            } else {
                resolve();
            }
        })
        .resume();
    });
}

module.exports = function(data, options) {
    var zip = this;
    options = utils.extend(options || {}, {
        base64: false,
        checkCRC32: false,
        optimizedBinaryString: false,
        createFolders: false,
        decodeFileName: utf8.utf8decode
    });

    if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
        return external.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file."));
    }

    return utils.prepareContent("the loaded zip file", data, true, options.optimizedBinaryString, options.base64)
    .then(function(data) {
        var zipEntries = new ZipEntries(options);
        zipEntries.load(data);
        return zipEntries;
    }).then(function checkCRC32(zipEntries) {
        var promises = [external.Promise.resolve(zipEntries)];
        var files = zipEntries.files;
        if (options.checkCRC32) {
            for (var i = 0; i < files.length; i++) {
                promises.push(checkEntryCRC32(files[i]));
            }
        }
        return external.Promise.all(promises);
    }).then(function addFiles(results) {
        var zipEntries = results.shift();
        var files = zipEntries.files;
        for (var i = 0; i < files.length; i++) {
            var input = files[i];
            zip.file(input.fileNameStr, input.decompressed, {
                binary: true,
                optimizedBinaryString: true,
                date: input.date,
                dir: input.dir,
                comment : input.fileCommentStr.length ? input.fileCommentStr : null,
                unixPermissions : input.unixPermissions,
                dosPermissions : input.dosPermissions,
                createFolders: options.createFolders
            });
        }
        if (zipEntries.zipComment.length) {
            zip.comment = zipEntries.zipComment;
        }

        return zip;
    });
};


/***/ }),

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var readerFor = __webpack_require__(602);
var utils = __webpack_require__(35);
var sig = __webpack_require__(601);
var ZipEntry = __webpack_require__(952);
var utf8 = __webpack_require__(144);
var support = __webpack_require__(117);
//  class ZipEntries {{{
/**
 * All the entries in the zip file.
 * @constructor
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntries(loadOptions) {
    this.files = [];
    this.loadOptions = loadOptions;
}
ZipEntries.prototype = {
    /**
     * Check that the reader is on the speficied signature.
     * @param {string} expectedSignature the expected signature.
     * @throws {Error} if it is an other signature.
     */
    checkSignature: function(expectedSignature) {
        if (!this.reader.readAndCheckSignature(expectedSignature)) {
            this.reader.index -= 4;
            var signature = this.reader.readString(4);
            throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
        }
    },
    /**
     * Check if the given signature is at the given index.
     * @param {number} askedIndex the index to check.
     * @param {string} expectedSignature the signature to expect.
     * @return {boolean} true if the signature is here, false otherwise.
     */
    isSignature: function(askedIndex, expectedSignature) {
        var currentIndex = this.reader.index;
        this.reader.setIndex(askedIndex);
        var signature = this.reader.readString(4);
        var result = signature === expectedSignature;
        this.reader.setIndex(currentIndex);
        return result;
    },
    /**
     * Read the end of the central directory.
     */
    readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2);
        this.diskWithCentralDirStart = this.reader.readInt(2);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
        this.centralDirRecords = this.reader.readInt(2);
        this.centralDirSize = this.reader.readInt(4);
        this.centralDirOffset = this.reader.readInt(4);

        this.zipCommentLength = this.reader.readInt(2);
        // warning : the encoding depends of the system locale
        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
        // On a windows machine, this field is encoded with the localized windows code page.
        var zipComment = this.reader.readData(this.zipCommentLength);
        var decodeParamType = support.uint8array ? "uint8array" : "array";
        // To get consistent behavior with the generation part, we will assume that
        // this is utf8 encoded unless specified otherwise.
        var decodeContent = utils.transformTo(decodeParamType, zipComment);
        this.zipComment = this.loadOptions.decodeFileName(decodeContent);
    },
    /**
     * Read the end of the Zip 64 central directory.
     * Not merged with the method readEndOfCentral :
     * The end of central can coexist with its Zip64 brother,
     * I don't want to read the wrong number of bytes !
     */
    readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8);
        this.reader.skip(4);
        // this.versionMadeBy = this.reader.readString(2);
        // this.versionNeeded = this.reader.readInt(2);
        this.diskNumber = this.reader.readInt(4);
        this.diskWithCentralDirStart = this.reader.readInt(4);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
        this.centralDirRecords = this.reader.readInt(8);
        this.centralDirSize = this.reader.readInt(8);
        this.centralDirOffset = this.reader.readInt(8);

        this.zip64ExtensibleData = {};
        var extraDataSize = this.zip64EndOfCentralSize - 44,
            index = 0,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;
        while (index < extraDataSize) {
            extraFieldId = this.reader.readInt(2);
            extraFieldLength = this.reader.readInt(4);
            extraFieldValue = this.reader.readData(extraFieldLength);
            this.zip64ExtensibleData[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Read the end of the Zip 64 central directory locator.
     */
    readBlockZip64EndOfCentralLocator: function() {
        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
        this.disksCount = this.reader.readInt(4);
        if (this.disksCount > 1) {
            throw new Error("Multi-volumes zip are not supported");
        }
    },
    /**
     * Read the local files, based on the offset read in the central part.
     */
    readLocalFiles: function() {
        var i, file;
        for (i = 0; i < this.files.length; i++) {
            file = this.files[i];
            this.reader.setIndex(file.localHeaderOffset);
            this.checkSignature(sig.LOCAL_FILE_HEADER);
            file.readLocalPart(this.reader);
            file.handleUTF8();
            file.processAttributes();
        }
    },
    /**
     * Read the central directory.
     */
    readCentralDir: function() {
        var file;

        this.reader.setIndex(this.centralDirOffset);
        while (this.reader.readAndCheckSignature(sig.CENTRAL_FILE_HEADER)) {
            file = new ZipEntry({
                zip64: this.zip64
            }, this.loadOptions);
            file.readCentralPart(this.reader);
            this.files.push(file);
        }

        if (this.centralDirRecords !== this.files.length) {
            if (this.centralDirRecords !== 0 && this.files.length === 0) {
                // We expected some records but couldn't find ANY.
                // This is really suspicious, as if something went wrong.
                throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
            } else {
                // We found some records but not all.
                // Something is wrong but we got something for the user: no error here.
                // console.warn("expected", this.centralDirRecords, "records in central dir, got", this.files.length);
            }
        }
    },
    /**
     * Read the end of central directory.
     */
    readEndOfCentral: function() {
        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
        if (offset < 0) {
            // Check if the content is a truncated zip or complete garbage.
            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
            // extractible zip for example) but it can give a good hint.
            // If an ajax request was used without responseType, we will also
            // get unreadable data.
            var isGarbage = !this.isSignature(0, sig.LOCAL_FILE_HEADER);

            if (isGarbage) {
                throw new Error("Can't find end of central directory : is this a zip file ? " +
                                "If it is, see http://stuk.github.io/jszip/documentation/howto/read_zip.html");
            } else {
                throw new Error("Corrupted zip : can't find end of central directory");
            }

        }
        this.reader.setIndex(offset);
        var endOfCentralDirOffset = offset;
        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
        this.readBlockEndOfCentral();


        /* extract from the zip spec :
            4)  If one of the fields in the end of central directory
                record is too small to hold required data, the field
                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
                ZIP64 format record should be created.
            5)  The end of central directory record and the
                Zip64 end of central directory locator record must
                reside on the same disk when splitting or spanning
                an archive.
         */
        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
            this.zip64 = true;

            /*
            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
            all numbers as 64-bit double precision IEEE 754 floating point numbers.
            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
            */

            // should look for a zip64 EOCD locator
            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            if (offset < 0) {
                throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
            }
            this.reader.setIndex(offset);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            this.readBlockZip64EndOfCentralLocator();

            // now the zip64 EOCD record
            if (!this.isSignature(this.relativeOffsetEndOfZip64CentralDir, sig.ZIP64_CENTRAL_DIRECTORY_END)) {
                // console.warn("ZIP64 end of central directory not where expected.");
                this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
                if (this.relativeOffsetEndOfZip64CentralDir < 0) {
                    throw new Error("Corrupted zip : can't find the ZIP64 end of central directory");
                }
            }
            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
            this.readBlockZip64EndOfCentral();
        }

        var expectedEndOfCentralDirOffset = this.centralDirOffset + this.centralDirSize;
        if (this.zip64) {
            expectedEndOfCentralDirOffset += 20; // end of central dir 64 locator
            expectedEndOfCentralDirOffset += 12 /* should not include the leading 12 bytes */ + this.zip64EndOfCentralSize;
        }

        var extraBytes = endOfCentralDirOffset - expectedEndOfCentralDirOffset;

        if (extraBytes > 0) {
            // console.warn(extraBytes, "extra bytes at beginning or within zipfile");
            if (this.isSignature(endOfCentralDirOffset, sig.CENTRAL_FILE_HEADER)) {
                // The offsets seem wrong, but we have something at the specified offset.
                // So… we keep it.
            } else {
                // the offset is wrong, update the "zero" of the reader
                // this happens if data has been prepended (crx files for example)
                this.reader.zero = extraBytes;
            }
        } else if (extraBytes < 0) {
            throw new Error("Corrupted zip: missing " + Math.abs(extraBytes) + " bytes.");
        }
    },
    prepareReader: function(data) {
        this.reader = readerFor(data);
    },
    /**
     * Read a zip file and create ZipEntries.
     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
     */
    load: function(data) {
        this.prepareReader(data);
        this.readEndOfCentral();
        this.readCentralDir();
        this.readLocalFiles();
    }
};
// }}} end of ZipEntries
module.exports = ZipEntries;


/***/ }),

/***/ 95:
/***/ (function(module, exports) {

module.exports = function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
};


/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DataReader = __webpack_require__(604);
var utils = __webpack_require__(35);

function StringReader(data) {
    DataReader.call(this, data);
}
utils.inherits(StringReader, DataReader);
/**
 * @see DataReader.byteAt
 */
StringReader.prototype.byteAt = function(i) {
    return this.data.charCodeAt(this.zero + i);
};
/**
 * @see DataReader.lastIndexOfSignature
 */
StringReader.prototype.lastIndexOfSignature = function(sig) {
    return this.data.lastIndexOf(sig) - this.zero;
};
/**
 * @see DataReader.readAndCheckSignature
 */
StringReader.prototype.readAndCheckSignature = function (sig) {
    var data = this.readData(4);
    return sig === data;
};
/**
 * @see DataReader.readData
 */
StringReader.prototype.readData = function(size) {
    this.checkOffset(size);
    // this will work because the constructor applied the "& 0xff" mask.
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = StringReader;


/***/ }),

/***/ 951:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Uint8ArrayReader = __webpack_require__(605);
var utils = __webpack_require__(35);

function NodeBufferReader(data) {
    Uint8ArrayReader.call(this, data);
}
utils.inherits(NodeBufferReader, Uint8ArrayReader);

/**
 * @see DataReader.readData
 */
NodeBufferReader.prototype.readData = function(size) {
    this.checkOffset(size);
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = NodeBufferReader;


/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var readerFor = __webpack_require__(602);
var utils = __webpack_require__(35);
var CompressedObject = __webpack_require__(489);
var crc32fn = __webpack_require__(490);
var utf8 = __webpack_require__(144);
var compressions = __webpack_require__(599);
var support = __webpack_require__(117);

var MADE_BY_DOS = 0x00;
var MADE_BY_UNIX = 0x03;

/**
 * Find a compression registered in JSZip.
 * @param {string} compressionMethod the method magic to find.
 * @return {Object|null} the JSZip compression object, null if none found.
 */
var findCompression = function(compressionMethod) {
    for (var method in compressions) {
        if (!compressions.hasOwnProperty(method)) {
            continue;
        }
        if (compressions[method].magic === compressionMethod) {
            return compressions[method];
        }
    }
    return null;
};

// class ZipEntry {{{
/**
 * An entry in the zip file.
 * @constructor
 * @param {Object} options Options of the current file.
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntry(options, loadOptions) {
    this.options = options;
    this.loadOptions = loadOptions;
}
ZipEntry.prototype = {
    /**
     * say if the file is encrypted.
     * @return {boolean} true if the file is encrypted, false otherwise.
     */
    isEncrypted: function() {
        // bit 1 is set
        return (this.bitFlag & 0x0001) === 0x0001;
    },
    /**
     * say if the file has utf-8 filename/comment.
     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
     */
    useUTF8: function() {
        // bit 11 is set
        return (this.bitFlag & 0x0800) === 0x0800;
    },
    /**
     * Read the local part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readLocalPart: function(reader) {
        var compression, localExtraFieldsLength;

        // we already know everything from the central dir !
        // If the central dir data are false, we are doomed.
        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
        // The less data we get here, the more reliable this should be.
        // Let's skip the whole header and dash to the data !
        reader.skip(22);
        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
        // Strangely, the filename here is OK.
        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
        // the internet.
        //
        // I think I see the logic here : the central directory is used to display
        // content and the local directory is used to extract the files. Mixing / and \
        // may be used to display \ to windows users and use / when extracting the files.
        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
        this.fileNameLength = reader.readInt(2);
        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
        // the fileName is stored as binary data, the handleUTF8 method will take care of the encoding.
        this.fileName = reader.readData(this.fileNameLength);
        reader.skip(localExtraFieldsLength);

        if (this.compressedSize === -1 || this.uncompressedSize === -1) {
            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize === -1 || uncompressedSize === -1)");
        }

        compression = findCompression(this.compressionMethod);
        if (compression === null) { // no compression found
            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + utils.transformTo("string", this.fileName) + ")");
        }
        this.decompressed = new CompressedObject(this.compressedSize, this.uncompressedSize, this.crc32, compression, reader.readData(this.compressedSize));
    },

    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readCentralPart: function(reader) {
        this.versionMadeBy = reader.readInt(2);
        reader.skip(2);
        // this.versionNeeded = reader.readInt(2);
        this.bitFlag = reader.readInt(2);
        this.compressionMethod = reader.readString(2);
        this.date = reader.readDate();
        this.crc32 = reader.readInt(4);
        this.compressedSize = reader.readInt(4);
        this.uncompressedSize = reader.readInt(4);
        var fileNameLength = reader.readInt(2);
        this.extraFieldsLength = reader.readInt(2);
        this.fileCommentLength = reader.readInt(2);
        this.diskNumberStart = reader.readInt(2);
        this.internalFileAttributes = reader.readInt(2);
        this.externalFileAttributes = reader.readInt(4);
        this.localHeaderOffset = reader.readInt(4);

        if (this.isEncrypted()) {
            throw new Error("Encrypted zip are not supported");
        }

        // will be read in the local part, see the comments there
        reader.skip(fileNameLength);
        this.readExtraFields(reader);
        this.parseZIP64ExtraField(reader);
        this.fileComment = reader.readData(this.fileCommentLength);
    },

    /**
     * Parse the external file attributes and get the unix/dos permissions.
     */
    processAttributes: function () {
        this.unixPermissions = null;
        this.dosPermissions = null;
        var madeBy = this.versionMadeBy >> 8;

        // Check if we have the DOS directory flag set.
        // We look for it in the DOS and UNIX permissions
        // but some unknown platform could set it as a compatibility flag.
        this.dir = this.externalFileAttributes & 0x0010 ? true : false;

        if(madeBy === MADE_BY_DOS) {
            // first 6 bits (0 to 5)
            this.dosPermissions = this.externalFileAttributes & 0x3F;
        }

        if(madeBy === MADE_BY_UNIX) {
            this.unixPermissions = (this.externalFileAttributes >> 16) & 0xFFFF;
            // the octal permissions are in (this.unixPermissions & 0x01FF).toString(8);
        }

        // fail safe : if the name ends with a / it probably means a folder
        if (!this.dir && this.fileNameStr.slice(-1) === '/') {
            this.dir = true;
        }
    },

    /**
     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
     * @param {DataReader} reader the reader to use.
     */
    parseZIP64ExtraField: function(reader) {

        if (!this.extraFields[0x0001]) {
            return;
        }

        // should be something, preparing the extra reader
        var extraReader = readerFor(this.extraFields[0x0001].value);

        // I really hope that these 64bits integer can fit in 32 bits integer, because js
        // won't let us have more.
        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
            this.uncompressedSize = extraReader.readInt(8);
        }
        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
            this.compressedSize = extraReader.readInt(8);
        }
        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
            this.localHeaderOffset = extraReader.readInt(8);
        }
        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
            this.diskNumberStart = extraReader.readInt(4);
        }
    },
    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readExtraFields: function(reader) {
        var end = reader.index + this.extraFieldsLength,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;

        if (!this.extraFields) {
            this.extraFields = {};
        }

        while (reader.index < end) {
            extraFieldId = reader.readInt(2);
            extraFieldLength = reader.readInt(2);
            extraFieldValue = reader.readData(extraFieldLength);

            this.extraFields[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Apply an UTF8 transformation if needed.
     */
    handleUTF8: function() {
        var decodeParamType = support.uint8array ? "uint8array" : "array";
        if (this.useUTF8()) {
            this.fileNameStr = utf8.utf8decode(this.fileName);
            this.fileCommentStr = utf8.utf8decode(this.fileComment);
        } else {
            var upath = this.findExtraFieldUnicodePath();
            if (upath !== null) {
                this.fileNameStr = upath;
            } else {
                // ASCII text or unsupported code page
                var fileNameByteArray =  utils.transformTo(decodeParamType, this.fileName);
                this.fileNameStr = this.loadOptions.decodeFileName(fileNameByteArray);
            }

            var ucomment = this.findExtraFieldUnicodeComment();
            if (ucomment !== null) {
                this.fileCommentStr = ucomment;
            } else {
                // ASCII text or unsupported code page
                var commentByteArray =  utils.transformTo(decodeParamType, this.fileComment);
                this.fileCommentStr = this.loadOptions.decodeFileName(commentByteArray);
            }
        }
    },

    /**
     * Find the unicode path declared in the extra field, if any.
     * @return {String} the unicode path, null otherwise.
     */
    findExtraFieldUnicodePath: function() {
        var upathField = this.extraFields[0x7075];
        if (upathField) {
            var extraReader = readerFor(upathField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the filename changed, this field is out of date.
            if (crc32fn(this.fileName) !== extraReader.readInt(4)) {
                return null;
            }

            return utf8.utf8decode(extraReader.readData(upathField.length - 5));
        }
        return null;
    },

    /**
     * Find the unicode comment declared in the extra field, if any.
     * @return {String} the unicode comment, null otherwise.
     */
    findExtraFieldUnicodeComment: function() {
        var ucommentField = this.extraFields[0x6375];
        if (ucommentField) {
            var extraReader = readerFor(ucommentField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the comment changed, this field is out of date.
            if (crc32fn(this.fileComment) !== extraReader.readInt(4)) {
                return null;
            }

            return utf8.utf8decode(extraReader.readData(ucommentField.length - 5));
        }
        return null;
    }
};
module.exports = ZipEntry;


/***/ }),

/***/ 953:
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = __webpack_require__(36);

var _reactRouterRedux = __webpack_require__(27);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _constants = __webpack_require__(658);

var cnt = _interopRequireWildcard(_constants);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getAssets),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(downloadContractingDocs),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(init),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(handleTracking),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(getRequest),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(rerouteOrDownload),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(onVerifyTokenSuccess),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(updateContractStatus),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(login),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(routeToAppAfterLogin),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(signUp),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(autoLogin),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(scheduleDemo),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(requestEzLoad),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(handleAfterSignup),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(sendExternalRates),
    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(downloadAll),
    _marked18 = /*#__PURE__*/regeneratorRuntime.mark(sendExternalRatesForOneRequest),
    _marked19 = /*#__PURE__*/regeneratorRuntime.mark(routeAfterCheckForDummy),
    _marked20 = /*#__PURE__*/regeneratorRuntime.mark(handleAutoLoginError),
    _marked21 = /*#__PURE__*/regeneratorRuntime.mark(doSignRateDocs),
    _marked22 = /*#__PURE__*/regeneratorRuntime.mark(markDummyTemplateAsViewed); /* global window */


function getAssets() {
  var _ref, senderId;

  return regeneratorRuntime.wrap(function getAssets$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 2:
          _ref = _context.sent;
          senderId = _ref.senderId;
          return _context.delegateYield((0, _sagas.apiSaga)(cnt.GET_ASSETS, _api.assetLanding.getAssets, [senderId]), 't0', 5);

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function downloadContractingDocs(_ref2) {
  var docId = _ref2.payload.docId;
  return regeneratorRuntime.wrap(function downloadContractingDocs$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!docId) {
            _context2.next = 3;
            break;
          }

          _context2.next = 3;
          return (0, _effects.put)({
            type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
            payload: {
              docId: docId,
              collection: 'contract',
              isBulk: true,
              forAL: true
            }
          });

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}
function openXls(_ref3) {
  var location = _ref3.payload.location;

  window.open(location);
}

function init(_ref4) {
  var payload = _ref4.payload;
  var hashToken, oldUrlPayload;
  return regeneratorRuntime.wrap(function init$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          hashToken = payload.hashToken || 'oldUrl';
          oldUrlPayload = payload.hashToken ? null : payload;
          // Important, we use this to retrieve the logged in session
          // we want to do this before verify token (retrieving info in the token from the backend)
          // so that after VERIFY_TOKEN, we can handle reroute first

          _context3.next = 4;
          return (0, _sagas.apiSaga)(cnt.GET_LOGGED_IN_SESSION, _api.admin.getSessionInfo, []);

        case 4:
          _context3.next = 6;
          return (0, _sagas.apiSaga)('VERIFY_TOKEN', _api.assetLanding.verifyToken, [hashToken, oldUrlPayload]);

        case 6:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function handleTracking(_ref5) {
  var payload = _ref5.payload;

  var _ref6, email, viewAs, userId;

  return regeneratorRuntime.wrap(function handleTracking$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 2:
          _ref6 = _context4.sent;
          email = _ref6.email;
          viewAs = _ref6.viewAs;
          userId = _ref6.userId;
          _context4.next = 8;
          return (0, _effects.put)({
            type: 'TRACK_EVENT',
            payload: {
              ga: {
                eventCategory: 'assetLanding',
                eventAction: payload.eventAction || 'click ' + payload.type + ' - ' + viewAs,
                eventLabel: email + '-' + userId
              }
            }
          });

        case 8:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function getRequest(_ref7) {
  var crId = _ref7.payload.crId;
  return regeneratorRuntime.wrap(function getRequest$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _sagas.apiSaga)('[asset-landing]GET_REQUEST', _api.contracting.getContractInfo, [{
            collection: 'contract',
            type: 'policyNotes',
            docId: crId,
            forAL: true
          }]);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function rerouteOrDownload() {
  var _ref8, _ref8$loggedInSession, loggedInSession, contractId, contractIds, DL, shortid, hashToken, fromHash, userId, companyType, viewerLoggedInAndCorrectAcctType, downloadPayload;

  return regeneratorRuntime.wrap(function rerouteOrDownload$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 2:
          _ref8 = _context6.sent;
          _ref8$loggedInSession = _ref8.loggedInSession;
          loggedInSession = _ref8$loggedInSession === undefined ? {} : _ref8$loggedInSession;
          contractId = _ref8.contractId;
          contractIds = _ref8.contractIds;
          DL = _ref8.DL;
          shortid = _ref8.shortid;
          hashToken = _ref8.hashToken;
          fromHash = _objectWithoutProperties(_ref8, ['loggedInSession', 'contractId', 'contractIds', 'DL', 'shortid', 'hashToken']);
          userId = loggedInSession.userId, companyType = loggedInSession.companyType;
          viewerLoggedInAndCorrectAcctType = userId && fromHash.userId && userId === fromHash.userId && companyType === fromHash.viewAs;
          // if viewer is the sender of the contract/request
          // OR if the receiver of the contract/request and is logged in to the correct account
          // route them to contract or contract list

          if (!(fromHash.viewerIsContractSender || viewerLoggedInAndCorrectAcctType)) {
            _context6.next = 17;
            break;
          }

          if (contractId || contractIds && contractIds.length === 1) {
            window.location = window.location.protocol + '//' + window.location.host + '/contracting/contract/' + (contractId || contractIds[0]) + '/details';
          } else {
            window.location = window.location.protocol + '//' + window.location.host + '/contracting/contract-list/recent?contractIds=' + contractIds;
          }
          _context6.next = 41;
          break;

        case 17:
          if (!(fromHash.viewAs === 'Contractor')) {
            _context6.next = 24;
            break;
          }

          downloadPayload = {
            collection: 'contract',
            isBulk: true,
            forAL: true
          };

          if (contractId) {
            downloadPayload.docId = contractId;
          } else if (contractIds && contractIds.length === 1) {
            downloadPayload.docId = contractIds[0];
          } else if (contractIds && contractIds.length > 1) {
            downloadPayload.contractIds = contractIds;
          }
          _context6.next = 22;
          return (0, _effects.put)({
            type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
            payload: downloadPayload
          });

        case 22:
          _context6.next = 41;
          break;

        case 24:
          if (!(fromHash.viewAs === 'Supplier' && (contractId || contractIds && contractIds.length === 1))) {
            _context6.next = 41;
            break;
          }

          if (!DL) {
            _context6.next = 30;
            break;
          }

          _context6.next = 28;
          return (0, _sagas.apiSaga)('[asset-landing]CHECK_DUMMY_ACCOUNT', _api.assetLanding.checkDummyAccount, [{ shortid: shortid, contractId: contractId || contractIds[0] }]);

        case 28:
          _context6.next = 41;
          break;

        case 30:
          _context6.t0 = _effects.put;
          _context6.t1 = _reactRouterRedux.push;
          _context6.next = 34;
          return (0, _effects.select)(function (state) {
            return state.routing.locationBeforeTransitions.query;
          });

        case 34:
          _context6.t2 = _context6.sent;
          _context6.t3 = {
            pathname: '/assets-landing-request',
            query: _context6.t2
          };
          _context6.t4 = (0, _context6.t1)(_context6.t3);
          _context6.next = 39;
          return (0, _context6.t0)(_context6.t4);

        case 39:
          _context6.next = 41;
          return getRequest({
            payload: {
              crId: contractId || contractIds[0]
            }
          });

        case 41:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function onVerifyTokenSuccess(_ref9) {
  var payload = _ref9.payload;
  var hashToken, encryptedEmail;
  return regeneratorRuntime.wrap(function onVerifyTokenSuccess$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          hashToken = payload.hashToken;

          if (!(payload.autosignin && payload.userId)) {
            _context7.next = 4;
            break;
          }

          return _context7.delegateYield((0, _sagas.apiSaga)(cnt.AUTO_LOGIN, _api.account.loginAsUser, [_extends({
            hashToken: hashToken,
            email: payload.realActorEmail
          }, payload)]), 't0', 3);

        case 3:
          return _context7.abrupt('return');

        case 4:
          encryptedEmail = payload.encryptedEmail || 'newUrl';
          // this is to add hashtoken to req.headers for requests sending from AL page

          _context7.next = 7;
          return (0, _sagas.apiSaga)(cnt.AUTH_BY_TOKEN, _api.assetLanding.authByToken, [hashToken, encryptedEmail]);

        case 7:
          sessionStorage.setItem('hashtoken', hashToken);
          sessionStorage.setItem('encryptedemail', encryptedEmail);

          if (!(window.location.pathname.indexOf('/assets-landing-signing') > -1)) {
            _context7.next = 14;
            break;
          }

          _context7.next = 12;
          return getRequest({
            payload: payload
          });

        case 12:
          _context7.next = 18;
          break;

        case 14:
          _context7.next = 16;
          return rerouteOrDownload();

        case 16:
          _context7.next = 18;
          return (0, _effects.all)([getAssets(), handleTracking({
            payload: {
              eventAction: 'page load - ' + (payload.userId ? 'Internal' : 'External') + ' ' + payload.viewAs
            }
          })]);

        case 18:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function updateContractStatus(_ref10) {
  var type = _ref10.type,
      payload = _ref10.payload;
  return regeneratorRuntime.wrap(function updateContractStatus$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          return _context8.delegateYield(handleTracking({ payload: { type: payload.state } }), 't0', 1);

        case 1:
          return _context8.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.updateContractStatus, [{
            contractIds: payload.contractIds,
            state: payload.state
          }]), 't1', 2);

        case 2:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function login(_ref11) {
  var type = _ref11.type,
      payload = _ref11.payload;
  return regeneratorRuntime.wrap(function login$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          return _context9.delegateYield((0, _sagas.apiSaga)(type, _api.account.login, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function routeToAppAfterLogin(_ref12) {
  var payload = _ref12.payload;

  var _ref13, hashToken, dialog, routeToUrl, jumpBackTo, userId;

  return regeneratorRuntime.wrap(function routeToAppAfterLogin$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          localStorage.setItem('jwt', payload.user.jwt);
          _context10.next = 3;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 3:
          _ref13 = _context10.sent;
          hashToken = _ref13.hashToken;
          dialog = _ref13.dialog;
          routeToUrl = _ref13.routeToUrl;
          jumpBackTo = _ref13.jumpBackTo;
          userId = _ref13.userId;

          if (dialog.associateEmail || dialog.routeToConsolidation) {
            window.location = window.location.protocol + '//' + window.location.host + '/assets-consolidation/' + hashToken + '?associateEmail=' + dialog.associateEmail;
          } else if (routeToUrl) {
            window.location = '' + routeToUrl + (routeToUrl.indexOf('?') > -1 ? '&' : '?') + 'jumpBackTo=' + jumpBackTo + '&magicLinkHashToken=' + hashToken;
          } else {
            window.location = window.location.protocol + '//' + window.location.host + '/contracting/contract-list/recent';
          }

        case 10:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function signUp() {
  var signup;
  return regeneratorRuntime.wrap(function signUp$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contractingSignUp.toJS();
          });

        case 2:
          signup = _context11.sent;
          return _context11.delegateYield((0, _sagas.apiSaga)(cnt.SIGN_UP, _api.account.shellSignUp, [signup]), 't0', 4);

        case 4:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function autoLogin() {
  var _ref14, hashToken, _ref15, userId, email, companyType;

  return regeneratorRuntime.wrap(function autoLogin$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 2:
          _ref14 = _context12.sent;
          hashToken = _ref14.hashToken;
          _context12.next = 6;
          return (0, _effects.select)(function (state) {
            return _ramda2.default.path(['assetsLandingReducer', 'dialog', 'newUserInfo'], state);
          });

        case 6:
          _ref15 = _context12.sent;
          userId = _ref15.userId;
          email = _ref15.email;
          companyType = _ref15.companyType;
          return _context12.delegateYield((0, _sagas.apiSaga)(cnt.AUTO_LOGIN, _api.account.loginAsUser, [{ userId: userId, email: email, companyType: companyType, hashToken: hashToken }]), 't0', 11);

        case 11:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function scheduleDemo() {
  var _ref16, email, viewAs, userId;

  return regeneratorRuntime.wrap(function scheduleDemo$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          window.open('https://app.hubspot.com/meetings/andrew157');
          _context13.next = 3;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 3:
          _ref16 = _context13.sent;
          email = _ref16.email;
          viewAs = _ref16.viewAs;
          userId = _ref16.userId;
          _context13.next = 9;
          return (0, _effects.put)({
            type: 'TRACK_EVENT',
            payload: {
              ga: {
                eventCategory: 'assetLanding',
                eventAction: 'scheduleDemo - ' + viewAs,
                eventLabel: email + '-' + userId
              }
            }
          });

        case 9:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function requestEzLoad(_ref17) {
  var afterSignUp = _ref17.afterSignUp;

  var _ref18, _ref18$dialog, files, allRequests, newUserInfo, companyId, thisEmail, supplierId, email, requests;

  return regeneratorRuntime.wrap(function requestEzLoad$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 2:
          _ref18 = _context14.sent;
          _ref18$dialog = _ref18.dialog;
          files = _ref18$dialog.files;
          allRequests = _ref18$dialog.allRequests;
          newUserInfo = _ref18$dialog.newUserInfo;
          companyId = _ref18.companyId;
          thisEmail = _ref18.email;
          supplierId = afterSignUp ? newUserInfo.companyId : companyId;
          email = afterSignUp ? newUserInfo.email : thisEmail;
          requests = allRequests.filter(function (obj) {
            return obj.checked;
          });
          return _context14.delegateYield((0, _sagas.apiSaga)(cnt.REQUEST_EZ_LOAD, _api.assetLanding.ezLoadRequest, [{ supplierId: supplierId, files: files, requests: requests, email: email }]), 't0', 13);

        case 13:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function handleAfterSignup() {
  var _ref19, dialogType, newUserInfo;

  return regeneratorRuntime.wrap(function handleAfterSignup$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer.dialog;
          });

        case 2:
          _ref19 = _context15.sent;
          dialogType = _ref19.type;
          newUserInfo = _ref19.newUserInfo;

          if (!(dialogType === 'dl-wizard')) {
            _context15.next = 9;
            break;
          }

          return _context15.delegateYield(requestEzLoad({ afterSignUp: true }), 't0', 7);

        case 7:
          _context15.next = 10;
          break;

        case 9:
          if (newUserInfo.email.indexOf('dl+') > -1) {
            window.location = window.location.protocol + '//' + window.location.host + '/admin/company-details/' + newUserInfo.companyId;
          }

        case 10:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}

function sendExternalRates(_ref20) {
  var type = _ref20.type,
      payload = _ref20.payload;

  var subject, message, _ref21, _ref21$dialog, files, allRequests, fromEmail, userId, companyId, requests;

  return regeneratorRuntime.wrap(function sendExternalRates$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          subject = payload.subject, message = payload.message;
          _context16.next = 3;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 3:
          _ref21 = _context16.sent;
          _ref21$dialog = _ref21.dialog;
          files = _ref21$dialog.files;
          allRequests = _ref21$dialog.allRequests;
          fromEmail = _ref21.email;
          userId = _ref21.userId;
          companyId = _ref21.companyId;
          requests = allRequests.filter(function (obj) {
            return obj.checked;
          });
          return _context16.delegateYield((0, _sagas.apiSaga)(type, _api.assetLanding.sendExternalRates, [{ subject: subject, message: message, files: files, requests: requests, fromEmail: fromEmail, userId: userId, supplierId: companyId }]), 't0', 12);

        case 12:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked16, this);
}

function downloadAll(what) {
  var _ref22, rates;

  return regeneratorRuntime.wrap(function downloadAll$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 2:
          _ref22 = _context17.sent;
          rates = _ref22.rates;
          _context17.next = 6;
          return (0, _effects.put)({
            type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
            payload: {
              contractIds: rates.filter(function (obj) {
                if (what === 'all') return true;
                if (what === 'current') return obj.endDate >= new Date().toISOString();
                return obj.endDate < new Date().toISOString();
              }).map(function (obj) {
                return obj._id;
              }),
              collection: 'contract',
              isBulk: true,
              forAL: true
            }
          });

        case 6:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked17, this);
}
function sendExternalRatesForOneRequest(_ref23) {
  var payload = _ref23.payload;

  var _ref24, fromEmail, userId;

  return regeneratorRuntime.wrap(function sendExternalRatesForOneRequest$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 2:
          _ref24 = _context18.sent;
          fromEmail = _ref24.email;
          userId = _ref24.userId;
          return _context18.delegateYield((0, _sagas.apiSaga)(cnt.SEND_RATES_FOR_ONE_REQUEST, _api.assetLanding.sendExternalRates, [_extends({}, payload, {
            fromEmail: fromEmail,
            userId: userId
          })]), 't0', 6);

        case 6:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked18, this);
}

function routeAfterCheckForDummy(_ref25) {
  var payload = _ref25.payload;
  return regeneratorRuntime.wrap(function routeAfterCheckForDummy$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          window.location = payload.url;

        case 1:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked19, this);
}

function handleAutoLoginError(_ref26) {
  var payload = _ref26.payload;
  return regeneratorRuntime.wrap(function handleAutoLoginError$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          window.alert(payload);
          window.location = window.location.protocol + '//' + window.location.host + '/' + (payload.indexOf('TC admin') > -1 ? 'admin-signin' : 'signin');

        case 2:
        case 'end':
          return _context20.stop();
      }
    }
  }, _marked20, this);
}

function doSignRateDocs(_ref27) {
  var type = _ref27.type,
      payload = _ref27.payload;
  return regeneratorRuntime.wrap(function doSignRateDocs$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return (0, _sagas.apiSaga)(type, _api.assetLanding.signRateDocs, [payload]);

        case 2:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked21, this);
}

function markDummyTemplateAsViewed(_ref28) {
  var type = _ref28.type,
      payload = _ref28.payload;
  return regeneratorRuntime.wrap(function markDummyTemplateAsViewed$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return (0, _sagas.apiSaga)(type, _api.assetLanding.markDummyTemplateAsViewed, [_extends({}, payload, {
            from: 'al-signing'
          })]);

        case 2:
        case 'end':
          return _context22.stop();
      }
    }
  }, _marked22, this);
}

exports.default = [(0, _effects.takeLatest)(cnt.DOWNLOAD_RATES_CONTRACT, downloadContractingDocs), (0, _effects.takeLatest)(cnt.INIT, init), (0, _effects.takeLatest)('VERIFY_TOKEN_SUCCESS', onVerifyTokenSuccess), (0, _effects.takeLatest)(cnt.CHANGE_CONTRACT_STATUS, updateContractStatus), (0, _effects.takeLatest)(cnt.LOG_IN, login), (0, _effects.takeLatest)(cnt.LOG_IN + '_SUCCESS', routeToAppAfterLogin), (0, _effects.takeLatest)(cnt.SIGN_UP, signUp), (0, _effects.takeLatest)(cnt.SIGN_UP + '_SUCCESS', handleAfterSignup), (0, _effects.takeLatest)(cnt.AUTO_LOGIN, autoLogin), (0, _effects.takeLatest)(cnt.AUTO_LOGIN + '_SUCCESS', routeToAppAfterLogin), (0, _effects.takeLatest)(cnt.AUTO_LOGIN + '_ERROR', handleAutoLoginError), (0, _effects.takeLatest)(cnt.OPEN_DIALOG, handleTracking), (0, _effects.takeLatest)(cnt.SCHEDULE_DEMO, scheduleDemo), (0, _effects.takeLatest)(cnt.REQUEST_EZ_LOAD, requestEzLoad), (0, _effects.takeLatest)(cnt.SEND_RATES, sendExternalRates), (0, _effects.takeLatest)(cnt.SEND_RATES_FOR_ONE_REQUEST, sendExternalRatesForOneRequest), (0, _effects.takeEvery)(cnt.GET_XLS + '_SUCCESS', openXls), (0, _effects.takeLatest)(cnt.DOWNLOAD_ALL_CURRENT, /*#__PURE__*/regeneratorRuntime.mark(function download() {
  return regeneratorRuntime.wrap(function download$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          _context23.next = 2;
          return downloadAll('current');

        case 2:
        case 'end':
          return _context23.stop();
      }
    }
  }, download, this);
})), (0, _effects.takeLatest)(cnt.DOWNLOAD_ALL, /*#__PURE__*/regeneratorRuntime.mark(function download() {
  return regeneratorRuntime.wrap(function download$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          _context24.next = 2;
          return downloadAll('all');

        case 2:
        case 'end':
          return _context24.stop();
      }
    }
  }, download, this);
})), (0, _effects.takeLatest)(cnt.DOWNLOAD_ALL_OUTDATED, /*#__PURE__*/regeneratorRuntime.mark(function download() {
  return regeneratorRuntime.wrap(function download$(_context25) {
    while (1) {
      switch (_context25.prev = _context25.next) {
        case 0:
          _context25.next = 2;
          return downloadAll('outdated');

        case 2:
        case 'end':
          return _context25.stop();
      }
    }
  }, download, this);
})), (0, _effects.takeLatest)('[asset-landing]CHECK_DUMMY_ACCOUNT_SUCCESS', routeAfterCheckForDummy), (0, _effects.takeLatest)('[asset-landing]SIGN_RATE_DOCS', doSignRateDocs), (0, _effects.takeLatest)('[asset-landing] RELOAD_CONTRACT_REQUEST', getRequest), (0, _effects.takeLatest)('[asset-landing] MARK_DUMMY_TEMPLATE_AS_VIEWED', markDummyTemplateAsViewed)];

/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _effects = __webpack_require__(36);

var _constants = __webpack_require__(630);

var cnt = _interopRequireWildcard(_constants);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

var _reactRouterRedux = __webpack_require__(27);

var _reduxSaga = __webpack_require__(92);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(init),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getAssociatedTemplates),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(deleteTemplate),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(renameTemplate),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(createSecondaryTemplate),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(routeToTemplate);

function init(_ref) {
  var _ref$payload = _ref.payload,
      pathname = _ref$payload.pathname,
      query = _ref$payload.query;
  return regeneratorRuntime.wrap(function init$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(pathname.indexOf('master-template-list') > -1)) {
            _context.next = 2;
            break;
          }

          return _context.delegateYield((0, _sagas.apiSaga)(cnt.GET_LIST, _api.masterTemplates.getAll, [query.type]), 't0', 2);

        case 2:
          if (!(pathname.indexOf('create-master-template') > -1)) {
            _context.next = 5;
            break;
          }

          _context.next = 5;
          return (0, _effects.put)({ type: cnt.INIT, payload: { templateType: query.type || 'policyNotes' } });

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function getAssociatedTemplates(_ref2) {
  var payload = _ref2.payload;

  var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, doc, id, type;

  return regeneratorRuntime.wrap(function getAssociatedTemplates$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context2.prev = 3;
          _iterator = payload[Symbol.iterator]();

        case 5:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context2.next = 12;
            break;
          }

          doc = _step.value;
          id = doc._id, type = doc.type;
          return _context2.delegateYield((0, _sagas.apiSaga)(cnt.GET_ASSOCIATED_TEMPLATES, _api.masterTemplates.getAssociatedTemplates, [{ id: id, type: type }]), 't0', 9);

        case 9:
          _iteratorNormalCompletion = true;
          _context2.next = 5;
          break;

        case 12:
          _context2.next = 18;
          break;

        case 14:
          _context2.prev = 14;
          _context2.t1 = _context2['catch'](3);
          _didIteratorError = true;
          _iteratorError = _context2.t1;

        case 18:
          _context2.prev = 18;
          _context2.prev = 19;

          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }

        case 21:
          _context2.prev = 21;

          if (!_didIteratorError) {
            _context2.next = 24;
            break;
          }

          throw _iteratorError;

        case 24:
          return _context2.finish(21);

        case 25:
          return _context2.finish(18);

        case 26:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[3, 14, 18, 26], [19,, 21, 25]]);
}

function deleteTemplate(_ref3) {
  var type = _ref3.type,
      payload = _ref3.payload;
  return regeneratorRuntime.wrap(function deleteTemplate$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.delegateYield((0, _sagas.apiSaga)(type, _api.masterTemplates.deleteTemplate, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function renameTemplate(_ref4) {
  var type = _ref4.type,
      payload = _ref4.payload;
  return regeneratorRuntime.wrap(function renameTemplate$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.delegateYield((0, _sagas.apiSaga)(type, _api.masterTemplates.renameTemplate, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function createSecondaryTemplate(_ref5) {
  var type = _ref5.type;

  var _ref6, templateType, templateName;

  return regeneratorRuntime.wrap(function createSecondaryTemplate$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.masterTemplate.createNew;
          });

        case 2:
          _ref6 = _context5.sent;
          templateType = _ref6.templateType;
          templateName = _ref6.templateName;
          return _context5.delegateYield((0, _sagas.apiSaga)(type, _api.masterTemplates.createInitial, [{ type: templateType, templateName: templateName }]), 't0', 6);

        case 6:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function routeToTemplate(_ref7) {
  var payload = _ref7.payload;
  return regeneratorRuntime.wrap(function routeToTemplate$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)((0, _reactRouterRedux.replace)('/contracting/master-template/draft:' + payload.newId));

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

exports.default = [(0, _effects.takeLatest)('@@router/LOCATION_CHANGE', init), (0, _effects.takeLatest)(cnt.GET_LIST + '_SUCCESS', getAssociatedTemplates), (0, _effects.takeLatest)(cnt.DELETE_TEMPLATE, deleteTemplate), (0, _effects.takeLatest)(cnt.RENAME_TEMPLATE, renameTemplate), (0, _effects.takeLatest)(cnt.CREATE, createSecondaryTemplate), (0, _effects.takeLatest)(cnt.CREATE + '_SUCCESS', routeToTemplate)];

/***/ }),

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _effects = __webpack_require__(36);

var _constants = __webpack_require__(579);

var cnt = _interopRequireWildcard(_constants);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

var _reactRouterRedux = __webpack_require__(27);

var _composeDraftEditDataByType = __webpack_require__(608);

var _editContractDetails = __webpack_require__(866);

var _editContractDetails2 = _interopRequireDefault(_editContractDetails);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getDocData),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getMasters),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(loadDoc),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(getTemplateDrafts),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(init),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(loadDiff),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(doCreateEditedDraft),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(routeToDraft),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(populateEditDialog),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(getAssociatedTemplates),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(saveEdits),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(discardDraft),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(routeToTemplate),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(finalise),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(handleClickFinalise),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(getAffectedBuyers),
    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(handleFinaliseSuccess),
    _marked18 = /*#__PURE__*/regeneratorRuntime.mark(applyToTemplates),
    _marked19 = /*#__PURE__*/regeneratorRuntime.mark(handleApplySuccess);

function getDocData() {
  var _ref, docs, currentId;

  return regeneratorRuntime.wrap(function getDocData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(function (_ref2) {
            var contracting = _ref2.contracting;
            return contracting.masterTemplate;
          });

        case 2:
          _ref = _context.sent;
          docs = _ref.docs;
          currentId = docs.currentId;
          return _context.abrupt('return', {
            currentId: currentId,
            docData: docs[currentId]
          });

        case 6:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function getMasters() {
  var _ref3, policyType;

  return regeneratorRuntime.wrap(function getMasters$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.masterTemplate.applyMasterToTemplatesReducer;
          });

        case 2:
          _ref3 = _context2.sent;
          policyType = _ref3.type;
          return _context2.delegateYield((0, _sagas.apiSaga)(cnt.apply.GET_MASTERS, _api.masterTemplates.getAll, [policyType]), 't0', 5);

        case 5:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function loadDoc() {
  var _ref4, pathname, _pathname$split$slice, _pathname$split$slice2, id;

  return regeneratorRuntime.wrap(function loadDoc$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.select)(function (state) {
            return state.route;
          });

        case 2:
          _ref4 = _context3.sent;
          pathname = _ref4.currentRoute;
          _pathname$split$slice = pathname.split('/').slice(3, 4), _pathname$split$slice2 = _slicedToArray(_pathname$split$slice, 1), id = _pathname$split$slice2[0];

          if (!id) {
            _context3.next = 7;
            break;
          }

          return _context3.delegateYield((0, _sagas.apiSaga)(cnt.GET_DOC, _api.masterTemplates.getOne, [id]), 't0', 7);

        case 7:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function getTemplateDrafts() {
  return regeneratorRuntime.wrap(function getTemplateDrafts$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.delegateYield((0, _sagas.apiSaga)(cnt.apply.GET_TEMPLATES, _api.contracting.getTemplateList, []), 't0', 1);

        case 1:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function init(_ref5) {
  var _ref5$payload = _ref5.payload,
      pathname = _ref5$payload.pathname,
      query = _ref5$payload.query;

  var _pathname$split$slice3, _pathname$split$slice4, masterId, _pathname$split$slice5, _pathname$split$slice6, templateDraftId;

  return regeneratorRuntime.wrap(function init$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          if (!(pathname.indexOf('/master-template/') > -1)) {
            _context5.next = 3;
            break;
          }

          _context5.next = 3;
          return loadDoc();

        case 3:
          if (!(pathname.indexOf('/associate') > -1)) {
            _context5.next = 9;
            break;
          }

          _pathname$split$slice3 = pathname.split('/').slice(3, 4), _pathname$split$slice4 = _slicedToArray(_pathname$split$slice3, 1), masterId = _pathname$split$slice4[0];
          _context5.next = 7;
          return getTemplateDrafts();

        case 7:
          _context5.next = 9;
          return (0, _effects.put)({
            type: cnt.apply.INIT,
            payload: {
              type: query.type,
              knownMasterId: masterId
            }
          });

        case 9:
          if (!(pathname.indexOf('pick-master-template') > -1)) {
            _context5.next = 15;
            break;
          }

          _pathname$split$slice5 = pathname.split('/').slice(3, 4), _pathname$split$slice6 = _slicedToArray(_pathname$split$slice5, 1), templateDraftId = _pathname$split$slice6[0];
          _context5.next = 13;
          return (0, _effects.put)({
            type: cnt.apply.INIT,
            payload: {
              type: query.type,
              knownTemplateDraftId: templateDraftId
            }
          });

        case 13:
          _context5.next = 15;
          return getMasters();

        case 15:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function loadDiff(_ref6) {
  var payload = _ref6.payload;
  return regeneratorRuntime.wrap(function loadDiff$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          if (!(payload.data.status === 'draft' && payload.data.originFrom === 'edited')) {
            _context6.next = 2;
            break;
          }

          return _context6.delegateYield((0, _sagas.apiSaga)(cnt.GET_DIFF_SUMMARY, _api.masterTemplates.getDiff, [{
            lhsDocId: payload.data.draftId,
            rhsDocId: 'draft:' + payload.data.draftId,
            onlyGetSummary: true
          }]), 't0', 2);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function doCreateEditedDraft(_ref7) {
  var type = _ref7.type;

  var _ref8, currentId;

  return regeneratorRuntime.wrap(function doCreateEditedDraft$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.select)(function (_ref9) {
            var contracting = _ref9.contracting;
            return contracting.masterTemplate.docs;
          });

        case 2:
          _ref8 = _context7.sent;
          currentId = _ref8.currentId;
          return _context7.delegateYield((0, _sagas.apiSaga)(type, _api.masterTemplates.createEditedDraft, [currentId]), 't0', 5);

        case 5:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function routeToDraft(_ref10) {
  var args = _ref10.args;
  return regeneratorRuntime.wrap(function routeToDraft$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.put)((0, _reactRouterRedux.replace)('/contracting/master-template/draft:' + args[0]));

        case 2:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function populateEditDialog() {
  var _ref11, docs, editDialog, currentId, composedData;

  return regeneratorRuntime.wrap(function populateEditDialog$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.select)(function (_ref12) {
            var contracting = _ref12.contracting;
            return contracting.masterTemplate;
          });

        case 2:
          _ref11 = _context9.sent;
          docs = _ref11.docs;
          editDialog = _ref11.editDialog;
          currentId = docs.currentId;
          composedData = (0, _composeDraftEditDataByType.composeForPolicyNotes)(editDialog, docs[currentId]);
          _context9.next = 9;
          return (0, _effects.put)({ type: cnt.POPULATE_EDIT_DIALOG_DATA, payload: composedData });

        case 9:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function getAssociatedTemplates() {
  var _ref13, docData, currentId, id;

  return regeneratorRuntime.wrap(function getAssociatedTemplates$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return getDocData();

        case 2:
          _ref13 = _context10.sent;
          docData = _ref13.docData;
          currentId = _ref13.currentId;
          id = docData.status === 'draft' ? currentId.split(':')[1] : currentId;
          return _context10.delegateYield((0, _sagas.apiSaga)(cnt.GET_ASSOCIATED_TEMPLATES, _api.masterTemplates.getAssociatedTemplates, [{ id: id, type: docData.type }]), 't0', 7);

        case 7:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function saveEdits(_ref14) {
  var type = _ref14.type,
      payload = _ref14.payload;

  var _ref15, docs, editDialog, currentId, doc, composePayload, nuFiles, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, val, uploaded, processed, updates;

  return regeneratorRuntime.wrap(function saveEdits$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.select)(function (_ref16) {
            var contracting = _ref16.contracting;
            return contracting.masterTemplate;
          });

        case 2:
          _ref15 = _context11.sent;
          docs = _ref15.docs;
          editDialog = _ref15.editDialog;
          currentId = docs.currentId;
          doc = docs[currentId];
          composePayload = { data: editDialog.data, updateType: payload.updateType };

          if (!(payload.updateType === 'SAVE_BILLING_INFO_ADD_EDIT' && editDialog.data.insuranceFiles.length)) {
            _context11.next = 39;
            break;
          }

          nuFiles = [];
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context11.prev = 13;
          _iterator = editDialog.data.insuranceFiles[Symbol.iterator]();

        case 15:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context11.next = 24;
            break;
          }

          val = _step.value;
          _context11.next = 19;
          return (0, _sagas.checkUpload)(val, type);

        case 19:
          uploaded = _context11.sent;

          nuFiles.push(uploaded);

        case 21:
          _iteratorNormalCompletion = true;
          _context11.next = 15;
          break;

        case 24:
          _context11.next = 30;
          break;

        case 26:
          _context11.prev = 26;
          _context11.t0 = _context11['catch'](13);
          _didIteratorError = true;
          _iteratorError = _context11.t0;

        case 30:
          _context11.prev = 30;
          _context11.prev = 31;

          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }

        case 33:
          _context11.prev = 33;

          if (!_didIteratorError) {
            _context11.next = 36;
            break;
          }

          throw _iteratorError;

        case 36:
          return _context11.finish(33);

        case 37:
          return _context11.finish(30);

        case 38:
          composePayload.data.insuranceFiles = nuFiles;

        case 39:
          processed = (0, _editContractDetails2.default)(doc, composePayload).contractDetails.toJS();
          updates = _ramda2.default.keys(processed).reduce(function (result, key) {
            return _extends({}, result, _defineProperty({}, doc.type + '.' + key, processed[key]));
          }, {});
          return _context11.delegateYield((0, _sagas.apiSaga)(type, _api.masterTemplates.edit, [currentId.split(':')[1], updates]), 't1', 42);

        case 42:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this, [[13, 26, 30, 38], [31,, 33, 37]]);
}

function discardDraft(_ref17) {
  var type = _ref17.type;

  var confirm, _ref18, currentId;

  return regeneratorRuntime.wrap(function discardDraft$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          confirm = window.confirm('Are you sure you want to discard this draft?');

          if (!confirm) {
            _context12.next = 7;
            break;
          }

          _context12.next = 4;
          return (0, _effects.select)(function (_ref19) {
            var contracting = _ref19.contracting;
            return contracting.masterTemplate;
          });

        case 4:
          _ref18 = _context12.sent;
          currentId = _ref18.docs.currentId;
          return _context12.delegateYield((0, _sagas.apiSaga)(type, _api.masterTemplates.discardDraft, [currentId.split(':')[1]]), 't0', 7);

        case 7:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function routeToTemplate(id) {
  return regeneratorRuntime.wrap(function routeToTemplate$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.put)((0, _reactRouterRedux.replace)('/contracting/master-template/' + id));

        case 2:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function finalise() {
  var _ref20, docData;

  return regeneratorRuntime.wrap(function finalise$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return getDocData();

        case 2:
          _ref20 = _context14.sent;
          docData = _ref20.docData;
          return _context14.delegateYield((0, _sagas.apiSaga)(cnt.FINALISE, _api.masterTemplates.finalise, [docData.draftId]), 't0', 5);

        case 5:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function handleClickFinalise() {
  var _ref21, docData, templates;

  return regeneratorRuntime.wrap(function handleClickFinalise$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return getDocData();

        case 2:
          _ref21 = _context15.sent;
          docData = _ref21.docData;
          templates = docData.templates;

          if (!(templates && templates.length)) {
            _context15.next = 10;
            break;
          }

          _context15.next = 8;
          return (0, _effects.put)({ type: cnt.OPEN_FINALISE_DIALOG });

        case 8:
          _context15.next = 12;
          break;

        case 10:
          _context15.next = 12;
          return finalise();

        case 12:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}

function getAffectedBuyers() {
  var _ref22, docData, draftId;

  return regeneratorRuntime.wrap(function getAffectedBuyers$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return getDocData();

        case 2:
          _ref22 = _context16.sent;
          docData = _ref22.docData;
          draftId = docData.draftId;
          return _context16.delegateYield((0, _sagas.apiSaga)(cnt.GET_AFFECTED_BUYERS, _api.masterTemplates.getAffectedBuyers, [draftId]), 't0', 6);

        case 6:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked16, this);
}

/*
 payload = {
  newId,
  oldId: draftId,
  templateName,
  type,
  nStagedTemplates,
  buyers,
};
*/
function handleFinaliseSuccess(_ref23) {
  var payload = _ref23.payload;
  return regeneratorRuntime.wrap(function handleFinaliseSuccess$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return routeToTemplate(payload.newId);

        case 2:
          if (!payload.nStagedTemplates) {
            _context17.next = 4;
            break;
          }

          return _context17.delegateYield((0, _sagas.apiSaga)(cnt.SEND_UPDATES, _api.contracting.supplierSendUpdates, [{}]), 't0', 4);

        case 4:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked17, this);
}

function applyToTemplates(_ref24) {
  var type = _ref24.type;

  var _ref25, _ref25$applyMasterToT, allTemplatesDrafts, sameAsCorporatePolicyNotes, knownMasterId, knownTemplateDraftId, masterType, masterList, honorPreloadContent;

  return regeneratorRuntime.wrap(function applyToTemplates$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.select)(function (_ref26) {
            var contracting = _ref26.contracting;
            return contracting.masterTemplate;
          });

        case 2:
          _ref25 = _context18.sent;
          _ref25$applyMasterToT = _ref25.applyMasterToTemplatesReducer;
          allTemplatesDrafts = _ref25$applyMasterToT.allTemplatesDrafts;
          sameAsCorporatePolicyNotes = _ref25$applyMasterToT.sameAsCorporatePolicyNotes;
          knownMasterId = _ref25$applyMasterToT.knownMasterId;
          knownTemplateDraftId = _ref25$applyMasterToT.knownTemplateDraftId;
          masterType = _ref25$applyMasterToT.type;
          masterList = _ref25$applyMasterToT.masterList;
          honorPreloadContent = _ref25$applyMasterToT.honorPreloadContent;
          return _context18.delegateYield((0, _sagas.apiSaga)(type, _api.masterTemplates.applyMasterToTemplates, [{
            masterTemplateId: knownMasterId || masterList.find(function (obj) {
              return obj.checked;
            })._id,
            type: masterType,
            templateDraftIds: knownTemplateDraftId ? [knownTemplateDraftId] : allTemplatesDrafts.filter(function (obj) {
              return obj.checked;
            }).map(function (obj) {
              return obj.originalContractId || obj._id;
            }),
            sameAsCorporatePolicyNotes: sameAsCorporatePolicyNotes,
            honorPreloadContent: honorPreloadContent
          }]), 't0', 12);

        case 12:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked18, this);
}

function handleApplySuccess() {
  var _ref27, knownTemplateDraftId;

  return regeneratorRuntime.wrap(function handleApplySuccess$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _effects.select)(function (_ref28) {
            var contracting = _ref28.contracting;
            return contracting.masterTemplate.applyMasterToTemplatesReducer;
          });

        case 2:
          _ref27 = _context19.sent;
          knownTemplateDraftId = _ref27.knownTemplateDraftId;

          if (!knownTemplateDraftId) {
            _context19.next = 11;
            break;
          }

          _context19.next = 7;
          return (0, _effects.put)((0, _reactRouterRedux.replace)('/contracting/draft/' + knownTemplateDraftId + '/policies'));

        case 7:
          _context19.next = 9;
          return (0, _effects.put)({ type: cnt.apply.CLEAR_STORE });

        case 9:
          _context19.next = 15;
          break;

        case 11:
          _context19.next = 13;
          return getTemplateDrafts();

        case 13:
          _context19.next = 15;
          return getAssociatedTemplates();

        case 15:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked19, this);
}
exports.default = [(0, _effects.takeLatest)('@@router/LOCATION_CHANGE', init), (0, _effects.takeLatest)(cnt.GET_DOC + '_SUCCESS', loadDiff), (0, _effects.takeLatest)(cnt.GET_DOC + '_SUCCESS', getAssociatedTemplates), (0, _effects.takeLatest)(cnt.CREATE_EDITED_DRAFT, doCreateEditedDraft), (0, _effects.takeLatest)(cnt.CREATE_EDITED_DRAFT + '_SUCCESS', routeToDraft), (0, _effects.takeLatest)(cnt.INITIATE_EDIT_WITH_TYPE, populateEditDialog), (0, _effects.takeLatest)(cnt.SAVE_EDITS, saveEdits), (0, _effects.takeLatest)(cnt.SAVE_EDITS + '_SUCCESS', loadDoc), (0, _effects.takeLatest)(cnt.DISCARD_DRAFT, discardDraft), (0, _effects.takeLatest)(cnt.DISCARD_DRAFT + '_SUCCESS', /*#__PURE__*/regeneratorRuntime.mark(function fn(_ref29) {
  var args = _ref29.args;
  return regeneratorRuntime.wrap(function fn$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return routeToTemplate(args[0]);

        case 2:
        case 'end':
          return _context20.stop();
      }
    }
  }, fn, this);
})), (0, _effects.takeLatest)(cnt.CLICK_FINALISE, handleClickFinalise), (0, _effects.takeLatest)(cnt.FINALISE + '_SUCCESS', handleFinaliseSuccess), (0, _effects.takeLatest)(cnt.OPEN_FINALISE_DIALOG, getAffectedBuyers), (0, _effects.takeLatest)(cnt.FINALISE, finalise), (0, _effects.takeLatest)(cnt.apply.GET_TEMPLATES, getTemplateDrafts), (0, _effects.takeLatest)(cnt.apply.GET_MASTERS, getMasters), (0, _effects.takeLatest)(cnt.apply.APPLY_TO_TEMPLATES, applyToTemplates), (0, _effects.takeLatest)(cnt.apply.APPLY_TO_TEMPLATES + '_SUCCESS', handleApplySuccess)];

/***/ }),

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.workspaceSagas = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = __webpack_require__(36);

var _api = __webpack_require__(37);

var _actions = __webpack_require__(476);

var _reactRouterRedux = __webpack_require__(27);

var _messagingActions = __webpack_require__(562);

var _constants = __webpack_require__(233);

var wkspConst = _interopRequireWildcard(_constants);

var _messagingConstants = __webpack_require__(506);

var inboxConst = _interopRequireWildcard(_messagingConstants);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _sagas = __webpack_require__(43);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchConnections),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(deleteMessage),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(addFilesToContract),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(fetchChannels),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(fetchContractConversations),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(fetchConversations),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(saveSelectedChannel),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(archiveConnection),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(archiveConversation),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(loadLastSelectedChannel),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(createMessage),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(markConversationRead),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(refreshStatusMessages),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(fetchChanges),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(contractConversationsRefresh),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(inboxCountLeft),
    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(markAcceptedRead);

var getRoute = function getRoute(state) {
  return state.routing.locationBeforeTransitions.pathname;
};
var getConnection = function getConnection(state) {
  return state.workspace.selectedConnection;
};
var getChannel = function getChannel(state) {
  return state.workspace.selectedChannel;
};
var getContract = function getContract(state) {
  return state.workspace.selectedContract;
};
var getChannels = function getChannels(state) {
  return state.workspace.channels;
};
var getConversations = function getConversations(state) {
  return state.workspace.conversations;
};
var routePath = '/workspace';

function fetchConnections() {
  var selectedConnection;
  return regeneratorRuntime.wrap(function fetchConnections$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(getConnection);

        case 2:
          selectedConnection = _context.sent;
          return _context.delegateYield((0, _sagas.apiSaga)(wkspConst.CONNECTIONS_FETCH, _api.workspace.getConnections, [selectedConnection]), 't0', 4);

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}
function deleteMessage(_ref) {
  var payload = _ref.payload,
      type = _ref.type;
  return regeneratorRuntime.wrap(function deleteMessage$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)({ type: wkspConst.MESSAGE_DISABLE, payload: payload });

        case 2:
          return _context2.delegateYield((0, _sagas.apiSaga)(type, _api.workspace.deleteMessage, [payload]), 't0', 3);

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function addFilesToContract(_ref2) {
  var payload = _ref2.payload;
  var contractId, files;
  return regeneratorRuntime.wrap(function addFilesToContract$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.select)(getContract);

        case 2:
          contractId = _context3.sent;
          _context3.next = 5;
          return (0, _effects.select)(getConversations);

        case 5:
          _context3.t0 = function (e) {
            return e.key === payload;
          };

          files = _context3.sent.filter(_context3.t0)[0].attachments;
          _context3.next = 9;
          return (0, _effects.put)({ type: wkspConst.MESSAGE_DISABLE, payload: payload });

        case 9:
          return _context3.delegateYield((0, _sagas.apiSaga)(wkspConst.MESSAGE_ADD_FILES_TO_CONTRACT, _api.contracting.addFilesToContract, [{ contractId: contractId, files: files, msgId: payload }]), 't1', 10);

        case 10:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function fetchChannels() {
  var connection, channel, contract;
  return regeneratorRuntime.wrap(function fetchChannels$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(getConnection);

        case 2:
          connection = _context4.sent;
          _context4.next = 5;
          return (0, _effects.select)(getChannel);

        case 5:
          channel = _context4.sent;
          _context4.next = 8;
          return (0, _effects.select)(getContract);

        case 8:
          contract = _context4.sent;

          if (!connection) {
            _context4.next = 11;
            break;
          }

          return _context4.delegateYield((0, _sagas.apiSaga)(wkspConst.CHANNELS_FETCH, _api.workspace.getChannels, [connection, channel, contract]), 't0', 11);

        case 11:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function fetchContractConversations() {
  var route, getContractFromContracting, _selectedContract, connection, selectedContract;

  return regeneratorRuntime.wrap(function fetchContractConversations$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(getRoute);

        case 2:
          route = _context5.sent;

          if (!(route.substring(0, routePath.length) !== routePath)) {
            _context5.next = 12;
            break;
          }

          // component is in contacting area
          getContractFromContracting = function getContractFromContracting(state) {
            return state.contracting.contractActivitiesProducts.getIn(['leftNav', 'contractId']);
          };

          _context5.next = 7;
          return (0, _effects.select)(getContractFromContracting);

        case 7:
          _selectedContract = _context5.sent;
          _context5.next = 10;
          return (0, _effects.put)({ type: 'LOADING_HISTORY_FEEDS' });

        case 10:
          return _context5.delegateYield((0, _sagas.apiSaga)('LOADING_HISTORY_FEEDS', _api.historyFeed.getHistory, [_selectedContract]), 't0', 11);

        case 11:
          return _context5.abrupt('return');

        case 12:
          _context5.next = 14;
          return (0, _effects.select)(getConnection);

        case 14:
          connection = _context5.sent;
          _context5.next = 17;
          return (0, _effects.select)(getContract);

        case 17:
          selectedContract = _context5.sent;
          return _context5.delegateYield((0, _sagas.apiSaga)(wkspConst.CONVERSATIONS_FETCH, _api.workspace.getConversations, [connection, selectedContract]), 't1', 19);

        case 19:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function fetchConversations() {
  var connection, channel, contract;
  return regeneratorRuntime.wrap(function fetchConversations$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.select)(getConnection);

        case 2:
          connection = _context6.sent;
          _context6.next = 5;
          return (0, _effects.select)(getChannel);

        case 5:
          channel = _context6.sent;
          _context6.next = 8;
          return (0, _effects.select)(getContract);

        case 8:
          contract = _context6.sent;

          if (!(connection && channel)) {
            _context6.next = 15;
            break;
          }

          if (!(contract && channel === 'contracting')) {
            _context6.next = 14;
            break;
          }

          return _context6.delegateYield(fetchContractConversations(), 't0', 12);

        case 12:
          _context6.next = 15;
          break;

        case 14:
          return _context6.delegateYield((0, _sagas.apiSaga)(wkspConst.CONVERSATIONS_FETCH, _api.workspace.getConversations, [connection, channel]), 't1', 15);

        case 15:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function saveSelectedChannel() {
  var selectedConnection, selectedChannel;
  return regeneratorRuntime.wrap(function saveSelectedChannel$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.select)(getConnection);

        case 2:
          selectedConnection = _context7.sent;
          _context7.next = 5;
          return (0, _effects.select)(getChannel);

        case 5:
          selectedChannel = _context7.sent;

          if (!(selectedConnection && selectedChannel)) {
            _context7.next = 8;
            break;
          }

          return _context7.delegateYield((0, _sagas.apiSaga)(wkspConst.CHANNELS_SELECT_SAVE, _api.workspace.saveSelectedChannel, [selectedConnection, selectedChannel]), 't0', 8);

        case 8:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function archiveConnection(action) {
  var selectedConnection;
  return regeneratorRuntime.wrap(function archiveConnection$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.select)(getConnection);

        case 2:
          selectedConnection = _context8.sent;

          if (!(selectedConnection === action.payload)) {
            _context8.next = 6;
            break;
          }

          _context8.next = 6;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/workspace'));

        case 6:
          return _context8.delegateYield((0, _sagas.apiSaga)(wkspConst.CONNECTIONS_ARCHIVE, _api.workspace.archiveConnection, [action.payload]), 't0', 7);

        case 7:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function archiveConversation(action) {
  var connection, channel, contract;
  return regeneratorRuntime.wrap(function archiveConversation$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.select)(getConnection);

        case 2:
          connection = _context9.sent;
          _context9.next = 5;
          return (0, _effects.select)(getChannel);

        case 5:
          channel = _context9.sent;
          _context9.next = 8;
          return (0, _effects.select)(getContract);

        case 8:
          contract = _context9.sent;

          if (!(channel === action.payload.channel && contract === action.payload.contract)) {
            _context9.next = 17;
            break;
          }

          if (!connection) {
            _context9.next = 15;
            break;
          }

          _context9.next = 13;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/workspace/' + connection + '/contracting'));

        case 13:
          _context9.next = 17;
          break;

        case 15:
          _context9.next = 17;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/workspace/' + connection + '/general'));

        case 17:
          return _context9.delegateYield((0, _sagas.apiSaga)(wkspConst.CHANNELS_ARCHIVE, _api.workspace.archiveConversation, [connection, action.payload.channel, action.payload.contract]), 't0', 18);

        case 18:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function loadLastSelectedChannel() {
  var getSelectedConnection, selectedConnection, getConnections, selectedConnectionData, getSelectedChannel, selectedChannel;
  return regeneratorRuntime.wrap(function loadLastSelectedChannel$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          // open the last selected channel, server side
          getSelectedConnection = function getSelectedConnection(state) {
            return state.workspace.selectedConnection;
          };

          _context10.next = 3;
          return (0, _effects.select)(getSelectedConnection);

        case 3:
          selectedConnection = _context10.sent;

          getConnections = function getConnections(state) {
            return state.workspace.connections;
          };

          _context10.next = 7;
          return (0, _effects.select)(getConnections);

        case 7:
          _context10.t0 = function (e) {
            return e.id === selectedConnection;
          };

          selectedConnectionData = _context10.sent.filter(_context10.t0)[0];

          getSelectedChannel = function getSelectedChannel(state) {
            return state.workspace.selectedChannel;
          };

          _context10.next = 12;
          return (0, _effects.select)(getSelectedChannel);

        case 12:
          selectedChannel = _context10.sent;

          if (!(!selectedChannel && selectedConnectionData && selectedConnectionData.lastChannel)) {
            _context10.next = 21;
            break;
          }

          if (!selectedConnectionData.lastContract) {
            _context10.next = 19;
            break;
          }

          _context10.next = 17;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/workspace/' + selectedConnection + '/' + selectedConnectionData.lastChannel + '/' + selectedConnectionData.lastContract));

        case 17:
          _context10.next = 21;
          break;

        case 19:
          _context10.next = 21;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/workspace/' + selectedConnection + '/' + selectedConnectionData.lastChannel));

        case 21:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function createMessage(action) {
  var selectedConnection, selectedChannel, convos;
  return regeneratorRuntime.wrap(function createMessage$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.select)(getConnection);

        case 2:
          selectedConnection = _context11.sent;
          _context11.next = 5;
          return (0, _effects.select)(getChannel);

        case 5:
          selectedChannel = _context11.sent;
          _context11.next = 8;
          return (0, _effects.select)(getConversations);

        case 8:
          convos = _context11.sent;
          return _context11.delegateYield((0, _sagas.apiSaga)(wkspConst.MESSAGE_CREATE, _api.workspace.newMessage, [_extends({
            type: selectedChannel === 'notes' ? 'note' : 'message',
            contractHFIds: selectedChannel && selectedChannel !== 'general' ? [selectedChannel] : [],
            partnerIds: selectedConnection ? [selectedConnection] : [],
            mostRecentIncomingMsg: _ramda2.default.call(_ramda2.default.compose(_ramda2.default.head, _ramda2.default.sortBy(_ramda2.default.descend(_ramda2.default.prop('timestamp'))), _ramda2.default.filter(function (obj) {
              return !obj.isSender;
            })), convos)
          }, action.payload)]), 't0', 10);

        case 10:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function markConversationRead(_ref3) {
  var payload = _ref3.payload;

  var assetType, assetId, messageId, route, getLeftNav, _ref4, historyFeedId, selectedConnection, selectedChannel;

  return regeneratorRuntime.wrap(function markConversationRead$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          if (!payload) {
            _context12.next = 4;
            break;
          }

          assetType = payload.assetType, assetId = payload.assetId, messageId = payload.messageId;
          return _context12.delegateYield((0, _sagas.apiSaga)(wkspConst.CONVERSATIONS_READ, _api.workspace.conversationsRead, [{
            assetType: assetType,
            assetId: assetId,
            messageId: messageId
          }]), 't0', 3);

        case 3:
          return _context12.abrupt('return');

        case 4:
          _context12.next = 6;
          return (0, _effects.select)(getRoute);

        case 6:
          route = _context12.sent;

          if (!(route.substring(0, routePath.length) !== routePath)) {
            _context12.next = 17;
            break;
          }

          // component is in contacting area
          getLeftNav = function getLeftNav(state) {
            return state.contracting.contractActivitiesProducts.get('leftNav').toJS();
          };

          _context12.next = 11;
          return (0, _effects.select)(getLeftNav);

        case 11:
          _ref4 = _context12.sent;
          historyFeedId = _ref4.historyFeedId;

          if (historyFeedId) {
            _context12.next = 15;
            break;
          }

          return _context12.abrupt('return');

        case 15:
          return _context12.delegateYield((0, _sagas.apiSaga)(wkspConst.CONVERSATIONS_READ, _api.workspace.conversationsRead, [{ assetId: historyFeedId, assetType: 'contract' }]), 't1', 16);

        case 16:
          return _context12.abrupt('return');

        case 17:
          _context12.next = 19;
          return (0, _effects.select)(getConnection);

        case 19:
          selectedConnection = _context12.sent;
          _context12.next = 22;
          return (0, _effects.select)(getChannel);

        case 22:
          selectedChannel = _context12.sent;

          if (selectedConnection && selectedChannel) {
            _context12.next = 25;
            break;
          }

          return _context12.abrupt('return');

        case 25:
          return _context12.delegateYield((0, _sagas.apiSaga)(wkspConst.CONVERSATIONS_READ, _api.workspace.conversationsRead, [{
            assetId: selectedConnection,
            assetType: 'partner'
            // Commented this because right now the frontend doesn't handle channels other than contracting
            // history feed "channel" which is taken care of by the "if (payload)" block above
            // triggered by markReadWithParams, which is called in comments.jsx
            // channelId: selectedChannel,
          }]), 't2', 26);

        case 26:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function refreshStatusMessages() {
  return regeneratorRuntime.wrap(function refreshStatusMessages$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          return _context13.delegateYield((0, _sagas.apiSaga)(wkspConst.STATUS_MESSAGES, _api.workspace.statusMessages, []), 't0', 1);

        case 1:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

// function* clearSelectedContract() {
//   yield put(selectContract(null));
// }
//
// function* clearSelectedChannel() {
//   yield put(selectChannel(null));
// }

// TODO: This function should be made global for frontend error handling
var logError = function logError(payload) {
  console.error(payload);
};

function fetchChanges(_ref5) {
  var payload = _ref5.payload;
  var channels;
  return regeneratorRuntime.wrap(function fetchChanges$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          if (!(payload.before.connection !== payload.connection)) {
            _context14.next = 7;
            break;
          }

          _context14.next = 3;
          return (0, _effects.put)((0, _actions.resetChannels)());

        case 3:
          _context14.next = 5;
          return (0, _effects.fork)(fetchChannels);

        case 5:
          _context14.next = 13;
          break;

        case 7:
          _context14.next = 9;
          return (0, _effects.select)(getChannels);

        case 9:
          channels = _context14.sent;

          if (!(channels.filter(function (e) {
            return e.channelId === payload.channel;
          }).length === 0)) {
            _context14.next = 13;
            break;
          }

          _context14.next = 13;
          return (0, _effects.fork)(fetchChannels);

        case 13:
          if (!(payload.before.connection !== payload.connection || payload.before.channel !== payload.channel)) {
            _context14.next = 20;
            break;
          }

          _context14.next = 16;
          return (0, _effects.put)((0, _actions.resetConversations)());

        case 16:
          _context14.next = 18;
          return (0, _effects.fork)(fetchConversations);

        case 18:
          _context14.next = 20;
          return (0, _effects.fork)(saveSelectedChannel);

        case 20:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function contractConversationsRefresh(action) {
  return regeneratorRuntime.wrap(function contractConversationsRefresh$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.put)({ type: 'GET_HISTORY_FEEDS', payload: { response: action.payload } });

        case 2:
          return _context15.delegateYield(markConversationRead({}), 't0', 3);

        case 3:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}

function inboxCountLeft(action) {
  var selectedChannel;
  return regeneratorRuntime.wrap(function inboxCountLeft$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.select)(getChannel);

        case 2:
          selectedChannel = _context16.sent;

          if (!(selectedChannel !== action.payload.messageId)) {
            _context16.next = 5;
            break;
          }

          return _context16.abrupt('return');

        case 5:
          _context16.next = 7;
          return (0, _effects.put)((0, _messagingActions.updateProps)('convs', { selectedConv: {}, messages: [] }));

        case 7:
          _context16.next = 9;
          return (0, _effects.put)({ type: inboxConst.MSGS_LOADED_INITIALLY, payload: {
              conv: {},
              messages: [],
              lastMsgId: '',
              messagesLoaded: true,
              loadingMessages: false
            } });

        case 9:
          _context16.next = 11;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/workspace/inbox'));

        case 11:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked16, this);
}

function markAcceptedRead(_ref6) {
  var payload = _ref6.payload;
  return regeneratorRuntime.wrap(function markAcceptedRead$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          return _context17.delegateYield((0, _sagas.apiSaga)(wkspConst.STATUS_CONNECTIONS_MARK_READ, _api.workspace.unreadAcceptedRead, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked17, this);
}

var workspaceSagas = exports.workspaceSagas = [(0, _effects.takeLatest)(wkspConst.CONNECTIONS_FETCH, fetchConnections), (0, _effects.takeLatest)(wkspConst.CHANNELS_FETCH, fetchChannels), (0, _effects.takeLatest)(wkspConst.CHANGE_SELECTION, fetchChanges), (0, _effects.takeLatest)(wkspConst.CONVERSATIONS_FETCH, fetchConversations), (0, _effects.takeLatest)(wkspConst.CONNECTIONS_ARCHIVE, archiveConnection), (0, _effects.takeLatest)(wkspConst.CONNECTIONS_ARCHIVE + '_SUCCESS', fetchConnections), (0, _effects.takeLatest)(wkspConst.CHANNELS_ARCHIVE, archiveConversation), (0, _effects.takeLatest)(wkspConst.CHANNELS_ARCHIVE + '_SUCCESS', fetchChannels), (0, _effects.takeLatest)(wkspConst.CHANNELS_FETCH + '_SUCCESS', loadLastSelectedChannel), (0, _effects.takeLatest)('' + wkspConst.CONVERSATIONS_READ, markConversationRead), (0, _effects.takeLatest)(wkspConst.CONVERSATIONS_READ_WITH_PARAMS, markConversationRead), (0, _effects.takeLatest)(wkspConst.MESSAGE_CREATE, createMessage), (0, _effects.takeLatest)(wkspConst.MESSAGE_CREATE + '_SUCCESS', fetchConversations), // refresh the conversation list
(0, _effects.takeLatest)(wkspConst.STATUS_MESSAGES, refreshStatusMessages), (0, _effects.takeEvery)(wkspConst.CONNECTIONS_FETCH + '_ERROR', logError), (0, _effects.takeEvery)(wkspConst.CONVERSATIONS_FETCH + '_ERROR', logError), (0, _effects.takeLatest)('SUBMIT_CONTRACTING_COMMENT_SUCCESS', fetchContractConversations), (0, _effects.takeLatest)('LOADING_HISTORY_FEEDS_SUCCESS', contractConversationsRefresh), (0, _effects.takeEvery)(wkspConst.MESSAGE_DELETE, deleteMessage), (0, _effects.takeLatest)(wkspConst.MESSAGE_DELETE + '_SUCCESS', fetchConversations), (0, _effects.takeLatest)(inboxConst.TOGGLE_CONV_DONESS_SUCCESS, inboxCountLeft), (0, _effects.takeEvery)(wkspConst.MESSAGE_ADD_FILES_TO_CONTRACT, addFilesToContract), (0, _effects.takeEvery)(wkspConst.MESSAGE_ADD_FILES_TO_CONTRACT + '_SUCCESS', fetchConversations), (0, _effects.takeEvery)(wkspConst.STATUS_CONNECTIONS_MARK_READ, markAcceptedRead)];

/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.massMessageSagas = undefined;

var _effects = __webpack_require__(36);

var _api = __webpack_require__(37);

var _sagas = __webpack_require__(43);

var _constants = __webpack_require__(654);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(createMessage),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getPartners),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(resendBulkMessage);

function createMessage(action) {
  return regeneratorRuntime.wrap(function createMessage$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.delegateYield((0, _sagas.apiSaga)(cnt.SENDMESSAGE, _api.massMessage.newMessage, [action.payload]), 't0', 1);

        case 1:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}
function getPartners() {
  return regeneratorRuntime.wrap(function getPartners$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.delegateYield((0, _sagas.apiSaga)(cnt.GETPARTNERS, _api.massMessage.getPartners, []), 't0', 1);

        case 1:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function resendBulkMessage(_ref) {
  var type = _ref.type,
      payload = _ref.payload;
  return regeneratorRuntime.wrap(function resendBulkMessage$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.delegateYield((0, _sagas.apiSaga)(type, _api.admin.resendBulkMessage, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

var massMessageSagas = exports.massMessageSagas = [(0, _effects.takeLatest)(cnt.SENDMESSAGE, createMessage), (0, _effects.takeLatest)(cnt.OPENMODAL, getPartners), (0, _effects.takeLatest)('ADMIN_RESEND_BULK_MESSAGE', resendBulkMessage)];

/***/ }),

/***/ 959:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
  Truncates a string to a number of characters, option to pass word consideration
  returns the truncate string + an ellipsis
*/
function truncate(n, useWordBoundary) {
  if (this.length <= n) {
    return this;
  }
  var subString = this.substr(0, n - 1);
  return (useWordBoundary && subString.indexOf(' ') > -1 ? subString.substr(0, subString.lastIndexOf(' ')) : subString) + '\u2026';
}

var truncateFn = function truncateFn(str, n, useWordBoundary) {
  if (str.length <= n) {
    return str;
  }
  var subString = str.substr(0, n - 1);
  return (useWordBoundary && subString.indexOf(' ') > -1 ? subString.substr(0, subString.lastIndexOf(' ')) : subString) + '\u2026';
};

var jsonParseFn = function jsonParseFn(str) {
  if ((typeof str === 'undefined' ? 'undefined' : _typeof(str)) === 'object') return str;
  var result = {};
  try {
    // if plain js
    result = JSON.parse(str);
  } catch (e) {
    // forget about it :)
  }
  return result;
};

module.exports = {
  truncate: truncate,
  truncateFn: truncateFn,
  jsonParseFn: jsonParseFn
};

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig s -> {s: a} -> a | Undefined
 * @param {String} p The property name
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 */
module.exports = _curry2(function prop(p, obj) { return obj[p]; });


/***/ }),

/***/ 960:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _effects = __webpack_require__(36);

var _reactRouterRedux = __webpack_require__(27);

var _api = __webpack_require__(37);

var _sagas = __webpack_require__(43);

var _constants = __webpack_require__(252);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(removeDraftOutOfQueue),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(addDraftToQueue),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(sendUpdatesFromQueue); /* global window */


function removeDraftOutOfQueue(_ref) {
  var type = _ref.type,
      payload = _ref.payload;
  return regeneratorRuntime.wrap(function removeDraftOutOfQueue$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.removeDraftOutOfQueue, [{
            templateId: payload.draftId,
            sourceId: payload.draftId,
            refreshSection: payload.refreshSection
          }]), 't0', 1);

        case 1:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function addDraftToQueue(_ref2) {
  var type = _ref2.type,
      payload = _ref2.payload;
  return regeneratorRuntime.wrap(function addDraftToQueue$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.addDraftToQueue, [{
            templateId: payload.draftId,
            sourceId: payload.draftId,
            source: 'draft',
            message: payload.message
          }]), 't0', 1);

        case 1:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function sendUpdatesFromQueue(_ref3) {
  var type = _ref3.type,
      payload = _ref3.payload;
  return regeneratorRuntime.wrap(function sendUpdatesFromQueue$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.supplierSendUpdates, [{ templateIds: payload.templateIds, subject: payload.subject }]), 't0', 1);

        case 1:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

exports.default = [(0, _effects.takeLatest)(cnt.REMOVE_DRAFT_FROM_QUEUE, removeDraftOutOfQueue), (0, _effects.takeLatest)(cnt.ADD_DRAFT_TO_QUEUE, addDraftToQueue), (0, _effects.takeLatest)(cnt.SEND_UPDATES_FROM_QUEUE, sendUpdatesFromQueue)];

/***/ }),

/***/ 961:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _effects = __webpack_require__(36);

var _constants = __webpack_require__(582);

var cnt = _interopRequireWildcard(_constants);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(init),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchHelp),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(trackOpen),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(closeHelp);

var getPath = function getPath(state) {
  return (state.routing.locationBeforeTransitions || {}).pathname;
};
var getLoadingIndex = function getLoadingIndex(state) {
  return state.sidebarHelp.helpIndex;
};
var getCurrentHelp = function getCurrentHelp(state) {
  return state.sidebarHelp.helpArticle;
};
var getCompanyType = function getCompanyType(state) {
  return state.assetsLandingReducer ? state.assetsLandingReducer.viewAs : state.user.getIn(['user', 'type']);
};
var getSupplierType = function getSupplierType(state) {
  return state.assetsLandingReducer ? '' : state.user.getIn(['company', 'productType']);
};

function init() {
  return regeneratorRuntime.wrap(function init$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.delegateYield((0, _sagas.apiSaga)(cnt.LOAD_HELPFILES, _api.contentful.sidebarHelp.getAllEntries, []), 't0', 1);

        case 1:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function fetchHelp() {
  var path, companyType, supplierType, fullIndex, helpIndex, helpArticle, currentHelp, entryId, _ref2, currentEntryId, title;

  return regeneratorRuntime.wrap(function fetchHelp$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)(getPath);

        case 2:
          path = _context2.sent;
          _context2.next = 5;
          return (0, _effects.select)(getCompanyType);

        case 5:
          companyType = _context2.sent;

          if (!(companyType === 'Supplier')) {
            _context2.next = 12;
            break;
          }

          _context2.next = 9;
          return (0, _effects.select)(getSupplierType);

        case 9:
          _context2.t0 = _context2.sent;
          _context2.next = 13;
          break;

        case 12:
          _context2.t0 = '';

        case 13:
          supplierType = _context2.t0.replace(/-/gi, ' ');
          _context2.next = 16;
          return (0, _effects.select)(getLoadingIndex);

        case 16:
          fullIndex = _context2.sent;
          helpIndex = fullIndex.filter(function (_ref) {
            var matchingRole = _ref.matchingRole;
            return matchingRole.indexOf('Everyone') > -1 || companyType === 'Contractor' && matchingRole.indexOf(companyType) > -1 || companyType === 'Supplier' && matchingRole.indexOf(companyType) > -1 && matchingRole.indexOf(supplierType) > -1;
          });

          if (!(helpIndex.length > 0)) {
            _context2.next = 32;
            break;
          }

          helpArticle = function () {
            var indexFound = helpIndex.findIndex(function (article) {
              return article.expressions.some(function (expression) {
                return expression.test(path);
              });
            });
            if (indexFound > -1) return indexFound;
            return helpIndex.findIndex(function (article) {
              return article.expressions.some(function (expression) {
                return expression.test('404');
              });
            });
          }();

          _context2.next = 22;
          return (0, _effects.select)(getCurrentHelp);

        case 22:
          currentHelp = _context2.sent;

          if (!helpIndex[helpArticle]) {
            _context2.next = 32;
            break;
          }

          entryId = helpIndex[helpArticle].entryId;
          _ref2 = currentHelp || { entryId: null }, currentEntryId = _ref2.entryId, title = _ref2.title;

          if (!(currentEntryId !== entryId)) {
            _context2.next = 30;
            break;
          }

          return _context2.delegateYield((0, _sagas.apiSaga)(cnt.LOAD_HELP_ARTICLE, _api.contentful.sidebarHelp.getHelp, [entryId]), 't1', 28);

        case 28:
          _context2.next = 32;
          break;

        case 30:
          _context2.next = 32;
          return (0, _effects.put)({
            type: 'TRACK_EVENT',
            payload: {
              ga: {
                eventCategory: 'sidebarhelp',
                eventAction: 'open',
                eventLabel: title,
                eventValue: entryId
              }
            }
          });

        case 32:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function trackOpen(_ref3) {
  var _ref3$payload$items = _slicedToArray(_ref3.payload.items, 1),
      _ref3$payload$items$ = _ref3$payload$items[0],
      title = _ref3$payload$items$.fields.title,
      id = _ref3$payload$items$.sys.id;

  return regeneratorRuntime.wrap(function trackOpen$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)({
            type: 'TRACK_EVENT',
            payload: {
              ga: {
                eventCategory: 'sidebarhelp',
                eventValue: id,
                eventAction: 'open',
                eventLabel: title
              }
            }
          });

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function closeHelp() {
  return regeneratorRuntime.wrap(function closeHelp$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)({ type: 'HELPWIDGET_CLOSE' });

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

exports.default = [(0, _effects.takeLatest)(cnt.OPEN_WIDGET, fetchHelp), (0, _effects.takeLatest)(cnt.SIDEBARHELP_INIT, init), (0, _effects.takeLatest)('@@router/LOCATION_CHANGE', closeHelp), (0, _effects.takeEvery)(cnt.LOAD_HELP_ARTICLE + '_SUCCESS', trackOpen)];

/***/ }),

/***/ 962:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _effects = __webpack_require__(36);

var _constants = __webpack_require__(655);

var cnt = _interopRequireWildcard(_constants);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

var _reduxSaga = __webpack_require__(92);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(consolidate),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getAssets),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(processHashtoken);

function consolidate() {
  var _ref, email, associateEmail, _ref2, companyId;

  return regeneratorRuntime.wrap(function consolidate$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(function (state) {
            return state.assetsConsolidation;
          });

        case 2:
          _ref = _context.sent;
          email = _ref.email;
          associateEmail = _ref.associateEmail;
          _context.next = 7;
          return (0, _effects.select)(function (state) {
            return state.user.toJS().company;
          });

        case 7:
          _ref2 = _context.sent;
          companyId = _ref2.companyId;
          return _context.delegateYield((0, _sagas.apiSaga)(cnt.CONSOLIDATE_ASSETS, _api.admin.consolidateAccount, [email, companyId, associateEmail]), 't0', 10);

        case 10:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function getAssets() {
  return regeneratorRuntime.wrap(function getAssets$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.delegateYield((0, _sagas.apiSaga)(cnt.GET_ASSETS, _api.assetLanding.getAssets, []), 't0', 1);

        case 1:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function processHashtoken(_ref3) {
  var type = _ref3.type,
      payload = _ref3.payload;
  var hashToken;
  return regeneratorRuntime.wrap(function processHashtoken$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          hashToken = payload.hashToken;
          return _context3.delegateYield((0, _sagas.apiSaga)(cnt.PROCESS_HASHTOKEN, _api.assetLanding.verifyToken, [hashToken]), 't0', 2);

        case 2:
          _context3.next = 4;
          return (0, _effects.call)(_reduxSaga.delay, 300);

        case 4:
          return _context3.delegateYield(getAssets(), 't1', 5);

        case 5:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

exports.default = [(0, _effects.takeLatest)(cnt.PROCESS_HASHTOKEN, processHashtoken), (0, _effects.takeLatest)(cnt.GET_ASSETS + '_SUCCESS', consolidate)];

/***/ }),

/***/ 963:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _effects = __webpack_require__(36);

var _profileConstants = __webpack_require__(646);

var cnt = _interopRequireWildcard(_profileConstants);

var _locationConstants = __webpack_require__(629);

var locCnt = _interopRequireWildcard(_locationConstants);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

var _reduxSaga = __webpack_require__(92);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(doUpdateGroup),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(refreshProfile),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(doDeleteGroup),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(reorderLocations),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(reorderProducts),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(doGetVerified),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(doNotifyUpgrade);

function doUpdateGroup(_ref) {
  var type = _ref.type,
      payload = _ref.payload;
  return regeneratorRuntime.wrap(function doUpdateGroup$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.delegateYield((0, _sagas.apiSaga)(type, _api.profile.updateGroup, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function refreshProfile() {
  var pathname, locationId;
  return regeneratorRuntime.wrap(function refreshProfile$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          pathname = window.location.pathname;

          if (!(pathname === '/profile')) {
            _context2.next = 5;
            break;
          }

          return _context2.delegateYield((0, _sagas.apiSaga)(cnt.GET_PROFILE, _api.profile.getCompanyProfile, []), 't0', 3);

        case 3:
          _context2.next = 8;
          break;

        case 5:
          if (!(pathname.indexOf('/profile/locations') > -1)) {
            _context2.next = 8;
            break;
          }

          locationId = _ramda2.default.last(_ramda2.default.split('/', pathname));
          return _context2.delegateYield((0, _sagas.apiSaga)('GET_USER_LOCATION_PROFILE', _api.profile.getUserLocationProfile, [{ locationId: locationId }]), 't1', 8);

        case 8:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function doDeleteGroup(_ref2) {
  var type = _ref2.type,
      payload = _ref2.payload;
  var confirmed;
  return regeneratorRuntime.wrap(function doDeleteGroup$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          confirmed = window.confirm('Are you sure you want to delete this group? Note: items won\'t be deleted.');

          if (!confirmed) {
            _context3.next = 3;
            break;
          }

          return _context3.delegateYield((0, _sagas.apiSaga)(type, _api.profile.deleteGroup, [payload]), 't0', 3);

        case 3:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function reorderLocations(_ref3) {
  var type = _ref3.type,
      payload = _ref3.payload;
  return regeneratorRuntime.wrap(function reorderLocations$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.delegateYield((0, _sagas.apiSaga)(type, _api.profile.reorderLocations, [payload.locationIds]), 't0', 1);

        case 1:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function reorderProducts(_ref4) {
  var type = _ref4.type,
      payload = _ref4.payload;
  return regeneratorRuntime.wrap(function reorderProducts$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.delegateYield((0, _sagas.apiSaga)(type, _api.profile.reorderProducts, [payload.productIds]), 't0', 1);

        case 1:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function doGetVerified(_ref5) {
  var type = _ref5.type;
  return regeneratorRuntime.wrap(function doGetVerified$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          window.open('https://www.tourconnect.com/tc-verified/');
          return _context6.delegateYield((0, _sagas.apiSaga)(type, _api.account.sendNotification, [{ action: 'getVerified' }]), 't0', 2);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function doNotifyUpgrade(_ref6) {
  var type = _ref6.type,
      payload = _ref6.payload;
  var name;
  return regeneratorRuntime.wrap(function doNotifyUpgrade$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          name = (0, _ramda.pathOr)('', ['name'], payload);

          if (!/(.+)Upgrade Click$/.test(name)) {
            _context7.next = 3;
            break;
          }

          return _context7.delegateYield((0, _sagas.apiSaga)(type, _api.account.sendNotification, [{ action: 'clickedUpgrade' }]), 't0', 3);

        case 3:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

exports.default = [(0, _effects.takeLatest)(cnt.UPDATE_GROUP, doUpdateGroup), (0, _effects.takeLatest)(cnt.UPDATE_GROUP + '_SUCCESS', refreshProfile), (0, _effects.takeLatest)(cnt.DELETE_GROUP, doDeleteGroup), (0, _effects.takeLatest)(cnt.DELETE_GROUP + '_SUCCESS', refreshProfile), (0, _effects.takeLatest)(cnt.REORDER_LOCATIONS, reorderLocations), (0, _effects.takeLatest)(cnt.REORDER_LOCATIONS + '_SUCCESS', refreshProfile), (0, _effects.takeLatest)(cnt.REORDER_PRODUCTS, reorderProducts), (0, _effects.takeLatest)(cnt.REORDER_PRODUCTS + '_SUCCESS', refreshProfile), (0, _effects.takeLatest)(cnt.IMPORTED_LOC, refreshProfile), (0, _effects.takeLatest)(locCnt.FINISHED_IMPORTING_PROD, refreshProfile), (0, _effects.takeLatest)('{profile} getVerified', doGetVerified), (0, _effects.takeLatest)('TRACK_EVENT', doNotifyUpgrade)];

/***/ }),

/***/ 964:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _effects = __webpack_require__(36);

var _constants = __webpack_require__(652);

var cnt = _interopRequireWildcard(_constants);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

var _reduxSaga = __webpack_require__(92);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

var _docCookie = __webpack_require__(142);

var _docCookie2 = _interopRequireDefault(_docCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(loadWidgetData),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(loadDashboard),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(handleYearChange),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(handleInit),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(loadFolders),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(handleWidgetFilterUpdate);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function loadWidgetData(widgetState) {
  var globalFiltersState, currentYear, startInCookie, endInCookie, globalFilters, id, url, filters, filterObj, query;
  return regeneratorRuntime.wrap(function loadWidgetData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contractingDashboard.globalFilters;
          });

        case 2:
          globalFiltersState = _context.sent;
          _context.next = 5;
          return (0, _effects.select)(function (state) {
            return state.contracting.currentYear;
          });

        case 5:
          currentYear = _context.sent;
          startInCookie = _docCookie2.default.getItem('contractYearStartDate');
          endInCookie = _docCookie2.default.getItem('contractYearEndDate');
          globalFilters = Object.entries(globalFiltersState).map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];

            if (value.key === 'locations') {
              return { locations: value.list.filter(function (obj) {
                  return obj.checked;
                }).map(_ramda2.default.prop('locId')) };
            }
            if (value.key === 'folder') {
              return { folder: value.list.filter(function (obj) {
                  return obj.checked;
                }).map(_ramda2.default.prop('value')) };
            }
            return _defineProperty({}, key, value.selectedValue);
          }).reduce(function (obj, item) {
            return _extends({
              contractingPeriod: (currentYear.startDate || startInCookie) + '|' + (currentYear.endDate || endInCookie)
            }, _extends({}, item), obj);
          });
          id = widgetState.id, url = widgetState.url, filters = widgetState.filters;
          filterObj = {};

          Object.values(filters || {}).forEach(function (_ref4) {
            var filterValue = _ref4.filterValue,
                filterBy = _ref4.filterBy;

            if (filterValue) {
              filterObj[filterBy] = filterValue;
            }
          });
          query = _queryString2.default.stringify(_extends({}, globalFilters, filterObj));
          return _context.delegateYield((0, _sagas.apiSaga)(cnt.UPDATE_WIDGET_DATA, function () {
            return (0, _api.callApi)('/proxy' + url + '?' + query);
          }, [{ widgetId: id }]), 't0', 14);

        case 14:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function loadDashboard() {
  var items;
  return regeneratorRuntime.wrap(function loadDashboard$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contractingDashboard.items;
          });

        case 2:
          items = _context2.sent;
          _context2.next = 5;
          return (0, _effects.all)(items.map(loadWidgetData));

        case 5:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function handleYearChange() {
  return regeneratorRuntime.wrap(function handleYearChange$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (!(window.location.pathname.indexOf('dashboard') > -1)) {
            _context3.next = 2;
            break;
          }

          return _context3.delegateYield(loadDashboard(), 't0', 2);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function handleInit() {
  var currentYear, startInCookie;
  return regeneratorRuntime.wrap(function handleInit$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.currentYear;
          });

        case 2:
          currentYear = _context4.sent;
          startInCookie = _docCookie2.default.getItem('contractYearStartDate');

          if (!(currentYear.startDate || startInCookie)) {
            _context4.next = 6;
            break;
          }

          return _context4.delegateYield(loadDashboard(), 't0', 6);

        case 6:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function loadFolders(_ref5) {
  var type = _ref5.type;
  return regeneratorRuntime.wrap(function loadFolders$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.getFolders, []), 't0', 1);

        case 1:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function handleWidgetFilterUpdate(_ref6) {
  var payload = _ref6.payload;
  var widgetState;
  return regeneratorRuntime.wrap(function handleWidgetFilterUpdate$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contractingDashboard.items.find(function (item) {
              return item.id === payload.id;
            });
          });

        case 2:
          widgetState = _context6.sent;
          return _context6.delegateYield(loadWidgetData(widgetState), 't0', 4);

        case 4:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

exports.default = [(0, _effects.takeLatest)('[contracting]SELECTED_YEAR_FOR_CONTRACTING', handleYearChange), (0, _effects.takeLatest)(cnt.INIT_DASHBOARD, handleInit), (0, _effects.takeLatest)(cnt.LOAD_DASHBOARD, loadDashboard), (0, _effects.takeLatest)(cnt.RESET_GLOBAL_DASHBOARD_FILTER, loadDashboard), (0, _effects.takeLatest)(cnt.LOAD_FOLDERS, loadFolders), (0, _effects.takeLatest)(cnt.UPDATE_WIDGET_FILTER, handleWidgetFilterUpdate)];

/***/ }),

/***/ 965:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _effects = __webpack_require__(36);

var _sagas = __webpack_require__(43);

var _reduxSaga = __webpack_require__(92);

var _updateCommissionRates = __webpack_require__(966);

var _updateNettRates = __webpack_require__(967);

var _updateDiscountRates = __webpack_require__(968);

var _updateDiscountRates2 = _interopRequireDefault(_updateDiscountRates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(updateRates);

function updateRates() {
  var state, updateType, rateType, retailNettMeasure, notApplyToExtraChild, roundingSetting, settings, newState;
  return regeneratorRuntime.wrap(function updateRates$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(function (mainState) {
            return mainState.contracting.massRateChange;
          });

        case 2:
          state = _context.sent;
          updateType = state.get('updateType');
          rateType = state.get('rateType');
          retailNettMeasure = state.getIn([updateType, rateType + 'Measure']);
          notApplyToExtraChild = state.getIn([updateType, 'notApplyToExtraChildFor' + rateType]);
          roundingSetting = state.getIn([updateType, 'roundingSetting']) ? state.getIn([updateType, 'roundingSetting']).toJS() : { roundType: 'normal', cents: 1 };
          settings = {
            updateType: updateType,
            retailNettMeasure: retailNettMeasure,
            notApplyToExtraChild: notApplyToExtraChild,
            roundingSetting: roundingSetting
          };
          newState = state.updateIn([updateType, 'products'], function (products) {
            return products.map(function (product) {
              if (rateType === 'discount') {
                return (0, _updateDiscountRates2.default)(settings, product);
              }
              var newNums = {
                updatedCommission: product.get('commission'),
                retailDiff: product.get('retailDiff'),
                nettDiff: product.get('nettDiff')
              };
              var updateRateSetsOrExtrasOrOffers = function () {
                if (rateType === 'commission') return _updateCommissionRates.updateRateSetsOrExtrasOrOffers;
                if (rateType === 'nett') return _updateNettRates.updateRateSetsOrExtrasOrOffers;
              }();
              if (updateType === 'seasonRates') {
                return product.update('seasonRates', function (seasonRates) {
                  if (!seasonRates) return seasonRates;
                  return seasonRates.map(function (seasonRate) {
                    return seasonRate.updateIn(['rateSets', rateType], function (rateSets) {
                      return updateRateSetsOrExtrasOrOffers(newNums, settings, rateSets);
                    });
                  });
                });
              }
              return product.updateIn([updateType, rateType], function (extrasOrOffers) {
                return updateRateSetsOrExtrasOrOffers(newNums, settings, extrasOrOffers);
              });
            });
          });
          _context.next = 12;
          return (0, _effects.put)({
            type: 'UPDATE_MASS_RATE_CHANGE_CALCULATION',
            payload: newState
          });

        case 12:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

exports.default = [(0, _effects.takeLatest)('CHANGE_WIDGET_VALUE_FOR_APPLY_ALL', updateRates), (0, _effects.takeLatest)('CHANGE_WIDGET_VALUE_FOR_PRODUCT', updateRates), (0, _effects.takeLatest)('CHANGE_MASS_RATE_CHANGE_MEASURE', updateRates), (0, _effects.takeLatest)('CHANGE_ROUNDING_SETTINGS_IN_MASS_RATE_CHANGE', updateRates), (0, _effects.takeLatest)('ON_CHANGE_NOT_APPLY_MASS_RATE_CHANGE_TO_EXTRA_CHILD', updateRates)];

/***/ }),

/***/ 966:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateRateSetsOrExtrasOrOffers = undefined;

var _ramda = __webpack_require__(2);

var _immutable = __webpack_require__(26);

var _roundTo = __webpack_require__(610);

var _roundTo2 = _interopRequireDefault(_roundTo);

var _roundingHelpers = __webpack_require__(491);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var roundNumber = function roundNumber(_ref, num) {
  var roundType = _ref.roundType,
      cents = _ref.cents;

  var newNum = Number(num);
  if (roundType === 'alwaysUp') return (0, _roundingHelpers.roundUpToNearest)(newNum, cents);
  if (roundType === 'alwaysDown') return (0, _roundingHelpers.roundDownToNearest)(newNum, cents);
  return (0, _roundingHelpers.roundToNearest)(newNum, cents);
};
var calRatesWithNewCommission = function calRatesWithNewCommission(commission, _ref2, rates) {
  var notApplyToExtraChild = _ref2.notApplyToExtraChild,
      roundingSetting = _ref2.roundingSetting;

  if (!rates) return rates;
  return rates.map(function (rate) {
    if (rate.get('notApplicable')) return rate;
    var initialNettRate = (0, _ramda.isNil)(rate.get('initialNettRate')) ? // Check isNil because rate may be 0
    (0, _ramda.isNil)(rate.get('nettRate')) ? 0 : rate.get('nettRate') : // if no nettRate then 0 else nettRate
    rate.get('initialNettRate');
    var nettRate = (0, _ramda.multiply)(rate.get('retailRate'))(100 - commission) / 100;
    // console.log('calRatesWithNewCommission', { nettRate, commission });
    if (notApplyToExtraChild && (rate.get('description') === 'Extra Child' || rate.get('description') === 'Extra Adult')) return rate.set('nettRate', initialNettRate);
    return rate.merge((0, _immutable.fromJS)({
      initialNettRate: initialNettRate,
      nettRate: roundNumber(roundingSetting, nettRate).toFixed(2)
    }));
  });
};

var calRatesWithNewRetailDiff = function calRatesWithNewRetailDiff(retailDiff, commissionPercentage, _ref3, rates) {
  var retailNettMeasure = _ref3.retailNettMeasure,
      notApplyToExtraChild = _ref3.notApplyToExtraChild,
      roundingSetting = _ref3.roundingSetting;

  if (!rates) return rates;
  return rates.map(function (rate) {
    if (rate.get('notApplicable')) return rate;
    var initialRetailRate = (0, _ramda.isNil)(rate.get('initialRetailRate')) ? // Check isNil because rate may be 0
    (0, _ramda.isNil)(rate.get('retailRate')) ? 0 : rate.get('retailRate') : // if no retailRate then 0 else retailRate
    rate.get('initialRetailRate');
    var initialNettRate = (0, _ramda.isNil)(rate.get('initialNettRate')) ? // Check isNil because rate may be 0
    (0, _ramda.isNil)(rate.get('nettRate')) ? 0 : rate.get('nettRate') : // if no nettRate then 0 else nettRate
    rate.get('initialNettRate');
    var numberedRetailChange = Number(retailDiff);
    var retailDiffAmount = retailNettMeasure === 'percentage' ? (0, _ramda.multiply)(initialRetailRate, (0, _ramda.divide)(numberedRetailChange, 100)) : numberedRetailChange;
    var retailRate = (0, _ramda.add)(initialRetailRate, retailDiffAmount);
    var nettRate = (0, _ramda.multiply)(retailRate, (0, _ramda.subtract)(100, commissionPercentage)) / 100;
    // console.log('calRatesWithNewRetailDiff', { retailDiffAmount, retailNettMeasure });
    if (notApplyToExtraChild && (rate.get('description') === 'Extra Child' || rate.get('description') === 'Extra Adult')) return rate.merge((0, _immutable.fromJS)({ nettRate: initialNettRate, retailRate: initialRetailRate }));
    return rate.merge((0, _immutable.fromJS)({
      initialRetailRate: initialRetailRate,
      initialNettRate: initialNettRate,
      retailRate: roundNumber(roundingSetting, retailRate).toFixed(2),
      nettRate: roundNumber(roundingSetting, nettRate).toFixed(2)
    }));
  });
};

var updateRateSetsOrExtrasOrOffers = exports.updateRateSetsOrExtrasOrOffers = function updateRateSetsOrExtrasOrOffers(_ref4, settings, rateSetsOrExtrasOrOffers) {
  var updatedCommission = _ref4.updatedCommission,
      retailDiff = _ref4.retailDiff;

  if (!rateSetsOrExtrasOrOffers) return rateSetsOrExtrasOrOffers;
  return rateSetsOrExtrasOrOffers.map(function (rateSet) {
    var initialCommissionPercentage = Number(rateSet.get('initialCommissionPercentage') ? rateSet.get('initialCommissionPercentage') : rateSet.get('commissionPercentage'));
    var commissionPercentage = !updatedCommission ? initialCommissionPercentage : Number(updatedCommission);
    // console.log({ updatedCommission, retailDiff });
    // if nothing changed, use initial rate
    if (!updatedCommission && !retailDiff) {
      return rateSet.set('commissionPercentage', commissionPercentage).set('retailDiff', retailDiff).update('rates', function (rates) {
        return rates.map(function (rate) {
          if (rate.get('notApplicable')) return rate;
          return rate.merge((0, _immutable.fromJS)({
            // when user toggling settings without any number updated, intial values weren't there yet
            retailRate: rate.get('initialRetailRate') || rate.get('retailRate'),
            nettRate: rate.get('initialNettRate') || rate.get('nettRate')
          }));
        });
      });
    }
    var ratesAfterCommission = commissionPercentage && !isNaN(commissionPercentage) ? calRatesWithNewCommission(Number(commissionPercentage), settings, rateSet.get('rates')) : rateSet.get('rates');
    var ratesAfterRetailDiff = !(0, _ramda.isNil)(retailDiff) && !isNaN(retailDiff) ? calRatesWithNewRetailDiff(retailDiff, commissionPercentage, settings, ratesAfterCommission) : ratesAfterCommission;
    var updateObject = {
      initialCommissionPercentage: initialCommissionPercentage,
      rates: ratesAfterRetailDiff,
      commissionPercentage: commissionPercentage
    };
    return rateSet.merge((0, _immutable.fromJS)(updateObject));
  });
};

/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateRateSetsOrExtrasOrOffers = undefined;

var _ramda = __webpack_require__(2);

var _immutable = __webpack_require__(26);

var _roundingHelpers = __webpack_require__(491);

var roundNumber = function roundNumber(_ref, num) {
  var roundType = _ref.roundType,
      cents = _ref.cents;

  var newNum = Number(num);
  if (roundType === 'alwaysUp') return (0, _roundingHelpers.roundUpToNearest)(newNum, cents);
  if (roundType === 'alwaysDown') return (0, _roundingHelpers.roundDownToNearest)(newNum, cents);
  return (0, _roundingHelpers.roundToNearest)(newNum, cents);
};

var calNettByDiff = (0, _ramda.curry)(function (nettDiff, _ref2, rates) {
  var retailNettMeasure = _ref2.retailNettMeasure,
      notApplyToExtraChild = _ref2.notApplyToExtraChild,
      roundingSetting = _ref2.roundingSetting;
  return rates.map(function (rate) {
    var initialNettRate = (0, _ramda.isNil)(rate.get('initialNettRate')) ? // Check isNil because rate may be 0
    (0, _ramda.isNil)(rate.get('nettRate')) ? 0 : rate.get('nettRate') : // if no nettRate then 0 else nettRate
    rate.get('initialNettRate');
    var nettRate = retailNettMeasure === 'percentage' ? (0, _ramda.multiply)(initialNettRate, (0, _ramda.divide)((0, _ramda.add)(Number(nettDiff), 100), 100)) : (0, _ramda.add)(initialNettRate, Number(nettDiff));
    if (notApplyToExtraChild && (rate.get('description') === 'Extra Child' || rate.get('description') === 'Extra Adult')) return rate.set('nettRate', initialNettRate);
    return rate.get('notApplicable') ? rate : rate.merge((0, _immutable.fromJS)({
      initialNettRate: initialNettRate,
      nettRate: nettDiff ? roundNumber(roundingSetting, nettRate).toFixed(2) : initialNettRate
    }));
  });
});

var updateRateSetsOrExtrasOrOffers = exports.updateRateSetsOrExtrasOrOffers = (0, _ramda.curry)(function (_ref3, settings, rateSetsOrExtrasOrOffers) {
  var nettDiff = _ref3.nettDiff;

  if (!rateSetsOrExtrasOrOffers) return rateSetsOrExtrasOrOffers;
  return rateSetsOrExtrasOrOffers.map(function (rateSet) {
    if (!rateSet) return rateSet;
    return rateSet.update('rates', calNettByDiff(nettDiff, settings));
  });
});

/***/ }),

/***/ 968:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(26);

var _ramda = __webpack_require__(2);

var _roundingHelpers = __webpack_require__(491);

var roundNumber = function roundNumber(_ref, num) {
  var roundType = _ref.roundType,
      cents = _ref.cents;

  var newNum = Number(num);
  if (roundType === 'alwaysUp') return (0, _roundingHelpers.roundUpToNearest)(newNum, cents);
  if (roundType === 'alwaysDown') return (0, _roundingHelpers.roundDownToNearest)(newNum, cents);
  return (0, _roundingHelpers.roundToNearest)(newNum, cents);
};

var updateDiscountRates = function updateDiscountRates(_ref2, product) {
  var measure = _ref2.retailNettMeasure,
      roundingSetting = _ref2.roundingSetting;

  var discountDiff = product.get('discountDiff');
  return product.updateIn(['offers', 'discount'], function (discountOffers) {
    return !discountOffers ? discountOffers : discountOffers.map(function (offer) {
      var initialAmount = (0, _ramda.isNil)(offer.get('initialAmount')) ? // Check isNil because offer may be 0
      (0, _ramda.isNil)(offer.get('amount')) ? 0 : offer.get('amount') : // if no amount then 0 else amount
      offer.get('initialAmount');
      var amount = measure === 'percentage' ? (0, _ramda.multiply)(initialAmount, (0, _ramda.divide)((0, _ramda.add)(Number(discountDiff), 100), 100)) : (0, _ramda.add)(Number(initialAmount), Number(discountDiff));
      return offer.get('notApplicable') ? offer : offer.merge((0, _immutable.fromJS)({
        initialAmount: initialAmount,
        amount: discountDiff ? roundNumber(roundingSetting, amount) : initialAmount
      }));
    });
  });
};

exports.default = updateDiscountRates;

/***/ }),

/***/ 969:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = __webpack_require__(36);

var _reactRouterRedux = __webpack_require__(27);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

var _constants = __webpack_require__(656);

var cnt = _interopRequireWildcard(_constants);

var _constants2 = __webpack_require__(233);

var wkspConst = _interopRequireWildcard(_constants2);

var _constants3 = __webpack_require__(648);

var _smallTemplateListConstants = __webpack_require__(649);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(resetSelectedTemplate),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(resetSelectedLocation),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(resetRateSelections),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(resetContractRequest),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(sendRates),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(sendRateRequest),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(sendMessage),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(getPartnerDetails),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(refreshActivities),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(_getActivities),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(_getFiles),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(refreshFiles),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(contractFromHistoryFeed),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(contractFromHistoryFeedSuccess),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(markAsRead);

var getRoute = function getRoute(state) {
  return state.routing.locationBeforeTransitions.pathname;
};
var getTaxId = function getTaxId(state) {
  return state.profile.get('corporateIdentifier');
};

// de-select the selected template
function resetSelectedTemplate() {
  return regeneratorRuntime.wrap(function resetSelectedTemplate$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)({
            type: _constants3.UPDATE_PROPS,
            payload: {
              templateSelected: {}
            }
          });

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

// de-select the selected location
function resetSelectedLocation() {
  return regeneratorRuntime.wrap(function resetSelectedLocation$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)({
            type: _constants3.RESET_LOCATION_SELECTION,
            payload: {
              locationId: ''
            }
          });

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function resetRateSelections() {
  return regeneratorRuntime.wrap(function resetRateSelections$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)({
            type: _constants3.RESET_TEMPLATE_SELECTION
          });

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function resetContractRequest() {
  var taxId;
  return regeneratorRuntime.wrap(function resetContractRequest$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(getTaxId);

        case 2:
          taxId = _context4.sent;
          _context4.next = 5;
          return (0, _effects.put)({ type: 'CLEAR_CONTRACTOR_CONTRACTING_WIZARD', payload: { taxId: taxId } });

        case 5:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function sendRates(payload) {
  return regeneratorRuntime.wrap(function sendRates$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.delegateYield((0, _sagas.apiSaga)(cnt.SEND_RATES, _api.contracting.sendContract, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function sendRateRequest(payload) {
  return regeneratorRuntime.wrap(function sendRateRequest$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          return _context6.delegateYield((0, _sagas.apiSaga)(cnt.SEND_RATE_REQUESTS, _api.contracting.sendContractRequest, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function sendMessage(_ref) {
  var _ref$payload = _ref.payload,
      partnerId = _ref$payload.partnerId,
      channel = _ref$payload.channel,
      message = _ref$payload.message;
  return regeneratorRuntime.wrap(function sendMessage$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          return _context7.delegateYield((0, _sagas.apiSaga)(cnt.SEND_MESSAGE, _api.workspace.newMessage, [_extends({
            type: channel === 'notes' ? 'note' : 'message'
          }, message, {
            partnerIds: [partnerId]
          })]), 't0', 1);

        case 1:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function getPartnerDetails(_ref2) {
  var pathname = _ref2.payload.pathname;
  var partnerId;
  return regeneratorRuntime.wrap(function getPartnerDetails$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          if (!(pathname.split('/')[1] === 'partnerDetails')) {
            _context8.next = 6;
            break;
          }

          partnerId = pathname.split('/')[2];
          _context8.next = 4;
          return (0, _effects.put)({ type: cnt.CLEAR_STORE });

        case 4:
          _context8.next = 6;
          return (0, _effects.all)([(0, _sagas.apiSaga)(cnt.GET_PARTNER_INFO, _api.partner.getCompanyInfo, [{ partnerId: partnerId }]), _getFiles(partnerId), _getActivities(partnerId)]);

        case 6:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function refreshActivities() {
  var pathname, companyId;
  return regeneratorRuntime.wrap(function refreshActivities$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.select)(getRoute);

        case 2:
          pathname = _context9.sent;

          if (!(pathname.split('/')[1] === 'partnerDetails')) {
            _context9.next = 6;
            break;
          }

          companyId = pathname.split('/')[2];
          return _context9.delegateYield((0, _sagas.apiSaga)(cnt.GET_ACTIVITY, _api.partner.getActivities, [{ assetId: companyId }]), 't0', 6);

        case 6:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function _getActivities(partnerId) {
  return regeneratorRuntime.wrap(function _getActivities$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          return _context10.delegateYield((0, _sagas.apiSaga)(cnt.GET_ACTIVITY, _api.partner.getActivities, [{ assetId: partnerId }]), 't0', 1);

        case 1:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function _getFiles(partnerId) {
  return regeneratorRuntime.wrap(function _getFiles$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          return _context11.delegateYield((0, _sagas.apiSaga)(cnt.GET_FILES, _api.contracting.getContracts, [{
            query: { partnerIds: partnerId },
            includeTemplateNames: true
          }]), 't0', 1);

        case 1:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function refreshFiles() {
  var pathname, partnerId;
  return regeneratorRuntime.wrap(function refreshFiles$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.select)(getRoute);

        case 2:
          pathname = _context12.sent;

          if (!(pathname.split('/')[1] === 'partnerDetails')) {
            _context12.next = 7;
            break;
          }

          partnerId = pathname.split('/')[2];
          _context12.next = 7;
          return (0, _effects.all)([_getFiles(partnerId), _getActivities(partnerId)]);

        case 7:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function contractFromHistoryFeed(_ref3) {
  var type = _ref3.type,
      payload = _ref3.payload;
  return regeneratorRuntime.wrap(function contractFromHistoryFeed$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.contractFromHF, [payload]);

        case 2:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function contractFromHistoryFeedSuccess(_ref4) {
  var payload = _ref4.payload;
  return regeneratorRuntime.wrap(function contractFromHistoryFeedSuccess$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.put)((0, _reactRouterRedux.push)(payload.path.replace('#contractId#', payload.contractId)));

        case 2:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function markAsRead() {
  var pathname, partnerId;
  return regeneratorRuntime.wrap(function markAsRead$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.select)(getRoute);

        case 2:
          pathname = _context15.sent;

          if (!(pathname.split('/')[1] === 'partnerDetails')) {
            _context15.next = 7;
            break;
          }

          partnerId = pathname.split('/')[2];
          _context15.next = 7;
          return (0, _sagas.apiSaga)(wkspConst.CONVERSATIONS_READ, _api.workspace.conversationsRead, [{ assetId: partnerId, assetType: 'partner' }]);

        case 7:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}

exports.default = [(0, _effects.takeLatest)('@@router/LOCATION_CHANGE', getPartnerDetails), (0, _effects.takeLatest)(cnt.RESET_SELECTED_ALL, resetRateSelections), (0, _effects.takeLatest)(cnt.RESET_SELECTED_LOCATION, resetSelectedLocation), (0, _effects.takeLatest)(cnt.RESET_SELECTED_RATE, resetSelectedTemplate), (0, _effects.takeLatest)(cnt.RESET_CONTRACTING_REQUEST, resetContractRequest), (0, _effects.takeLatest)(cnt.SEND_MESSAGE, sendMessage), (0, _effects.takeLatest)(cnt.SEND_RATES, sendRates), (0, _effects.takeLatest)(cnt.SEND_RATE_REQUESTS, sendRateRequest), (0, _effects.takeLatest)(_smallTemplateListConstants.POPULATE_REDUCER, resetSelectedTemplate), (0, _effects.takeLatest)(cnt.SEND_MESSAGE + '_SUCCESS', refreshActivities), (0, _effects.takeLatest)(cnt.SEND_RATES + '_SUCCESS', refreshFiles), (0, _effects.takeLatest)(cnt.SEND_RATES + '_SUCCESS', refreshActivities), (0, _effects.takeLatest)(cnt.SEND_RATE_REQUESTS + '_SUCCESS', refreshFiles), (0, _effects.takeLatest)(cnt.SEND_RATE_REQUESTS + '_SUCCESS', refreshActivities), (0, _effects.takeLatest)('CONTRACT_FROM_HF', contractFromHistoryFeed), (0, _effects.takeLatest)('CONTRACT_FROM_HF_SUCCESS', contractFromHistoryFeedSuccess), (0, _effects.takeLatest)(cnt.GET_ACTIVITY + '_SUCCESS', markAsRead)];

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _curry2 = __webpack_require__(1);
var _reduce = __webpack_require__(18);
var map = __webpack_require__(16);


/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the second argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */
module.exports = _curry2(function ap(applyF, applyX) {
  return (
    typeof applyX['fantasy-land/ap'] === 'function' ?
      applyX['fantasy-land/ap'](applyF) :
    typeof applyF.ap === 'function' ?
      applyF.ap(applyX) :
    typeof applyF === 'function' ?
      function(x) { return applyF(x)(applyX(x)); } :
    // else
      _reduce(function(acc, f) { return _concat(acc, map(f, applyX)); }, [], applyF)
  );
});


/***/ }),

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = __webpack_require__(36);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _partnerFinderConstants = __webpack_require__(653);

var constPF = _interopRequireWildcard(_partnerFinderConstants);

var _connectionsConstants = __webpack_require__(867);

var constCO = _interopRequireWildcard(_connectionsConstants);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(tagAsAdmin),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(rollbarConfigure),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(trackEvent),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(pageView),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(sendUserDataToTag),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(gaEvent),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(intercomEvent),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(gaChangeStatus),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(invitationsEvent),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(intercomLocationFieldUpdate),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(intercomMMUpdate),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(upgradeEvent),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(signUpEvent);

/*
	Middleware to use for 3rd Party Tracking Scripts
*/

var getUserId = function getUserId(state) {
  return state.user.get('id');
};
var getUserEmail = function getUserEmail(state) {
  return state.user.get('user').get('email');
};
var getisAdmin = function getisAdmin(state) {
  return state.user.get('isAnAdmin');
};
var getInvitationsSent = function getInvitationsSent(state) {
  return state.tempConnections.get('emailStatuses').sent;
};
var getSignUp = function getSignUp(state) {
  return state.signup.toJS();
};
var getAssetsLandingReducer = function getAssetsLandingReducer(state) {
  return state.assetsLandingReducer;
};

var sendIntercom = function sendIntercom() {
  if (window.Intercom) {
    var _window;

    (_window = window).Intercom.apply(_window, arguments); // eslint-disable-line new-cap
  }
};

/*
	Loop through all Google Analytics trackers and send event
*/
var gaSendEvent = function gaSendEvent(_ref) {
  var eventCategory = _ref.eventCategory,
      eventValue = _ref.eventValue,
      eventAction = _ref.eventAction,
      eventLabel = _ref.eventLabel;

  window.dataLayer.push({
    event: 'TRACK_EVENT',
    ev: {
      category: eventCategory,
      action: eventAction,
      label: eventLabel,
      value: eventValue
    }
  });
};

window.dataLayer = window.dataLayer || [];

function tagAsAdmin() {
  return regeneratorRuntime.wrap(function tagAsAdmin$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(getisAdmin);

        case 2:
          if (!_context.sent) {
            _context.next = 4;
            break;
          }

          window.dataLayer.push({ isTCAdminSession: true });

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function rollbarConfigure() {
  return regeneratorRuntime.wrap(function rollbarConfigure$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!window.Rollbar) {
            _context2.next = 12;
            break;
          }

          _context2.t0 = window.Rollbar;
          _context2.next = 4;
          return (0, _effects.select)(getUserId);

        case 4:
          _context2.t1 = _context2.sent;
          _context2.next = 7;
          return (0, _effects.select)(getUserEmail);

        case 7:
          _context2.t2 = _context2.sent;
          _context2.t3 = {
            id: _context2.t1,
            email: _context2.t2
          };
          _context2.t4 = {
            person: _context2.t3
          };
          _context2.t5 = {
            payload: _context2.t4
          };

          _context2.t0.configure.call(_context2.t0, _context2.t5);

        case 12:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function trackEvent(_ref2) {
  var payload = _ref2.payload;
  return regeneratorRuntime.wrap(function trackEvent$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (payload.name) {
            sendIntercom('trackEvent', payload.name, _extends({}, payload.values));
          }
          if (payload.ga) {
            gaSendEvent(payload.ga);
          }

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function pageView(_ref3) {
  var payload = _ref3.payload;
  return regeneratorRuntime.wrap(function pageView$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          window.dataLayer.push({
            event: 'PAGE_VIEW',
            document: {
              pagePath: payload.path,
              pageTitle: payload.title
            }
          });

        case 1:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function sendUserDataToTag(_ref4) {
  var user = _ref4.user;

  var userId, _user$user, name, email, createdAt, intercomApp, intercomUserHash, isMarketingReady, _user$company, companyId, companyName, companyType, plan, productType, websiteUrl, phone, acctCreationReason, companyCreatedAt, bookingSystem, emailClient, affiliateURL, payload;

  return regeneratorRuntime.wrap(function sendUserDataToTag$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          userId = user.id, _user$user = user.user, name = _user$user.name, email = _user$user.email, createdAt = _user$user.createdAt, intercomApp = _user$user.intercomApp, intercomUserHash = _user$user.intercomUserHash, isMarketingReady = user.isMarketingReady, _user$company = user.company, companyId = _user$company.companyId, companyName = _user$company.companyName, companyType = _user$company.companyType, plan = _user$company.plan, productType = _user$company.productType, websiteUrl = _user$company.websiteUrl, phone = _user$company.phone, acctCreationReason = _user$company.acctCreationReason, companyCreatedAt = _user$company.createdAt, bookingSystem = user.bookingSystem, emailClient = user.emailClient, affiliateURL = user.affiliateURL;
          payload = {
            event: 'GET_USER',
            user: {
              id: userId,
              name: name || '',
              email: email,
              createdAt: new Date(createdAt).getTime() / 1000,
              app_id: intercomApp,
              user_hash: intercomUserHash
            },
            company: {
              id: companyId,
              createdAt: new Date(companyCreatedAt).getTime() / 1000,
              accountAge: (0, _moment2.default)().diff(companyCreatedAt, 'days'),
              creationReason: acctCreationReason,
              type: companyType,
              plan: plan,
              name: companyName,
              website: websiteUrl,
              phone: phone,
              isMarketingReady: isMarketingReady,
              productType: productType,
              bookingSystem: bookingSystem,
              emailClient: emailClient,
              affiliateURL: affiliateURL
            }
          };

          window.dataLayer.push(payload);

        case 3:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function sendUserDataToIntercom(_ref5) {
  var user = _ref5.user;
  var _user$user2 = user.user,
      name = _user$user2.name,
      email = _user$user2.email,
      intercomApp = _user$user2.intercomApp,
      intercomUserHash = _user$user2.intercomUserHash,
      _user$company2 = user.company,
      companyId = _user$company2.companyId,
      companyName = _user$company2.companyName,
      companyType = _user$company2.companyType,
      plan = _user$company2.plan,
      websiteUrl = _user$company2.websiteUrl,
      phone = _user$company2.phone,
      acctCreationReason = _user$company2.acctCreationReason,
      bookingSystem = user.bookingSystem,
      emailClient = user.emailClient,
      affiliateURL = user.affiliateURL;

  setTimeout(function () {
    sendIntercom('boot', {
      app_id: intercomApp,
      // user_id: userId // DO NOT SEND USER ID as we are using user_hash base on email
      name: name || '',
      email: email,
      user_hash: intercomUserHash,
      company: {
        id: companyId,
        creation_reason: acctCreationReason,
        plan: plan,
        company_type: companyType,
        name: companyName,
        website: websiteUrl,
        phone: phone,
        booking_system: bookingSystem,
        email_platform: emailClient,
        affiliateURL: affiliateURL
      }
    });
  }, 3e3);
}

function sendTokenDataToTag(_ref6) {
  var payload = _ref6.payload;
  var userId = payload.userId,
      email = payload.email,
      companyName = payload.companyName,
      companyId = payload.companyId,
      viewAs = payload.viewAs,
      intercomUserHash = payload.intercomUserHash;

  window.dataLayer.push({ event: 'GET_USER',
    user: {
      id: userId || email,
      email: email,
      user_hash: intercomUserHash
    },
    company: {
      id: companyId,
      name: companyName,
      type: viewAs
    }
  });
}
function gaEvent(_ref7) {
  var _STARTING_DRAFT_CREAT;

  var type = _ref7.type,
      _ref7$payload = _ref7.payload,
      payload = _ref7$payload === undefined ? {} : _ref7$payload;
  var event;
  return regeneratorRuntime.wrap(function gaEvent$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          event = (_STARTING_DRAFT_CREAT = {
            STARTING_DRAFT_CREATE_IN_TEMPLATE_LIST: { // Click on 'Created Template' button or clicked on request from Contract List
              eventCategory: 'template',
              eventAction: 'start_template'
            },
            LOADED_TEMPLATES_SUPPLIER_SEND_TEMPLATE_WIZARD: {
              eventCategory: 'template',
              eventAction: 'start_template'
            },
            PUBLISH_TEMPLATE_DRAFT_SUCCESS: { // Clicked to Enter e-Signature
              eventCategory: 'template',
              eventAction: payload.originFrom === 'initial' ? 'complete_initial_template' : 'complete_edited_template'
            },
            CREATE_CONTRACT_FINISHED: { // Buyer sent a contract request
              eventCategory: 'contract',
              eventAction: 'send_request'
            },
            CONTRACTS_CREATED_SUPPLIER_SEND_TEMPLATE_WIZARD: { // Supplier Sent Rates
              eventCategory: 'template',
              eventAction: 'send_rates'
            },
            SEARCH: {
              eventCategory: 'partner-finder',
              eventAction: 'search'
            }
          }, _defineProperty(_STARTING_DRAFT_CREAT, constPF.SEND_INVITATION_PF, {
            eventCategory: 'partner-finder',
            eventAction: 'send-invitation'
          }), _defineProperty(_STARTING_DRAFT_CREAT, constPF.ACCEPT_CONNECTION_PF, {
            eventCategory: 'connection',
            eventAction: 'accept'
          }), _defineProperty(_STARTING_DRAFT_CREAT, constPF.IGNORE_CONNECTION_PF, {
            eventCategory: 'connection',
            eventAction: 'reject'
          }), _defineProperty(_STARTING_DRAFT_CREAT, constCO.IGNORE_CONNECTION, {
            eventCategory: 'connection',
            eventAction: 'reject'
          }), _STARTING_DRAFT_CREAT)[type];

          if (event) gaSendEvent(event);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function intercomEvent(_ref8) {
  var _CREATE_CONTRACT_FINI;

  var type = _ref8.type;
  var message;
  return regeneratorRuntime.wrap(function intercomEvent$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          message = (_CREATE_CONTRACT_FINI = {
            CREATE_CONTRACT_FINISHED: '[Contract] Send Request',
            STATE_CHANGE_CONTRACT_LIST: '[Contract] Change Status',
            ONBOARDING_COMPLETE: '[Account] Completed Onboarding',
            ADD_PRODUCT: '[Location] Added Product',
            SENT_MARKETING_MATERIALS: '[Marketing Material] Share',
            ADD_LOCATION: 'Added Location',
            ADD_NEW_USERS: '[Settings] Added New User',
            SEARCH: '[Partner Finder] Search'
          }, _defineProperty(_CREATE_CONTRACT_FINI, constPF.SEND_INVITATION_PF, '[Partner Finder] Send Invitation'), _defineProperty(_CREATE_CONTRACT_FINI, constPF.RESEND_INVITATION_PF, '[Partner Finder] Re-Send Invitation'), _defineProperty(_CREATE_CONTRACT_FINI, constPF.ACCEPT_CONNECTION_PF, '[Connection] Accepted Connection'), _defineProperty(_CREATE_CONTRACT_FINI, constPF.IGNORE_CONNECTION_PF, '[Connection] Rejected Connection'), _defineProperty(_CREATE_CONTRACT_FINI, constCO.IGNORE_CONNECTION, '[Connection] Rejected Connection'), _defineProperty(_CREATE_CONTRACT_FINI, 'HELPWIDGET_OPEN', '[Support] Widget Open'), _defineProperty(_CREATE_CONTRACT_FINI, 'SIGN_UP_USER_FINISHED', '[Sign Up] Create Account'), _defineProperty(_CREATE_CONTRACT_FINI, '[asset-landing]SIGN_UP_SUCCESS', '[Sign Up] Create Account'), _defineProperty(_CREATE_CONTRACT_FINI, 'AITools_Clicked', 'AITools_Clicked'), _CREATE_CONTRACT_FINI)[type];

          if (message) sendIntercom('trackEvent', message);

        case 2:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

// Buyer changed the status of a contract
function gaChangeStatus(_ref9) {
  var newState = _ref9.payload.newState;
  return regeneratorRuntime.wrap(function gaChangeStatus$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          gaSendEvent({
            eventCategory: 'contract',
            eventAction: 'change_status',
            eventLabel: newState
          });

        case 1:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function invitationsEvent() {
  var count;
  return regeneratorRuntime.wrap(function invitationsEvent$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.select)(getInvitationsSent);

        case 2:
          count = _context9.sent;

          sendIntercom('trackEvent', '[Connections] Invitation', {
            count: count
          });
          gaSendEvent({
            eventCategory: 'connection',
            eventValue: count,
            eventAction: 'sent connection'
          });

        case 5:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function intercomLocationFieldUpdate(_ref10) {
  var updateField = _ref10.payload.updateField;
  var event;
  return regeneratorRuntime.wrap(function intercomLocationFieldUpdate$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          event = {
            contacts: '[Location] Contact',
            description: '[Location] Description',
            amenities: '[Location] Amenities',
            rating: '[Location] Star Rating',
            address: '[Location] Address',
            website: '[Location] Website',
            phone: '[Location] Phone',
            marketSegments: '[Location] Market Segments',
            companyTypes: '[Location] Company Types'
          }[updateField];

          if (event) {
            sendIntercom('trackEvent', event);
          }

        case 2:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function intercomMMUpdate(_ref11) {
  var _ref11$payload = _ref11.payload;
  _ref11$payload = _ref11$payload === undefined ? {} : _ref11$payload;
  var uploadingFile = _ref11$payload.uploadingFile;
  return regeneratorRuntime.wrap(function intercomMMUpdate$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          if (uploadingFile) {
            sendIntercom('trackEvent', '[Location] Marketing Material');
          }

        case 1:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function upgradeEvent(_ref12) {
  var _ref12$payload = _ref12.payload;
  _ref12$payload = _ref12$payload === undefined ? {} : _ref12$payload;
  var plan = _ref12$payload.plan;
  return regeneratorRuntime.wrap(function upgradeEvent$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          sendIntercom('trackEvent', '[Billing] Upgrade Plan', { plan: plan });
          gaSendEvent({
            eventCategory: 'account',
            eventAction: 'upgrade'
          });
          if (window.fbq) window.fbq('track', 'Purchase');

        case 3:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function signUpEvent(_ref13) {
  var type = _ref13.type;
  var shellSignup, signUpObj;
  return regeneratorRuntime.wrap(function signUpEvent$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          shellSignup = type === '[asset-landing]SIGN_UP_SUCCESS';

          if (!shellSignup) {
            _context13.next = 11;
            break;
          }

          _context13.t1 = _ramda2.default;
          _context13.t2 = {};
          _context13.t3 = ['dialog', 'newUserInfo'];
          _context13.next = 7;
          return (0, _effects.select)(getAssetsLandingReducer);

        case 7:
          _context13.t4 = _context13.sent;
          _context13.t0 = _context13.t1.pathOr.call(_context13.t1, _context13.t2, _context13.t3, _context13.t4);
          _context13.next = 14;
          break;

        case 11:
          _context13.next = 13;
          return (0, _effects.select)(getSignUp);

        case 13:
          _context13.t0 = _context13.sent;

        case 14:
          signUpObj = _context13.t0;

          window.dataLayer.push({
            event: 'ACCOUNT_SIGN_UP',
            signUpType: shellSignup ? 'shell' : 'full',
            user: {
              email: signUpObj.email
            },
            company: {
              creationReason: shellSignup ? 'shell' : signUpObj.acctCreationReason,
              name: signUpObj.companyName,
              companyType: signUpObj.companyType
            }
          });

        case 16:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

exports.default = [(0, _effects.takeLatest)('GET_USER', tagAsAdmin), (0, _effects.takeLatest)('GET_USER', rollbarConfigure), (0, _effects.takeLatest)('TRACK_EVENT', trackEvent), (0, _effects.takeEvery)('PAGE_VIEW', pageView), (0, _effects.takeLatest)('GET_USER', sendUserDataToTag), (0, _effects.takeLatest)('GET_USER', sendUserDataToIntercom), (0, _effects.takeLatest)('VERIFY_TOKEN_SUCCESS', sendTokenDataToTag), (0, _effects.takeLatest)('STARTING_DRAFT_CREATE_IN_TEMPLATE_LIST', gaEvent), (0, _effects.takeLatest)('LOADED_TEMPLATES_SUPPLIER_SEND_TEMPLATE_WIZARD', gaEvent), (0, _effects.takeLatest)('PUBLISH_TEMPLATE_DRAFT_SUCCESS', gaEvent), (0, _effects.takeLatest)('CONTRACTS_CREATED_SUPPLIER_SEND_TEMPLATE_WIZARD', gaEvent), (0, _effects.takeLatest)('CREATE_CONTRACT_FINISHED', gaEvent), (0, _effects.takeLatest)('CREATE_CONTRACT_FINISHED', intercomEvent), (0, _effects.takeLatest)('STATE_CHANGE_CONTRACT_LIST', gaChangeStatus), (0, _effects.takeLatest)('STATE_CHANGE_CONTRACT_LIST', intercomEvent), (0, _effects.takeLatest)('SEND_EMAIL_TO_TEMP_CONNECTIONS', invitationsEvent), (0, _effects.takeLatest)('ONBOARDING_COMPLETE', intercomEvent), (0, _effects.takeEvery)('EDIT_USER_LOCATION_PROFILE_FIELD_STARTING', intercomLocationFieldUpdate), (0, _effects.takeLatest)('ADD_PRODUCT', intercomEvent), (0, _effects.takeLatest)('UPDATE_MM_PROP', intercomMMUpdate), (0, _effects.takeLatest)('SENT_MARKETING_MATERIALS', intercomEvent), (0, _effects.takeLatest)('ADD_LOCATION', intercomEvent), (0, _effects.takeLatest)('ADD_NEW_USERS', intercomEvent), (0, _effects.takeEvery)('SEARCH', intercomEvent), (0, _effects.takeEvery)('SEARCH', gaEvent), (0, _effects.takeLatest)(constPF.SEND_INVITATION_PF, intercomEvent), (0, _effects.takeLatest)(constPF.RESEND_INVITATION_PF, intercomEvent), (0, _effects.takeEvery)('USER_STORE_PLAN_UPDATE', upgradeEvent), (0, _effects.takeEvery)('UPGRADE_PLAN', upgradeEvent), (0, _effects.takeEvery)('SELECT_PLAN', upgradeEvent), (0, _effects.takeEvery)(constPF.ACCEPT_CONNECTION_PF, intercomEvent), (0, _effects.takeEvery)(constPF.ACCEPT_CONNECTION_PF, gaEvent), (0, _effects.takeEvery)(constPF.IGNORE_CONNECTION_PF, intercomEvent), (0, _effects.takeEvery)(constPF.IGNORE_CONNECTION_PF, gaEvent), (0, _effects.takeEvery)('[asset-landing]SIGN_UP_SUCCESS', signUpEvent), (0, _effects.takeEvery)('SIGN_UP_USER_FINISHED', signUpEvent), (0, _effects.takeEvery)('[asset-landing]SIGN_UP_SUCCESS', intercomEvent), (0, _effects.takeEvery)('SIGN_UP_USER_FINISHED', intercomEvent), (0, _effects.takeEvery)('HELPWIDGET_OPEN', intercomEvent), (0, _effects.takeEvery)('AITools_Clicked', intercomEvent)];

/***/ }),

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _effects = __webpack_require__(36);

var _globalErrorsDisplayActions = __webpack_require__(486);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

var _actions = __webpack_require__(253);

var _constants = __webpack_require__(657);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getSettings),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(saveSettings),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(cantAddUser),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(couldAddUser);

function getSettings(_ref) {
  var pathname = _ref.payload.pathname;
  return regeneratorRuntime.wrap(function getSettings$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(pathname.split('/')[1] === 'settings')) {
            _context.next = 3;
            break;
          }

          _context.next = 3;
          return (0, _sagas.apiSaga)(cnt.GET_SETTINGS, _api.settings.getSettings, []);

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function saveSettings(_ref2) {
  var payload = _ref2.payload;
  return regeneratorRuntime.wrap(function saveSettings$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _sagas.apiSaga)(cnt.SAVE_SETTINGS, _api.settings.saveSettings, [payload]);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function cantAddUser(_ref3) {
  var payload = _ref3.payload;
  var errorMessage;
  return regeneratorRuntime.wrap(function cantAddUser$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          errorMessage = 'This user cannot be added.';

          if (!payload.message) {
            _context3.next = 6;
            break;
          }

          _context3.next = 4;
          return (0, _effects.put)((0, _globalErrorsDisplayActions.triggerError)({ errorMessage: errorMessage + ' ' + payload.message + '.' }));

        case 4:
          _context3.next = 8;
          break;

        case 6:
          _context3.next = 8;
          return (0, _effects.put)((0, _globalErrorsDisplayActions.triggerError)({ errorMessage: errorMessage }));

        case 8:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}
function couldAddUser() {
  return regeneratorRuntime.wrap(function couldAddUser$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)({ type: 'UPDATE_UM_PROP', payload: { addingNewUserDialog: false } });

        case 2:
          _context4.next = 4;
          return (0, _effects.put)((0, _actions.getUsersByFilter)('user'));

        case 4:
          _context4.next = 6;
          return (0, _effects.put)((0, _actions.getUsersByFilter)('team'));

        case 6:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

exports.default = [(0, _effects.takeLatest)('@@router/LOCATION_CHANGE', getSettings), (0, _effects.takeLatest)('ADD_USER_FAILED', cantAddUser), (0, _effects.takeLatest)('ADDED_USER', couldAddUser), (0, _effects.takeLatest)(cnt.SAVE_SETTINGS, saveSettings)];

/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = __webpack_require__(647);

var cnt = _interopRequireWildcard(_actions);

var _effects = __webpack_require__(36);

var _api = __webpack_require__(37);

var _sagas = __webpack_require__(43);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(doAddConnectAsPartner);

function doAddConnectAsPartner(_ref) {
  var payload = _ref.payload;
  return regeneratorRuntime.wrap(function doAddConnectAsPartner$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.delegateYield((0, _sagas.apiSaga)(cnt.ADD_CONNECTION_AS_PARTNER, _api.partner.addConnectionAsPartner, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

exports.default = [(0, _effects.takeLatest)(cnt.ADD_CONNECTION_AS_PARTNER, doAddConnectAsPartner)];

/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.refreshPolicyNotes = refreshPolicyNotes;

var _effects = __webpack_require__(36);

var _reduxSaga = __webpack_require__(92);

var _sagas = __webpack_require__(43);

var _reactRouterRedux = __webpack_require__(27);

var _api = __webpack_require__(37);

var _sagas2 = __webpack_require__(609);

var _marked = /*#__PURE__*/regeneratorRuntime.mark(refreshPolicyNotes),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(refreshActivities),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(createTemplatesInDummyAcct),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(afterCreateTemplatesInDummyAcctSuccess),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(acceptDummyTemplate),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(afterAcceptDummyTemplate),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(doRequestSignature),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(updateWorkspaceContract),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(handleSendMessage),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(submitRates),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(afterSubmitRatesAsDLSuccess),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(createDummyTemplateDraftForBuyer),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(afterCreateDummyTemplateDraftForBuyerSuccess),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(deleteRateSheet),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(loadDataForIframe),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(checkIfRateComplete),
    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(onCloseIframe),
    _marked18 = /*#__PURE__*/regeneratorRuntime.mark(discardEditedDraft),
    _marked19 = /*#__PURE__*/regeneratorRuntime.mark(loadDraftDiff);

function refreshPolicyNotes(_ref) {
  var args = _ref.args;

  var _args$, crId, contractId, inActivityFeed, isRateContract;

  return regeneratorRuntime.wrap(function refreshPolicyNotes$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _args$ = args[0], crId = _args$.crId, contractId = _args$.contractId, inActivityFeed = _args$.inActivityFeed, isRateContract = _args$.isRateContract;

          if (!(window.location.href.indexOf('/assets-landing') > -1)) {
            _context.next = 6;
            break;
          }

          _context.next = 4;
          return (0, _sagas.apiSaga)('[asset-landing]GET_REQUEST', _api.contracting.getContractInfo, [{
            collection: 'contract',
            type: 'policyNotes',
            docId: crId || contractId,
            forAL: true
          }]);

        case 4:
          _context.next = 8;
          break;

        case 6:
          _context.next = 8;
          return (0, _effects.all)([inActivityFeed ? Promise.resolve() : (0, _sagas.apiSaga)('{rates-draft} REFRESH_POLICIES_NOTES', _api.contracting.getContractInfo, [{
            collection: 'contract',
            docId: crId || contractId,
            type: 'policyNotes'
          }]), (0, _sagas.apiSaga)('{rates-draft} REFRESH_LEFT_NAV', _api.contracting.getContractInfo, [{
            collection: 'contract',
            docId: isRateContract ? contractId : crId || contractId,
            type: 'leftNav'
          }])]);

        case 8:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function refreshActivities(_ref2) {
  var args = _ref2.args;
  return regeneratorRuntime.wrap(function refreshActivities$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!(args[0].contractId || args[0].crId)) {
            _context2.next = 3;
            break;
          }

          _context2.next = 3;
          return (0, _sagas.apiSaga)('LOADING_HISTORY_FEEDS', _api.historyFeed.getHistory, [args[0].contractId || args[0].crId]);

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function createTemplatesInDummyAcct(_ref3) {
  var type = _ref3.type,
      payload = _ref3.payload;
  return regeneratorRuntime.wrap(function createTemplatesInDummyAcct$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.createTemplatesInDummyAcct, [payload]);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function afterCreateTemplatesInDummyAcctSuccess(_ref4) {
  var args = _ref4.args;

  var _ref5, _ref5$rateConversionS, rateConversionStatus, crId;

  return regeneratorRuntime.wrap(function afterCreateTemplatesInDummyAcctSuccess$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(function (state) {
            return state.dummyAcct.inCR;
          });

        case 2:
          _ref5 = _context4.sent;
          _ref5$rateConversionS = _ref5.rateConversionStatus;
          rateConversionStatus = _ref5$rateConversionS === undefined ? '' : _ref5$rateConversionS;
          crId = _ref5.crId;

          if (!(rateConversionStatus.toLowerCase() === 'awaiting supplier rates' || rateConversionStatus.toLowerCase() === 'in queue')) {
            _context4.next = 11;
            break;
          }

          _context4.next = 9;
          return updateWorkspaceContract({
            type: '[contract-request] UPDATE_RATE_LOADING_STATUS',
            payload: { contractId: crId, updater: { rateConversionStatus: 'In Progress' } }
          });

        case 9:
          _context4.next = 13;
          break;

        case 11:
          _context4.next = 13;
          return refreshPolicyNotes({ args: args });

        case 13:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function acceptDummyTemplate(_ref6) {
  var type = _ref6.type,
      payload = _ref6.payload;
  var confirm;
  return regeneratorRuntime.wrap(function acceptDummyTemplate$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          confirm = window.confirm('Please be informed that by accepting this rate sheet, you will no longer be able to request a signature from your supplier.');

          if (!confirm) {
            _context5.next = 4;
            break;
          }

          _context5.next = 4;
          return (0, _sagas.apiSaga)(type, _api.contracting.acceptDummyTemplate, [{
            rateDocId: payload.rateDocId,
            from: 'buyer-acct-cr'
          }]);

        case 4:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}
function afterAcceptDummyTemplate(_ref7) {
  var payload = _ref7.payload;
  return regeneratorRuntime.wrap(function afterAcceptDummyTemplate$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          if (!payload.contractId) {
            _context6.next = 5;
            break;
          }

          _context6.next = 3;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/contracting/contract/' + payload.contractId + '/details'));

        case 3:
          _context6.next = 12;
          break;

        case 5:
          if (!payload.templateId) {
            _context6.next = 10;
            break;
          }

          _context6.next = 8;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/contracting/template/' + payload.templateId + '/details'));

        case 8:
          _context6.next = 12;
          break;

        case 10:
          _context6.next = 12;
          return (0, _sagas2.refreshContractDoc)();

        case 12:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function doRequestSignature(_ref8) {
  var type = _ref8.type,
      payload = _ref8.payload;
  return regeneratorRuntime.wrap(function doRequestSignature$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.sendRCMsg, [_extends({}, payload, { who: 'Supplier' })]);

        case 2:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function updateWorkspaceContract(_ref9) {
  var type = _ref9.type,
      payload = _ref9.payload;
  return regeneratorRuntime.wrap(function updateWorkspaceContract$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.updateWorkspaceContract, [payload]);

        case 2:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function handleSendMessage(_ref10) {
  var type = _ref10.type,
      payload = _ref10.payload;
  return regeneratorRuntime.wrap(function handleSendMessage$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          if (!(payload.who === 'Supplier' && !payload.rateDocIds.length)) {
            _context9.next = 4;
            break;
          }

          return _context9.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.submitContractingComment, [{
            files: payload.leanFiles || [],
            message: payload.message,
            historyFeedId: payload.historyFeedId,
            emails: payload.emails,
            subject: payload.subject,
            crId: payload.crId
          }]), 't0', 2);

        case 2:
          _context9.next = 6;
          break;

        case 4:
          _context9.next = 6;
          return (0, _sagas.apiSaga)(type, _api.contracting.sendRCMsg, [payload]);

        case 6:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function submitRates(_ref11) {
  var type = _ref11.type,
      payload = _ref11.payload;
  return regeneratorRuntime.wrap(function submitRates$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.submitRCRates, [payload]);

        case 2:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function afterSubmitRatesAsDLSuccess(_ref12) {
  var args = _ref12.args;
  return regeneratorRuntime.wrap(function afterSubmitRatesAsDLSuccess$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          return _context11.delegateYield([(0, _sagas.apiSaga)('[contract-request]GET_RESPONDED_CONTRACT_LIST', _api.contracting.getRespondedContractList, [{ requestId: args[0].crId }]), refreshPolicyNotes({ args: args })], 't0', 1);

        case 1:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function createDummyTemplateDraftForBuyer(_ref13) {
  var type = _ref13.type,
      payload = _ref13.payload;
  return regeneratorRuntime.wrap(function createDummyTemplateDraftForBuyer$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.createEditedDraftForBuyer, [payload]);

        case 2:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function afterCreateDummyTemplateDraftForBuyerSuccess(_ref14) {
  var payload = _ref14.payload;
  return regeneratorRuntime.wrap(function afterCreateDummyTemplateDraftForBuyerSuccess$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.put)({ type: '[contractTemplate]TOGGLE_CREATE_DRAFT_DIALOG' });

        case 2:
          _context13.next = 4;
          return (0, _effects.put)({
            type: '{dummy-account} RateDocIframe_open',
            payload: {
              url: payload.magicLink + '&jumpBackTo=' + window.location.href,
              collection: 'draft',
              rateDocId: payload.docId,
              isInSigning: false
            }
          });

        case 4:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function deleteRateSheet(_ref15) {
  var type = _ref15.type,
      payload = _ref15.payload;
  return regeneratorRuntime.wrap(function deleteRateSheet$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.deleteTemplateDraft, [payload]);

        case 2:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function loadDataForIframe() {
  var _ref16, rateDocId, collection, forImport;

  return regeneratorRuntime.wrap(function loadDataForIframe$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.select)(function (state) {
            return state.dummyAcct.rateDocIframe;
          });

        case 2:
          _ref16 = _context15.sent;
          rateDocId = _ref16.rateDocId;
          collection = _ref16.collection;
          forImport = _ref16.forImport;

          if (!(rateDocId && collection && window.location.href.indexOf('/assets-landing') === -1 && !forImport)) {
            _context15.next = 9;
            break;
          }

          _context15.next = 9;
          return (0, _sagas.apiSaga)('{dummy-account} loadDataForIframe', _api.contracting.loadDataForIframe, [{ rateDocId: rateDocId, collection: collection }]);

        case 9:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}
function checkIfRateComplete(_ref17) {
  var type = _ref17.type,
      payload = _ref17.payload,
      next = _ref17.next,
      shouldBlock = _ref17.shouldBlock;

  var _ref18, rateDocId, collection, originFrom, _ref19, completionPercent, rawDiffData, isADraft, rateInfoComplete, confirmed;

  return regeneratorRuntime.wrap(function checkIfRateComplete$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.select)(function (state) {
            return state.dummyAcct.rateDocIframe;
          });

        case 2:
          _ref18 = _context16.sent;
          rateDocId = _ref18.rateDocId;
          collection = _ref18.collection;
          originFrom = _ref18.originFrom;
          _context16.next = 8;
          return (0, _effects.all)([(0, _sagas.apiSaga)(type, _api.contracting.loadDataForIframe, [{ rateDocId: rateDocId, collection: collection }]), loadDraftDiff()]);

        case 8:
          _context16.next = 10;
          return (0, _effects.select)(function (state) {
            return state.dummyAcct.rateDocIframe;
          });

        case 10:
          _ref19 = _context16.sent;
          completionPercent = _ref19.completionPercent;
          rawDiffData = _ref19.rawDiffData;
          isADraft = collection === 'draft';

          rateInfoComplete = function () {
            if (!isADraft) return true;
            if (originFrom === 'initial') {
              return completionPercent === 100;
            }
            return Boolean(completionPercent === 100 && rawDiffData.length);
          }();

          if (!rateInfoComplete) {
            _context16.next = 20;
            break;
          }

          _context16.next = 18;
          return (0, _effects.put)({ type: next, payload: payload });

        case 18:
          _context16.next = 28;
          break;

        case 20:
          if (!(shouldBlock || !rawDiffData.length && originFrom === 'edited')) {
            _context16.next = 24;
            break;
          }

          // if the draft does not contain any changes, we need to block because backend won't process
          if (!rawDiffData.length && originFrom === 'edited') window.alert('You haven\'t made any changes yet.');else window.alert('Please complete the rate sheet before continuing');
          _context16.next = 28;
          break;

        case 24:
          confirmed = window.confirm('This rate sheet is not complete, are you sure that you want to continue?');

          if (!confirmed) {
            _context16.next = 28;
            break;
          }

          _context16.next = 28;
          return (0, _effects.put)({ type: next, payload: payload });

        case 28:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked16, this);
}

function onCloseIframe() {
  var contractId, _ref20, crId;

  return regeneratorRuntime.wrap(function onCloseIframe$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          // TODO: UPDATE when old view is deprecated
          contractId = void 0;

          if (window.location.pathname.indexOf('/workspace/')) {
            contractId = (window.location.pathname.match(/^\/contracting\/workspace\/([a-f\d]{24})\//) || [])[1];
          } else {
            contractId = (window.location.pathname.match(/^\/contracting\/contract\/([a-f\d]{24})\//) || [])[1];
          }

          if (!contractId) {
            _context17.next = 7;
            break;
          }

          _context17.next = 5;
          return refreshPolicyNotes({ args: [{ contractId: contractId }] });

        case 5:
          _context17.next = 14;
          break;

        case 7:
          if (!(window.location.href.indexOf('/assets-landing') > -1)) {
            _context17.next = 14;
            break;
          }

          _context17.next = 10;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer.request;
          });

        case 10:
          _ref20 = _context17.sent;
          crId = _ref20.contractId;
          _context17.next = 14;
          return refreshPolicyNotes({ args: [{ crId: crId }] });

        case 14:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked17, this);
}

function discardEditedDraft(_ref21) {
  var type = _ref21.type;

  var confirmed, _ref22, rateDocId;

  return regeneratorRuntime.wrap(function discardEditedDraft$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          confirmed = window.confirm('Are you sure you want to discard this draft?');

          if (!confirmed) {
            _context18.next = 8;
            break;
          }

          _context18.next = 4;
          return (0, _effects.select)(function (state) {
            return state.dummyAcct.rateDocIframe;
          });

        case 4:
          _ref22 = _context18.sent;
          rateDocId = _ref22.rateDocId;
          _context18.next = 8;
          return (0, _sagas.apiSaga)(type, _api.contracting.deleteEditedDraft, [rateDocId]);

        case 8:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked18, this);
}

function loadDraftDiff() {
  var _ref23, rateDocId, originFrom;

  return regeneratorRuntime.wrap(function loadDraftDiff$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _effects.select)(function (state) {
            return state.dummyAcct.rateDocIframe;
          });

        case 2:
          _ref23 = _context19.sent;
          rateDocId = _ref23.rateDocId;
          originFrom = _ref23.originFrom;

          if (!(originFrom === 'edited')) {
            _context19.next = 10;
            break;
          }

          _context19.next = 8;
          return (0, _effects.call)(_reduxSaga.delay, 500);

        case 8:
          _context19.next = 10;
          return (0, _sagas.apiSaga)('{dummy-account} loadDraftDiff', _api.contracting.getDiffReport, [{ docs: 'draft:' + rateDocId + ':' + rateDocId, onlyGetSummary: true }]);

        case 10:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked19, this);
}
exports.default = [(0, _effects.takeLatest)('[contract-request]CREATE_TEMPLATE_IN_DUMMY_ACCOUNT_FOR_CR', createTemplatesInDummyAcct), (0, _effects.takeLatest)('[contract-request]CREATE_TEMPLATE_IN_DUMMY_ACCOUNT_FOR_CR_SUCCESS', afterCreateTemplatesInDummyAcctSuccess), (0, _effects.takeLatest)('{dummy-account} ACCEPT_DUMMY_TEMPLATE', acceptDummyTemplate), (0, _effects.takeLatest)('{dummy-account} ACCEPT_DUMMY_TEMPLATE_SUCCESS', afterAcceptDummyTemplate), (0, _effects.takeLatest)('{dummy-account} REQUEST_SIGNATURE', doRequestSignature), (0, _effects.takeLatest)('{dummy-account} REQUEST_SIGNATURE_SUCCESS', loadDataForIframe), (0, _effects.takeLatest)(['[contract-request] UPDATE_RATE_LOADING_STATUS', '[contract-request] UPDATE_RATE_CONVERSION_SETTING', '[contract-request] UPDATE_RATE_CONVERSION_PRIORITY', '[contract-request] UPDATE_CONTRACTING_WORKSPACE'], updateWorkspaceContract), (0, _effects.takeLatest)(['[contract-request] UPDATE_RATE_LOADING_STATUS_SUCCESS', '[contract-request] UPDATE_RATE_CONVERSION_SETTING_SUCCESS', '[contract-request] UPDATE_RATE_CONVERSION_PRIORITY_SUCCESS', '[contract-request] UPDATE_CONTRACTING_WORKSPACE_SUCCESS'], refreshPolicyNotes), (0, _effects.takeLatest)('{rl-send-message} SEND_MESSAGE', handleSendMessage), (0, _effects.takeLatest)('{rl-send-message} SUBMIT_RATES_AS_DL', submitRates), (0, _effects.takeLatest)('{rl-send-message} SUBMIT_RATES_AS_DL_SUCCESS', afterSubmitRatesAsDLSuccess), (0, _effects.takeLatest)('{rl-send-message} SEND_MESSAGE_SUCCESS', refreshPolicyNotes), (0, _effects.takeLatest)('{rl-send-message} SEND_MESSAGE_SUCCESS', refreshActivities), (0, _effects.takeLatest)('{dummy-account} CREATE_DUMMY_TEMPLATE_DRAFT', createDummyTemplateDraftForBuyer), (0, _effects.takeLatest)('{dummy-account} CREATE_DUMMY_TEMPLATE_DRAFT_SUCCESS', afterCreateDummyTemplateDraftForBuyerSuccess), (0, _effects.takeLatest)('[contract-request] DELETE_RATE_SHEET', deleteRateSheet), (0, _effects.takeLatest)('{dummy-account} RateDocIframe_open', loadDataForIframe), (0, _effects.takeLatest)('{dummy-account} RateDocIframe_checkIfRateComplete', checkIfRateComplete), (0, _effects.takeLatest)('{dummy-account} RateDocIframe_close', onCloseIframe), (0, _effects.takeLatest)('{dummy-account} DISCARD_DUMMY_TEMPLATE_DRAFT', discardEditedDraft), (0, _effects.takeLatest)('{dummy-account} loadDataForIframe_SUCCESS', loadDraftDiff)];

/***/ }),

/***/ 974:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _effects = __webpack_require__(36);

var _reduxSaga = __webpack_require__(92);

var _api = __webpack_require__(37);

var _sagas = __webpack_require__(43);

var _ramda = __webpack_require__(2);

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(checkJobStatus),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(startPolling);

function checkJobStatus(payload) {
  var jobSucceeded, pollingAction;
  return regeneratorRuntime.wrap(function checkJobStatus$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          jobSucceeded = false;

        case 1:
          if (jobSucceeded) {
            _context.next = 23;
            break;
          }

          _context.next = 4;
          return (0, _effects.call)(_reduxSaga.delay, 4000);

        case 4:
          _context.next = 6;
          return (0, _effects.put)({ type: '{integration-export}POLLING_ACTION_REQUEST' });

        case 6:
          _context.next = 8;
          return (0, _effects.call)(_api.integration.getJobStatus, { jobId: payload.jobId });

        case 8:
          pollingAction = _context.sent;
          _context.t0 = pollingAction.response.state;
          _context.next = _context.t0 === 'succeded' ? 12 : _context.t0 === 'failed' ? 16 : 20;
          break;

        case 12:
          jobSucceeded = true;
          _context.next = 15;
          return (0, _effects.put)({ type: '{integration-export} GET_PROCESSED_RESPONSE', payload: pollingAction.response.callbackResult });

        case 15:
          return _context.abrupt('break', 21);

        case 16:
          jobSucceeded = true;
          _context.next = 19;
          return (0, _effects.put)({ type: '{integration-export} HANDLE_POLLING_FAILURE' });

        case 19:
          return _context.abrupt('break', 21);

        case 20:
          return _context.abrupt('break', 21);

        case 21:
          _context.next = 1;
          break;

        case 23:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function startPolling(_ref) {
  var payload = _ref.payload;

  var _ref2, timeout;

  return regeneratorRuntime.wrap(function startPolling$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.race)({
            response: (0, _effects.call)(function () {
              return checkJobStatus(payload);
            }),
            timeout: (0, _effects.call)(_reduxSaga.delay, 60e3)
          });

        case 2:
          _ref2 = _context2.sent;
          timeout = _ref2.timeout;

          if (!timeout) {
            _context2.next = 7;
            break;
          }

          _context2.next = 7;
          return (0, _effects.put)({ type: '{integration-export} HANDLE_POLLING_FAILURE', error: 'TOOOOO LOOOOOG' });

        case 7:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

exports.default = [(0, _effects.takeLatest)('{integration-export} POLLING_ACTION_RESPONSE', startPolling)];

/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _effects = __webpack_require__(36);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getInvoices);

function getInvoices(_ref) {
  var type = _ref.type,
      payload = _ref.payload;
  return regeneratorRuntime.wrap(function getInvoices$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _sagas.apiSaga)(type, _api.billing.getInvoices, [payload || {}]);

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}
exports.default = [(0, _effects.takeLatest)('{billing} getInvoices', getInvoices)];

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */
module.exports = Number.isInteger || function _isInteger(n) {
  return (n << 0) === n;
};


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _makeFlat = __webpack_require__(159);
var _xchain = __webpack_require__(284);
var map = __webpack_require__(16);


/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      var duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */
module.exports = _curry2(_dispatchable(['fantasy-land/chain', 'chain'], _xchain, function chain(fn, monad) {
  if (typeof monad === 'function') {
    return function(x) { return fn(monad(x))(x); };
  }
  return _makeFlat(false)(map(fn, monad));
}));


/***/ })

},[3615]);


// WEBPACK FOOTER //
// signin.js